var D6 = Object.defineProperty;
var Ox = (r) => {
  throw TypeError(r);
};
var j6 = (r, e, t) => e in r ? D6(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var Q = (r, e, t) => j6(r, typeof e != "symbol" ? e + "" : e, t), Ch = (r, e, t) => e.has(r) || Ox("Cannot " + t);
var x = (r, e, t) => (Ch(r, e, "read from private field"), t ? t.call(r) : e.get(r)), Z = (r, e, t) => e.has(r) ? Ox("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(r) : e.set(r, t), F = (r, e, t, n) => (Ch(r, e, "write to private field"), n ? n.call(r, t) : e.set(r, t), t), de = (r, e, t) => (Ch(r, e, "access private method"), t);
var rn = (r, e, t, n) => ({
  set _(s) {
    F(r, e, s, t);
  },
  get _() {
    return x(r, e, n);
  }
});
const Fd = "6.13.5";
function H6(r, e, t) {
  const n = e.split("|").map((i) => i.trim());
  for (let i = 0; i < n.length; i++)
    switch (e) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof r === e)
          return;
    }
  const s = new Error(`invalid value for type ${e}`);
  throw s.code = "INVALID_ARGUMENT", s.argument = `value.${t}`, s.value = r, s;
}
async function Lt(r) {
  const e = Object.keys(r);
  return (await Promise.all(e.map((n) => Promise.resolve(r[n])))).reduce((n, s, i) => (n[e[i]] = s, n), {});
}
function _e(r, e, t) {
  for (let n in e) {
    let s = e[n];
    const i = t ? t[n] : null;
    i && H6(s, i, n), Object.defineProperty(r, n, { enumerable: !0, value: s, writable: !1 });
  }
}
function ic(r) {
  if (r == null)
    return "null";
  if (Array.isArray(r))
    return "[ " + r.map(ic).join(", ") + " ]";
  if (r instanceof Uint8Array) {
    const e = "0123456789abcdef";
    let t = "0x";
    for (let n = 0; n < r.length; n++)
      t += e[r[n] >> 4], t += e[r[n] & 15];
    return t;
  }
  if (typeof r == "object" && typeof r.toJSON == "function")
    return ic(r.toJSON());
  switch (typeof r) {
    case "boolean":
    case "symbol":
      return r.toString();
    case "bigint":
      return BigInt(r).toString();
    case "number":
      return r.toString();
    case "string":
      return JSON.stringify(r);
    case "object": {
      const e = Object.keys(r);
      return e.sort(), "{ " + e.map((t) => `${ic(t)}: ${ic(r[t])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
function Ct(r, e) {
  return r && r.code === e;
}
function q0(r) {
  return Ct(r, "CALL_EXCEPTION");
}
function xt(r, e, t) {
  let n = r;
  {
    const i = [];
    if (t) {
      if ("message" in t || "code" in t || "name" in t)
        throw new Error(`value will overwrite populated values: ${ic(t)}`);
      for (const a in t) {
        if (a === "shortMessage")
          continue;
        const o = t[a];
        i.push(a + "=" + ic(o));
      }
    }
    i.push(`code=${e}`), i.push(`version=${Fd}`), i.length && (r += " (" + i.join(", ") + ")");
  }
  let s;
  switch (e) {
    case "INVALID_ARGUMENT":
      s = new TypeError(r);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      s = new RangeError(r);
      break;
    default:
      s = new Error(r);
  }
  return _e(s, { code: e }), t && Object.assign(s, t), s.shortMessage == null && _e(s, { shortMessage: n }), s;
}
function Ee(r, e, t, n) {
  if (!r)
    throw xt(e, t, n);
}
function ue(r, e, t, n) {
  Ee(r, e, "INVALID_ARGUMENT", { argument: t, value: n });
}
function Dd(r, e, t) {
  t == null && (t = ""), t && (t = ": " + t), Ee(r >= e, "missing argument" + t, "MISSING_ARGUMENT", {
    count: r,
    expectedCount: e
  }), Ee(r <= e, "too many arguments" + t, "UNEXPECTED_ARGUMENT", {
    count: r,
    expectedCount: e
  });
}
const G6 = ["NFD", "NFC", "NFKD", "NFKC"].reduce((r, e) => {
  try {
    if ("test".normalize(e) !== "test")
      throw new Error("bad");
    if (e === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    r.push(e);
  } catch {
  }
  return r;
}, []);
function jd(r) {
  Ee(G6.indexOf(r) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
    operation: "String.prototype.normalize",
    info: { form: r }
  });
}
function es(r, e, t) {
  if (t == null && (t = ""), r !== e) {
    let n = t, s = "new";
    t && (n += ".", s += " " + t), Ee(!1, `private constructor; use ${n}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: s
    });
  }
}
function L2(r, e, t) {
  if (r instanceof Uint8Array)
    return t ? new Uint8Array(r) : r;
  if (typeof r == "string" && r.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const n = new Uint8Array((r.length - 2) / 2);
    let s = 2;
    for (let i = 0; i < n.length; i++)
      n[i] = parseInt(r.substring(s, s + 2), 16), s += 2;
    return n;
  }
  ue(!1, "invalid BytesLike value", e || "value", r);
}
function Ce(r, e) {
  return L2(r, e, !1);
}
function Mt(r, e) {
  return L2(r, e, !0);
}
function dt(r, e) {
  return !(typeof r != "string" || !r.match(/^0x[0-9A-Fa-f]*$/) || typeof e == "number" && r.length !== 2 + 2 * e || e === !0 && r.length % 2 !== 0);
}
function Su(r) {
  return dt(r, !0) || r instanceof Uint8Array;
}
const Nx = "0123456789abcdef";
function Oe(r) {
  const e = Ce(r);
  let t = "0x";
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    t += Nx[(s & 240) >> 4] + Nx[s & 15];
  }
  return t;
}
function it(r) {
  return "0x" + r.map((e) => Oe(e).substring(2)).join("");
}
function Is(r) {
  return dt(r, !0) ? (r.length - 2) / 2 : Ce(r).length;
}
function lt(r, e, t) {
  const n = Ce(r);
  return t != null && t > n.length && Ee(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: n,
    length: n.length,
    offset: t
  }), Oe(n.slice(e ?? 0, t ?? n.length));
}
function M2(r) {
  let e = Oe(r).substring(2);
  for (; e.startsWith("00"); )
    e = e.substring(2);
  return "0x" + e;
}
function F2(r, e, t) {
  const n = Ce(r);
  Ee(e >= n.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(n),
    length: e,
    offset: e + 1
  });
  const s = new Uint8Array(e);
  return s.fill(0), t ? s.set(n, e - n.length) : s.set(n, 0), Oe(s);
}
function Xr(r, e) {
  return F2(r, e, !0);
}
function W0(r, e) {
  return F2(r, e, !1);
}
const Hd = BigInt(0), An = BigInt(1), ac = 9007199254740991;
function ou(r, e) {
  const t = Cu(r, "value"), n = BigInt(Ve(e, "width"));
  if (Ee(t >> n === Hd, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: r
  }), t >> n - An) {
    const s = (An << n) - An;
    return -((~t & s) + An);
  }
  return t;
}
function Y0(r, e) {
  let t = De(r, "value");
  const n = BigInt(Ve(e, "width")), s = An << n - An;
  if (t < Hd) {
    t = -t, Ee(t <= s, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: r
    });
    const i = (An << n) - An;
    return (~t & i) + An;
  } else
    Ee(t < s, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: r
    });
  return t;
}
function Cs(r, e) {
  const t = Cu(r, "value"), n = BigInt(Ve(e, "bits"));
  return t & (An << n) - An;
}
function De(r, e) {
  switch (typeof r) {
    case "bigint":
      return r;
    case "number":
      return ue(Number.isInteger(r), "underflow", e || "value", r), ue(r >= -ac && r <= ac, "overflow", e || "value", r), BigInt(r);
    case "string":
      try {
        if (r === "")
          throw new Error("empty string");
        return r[0] === "-" && r[1] !== "-" ? -BigInt(r.substring(1)) : BigInt(r);
      } catch (t) {
        ue(!1, `invalid BigNumberish string: ${t.message}`, e || "value", r);
      }
  }
  ue(!1, "invalid BigNumberish value", e || "value", r);
}
function Cu(r, e) {
  const t = De(r, e);
  return Ee(t >= Hd, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: r
  }), t;
}
const Sx = "0123456789abcdef";
function Bo(r) {
  if (r instanceof Uint8Array) {
    let e = "0x0";
    for (const t of r)
      e += Sx[t >> 4], e += Sx[t & 15];
    return BigInt(e);
  }
  return De(r);
}
function Ve(r, e) {
  switch (typeof r) {
    case "bigint":
      return ue(r >= -ac && r <= ac, "overflow", e || "value", r), Number(r);
    case "number":
      return ue(Number.isInteger(r), "underflow", e || "value", r), ue(r >= -ac && r <= ac, "overflow", e || "value", r), r;
    case "string":
      try {
        if (r === "")
          throw new Error("empty string");
        return Ve(BigInt(r), e);
      } catch (t) {
        ue(!1, `invalid numeric string: ${t.message}`, e || "value", r);
      }
  }
  ue(!1, "invalid numeric value", e || "value", r);
}
function Qb(r) {
  return Ve(Bo(r));
}
function tn(r, e) {
  let n = Cu(r, "value").toString(16);
  if (e == null)
    n.length % 2 && (n = "0" + n);
  else {
    const s = Ve(e, "width");
    for (Ee(s * 2 >= n.length, `value exceeds width (${s} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: r
    }); n.length < s * 2; )
      n = "0" + n;
  }
  return "0x" + n;
}
function Ft(r) {
  const e = Cu(r, "value");
  if (e === Hd)
    return new Uint8Array([]);
  let t = e.toString(16);
  t.length % 2 && (t = "0" + t);
  const n = new Uint8Array(t.length / 2);
  for (let s = 0; s < n.length; s++) {
    const i = s * 2;
    n[s] = parseInt(t.substring(i, i + 2), 16);
  }
  return n;
}
function Rs(r) {
  let e = Oe(Su(r) ? r : Ft(r)).substring(2);
  for (; e.startsWith("0"); )
    e = e.substring(1);
  return e === "" && (e = "0"), "0x" + e;
}
const od = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let xf = null;
function V6(r) {
  if (xf == null) {
    xf = {};
    for (let t = 0; t < od.length; t++)
      xf[od[t]] = BigInt(t);
  }
  const e = xf[r];
  return ue(e != null, "invalid base58 value", "letter", r), e;
}
const $6 = BigInt(0), Cp = BigInt(58);
function Gd(r) {
  const e = Ce(r);
  let t = Bo(e), n = "";
  for (; t; )
    n = od[Number(t % Cp)] + n, t /= Cp;
  for (let s = 0; s < e.length && !e[s]; s++)
    n = od[0] + n;
  return n;
}
function qb(r) {
  let e = $6;
  for (let t = 0; t < r.length; t++)
    e *= Cp, e += V6(r[t]);
  return e;
}
function Wb(r) {
  r = atob(r);
  const e = new Uint8Array(r.length);
  for (let t = 0; t < r.length; t++)
    e[t] = r.charCodeAt(t);
  return Ce(e);
}
function Yb(r) {
  const e = Ce(r);
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += String.fromCharCode(e[n]);
  return btoa(t);
}
var bc;
class Vd {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(e, t, n) {
    /**
     *  The event filter.
     */
    Q(this, "filter");
    /**
     *  The **EventEmitterable**.
     */
    Q(this, "emitter");
    Z(this, bc);
    F(this, bc, t), _e(this, { emitter: e, filter: n });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    x(this, bc) != null && await this.emitter.off(this.filter, x(this, bc));
  }
}
bc = new WeakMap();
function K6(r, e, t, n, s) {
  ue(!1, `invalid codepoint at offset ${e}; ${r}`, "bytes", t);
}
function D2(r, e, t, n, s) {
  if (r === "BAD_PREFIX" || r === "UNEXPECTED_CONTINUE") {
    let i = 0;
    for (let a = e + 1; a < t.length && t[a] >> 6 === 2; a++)
      i++;
    return i;
  }
  return r === "OVERRUN" ? t.length - e - 1 : 0;
}
function z6(r, e, t, n, s) {
  return r === "OVERLONG" ? (ue(typeof s == "number", "invalid bad code point for replacement", "badCodepoint", s), n.push(s), 0) : (n.push(65533), D2(r, e, t));
}
const Zb = Object.freeze({
  error: K6,
  ignore: D2,
  replace: z6
});
function j2(r, e) {
  e == null && (e = Zb.error);
  const t = Ce(r, "bytes"), n = [];
  let s = 0;
  for (; s < t.length; ) {
    const i = t[s++];
    if (!(i >> 7)) {
      n.push(i);
      continue;
    }
    let a = null, o = null;
    if ((i & 224) === 192)
      a = 1, o = 127;
    else if ((i & 240) === 224)
      a = 2, o = 2047;
    else if ((i & 248) === 240)
      a = 3, o = 65535;
    else {
      (i & 192) === 128 ? s += e("UNEXPECTED_CONTINUE", s - 1, t, n) : s += e("BAD_PREFIX", s - 1, t, n);
      continue;
    }
    if (s - 1 + a >= t.length) {
      s += e("OVERRUN", s - 1, t, n);
      continue;
    }
    let u = i & (1 << 8 - a - 1) - 1;
    for (let c = 0; c < a; c++) {
      let l = t[s];
      if ((l & 192) != 128) {
        s += e("MISSING_CONTINUE", s, t, n), u = null;
        break;
      }
      u = u << 6 | l & 63, s++;
    }
    if (u !== null) {
      if (u > 1114111) {
        s += e("OUT_OF_RANGE", s - 1 - a, t, n, u);
        continue;
      }
      if (u >= 55296 && u <= 57343) {
        s += e("UTF16_SURROGATE", s - 1 - a, t, n, u);
        continue;
      }
      if (u <= o) {
        s += e("OVERLONG", s - 1 - a, t, n, u);
        continue;
      }
      n.push(u);
    }
  }
  return n;
}
function It(r, e) {
  ue(typeof r == "string", "invalid string value", "str", r), e != null && (jd(e), r = r.normalize(e));
  let t = [];
  for (let n = 0; n < r.length; n++) {
    const s = r.charCodeAt(n);
    if (s < 128)
      t.push(s);
    else if (s < 2048)
      t.push(s >> 6 | 192), t.push(s & 63 | 128);
    else if ((s & 64512) == 55296) {
      n++;
      const i = r.charCodeAt(n);
      ue(n < r.length && (i & 64512) === 56320, "invalid surrogate pair", "str", r);
      const a = 65536 + ((s & 1023) << 10) + (i & 1023);
      t.push(a >> 18 | 240), t.push(a >> 12 & 63 | 128), t.push(a >> 6 & 63 | 128), t.push(a & 63 | 128);
    } else
      t.push(s >> 12 | 224), t.push(s >> 6 & 63 | 128), t.push(s & 63 | 128);
  }
  return new Uint8Array(t);
}
function J6(r) {
  return r.map((e) => e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10 & 1023) + 55296, (e & 1023) + 56320))).join("");
}
function Fs(r, e) {
  return J6(j2(r, e));
}
function H2(r, e) {
  return j2(It(r, e));
}
function G2(r) {
  async function e(t, n) {
    Ee(n == null || !n.cancelled, "request cancelled before sending", "CANCELLED");
    const s = t.url.split(":")[0].toLowerCase();
    Ee(s === "http" || s === "https", `unsupported protocol ${s}`, "UNSUPPORTED_OPERATION", {
      info: { protocol: s },
      operation: "request"
    }), Ee(s === "https" || !t.credentials || t.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
      operation: "request"
    });
    let i = null;
    const a = new AbortController(), o = setTimeout(() => {
      i = xt("request timeout", "TIMEOUT"), a.abort();
    }, t.timeout);
    n && n.addListener(() => {
      i = xt("request cancelled", "CANCELLED"), a.abort();
    });
    const u = {
      method: t.method,
      headers: new Headers(Array.from(t)),
      body: t.body || void 0,
      signal: a.signal
    };
    let c;
    try {
      c = await fetch(t.url, u);
    } catch (h) {
      throw clearTimeout(o), i || h;
    }
    clearTimeout(o);
    const l = {};
    c.headers.forEach((h, p) => {
      l[p.toLowerCase()] = h;
    });
    const f = await c.arrayBuffer(), d = f == null ? null : new Uint8Array(f);
    return {
      statusCode: c.status,
      statusMessage: c.statusText,
      headers: l,
      body: d
    };
  }
  return e;
}
const Q6 = 12, q6 = 250;
let Cx = G2();
const W6 = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), Y6 = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
let Rh = !1;
async function V2(r, e) {
  try {
    const t = r.match(W6);
    if (!t)
      throw new Error("invalid data");
    return new Wn(200, "OK", {
      "content-type": t[1] || "text/plain"
    }, t[2] ? Wb(t[3]) : Z6(t[3]));
  } catch {
    return new Wn(599, "BAD REQUEST (invalid data: URI)", {}, null, new Kt(r));
  }
}
function $2(r) {
  async function e(t, n) {
    try {
      const s = t.match(Y6);
      if (!s)
        throw new Error("invalid link");
      return new Kt(`${r}${s[2]}`);
    } catch {
      return new Wn(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new Kt(t));
    }
  }
  return e;
}
const mf = {
  data: V2,
  ipfs: $2("https://gateway.ipfs.io/ipfs/")
}, K2 = /* @__PURE__ */ new WeakMap();
var Da, ui;
class Xb {
  constructor(e) {
    Z(this, Da);
    Z(this, ui);
    F(this, Da, []), F(this, ui, !1), K2.set(e, () => {
      if (!x(this, ui)) {
        F(this, ui, !0);
        for (const t of x(this, Da))
          setTimeout(() => {
            t();
          }, 0);
        F(this, Da, []);
      }
    });
  }
  addListener(e) {
    Ee(!x(this, ui), "singal already cancelled", "UNSUPPORTED_OPERATION", {
      operation: "fetchCancelSignal.addCancelListener"
    }), x(this, Da).push(e);
  }
  get cancelled() {
    return x(this, ui);
  }
  checkSignal() {
    Ee(!this.cancelled, "cancelled", "CANCELLED", {});
  }
}
Da = new WeakMap(), ui = new WeakMap();
function yf(r) {
  if (r == null)
    throw new Error("missing signal; should not happen");
  return r.checkSignal(), r;
}
var gc, xc, pn, xs, mc, yc, Ht, Or, ms, ja, Ha, Ga, jn, bn, li, Va, n0;
const Cd = class Cd {
  /**
   *  Create a new FetchRequest instance with default values.
   *
   *  Once created, each property may be set before issuing a
   *  ``.send()`` to make the request.
   */
  constructor(e) {
    Z(this, Va);
    Z(this, gc);
    Z(this, xc);
    Z(this, pn);
    Z(this, xs);
    Z(this, mc);
    Z(this, yc);
    Z(this, Ht);
    Z(this, Or);
    Z(this, ms);
    // Hooks
    Z(this, ja);
    Z(this, Ha);
    Z(this, Ga);
    Z(this, jn);
    Z(this, bn);
    Z(this, li);
    F(this, yc, String(e)), F(this, gc, !1), F(this, xc, !0), F(this, pn, {}), F(this, xs, ""), F(this, mc, 3e5), F(this, bn, {
      slotInterval: q6,
      maxAttempts: Q6
    }), F(this, li, null);
  }
  /**
   *  The fetch URL to request.
   */
  get url() {
    return x(this, yc);
  }
  set url(e) {
    F(this, yc, String(e));
  }
  /**
   *  The fetch body, if any, to send as the request body. //(default: null)//
   *
   *  When setting a body, the intrinsic ``Content-Type`` is automatically
   *  set and will be used if **not overridden** by setting a custom
   *  header.
   *
   *  If %%body%% is null, the body is cleared (along with the
   *  intrinsic ``Content-Type``).
   *
   *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
   *  ``text/plain``.
   *
   *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
   *  ``application/octet-stream``.
   *
   *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
   *  set to ``application/json``.
   */
  get body() {
    return x(this, Ht) == null ? null : new Uint8Array(x(this, Ht));
  }
  set body(e) {
    if (e == null)
      F(this, Ht, void 0), F(this, Or, void 0);
    else if (typeof e == "string")
      F(this, Ht, It(e)), F(this, Or, "text/plain");
    else if (e instanceof Uint8Array)
      F(this, Ht, e), F(this, Or, "application/octet-stream");
    else if (typeof e == "object")
      F(this, Ht, It(JSON.stringify(e))), F(this, Or, "application/json");
    else
      throw new Error("invalid body");
  }
  /**
   *  Returns true if the request has a body.
   */
  hasBody() {
    return x(this, Ht) != null;
  }
  /**
   *  The HTTP method to use when requesting the URI. If no method
   *  has been explicitly set, then ``GET`` is used if the body is
   *  null and ``POST`` otherwise.
   */
  get method() {
    return x(this, xs) ? x(this, xs) : this.hasBody() ? "POST" : "GET";
  }
  set method(e) {
    e == null && (e = ""), F(this, xs, String(e).toUpperCase());
  }
  /**
   *  The headers that will be used when requesting the URI. All
   *  keys are lower-case.
   *
   *  This object is a copy, so any changes will **NOT** be reflected
   *  in the ``FetchRequest``.
   *
   *  To set a header entry, use the ``setHeader`` method.
   */
  get headers() {
    const e = Object.assign({}, x(this, pn));
    return x(this, ms) && (e.authorization = `Basic ${Yb(It(x(this, ms)))}`), this.allowGzip && (e["accept-encoding"] = "gzip"), e["content-type"] == null && x(this, Or) && (e["content-type"] = x(this, Or)), this.body && (e["content-length"] = String(this.body.length)), e;
  }
  /**
   *  Get the header for %%key%%, ignoring case.
   */
  getHeader(e) {
    return this.headers[e.toLowerCase()];
  }
  /**
   *  Set the header for %%key%% to %%value%%. All values are coerced
   *  to a string.
   */
  setHeader(e, t) {
    x(this, pn)[String(e).toLowerCase()] = String(t);
  }
  /**
   *  Clear all headers, resetting all intrinsic headers.
   */
  clearHeaders() {
    F(this, pn, {});
  }
  [Symbol.iterator]() {
    const e = this.headers, t = Object.keys(e);
    let n = 0;
    return {
      next: () => {
        if (n < t.length) {
          const s = t[n++];
          return {
            value: [s, e[s]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  The value that will be sent for the ``Authorization`` header.
   *
   *  To set the credentials, use the ``setCredentials`` method.
   */
  get credentials() {
    return x(this, ms) || null;
  }
  /**
   *  Sets an ``Authorization`` for %%username%% with %%password%%.
   */
  setCredentials(e, t) {
    ue(!e.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), F(this, ms, `${e}:${t}`);
  }
  /**
   *  Enable and request gzip-encoded responses. The response will
   *  automatically be decompressed. //(default: true)//
   */
  get allowGzip() {
    return x(this, xc);
  }
  set allowGzip(e) {
    F(this, xc, !!e);
  }
  /**
   *  Allow ``Authentication`` credentials to be sent over insecure
   *  channels. //(default: false)//
   */
  get allowInsecureAuthentication() {
    return !!x(this, gc);
  }
  set allowInsecureAuthentication(e) {
    F(this, gc, !!e);
  }
  /**
   *  The timeout (in milliseconds) to wait for a complete response.
   *  //(default: 5 minutes)//
   */
  get timeout() {
    return x(this, mc);
  }
  set timeout(e) {
    ue(e >= 0, "timeout must be non-zero", "timeout", e), F(this, mc, e);
  }
  /**
   *  This function is called prior to each request, for example
   *  during a redirection or retry in case of server throttling.
   *
   *  This offers an opportunity to populate headers or update
   *  content before sending a request.
   */
  get preflightFunc() {
    return x(this, ja) || null;
  }
  set preflightFunc(e) {
    F(this, ja, e);
  }
  /**
   *  This function is called after each response, offering an
   *  opportunity to provide client-level throttling or updating
   *  response data.
   *
   *  Any error thrown in this causes the ``send()`` to throw.
   *
   *  To schedule a retry attempt (assuming the maximum retry limit
   *  has not been reached), use [[response.throwThrottleError]].
   */
  get processFunc() {
    return x(this, Ha) || null;
  }
  set processFunc(e) {
    F(this, Ha, e);
  }
  /**
   *  This function is called on each retry attempt.
   */
  get retryFunc() {
    return x(this, Ga) || null;
  }
  set retryFunc(e) {
    F(this, Ga, e);
  }
  /**
   *  This function is called to fetch content from HTTP and
   *  HTTPS URLs and is platform specific (e.g. nodejs vs
   *  browsers).
   *
   *  This is by default the currently registered global getUrl
   *  function, which can be changed using [[registerGetUrl]].
   *  If this has been set, setting is to ``null`` will cause
   *  this FetchRequest (and any future clones) to revert back to
   *  using the currently registered global getUrl function.
   *
   *  Setting this is generally not necessary, but may be useful
   *  for developers that wish to intercept requests or to
   *  configurege a proxy or other agent.
   */
  get getUrlFunc() {
    return x(this, li) || Cx;
  }
  set getUrlFunc(e) {
    F(this, li, e);
  }
  toString() {
    return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${x(this, Ht) ? Oe(x(this, Ht)) : "null"}>`;
  }
  /**
   *  Update the throttle parameters used to determine maximum
   *  attempts and exponential-backoff properties.
   */
  setThrottleParams(e) {
    e.slotInterval != null && (x(this, bn).slotInterval = e.slotInterval), e.maxAttempts != null && (x(this, bn).maxAttempts = e.maxAttempts);
  }
  /**
   *  Resolves to the response by sending the request.
   */
  send() {
    return Ee(x(this, jn) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), F(this, jn, new Xb(this)), de(this, Va, n0).call(this, 0, Rx() + this.timeout, 0, this, new Wn(0, "", {}, null, this));
  }
  /**
   *  Cancels the inflight response, causing a ``CANCELLED``
   *  error to be rejected from the [[send]].
   */
  cancel() {
    Ee(x(this, jn) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
    const e = K2.get(this);
    if (!e)
      throw new Error("missing signal; should not happen");
    e();
  }
  /**
   *  Returns a new [[FetchRequest]] that represents the redirection
   *  to %%location%%.
   */
  redirect(e) {
    const t = this.url.split(":")[0].toLowerCase(), n = e.split(":")[0].toLowerCase();
    Ee(this.method === "GET" && (t !== "https" || n !== "http") && e.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
      operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(e)})`
    });
    const s = new Cd(e);
    return s.method = "GET", s.allowGzip = this.allowGzip, s.timeout = this.timeout, F(s, pn, Object.assign({}, x(this, pn))), x(this, Ht) && F(s, Ht, new Uint8Array(x(this, Ht))), F(s, Or, x(this, Or)), s;
  }
  /**
   *  Create a new copy of this request.
   */
  clone() {
    const e = new Cd(this.url);
    return F(e, xs, x(this, xs)), x(this, Ht) && F(e, Ht, x(this, Ht)), F(e, Or, x(this, Or)), F(e, pn, Object.assign({}, x(this, pn))), F(e, ms, x(this, ms)), this.allowGzip && (e.allowGzip = !0), e.timeout = this.timeout, this.allowInsecureAuthentication && (e.allowInsecureAuthentication = !0), F(e, ja, x(this, ja)), F(e, Ha, x(this, Ha)), F(e, Ga, x(this, Ga)), F(e, bn, Object.assign({}, x(this, bn))), F(e, li, x(this, li)), e;
  }
  /**
   *  Locks all static configuration for gateways and FetchGetUrlFunc
   *  registration.
   */
  static lockConfig() {
    Rh = !0;
  }
  /**
   *  Get the current Gateway function for %%scheme%%.
   */
  static getGateway(e) {
    return mf[e.toLowerCase()] || null;
  }
  /**
   *  Use the %%func%% when fetching URIs using %%scheme%%.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGateway(e, t) {
    if (e = e.toLowerCase(), e === "http" || e === "https")
      throw new Error(`cannot intercept ${e}; use registerGetUrl`);
    if (Rh)
      throw new Error("gateways locked");
    mf[e] = t;
  }
  /**
   *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGetUrl(e) {
    if (Rh)
      throw new Error("gateways locked");
    Cx = e;
  }
  /**
   *  Creates a getUrl function that fetches content from HTTP and
   *  HTTPS URLs.
   *
   *  The available %%options%% are dependent on the platform
   *  implementation of the default getUrl function.
   *
   *  This is not generally something that is needed, but is useful
   *  when trying to customize simple behaviour when fetching HTTP
   *  content.
   */
  static createGetUrlFunc(e) {
    return G2();
  }
  /**
   *  Creates a function that can "fetch" data URIs.
   *
   *  Note that this is automatically done internally to support
   *  data URIs, so it is not necessary to register it.
   *
   *  This is not generally something that is needed, but may
   *  be useful in a wrapper to perfom custom data URI functionality.
   */
  static createDataGateway() {
    return V2;
  }
  /**
   *  Creates a function that will fetch IPFS (unvalidated) from
   *  a custom gateway baseUrl.
   *
   *  The default IPFS gateway used internally is
   *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
   */
  static createIpfsGatewayFunc(e) {
    return $2(e);
  }
};
gc = new WeakMap(), xc = new WeakMap(), pn = new WeakMap(), xs = new WeakMap(), mc = new WeakMap(), yc = new WeakMap(), Ht = new WeakMap(), Or = new WeakMap(), ms = new WeakMap(), ja = new WeakMap(), Ha = new WeakMap(), Ga = new WeakMap(), jn = new WeakMap(), bn = new WeakMap(), li = new WeakMap(), Va = new WeakSet(), n0 = async function(e, t, n, s, i) {
  var l, f, d;
  if (e >= x(this, bn).maxAttempts)
    return i.makeServerError("exceeded maximum retry limit");
  Ee(Rx() <= t, "timeout", "TIMEOUT", {
    operation: "request.send",
    reason: "timeout",
    request: s
  }), n > 0 && await X6(n);
  let a = this.clone();
  const o = (a.url.split(":")[0] || "").toLowerCase();
  if (o in mf) {
    const h = await mf[o](a.url, yf(x(s, jn)));
    if (h instanceof Wn) {
      let p = h;
      if (this.processFunc) {
        yf(x(s, jn));
        try {
          p = await this.processFunc(a, p);
        } catch (g) {
          (g.throttle == null || typeof g.stall != "number") && p.makeServerError("error in post-processing function", g).assertOk();
        }
      }
      return p;
    }
    a = h;
  }
  this.preflightFunc && (a = await this.preflightFunc(a));
  const u = await this.getUrlFunc(a, yf(x(s, jn)));
  let c = new Wn(u.statusCode, u.statusMessage, u.headers, u.body, s);
  if (c.statusCode === 301 || c.statusCode === 302) {
    try {
      const h = c.headers.location || "";
      return de(l = a.redirect(h), Va, n0).call(l, e + 1, t, 0, s, c);
    } catch {
    }
    return c;
  } else if (c.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(a, c, e))) {
    const h = c.headers["retry-after"];
    let p = x(this, bn).slotInterval * Math.trunc(Math.random() * Math.pow(2, e));
    return typeof h == "string" && h.match(/^[1-9][0-9]*$/) && (p = parseInt(h)), de(f = a.clone(), Va, n0).call(f, e + 1, t, p, s, c);
  }
  if (this.processFunc) {
    yf(x(s, jn));
    try {
      c = await this.processFunc(a, c);
    } catch (h) {
      (h.throttle == null || typeof h.stall != "number") && c.makeServerError("error in post-processing function", h).assertOk();
      let p = x(this, bn).slotInterval * Math.trunc(Math.random() * Math.pow(2, e));
      return h.stall >= 0 && (p = h.stall), de(d = a.clone(), Va, n0).call(d, e + 1, t, p, s, c);
    }
  }
  return c;
};
let Kt = Cd;
var S0, C0, R0, Nr, wc, $a;
const Ax = class Ax {
  constructor(e, t, n, s, i) {
    Z(this, S0);
    Z(this, C0);
    Z(this, R0);
    Z(this, Nr);
    Z(this, wc);
    Z(this, $a);
    F(this, S0, e), F(this, C0, t), F(this, R0, Object.keys(n).reduce((a, o) => (a[o.toLowerCase()] = String(n[o]), a), {})), F(this, Nr, s == null ? null : new Uint8Array(s)), F(this, wc, i || null), F(this, $a, { message: "" });
  }
  toString() {
    return `<FetchResponse status=${this.statusCode} body=${x(this, Nr) ? Oe(x(this, Nr)) : "null"}>`;
  }
  /**
   *  The response status code.
   */
  get statusCode() {
    return x(this, S0);
  }
  /**
   *  The response status message.
   */
  get statusMessage() {
    return x(this, C0);
  }
  /**
   *  The response headers. All keys are lower-case.
   */
  get headers() {
    return Object.assign({}, x(this, R0));
  }
  /**
   *  The response body, or ``null`` if there was no body.
   */
  get body() {
    return x(this, Nr) == null ? null : new Uint8Array(x(this, Nr));
  }
  /**
   *  The response body as a UTF-8 encoded string, or the empty
   *  string (i.e. ``""``) if there was no body.
   *
   *  An error is thrown if the body is invalid UTF-8 data.
   */
  get bodyText() {
    try {
      return x(this, Nr) == null ? "" : Fs(x(this, Nr));
    } catch {
      Ee(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
        operation: "bodyText",
        info: { response: this }
      });
    }
  }
  /**
   *  The response body, decoded as JSON.
   *
   *  An error is thrown if the body is invalid JSON-encoded data
   *  or if there was no body.
   */
  get bodyJson() {
    try {
      return JSON.parse(this.bodyText);
    } catch {
      Ee(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
        operation: "bodyJson",
        info: { response: this }
      });
    }
  }
  [Symbol.iterator]() {
    const e = this.headers, t = Object.keys(e);
    let n = 0;
    return {
      next: () => {
        if (n < t.length) {
          const s = t[n++];
          return {
            value: [s, e[s]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  Return a Response with matching headers and body, but with
   *  an error status code (i.e. 599) and %%message%% with an
   *  optional %%error%%.
   */
  makeServerError(e, t) {
    let n;
    e ? n = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${e})` : (e = `${this.statusCode} ${this.statusMessage}`, n = `CLIENT ESCALATED SERVER ERROR (${e})`);
    const s = new Ax(599, n, this.headers, this.body, x(this, wc) || void 0);
    return F(s, $a, { message: e, error: t }), s;
  }
  /**
   *  If called within a [request.processFunc](FetchRequest-processFunc)
   *  call, causes the request to retry as if throttled for %%stall%%
   *  milliseconds.
   */
  throwThrottleError(e, t) {
    t == null ? t = -1 : ue(Number.isInteger(t) && t >= 0, "invalid stall timeout", "stall", t);
    const n = new Error(e || "throttling requests");
    throw _e(n, { stall: t, throttle: !0 }), n;
  }
  /**
   *  Get the header value for %%key%%, ignoring case.
   */
  getHeader(e) {
    return this.headers[e.toLowerCase()];
  }
  /**
   *  Returns true if the response has a body.
   */
  hasBody() {
    return x(this, Nr) != null;
  }
  /**
   *  The request made for this response.
   */
  get request() {
    return x(this, wc);
  }
  /**
   *  Returns true if this response was a success statusCode.
   */
  ok() {
    return x(this, $a).message === "" && this.statusCode >= 200 && this.statusCode < 300;
  }
  /**
   *  Throws a ``SERVER_ERROR`` if this response is not ok.
   */
  assertOk() {
    if (this.ok())
      return;
    let { message: e, error: t } = x(this, $a);
    e === "" && (e = `server response ${this.statusCode} ${this.statusMessage}`);
    let n = null;
    this.request && (n = this.request.url);
    let s = null;
    try {
      x(this, Nr) && (s = Fs(x(this, Nr)));
    } catch {
    }
    Ee(!1, e, "SERVER_ERROR", {
      request: this.request || "unknown request",
      response: this,
      error: t,
      info: {
        requestUrl: n,
        responseBody: s,
        responseStatus: `${this.statusCode} ${this.statusMessage}`
      }
    });
  }
};
S0 = new WeakMap(), C0 = new WeakMap(), R0 = new WeakMap(), Nr = new WeakMap(), wc = new WeakMap(), $a = new WeakMap();
let Wn = Ax;
function Rx() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Z6(r) {
  return It(r.replace(/%([0-9a-f][0-9a-f])/gi, (e, t) => String.fromCharCode(parseInt(t, 16))));
}
function X6(r) {
  return new Promise((e) => setTimeout(e, r));
}
const e8 = BigInt(-1), ln = BigInt(0), oc = BigInt(1), t8 = BigInt(5), Ko = {};
let fc = "0000";
for (; fc.length < 80; )
  fc += fc;
function Zi(r) {
  let e = fc;
  for (; e.length < r; )
    e += e;
  return BigInt("1" + e.substring(0, r));
}
function Hu(r, e, t) {
  const n = BigInt(e.width);
  if (e.signed) {
    const s = oc << n - oc;
    Ee(t == null || r >= -s && r < s, "overflow", "NUMERIC_FAULT", {
      operation: t,
      fault: "overflow",
      value: r
    }), r > ln ? r = ou(Cs(r, n), n) : r = -ou(Cs(-r, n), n);
  } else {
    const s = oc << n;
    Ee(t == null || r >= 0 && r < s, "overflow", "NUMERIC_FAULT", {
      operation: t,
      fault: "overflow",
      value: r
    }), r = (r % s + s) % s & s - oc;
  }
  return r;
}
function Ih(r) {
  typeof r == "number" && (r = `fixed128x${r}`);
  let e = !0, t = 128, n = 18;
  if (typeof r == "string") {
    if (r !== "fixed") if (r === "ufixed")
      e = !1;
    else {
      const i = r.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
      ue(i, "invalid fixed format", "format", r), e = i[1] !== "u", t = parseInt(i[2]), n = parseInt(i[3]);
    }
  } else if (r) {
    const i = r, a = (o, u, c) => i[o] == null ? c : (ue(typeof i[o] === u, "invalid fixed format (" + o + " not " + u + ")", "format." + o, i[o]), i[o]);
    e = a("signed", "boolean", e), t = a("width", "number", t), n = a("decimals", "number", n);
  }
  ue(t % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", t), ue(n <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", n);
  const s = (e ? "" : "u") + "fixed" + String(t) + "x" + String(n);
  return { signed: e, width: t, decimals: n, name: s };
}
function r8(r, e) {
  let t = "";
  r < ln && (t = "-", r *= e8);
  let n = r.toString();
  if (e === 0)
    return t + n;
  for (; n.length <= e; )
    n = fc + n;
  const s = n.length - e;
  for (n = n.substring(0, s) + "." + n.substring(s); n[0] === "0" && n[1] !== "."; )
    n = n.substring(1);
  for (; n[n.length - 1] === "0" && n[n.length - 2] !== "."; )
    n = n.substring(0, n.length - 1);
  return t + n;
}
var gn, ut, ar, ct, Ta, ls, Rp, Ip, _p, Up;
const ci = class ci {
  // Use this when changing this file to get some typing info,
  // but then switch to any to mask the internal type
  //constructor(guard: any, value: bigint, format: _FixedFormat) {
  /**
   *  @private
   */
  constructor(e, t, n) {
    Z(this, ct);
    /**
     *  The specific fixed-point arithmetic field for this value.
     */
    Q(this, "format");
    Z(this, gn);
    // The actual value (accounting for decimals)
    Z(this, ut);
    // A base-10 value to multiple values by to maintain the magnitude
    Z(this, ar);
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */
    Q(this, "_value");
    es(e, Ko, "FixedNumber"), F(this, ut, t), F(this, gn, n);
    const s = r8(t, n.decimals);
    _e(this, { format: n.name, _value: s }), F(this, ar, Zi(n.decimals));
  }
  /**
   *  If true, negative values are permitted, otherwise only
   *  positive values and zero are allowed.
   */
  get signed() {
    return x(this, gn).signed;
  }
  /**
   *  The number of bits available to store the value.
   */
  get width() {
    return x(this, gn).width;
  }
  /**
   *  The number of decimal places in the fixed-point arithment field.
   */
  get decimals() {
    return x(this, gn).decimals;
  }
  /**
   *  The value as an integer, based on the smallest unit the
   *  [[decimals]] allow.
   */
  get value() {
    return x(this, ut);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%, ignoring overflow.
   */
  addUnsafe(e) {
    return de(this, ct, Rp).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  add(e) {
    return de(this, ct, Rp).call(this, e, "add");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%, ignoring overflow.
   */
  subUnsafe(e) {
    return de(this, ct, Ip).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  sub(e) {
    return de(this, ct, Ip).call(this, e, "sub");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%, ignoring overflow and underflow (precision loss).
   */
  mulUnsafe(e) {
    return de(this, ct, _p).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  mul(e) {
    return de(this, ct, _p).call(this, e, "mul");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs or if underflow (precision loss) occurs.
   */
  mulSignal(e) {
    de(this, ct, Ta).call(this, e);
    const t = x(this, ut) * x(e, ut);
    return Ee(t % x(this, ar) === ln, "precision lost during signalling mul", "NUMERIC_FAULT", {
      operation: "mulSignal",
      fault: "underflow",
      value: this
    }), de(this, ct, ls).call(this, t / x(this, ar), "mulSignal");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  divUnsafe(e) {
    return de(this, ct, Up).call(this, e);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  div(e) {
    return de(this, ct, Up).call(this, e, "div");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
   *  (precision loss) occurs.
   */
  divSignal(e) {
    Ee(x(e, ut) !== ln, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), de(this, ct, Ta).call(this, e);
    const t = x(this, ut) * x(this, ar);
    return Ee(t % x(e, ut) === ln, "precision lost during signalling div", "NUMERIC_FAULT", {
      operation: "divSignal",
      fault: "underflow",
      value: this
    }), de(this, ct, ls).call(this, t / x(e, ut), "divSignal");
  }
  /**
   *  Returns a comparison result between %%this%% and %%other%%.
   *
   *  This is suitable for use in sorting, where ``-1`` implies %%this%%
   *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
   *  both are equal.
   */
  cmp(e) {
    let t = this.value, n = e.value;
    const s = this.decimals - e.decimals;
    return s > 0 ? n *= Zi(s) : s < 0 && (t *= Zi(-s)), t < n ? -1 : t > n ? 1 : 0;
  }
  /**
   *  Returns true if %%other%% is equal to %%this%%.
   */
  eq(e) {
    return this.cmp(e) === 0;
  }
  /**
   *  Returns true if %%other%% is less than to %%this%%.
   */
  lt(e) {
    return this.cmp(e) < 0;
  }
  /**
   *  Returns true if %%other%% is less than or equal to %%this%%.
   */
  lte(e) {
    return this.cmp(e) <= 0;
  }
  /**
   *  Returns true if %%other%% is greater than to %%this%%.
   */
  gt(e) {
    return this.cmp(e) > 0;
  }
  /**
   *  Returns true if %%other%% is greater than or equal to %%this%%.
   */
  gte(e) {
    return this.cmp(e) >= 0;
  }
  /**
   *  Returns a new [[FixedNumber]] which is the largest **integer**
   *  that is less than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  floor() {
    let e = x(this, ut);
    return x(this, ut) < ln && (e -= x(this, ar) - oc), e = x(this, ut) / x(this, ar) * x(this, ar), de(this, ct, ls).call(this, e, "floor");
  }
  /**
   *  Returns a new [[FixedNumber]] which is the smallest **integer**
   *  that is greater than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  ceiling() {
    let e = x(this, ut);
    return x(this, ut) > ln && (e += x(this, ar) - oc), e = x(this, ut) / x(this, ar) * x(this, ar), de(this, ct, ls).call(this, e, "ceiling");
  }
  /**
   *  Returns a new [[FixedNumber]] with the decimal component
   *  rounded up on ties at %%decimals%% places.
   */
  round(e) {
    if (e == null && (e = 0), e >= this.decimals)
      return this;
    const t = this.decimals - e, n = t8 * Zi(t - 1);
    let s = this.value + n;
    const i = Zi(t);
    return s = s / i * i, Hu(s, x(this, gn), "round"), new ci(Ko, s, x(this, gn));
  }
  /**
   *  Returns true if %%this%% is equal to ``0``.
   */
  isZero() {
    return x(this, ut) === ln;
  }
  /**
   *  Returns true if %%this%% is less than ``0``.
   */
  isNegative() {
    return x(this, ut) < ln;
  }
  /**
   *  Returns the string representation of %%this%%.
   */
  toString() {
    return this._value;
  }
  /**
   *  Returns a float approximation.
   *
   *  Due to IEEE 754 precission (or lack thereof), this function
   *  can only return an approximation and most values will contain
   *  rounding errors.
   */
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  /**
   *  Return a new [[FixedNumber]] with the same value but has had
   *  its field set to %%format%%.
   *
   *  This will throw if the value cannot fit into %%format%%.
   */
  toFormat(e) {
    return ci.fromString(this.toString(), e);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% divided by
   *  %%decimal%% places with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
   *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
   *  or underflow (precision loss).
   */
  static fromValue(e, t, n) {
    const s = t == null ? 0 : Ve(t), i = Ih(n);
    let a = De(e, "value");
    const o = s - i.decimals;
    if (o > 0) {
      const u = Zi(o);
      Ee(a % u === ln, "value loses precision for format", "NUMERIC_FAULT", {
        operation: "fromValue",
        fault: "underflow",
        value: e
      }), a /= u;
    } else o < 0 && (a *= Zi(-o));
    return Hu(a, i, "fromValue"), new ci(Ko, a, i);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%%, either due to overflow or underflow (precision loss).
   */
  static fromString(e, t) {
    const n = e.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
    ue(n && n[2].length + n[3].length > 0, "invalid FixedNumber string value", "value", e);
    const s = Ih(t);
    let i = n[2] || "0", a = n[3] || "";
    for (; a.length < s.decimals; )
      a += fc;
    Ee(a.substring(s.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
      operation: "fromString",
      fault: "underflow",
      value: e
    }), a = a.substring(0, s.decimals);
    const o = BigInt(n[1] + i + a);
    return Hu(o, s, "fromString"), new ci(Ko, o, s);
  }
  /**
   *  Creates a new [[FixedNumber]] with the big-endian representation
   *  %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%% due to overflow.
   */
  static fromBytes(e, t) {
    let n = Bo(Ce(e, "value"));
    const s = Ih(t);
    return s.signed && (n = ou(n, s.width)), Hu(n, s, "fromBytes"), new ci(Ko, n, s);
  }
};
gn = new WeakMap(), ut = new WeakMap(), ar = new WeakMap(), ct = new WeakSet(), Ta = function(e) {
  ue(this.format === e.format, "incompatible format; use fixedNumber.toFormat", "other", e);
}, ls = function(e, t) {
  return e = Hu(e, x(this, gn), t), new ci(Ko, e, x(this, gn));
}, Rp = function(e, t) {
  return de(this, ct, Ta).call(this, e), de(this, ct, ls).call(this, x(this, ut) + x(e, ut), t);
}, Ip = function(e, t) {
  return de(this, ct, Ta).call(this, e), de(this, ct, ls).call(this, x(this, ut) - x(e, ut), t);
}, _p = function(e, t) {
  return de(this, ct, Ta).call(this, e), de(this, ct, ls).call(this, x(this, ut) * x(e, ut) / x(this, ar), t);
}, Up = function(e, t) {
  return Ee(x(e, ut) !== ln, "division by zero", "NUMERIC_FAULT", {
    operation: "div",
    fault: "divide-by-zero",
    value: this
  }), de(this, ct, Ta).call(this, e), de(this, ct, ls).call(this, x(this, ut) * x(this, ar) / x(e, ut), t);
};
let cu = ci;
function n8(r) {
  let e = r.toString(16);
  for (; e.length < 2; )
    e = "0" + e;
  return "0x" + e;
}
function Ix(r, e, t) {
  let n = 0;
  for (let s = 0; s < t; s++)
    n = n * 256 + r[e + s];
  return n;
}
function _x(r, e, t, n) {
  const s = [];
  for (; t < e + 1 + n; ) {
    const i = z2(r, t);
    s.push(i.result), t += i.consumed, Ee(t <= e + 1 + n, "child data too short", "BUFFER_OVERRUN", {
      buffer: r,
      length: n,
      offset: e
    });
  }
  return { consumed: 1 + n, result: s };
}
function z2(r, e) {
  Ee(r.length !== 0, "data too short", "BUFFER_OVERRUN", {
    buffer: r,
    length: 0,
    offset: 1
  });
  const t = (n) => {
    Ee(n <= r.length, "data short segment too short", "BUFFER_OVERRUN", {
      buffer: r,
      length: r.length,
      offset: n
    });
  };
  if (r[e] >= 248) {
    const n = r[e] - 247;
    t(e + 1 + n);
    const s = Ix(r, e + 1, n);
    return t(e + 1 + n + s), _x(r, e, e + 1 + n, n + s);
  } else if (r[e] >= 192) {
    const n = r[e] - 192;
    return t(e + 1 + n), _x(r, e, e + 1, n);
  } else if (r[e] >= 184) {
    const n = r[e] - 183;
    t(e + 1 + n);
    const s = Ix(r, e + 1, n);
    t(e + 1 + n + s);
    const i = Oe(r.slice(e + 1 + n, e + 1 + n + s));
    return { consumed: 1 + n + s, result: i };
  } else if (r[e] >= 128) {
    const n = r[e] - 128;
    t(e + 1 + n);
    const s = Oe(r.slice(e + 1, e + 1 + n));
    return { consumed: 1 + n, result: s };
  }
  return { consumed: 1, result: n8(r[e]) };
}
function Ru(r) {
  const e = Ce(r, "data"), t = z2(e, 0);
  return ue(t.consumed === e.length, "unexpected junk after rlp payload", "data", r), t.result;
}
function Ux(r) {
  const e = [];
  for (; r; )
    e.unshift(r & 255), r >>= 8;
  return e;
}
function J2(r) {
  if (Array.isArray(r)) {
    let n = [];
    if (r.forEach(function(i) {
      n = n.concat(J2(i));
    }), n.length <= 55)
      return n.unshift(192 + n.length), n;
    const s = Ux(n.length);
    return s.unshift(247 + s.length), s.concat(n);
  }
  const e = Array.prototype.slice.call(Ce(r, "object"));
  if (e.length === 1 && e[0] <= 127)
    return e;
  if (e.length <= 55)
    return e.unshift(128 + e.length), e;
  const t = Ux(e.length);
  return t.unshift(183 + t.length), t.concat(e);
}
const Lx = "0123456789abcdef";
function Ds(r) {
  let e = "0x";
  for (const t of J2(r))
    e += Lx[t >> 4], e += Lx[t & 15];
  return e;
}
const Q2 = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function eg(r, e) {
  let t = 18;
  if (typeof e == "string") {
    const n = Q2.indexOf(e);
    ue(n >= 0, "invalid unit", "unit", e), t = 3 * n;
  } else e != null && (t = Ve(e, "unit"));
  return cu.fromValue(r, t, { decimals: t, width: 512 }).toString();
}
function tg(r, e) {
  ue(typeof r == "string", "value must be a string", "value", r);
  let t = 18;
  if (typeof e == "string") {
    const n = Q2.indexOf(e);
    ue(n >= 0, "invalid unit", "unit", e), t = 3 * n;
  } else e != null && (t = Ve(e, "unit"));
  return cu.fromString(r, { decimals: t, width: 512 }).value;
}
function q2(r) {
  return eg(r, 18);
}
function W2(r) {
  return tg(r, 18);
}
function rg(r) {
  const e = Ce(r, "randomBytes");
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const t = Oe(e);
  return [
    t.substring(2, 10),
    t.substring(10, 14),
    t.substring(14, 18),
    t.substring(18, 22),
    t.substring(22, 34)
  ].join("-");
}
const cr = 32, Lp = new Uint8Array(cr), s8 = ["then"], wf = {}, Y2 = /* @__PURE__ */ new WeakMap();
function Ca(r) {
  return Y2.get(r);
}
function Mx(r, e) {
  Y2.set(r, e);
}
function Gu(r, e) {
  const t = new Error(`deferred error during ABI decoding triggered accessing ${r}`);
  throw t.error = e, t;
}
function Mp(r, e, t) {
  return r.indexOf(null) >= 0 ? e.map((n, s) => n instanceof Ri ? Mp(Ca(n), n, t) : n) : r.reduce((n, s, i) => {
    let a = e.getValue(s);
    return s in n || (t && a instanceof Ri && (a = Mp(Ca(a), a, t)), n[s] = a), n;
  }, {});
}
var Ac;
const cc = class cc extends Array {
  /**
   *  @private
   */
  constructor(...t) {
    const n = t[0];
    let s = t[1], i = (t[2] || []).slice(), a = !0;
    n !== wf && (s = t, i = [], a = !1);
    super(s.length);
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    Z(this, Ac);
    s.forEach((c, l) => {
      this[l] = c;
    });
    const o = i.reduce((c, l) => (typeof l == "string" && c.set(l, (c.get(l) || 0) + 1), c), /* @__PURE__ */ new Map());
    if (Mx(this, Object.freeze(s.map((c, l) => {
      const f = i[l];
      return f != null && o.get(f) === 1 ? f : null;
    }))), F(this, Ac, []), x(this, Ac) == null && x(this, Ac), !a)
      return;
    Object.freeze(this);
    const u = new Proxy(this, {
      get: (c, l, f) => {
        if (typeof l == "string") {
          if (l.match(/^[0-9]+$/)) {
            const h = Ve(l, "%index");
            if (h < 0 || h >= this.length)
              throw new RangeError("out of result range");
            const p = c[h];
            return p instanceof Error && Gu(`index ${h}`, p), p;
          }
          if (s8.indexOf(l) >= 0)
            return Reflect.get(c, l, f);
          const d = c[l];
          if (d instanceof Function)
            return function(...h) {
              return d.apply(this === f ? c : this, h);
            };
          if (!(l in c))
            return c.getValue.apply(this === f ? c : this, [l]);
        }
        return Reflect.get(c, l, f);
      }
    });
    return Mx(u, Ca(this)), u;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(t) {
    const n = [];
    return this.forEach((s, i) => {
      s instanceof Error && Gu(`index ${i}`, s), t && s instanceof cc && (s = s.toArray(t)), n.push(s);
    }), n;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(t) {
    const n = Ca(this);
    return n.reduce((s, i, a) => (Ee(i != null, `value at index ${a} unnamed`, "UNSUPPORTED_OPERATION", {
      operation: "toObject()"
    }), Mp(n, this, t)), {});
  }
  /**
   *  @_ignore
   */
  slice(t, n) {
    t == null && (t = 0), t < 0 && (t += this.length, t < 0 && (t = 0)), n == null && (n = this.length), n < 0 && (n += this.length, n < 0 && (n = 0)), n > this.length && (n = this.length);
    const s = Ca(this), i = [], a = [];
    for (let o = t; o < n; o++)
      i.push(this[o]), a.push(s[o]);
    return new cc(wf, i, a);
  }
  /**
   *  @_ignore
   */
  filter(t, n) {
    const s = Ca(this), i = [], a = [];
    for (let o = 0; o < this.length; o++) {
      const u = this[o];
      u instanceof Error && Gu(`index ${o}`, u), t.call(n, u, o, this) && (i.push(u), a.push(s[o]));
    }
    return new cc(wf, i, a);
  }
  /**
   *  @_ignore
   */
  map(t, n) {
    const s = [];
    for (let i = 0; i < this.length; i++) {
      const a = this[i];
      a instanceof Error && Gu(`index ${i}`, a), s.push(t.call(n, a, i, this));
    }
    return s;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(t) {
    const n = Ca(this).indexOf(t);
    if (n === -1)
      return;
    const s = this[n];
    return s instanceof Error && Gu(`property ${JSON.stringify(t)}`, s.error), s;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(t, n) {
    return new cc(wf, t, n);
  }
};
Ac = new WeakMap();
let Ri = cc;
function Z2(r) {
  const e = [], t = function(n, s) {
    if (Array.isArray(s))
      for (let i in s) {
        const a = n.slice();
        a.push(i);
        try {
          t(a, s[i]);
        } catch (o) {
          e.push({ path: a, error: o });
        }
      }
  };
  return t([], r), e;
}
function Fx(r) {
  let e = Ft(r);
  return Ee(e.length <= cr, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: e, length: cr, offset: e.length }), e.length !== cr && (e = Mt(it([Lp.slice(e.length % cr), e]))), e;
}
class Vs {
  constructor(e, t, n, s) {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    Q(this, "name");
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    Q(this, "type");
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    Q(this, "localName");
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    Q(this, "dynamic");
    _e(this, { name: e, type: t, localName: n, dynamic: s }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(e, t) {
    ue(!1, e, this.localName, t);
  }
}
var ys, Ka, Ec, Ff;
class Fp {
  constructor() {
    Z(this, Ec);
    // An array of WordSize lengthed objects to concatenation
    Z(this, ys);
    Z(this, Ka);
    F(this, ys, []), F(this, Ka, 0);
  }
  get data() {
    return it(x(this, ys));
  }
  get length() {
    return x(this, Ka);
  }
  appendWriter(e) {
    return de(this, Ec, Ff).call(this, Mt(e.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(e) {
    let t = Mt(e);
    const n = t.length % cr;
    return n && (t = Mt(it([t, Lp.slice(n)]))), de(this, Ec, Ff).call(this, t);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(e) {
    return de(this, Ec, Ff).call(this, Fx(e));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const e = x(this, ys).length;
    return x(this, ys).push(Lp), F(this, Ka, x(this, Ka) + cr), (t) => {
      x(this, ys)[e] = Fx(t);
    };
  }
}
ys = new WeakMap(), Ka = new WeakMap(), Ec = new WeakSet(), Ff = function(e) {
  return x(this, ys).push(e), F(this, Ka, x(this, Ka) + e.length), e.length;
};
var fr, Sr, za, Ja, fi, To, jp, X2;
const Ex = class Ex {
  constructor(e, t, n) {
    Z(this, To);
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    Q(this, "allowLoose");
    Z(this, fr);
    Z(this, Sr);
    Z(this, za);
    Z(this, Ja);
    Z(this, fi);
    _e(this, { allowLoose: !!t }), F(this, fr, Mt(e)), F(this, za, 0), F(this, Ja, null), F(this, fi, n ?? 1024), F(this, Sr, 0);
  }
  get data() {
    return Oe(x(this, fr));
  }
  get dataLength() {
    return x(this, fr).length;
  }
  get consumed() {
    return x(this, Sr);
  }
  get bytes() {
    return new Uint8Array(x(this, fr));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(e) {
    const t = new Ex(x(this, fr).slice(x(this, Sr) + e), this.allowLoose, x(this, fi));
    return F(t, Ja, this), t;
  }
  // Read bytes
  readBytes(e, t) {
    let n = de(this, To, X2).call(this, 0, e, !!t);
    return de(this, To, jp).call(this, e), F(this, Sr, x(this, Sr) + n.length), n.slice(0, e);
  }
  // Read a numeric values
  readValue() {
    return Bo(this.readBytes(cr));
  }
  readIndex() {
    return Qb(this.readBytes(cr));
  }
};
fr = new WeakMap(), Sr = new WeakMap(), za = new WeakMap(), Ja = new WeakMap(), fi = new WeakMap(), To = new WeakSet(), jp = function(e) {
  var t;
  if (x(this, Ja))
    return de(t = x(this, Ja), To, jp).call(t, e);
  F(this, za, x(this, za) + e), Ee(x(this, fi) < 1 || x(this, za) <= x(this, fi) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${x(this, fi)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: Mt(x(this, fr)),
    offset: x(this, Sr),
    length: e,
    info: {
      bytesRead: x(this, za),
      dataLength: this.dataLength
    }
  });
}, X2 = function(e, t, n) {
  let s = Math.ceil(t / cr) * cr;
  return x(this, Sr) + s > x(this, fr).length && (this.allowLoose && n && x(this, Sr) + t <= x(this, fr).length ? s = t : Ee(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: Mt(x(this, fr)),
    length: x(this, fr).length,
    offset: x(this, Sr) + s
  })), x(this, fr).slice(x(this, Sr), x(this, Sr) + s);
};
let Dp = Ex;
function Rr(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error(`Wrong positive integer: ${r}`);
}
function ng(r, ...e) {
  if (!(r instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(r.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${r.length}`);
}
function ew(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Rr(r.outputLen), Rr(r.blockLen);
}
function uu(r, e = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function tw(r, e) {
  ng(r);
  const t = e.outputLen;
  if (r.length < t)
    throw new Error(`digestInto() expects output buffer of length at least ${t}`);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const i8 = (r) => r instanceof Uint8Array, Df = (r) => new Uint32Array(r.buffer, r.byteOffset, Math.floor(r.byteLength / 4)), jf = (r) => new DataView(r.buffer, r.byteOffset, r.byteLength), Mn = (r, e) => r << 32 - e | r >>> e, a8 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!a8)
  throw new Error("Non little-endian hardware is not supported");
const o8 = async () => {
};
async function Dx(r, e, t) {
  let n = Date.now();
  for (let s = 0; s < r; s++) {
    t(s);
    const i = Date.now() - n;
    i >= 0 && i < e || (await o8(), n += i);
  }
}
function c8(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function lu(r) {
  if (typeof r == "string" && (r = c8(r)), !i8(r))
    throw new Error(`expected Uint8Array, got ${typeof r}`);
  return r;
}
class sg {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
const u8 = {}.toString;
function rw(r, e) {
  if (e !== void 0 && u8.call(e) !== "[object Object]")
    throw new Error("Options should be object or undefined");
  return Object.assign(r, e);
}
function $d(r) {
  const e = (n) => r().update(lu(n)).digest(), t = r();
  return e.outputLen = t.outputLen, e.blockLen = t.blockLen, e.create = () => r(), e;
}
class nw extends sg {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, ew(e);
    const n = lu(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const s = this.blockLen, i = new Uint8Array(s);
    i.set(n.length > s ? e.create().update(n).digest() : n);
    for (let a = 0; a < i.length; a++)
      i[a] ^= 54;
    this.iHash.update(i), this.oHash = e.create();
    for (let a = 0; a < i.length; a++)
      i[a] ^= 106;
    this.oHash.update(i), i.fill(0);
  }
  update(e) {
    return uu(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    uu(this), ng(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: n, finished: s, destroyed: i, blockLen: a, outputLen: o } = this;
    return e = e, e.finished = s, e.destroyed = i, e.blockLen = a, e.outputLen = o, e.oHash = t._cloneInto(e.oHash), e.iHash = n._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const ig = (r, e, t) => new nw(r, e).update(t).digest();
ig.create = (r, e) => new nw(r, e);
function l8(r, e, t, n) {
  ew(r);
  const s = rw({ dkLen: 32, asyncTick: 10 }, n), { c: i, dkLen: a, asyncTick: o } = s;
  if (Rr(i), Rr(a), Rr(o), i < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const u = lu(e), c = lu(t), l = new Uint8Array(a), f = ig.create(r, u), d = f._cloneInto().update(c);
  return { c: i, dkLen: a, asyncTick: o, DK: l, PRF: f, PRFSalt: d };
}
function f8(r, e, t, n, s) {
  return r.destroy(), e.destroy(), n && n.destroy(), s.fill(0), t;
}
function ag(r, e, t, n) {
  const { c: s, dkLen: i, DK: a, PRF: o, PRFSalt: u } = l8(r, e, t, n);
  let c;
  const l = new Uint8Array(4), f = jf(l), d = new Uint8Array(o.outputLen);
  for (let h = 1, p = 0; p < i; h++, p += o.outputLen) {
    const g = a.subarray(p, p + o.outputLen);
    f.setInt32(0, h, !1), (c = u._cloneInto(c)).update(l).digestInto(d), g.set(d.subarray(0, g.length));
    for (let k = 1; k < s; k++) {
      o._cloneInto(c).update(d).digestInto(d);
      for (let A = 0; A < g.length; A++)
        g[A] ^= d[A];
    }
  }
  return f8(o, u, a, c, d);
}
function d8(r, e, t, n) {
  if (typeof r.setBigUint64 == "function")
    return r.setBigUint64(e, t, n);
  const s = BigInt(32), i = BigInt(4294967295), a = Number(t >> s & i), o = Number(t & i), u = n ? 4 : 0, c = n ? 0 : 4;
  r.setUint32(e + u, a, n), r.setUint32(e + c, o, n);
}
class og extends sg {
  constructor(e, t, n, s) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = n, this.isLE = s, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = jf(this.buffer);
  }
  update(e) {
    uu(this);
    const { view: t, buffer: n, blockLen: s } = this;
    e = lu(e);
    const i = e.length;
    for (let a = 0; a < i; ) {
      const o = Math.min(s - this.pos, i - a);
      if (o === s) {
        const u = jf(e);
        for (; s <= i - a; a += s)
          this.process(u, a);
        continue;
      }
      n.set(e.subarray(a, a + o), this.pos), this.pos += o, a += o, this.pos === s && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    uu(this), tw(e, this), this.finished = !0;
    const { buffer: t, view: n, blockLen: s, isLE: i } = this;
    let { pos: a } = this;
    t[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > s - a && (this.process(n, 0), a = 0);
    for (let f = a; f < s; f++)
      t[f] = 0;
    d8(n, s - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const o = jf(e), u = this.outputLen;
    if (u % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const c = u / 4, l = this.get();
    if (c > l.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < c; f++)
      o.setUint32(4 * f, l[f], i);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const n = e.slice(0, t);
    return this.destroy(), n;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: n, length: s, finished: i, destroyed: a, pos: o } = this;
    return e.length = s, e.pos = o, e.finished = i, e.destroyed = a, s % t && e.buffer.set(n), e;
  }
}
const h8 = (r, e, t) => r & e ^ ~r & t, p8 = (r, e, t) => r & e ^ r & t ^ e & t, b8 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), ni = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), si = /* @__PURE__ */ new Uint32Array(64);
class g8 extends og {
  constructor() {
    super(64, 32, 8, !1), this.A = ni[0] | 0, this.B = ni[1] | 0, this.C = ni[2] | 0, this.D = ni[3] | 0, this.E = ni[4] | 0, this.F = ni[5] | 0, this.G = ni[6] | 0, this.H = ni[7] | 0;
  }
  get() {
    const { A: e, B: t, C: n, D: s, E: i, F: a, G: o, H: u } = this;
    return [e, t, n, s, i, a, o, u];
  }
  // prettier-ignore
  set(e, t, n, s, i, a, o, u) {
    this.A = e | 0, this.B = t | 0, this.C = n | 0, this.D = s | 0, this.E = i | 0, this.F = a | 0, this.G = o | 0, this.H = u | 0;
  }
  process(e, t) {
    for (let f = 0; f < 16; f++, t += 4)
      si[f] = e.getUint32(t, !1);
    for (let f = 16; f < 64; f++) {
      const d = si[f - 15], h = si[f - 2], p = Mn(d, 7) ^ Mn(d, 18) ^ d >>> 3, g = Mn(h, 17) ^ Mn(h, 19) ^ h >>> 10;
      si[f] = g + si[f - 7] + p + si[f - 16] | 0;
    }
    let { A: n, B: s, C: i, D: a, E: o, F: u, G: c, H: l } = this;
    for (let f = 0; f < 64; f++) {
      const d = Mn(o, 6) ^ Mn(o, 11) ^ Mn(o, 25), h = l + d + h8(o, u, c) + b8[f] + si[f] | 0, g = (Mn(n, 2) ^ Mn(n, 13) ^ Mn(n, 22)) + p8(n, s, i) | 0;
      l = c, c = u, u = o, o = a + h | 0, a = i, i = s, s = n, n = h + g | 0;
    }
    n = n + this.A | 0, s = s + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, o = o + this.E | 0, u = u + this.F | 0, c = c + this.G | 0, l = l + this.H | 0, this.set(n, s, i, a, o, u, c, l);
  }
  roundClean() {
    si.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Z0 = /* @__PURE__ */ $d(() => new g8()), Af = /* @__PURE__ */ BigInt(2 ** 32 - 1), Hp = /* @__PURE__ */ BigInt(32);
function sw(r, e = !1) {
  return e ? { h: Number(r & Af), l: Number(r >> Hp & Af) } : { h: Number(r >> Hp & Af) | 0, l: Number(r & Af) | 0 };
}
function iw(r, e = !1) {
  let t = new Uint32Array(r.length), n = new Uint32Array(r.length);
  for (let s = 0; s < r.length; s++) {
    const { h: i, l: a } = sw(r[s], e);
    [t[s], n[s]] = [i, a];
  }
  return [t, n];
}
const x8 = (r, e) => BigInt(r >>> 0) << Hp | BigInt(e >>> 0), m8 = (r, e, t) => r >>> t, y8 = (r, e, t) => r << 32 - t | e >>> t, w8 = (r, e, t) => r >>> t | e << 32 - t, A8 = (r, e, t) => r << 32 - t | e >>> t, E8 = (r, e, t) => r << 64 - t | e >>> t - 32, P8 = (r, e, t) => r >>> t - 32 | e << 64 - t, v8 = (r, e) => e, k8 = (r, e) => r, aw = (r, e, t) => r << t | e >>> 32 - t, ow = (r, e, t) => e << t | r >>> 32 - t, cw = (r, e, t) => e << t - 32 | r >>> 64 - t, uw = (r, e, t) => r << t - 32 | e >>> 64 - t;
function T8(r, e, t, n) {
  const s = (e >>> 0) + (n >>> 0);
  return { h: r + t + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const B8 = (r, e, t) => (r >>> 0) + (e >>> 0) + (t >>> 0), O8 = (r, e, t, n) => e + t + n + (r / 2 ** 32 | 0) | 0, N8 = (r, e, t, n) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0), S8 = (r, e, t, n, s) => e + t + n + s + (r / 2 ** 32 | 0) | 0, C8 = (r, e, t, n, s) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0) + (s >>> 0), R8 = (r, e, t, n, s, i) => e + t + n + s + i + (r / 2 ** 32 | 0) | 0, Ye = {
  fromBig: sw,
  split: iw,
  toBig: x8,
  shrSH: m8,
  shrSL: y8,
  rotrSH: w8,
  rotrSL: A8,
  rotrBH: E8,
  rotrBL: P8,
  rotr32H: v8,
  rotr32L: k8,
  rotlSH: aw,
  rotlSL: ow,
  rotlBH: cw,
  rotlBL: uw,
  add: T8,
  add3L: B8,
  add3H: O8,
  add4L: N8,
  add4H: S8,
  add5H: R8,
  add5L: C8
}, [I8, _8] = Ye.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((r) => BigInt(r))), ii = /* @__PURE__ */ new Uint32Array(80), ai = /* @__PURE__ */ new Uint32Array(80);
class U8 extends og {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: n, Bl: s, Ch: i, Cl: a, Dh: o, Dl: u, Eh: c, El: l, Fh: f, Fl: d, Gh: h, Gl: p, Hh: g, Hl: k } = this;
    return [e, t, n, s, i, a, o, u, c, l, f, d, h, p, g, k];
  }
  // prettier-ignore
  set(e, t, n, s, i, a, o, u, c, l, f, d, h, p, g, k) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = n | 0, this.Bl = s | 0, this.Ch = i | 0, this.Cl = a | 0, this.Dh = o | 0, this.Dl = u | 0, this.Eh = c | 0, this.El = l | 0, this.Fh = f | 0, this.Fl = d | 0, this.Gh = h | 0, this.Gl = p | 0, this.Hh = g | 0, this.Hl = k | 0;
  }
  process(e, t) {
    for (let E = 0; E < 16; E++, t += 4)
      ii[E] = e.getUint32(t), ai[E] = e.getUint32(t += 4);
    for (let E = 16; E < 80; E++) {
      const m = ii[E - 15] | 0, N = ai[E - 15] | 0, T = Ye.rotrSH(m, N, 1) ^ Ye.rotrSH(m, N, 8) ^ Ye.shrSH(m, N, 7), U = Ye.rotrSL(m, N, 1) ^ Ye.rotrSL(m, N, 8) ^ Ye.shrSL(m, N, 7), R = ii[E - 2] | 0, j = ai[E - 2] | 0, D = Ye.rotrSH(R, j, 19) ^ Ye.rotrBH(R, j, 61) ^ Ye.shrSH(R, j, 6), O = Ye.rotrSL(R, j, 19) ^ Ye.rotrBL(R, j, 61) ^ Ye.shrSL(R, j, 6), I = Ye.add4L(U, O, ai[E - 7], ai[E - 16]), P = Ye.add4H(I, T, D, ii[E - 7], ii[E - 16]);
      ii[E] = P | 0, ai[E] = I | 0;
    }
    let { Ah: n, Al: s, Bh: i, Bl: a, Ch: o, Cl: u, Dh: c, Dl: l, Eh: f, El: d, Fh: h, Fl: p, Gh: g, Gl: k, Hh: A, Hl: y } = this;
    for (let E = 0; E < 80; E++) {
      const m = Ye.rotrSH(f, d, 14) ^ Ye.rotrSH(f, d, 18) ^ Ye.rotrBH(f, d, 41), N = Ye.rotrSL(f, d, 14) ^ Ye.rotrSL(f, d, 18) ^ Ye.rotrBL(f, d, 41), T = f & h ^ ~f & g, U = d & p ^ ~d & k, R = Ye.add5L(y, N, U, _8[E], ai[E]), j = Ye.add5H(R, A, m, T, I8[E], ii[E]), D = R | 0, O = Ye.rotrSH(n, s, 28) ^ Ye.rotrBH(n, s, 34) ^ Ye.rotrBH(n, s, 39), I = Ye.rotrSL(n, s, 28) ^ Ye.rotrBL(n, s, 34) ^ Ye.rotrBL(n, s, 39), P = n & i ^ n & o ^ i & o, S = s & a ^ s & u ^ a & u;
      A = g | 0, y = k | 0, g = h | 0, k = p | 0, h = f | 0, p = d | 0, { h: f, l: d } = Ye.add(c | 0, l | 0, j | 0, D | 0), c = o | 0, l = u | 0, o = i | 0, u = a | 0, i = n | 0, a = s | 0;
      const B = Ye.add3L(D, I, S);
      n = Ye.add3H(B, j, O, P), s = B | 0;
    }
    ({ h: n, l: s } = Ye.add(this.Ah | 0, this.Al | 0, n | 0, s | 0)), { h: i, l: a } = Ye.add(this.Bh | 0, this.Bl | 0, i | 0, a | 0), { h: o, l: u } = Ye.add(this.Ch | 0, this.Cl | 0, o | 0, u | 0), { h: c, l } = Ye.add(this.Dh | 0, this.Dl | 0, c | 0, l | 0), { h: f, l: d } = Ye.add(this.Eh | 0, this.El | 0, f | 0, d | 0), { h, l: p } = Ye.add(this.Fh | 0, this.Fl | 0, h | 0, p | 0), { h: g, l: k } = Ye.add(this.Gh | 0, this.Gl | 0, g | 0, k | 0), { h: A, l: y } = Ye.add(this.Hh | 0, this.Hl | 0, A | 0, y | 0), this.set(n, s, i, a, o, u, c, l, f, d, h, p, g, k, A, y);
  }
  roundClean() {
    ii.fill(0), ai.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const cg = /* @__PURE__ */ $d(() => new U8());
function L8() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}
const jx = L8(), Hx = jx.crypto || jx.msCrypto;
function lw(r) {
  switch (r) {
    case "sha256":
      return Z0.create();
    case "sha512":
      return cg.create();
  }
  ue(!1, "invalid hashing algorithm name", "algorithm", r);
}
function M8(r, e) {
  const t = { sha256: Z0, sha512: cg }[r];
  return ue(t != null, "invalid hmac algorithm", "algorithm", r), ig.create(t, e);
}
function F8(r, e, t, n, s) {
  const i = { sha256: Z0, sha512: cg }[s];
  return ue(i != null, "invalid pbkdf2 algorithm", "algorithm", s), ag(i, r, e, { c: t, dkLen: n });
}
function D8(r) {
  Ee(Hx != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
    operation: "randomBytes"
  }), ue(Number.isInteger(r) && r > 0 && r <= 1024, "invalid length", "length", r);
  const e = new Uint8Array(r);
  return Hx.getRandomValues(e), e;
}
let fw = !1;
const dw = function(r, e, t) {
  return M8(r, e).update(t).digest();
};
let hw = dw;
function $s(r, e, t) {
  const n = Ce(e, "key"), s = Ce(t, "data");
  return Oe(hw(r, n, s));
}
$s._ = dw;
$s.lock = function() {
  fw = !0;
};
$s.register = function(r) {
  if (fw)
    throw new Error("computeHmac is locked");
  hw = r;
};
Object.freeze($s);
const [pw, bw, gw] = [[], [], []], j8 = /* @__PURE__ */ BigInt(0), Vu = /* @__PURE__ */ BigInt(1), H8 = /* @__PURE__ */ BigInt(2), G8 = /* @__PURE__ */ BigInt(7), V8 = /* @__PURE__ */ BigInt(256), $8 = /* @__PURE__ */ BigInt(113);
for (let r = 0, e = Vu, t = 1, n = 0; r < 24; r++) {
  [t, n] = [n, (2 * t + 3 * n) % 5], pw.push(2 * (5 * n + t)), bw.push((r + 1) * (r + 2) / 2 % 64);
  let s = j8;
  for (let i = 0; i < 7; i++)
    e = (e << Vu ^ (e >> G8) * $8) % V8, e & H8 && (s ^= Vu << (Vu << /* @__PURE__ */ BigInt(i)) - Vu);
  gw.push(s);
}
const [K8, z8] = /* @__PURE__ */ iw(gw, !0), Gx = (r, e, t) => t > 32 ? cw(r, e, t) : aw(r, e, t), Vx = (r, e, t) => t > 32 ? uw(r, e, t) : ow(r, e, t);
function J8(r, e = 24) {
  const t = new Uint32Array(10);
  for (let n = 24 - e; n < 24; n++) {
    for (let a = 0; a < 10; a++)
      t[a] = r[a] ^ r[a + 10] ^ r[a + 20] ^ r[a + 30] ^ r[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const o = (a + 8) % 10, u = (a + 2) % 10, c = t[u], l = t[u + 1], f = Gx(c, l, 1) ^ t[o], d = Vx(c, l, 1) ^ t[o + 1];
      for (let h = 0; h < 50; h += 10)
        r[a + h] ^= f, r[a + h + 1] ^= d;
    }
    let s = r[2], i = r[3];
    for (let a = 0; a < 24; a++) {
      const o = bw[a], u = Gx(s, i, o), c = Vx(s, i, o), l = pw[a];
      s = r[l], i = r[l + 1], r[l] = u, r[l + 1] = c;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let o = 0; o < 10; o++)
        t[o] = r[a + o];
      for (let o = 0; o < 10; o++)
        r[a + o] ^= ~t[(o + 2) % 10] & t[(o + 4) % 10];
    }
    r[0] ^= K8[n], r[1] ^= z8[n];
  }
  t.fill(0);
}
let Q8 = class xw extends sg {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, t, n, s = !1, i = 24) {
    if (super(), this.blockLen = e, this.suffix = t, this.outputLen = n, this.enableXOF = s, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Rr(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Df(this.state);
  }
  keccak() {
    J8(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    uu(this);
    const { blockLen: t, state: n } = this;
    e = lu(e);
    const s = e.length;
    for (let i = 0; i < s; ) {
      const a = Math.min(t - this.pos, s - i);
      for (let o = 0; o < a; o++)
        n[this.pos++] ^= e[i++];
      this.pos === t && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: t, pos: n, blockLen: s } = this;
    e[n] ^= t, t & 128 && n === s - 1 && this.keccak(), e[s - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    uu(this, !1), ng(e), this.finish();
    const t = this.state, { blockLen: n } = this;
    for (let s = 0, i = e.length; s < i; ) {
      this.posOut >= n && this.keccak();
      const a = Math.min(n - this.posOut, i - s);
      e.set(t.subarray(this.posOut, this.posOut + a), s), this.posOut += a, s += a;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Rr(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (tw(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: t, suffix: n, outputLen: s, rounds: i, enableXOF: a } = this;
    return e || (e = new xw(t, n, s, a, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = n, e.outputLen = s, e.enableXOF = a, e.destroyed = this.destroyed, e;
  }
};
const q8 = (r, e, t) => $d(() => new Q8(e, r, t)), W8 = /* @__PURE__ */ q8(1, 136, 256 / 8);
let mw = !1;
const yw = function(r) {
  return W8(r);
};
let ww = yw;
function ft(r) {
  const e = Ce(r, "data");
  return Oe(ww(e));
}
ft._ = yw;
ft.lock = function() {
  mw = !0;
};
ft.register = function(r) {
  if (mw)
    throw new TypeError("keccak256 is locked");
  ww = r;
};
Object.freeze(ft);
const Y8 = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Aw = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (r, e) => e), Z8 = /* @__PURE__ */ Aw.map((r) => (9 * r + 5) % 16);
let ug = [Aw], lg = [Z8];
for (let r = 0; r < 4; r++)
  for (let e of [ug, lg])
    e.push(e[r].map((t) => Y8[t]));
const Ew = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((r) => new Uint8Array(r)), X8 = /* @__PURE__ */ ug.map((r, e) => r.map((t) => Ew[e][t])), e5 = /* @__PURE__ */ lg.map((r, e) => r.map((t) => Ew[e][t])), t5 = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), r5 = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]), Ef = (r, e) => r << e | r >>> 32 - e;
function $x(r, e, t, n) {
  return r === 0 ? e ^ t ^ n : r === 1 ? e & t | ~e & n : r === 2 ? (e | ~t) ^ n : r === 3 ? e & n | t & ~n : e ^ (t | ~n);
}
const Pf = /* @__PURE__ */ new Uint32Array(16);
class n5 extends og {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: e, h1: t, h2: n, h3: s, h4: i } = this;
    return [e, t, n, s, i];
  }
  set(e, t, n, s, i) {
    this.h0 = e | 0, this.h1 = t | 0, this.h2 = n | 0, this.h3 = s | 0, this.h4 = i | 0;
  }
  process(e, t) {
    for (let h = 0; h < 16; h++, t += 4)
      Pf[h] = e.getUint32(t, !0);
    let n = this.h0 | 0, s = n, i = this.h1 | 0, a = i, o = this.h2 | 0, u = o, c = this.h3 | 0, l = c, f = this.h4 | 0, d = f;
    for (let h = 0; h < 5; h++) {
      const p = 4 - h, g = t5[h], k = r5[h], A = ug[h], y = lg[h], E = X8[h], m = e5[h];
      for (let N = 0; N < 16; N++) {
        const T = Ef(n + $x(h, i, o, c) + Pf[A[N]] + g, E[N]) + f | 0;
        n = f, f = c, c = Ef(o, 10) | 0, o = i, i = T;
      }
      for (let N = 0; N < 16; N++) {
        const T = Ef(s + $x(p, a, u, l) + Pf[y[N]] + k, m[N]) + d | 0;
        s = d, d = l, l = Ef(u, 10) | 0, u = a, a = T;
      }
    }
    this.set(this.h1 + o + l | 0, this.h2 + c + d | 0, this.h3 + f + s | 0, this.h4 + n + a | 0, this.h0 + i + u | 0);
  }
  roundClean() {
    Pf.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
const s5 = /* @__PURE__ */ $d(() => new n5());
let Pw = !1;
const vw = function(r) {
  return s5(r);
};
let kw = vw;
function Ks(r) {
  const e = Ce(r, "data");
  return Oe(kw(e));
}
Ks._ = vw;
Ks.lock = function() {
  Pw = !0;
};
Ks.register = function(r) {
  if (Pw)
    throw new TypeError("ripemd160 is locked");
  kw = r;
};
Object.freeze(Ks);
let Tw = !1;
const Bw = function(r, e, t, n, s) {
  return F8(r, e, t, n, s);
};
let Ow = Bw;
function Bn(r, e, t, n, s) {
  const i = Ce(r, "password"), a = Ce(e, "salt");
  return Oe(Ow(i, a, t, n, s));
}
Bn._ = Bw;
Bn.lock = function() {
  Tw = !0;
};
Bn.register = function(r) {
  if (Tw)
    throw new Error("pbkdf2 is locked");
  Ow = r;
};
Object.freeze(Bn);
let Nw = !1;
const Sw = function(r) {
  return new Uint8Array(D8(r));
};
let Cw = Sw;
function Ir(r) {
  return Cw(r);
}
Ir._ = Sw;
Ir.lock = function() {
  Nw = !0;
};
Ir.register = function(r) {
  if (Nw)
    throw new Error("randomBytes is locked");
  Cw = r;
};
Object.freeze(Ir);
const at = (r, e) => r << e | r >>> 32 - e;
function Kx(r, e, t, n, s, i) {
  let a = r[e++] ^ t[n++], o = r[e++] ^ t[n++], u = r[e++] ^ t[n++], c = r[e++] ^ t[n++], l = r[e++] ^ t[n++], f = r[e++] ^ t[n++], d = r[e++] ^ t[n++], h = r[e++] ^ t[n++], p = r[e++] ^ t[n++], g = r[e++] ^ t[n++], k = r[e++] ^ t[n++], A = r[e++] ^ t[n++], y = r[e++] ^ t[n++], E = r[e++] ^ t[n++], m = r[e++] ^ t[n++], N = r[e++] ^ t[n++], T = a, U = o, R = u, j = c, D = l, O = f, I = d, P = h, S = p, B = g, C = k, H = A, V = y, J = E, M = m, G = N;
  for (let K = 0; K < 8; K += 2)
    D ^= at(T + V | 0, 7), S ^= at(D + T | 0, 9), V ^= at(S + D | 0, 13), T ^= at(V + S | 0, 18), B ^= at(O + U | 0, 7), J ^= at(B + O | 0, 9), U ^= at(J + B | 0, 13), O ^= at(U + J | 0, 18), M ^= at(C + I | 0, 7), R ^= at(M + C | 0, 9), I ^= at(R + M | 0, 13), C ^= at(I + R | 0, 18), j ^= at(G + H | 0, 7), P ^= at(j + G | 0, 9), H ^= at(P + j | 0, 13), G ^= at(H + P | 0, 18), U ^= at(T + j | 0, 7), R ^= at(U + T | 0, 9), j ^= at(R + U | 0, 13), T ^= at(j + R | 0, 18), I ^= at(O + D | 0, 7), P ^= at(I + O | 0, 9), D ^= at(P + I | 0, 13), O ^= at(D + P | 0, 18), H ^= at(C + B | 0, 7), S ^= at(H + C | 0, 9), B ^= at(S + H | 0, 13), C ^= at(B + S | 0, 18), V ^= at(G + M | 0, 7), J ^= at(V + G | 0, 9), M ^= at(J + V | 0, 13), G ^= at(M + J | 0, 18);
  s[i++] = a + T | 0, s[i++] = o + U | 0, s[i++] = u + R | 0, s[i++] = c + j | 0, s[i++] = l + D | 0, s[i++] = f + O | 0, s[i++] = d + I | 0, s[i++] = h + P | 0, s[i++] = p + S | 0, s[i++] = g + B | 0, s[i++] = k + C | 0, s[i++] = A + H | 0, s[i++] = y + V | 0, s[i++] = E + J | 0, s[i++] = m + M | 0, s[i++] = N + G | 0;
}
function dc(r, e, t, n, s) {
  let i = n + 0, a = n + 16 * s;
  for (let o = 0; o < 16; o++)
    t[a + o] = r[e + (2 * s - 1) * 16 + o];
  for (let o = 0; o < s; o++, i += 16, e += 16)
    Kx(t, a, r, e, t, i), o > 0 && (a += 16), Kx(t, i, r, e += 16, t, a);
}
function Rw(r, e, t) {
  const n = rw({
    dkLen: 32,
    asyncTick: 10,
    maxmem: 1073742848
  }, t), { N: s, r: i, p: a, dkLen: o, asyncTick: u, maxmem: c, onProgress: l } = n;
  if (Rr(s), Rr(i), Rr(a), Rr(o), Rr(u), Rr(c), l !== void 0 && typeof l != "function")
    throw new Error("progressCb should be function");
  const f = 128 * i, d = f / 4;
  if (s <= 1 || s & s - 1 || s >= 2 ** (f / 8) || s > 2 ** 32)
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
  if (a < 0 || a > (2 ** 32 - 1) * 32 / f)
    throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
  if (o < 0 || o > (2 ** 32 - 1) * 32)
    throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
  const h = f * (s + a);
  if (h > c)
    throw new Error(`Scrypt: parameters too large, ${h} (128 * r * (N + p)) > ${c} (maxmem)`);
  const p = ag(Z0, r, e, { c: 1, dkLen: f * a }), g = Df(p), k = Df(new Uint8Array(f * s)), A = Df(new Uint8Array(f));
  let y = () => {
  };
  if (l) {
    const E = 2 * s * a, m = Math.max(Math.floor(E / 1e4), 1);
    let N = 0;
    y = () => {
      N++, l && (!(N % m) || N === E) && l(N / E);
    };
  }
  return { N: s, r: i, p: a, dkLen: o, blockSize32: d, V: k, B32: g, B: p, tmp: A, blockMixCb: y, asyncTick: u };
}
function Iw(r, e, t, n, s) {
  const i = ag(Z0, r, t, { c: 1, dkLen: e });
  return t.fill(0), n.fill(0), s.fill(0), i;
}
function i5(r, e, t) {
  const { N: n, r: s, p: i, dkLen: a, blockSize32: o, V: u, B32: c, B: l, tmp: f, blockMixCb: d } = Rw(r, e, t);
  for (let h = 0; h < i; h++) {
    const p = o * h;
    for (let g = 0; g < o; g++)
      u[g] = c[p + g];
    for (let g = 0, k = 0; g < n - 1; g++)
      dc(u, k, u, k += o, s), d();
    dc(u, (n - 1) * o, c, p, s), d();
    for (let g = 0; g < n; g++) {
      const k = c[p + o - 16] % n;
      for (let A = 0; A < o; A++)
        f[A] = c[p + A] ^ u[k * o + A];
      dc(f, 0, c, p, s), d();
    }
  }
  return Iw(r, a, l, u, f);
}
async function a5(r, e, t) {
  const { N: n, r: s, p: i, dkLen: a, blockSize32: o, V: u, B32: c, B: l, tmp: f, blockMixCb: d, asyncTick: h } = Rw(r, e, t);
  for (let p = 0; p < i; p++) {
    const g = o * p;
    for (let A = 0; A < o; A++)
      u[A] = c[g + A];
    let k = 0;
    await Dx(n - 1, h, () => {
      dc(u, k, u, k += o, s), d();
    }), dc(u, (n - 1) * o, c, g, s), d(), await Dx(n, h, () => {
      const A = c[g + o - 16] % n;
      for (let y = 0; y < o; y++)
        f[y] = c[g + y] ^ u[A * o + y];
      dc(f, 0, c, g, s), d();
    });
  }
  return Iw(r, a, l, u, f);
}
let _w = !1, Uw = !1;
const Lw = async function(r, e, t, n, s, i, a) {
  return await a5(r, e, { N: t, r: n, p: s, dkLen: i, onProgress: a });
}, Mw = function(r, e, t, n, s, i) {
  return i5(r, e, { N: t, r: n, p: s, dkLen: i });
};
let Fw = Lw, Dw = Mw;
async function zs(r, e, t, n, s, i, a) {
  const o = Ce(r, "passwd"), u = Ce(e, "salt");
  return Oe(await Fw(o, u, t, n, s, i, a));
}
zs._ = Lw;
zs.lock = function() {
  Uw = !0;
};
zs.register = function(r) {
  if (Uw)
    throw new Error("scrypt is locked");
  Fw = r;
};
Object.freeze(zs);
function Js(r, e, t, n, s, i) {
  const a = Ce(r, "passwd"), o = Ce(e, "salt");
  return Oe(Dw(a, o, t, n, s, i));
}
Js._ = Mw;
Js.lock = function() {
  _w = !0;
};
Js.register = function(r) {
  if (_w)
    throw new Error("scryptSync is locked");
  Dw = r;
};
Object.freeze(Js);
const jw = function(r) {
  return lw("sha256").update(r).digest();
}, Hw = function(r) {
  return lw("sha512").update(r).digest();
};
let Gw = jw, Vw = Hw, $w = !1, Kw = !1;
function nr(r) {
  const e = Ce(r, "data");
  return Oe(Gw(e));
}
nr._ = jw;
nr.lock = function() {
  $w = !0;
};
nr.register = function(r) {
  if ($w)
    throw new Error("sha256 is locked");
  Gw = r;
};
Object.freeze(nr);
function Iu(r) {
  const e = Ce(r, "data");
  return Oe(Vw(e));
}
Iu._ = Hw;
Iu.lock = function() {
  Kw = !0;
};
Iu.register = function(r) {
  if (Kw)
    throw new Error("sha512 is locked");
  Vw = r;
};
Object.freeze(nr);
var nt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function o5(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function zw(r) {
  if (r.__esModule) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Xi = {}, $u = {}, Zt = {}, zx;
function X0() {
  if (zx) return Zt;
  zx = 1, Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.output = Zt.exists = Zt.hash = Zt.bytes = Zt.bool = Zt.number = void 0;
  function r(o) {
    if (!Number.isSafeInteger(o) || o < 0)
      throw new Error(`Wrong positive integer: ${o}`);
  }
  Zt.number = r;
  function e(o) {
    if (typeof o != "boolean")
      throw new Error(`Expected boolean, not ${o}`);
  }
  Zt.bool = e;
  function t(o, ...u) {
    if (!(o instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (u.length > 0 && !u.includes(o.length))
      throw new Error(`Expected Uint8Array of length ${u}, not of length=${o.length}`);
  }
  Zt.bytes = t;
  function n(o) {
    if (typeof o != "function" || typeof o.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    r(o.outputLen), r(o.blockLen);
  }
  Zt.hash = n;
  function s(o, u = !0) {
    if (o.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (u && o.finished)
      throw new Error("Hash#digest() has already been called");
  }
  Zt.exists = s;
  function i(o, u) {
    t(o);
    const c = u.outputLen;
    if (o.length < c)
      throw new Error(`digestInto() expects output buffer of length at least ${c}`);
  }
  Zt.output = i;
  const a = { number: r, bool: e, bytes: t, hash: n, exists: s, output: i };
  return Zt.default = a, Zt;
}
var _h = {}, Ku = {}, Jx;
function c5() {
  return Jx || (Jx = 1, Object.defineProperty(Ku, "__esModule", { value: !0 }), Ku.crypto = void 0, Ku.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), Ku;
}
var Qx;
function On() {
  return Qx || (Qx = 1, function(r) {
    /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    Object.defineProperty(r, "__esModule", { value: !0 }), r.randomBytes = r.wrapXOFConstructorWithOpts = r.wrapConstructorWithOpts = r.wrapConstructor = r.checkOpts = r.Hash = r.concatBytes = r.toBytes = r.utf8ToBytes = r.asyncLoop = r.nextTick = r.hexToBytes = r.bytesToHex = r.isLE = r.rotr = r.createView = r.u32 = r.u8 = void 0;
    const e = c5(), t = (T) => T instanceof Uint8Array, n = (T) => new Uint8Array(T.buffer, T.byteOffset, T.byteLength);
    r.u8 = n;
    const s = (T) => new Uint32Array(T.buffer, T.byteOffset, Math.floor(T.byteLength / 4));
    r.u32 = s;
    const i = (T) => new DataView(T.buffer, T.byteOffset, T.byteLength);
    r.createView = i;
    const a = (T, U) => T << 32 - U | T >>> U;
    if (r.rotr = a, r.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !r.isLE)
      throw new Error("Non little-endian hardware is not supported");
    const o = /* @__PURE__ */ Array.from({ length: 256 }, (T, U) => U.toString(16).padStart(2, "0"));
    function u(T) {
      if (!t(T))
        throw new Error("Uint8Array expected");
      let U = "";
      for (let R = 0; R < T.length; R++)
        U += o[T[R]];
      return U;
    }
    r.bytesToHex = u;
    function c(T) {
      if (typeof T != "string")
        throw new Error("hex string expected, got " + typeof T);
      const U = T.length;
      if (U % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + U);
      const R = new Uint8Array(U / 2);
      for (let j = 0; j < R.length; j++) {
        const D = j * 2, O = T.slice(D, D + 2), I = Number.parseInt(O, 16);
        if (Number.isNaN(I) || I < 0)
          throw new Error("Invalid byte sequence");
        R[j] = I;
      }
      return R;
    }
    r.hexToBytes = c;
    const l = async () => {
    };
    r.nextTick = l;
    async function f(T, U, R) {
      let j = Date.now();
      for (let D = 0; D < T; D++) {
        R(D);
        const O = Date.now() - j;
        O >= 0 && O < U || (await (0, r.nextTick)(), j += O);
      }
    }
    r.asyncLoop = f;
    function d(T) {
      if (typeof T != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof T}`);
      return new Uint8Array(new TextEncoder().encode(T));
    }
    r.utf8ToBytes = d;
    function h(T) {
      if (typeof T == "string" && (T = d(T)), !t(T))
        throw new Error(`expected Uint8Array, got ${typeof T}`);
      return T;
    }
    r.toBytes = h;
    function p(...T) {
      const U = new Uint8Array(T.reduce((j, D) => j + D.length, 0));
      let R = 0;
      return T.forEach((j) => {
        if (!t(j))
          throw new Error("Uint8Array expected");
        U.set(j, R), R += j.length;
      }), U;
    }
    r.concatBytes = p;
    class g {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    r.Hash = g;
    const k = {}.toString;
    function A(T, U) {
      if (U !== void 0 && k.call(U) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(T, U);
    }
    r.checkOpts = A;
    function y(T) {
      const U = (j) => T().update(h(j)).digest(), R = T();
      return U.outputLen = R.outputLen, U.blockLen = R.blockLen, U.create = () => T(), U;
    }
    r.wrapConstructor = y;
    function E(T) {
      const U = (j, D) => T(D).update(h(j)).digest(), R = T({});
      return U.outputLen = R.outputLen, U.blockLen = R.blockLen, U.create = (j) => T(j), U;
    }
    r.wrapConstructorWithOpts = E;
    function m(T) {
      const U = (j, D) => T(D).update(h(j)).digest(), R = T({});
      return U.outputLen = R.outputLen, U.blockLen = R.blockLen, U.create = (j) => T(j), U;
    }
    r.wrapXOFConstructorWithOpts = m;
    function N(T = 32) {
      if (e.crypto && typeof e.crypto.getRandomValues == "function")
        return e.crypto.getRandomValues(new Uint8Array(T));
      throw new Error("crypto.getRandomValues must be defined");
    }
    r.randomBytes = N;
  }(_h)), _h;
}
var qx;
function fg() {
  if (qx) return $u;
  qx = 1, Object.defineProperty($u, "__esModule", { value: !0 }), $u.SHA2 = void 0;
  const r = X0(), e = On();
  function t(s, i, a, o) {
    if (typeof s.setBigUint64 == "function")
      return s.setBigUint64(i, a, o);
    const u = BigInt(32), c = BigInt(4294967295), l = Number(a >> u & c), f = Number(a & c), d = o ? 4 : 0, h = o ? 0 : 4;
    s.setUint32(i + d, l, o), s.setUint32(i + h, f, o);
  }
  class n extends e.Hash {
    constructor(i, a, o, u) {
      super(), this.blockLen = i, this.outputLen = a, this.padOffset = o, this.isLE = u, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(i), this.view = (0, e.createView)(this.buffer);
    }
    update(i) {
      (0, r.exists)(this);
      const { view: a, buffer: o, blockLen: u } = this;
      i = (0, e.toBytes)(i);
      const c = i.length;
      for (let l = 0; l < c; ) {
        const f = Math.min(u - this.pos, c - l);
        if (f === u) {
          const d = (0, e.createView)(i);
          for (; u <= c - l; l += u)
            this.process(d, l);
          continue;
        }
        o.set(i.subarray(l, l + f), this.pos), this.pos += f, l += f, this.pos === u && (this.process(a, 0), this.pos = 0);
      }
      return this.length += i.length, this.roundClean(), this;
    }
    digestInto(i) {
      (0, r.exists)(this), (0, r.output)(i, this), this.finished = !0;
      const { buffer: a, view: o, blockLen: u, isLE: c } = this;
      let { pos: l } = this;
      a[l++] = 128, this.buffer.subarray(l).fill(0), this.padOffset > u - l && (this.process(o, 0), l = 0);
      for (let g = l; g < u; g++)
        a[g] = 0;
      t(o, u - 8, BigInt(this.length * 8), c), this.process(o, 0);
      const f = (0, e.createView)(i), d = this.outputLen;
      if (d % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const h = d / 4, p = this.get();
      if (h > p.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let g = 0; g < h; g++)
        f.setUint32(4 * g, p[g], c);
    }
    digest() {
      const { buffer: i, outputLen: a } = this;
      this.digestInto(i);
      const o = i.slice(0, a);
      return this.destroy(), o;
    }
    _cloneInto(i) {
      i || (i = new this.constructor()), i.set(...this.get());
      const { blockLen: a, buffer: o, length: u, finished: c, destroyed: l, pos: f } = this;
      return i.length = u, i.pos = f, i.finished = c, i.destroyed = l, u % a && i.buffer.set(o), i;
    }
  }
  return $u.SHA2 = n, $u;
}
var Wx;
function Kd() {
  if (Wx) return Xi;
  Wx = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.sha224 = Xi.sha256 = void 0;
  const r = fg(), e = On(), t = (c, l, f) => c & l ^ ~c & f, n = (c, l, f) => c & l ^ c & f ^ l & f, s = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), i = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), a = /* @__PURE__ */ new Uint32Array(64);
  class o extends r.SHA2 {
    constructor() {
      super(64, 32, 8, !1), this.A = i[0] | 0, this.B = i[1] | 0, this.C = i[2] | 0, this.D = i[3] | 0, this.E = i[4] | 0, this.F = i[5] | 0, this.G = i[6] | 0, this.H = i[7] | 0;
    }
    get() {
      const { A: l, B: f, C: d, D: h, E: p, F: g, G: k, H: A } = this;
      return [l, f, d, h, p, g, k, A];
    }
    // prettier-ignore
    set(l, f, d, h, p, g, k, A) {
      this.A = l | 0, this.B = f | 0, this.C = d | 0, this.D = h | 0, this.E = p | 0, this.F = g | 0, this.G = k | 0, this.H = A | 0;
    }
    process(l, f) {
      for (let m = 0; m < 16; m++, f += 4)
        a[m] = l.getUint32(f, !1);
      for (let m = 16; m < 64; m++) {
        const N = a[m - 15], T = a[m - 2], U = (0, e.rotr)(N, 7) ^ (0, e.rotr)(N, 18) ^ N >>> 3, R = (0, e.rotr)(T, 17) ^ (0, e.rotr)(T, 19) ^ T >>> 10;
        a[m] = R + a[m - 7] + U + a[m - 16] | 0;
      }
      let { A: d, B: h, C: p, D: g, E: k, F: A, G: y, H: E } = this;
      for (let m = 0; m < 64; m++) {
        const N = (0, e.rotr)(k, 6) ^ (0, e.rotr)(k, 11) ^ (0, e.rotr)(k, 25), T = E + N + t(k, A, y) + s[m] + a[m] | 0, R = ((0, e.rotr)(d, 2) ^ (0, e.rotr)(d, 13) ^ (0, e.rotr)(d, 22)) + n(d, h, p) | 0;
        E = y, y = A, A = k, k = g + T | 0, g = p, p = h, h = d, d = T + R | 0;
      }
      d = d + this.A | 0, h = h + this.B | 0, p = p + this.C | 0, g = g + this.D | 0, k = k + this.E | 0, A = A + this.F | 0, y = y + this.G | 0, E = E + this.H | 0, this.set(d, h, p, g, k, A, y, E);
    }
    roundClean() {
      a.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class u extends o {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return Xi.sha256 = (0, e.wrapConstructor)(() => new o()), Xi.sha224 = (0, e.wrapConstructor)(() => new u()), Xi;
}
var u5 = Kd(), Yx = On();
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Jw = BigInt(0), zd = BigInt(1), l5 = BigInt(2), Jd = (r) => r instanceof Uint8Array, f5 = /* @__PURE__ */ Array.from({ length: 256 }, (r, e) => e.toString(16).padStart(2, "0"));
function fu(r) {
  if (!Jd(r))
    throw new Error("Uint8Array expected");
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += f5[r[t]];
  return e;
}
function Qw(r) {
  const e = r.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function dg(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  return BigInt(r === "" ? "0" : `0x${r}`);
}
function du(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  const e = r.length;
  if (e % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + e);
  const t = new Uint8Array(e / 2);
  for (let n = 0; n < t.length; n++) {
    const s = n * 2, i = r.slice(s, s + 2), a = Number.parseInt(i, 16);
    if (Number.isNaN(a) || a < 0)
      throw new Error("Invalid byte sequence");
    t[n] = a;
  }
  return t;
}
function ho(r) {
  return dg(fu(r));
}
function hg(r) {
  if (!Jd(r))
    throw new Error("Uint8Array expected");
  return dg(fu(Uint8Array.from(r).reverse()));
}
function hu(r, e) {
  return du(r.toString(16).padStart(e * 2, "0"));
}
function pg(r, e) {
  return hu(r, e).reverse();
}
function d5(r) {
  return du(Qw(r));
}
function hn(r, e, t) {
  let n;
  if (typeof e == "string")
    try {
      n = du(e);
    } catch (i) {
      throw new Error(`${r} must be valid hex string, got "${e}". Cause: ${i}`);
    }
  else if (Jd(e))
    n = Uint8Array.from(e);
  else
    throw new Error(`${r} must be hex string or Uint8Array`);
  const s = n.length;
  if (typeof t == "number" && s !== t)
    throw new Error(`${r} expected ${t} bytes, got ${s}`);
  return n;
}
function A0(...r) {
  const e = new Uint8Array(r.reduce((n, s) => n + s.length, 0));
  let t = 0;
  return r.forEach((n) => {
    if (!Jd(n))
      throw new Error("Uint8Array expected");
    e.set(n, t), t += n.length;
  }), e;
}
function h5(r, e) {
  if (r.length !== e.length)
    return !1;
  for (let t = 0; t < r.length; t++)
    if (r[t] !== e[t])
      return !1;
  return !0;
}
function p5(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function b5(r) {
  let e;
  for (e = 0; r > Jw; r >>= zd, e += 1)
    ;
  return e;
}
function g5(r, e) {
  return r >> BigInt(e) & zd;
}
const x5 = (r, e, t) => r | (t ? zd : Jw) << BigInt(e), bg = (r) => (l5 << BigInt(r - 1)) - zd, Uh = (r) => new Uint8Array(r), Zx = (r) => Uint8Array.from(r);
function qw(r, e, t) {
  if (typeof r != "number" || r < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof t != "function")
    throw new Error("hmacFn must be a function");
  let n = Uh(r), s = Uh(r), i = 0;
  const a = () => {
    n.fill(1), s.fill(0), i = 0;
  }, o = (...f) => t(s, n, ...f), u = (f = Uh()) => {
    s = o(Zx([0]), f), n = o(), f.length !== 0 && (s = o(Zx([1]), f), n = o());
  }, c = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const d = [];
    for (; f < e; ) {
      n = o();
      const h = n.slice();
      d.push(h), f += n.length;
    }
    return A0(...d);
  };
  return (f, d) => {
    a(), u(f);
    let h;
    for (; !(h = d(c())); )
      u();
    return a(), h;
  };
}
const m5 = {
  bigint: (r) => typeof r == "bigint",
  function: (r) => typeof r == "function",
  boolean: (r) => typeof r == "boolean",
  string: (r) => typeof r == "string",
  stringOrUint8Array: (r) => typeof r == "string" || r instanceof Uint8Array,
  isSafeInteger: (r) => Number.isSafeInteger(r),
  array: (r) => Array.isArray(r),
  field: (r, e) => e.Fp.isValid(r),
  hash: (r) => typeof r == "function" && Number.isSafeInteger(r.outputLen)
};
function ef(r, e, t = {}) {
  const n = (s, i, a) => {
    const o = m5[i];
    if (typeof o != "function")
      throw new Error(`Invalid validator "${i}", expected function`);
    const u = r[s];
    if (!(a && u === void 0) && !o(u, r))
      throw new Error(`Invalid param ${String(s)}=${u} (${typeof u}), expected ${i}`);
  };
  for (const [s, i] of Object.entries(e))
    n(s, i, !1);
  for (const [s, i] of Object.entries(t))
    n(s, i, !0);
  return r;
}
const y5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: g5,
  bitLen: b5,
  bitMask: bg,
  bitSet: x5,
  bytesToHex: fu,
  bytesToNumberBE: ho,
  bytesToNumberLE: hg,
  concatBytes: A0,
  createHmacDrbg: qw,
  ensureBytes: hn,
  equalBytes: h5,
  hexToBytes: du,
  hexToNumber: dg,
  numberToBytesBE: hu,
  numberToBytesLE: pg,
  numberToHexUnpadded: Qw,
  numberToVarBytesBE: d5,
  utf8ToBytes: p5,
  validateObject: ef
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Vt = BigInt(0), Nt = BigInt(1), Ra = BigInt(2), w5 = BigInt(3), Gp = BigInt(4), Xx = BigInt(5), em = BigInt(8);
BigInt(9);
BigInt(16);
function pr(r, e) {
  const t = r % e;
  return t >= Vt ? t : e + t;
}
function A5(r, e, t) {
  if (t <= Vt || e < Vt)
    throw new Error("Expected power/modulo > 0");
  if (t === Nt)
    return Vt;
  let n = Nt;
  for (; e > Vt; )
    e & Nt && (n = n * r % t), r = r * r % t, e >>= Nt;
  return n;
}
function Fr(r, e, t) {
  let n = r;
  for (; e-- > Vt; )
    n *= n, n %= t;
  return n;
}
function Vp(r, e) {
  if (r === Vt || e <= Vt)
    throw new Error(`invert: expected positive integers, got n=${r} mod=${e}`);
  let t = pr(r, e), n = e, s = Vt, i = Nt;
  for (; t !== Vt; ) {
    const o = n / t, u = n % t, c = s - i * o;
    n = t, t = u, s = i, i = c;
  }
  if (n !== Nt)
    throw new Error("invert: does not exist");
  return pr(s, e);
}
function E5(r) {
  const e = (r - Nt) / Ra;
  let t, n, s;
  for (t = r - Nt, n = 0; t % Ra === Vt; t /= Ra, n++)
    ;
  for (s = Ra; s < r && A5(s, e, r) !== r - Nt; s++)
    ;
  if (n === 1) {
    const a = (r + Nt) / Gp;
    return function(u, c) {
      const l = u.pow(c, a);
      if (!u.eql(u.sqr(l), c))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  const i = (t + Nt) / Ra;
  return function(o, u) {
    if (o.pow(u, e) === o.neg(o.ONE))
      throw new Error("Cannot find square root");
    let c = n, l = o.pow(o.mul(o.ONE, s), t), f = o.pow(u, i), d = o.pow(u, t);
    for (; !o.eql(d, o.ONE); ) {
      if (o.eql(d, o.ZERO))
        return o.ZERO;
      let h = 1;
      for (let g = o.sqr(d); h < c && !o.eql(g, o.ONE); h++)
        g = o.sqr(g);
      const p = o.pow(l, Nt << BigInt(c - h - 1));
      l = o.sqr(p), f = o.mul(f, p), d = o.mul(d, l), c = h;
    }
    return f;
  };
}
function P5(r) {
  if (r % Gp === w5) {
    const e = (r + Nt) / Gp;
    return function(n, s) {
      const i = n.pow(s, e);
      if (!n.eql(n.sqr(i), s))
        throw new Error("Cannot find square root");
      return i;
    };
  }
  if (r % em === Xx) {
    const e = (r - Xx) / em;
    return function(n, s) {
      const i = n.mul(s, Ra), a = n.pow(i, e), o = n.mul(s, a), u = n.mul(n.mul(o, Ra), a), c = n.mul(o, n.sub(u, n.ONE));
      if (!n.eql(n.sqr(c), s))
        throw new Error("Cannot find square root");
      return c;
    };
  }
  return E5(r);
}
const v5 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function k5(r) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, t = v5.reduce((n, s) => (n[s] = "function", n), e);
  return ef(r, t);
}
function T5(r, e, t) {
  if (t < Vt)
    throw new Error("Expected power > 0");
  if (t === Vt)
    return r.ONE;
  if (t === Nt)
    return e;
  let n = r.ONE, s = e;
  for (; t > Vt; )
    t & Nt && (n = r.mul(n, s)), s = r.sqr(s), t >>= Nt;
  return n;
}
function B5(r, e) {
  const t = new Array(e.length), n = e.reduce((i, a, o) => r.is0(a) ? i : (t[o] = i, r.mul(i, a)), r.ONE), s = r.inv(n);
  return e.reduceRight((i, a, o) => r.is0(a) ? i : (t[o] = r.mul(i, t[o]), r.mul(i, a)), s), t;
}
function Ww(r, e) {
  const t = e !== void 0 ? e : r.toString(2).length, n = Math.ceil(t / 8);
  return { nBitLength: t, nByteLength: n };
}
function O5(r, e, t = !1, n = {}) {
  if (r <= Vt)
    throw new Error(`Expected Field ORDER > 0, got ${r}`);
  const { nBitLength: s, nByteLength: i } = Ww(r, e);
  if (i > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const a = P5(r), o = Object.freeze({
    ORDER: r,
    BITS: s,
    BYTES: i,
    MASK: bg(s),
    ZERO: Vt,
    ONE: Nt,
    create: (u) => pr(u, r),
    isValid: (u) => {
      if (typeof u != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof u}`);
      return Vt <= u && u < r;
    },
    is0: (u) => u === Vt,
    isOdd: (u) => (u & Nt) === Nt,
    neg: (u) => pr(-u, r),
    eql: (u, c) => u === c,
    sqr: (u) => pr(u * u, r),
    add: (u, c) => pr(u + c, r),
    sub: (u, c) => pr(u - c, r),
    mul: (u, c) => pr(u * c, r),
    pow: (u, c) => T5(o, u, c),
    div: (u, c) => pr(u * Vp(c, r), r),
    // Same as above, but doesn't normalize
    sqrN: (u) => u * u,
    addN: (u, c) => u + c,
    subN: (u, c) => u - c,
    mulN: (u, c) => u * c,
    inv: (u) => Vp(u, r),
    sqrt: n.sqrt || ((u) => a(o, u)),
    invertBatch: (u) => B5(o, u),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (u, c, l) => l ? c : u,
    toBytes: (u) => t ? pg(u, i) : hu(u, i),
    fromBytes: (u) => {
      if (u.length !== i)
        throw new Error(`Fp.fromBytes: expected ${i}, got ${u.length}`);
      return t ? hg(u) : ho(u);
    }
  });
  return Object.freeze(o);
}
function Yw(r) {
  if (typeof r != "bigint")
    throw new Error("field order must be bigint");
  const e = r.toString(2).length;
  return Math.ceil(e / 8);
}
function Zw(r) {
  const e = Yw(r);
  return e + Math.ceil(e / 2);
}
function N5(r, e, t = !1) {
  const n = r.length, s = Yw(e), i = Zw(e);
  if (n < 16 || n < i || n > 1024)
    throw new Error(`expected ${i}-1024 bytes of input, got ${n}`);
  const a = t ? ho(r) : hg(r), o = pr(a, e - Nt) + Nt;
  return t ? pg(o, s) : hu(o, s);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const S5 = BigInt(0), Lh = BigInt(1);
function C5(r, e) {
  const t = (s, i) => {
    const a = i.negate();
    return s ? a : i;
  }, n = (s) => {
    const i = Math.ceil(e / s) + 1, a = 2 ** (s - 1);
    return { windows: i, windowSize: a };
  };
  return {
    constTimeNegate: t,
    // non-const time multiplication ladder
    unsafeLadder(s, i) {
      let a = r.ZERO, o = s;
      for (; i > S5; )
        i & Lh && (a = a.add(o)), o = o.double(), i >>= Lh;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(s, i) {
      const { windows: a, windowSize: o } = n(i), u = [];
      let c = s, l = c;
      for (let f = 0; f < a; f++) {
        l = c, u.push(l);
        for (let d = 1; d < o; d++)
          l = l.add(c), u.push(l);
        c = l.double();
      }
      return u;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(s, i, a) {
      const { windows: o, windowSize: u } = n(s);
      let c = r.ZERO, l = r.BASE;
      const f = BigInt(2 ** s - 1), d = 2 ** s, h = BigInt(s);
      for (let p = 0; p < o; p++) {
        const g = p * u;
        let k = Number(a & f);
        a >>= h, k > u && (k -= d, a += Lh);
        const A = g, y = g + Math.abs(k) - 1, E = p % 2 !== 0, m = k < 0;
        k === 0 ? l = l.add(t(E, i[A])) : c = c.add(t(m, i[y]));
      }
      return { p: c, f: l };
    },
    wNAFCached(s, i, a, o) {
      const u = s._WINDOW_SIZE || 1;
      let c = i.get(s);
      return c || (c = this.precomputeWindow(s, u), u !== 1 && i.set(s, o(c))), this.wNAF(u, c, a);
    }
  };
}
function Xw(r) {
  return k5(r.Fp), ef(r, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Ww(r.n, r.nBitLength),
    ...r,
    p: r.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function R5(r) {
  const e = Xw(r);
  ef(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: t, Fp: n, a: s } = e;
  if (t) {
    if (!n.eql(s, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof t != "object" || typeof t.beta != "bigint" || typeof t.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: I5, hexToBytes: _5 } = y5, La = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(r) {
    const { Err: e } = La;
    if (r.length < 2 || r[0] !== 2)
      throw new e("Invalid signature integer tag");
    const t = r[1], n = r.subarray(2, t + 2);
    if (!t || n.length !== t)
      throw new e("Invalid signature integer: wrong length");
    if (n[0] & 128)
      throw new e("Invalid signature integer: negative");
    if (n[0] === 0 && !(n[1] & 128))
      throw new e("Invalid signature integer: unnecessary leading zero");
    return { d: I5(n), l: r.subarray(t + 2) };
  },
  toSig(r) {
    const { Err: e } = La, t = typeof r == "string" ? _5(r) : r;
    if (!(t instanceof Uint8Array))
      throw new Error("ui8a expected");
    let n = t.length;
    if (n < 2 || t[0] != 48)
      throw new e("Invalid signature tag");
    if (t[1] !== n - 2)
      throw new e("Invalid signature: incorrect length");
    const { d: s, l: i } = La._parseInt(t.subarray(2)), { d: a, l: o } = La._parseInt(i);
    if (o.length)
      throw new e("Invalid signature: left bytes after parsing");
    return { r: s, s: a };
  },
  hexFromSig(r) {
    const e = (c) => Number.parseInt(c[0], 16) & 8 ? "00" + c : c, t = (c) => {
      const l = c.toString(16);
      return l.length & 1 ? `0${l}` : l;
    }, n = e(t(r.s)), s = e(t(r.r)), i = n.length / 2, a = s.length / 2, o = t(i), u = t(a);
    return `30${t(a + i + 4)}02${u}${s}02${o}${n}`;
  }
}, Ss = BigInt(0), Wr = BigInt(1);
BigInt(2);
const tm = BigInt(3);
BigInt(4);
function U5(r) {
  const e = R5(r), { Fp: t } = e, n = e.toBytes || ((p, g, k) => {
    const A = g.toAffine();
    return A0(Uint8Array.from([4]), t.toBytes(A.x), t.toBytes(A.y));
  }), s = e.fromBytes || ((p) => {
    const g = p.subarray(1), k = t.fromBytes(g.subarray(0, t.BYTES)), A = t.fromBytes(g.subarray(t.BYTES, 2 * t.BYTES));
    return { x: k, y: A };
  });
  function i(p) {
    const { a: g, b: k } = e, A = t.sqr(p), y = t.mul(A, p);
    return t.add(t.add(y, t.mul(p, g)), k);
  }
  if (!t.eql(t.sqr(e.Gy), i(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function a(p) {
    return typeof p == "bigint" && Ss < p && p < e.n;
  }
  function o(p) {
    if (!a(p))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function u(p) {
    const { allowedPrivateKeyLengths: g, nByteLength: k, wrapPrivateKey: A, n: y } = e;
    if (g && typeof p != "bigint") {
      if (p instanceof Uint8Array && (p = fu(p)), typeof p != "string" || !g.includes(p.length))
        throw new Error("Invalid key");
      p = p.padStart(k * 2, "0");
    }
    let E;
    try {
      E = typeof p == "bigint" ? p : ho(hn("private key", p, k));
    } catch {
      throw new Error(`private key must be ${k} bytes, hex or bigint, not ${typeof p}`);
    }
    return A && (E = pr(E, y)), o(E), E;
  }
  const c = /* @__PURE__ */ new Map();
  function l(p) {
    if (!(p instanceof f))
      throw new Error("ProjectivePoint expected");
  }
  class f {
    constructor(g, k, A) {
      if (this.px = g, this.py = k, this.pz = A, g == null || !t.isValid(g))
        throw new Error("x required");
      if (k == null || !t.isValid(k))
        throw new Error("y required");
      if (A == null || !t.isValid(A))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(g) {
      const { x: k, y: A } = g || {};
      if (!g || !t.isValid(k) || !t.isValid(A))
        throw new Error("invalid affine point");
      if (g instanceof f)
        throw new Error("projective point not allowed");
      const y = (E) => t.eql(E, t.ZERO);
      return y(k) && y(A) ? f.ZERO : new f(k, A, t.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(g) {
      const k = t.invertBatch(g.map((A) => A.pz));
      return g.map((A, y) => A.toAffine(k[y])).map(f.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(g) {
      const k = f.fromAffine(s(hn("pointHex", g)));
      return k.assertValidity(), k;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(g) {
      return f.BASE.multiply(u(g));
    }
    // "Private method", don't use it directly
    _setWindowSize(g) {
      this._WINDOW_SIZE = g, c.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (e.allowInfinityPoint && !t.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: g, y: k } = this.toAffine();
      if (!t.isValid(g) || !t.isValid(k))
        throw new Error("bad point: x or y not FE");
      const A = t.sqr(k), y = i(g);
      if (!t.eql(A, y))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: g } = this.toAffine();
      if (t.isOdd)
        return !t.isOdd(g);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(g) {
      l(g);
      const { px: k, py: A, pz: y } = this, { px: E, py: m, pz: N } = g, T = t.eql(t.mul(k, N), t.mul(E, y)), U = t.eql(t.mul(A, N), t.mul(m, y));
      return T && U;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new f(this.px, t.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: g, b: k } = e, A = t.mul(k, tm), { px: y, py: E, pz: m } = this;
      let N = t.ZERO, T = t.ZERO, U = t.ZERO, R = t.mul(y, y), j = t.mul(E, E), D = t.mul(m, m), O = t.mul(y, E);
      return O = t.add(O, O), U = t.mul(y, m), U = t.add(U, U), N = t.mul(g, U), T = t.mul(A, D), T = t.add(N, T), N = t.sub(j, T), T = t.add(j, T), T = t.mul(N, T), N = t.mul(O, N), U = t.mul(A, U), D = t.mul(g, D), O = t.sub(R, D), O = t.mul(g, O), O = t.add(O, U), U = t.add(R, R), R = t.add(U, R), R = t.add(R, D), R = t.mul(R, O), T = t.add(T, R), D = t.mul(E, m), D = t.add(D, D), R = t.mul(D, O), N = t.sub(N, R), U = t.mul(D, j), U = t.add(U, U), U = t.add(U, U), new f(N, T, U);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(g) {
      l(g);
      const { px: k, py: A, pz: y } = this, { px: E, py: m, pz: N } = g;
      let T = t.ZERO, U = t.ZERO, R = t.ZERO;
      const j = e.a, D = t.mul(e.b, tm);
      let O = t.mul(k, E), I = t.mul(A, m), P = t.mul(y, N), S = t.add(k, A), B = t.add(E, m);
      S = t.mul(S, B), B = t.add(O, I), S = t.sub(S, B), B = t.add(k, y);
      let C = t.add(E, N);
      return B = t.mul(B, C), C = t.add(O, P), B = t.sub(B, C), C = t.add(A, y), T = t.add(m, N), C = t.mul(C, T), T = t.add(I, P), C = t.sub(C, T), R = t.mul(j, B), T = t.mul(D, P), R = t.add(T, R), T = t.sub(I, R), R = t.add(I, R), U = t.mul(T, R), I = t.add(O, O), I = t.add(I, O), P = t.mul(j, P), B = t.mul(D, B), I = t.add(I, P), P = t.sub(O, P), P = t.mul(j, P), B = t.add(B, P), O = t.mul(I, B), U = t.add(U, O), O = t.mul(C, B), T = t.mul(S, T), T = t.sub(T, O), O = t.mul(S, I), R = t.mul(C, R), R = t.add(R, O), new f(T, U, R);
    }
    subtract(g) {
      return this.add(g.negate());
    }
    is0() {
      return this.equals(f.ZERO);
    }
    wNAF(g) {
      return h.wNAFCached(this, c, g, (k) => {
        const A = t.invertBatch(k.map((y) => y.pz));
        return k.map((y, E) => y.toAffine(A[E])).map(f.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(g) {
      const k = f.ZERO;
      if (g === Ss)
        return k;
      if (o(g), g === Wr)
        return this;
      const { endo: A } = e;
      if (!A)
        return h.unsafeLadder(this, g);
      let { k1neg: y, k1: E, k2neg: m, k2: N } = A.splitScalar(g), T = k, U = k, R = this;
      for (; E > Ss || N > Ss; )
        E & Wr && (T = T.add(R)), N & Wr && (U = U.add(R)), R = R.double(), E >>= Wr, N >>= Wr;
      return y && (T = T.negate()), m && (U = U.negate()), U = new f(t.mul(U.px, A.beta), U.py, U.pz), T.add(U);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(g) {
      o(g);
      let k = g, A, y;
      const { endo: E } = e;
      if (E) {
        const { k1neg: m, k1: N, k2neg: T, k2: U } = E.splitScalar(k);
        let { p: R, f: j } = this.wNAF(N), { p: D, f: O } = this.wNAF(U);
        R = h.constTimeNegate(m, R), D = h.constTimeNegate(T, D), D = new f(t.mul(D.px, E.beta), D.py, D.pz), A = R.add(D), y = j.add(O);
      } else {
        const { p: m, f: N } = this.wNAF(k);
        A = m, y = N;
      }
      return f.normalizeZ([A, y])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(g, k, A) {
      const y = f.BASE, E = (N, T) => T === Ss || T === Wr || !N.equals(y) ? N.multiplyUnsafe(T) : N.multiply(T), m = E(this, k).add(E(g, A));
      return m.is0() ? void 0 : m;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(g) {
      const { px: k, py: A, pz: y } = this, E = this.is0();
      g == null && (g = E ? t.ONE : t.inv(y));
      const m = t.mul(k, g), N = t.mul(A, g), T = t.mul(y, g);
      if (E)
        return { x: t.ZERO, y: t.ZERO };
      if (!t.eql(T, t.ONE))
        throw new Error("invZ was invalid");
      return { x: m, y: N };
    }
    isTorsionFree() {
      const { h: g, isTorsionFree: k } = e;
      if (g === Wr)
        return !0;
      if (k)
        return k(f, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: g, clearCofactor: k } = e;
      return g === Wr ? this : k ? k(f, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(g = !0) {
      return this.assertValidity(), n(f, this, g);
    }
    toHex(g = !0) {
      return fu(this.toRawBytes(g));
    }
  }
  f.BASE = new f(e.Gx, e.Gy, t.ONE), f.ZERO = new f(t.ZERO, t.ONE, t.ZERO);
  const d = e.nBitLength, h = C5(f, e.endo ? Math.ceil(d / 2) : d);
  return {
    CURVE: e,
    ProjectivePoint: f,
    normPrivateKeyToScalar: u,
    weierstrassEquation: i,
    isWithinCurveOrder: a
  };
}
function L5(r) {
  const e = Xw(r);
  return ef(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function M5(r) {
  const e = L5(r), { Fp: t, n } = e, s = t.BYTES + 1, i = 2 * t.BYTES + 1;
  function a(B) {
    return Ss < B && B < t.ORDER;
  }
  function o(B) {
    return pr(B, n);
  }
  function u(B) {
    return Vp(B, n);
  }
  const { ProjectivePoint: c, normPrivateKeyToScalar: l, weierstrassEquation: f, isWithinCurveOrder: d } = U5({
    ...e,
    toBytes(B, C, H) {
      const V = C.toAffine(), J = t.toBytes(V.x), M = A0;
      return H ? M(Uint8Array.from([C.hasEvenY() ? 2 : 3]), J) : M(Uint8Array.from([4]), J, t.toBytes(V.y));
    },
    fromBytes(B) {
      const C = B.length, H = B[0], V = B.subarray(1);
      if (C === s && (H === 2 || H === 3)) {
        const J = ho(V);
        if (!a(J))
          throw new Error("Point is not on curve");
        const M = f(J);
        let G = t.sqrt(M);
        const K = (G & Wr) === Wr;
        return (H & 1) === 1 !== K && (G = t.neg(G)), { x: J, y: G };
      } else if (C === i && H === 4) {
        const J = t.fromBytes(V.subarray(0, t.BYTES)), M = t.fromBytes(V.subarray(t.BYTES, 2 * t.BYTES));
        return { x: J, y: M };
      } else
        throw new Error(`Point of length ${C} was invalid. Expected ${s} compressed bytes or ${i} uncompressed bytes`);
    }
  }), h = (B) => fu(hu(B, e.nByteLength));
  function p(B) {
    const C = n >> Wr;
    return B > C;
  }
  function g(B) {
    return p(B) ? o(-B) : B;
  }
  const k = (B, C, H) => ho(B.slice(C, H));
  class A {
    constructor(C, H, V) {
      this.r = C, this.s = H, this.recovery = V, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(C) {
      const H = e.nByteLength;
      return C = hn("compactSignature", C, H * 2), new A(k(C, 0, H), k(C, H, 2 * H));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(C) {
      const { r: H, s: V } = La.toSig(hn("DER", C));
      return new A(H, V);
    }
    assertValidity() {
      if (!d(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!d(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(C) {
      return new A(this.r, this.s, C);
    }
    recoverPublicKey(C) {
      const { r: H, s: V, recovery: J } = this, M = U(hn("msgHash", C));
      if (J == null || ![0, 1, 2, 3].includes(J))
        throw new Error("recovery id invalid");
      const G = J === 2 || J === 3 ? H + e.n : H;
      if (G >= t.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const K = J & 1 ? "03" : "02", X = c.fromHex(K + h(G)), te = u(G), pe = o(-M * te), he = o(V * te), ye = c.BASE.multiplyAndAddUnsafe(X, pe, he);
      if (!ye)
        throw new Error("point at infinify");
      return ye.assertValidity(), ye;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return p(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new A(this.r, o(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return du(this.toDERHex());
    }
    toDERHex() {
      return La.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return du(this.toCompactHex());
    }
    toCompactHex() {
      return h(this.r) + h(this.s);
    }
  }
  const y = {
    isValidPrivateKey(B) {
      try {
        return l(B), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: l,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const B = Zw(e.n);
      return N5(e.randomBytes(B), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(B = 8, C = c.BASE) {
      return C._setWindowSize(B), C.multiply(BigInt(3)), C;
    }
  };
  function E(B, C = !0) {
    return c.fromPrivateKey(B).toRawBytes(C);
  }
  function m(B) {
    const C = B instanceof Uint8Array, H = typeof B == "string", V = (C || H) && B.length;
    return C ? V === s || V === i : H ? V === 2 * s || V === 2 * i : B instanceof c;
  }
  function N(B, C, H = !0) {
    if (m(B))
      throw new Error("first arg must be private key");
    if (!m(C))
      throw new Error("second arg must be public key");
    return c.fromHex(C).multiply(l(B)).toRawBytes(H);
  }
  const T = e.bits2int || function(B) {
    const C = ho(B), H = B.length * 8 - e.nBitLength;
    return H > 0 ? C >> BigInt(H) : C;
  }, U = e.bits2int_modN || function(B) {
    return o(T(B));
  }, R = bg(e.nBitLength);
  function j(B) {
    if (typeof B != "bigint")
      throw new Error("bigint expected");
    if (!(Ss <= B && B < R))
      throw new Error(`bigint expected < 2^${e.nBitLength}`);
    return hu(B, e.nByteLength);
  }
  function D(B, C, H = O) {
    if (["recovered", "canonical"].some((ae) => ae in H))
      throw new Error("sign() legacy options not supported");
    const { hash: V, randomBytes: J } = e;
    let { lowS: M, prehash: G, extraEntropy: K } = H;
    M == null && (M = !0), B = hn("msgHash", B), G && (B = hn("prehashed msgHash", V(B)));
    const X = U(B), te = l(C), pe = [j(te), j(X)];
    if (K != null) {
      const ae = K === !0 ? J(t.BYTES) : K;
      pe.push(hn("extraEntropy", ae));
    }
    const he = A0(...pe), ye = X;
    function re(ae) {
      const L = T(ae);
      if (!d(L))
        return;
      const ne = u(L), oe = c.BASE.multiply(L).toAffine(), ee = o(oe.x);
      if (ee === Ss)
        return;
      const W = o(ne * o(ye + ee * te));
      if (W === Ss)
        return;
      let v = (oe.x === ee ? 0 : 2) | Number(oe.y & Wr), z = W;
      return M && p(W) && (z = g(W), v ^= 1), new A(ee, z, v);
    }
    return { seed: he, k2sig: re };
  }
  const O = { lowS: e.lowS, prehash: !1 }, I = { lowS: e.lowS, prehash: !1 };
  function P(B, C, H = O) {
    const { seed: V, k2sig: J } = D(B, C, H), M = e;
    return qw(M.hash.outputLen, M.nByteLength, M.hmac)(V, J);
  }
  c.BASE._setWindowSize(8);
  function S(B, C, H, V = I) {
    var oe;
    const J = B;
    if (C = hn("msgHash", C), H = hn("publicKey", H), "strict" in V)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: M, prehash: G } = V;
    let K, X;
    try {
      if (typeof J == "string" || J instanceof Uint8Array)
        try {
          K = A.fromDER(J);
        } catch (ee) {
          if (!(ee instanceof La.Err))
            throw ee;
          K = A.fromCompact(J);
        }
      else if (typeof J == "object" && typeof J.r == "bigint" && typeof J.s == "bigint") {
        const { r: ee, s: W } = J;
        K = new A(ee, W);
      } else
        throw new Error("PARSE");
      X = c.fromHex(H);
    } catch (ee) {
      if (ee.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (M && K.hasHighS())
      return !1;
    G && (C = e.hash(C));
    const { r: te, s: pe } = K, he = U(C), ye = u(pe), re = o(he * ye), ae = o(te * ye), L = (oe = c.BASE.multiplyAndAddUnsafe(X, re, ae)) == null ? void 0 : oe.toAffine();
    return L ? o(L.x) === te : !1;
  }
  return {
    CURVE: e,
    getPublicKey: E,
    getSharedSecret: N,
    sign: P,
    verify: S,
    ProjectivePoint: c,
    Signature: A,
    utils: y
  };
}
var Mh = {}, rm;
function Qd() {
  return rm || (rm = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.hmac = r.HMAC = void 0;
    const e = X0(), t = On();
    class n extends t.Hash {
      constructor(a, o) {
        super(), this.finished = !1, this.destroyed = !1, (0, e.hash)(a);
        const u = (0, t.toBytes)(o);
        if (this.iHash = a.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const c = this.blockLen, l = new Uint8Array(c);
        l.set(u.length > c ? a.create().update(u).digest() : u);
        for (let f = 0; f < l.length; f++)
          l[f] ^= 54;
        this.iHash.update(l), this.oHash = a.create();
        for (let f = 0; f < l.length; f++)
          l[f] ^= 106;
        this.oHash.update(l), l.fill(0);
      }
      update(a) {
        return (0, e.exists)(this), this.iHash.update(a), this;
      }
      digestInto(a) {
        (0, e.exists)(this), (0, e.bytes)(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
      }
      digest() {
        const a = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(a), a;
      }
      _cloneInto(a) {
        a || (a = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: o, iHash: u, finished: c, destroyed: l, blockLen: f, outputLen: d } = this;
        return a = a, a.finished = c, a.destroyed = l, a.blockLen = f, a.outputLen = d, a.oHash = o._cloneInto(a.oHash), a.iHash = u._cloneInto(a.iHash), a;
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    r.HMAC = n;
    const s = (i, a, o) => new n(i, a).update(o).digest();
    r.hmac = s, r.hmac.create = (i, a) => new n(i, a);
  }(Mh)), Mh;
}
var F5 = Qd();
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function D5(r) {
  return {
    hash: r,
    hmac: (e, ...t) => F5.hmac(r, e, Yx.concatBytes(...t)),
    randomBytes: Yx.randomBytes
  };
}
function j5(r, e) {
  const t = (n) => M5({ ...r, ...D5(n) });
  return Object.freeze({ ...t(e), create: t });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const e3 = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), nm = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), H5 = BigInt(1), $p = BigInt(2), sm = (r, e) => (r + e / $p) / e;
function G5(r) {
  const e = e3, t = BigInt(3), n = BigInt(6), s = BigInt(11), i = BigInt(22), a = BigInt(23), o = BigInt(44), u = BigInt(88), c = r * r * r % e, l = c * c * r % e, f = Fr(l, t, e) * l % e, d = Fr(f, t, e) * l % e, h = Fr(d, $p, e) * c % e, p = Fr(h, s, e) * h % e, g = Fr(p, i, e) * p % e, k = Fr(g, o, e) * g % e, A = Fr(k, u, e) * k % e, y = Fr(A, o, e) * g % e, E = Fr(y, t, e) * l % e, m = Fr(E, a, e) * p % e, N = Fr(m, n, e) * c % e, T = Fr(N, $p, e);
  if (!Kp.eql(Kp.sqr(T), r))
    throw new Error("Cannot find square root");
  return T;
}
const Kp = O5(e3, void 0, void 0, { sqrt: G5 }), oi = j5({
  a: BigInt(0),
  b: BigInt(7),
  Fp: Kp,
  n: nm,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (r) => {
      const e = nm, t = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -H5 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), s = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = t, a = BigInt("0x100000000000000000000000000000000"), o = sm(i * r, e), u = sm(-n * r, e);
      let c = pr(r - o * t - u * s, e), l = pr(-o * n - u * i, e);
      const f = c > a, d = l > a;
      if (f && (c = e - c), d && (l = e - l), c > a || l > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + r);
      return { k1neg: f, k1: c, k2neg: d, k2: l };
    }
  }
}, u5.sha256);
BigInt(0);
oi.ProjectivePoint;
const bo = "0x0000000000000000000000000000000000000000", cd = "0x0000000000000000000000000000000000000000000000000000000000000000", t3 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), r3 = BigInt("1000000000000000000"), n3 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), s3 = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1), i3 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), a3 = "Ξ", gg = `Ethereum Signed Message:
`, im = BigInt(0), am = BigInt(1), om = BigInt(2), cm = BigInt(27), um = BigInt(28), vf = BigInt(35), zo = {};
function lm(r) {
  return Xr(Ft(r), 32);
}
var Pc, vc, kc, Qa;
const fn = class fn {
  /**
   *  @private
   */
  constructor(e, t, n, s) {
    Z(this, Pc);
    Z(this, vc);
    Z(this, kc);
    Z(this, Qa);
    es(e, zo, "Signature"), F(this, Pc, t), F(this, vc, n), F(this, kc, s), F(this, Qa, null);
  }
  /**
   *  The ``r`` value for a signautre.
   *
   *  This represents the ``x`` coordinate of a "reference" or
   *  challenge point, from which the ``y`` can be computed.
   */
  get r() {
    return x(this, Pc);
  }
  set r(e) {
    ue(Is(e) === 32, "invalid r", "value", e), F(this, Pc, Oe(e));
  }
  /**
   *  The ``s`` value for a signature.
   */
  get s() {
    return x(this, vc);
  }
  set s(e) {
    ue(Is(e) === 32, "invalid s", "value", e);
    const t = Oe(e);
    ue(parseInt(t.substring(0, 3)) < 8, "non-canonical s", "value", t), F(this, vc, t);
  }
  /**
   *  The ``v`` value for a signature.
   *
   *  Since a given ``x`` value for ``r`` has two possible values for
   *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
   *  values to use.
   *
   *  It is normalized to the values ``27`` or ``28`` for legacy
   *  purposes.
   */
  get v() {
    return x(this, kc);
  }
  set v(e) {
    const t = Ve(e, "value");
    ue(t === 27 || t === 28, "invalid v", "v", e), F(this, kc, t);
  }
  /**
   *  The EIP-155 ``v`` for legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get networkV() {
    return x(this, Qa);
  }
  /**
   *  The chain ID for EIP-155 legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get legacyChainId() {
    const e = this.networkV;
    return e == null ? null : fn.getChainId(e);
  }
  /**
   *  The ``yParity`` for the signature.
   *
   *  See ``v`` for more details on how this value is used.
   */
  get yParity() {
    return this.v === 27 ? 0 : 1;
  }
  /**
   *  The [[link-eip-2098]] compact representation of the ``yParity``
   *  and ``s`` compacted into a single ``bytes32``.
   */
  get yParityAndS() {
    const e = Ce(this.s);
    return this.yParity && (e[0] |= 128), Oe(e);
  }
  /**
   *  The [[link-eip-2098]] compact representation.
   */
  get compactSerialized() {
    return it([this.r, this.yParityAndS]);
  }
  /**
   *  The serialized representation.
   */
  get serialized() {
    return it([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
  }
  /**
   *  Returns a new identical [[Signature]].
   */
  clone() {
    const e = new fn(zo, this.r, this.s, this.v);
    return this.networkV && F(e, Qa, this.networkV), e;
  }
  /**
   *  Returns a representation that is compatible with ``JSON.stringify``.
   */
  toJSON() {
    const e = this.networkV;
    return {
      _type: "signature",
      networkV: e != null ? e.toString() : null,
      r: this.r,
      s: this.s,
      v: this.v
    };
  }
  /**
   *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
   *
   *  @example:
   *    Signature.getChainId(45)
   *    //_result:
   *
   *    Signature.getChainId(46)
   *    //_result:
   */
  static getChainId(e) {
    const t = De(e, "v");
    return t == cm || t == um ? im : (ue(t >= vf, "invalid EIP-155 v", "v", e), (t - vf) / om);
  }
  /**
   *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
   *
   *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
   *  property to include the chain ID.
   *
   *  @example:
   *    Signature.getChainIdV(5, 27)
   *    //_result:
   *
   *    Signature.getChainIdV(5, 28)
   *    //_result:
   *
   */
  static getChainIdV(e, t) {
    return De(e) * om + BigInt(35 + t - 27);
  }
  /**
   *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
   *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
   *
   *  @example:
   *    // The values 0 and 1 imply v is actually yParity
   *    Signature.getNormalizedV(0)
   *    //_result:
   *
   *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
   *    Signature.getNormalizedV(27)
   *    //_result:
   *
   *    // Legacy EIP-155 transaction (i.e. >= 35)
   *    Signature.getNormalizedV(46)
   *    //_result:
   *
   *    // Invalid values throw
   *    Signature.getNormalizedV(5)
   *    //_error:
   */
  static getNormalizedV(e) {
    const t = De(e);
    return t === im || t === cm ? 27 : t === am || t === um ? 28 : (ue(t >= vf, "invalid v", "v", e), t & am ? 27 : 28);
  }
  /**
   *  Creates a new [[Signature]].
   *
   *  If no %%sig%% is provided, a new [[Signature]] is created
   *  with default values.
   *
   *  If %%sig%% is a string, it is parsed.
   */
  static from(e) {
    function t(c, l) {
      ue(c, l, "signature", e);
    }
    if (e == null)
      return new fn(zo, cd, cd, 27);
    if (typeof e == "string") {
      const c = Ce(e, "signature");
      if (c.length === 64) {
        const l = Oe(c.slice(0, 32)), f = c.slice(32, 64), d = f[0] & 128 ? 28 : 27;
        return f[0] &= 127, new fn(zo, l, Oe(f), d);
      }
      if (c.length === 65) {
        const l = Oe(c.slice(0, 32)), f = c.slice(32, 64);
        t((f[0] & 128) === 0, "non-canonical s");
        const d = fn.getNormalizedV(c[64]);
        return new fn(zo, l, Oe(f), d);
      }
      t(!1, "invalid raw signature length");
    }
    if (e instanceof fn)
      return e.clone();
    const n = e.r;
    t(n != null, "missing r");
    const s = lm(n), i = function(c, l) {
      if (c != null)
        return lm(c);
      if (l != null) {
        t(dt(l, 32), "invalid yParityAndS");
        const f = Ce(l);
        return f[0] &= 127, Oe(f);
      }
      t(!1, "missing s");
    }(e.s, e.yParityAndS);
    t((Ce(i)[0] & 128) == 0, "non-canonical s");
    const { networkV: a, v: o } = function(c, l, f) {
      if (c != null) {
        const d = De(c);
        return {
          networkV: d >= vf ? d : void 0,
          v: fn.getNormalizedV(d)
        };
      }
      if (l != null)
        return t(dt(l, 32), "invalid yParityAndS"), { v: Ce(l)[0] & 128 ? 28 : 27 };
      if (f != null) {
        switch (Ve(f, "sig.yParity")) {
          case 0:
            return { v: 27 };
          case 1:
            return { v: 28 };
        }
        t(!1, "invalid yParity");
      }
      t(!1, "missing v");
    }(e.v, e.yParityAndS, e.yParity), u = new fn(zo, s, i, o);
    return a && F(u, Qa, a), t(e.yParity == null || Ve(e.yParity, "sig.yParity") === u.yParity, "yParity mismatch"), t(e.yParityAndS == null || e.yParityAndS === u.yParityAndS, "yParityAndS mismatch"), u;
  }
};
Pc = new WeakMap(), vc = new WeakMap(), kc = new WeakMap(), Qa = new WeakMap();
let Ur = fn;
var ws;
const Ia = class Ia {
  /**
   *  Creates a new **SigningKey** for %%privateKey%%.
   */
  constructor(e) {
    Z(this, ws);
    ue(Is(e) === 32, "invalid private key", "privateKey", "[REDACTED]"), F(this, ws, Oe(e));
  }
  /**
   *  The private key.
   */
  get privateKey() {
    return x(this, ws);
  }
  /**
   *  The uncompressed public key.
   *
   * This will always begin with the prefix ``0x04`` and be 132
   * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
   */
  get publicKey() {
    return Ia.computePublicKey(x(this, ws));
  }
  /**
   *  The compressed public key.
   *
   *  This will always begin with either the prefix ``0x02`` or ``0x03``
   *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
   *  nibbles)
   */
  get compressedPublicKey() {
    return Ia.computePublicKey(x(this, ws), !0);
  }
  /**
   *  Return the signature of the signed %%digest%%.
   */
  sign(e) {
    ue(Is(e) === 32, "invalid digest length", "digest", e);
    const t = oi.sign(Mt(e), Mt(x(this, ws)), {
      lowS: !0
    });
    return Ur.from({
      r: tn(t.r, 32),
      s: tn(t.s, 32),
      v: t.recovery ? 28 : 27
    });
  }
  /**
   *  Returns the [[link-wiki-ecdh]] shared secret between this
   *  private key and the %%other%% key.
   *
   *  The %%other%% key may be any type of key, a raw public key,
   *  a compressed/uncompressed pubic key or aprivate key.
   *
   *  Best practice is usually to use a cryptographic hash on the
   *  returned value before using it as a symetric secret.
   *
   *  @example:
   *    sign1 = new SigningKey(id("some-secret-1"))
   *    sign2 = new SigningKey(id("some-secret-2"))
   *
   *    // Notice that privA.computeSharedSecret(pubB)...
   *    sign1.computeSharedSecret(sign2.publicKey)
   *    //_result:
   *
   *    // ...is equal to privB.computeSharedSecret(pubA).
   *    sign2.computeSharedSecret(sign1.publicKey)
   *    //_result:
   */
  computeSharedSecret(e) {
    const t = Ia.computePublicKey(e);
    return Oe(oi.getSharedSecret(Mt(x(this, ws)), Ce(t), !1));
  }
  /**
   *  Compute the public key for %%key%%, optionally %%compressed%%.
   *
   *  The %%key%% may be any type of key, a raw public key, a
   *  compressed/uncompressed public key or private key.
   *
   *  @example:
   *    sign = new SigningKey(id("some-secret"));
   *
   *    // Compute the uncompressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey)
   *    //_result:
   *
   *    // Compute the compressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey, true)
   *    //_result:
   *
   *    // Compute the uncompressed public key
   *    SigningKey.computePublicKey(sign.publicKey, false);
   *    //_result:
   *
   *    // Compute the Compressed a public key
   *    SigningKey.computePublicKey(sign.publicKey, true);
   *    //_result:
   */
  static computePublicKey(e, t) {
    let n = Ce(e, "key");
    if (n.length === 32) {
      const i = oi.getPublicKey(n, !!t);
      return Oe(i);
    }
    if (n.length === 64) {
      const i = new Uint8Array(65);
      i[0] = 4, i.set(n, 1), n = i;
    }
    const s = oi.ProjectivePoint.fromHex(n);
    return Oe(s.toRawBytes(t));
  }
  /**
   *  Returns the public key for the private key which produced the
   *  %%signature%% for the given %%digest%%.
   *
   *  @example:
   *    key = new SigningKey(id("some-secret"))
   *    digest = id("hello world")
   *    sig = key.sign(digest)
   *
   *    // Notice the signer public key...
   *    key.publicKey
   *    //_result:
   *
   *    // ...is equal to the recovered public key
   *    SigningKey.recoverPublicKey(digest, sig)
   *    //_result:
   *
   */
  static recoverPublicKey(e, t) {
    ue(Is(e) === 32, "invalid digest length", "digest", e);
    const n = Ur.from(t);
    let s = oi.Signature.fromCompact(Mt(it([n.r, n.s])));
    s = s.addRecoveryBit(n.yParity);
    const i = s.recoverPublicKey(Mt(e));
    return ue(i != null, "invalid signautre for digest", "signature", t), "0x" + i.toHex(!1);
  }
  /**
   *  Returns the point resulting from adding the ellipic curve points
   *  %%p0%% and %%p1%%.
   *
   *  This is not a common function most developers should require, but
   *  can be useful for certain privacy-specific techniques.
   *
   *  For example, it is used by [[HDNodeWallet]] to compute child
   *  addresses from parent public keys and chain codes.
   */
  static addPoints(e, t, n) {
    const s = oi.ProjectivePoint.fromHex(Ia.computePublicKey(e).substring(2)), i = oi.ProjectivePoint.fromHex(Ia.computePublicKey(t).substring(2));
    return "0x" + s.add(i).toHex(!!n);
  }
};
ws = new WeakMap();
let en = Ia;
function o3() {
  $s.lock(), ft.lock(), Bn.lock(), Ir.lock(), Ks.lock(), zs.lock(), Js.lock(), nr.lock(), Iu.lock(), Ir.lock();
}
const V5 = BigInt(0), $5 = BigInt(36);
function fm(r) {
  r = r.toLowerCase();
  const e = r.substring(2).split(""), t = new Uint8Array(40);
  for (let s = 0; s < 40; s++)
    t[s] = e[s].charCodeAt(0);
  const n = Ce(ft(t));
  for (let s = 0; s < 40; s += 2)
    n[s >> 1] >> 4 >= 8 && (e[s] = e[s].toUpperCase()), (n[s >> 1] & 15) >= 8 && (e[s + 1] = e[s + 1].toUpperCase());
  return "0x" + e.join("");
}
const xg = {};
for (let r = 0; r < 10; r++)
  xg[String(r)] = String(r);
for (let r = 0; r < 26; r++)
  xg[String.fromCharCode(65 + r)] = String(10 + r);
const dm = 15;
function c3(r) {
  r = r.toUpperCase(), r = r.substring(4) + r.substring(0, 2) + "00";
  let e = r.split("").map((n) => xg[n]).join("");
  for (; e.length >= dm; ) {
    let n = e.substring(0, dm);
    e = parseInt(n, 10) % 97 + e.substring(n.length);
  }
  let t = String(98 - parseInt(e, 10) % 97);
  for (; t.length < 2; )
    t = "0" + t;
  return t;
}
const K5 = function() {
  const r = {};
  for (let e = 0; e < 36; e++) {
    const t = "0123456789abcdefghijklmnopqrstuvwxyz"[e];
    r[t] = BigInt(e);
  }
  return r;
}();
function z5(r) {
  r = r.toLowerCase();
  let e = V5;
  for (let t = 0; t < r.length; t++)
    e = e * $5 + K5[r[t]];
  return e;
}
function et(r) {
  if (ue(typeof r == "string", "invalid address", "address", r), r.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    r.startsWith("0x") || (r = "0x" + r);
    const e = fm(r);
    return ue(!r.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || e === r, "bad address checksum", "address", r), e;
  }
  if (r.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    ue(r.substring(2, 4) === c3(r), "bad icap checksum", "address", r);
    let e = z5(r.substring(4)).toString(16);
    for (; e.length < 40; )
      e = "0" + e;
    return fm("0x" + e);
  }
  ue(!1, "invalid address", "address", r);
}
function u3(r) {
  let e = BigInt(et(r)).toString(36).toUpperCase();
  for (; e.length < 30; )
    e = "0" + e;
  return "XE" + c3("XE00" + e) + e;
}
function qd(r) {
  const e = et(r.from);
  let n = De(r.nonce, "tx.nonce").toString(16);
  return n === "0" ? n = "0x" : n.length % 2 ? n = "0x0" + n : n = "0x" + n, et(lt(ft(Ds([e, n])), 12));
}
function l3(r, e, t) {
  const n = et(r), s = Ce(e, "salt"), i = Ce(t, "initCodeHash");
  return ue(s.length === 32, "salt must be 32 bytes", "salt", e), ue(i.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", t), et(lt(ft(it(["0xff", n, s, i])), 12));
}
function Wd(r) {
  return r && typeof r.getAddress == "function";
}
function f3(r) {
  try {
    return et(r), !0;
  } catch {
  }
  return !1;
}
async function Fh(r, e) {
  const t = await e;
  return (t == null || t === "0x0000000000000000000000000000000000000000") && (Ee(typeof r != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: r }), ue(!1, "invalid AddressLike value; did not resolve to a value address", "target", r)), et(t);
}
function Dt(r, e) {
  if (typeof r == "string")
    return r.match(/^0x[0-9a-f]{40}$/i) ? et(r) : (Ee(e != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), Fh(r, e.resolveName(r)));
  if (Wd(r))
    return Fh(r, r.getAddress());
  if (r && typeof r.then == "function")
    return Fh(r, r);
  ue(!1, "unsupported addressable value", "target", r);
}
const hs = {};
function Fe(r, e) {
  let t = !1;
  return e < 0 && (t = !0, e *= -1), new $t(hs, `${t ? "" : "u"}int${e}`, r, { signed: t, width: e });
}
function ot(r, e) {
  return new $t(hs, `bytes${e || ""}`, r, { size: e });
}
const hm = Symbol.for("_ethers_typed");
var qa;
const bs = class bs {
  /**
   *  @_ignore:
   */
  constructor(e, t, n, s) {
    /**
     *  The type, as a Solidity-compatible type.
     */
    Q(this, "type");
    /**
     *  The actual value.
     */
    Q(this, "value");
    Z(this, qa);
    /**
     *  @_ignore:
     */
    Q(this, "_typedSymbol");
    s == null && (s = null), es(hs, e, "Typed"), _e(this, { _typedSymbol: hm, type: t, value: n }), F(this, qa, s), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((e) => e.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return x(this, qa);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return x(this, qa) === !0 ? -1 : x(this, qa) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(e, t) {
    return new bs(hs, e, t);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(e) {
    return Fe(e, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(e) {
    return Fe(e, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(e) {
    return Fe(e, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(e) {
    return Fe(e, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(e) {
    return Fe(e, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(e) {
    return Fe(e, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(e) {
    return Fe(e, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(e) {
    return Fe(e, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(e) {
    return Fe(e, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(e) {
    return Fe(e, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(e) {
    return Fe(e, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(e) {
    return Fe(e, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(e) {
    return Fe(e, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(e) {
    return Fe(e, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(e) {
    return Fe(e, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(e) {
    return Fe(e, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(e) {
    return Fe(e, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(e) {
    return Fe(e, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(e) {
    return Fe(e, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(e) {
    return Fe(e, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(e) {
    return Fe(e, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(e) {
    return Fe(e, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(e) {
    return Fe(e, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(e) {
    return Fe(e, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(e) {
    return Fe(e, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(e) {
    return Fe(e, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(e) {
    return Fe(e, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(e) {
    return Fe(e, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(e) {
    return Fe(e, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(e) {
    return Fe(e, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(e) {
    return Fe(e, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(e) {
    return Fe(e, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(e) {
    return Fe(e, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(e) {
    return Fe(e, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(e) {
    return Fe(e, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(e) {
    return Fe(e, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(e) {
    return Fe(e, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(e) {
    return Fe(e, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(e) {
    return Fe(e, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(e) {
    return Fe(e, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(e) {
    return Fe(e, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(e) {
    return Fe(e, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(e) {
    return Fe(e, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(e) {
    return Fe(e, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(e) {
    return Fe(e, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(e) {
    return Fe(e, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(e) {
    return Fe(e, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(e) {
    return Fe(e, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(e) {
    return Fe(e, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(e) {
    return Fe(e, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(e) {
    return Fe(e, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(e) {
    return Fe(e, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(e) {
    return Fe(e, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(e) {
    return Fe(e, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(e) {
    return Fe(e, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(e) {
    return Fe(e, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(e) {
    return Fe(e, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(e) {
    return Fe(e, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(e) {
    return Fe(e, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(e) {
    return Fe(e, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(e) {
    return Fe(e, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(e) {
    return Fe(e, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(e) {
    return Fe(e, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(e) {
    return Fe(e, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(e) {
    return Fe(e, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(e) {
    return Fe(e, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(e) {
    return ot(e, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(e) {
    return ot(e, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(e) {
    return ot(e, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(e) {
    return ot(e, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(e) {
    return ot(e, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(e) {
    return ot(e, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(e) {
    return ot(e, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(e) {
    return ot(e, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(e) {
    return ot(e, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(e) {
    return ot(e, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(e) {
    return ot(e, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(e) {
    return ot(e, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(e) {
    return ot(e, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(e) {
    return ot(e, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(e) {
    return ot(e, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(e) {
    return ot(e, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(e) {
    return ot(e, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(e) {
    return ot(e, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(e) {
    return ot(e, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(e) {
    return ot(e, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(e) {
    return ot(e, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(e) {
    return ot(e, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(e) {
    return ot(e, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(e) {
    return ot(e, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(e) {
    return ot(e, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(e) {
    return ot(e, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(e) {
    return ot(e, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(e) {
    return ot(e, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(e) {
    return ot(e, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(e) {
    return ot(e, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(e) {
    return ot(e, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(e) {
    return ot(e, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(e) {
    return new bs(hs, "address", e);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(e) {
    return new bs(hs, "bool", !!e);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(e) {
    return new bs(hs, "bytes", e);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(e) {
    return new bs(hs, "string", e);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(e, t) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(e, t) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(e) {
    return new bs(hs, "overrides", Object.assign({}, e));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(e) {
    return e && typeof e == "object" && "_typedSymbol" in e && e._typedSymbol === hm;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(e, t) {
    if (bs.isTyped(e)) {
      if (e.type !== t)
        throw new Error(`invalid type: expecetd ${t}, got ${e.type}`);
      return e.value;
    }
    return e;
  }
};
qa = new WeakMap();
let $t = bs;
class J5 extends Vs {
  constructor(e) {
    super("address", "address", e, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(e, t) {
    let n = $t.dereference(t, "string");
    try {
      n = et(n);
    } catch (s) {
      return this._throwError(s.message, t);
    }
    return e.writeValue(n);
  }
  decode(e) {
    return et(tn(e.readValue(), 20));
  }
}
class Q5 extends Vs {
  constructor(t) {
    super(t.name, t.type, "_", t.dynamic);
    Q(this, "coder");
    this.coder = t;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(t, n) {
    return this.coder.encode(t, n);
  }
  decode(t) {
    return this.coder.decode(t);
  }
}
function d3(r, e, t) {
  let n = [];
  if (Array.isArray(t))
    n = t;
  else if (t && typeof t == "object") {
    let u = {};
    n = e.map((c) => {
      const l = c.localName;
      return Ee(l, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: c }, value: t }), Ee(!u[l], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: c }, value: t }), u[l] = !0, t[l];
    });
  } else
    ue(!1, "invalid tuple value", "tuple", t);
  ue(e.length === n.length, "types/value length mismatch", "tuple", t);
  let s = new Fp(), i = new Fp(), a = [];
  e.forEach((u, c) => {
    let l = n[c];
    if (u.dynamic) {
      let f = i.length;
      u.encode(i, l);
      let d = s.writeUpdatableValue();
      a.push((h) => {
        d(h + f);
      });
    } else
      u.encode(s, l);
  }), a.forEach((u) => {
    u(s.length);
  });
  let o = r.appendWriter(s);
  return o += r.appendWriter(i), o;
}
function h3(r, e) {
  let t = [], n = [], s = r.subReader(0);
  return e.forEach((i) => {
    let a = null;
    if (i.dynamic) {
      let o = r.readIndex(), u = s.subReader(o);
      try {
        a = i.decode(u);
      } catch (c) {
        if (Ct(c, "BUFFER_OVERRUN"))
          throw c;
        a = c, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    } else
      try {
        a = i.decode(r);
      } catch (o) {
        if (Ct(o, "BUFFER_OVERRUN"))
          throw o;
        a = o, a.baseType = i.name, a.name = i.localName, a.type = i.type;
      }
    if (a == null)
      throw new Error("investigate");
    t.push(a), n.push(i.localName || null);
  }), Ri.fromItems(t, n);
}
class q5 extends Vs {
  constructor(t, n, s) {
    const i = t.type + "[" + (n >= 0 ? n : "") + "]", a = n === -1 || t.dynamic;
    super("array", i, s, a);
    Q(this, "coder");
    Q(this, "length");
    _e(this, { coder: t, length: n });
  }
  defaultValue() {
    const t = this.coder.defaultValue(), n = [];
    for (let s = 0; s < this.length; s++)
      n.push(t);
    return n;
  }
  encode(t, n) {
    const s = $t.dereference(n, "array");
    Array.isArray(s) || this._throwError("expected array value", s);
    let i = this.length;
    i === -1 && (i = s.length, t.writeValue(s.length)), Dd(s.length, i, "coder array" + (this.localName ? " " + this.localName : ""));
    let a = [];
    for (let o = 0; o < s.length; o++)
      a.push(this.coder);
    return d3(t, a, s);
  }
  decode(t) {
    let n = this.length;
    n === -1 && (n = t.readIndex(), Ee(n * cr <= t.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: t.bytes, offset: n * cr, length: t.dataLength }));
    let s = [];
    for (let i = 0; i < n; i++)
      s.push(new Q5(this.coder));
    return h3(t, s);
  }
}
class W5 extends Vs {
  constructor(e) {
    super("bool", "bool", e, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(e, t) {
    const n = $t.dereference(t, "bool");
    return e.writeValue(n ? 1 : 0);
  }
  decode(e) {
    return !!e.readValue();
  }
}
class p3 extends Vs {
  constructor(e, t) {
    super(e, e, t, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(e, t) {
    t = Mt(t);
    let n = e.writeValue(t.length);
    return n += e.writeBytes(t), n;
  }
  decode(e) {
    return e.readBytes(e.readIndex(), !0);
  }
}
class Y5 extends p3 {
  constructor(e) {
    super("bytes", e);
  }
  decode(e) {
    return Oe(super.decode(e));
  }
}
class Z5 extends Vs {
  constructor(t, n) {
    let s = "bytes" + String(t);
    super(s, s, n, !1);
    Q(this, "size");
    _e(this, { size: t }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(t, n) {
    let s = Mt($t.dereference(n, this.type));
    return s.length !== this.size && this._throwError("incorrect data length", n), t.writeBytes(s);
  }
  decode(t) {
    return Oe(t.readBytes(this.size));
  }
}
const X5 = new Uint8Array([]);
class eE extends Vs {
  constructor(e) {
    super("null", "", e, !1);
  }
  defaultValue() {
    return null;
  }
  encode(e, t) {
    return t != null && this._throwError("not null", t), e.writeBytes(X5);
  }
  decode(e) {
    return e.readBytes(0), null;
  }
}
const tE = BigInt(0), rE = BigInt(1), nE = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class sE extends Vs {
  constructor(t, n, s) {
    const i = (n ? "int" : "uint") + t * 8;
    super(i, i, s, !1);
    Q(this, "size");
    Q(this, "signed");
    _e(this, { size: t, signed: n }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(t, n) {
    let s = De($t.dereference(n, this.type)), i = Cs(nE, cr * 8);
    if (this.signed) {
      let a = Cs(i, this.size * 8 - 1);
      (s > a || s < -(a + rE)) && this._throwError("value out-of-bounds", n), s = Y0(s, 8 * cr);
    } else (s < tE || s > Cs(i, this.size * 8)) && this._throwError("value out-of-bounds", n);
    return t.writeValue(s);
  }
  decode(t) {
    let n = Cs(t.readValue(), this.size * 8);
    return this.signed && (n = ou(n, this.size * 8)), n;
  }
}
class iE extends p3 {
  constructor(e) {
    super("string", e);
  }
  defaultValue() {
    return "";
  }
  encode(e, t) {
    return super.encode(e, It($t.dereference(t, "string")));
  }
  decode(e) {
    return Fs(super.decode(e));
  }
}
class kf extends Vs {
  constructor(t, n) {
    let s = !1;
    const i = [];
    t.forEach((o) => {
      o.dynamic && (s = !0), i.push(o.type);
    });
    const a = "tuple(" + i.join(",") + ")";
    super("tuple", a, n, s);
    Q(this, "coders");
    _e(this, { coders: Object.freeze(t.slice()) });
  }
  defaultValue() {
    const t = [];
    this.coders.forEach((s) => {
      t.push(s.defaultValue());
    });
    const n = this.coders.reduce((s, i) => {
      const a = i.localName;
      return a && (s[a] || (s[a] = 0), s[a]++), s;
    }, {});
    return this.coders.forEach((s, i) => {
      let a = s.localName;
      !a || n[a] !== 1 || (a === "length" && (a = "_length"), t[a] == null && (t[a] = t[i]));
    }), Object.freeze(t);
  }
  encode(t, n) {
    const s = $t.dereference(n, "tuple");
    return d3(t, this.coders, s);
  }
  decode(t) {
    return h3(t, this.coders);
  }
}
function vn(r) {
  return ft(It(r));
}
var aE = "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";
const pm = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), bm = 4;
function oE(r) {
  let e = 0;
  function t() {
    return r[e++] << 8 | r[e++];
  }
  let n = t(), s = 1, i = [0, 1];
  for (let N = 1; N < n; N++)
    i.push(s += t());
  let a = t(), o = e;
  e += a;
  let u = 0, c = 0;
  function l() {
    return u == 0 && (c = c << 8 | r[e++], u = 8), c >> --u & 1;
  }
  const f = 31, d = 2 ** f, h = d >>> 1, p = h >> 1, g = d - 1;
  let k = 0;
  for (let N = 0; N < f; N++) k = k << 1 | l();
  let A = [], y = 0, E = d;
  for (; ; ) {
    let N = Math.floor(((k - y + 1) * s - 1) / E), T = 0, U = n;
    for (; U - T > 1; ) {
      let D = T + U >>> 1;
      N < i[D] ? U = D : T = D;
    }
    if (T == 0) break;
    A.push(T);
    let R = y + Math.floor(E * i[T] / s), j = y + Math.floor(E * i[T + 1] / s) - 1;
    for (; !((R ^ j) & h); )
      k = k << 1 & g | l(), R = R << 1 & g, j = j << 1 & g | 1;
    for (; R & ~j & p; )
      k = k & h | k << 1 & g >>> 1 | l(), R = R << 1 ^ h, j = (j ^ h) << 1 | h | 1;
    y = R, E = 1 + j - R;
  }
  let m = n - 4;
  return A.map((N) => {
    switch (N - m) {
      case 3:
        return m + 65792 + (r[o++] << 16 | r[o++] << 8 | r[o++]);
      case 2:
        return m + 256 + (r[o++] << 8 | r[o++]);
      case 1:
        return m + r[o++];
      default:
        return N - 1;
    }
  });
}
function cE(r) {
  let e = 0;
  return () => r[e++];
}
function b3(r) {
  return cE(oE(uE(r)));
}
function uE(r) {
  let e = [];
  [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((s, i) => e[s.charCodeAt(0)] = i);
  let t = r.length, n = new Uint8Array(6 * t >> 3);
  for (let s = 0, i = 0, a = 0, o = 0; s < t; s++)
    o = o << 6 | e[r.charCodeAt(s)], a += 6, a >= 8 && (n[i++] = o >> (a -= 8));
  return n;
}
function lE(r) {
  return r & 1 ? ~r >> 1 : r >> 1;
}
function fE(r, e) {
  let t = Array(r);
  for (let n = 0, s = 0; n < r; n++) t[n] = s += lE(e());
  return t;
}
function E0(r, e = 0) {
  let t = [];
  for (; ; ) {
    let n = r(), s = r();
    if (!s) break;
    e += n;
    for (let i = 0; i < s; i++)
      t.push(e + i);
    e += s + 1;
  }
  return t;
}
function g3(r) {
  return P0(() => {
    let e = E0(r);
    if (e.length) return e;
  });
}
function x3(r) {
  let e = [];
  for (; ; ) {
    let t = r();
    if (t == 0) break;
    e.push(dE(t, r));
  }
  for (; ; ) {
    let t = r() - 1;
    if (t < 0) break;
    e.push(hE(t, r));
  }
  return e.flat();
}
function P0(r) {
  let e = [];
  for (; ; ) {
    let t = r(e.length);
    if (!t) break;
    e.push(t);
  }
  return e;
}
function m3(r, e, t) {
  let n = Array(r).fill().map(() => []);
  for (let s = 0; s < e; s++)
    fE(r, t).forEach((i, a) => n[a].push(i));
  return n;
}
function dE(r, e) {
  let t = 1 + e(), n = e(), s = P0(e);
  return m3(s.length, 1 + r, e).flatMap((a, o) => {
    let [u, ...c] = a;
    return Array(s[o]).fill().map((l, f) => {
      let d = f * n;
      return [u + f * t, c.map((h) => h + d)];
    });
  });
}
function hE(r, e) {
  let t = 1 + e();
  return m3(t, 1 + r, e).map((s) => [s[0], s.slice(1)]);
}
function pE(r) {
  let e = [], t = E0(r);
  return s(n([]), []), e;
  function n(i) {
    let a = r(), o = P0(() => {
      let u = E0(r).map((c) => t[c]);
      if (u.length) return n(u);
    });
    return { S: a, B: o, Q: i };
  }
  function s({ S: i, B: a }, o, u) {
    if (!(i & 4 && u === o[o.length - 1])) {
      i & 2 && (u = o[o.length - 1]), i & 1 && e.push(o);
      for (let c of a)
        for (let l of c.Q)
          s(c, [...o, l], u);
    }
  }
}
function bE(r) {
  return r.toString(16).toUpperCase().padStart(2, "0");
}
function y3(r) {
  return `{${bE(r)}}`;
}
function gE(r) {
  let e = [];
  for (let t = 0, n = r.length; t < n; ) {
    let s = r.codePointAt(t);
    t += s < 65536 ? 1 : 2, e.push(s);
  }
  return e;
}
function pu(r) {
  let t = r.length;
  if (t < 4096) return String.fromCodePoint(...r);
  let n = [];
  for (let s = 0; s < t; )
    n.push(String.fromCodePoint(...r.slice(s, s += 4096)));
  return n.join("");
}
function xE(r, e) {
  let t = r.length, n = t - e.length;
  for (let s = 0; n == 0 && s < t; s++) n = r[s] - e[s];
  return n;
}
var mE = "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";
const v0 = 44032, ud = 4352, ld = 4449, fd = 4519, w3 = 19, A3 = 21, bu = 28, dd = A3 * bu, yE = w3 * dd, wE = v0 + yE, AE = ud + w3, EE = ld + A3, PE = fd + bu;
function s0(r) {
  return r >> 24 & 255;
}
function E3(r) {
  return r & 16777215;
}
let zp, gm, Jp, Hf;
function vE() {
  let r = b3(mE);
  zp = new Map(g3(r).flatMap((e, t) => e.map((n) => [n, t + 1 << 24]))), gm = new Set(E0(r)), Jp = /* @__PURE__ */ new Map(), Hf = /* @__PURE__ */ new Map();
  for (let [e, t] of x3(r)) {
    if (!gm.has(e) && t.length == 2) {
      let [n, s] = t, i = Hf.get(n);
      i || (i = /* @__PURE__ */ new Map(), Hf.set(n, i)), i.set(s, e);
    }
    Jp.set(e, t.reverse());
  }
}
function P3(r) {
  return r >= v0 && r < wE;
}
function kE(r, e) {
  if (r >= ud && r < AE && e >= ld && e < EE)
    return v0 + (r - ud) * dd + (e - ld) * bu;
  if (P3(r) && e > fd && e < PE && (r - v0) % bu == 0)
    return r + (e - fd);
  {
    let t = Hf.get(r);
    return t && (t = t.get(e), t) ? t : -1;
  }
}
function v3(r) {
  zp || vE();
  let e = [], t = [], n = !1;
  function s(i) {
    let a = zp.get(i);
    a && (n = !0, i |= a), e.push(i);
  }
  for (let i of r)
    for (; ; ) {
      if (i < 128)
        e.push(i);
      else if (P3(i)) {
        let a = i - v0, o = a / dd | 0, u = a % dd / bu | 0, c = a % bu;
        s(ud + o), s(ld + u), c > 0 && s(fd + c);
      } else {
        let a = Jp.get(i);
        a ? t.push(...a) : s(i);
      }
      if (!t.length) break;
      i = t.pop();
    }
  if (n && e.length > 1) {
    let i = s0(e[0]);
    for (let a = 1; a < e.length; a++) {
      let o = s0(e[a]);
      if (o == 0 || i <= o) {
        i = o;
        continue;
      }
      let u = a - 1;
      for (; ; ) {
        let c = e[u + 1];
        if (e[u + 1] = e[u], e[u] = c, !u || (i = s0(e[--u]), i <= o)) break;
      }
      i = s0(e[a]);
    }
  }
  return e;
}
function TE(r) {
  let e = [], t = [], n = -1, s = 0;
  for (let i of r) {
    let a = s0(i), o = E3(i);
    if (n == -1)
      a == 0 ? n = o : e.push(o);
    else if (s > 0 && s >= a)
      a == 0 ? (e.push(n, ...t), t.length = 0, n = o) : t.push(o), s = a;
    else {
      let u = kE(n, o);
      u >= 0 ? n = u : s == 0 && a == 0 ? (e.push(n), n = o) : (t.push(o), s = a);
    }
  }
  return n >= 0 && e.push(n, ...t), e;
}
function k3(r) {
  return v3(r).map(E3);
}
function BE(r) {
  return TE(v3(r));
}
const xm = 45, T3 = ".", B3 = 65039, O3 = 1, hd = (r) => Array.from(r);
function k0(r, e) {
  return r.P.has(e) || r.Q.has(e);
}
class OE extends Array {
  get is_emoji() {
    return !0;
  }
  // free tagging system
}
let Qp, N3, Ma, qp, S3, hc, Dh, ec, Ba, mm, Wp;
function mg() {
  if (Qp) return;
  let r = b3(aE);
  const e = () => E0(r), t = () => new Set(e()), n = (l, f) => f.forEach((d) => l.add(d));
  Qp = new Map(x3(r)), N3 = t(), Ma = e(), qp = new Set(e().map((l) => Ma[l])), Ma = new Set(Ma), S3 = t(), t();
  let s = g3(r), i = r();
  const a = () => {
    let l = /* @__PURE__ */ new Set();
    return e().forEach((f) => n(l, s[f])), n(l, e()), l;
  };
  hc = P0((l) => {
    let f = P0(r).map((d) => d + 96);
    if (f.length) {
      let d = l >= i;
      f[0] -= 32, f = pu(f), d && (f = `Restricted[${f}]`);
      let h = a(), p = a(), g = !r();
      return { N: f, P: h, Q: p, M: g, R: d };
    }
  }), Dh = t(), ec = /* @__PURE__ */ new Map();
  let o = e().concat(hd(Dh)).sort((l, f) => l - f);
  o.forEach((l, f) => {
    let d = r(), h = o[f] = d ? o[f - d] : { V: [], M: /* @__PURE__ */ new Map() };
    h.V.push(l), Dh.has(l) || ec.set(l, h);
  });
  for (let { V: l, M: f } of new Set(ec.values())) {
    let d = [];
    for (let p of l) {
      let g = hc.filter((A) => k0(A, p)), k = d.find(({ G: A }) => g.some((y) => A.has(y)));
      k || (k = { G: /* @__PURE__ */ new Set(), V: [] }, d.push(k)), k.V.push(p), n(k.G, g);
    }
    let h = d.flatMap((p) => hd(p.G));
    for (let { G: p, V: g } of d) {
      let k = new Set(h.filter((A) => !p.has(A)));
      for (let A of g)
        f.set(A, k);
    }
  }
  Ba = /* @__PURE__ */ new Set();
  let u = /* @__PURE__ */ new Set();
  const c = (l) => Ba.has(l) ? u.add(l) : Ba.add(l);
  for (let l of hc) {
    for (let f of l.P) c(f);
    for (let f of l.Q) c(f);
  }
  for (let l of Ba)
    !ec.has(l) && !u.has(l) && ec.set(l, O3);
  n(Ba, k3(Ba)), mm = pE(r).map((l) => OE.from(l)).sort(xE), Wp = /* @__PURE__ */ new Map();
  for (let l of mm) {
    let f = [Wp];
    for (let d of l) {
      let h = f.map((p) => {
        let g = p.get(d);
        return g || (g = /* @__PURE__ */ new Map(), p.set(d, g)), g;
      });
      d === B3 ? f.push(...h) : f = h;
    }
    for (let d of f)
      d.V = l;
  }
}
function yg(r) {
  return (C3(r) ? "" : `${wg(Yd([r]))} `) + y3(r);
}
function wg(r) {
  return `"${r}"‎`;
}
function NE(r) {
  if (r.length >= 4 && r[2] == xm && r[3] == xm)
    throw new Error(`invalid label extension: "${pu(r.slice(0, 4))}"`);
}
function SE(r) {
  for (let t = r.lastIndexOf(95); t > 0; )
    if (r[--t] !== 95)
      throw new Error("underscore allowed only at start");
}
function CE(r) {
  let e = r[0], t = pm.get(e);
  if (t) throw g0(`leading ${t}`);
  let n = r.length, s = -1;
  for (let i = 1; i < n; i++) {
    e = r[i];
    let a = pm.get(e);
    if (a) {
      if (s == i) throw g0(`${t} + ${a}`);
      s = i + 1, t = a;
    }
  }
  if (s == n) throw g0(`trailing ${t}`);
}
function Yd(r, e = 1 / 0, t = y3) {
  let n = [];
  RE(r[0]) && n.push("◌"), r.length > e && (e >>= 1, r = [...r.slice(0, e), 8230, ...r.slice(-e)]);
  let s = 0, i = r.length;
  for (let a = 0; a < i; a++) {
    let o = r[a];
    C3(o) && (n.push(pu(r.slice(s, a))), n.push(t(o)), s = a + 1);
  }
  return n.push(pu(r.slice(s, i))), n.join("");
}
function RE(r) {
  return mg(), Ma.has(r);
}
function C3(r) {
  return mg(), S3.has(r);
}
function IE(r) {
  return ME(_E(r, BE, jE));
}
function _E(r, e, t) {
  if (!r) return [];
  mg();
  let n = 0;
  return r.split(T3).map((s) => {
    let i = gE(s), a = {
      input: i,
      offset: n
      // codepoint, not substring!
    };
    n += i.length + 1;
    try {
      let o = a.tokens = DE(i, e, t), u = o.length, c;
      if (!u)
        throw new Error("empty label");
      let l = a.output = o.flat();
      if (SE(l), !(a.emoji = u > 1 || o[0].is_emoji) && l.every((d) => d < 128))
        NE(l), c = "ASCII";
      else {
        let d = o.flatMap((h) => h.is_emoji ? [] : h);
        if (!d.length)
          c = "Emoji";
        else {
          if (Ma.has(l[0])) throw g0("leading combining mark");
          for (let g = 1; g < u; g++) {
            let k = o[g];
            if (!k.is_emoji && Ma.has(k[0]))
              throw g0(`emoji + combining mark: "${pu(o[g - 1])} + ${Yd([k[0]])}"`);
          }
          CE(l);
          let h = hd(new Set(d)), [p] = LE(h);
          FE(p, d), UE(p, h), c = p.N;
        }
      }
      a.type = c;
    } catch (o) {
      a.error = o;
    }
    return a;
  });
}
function UE(r, e) {
  let t, n = [];
  for (let s of e) {
    let i = ec.get(s);
    if (i === O3) return;
    if (i) {
      let a = i.M.get(s);
      if (t = t ? t.filter((o) => a.has(o)) : hd(a), !t.length) return;
    } else
      n.push(s);
  }
  if (t) {
    for (let s of t)
      if (n.every((i) => k0(s, i)))
        throw new Error(`whole-script confusable: ${r.N}/${s.N}`);
  }
}
function LE(r) {
  let e = hc;
  for (let t of r) {
    let n = e.filter((s) => k0(s, t));
    if (!n.length)
      throw hc.some((s) => k0(s, t)) ? I3(e[0], t) : R3(t);
    if (e = n, n.length == 1) break;
  }
  return e;
}
function ME(r) {
  return r.map(({ input: e, error: t, output: n }) => {
    if (t) {
      let s = t.message;
      throw new Error(r.length == 1 ? s : `Invalid label ${wg(Yd(e, 63))}: ${s}`);
    }
    return pu(n);
  }).join(T3);
}
function R3(r) {
  return new Error(`disallowed character: ${yg(r)}`);
}
function I3(r, e) {
  let t = yg(e), n = hc.find((s) => s.P.has(e));
  return n && (t = `${n.N} ${t}`), new Error(`illegal mixture: ${r.N} + ${t}`);
}
function g0(r) {
  return new Error(`illegal placement: ${r}`);
}
function FE(r, e) {
  for (let t of e)
    if (!k0(r, t))
      throw I3(r, t);
  if (r.M) {
    let t = k3(e);
    for (let n = 1, s = t.length; n < s; n++)
      if (qp.has(t[n])) {
        let i = n + 1;
        for (let a; i < s && qp.has(a = t[i]); i++)
          for (let o = n; o < i; o++)
            if (t[o] == a)
              throw new Error(`duplicate non-spacing marks: ${yg(a)}`);
        if (i - n > bm)
          throw new Error(`excessive non-spacing marks: ${wg(Yd(t.slice(n - 1, i)))} (${i - n}/${bm})`);
        n = i;
      }
  }
}
function DE(r, e, t) {
  let n = [], s = [];
  for (r = r.slice().reverse(); r.length; ) {
    let i = HE(r);
    if (i)
      s.length && (n.push(e(s)), s = []), n.push(t(i));
    else {
      let a = r.pop();
      if (Ba.has(a))
        s.push(a);
      else {
        let o = Qp.get(a);
        if (o)
          s.push(...o);
        else if (!N3.has(a))
          throw R3(a);
      }
    }
  }
  return s.length && n.push(e(s)), n;
}
function jE(r) {
  return r.filter((e) => e != B3);
}
function HE(r, e) {
  let t = Wp, n, s = r.length;
  for (; s && (t = t.get(r[--s]), !!t); ) {
    let { V: i } = t;
    i && (n = i, r.length = s);
  }
  return n;
}
const _3 = new Uint8Array(32);
_3.fill(0);
function ym(r) {
  return ue(r.length !== 0, "invalid ENS name; empty component", "comp", r), r;
}
function Ag(r) {
  const e = It(Eg(r)), t = [];
  if (r.length === 0)
    return t;
  let n = 0;
  for (let s = 0; s < e.length; s++)
    e[s] === 46 && (t.push(ym(e.slice(n, s))), n = s + 1);
  return ue(n < e.length, "invalid ENS name; empty component", "name", r), t.push(ym(e.slice(n))), t;
}
function Eg(r) {
  try {
    if (r.length === 0)
      throw new Error("empty label");
    return IE(r);
  } catch (e) {
    ue(!1, `invalid ENS name (${e.message})`, "name", r);
  }
}
function U3(r) {
  try {
    return Ag(r).length !== 0;
  } catch {
  }
  return !1;
}
function T0(r) {
  ue(typeof r == "string", "invalid ENS name; not a string", "name", r), ue(r.length, "invalid ENS name (empty label)", "name", r);
  let e = _3;
  const t = Ag(r);
  for (; t.length; )
    e = ft(it([e, ft(t.pop())]));
  return Oe(e);
}
function Pg(r, e) {
  const t = e ?? 63;
  return ue(t <= 255, "DNS encoded label cannot exceed 255", "length", t), Oe(it(Ag(r).map((n) => {
    ue(n.length <= t, `label ${JSON.stringify(r)} exceeds ${t} bytes`, "name", r);
    const s = new Uint8Array(n.length + 1);
    return s.set(n, 1), s[0] = s.length - 1, s;
  }))) + "00";
}
function jh(r, e) {
  return {
    address: et(r),
    storageKeys: e.map((t, n) => (ue(dt(t, 32), "invalid slot", `storageKeys[${n}]`, t), t.toLowerCase()))
  };
}
function ts(r) {
  if (Array.isArray(r))
    return r.map((t, n) => Array.isArray(t) ? (ue(t.length === 2, "invalid slot set", `value[${n}]`, t), jh(t[0], t[1])) : (ue(t != null && typeof t == "object", "invalid address-slot set", "value", r), jh(t.address, t.storageKeys)));
  ue(r != null && typeof r == "object", "invalid access list", "value", r);
  const e = Object.keys(r).map((t) => {
    const n = r[t].reduce((s, i) => (s[i] = !0, s), {});
    return jh(t, Object.keys(n).sort());
  });
  return e.sort((t, n) => t.address.localeCompare(n.address)), e;
}
function Oo(r) {
  let e;
  return typeof r == "string" ? e = en.computePublicKey(r, !1) : e = r.publicKey, et(ft("0x" + e.substring(4)).substring(26));
}
function tf(r, e) {
  return Oo(en.recoverPublicKey(r, e));
}
const Gt = BigInt(0), GE = BigInt(2), VE = BigInt(27), $E = BigInt(28), KE = BigInt(35), zE = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), Hh = 4096 * 32;
function wm(r, e) {
  let t = r.toString(16);
  for (; t.length < 2; )
    t = "0" + t;
  return t += nr(e).substring(4), "0x" + t;
}
function Zd(r) {
  return r === "0x" ? null : et(r);
}
function vg(r, e) {
  try {
    return ts(r);
  } catch (t) {
    ue(!1, t.message, e, r);
  }
}
function rf(r, e) {
  return r === "0x" ? 0 : Ve(r, e);
}
function St(r, e) {
  if (r === "0x")
    return Gt;
  const t = De(r, e);
  return ue(t <= zE, "value exceeds uint size", e, t), t;
}
function At(r, e) {
  const t = De(r, "value"), n = Ft(t);
  return ue(n.length <= 32, "value too large", `tx.${e}`, t), n;
}
function kg(r) {
  return ts(r).map((e) => [e.address, e.storageKeys]);
}
function JE(r, e) {
  ue(Array.isArray(r), `invalid ${e}`, "value", r);
  for (let t = 0; t < r.length; t++)
    ue(dt(r[t], 32), "invalid ${ param } hash", `value[${t}]`, r[t]);
  return r;
}
function QE(r) {
  const e = Ru(r);
  ue(Array.isArray(e) && (e.length === 9 || e.length === 6), "invalid field count for legacy transaction", "data", r);
  const t = {
    type: 0,
    nonce: rf(e[0], "nonce"),
    gasPrice: St(e[1], "gasPrice"),
    gasLimit: St(e[2], "gasLimit"),
    to: Zd(e[3]),
    value: St(e[4], "value"),
    data: Oe(e[5]),
    chainId: Gt
  };
  if (e.length === 6)
    return t;
  const n = St(e[6], "v"), s = St(e[7], "r"), i = St(e[8], "s");
  if (s === Gt && i === Gt)
    t.chainId = n;
  else {
    let a = (n - KE) / GE;
    a < Gt && (a = Gt), t.chainId = a, ue(a !== Gt || n === VE || n === $E, "non-canonical legacy v", "v", e[6]), t.signature = Ur.from({
      r: Xr(e[7], 32),
      s: Xr(e[8], 32),
      v: n
    });
  }
  return t;
}
function qE(r, e) {
  const t = [
    At(r.nonce, "nonce"),
    At(r.gasPrice || 0, "gasPrice"),
    At(r.gasLimit, "gasLimit"),
    r.to || "0x",
    At(r.value, "value"),
    r.data
  ];
  let n = Gt;
  if (r.chainId != Gt)
    n = De(r.chainId, "tx.chainId"), ue(!e || e.networkV == null || e.legacyChainId === n, "tx.chainId/sig.v mismatch", "sig", e);
  else if (r.signature) {
    const i = r.signature.legacyChainId;
    i != null && (n = i);
  }
  if (!e)
    return n !== Gt && (t.push(Ft(n)), t.push("0x"), t.push("0x")), Ds(t);
  let s = BigInt(27 + e.yParity);
  return n !== Gt ? s = Ur.getChainIdV(n, e.v) : BigInt(e.v) !== s && ue(!1, "tx.chainId/sig.v mismatch", "sig", e), t.push(Ft(s)), t.push(Ft(e.r)), t.push(Ft(e.s)), Ds(t);
}
function Tg(r, e) {
  let t;
  try {
    if (t = rf(e[0], "yParity"), t !== 0 && t !== 1)
      throw new Error("bad yParity");
  } catch {
    ue(!1, "invalid yParity", "yParity", e[0]);
  }
  const n = Xr(e[1], 32), s = Xr(e[2], 32), i = Ur.from({ r: n, s, yParity: t });
  r.signature = i;
}
function WE(r) {
  const e = Ru(Ce(r).slice(1));
  ue(Array.isArray(e) && (e.length === 9 || e.length === 12), "invalid field count for transaction type: 2", "data", Oe(r));
  const t = {
    type: 2,
    chainId: St(e[0], "chainId"),
    nonce: rf(e[1], "nonce"),
    maxPriorityFeePerGas: St(e[2], "maxPriorityFeePerGas"),
    maxFeePerGas: St(e[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: St(e[4], "gasLimit"),
    to: Zd(e[5]),
    value: St(e[6], "value"),
    data: Oe(e[7]),
    accessList: vg(e[8], "accessList")
  };
  return e.length === 9 || Tg(t, e.slice(9)), t;
}
function YE(r, e) {
  const t = [
    At(r.chainId, "chainId"),
    At(r.nonce, "nonce"),
    At(r.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    At(r.maxFeePerGas || 0, "maxFeePerGas"),
    At(r.gasLimit, "gasLimit"),
    r.to || "0x",
    At(r.value, "value"),
    r.data,
    kg(r.accessList || [])
  ];
  return e && (t.push(At(e.yParity, "yParity")), t.push(Ft(e.r)), t.push(Ft(e.s))), it(["0x02", Ds(t)]);
}
function ZE(r) {
  const e = Ru(Ce(r).slice(1));
  ue(Array.isArray(e) && (e.length === 8 || e.length === 11), "invalid field count for transaction type: 1", "data", Oe(r));
  const t = {
    type: 1,
    chainId: St(e[0], "chainId"),
    nonce: rf(e[1], "nonce"),
    gasPrice: St(e[2], "gasPrice"),
    gasLimit: St(e[3], "gasLimit"),
    to: Zd(e[4]),
    value: St(e[5], "value"),
    data: Oe(e[6]),
    accessList: vg(e[7], "accessList")
  };
  return e.length === 8 || Tg(t, e.slice(8)), t;
}
function XE(r, e) {
  const t = [
    At(r.chainId, "chainId"),
    At(r.nonce, "nonce"),
    At(r.gasPrice || 0, "gasPrice"),
    At(r.gasLimit, "gasLimit"),
    r.to || "0x",
    At(r.value, "value"),
    r.data,
    kg(r.accessList || [])
  ];
  return e && (t.push(At(e.yParity, "recoveryParam")), t.push(Ft(e.r)), t.push(Ft(e.s))), it(["0x01", Ds(t)]);
}
function e7(r) {
  let e = Ru(Ce(r).slice(1)), t = "3", n = null;
  if (e.length === 4 && Array.isArray(e[0])) {
    t = "3 (network format)";
    const i = e[1], a = e[2], o = e[3];
    ue(Array.isArray(i), "invalid network format: blobs not an array", "fields[1]", i), ue(Array.isArray(a), "invalid network format: commitments not an array", "fields[2]", a), ue(Array.isArray(o), "invalid network format: proofs not an array", "fields[3]", o), ue(i.length === a.length, "invalid network format: blobs/commitments length mismatch", "fields", e), ue(i.length === o.length, "invalid network format: blobs/proofs length mismatch", "fields", e), n = [];
    for (let u = 0; u < e[1].length; u++)
      n.push({
        data: i[u],
        commitment: a[u],
        proof: o[u]
      });
    e = e[0];
  }
  ue(Array.isArray(e) && (e.length === 11 || e.length === 14), `invalid field count for transaction type: ${t}`, "data", Oe(r));
  const s = {
    type: 3,
    chainId: St(e[0], "chainId"),
    nonce: rf(e[1], "nonce"),
    maxPriorityFeePerGas: St(e[2], "maxPriorityFeePerGas"),
    maxFeePerGas: St(e[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: St(e[4], "gasLimit"),
    to: Zd(e[5]),
    value: St(e[6], "value"),
    data: Oe(e[7]),
    accessList: vg(e[8], "accessList"),
    maxFeePerBlobGas: St(e[9], "maxFeePerBlobGas"),
    blobVersionedHashes: e[10]
  };
  n && (s.blobs = n), ue(s.to != null, `invalid address for transaction type: ${t}`, "data", r), ue(Array.isArray(s.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", r);
  for (let i = 0; i < s.blobVersionedHashes.length; i++)
    ue(dt(s.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", r);
  return e.length === 11 || Tg(s, e.slice(11)), s;
}
function t7(r, e, t) {
  const n = [
    At(r.chainId, "chainId"),
    At(r.nonce, "nonce"),
    At(r.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    At(r.maxFeePerGas || 0, "maxFeePerGas"),
    At(r.gasLimit, "gasLimit"),
    r.to || bo,
    At(r.value, "value"),
    r.data,
    kg(r.accessList || []),
    At(r.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
    JE(r.blobVersionedHashes || [], "blobVersionedHashes")
  ];
  return e && (n.push(At(e.yParity, "yParity")), n.push(Ft(e.r)), n.push(Ft(e.s)), t) ? it([
    "0x03",
    Ds([
      n,
      t.map((s) => s.data),
      t.map((s) => s.commitment),
      t.map((s) => s.proof)
    ])
  ]) : it(["0x03", Ds(n)]);
}
var Hn, Tc, Bc, Oc, Nc, Sc, Cc, Rc, Ic, _c, Uc, Lc, Wa, di, As, hi, Mc, Gf;
const gs = class gs {
  /**
   *  Creates a new Transaction with default values.
   */
  constructor() {
    Z(this, Mc);
    Z(this, Hn);
    Z(this, Tc);
    Z(this, Bc);
    Z(this, Oc);
    Z(this, Nc);
    Z(this, Sc);
    Z(this, Cc);
    Z(this, Rc);
    Z(this, Ic);
    Z(this, _c);
    Z(this, Uc);
    Z(this, Lc);
    Z(this, Wa);
    Z(this, di);
    Z(this, As);
    Z(this, hi);
    F(this, Hn, null), F(this, Tc, null), F(this, Oc, 0), F(this, Nc, Gt), F(this, Sc, null), F(this, Cc, null), F(this, Rc, null), F(this, Bc, "0x"), F(this, Ic, Gt), F(this, _c, Gt), F(this, Uc, null), F(this, Lc, null), F(this, Wa, null), F(this, di, null), F(this, hi, null), F(this, As, null);
  }
  /**
   *  The transaction type.
   *
   *  If null, the type will be automatically inferred based on
   *  explicit properties.
   */
  get type() {
    return x(this, Hn);
  }
  set type(e) {
    switch (e) {
      case null:
        F(this, Hn, null);
        break;
      case 0:
      case "legacy":
        F(this, Hn, 0);
        break;
      case 1:
      case "berlin":
      case "eip-2930":
        F(this, Hn, 1);
        break;
      case 2:
      case "london":
      case "eip-1559":
        F(this, Hn, 2);
        break;
      case 3:
      case "cancun":
      case "eip-4844":
        F(this, Hn, 3);
        break;
      default:
        ue(!1, "unsupported transaction type", "type", e);
    }
  }
  /**
   *  The name of the transaction type.
   */
  get typeName() {
    switch (this.type) {
      case 0:
        return "legacy";
      case 1:
        return "eip-2930";
      case 2:
        return "eip-1559";
      case 3:
        return "eip-4844";
    }
    return null;
  }
  /**
   *  The ``to`` address for the transaction or ``null`` if the
   *  transaction is an ``init`` transaction.
   */
  get to() {
    const e = x(this, Tc);
    return e == null && this.type === 3 ? bo : e;
  }
  set to(e) {
    F(this, Tc, e == null ? null : et(e));
  }
  /**
   *  The transaction nonce.
   */
  get nonce() {
    return x(this, Oc);
  }
  set nonce(e) {
    F(this, Oc, Ve(e, "value"));
  }
  /**
   *  The gas limit.
   */
  get gasLimit() {
    return x(this, Nc);
  }
  set gasLimit(e) {
    F(this, Nc, De(e));
  }
  /**
   *  The gas price.
   *
   *  On legacy networks this defines the fee that will be paid. On
   *  EIP-1559 networks, this should be ``null``.
   */
  get gasPrice() {
    const e = x(this, Sc);
    return e == null && (this.type === 0 || this.type === 1) ? Gt : e;
  }
  set gasPrice(e) {
    F(this, Sc, e == null ? null : De(e, "gasPrice"));
  }
  /**
   *  The maximum priority fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxPriorityFeePerGas() {
    const e = x(this, Cc);
    return e ?? (this.type === 2 || this.type === 3 ? Gt : null);
  }
  set maxPriorityFeePerGas(e) {
    F(this, Cc, e == null ? null : De(e, "maxPriorityFeePerGas"));
  }
  /**
   *  The maximum total fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxFeePerGas() {
    const e = x(this, Rc);
    return e ?? (this.type === 2 || this.type === 3 ? Gt : null);
  }
  set maxFeePerGas(e) {
    F(this, Rc, e == null ? null : De(e, "maxFeePerGas"));
  }
  /**
   *  The transaction data. For ``init`` transactions this is the
   *  deployment code.
   */
  get data() {
    return x(this, Bc);
  }
  set data(e) {
    F(this, Bc, Oe(e));
  }
  /**
   *  The amount of ether (in wei) to send in this transactions.
   */
  get value() {
    return x(this, Ic);
  }
  set value(e) {
    F(this, Ic, De(e, "value"));
  }
  /**
   *  The chain ID this transaction is valid on.
   */
  get chainId() {
    return x(this, _c);
  }
  set chainId(e) {
    F(this, _c, De(e));
  }
  /**
   *  If signed, the signature for this transaction.
   */
  get signature() {
    return x(this, Uc) || null;
  }
  set signature(e) {
    F(this, Uc, e == null ? null : Ur.from(e));
  }
  /**
   *  The access list.
   *
   *  An access list permits discounted (but pre-paid) access to
   *  bytecode and state variable access within contract execution.
   */
  get accessList() {
    const e = x(this, Lc) || null;
    return e ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
  }
  set accessList(e) {
    F(this, Lc, e == null ? null : ts(e));
  }
  /**
   *  The max fee per blob gas for Cancun transactions.
   */
  get maxFeePerBlobGas() {
    const e = x(this, Wa);
    return e == null && this.type === 3 ? Gt : e;
  }
  set maxFeePerBlobGas(e) {
    F(this, Wa, e == null ? null : De(e, "maxFeePerBlobGas"));
  }
  /**
   *  The BLOb versioned hashes for Cancun transactions.
   */
  get blobVersionedHashes() {
    let e = x(this, di);
    return e == null && this.type === 3 ? [] : e;
  }
  set blobVersionedHashes(e) {
    if (e != null) {
      ue(Array.isArray(e), "blobVersionedHashes must be an Array", "value", e), e = e.slice();
      for (let t = 0; t < e.length; t++)
        ue(dt(e[t], 32), "invalid blobVersionedHash", `value[${t}]`, e[t]);
    }
    F(this, di, e);
  }
  /**
   *  The BLObs for the Transaction, if any.
   *
   *  If ``blobs`` is non-``null``, then the [[seriailized]]
   *  will return the network formatted sidecar, otherwise it
   *  will return the standard [[link-eip-2718]] payload. The
   *  [[unsignedSerialized]] is unaffected regardless.
   *
   *  When setting ``blobs``, either fully valid [[Blob]] objects
   *  may be specified (i.e. correctly padded, with correct
   *  committments and proofs) or a raw [[BytesLike]] may
   *  be provided.
   *
   *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
   *  be already set. The blob will be correctly padded and the
   *  [[KzgLibrary]] will be used to compute the committment and
   *  proof for the blob.
   *
   *  A BLOb is a sequence of field elements, each of which must
   *  be within the BLS field modulo, so some additional processing
   *  may be required to encode arbitrary data to ensure each 32 byte
   *  field is within the valid range.
   *
   *  Setting this automatically populates [[blobVersionedHashes]],
   *  overwriting any existing values. Setting this to ``null``
   *  does **not** remove the [[blobVersionedHashes]], leaving them
   *  present.
   */
  get blobs() {
    return x(this, hi) == null ? null : x(this, hi).map((e) => Object.assign({}, e));
  }
  set blobs(e) {
    if (e == null) {
      F(this, hi, null);
      return;
    }
    const t = [], n = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      if (Su(i)) {
        Ee(x(this, As), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
          operation: "set blobs()"
        });
        let a = Ce(i);
        if (ue(a.length <= Hh, "blob is too large", `blobs[${s}]`, i), a.length !== Hh) {
          const c = new Uint8Array(Hh);
          c.set(a), a = c;
        }
        const o = x(this, As).blobToKzgCommitment(a), u = Oe(x(this, As).computeBlobKzgProof(a, o));
        t.push({
          data: Oe(a),
          commitment: Oe(o),
          proof: u
        }), n.push(wm(1, o));
      } else {
        const a = Oe(i.commitment);
        t.push({
          data: Oe(i.data),
          commitment: a,
          proof: Oe(i.proof)
        }), n.push(wm(1, a));
      }
    }
    F(this, hi, t), F(this, di, n);
  }
  get kzg() {
    return x(this, As);
  }
  set kzg(e) {
    F(this, As, e);
  }
  /**
   *  The transaction hash, if signed. Otherwise, ``null``.
   */
  get hash() {
    return this.signature == null ? null : ft(de(this, Mc, Gf).call(this, !0, !1));
  }
  /**
   *  The pre-image hash of this transaction.
   *
   *  This is the digest that a [[Signer]] must sign to authorize
   *  this transaction.
   */
  get unsignedHash() {
    return ft(this.unsignedSerialized);
  }
  /**
   *  The sending address, if signed. Otherwise, ``null``.
   */
  get from() {
    return this.signature == null ? null : tf(this.unsignedHash, this.signature);
  }
  /**
   *  The public key of the sender, if signed. Otherwise, ``null``.
   */
  get fromPublicKey() {
    return this.signature == null ? null : en.recoverPublicKey(this.unsignedHash, this.signature);
  }
  /**
   *  Returns true if signed.
   *
   *  This provides a Type Guard that properties requiring a signed
   *  transaction are non-null.
   */
  isSigned() {
    return this.signature != null;
  }
  /**
   *  The serialized transaction.
   *
   *  This throws if the transaction is unsigned. For the pre-image,
   *  use [[unsignedSerialized]].
   */
  get serialized() {
    return de(this, Mc, Gf).call(this, !0, !0);
  }
  /**
   *  The transaction pre-image.
   *
   *  The hash of this is the digest which needs to be signed to
   *  authorize this transaction.
   */
  get unsignedSerialized() {
    return de(this, Mc, Gf).call(this, !1, !1);
  }
  /**
   *  Return the most "likely" type; currently the highest
   *  supported transaction type.
   */
  inferType() {
    const e = this.inferTypes();
    return e.indexOf(2) >= 0 ? 2 : e.pop();
  }
  /**
   *  Validates the explicit properties and returns a list of compatible
   *  transaction types.
   */
  inferTypes() {
    const e = this.gasPrice != null, t = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, n = this.accessList != null, s = x(this, Wa) != null || x(this, di);
    this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && Ee(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), Ee(!t || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), Ee(this.type !== 0 || !n, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
    const i = [];
    return this.type != null ? i.push(this.type) : t ? i.push(2) : e ? (i.push(1), n || i.push(0)) : n ? (i.push(1), i.push(2)) : (s && this.to || (i.push(0), i.push(1), i.push(2)), i.push(3)), i.sort(), i;
  }
  /**
   *  Returns true if this transaction is a legacy transaction (i.e.
   *  ``type === 0``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if this transaction is berlin hardform transaction (i.e.
   *  ``type === 1``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if this transaction is london hardform transaction (i.e.
   *  ``type === 2``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if this transaction is an [[link-eip-4844]] BLOB
   *  transaction.
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Create a copy of this transaciton.
   */
  clone() {
    return gs.from(this);
  }
  /**
   *  Return a JSON-friendly object.
   */
  toJSON() {
    const e = (t) => t == null ? null : t.toString();
    return {
      type: this.type,
      to: this.to,
      //            from: this.from,
      data: this.data,
      nonce: this.nonce,
      gasLimit: e(this.gasLimit),
      gasPrice: e(this.gasPrice),
      maxPriorityFeePerGas: e(this.maxPriorityFeePerGas),
      maxFeePerGas: e(this.maxFeePerGas),
      value: e(this.value),
      chainId: e(this.chainId),
      sig: this.signature ? this.signature.toJSON() : null,
      accessList: this.accessList
    };
  }
  /**
   *  Create a **Transaction** from a serialized transaction or a
   *  Transaction-like object.
   */
  static from(e) {
    if (e == null)
      return new gs();
    if (typeof e == "string") {
      const n = Ce(e);
      if (n[0] >= 127)
        return gs.from(QE(n));
      switch (n[0]) {
        case 1:
          return gs.from(ZE(n));
        case 2:
          return gs.from(WE(n));
        case 3:
          return gs.from(e7(n));
      }
      Ee(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
    }
    const t = new gs();
    return e.type != null && (t.type = e.type), e.to != null && (t.to = e.to), e.nonce != null && (t.nonce = e.nonce), e.gasLimit != null && (t.gasLimit = e.gasLimit), e.gasPrice != null && (t.gasPrice = e.gasPrice), e.maxPriorityFeePerGas != null && (t.maxPriorityFeePerGas = e.maxPriorityFeePerGas), e.maxFeePerGas != null && (t.maxFeePerGas = e.maxFeePerGas), e.maxFeePerBlobGas != null && (t.maxFeePerBlobGas = e.maxFeePerBlobGas), e.data != null && (t.data = e.data), e.value != null && (t.value = e.value), e.chainId != null && (t.chainId = e.chainId), e.signature != null && (t.signature = Ur.from(e.signature)), e.accessList != null && (t.accessList = e.accessList), e.blobVersionedHashes != null && (t.blobVersionedHashes = e.blobVersionedHashes), e.kzg != null && (t.kzg = e.kzg), e.blobs != null && (t.blobs = e.blobs), e.hash != null && (ue(t.isSigned(), "unsigned transaction cannot define '.hash'", "tx", e), ue(t.hash === e.hash, "hash mismatch", "tx", e)), e.from != null && (ue(t.isSigned(), "unsigned transaction cannot define '.from'", "tx", e), ue(t.from.toLowerCase() === (e.from || "").toLowerCase(), "from mismatch", "tx", e)), t;
  }
};
Hn = new WeakMap(), Tc = new WeakMap(), Bc = new WeakMap(), Oc = new WeakMap(), Nc = new WeakMap(), Sc = new WeakMap(), Cc = new WeakMap(), Rc = new WeakMap(), Ic = new WeakMap(), _c = new WeakMap(), Uc = new WeakMap(), Lc = new WeakMap(), Wa = new WeakMap(), di = new WeakMap(), As = new WeakMap(), hi = new WeakMap(), Mc = new WeakSet(), Gf = function(e, t) {
  Ee(!e || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  const n = e ? this.signature : null;
  switch (this.inferType()) {
    case 0:
      return qE(this, n);
    case 1:
      return XE(this, n);
    case 2:
      return YE(this, n);
    case 3:
      return t7(this, n, t ? this.blobs : null);
  }
  Ee(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
};
let Ii = gs;
function Xd(r) {
  return typeof r == "string" && (r = It(r)), ft(it([
    It(gg),
    It(String(r.length)),
    r
  ]));
}
function L3(r, e) {
  const t = Xd(r);
  return tf(t, e);
}
const r7 = new RegExp("^bytes([0-9]+)$"), n7 = new RegExp("^(u?int)([0-9]*)$"), s7 = new RegExp("^(.*)\\[([0-9]*)\\]$");
function M3(r, e, t) {
  switch (r) {
    case "address":
      return Ce(t ? Xr(e, 32) : et(e));
    case "string":
      return It(e);
    case "bytes":
      return Ce(e);
    case "bool":
      return e = e ? "0x01" : "0x00", Ce(t ? Xr(e, 32) : e);
  }
  let n = r.match(n7);
  if (n) {
    let s = n[1] === "int", i = parseInt(n[2] || "256");
    return ue((!n[2] || n[2] === String(i)) && i % 8 === 0 && i !== 0 && i <= 256, "invalid number type", "type", r), t && (i = 256), s && (e = Y0(e, i)), Ce(Xr(Ft(e), i / 8));
  }
  if (n = r.match(r7), n) {
    const s = parseInt(n[1]);
    return ue(String(s) === n[1] && s !== 0 && s <= 32, "invalid bytes type", "type", r), ue(Is(e) === s, `invalid value for ${r}`, "value", e), t ? Ce(W0(e, 32)) : e;
  }
  if (n = r.match(s7), n && Array.isArray(e)) {
    const s = n[1], i = parseInt(n[2] || String(e.length));
    ue(i === e.length, `invalid array length for ${r}`, "value", e);
    const a = [];
    return e.forEach(function(o) {
      a.push(M3(s, o, !0));
    }), Ce(it(a));
  }
  ue(!1, "invalid type", "type", r);
}
function eh(r, e) {
  ue(r.length === e.length, "wrong number of values; expected ${ types.length }", "values", e);
  const t = [];
  return r.forEach(function(n, s) {
    t.push(M3(n, e[s]));
  }), Oe(it(t));
}
function F3(r, e) {
  return ft(eh(r, e));
}
function D3(r, e) {
  return nr(eh(r, e));
}
const j3 = new Uint8Array(32);
j3.fill(0);
const i7 = BigInt(-1), H3 = BigInt(0), G3 = BigInt(1), a7 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function o7(r) {
  const e = Ce(r), t = e.length % 32;
  return t ? it([e, j3.slice(t)]) : Oe(e);
}
const c7 = tn(G3, 32), u7 = tn(H3, 32), Am = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, Gh = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function Em(r) {
  return function(e) {
    return ue(typeof e == "string", `invalid domain value for ${JSON.stringify(r)}`, `domain.${r}`, e), e;
  };
}
const l7 = {
  name: Em("name"),
  version: Em("version"),
  chainId: function(r) {
    const e = De(r, "domain.chainId");
    return ue(e >= 0, "invalid chain ID", "domain.chainId", r), Number.isSafeInteger(e) ? Number(e) : Rs(e);
  },
  verifyingContract: function(r) {
    try {
      return et(r).toLowerCase();
    } catch {
    }
    ue(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", r);
  },
  salt: function(r) {
    const e = Ce(r, "domain.salt");
    return ue(e.length === 32, 'invalid domain value "salt"', "domain.salt", r), Oe(e);
  }
};
function Vh(r) {
  {
    const e = r.match(/^(u?)int(\d+)$/);
    if (e) {
      const t = e[1] === "", n = parseInt(e[2]);
      ue(n % 8 === 0 && n !== 0 && n <= 256 && e[2] === String(n), "invalid numeric width", "type", r);
      const s = Cs(a7, t ? n - 1 : n), i = t ? (s + G3) * i7 : H3;
      return function(a) {
        const o = De(a, "value");
        return ue(o >= i && o <= s, `value out-of-bounds for ${r}`, "value", o), tn(t ? Y0(o, 256) : o, 32);
      };
    }
  }
  {
    const e = r.match(/^bytes(\d+)$/);
    if (e) {
      const t = parseInt(e[1]);
      return ue(t !== 0 && t <= 32 && e[1] === String(t), "invalid bytes width", "type", r), function(n) {
        const s = Ce(n);
        return ue(s.length === t, `invalid length for ${r}`, "value", n), o7(n);
      };
    }
  }
  switch (r) {
    case "address":
      return function(e) {
        return Xr(et(e), 32);
      };
    case "bool":
      return function(e) {
        return e ? c7 : u7;
      };
    case "bytes":
      return function(e) {
        return ft(e);
      };
    case "string":
      return function(e) {
        return vn(e);
      };
  }
  return null;
}
function Pm(r, e) {
  return `${r}(${e.map(({ name: t, type: n }) => n + " " + t).join(",")})`;
}
function Tf(r) {
  const e = r.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
  return e ? {
    base: e[1],
    index: e[2] + e[4],
    array: {
      base: e[1],
      prefix: e[1] + e[2],
      count: e[5] ? parseInt(e[5]) : -1
    }
  } : { base: r };
}
var I0, Es, Fc, Rd, V3;
const Vr = class Vr {
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   *
   *  This performs all necessary checking that types are valid and
   *  do not violate the [[link-eip-712]] structural constraints as
   *  well as computes the [[primaryType]].
   */
  constructor(e) {
    Z(this, Rd);
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */
    Q(this, "primaryType");
    Z(this, I0);
    Z(this, Es);
    Z(this, Fc);
    F(this, Es, /* @__PURE__ */ new Map()), F(this, Fc, /* @__PURE__ */ new Map());
    const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = {};
    Object.keys(e).forEach((u) => {
      i[u] = e[u].map(({ name: c, type: l }) => {
        let { base: f, index: d } = Tf(l);
        return f === "int" && !e.int && (f = "int256"), f === "uint" && !e.uint && (f = "uint256"), { name: c, type: f + (d || "") };
      }), t.set(u, /* @__PURE__ */ new Set()), n.set(u, []), s.set(u, /* @__PURE__ */ new Set());
    }), F(this, I0, JSON.stringify(i));
    for (const u in i) {
      const c = /* @__PURE__ */ new Set();
      for (const l of i[u]) {
        ue(!c.has(l.name), `duplicate variable name ${JSON.stringify(l.name)} in ${JSON.stringify(u)}`, "types", e), c.add(l.name);
        const f = Tf(l.type).base;
        ue(f !== u, `circular type reference to ${JSON.stringify(f)}`, "types", e), !Vh(f) && (ue(n.has(f), `unknown type ${JSON.stringify(f)}`, "types", e), n.get(f).push(u), t.get(u).add(f));
      }
    }
    const a = Array.from(n.keys()).filter((u) => n.get(u).length === 0);
    ue(a.length !== 0, "missing primary type", "types", e), ue(a.length === 1, `ambiguous primary types or unused types: ${a.map((u) => JSON.stringify(u)).join(", ")}`, "types", e), _e(this, { primaryType: a[0] });
    function o(u, c) {
      ue(!c.has(u), `circular type reference to ${JSON.stringify(u)}`, "types", e), c.add(u);
      for (const l of t.get(u))
        if (n.has(l)) {
          o(l, c);
          for (const f of c)
            s.get(f).add(l);
        }
      c.delete(u);
    }
    o(this.primaryType, /* @__PURE__ */ new Set());
    for (const [u, c] of s) {
      const l = Array.from(c);
      l.sort(), x(this, Es).set(u, Pm(u, i[u]) + l.map((f) => Pm(f, i[f])).join(""));
    }
  }
  /**
   *  The types.
   */
  get types() {
    return JSON.parse(x(this, I0));
  }
  /**
   *  Returnthe encoder for the specific %%type%%.
   */
  getEncoder(e) {
    let t = x(this, Fc).get(e);
    return t || (t = de(this, Rd, V3).call(this, e), x(this, Fc).set(e, t)), t;
  }
  /**
   *  Return the full type for %%name%%.
   */
  encodeType(e) {
    const t = x(this, Es).get(e);
    return ue(t, `unknown type: ${JSON.stringify(e)}`, "name", e), t;
  }
  /**
   *  Return the encoded %%value%% for the %%type%%.
   */
  encodeData(e, t) {
    return this.getEncoder(e)(t);
  }
  /**
   *  Returns the hash of %%value%% for the type of %%name%%.
   */
  hashStruct(e, t) {
    return ft(this.encodeData(e, t));
  }
  /**
   *  Return the fulled encoded %%value%% for the [[types]].
   */
  encode(e) {
    return this.encodeData(this.primaryType, e);
  }
  /**
   *  Return the hash of the fully encoded %%value%% for the [[types]].
   */
  hash(e) {
    return this.hashStruct(this.primaryType, e);
  }
  /**
   *  @_ignore:
   */
  _visit(e, t, n) {
    if (Vh(e))
      return n(e, t);
    const s = Tf(e).array;
    if (s)
      return ue(s.count === -1 || s.count === t.length, `array length mismatch; expected length ${s.count}`, "value", t), t.map((a) => this._visit(s.prefix, a, n));
    const i = this.types[e];
    if (i)
      return i.reduce((a, { name: o, type: u }) => (a[o] = this._visit(u, t[o], n), a), {});
    ue(!1, `unknown type: ${e}`, "type", e);
  }
  /**
   *  Call %%calback%% for each value in %%value%%, passing the type and
   *  component within %%value%%.
   *
   *  This is useful for replacing addresses or other transformation that
   *  may be desired on each component, based on its type.
   */
  visit(e, t) {
    return this._visit(this.primaryType, e, t);
  }
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   */
  static from(e) {
    return new Vr(e);
  }
  /**
   *  Return the primary type for %%types%%.
   */
  static getPrimaryType(e) {
    return Vr.from(e).primaryType;
  }
  /**
   *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
   */
  static hashStruct(e, t, n) {
    return Vr.from(t).hashStruct(e, n);
  }
  /**
   *  Return the domain hash for %%domain%%.
   */
  static hashDomain(e) {
    const t = [];
    for (const n in e) {
      if (e[n] == null)
        continue;
      const s = Am[n];
      ue(s, `invalid typed-data domain key: ${JSON.stringify(n)}`, "domain", e), t.push({ name: n, type: s });
    }
    return t.sort((n, s) => Gh.indexOf(n.name) - Gh.indexOf(s.name)), Vr.hashStruct("EIP712Domain", { EIP712Domain: t }, e);
  }
  /**
   *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static encode(e, t, n) {
    return it([
      "0x1901",
      Vr.hashDomain(e),
      Vr.from(t).hash(n)
    ]);
  }
  /**
   *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static hash(e, t, n) {
    return ft(Vr.encode(e, t, n));
  }
  // Replaces all address types with ENS names with their looked up address
  /**
   * Resolves to the value from resolving all addresses in %%value%% for
   * %%types%% and the %%domain%%.
   */
  static async resolveNames(e, t, n, s) {
    e = Object.assign({}, e);
    for (const o in e)
      e[o] == null && delete e[o];
    const i = {};
    e.verifyingContract && !dt(e.verifyingContract, 20) && (i[e.verifyingContract] = "0x");
    const a = Vr.from(t);
    a.visit(n, (o, u) => (o === "address" && !dt(u, 20) && (i[u] = "0x"), u));
    for (const o in i)
      i[o] = await s(o);
    return e.verifyingContract && i[e.verifyingContract] && (e.verifyingContract = i[e.verifyingContract]), n = a.visit(n, (o, u) => o === "address" && i[u] ? i[u] : u), { domain: e, value: n };
  }
  /**
   *  Returns the JSON-encoded payload expected by nodes which implement
   *  the JSON-RPC [[link-eip-712]] method.
   */
  static getPayload(e, t, n) {
    Vr.hashDomain(e);
    const s = {}, i = [];
    Gh.forEach((u) => {
      const c = e[u];
      c != null && (s[u] = l7[u](c), i.push({ name: u, type: Am[u] }));
    });
    const a = Vr.from(t);
    t = a.types;
    const o = Object.assign({}, t);
    return ue(o.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", t), o.EIP712Domain = i, a.encode(n), {
      types: o,
      domain: s,
      primaryType: a.primaryType,
      message: a.visit(n, (u, c) => {
        if (u.match(/^bytes(\d*)/))
          return Oe(Ce(c));
        if (u.match(/^u?int/))
          return De(c).toString();
        switch (u) {
          case "address":
            return c.toLowerCase();
          case "bool":
            return !!c;
          case "string":
            return ue(typeof c == "string", "invalid string", "value", c), c;
        }
        ue(!1, "unsupported type", "type", u);
      })
    };
  }
};
I0 = new WeakMap(), Es = new WeakMap(), Fc = new WeakMap(), Rd = new WeakSet(), V3 = function(e) {
  {
    const s = Vh(e);
    if (s)
      return s;
  }
  const t = Tf(e).array;
  if (t) {
    const s = t.prefix, i = this.getEncoder(s);
    return (a) => {
      ue(t.count === -1 || t.count === a.length, `array length mismatch; expected length ${t.count}`, "value", a);
      let o = a.map(i);
      return x(this, Es).has(s) && (o = o.map(ft)), ft(it(o));
    };
  }
  const n = this.types[e];
  if (n) {
    const s = vn(x(this, Es).get(e));
    return (i) => {
      const a = n.map(({ name: o, type: u }) => {
        const c = this.getEncoder(u)(i[o]);
        return x(this, Es).has(u) ? ft(c) : c;
      });
      return a.unshift(s), it(a);
    };
  }
  ue(!1, `unknown type: ${e}`, "type", e);
};
let js = Vr;
function $3(r, e, t, n) {
  return tf(js.hash(r, e, t), n);
}
function ur(r) {
  const e = /* @__PURE__ */ new Set();
  return r.forEach((t) => e.add(t)), Object.freeze(e);
}
const f7 = "external public payable override", d7 = ur(f7.split(" ")), K3 = "constant external internal payable private public pure view override", h7 = ur(K3.split(" ")), z3 = "constructor error event fallback function receive struct", J3 = ur(z3.split(" ")), Q3 = "calldata memory storage payable indexed", p7 = ur(Q3.split(" ")), b7 = "tuple returns", g7 = [z3, Q3, b7, K3].join(" "), x7 = ur(g7.split(" ")), m7 = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, y7 = new RegExp("^(\\s*)"), w7 = new RegExp("^([0-9]+)"), A7 = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), q3 = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), W3 = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var qt, xn, _0, Yp;
const Id = class Id {
  constructor(e) {
    Z(this, _0);
    Z(this, qt);
    Z(this, xn);
    F(this, qt, 0), F(this, xn, e.slice());
  }
  get offset() {
    return x(this, qt);
  }
  get length() {
    return x(this, xn).length - x(this, qt);
  }
  clone() {
    return new Id(x(this, xn));
  }
  reset() {
    F(this, qt, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(e) {
    const t = this.peek();
    if (t.type !== "KEYWORD" || !e.has(t.text))
      throw new Error(`expected keyword ${t.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(e) {
    if (this.peek().type !== e) {
      const t = this.peek();
      throw new Error(`expected ${e}; got ${t.type} ${JSON.stringify(t.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const e = this.peek();
    if (e.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const t = de(this, _0, Yp).call(this, x(this, qt) + 1, e.match + 1);
    return F(this, qt, e.match + 1), t;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const e = this.peek();
    if (e.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const t = [];
    for (; x(this, qt) < e.match - 1; ) {
      const n = this.peek().linkNext;
      t.push(de(this, _0, Yp).call(this, x(this, qt) + 1, n)), F(this, qt, n);
    }
    return F(this, qt, e.match + 1), t;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (x(this, qt) >= x(this, xn).length)
      throw new Error("out-of-bounds");
    return x(this, xn)[x(this, qt)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(e) {
    const t = this.peekType("KEYWORD");
    return t != null && e.has(t) ? t : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(e) {
    if (this.length === 0)
      return null;
    const t = this.peek();
    return t.type === e ? t.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const e = this.peek();
    return rn(this, qt)._++, e;
  }
  toString() {
    const e = [];
    for (let t = x(this, qt); t < x(this, xn).length; t++) {
      const n = x(this, xn)[t];
      e.push(`${n.type}:${n.text}`);
    }
    return `<TokenString ${e.join(" ")}>`;
  }
};
qt = new WeakMap(), xn = new WeakMap(), _0 = new WeakSet(), Yp = function(e = 0, t = 0) {
  return new Id(x(this, xn).slice(e, t).map((n) => Object.freeze(Object.assign({}, n, {
    match: n.match - e,
    linkBack: n.linkBack - e,
    linkNext: n.linkNext - e
  }))));
};
let kn = Id;
function Mi(r) {
  const e = [], t = (a) => {
    const o = i < r.length ? JSON.stringify(r[i]) : "$EOI";
    throw new Error(`invalid token ${o} at ${i}: ${a}`);
  };
  let n = [], s = [], i = 0;
  for (; i < r.length; ) {
    let a = r.substring(i), o = a.match(y7);
    o && (i += o[1].length, a = r.substring(i));
    const u = { depth: n.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: i, value: -1 };
    e.push(u);
    let c = m7[a[0]] || "";
    if (c) {
      if (u.type = c, u.text = a[0], i++, c === "OPEN_PAREN")
        n.push(e.length - 1), s.push(e.length - 1);
      else if (c == "CLOSE_PAREN")
        n.length === 0 && t("no matching open bracket"), u.match = n.pop(), e[u.match].match = e.length - 1, u.depth--, u.linkBack = s.pop(), e[u.linkBack].linkNext = e.length - 1;
      else if (c === "COMMA")
        u.linkBack = s.pop(), e[u.linkBack].linkNext = e.length - 1, s.push(e.length - 1);
      else if (c === "OPEN_BRACKET")
        u.type = "BRACKET";
      else if (c === "CLOSE_BRACKET") {
        let l = e.pop().text;
        if (e.length > 0 && e[e.length - 1].type === "NUMBER") {
          const f = e.pop().text;
          l = f + l, e[e.length - 1].value = Ve(f);
        }
        if (e.length === 0 || e[e.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        e[e.length - 1].text += l;
      }
      continue;
    }
    if (o = a.match(A7), o) {
      if (u.text = o[1], i += u.text.length, x7.has(u.text)) {
        u.type = "KEYWORD";
        continue;
      }
      if (u.text.match(W3)) {
        u.type = "TYPE";
        continue;
      }
      u.type = "ID";
      continue;
    }
    if (o = a.match(w7), o) {
      u.text = o[1], u.type = "NUMBER", i += u.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(a[0])} at position ${i}`);
  }
  return new kn(e.map((a) => Object.freeze(a)));
}
function vm(r, e) {
  let t = [];
  for (const n in e.keys())
    r.has(n) && t.push(n);
  if (t.length > 1)
    throw new Error(`conflicting types: ${t.join(", ")}`);
}
function th(r, e) {
  if (e.peekKeyword(J3)) {
    const t = e.pop().text;
    if (t !== r)
      throw new Error(`expected ${r}, got ${t}`);
  }
  return e.popType("ID");
}
function Hs(r, e) {
  const t = /* @__PURE__ */ new Set();
  for (; ; ) {
    const n = r.peekType("KEYWORD");
    if (n == null || e && !e.has(n))
      break;
    if (r.pop(), t.has(n))
      throw new Error(`duplicate keywords: ${JSON.stringify(n)}`);
    t.add(n);
  }
  return Object.freeze(t);
}
function Y3(r) {
  let e = Hs(r, h7);
  return vm(e, ur("constant payable nonpayable".split(" "))), vm(e, ur("pure view payable nonpayable".split(" "))), e.has("view") ? "view" : e.has("pure") ? "pure" : e.has("payable") ? "payable" : e.has("nonpayable") ? "nonpayable" : e.has("constant") ? "view" : "nonpayable";
}
function _s(r, e) {
  return r.popParams().map((t) => jt.from(t, e));
}
function Z3(r) {
  if (r.peekType("AT")) {
    if (r.pop(), r.peekType("NUMBER"))
      return De(r.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
function go(r) {
  if (r.length)
    throw new Error(`unexpected tokens at offset ${r.offset}: ${r.toString()}`);
}
const E7 = new RegExp(/^(.*)\[([0-9]*)\]$/);
function km(r) {
  const e = r.match(W3);
  if (ue(e, "invalid type", "type", r), r === "uint")
    return "uint256";
  if (r === "int")
    return "int256";
  if (e[2]) {
    const t = parseInt(e[2]);
    ue(t !== 0 && t <= 32, "invalid bytes length", "type", r);
  } else if (e[3]) {
    const t = parseInt(e[3]);
    ue(t !== 0 && t <= 256 && t % 8 === 0, "invalid numeric width", "type", r);
  }
  return r;
}
const Pt = {}, br = Symbol.for("_ethers_internal"), Tm = "_ParamTypeInternal", Bm = "_ErrorInternal", Om = "_EventInternal", Nm = "_ConstructorInternal", Sm = "_FallbackInternal", Cm = "_FunctionInternal", Rm = "_StructInternal";
var Dc, Vf;
const $r = class $r {
  /**
   *  @private
   */
  constructor(e, t, n, s, i, a, o, u) {
    Z(this, Dc);
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */
    Q(this, "name");
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */
    Q(this, "type");
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */
    Q(this, "baseType");
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */
    Q(this, "indexed");
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */
    Q(this, "components");
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */
    Q(this, "arrayLength");
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */
    Q(this, "arrayChildren");
    if (es(e, Pt, "ParamType"), Object.defineProperty(this, br, { value: Tm }), a && (a = Object.freeze(a.slice())), s === "array") {
      if (o == null || u == null)
        throw new Error("");
    } else if (o != null || u != null)
      throw new Error("");
    if (s === "tuple") {
      if (a == null)
        throw new Error("");
    } else if (a != null)
      throw new Error("");
    _e(this, {
      name: t,
      type: n,
      baseType: s,
      indexed: i,
      components: a,
      arrayLength: o,
      arrayChildren: u
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json") {
      const n = this.name || "";
      if (this.isArray()) {
        const i = JSON.parse(this.arrayChildren.format("json"));
        return i.name = n, i.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(i);
      }
      const s = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: n
      };
      return typeof this.indexed == "boolean" && (s.indexed = this.indexed), this.isTuple() && (s.components = this.components.map((i) => JSON.parse(i.format(e)))), JSON.stringify(s);
    }
    let t = "";
    return this.isArray() ? (t += this.arrayChildren.format(e), t += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? t += "(" + this.components.map((n) => n.format(e)).join(e === "full" ? ", " : ",") + ")" : t += this.type, e !== "sighash" && (this.indexed === !0 && (t += " indexed"), e === "full" && this.name && (t += " " + this.name)), t;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(e, t) {
    if (this.isArray()) {
      if (!Array.isArray(e))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && e.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const n = this;
      return e.map((s) => n.arrayChildren.walk(s, t));
    }
    if (this.isTuple()) {
      if (!Array.isArray(e))
        throw new Error("invalid tuple value");
      if (e.length !== this.components.length)
        throw new Error("array is wrong length");
      const n = this;
      return e.map((s, i) => n.components[i].walk(s, t));
    }
    return t(this.type, e);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(e, t) {
    const n = [], s = [e];
    return de(this, Dc, Vf).call(this, n, e, t, (i) => {
      s[0] = i;
    }), n.length && await Promise.all(n), s[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(e, t) {
    if ($r.isParamType(e))
      return e;
    if (typeof e == "string")
      try {
        return $r.from(Mi(e), t);
      } catch {
        ue(!1, "invalid param type", "obj", e);
      }
    else if (e instanceof kn) {
      let o = "", u = "", c = null;
      Hs(e, ur(["tuple"])).has("tuple") || e.peekType("OPEN_PAREN") ? (u = "tuple", c = e.popParams().map((g) => $r.from(g)), o = `tuple(${c.map((g) => g.format()).join(",")})`) : (o = km(e.popType("TYPE")), u = o);
      let l = null, f = null;
      for (; e.length && e.peekType("BRACKET"); ) {
        const g = e.pop();
        l = new $r(Pt, "", o, u, null, c, f, l), f = g.value, o += g.text, u = "array", c = null;
      }
      let d = null;
      if (Hs(e, p7).has("indexed")) {
        if (!t)
          throw new Error("");
        d = !0;
      }
      const p = e.peekType("ID") ? e.pop().text : "";
      if (e.length)
        throw new Error("leftover tokens");
      return new $r(Pt, p, o, u, d, c, f, l);
    }
    const n = e.name;
    ue(!n || typeof n == "string" && n.match(q3), "invalid name", "obj.name", n);
    let s = e.indexed;
    s != null && (ue(t, "parameter cannot be indexed", "obj.indexed", e.indexed), s = !!s);
    let i = e.type, a = i.match(E7);
    if (a) {
      const o = parseInt(a[2] || "-1"), u = $r.from({
        type: a[1],
        components: e.components
      });
      return new $r(Pt, n || "", i, "array", s, null, o, u);
    }
    if (i === "tuple" || i.startsWith(
      "tuple("
      /* fix: ) */
    ) || i.startsWith(
      "("
      /* fix: ) */
    )) {
      const o = e.components != null ? e.components.map((c) => $r.from(c)) : null;
      return new $r(Pt, n || "", i, "tuple", s, o, null, null);
    }
    return i = km(e.type), new $r(Pt, n || "", i, i, s, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(e) {
    return e && e[br] === Tm;
  }
};
Dc = new WeakSet(), Vf = function(e, t, n, s) {
  if (this.isArray()) {
    if (!Array.isArray(t))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && t.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const a = this.arrayChildren, o = t.slice();
    o.forEach((u, c) => {
      var l;
      de(l = a, Dc, Vf).call(l, e, u, n, (f) => {
        o[c] = f;
      });
    }), s(o);
    return;
  }
  if (this.isTuple()) {
    const a = this.components;
    let o;
    if (Array.isArray(t))
      o = t.slice();
    else {
      if (t == null || typeof t != "object")
        throw new Error("invalid tuple value");
      o = a.map((u) => {
        if (!u.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(u.name in t))
          throw new Error(`missing value for component ${u.name}`);
        return t[u.name];
      });
    }
    if (o.length !== this.components.length)
      throw new Error("array is wrong length");
    o.forEach((u, c) => {
      var l;
      de(l = a[c], Dc, Vf).call(l, e, u, n, (f) => {
        o[c] = f;
      });
    }), s(o);
    return;
  }
  const i = n(this.type, t);
  i.then ? e.push(async function() {
    s(await i);
  }()) : s(i);
};
let jt = $r;
class Gs {
  /**
   *  @private
   */
  constructor(e, t, n) {
    /**
     *  The type of the fragment.
     */
    Q(this, "type");
    /**
     *  The inputs for the fragment.
     */
    Q(this, "inputs");
    es(e, Pt, "Fragment"), n = Object.freeze(n.slice()), _e(this, { type: t, inputs: n });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(e) {
    if (typeof e == "string") {
      try {
        Gs.from(JSON.parse(e));
      } catch {
      }
      return Gs.from(Mi(e));
    }
    if (e instanceof kn)
      switch (e.peekKeyword(J3)) {
        case "constructor":
          return En.from(e);
        case "error":
          return rr.from(e);
        case "event":
          return Yr.from(e);
        case "fallback":
        case "receive":
          return wn.from(e);
        case "function":
          return Zr.from(e);
        case "struct":
          return Us.from(e);
      }
    else if (typeof e == "object") {
      switch (e.type) {
        case "constructor":
          return En.from(e);
        case "error":
          return rr.from(e);
        case "event":
          return Yr.from(e);
        case "fallback":
        case "receive":
          return wn.from(e);
        case "function":
          return Zr.from(e);
        case "struct":
          return Us.from(e);
      }
      Ee(!1, `unsupported type: ${e.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    ue(!1, "unsupported frgament object", "obj", e);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(e) {
    return En.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(e) {
    return rr.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(e) {
    return Yr.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(e) {
    return Zr.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(e) {
    return Us.isFragment(e);
  }
}
class _u extends Gs {
  /**
   *  @private
   */
  constructor(t, n, s, i) {
    super(t, n, i);
    /**
     *  The name of the fragment.
     */
    Q(this, "name");
    ue(typeof s == "string" && s.match(q3), "invalid identifier", "name", s), i = Object.freeze(i.slice()), _e(this, { name: s });
  }
}
function B0(r, e) {
  return "(" + e.map((t) => t.format(r)).join(r === "full" ? ", " : ",") + ")";
}
class rr extends _u {
  /**
   *  @private
   */
  constructor(e, t, n) {
    super(e, "error", t, n), Object.defineProperty(this, br, { value: Bm });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return vn(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((n) => JSON.parse(n.format(e)))
      });
    const t = [];
    return e !== "sighash" && t.push("error"), t.push(this.name + B0(e, this.inputs)), t.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(e) {
    if (rr.isFragment(e))
      return e;
    if (typeof e == "string")
      return rr.from(Mi(e));
    if (e instanceof kn) {
      const t = th("error", e), n = _s(e);
      return go(e), new rr(Pt, t, n);
    }
    return new rr(Pt, e.name, e.inputs ? e.inputs.map(jt.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(e) {
    return e && e[br] === Bm;
  }
}
class Yr extends _u {
  /**
   *  @private
   */
  constructor(t, n, s, i) {
    super(t, "event", n, s);
    /**
     *  Whether this event is anonymous.
     */
    Q(this, "anonymous");
    Object.defineProperty(this, br, { value: Om }), _e(this, { anonymous: i });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return vn(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((s) => JSON.parse(s.format(t)))
      });
    const n = [];
    return t !== "sighash" && n.push("event"), n.push(this.name + B0(t, this.inputs)), t !== "sighash" && this.anonymous && n.push("anonymous"), n.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(t, n) {
    return n = (n || []).map((i) => jt.from(i)), new Yr(Pt, t, n, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(t) {
    if (Yr.isFragment(t))
      return t;
    if (typeof t == "string")
      try {
        return Yr.from(Mi(t));
      } catch {
        ue(!1, "invalid event fragment", "obj", t);
      }
    else if (t instanceof kn) {
      const n = th("event", t), s = _s(t, !0), i = !!Hs(t, ur(["anonymous"])).has("anonymous");
      return go(t), new Yr(Pt, n, s, i);
    }
    return new Yr(Pt, t.name, t.inputs ? t.inputs.map((n) => jt.from(n, !0)) : [], !!t.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(t) {
    return t && t[br] === Om;
  }
}
class En extends Gs {
  /**
   *  @private
   */
  constructor(t, n, s, i, a) {
    super(t, n, s);
    /**
     *  Whether the constructor can receive an endowment.
     */
    Q(this, "payable");
    /**
     *  The recommended gas limit for deployment or ``null``.
     */
    Q(this, "gas");
    Object.defineProperty(this, br, { value: Nm }), _e(this, { payable: i, gas: a });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(t) {
    if (Ee(t != null && t !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), t === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((s) => JSON.parse(s.format(t)))
      });
    const n = [`constructor${B0(t, this.inputs)}`];
    return this.payable && n.push("payable"), this.gas != null && n.push(`@${this.gas.toString()}`), n.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(t) {
    if (En.isFragment(t))
      return t;
    if (typeof t == "string")
      try {
        return En.from(Mi(t));
      } catch {
        ue(!1, "invalid constuctor fragment", "obj", t);
      }
    else if (t instanceof kn) {
      Hs(t, ur(["constructor"]));
      const n = _s(t), s = !!Hs(t, d7).has("payable"), i = Z3(t);
      return go(t), new En(Pt, "constructor", n, s, i);
    }
    return new En(Pt, "constructor", t.inputs ? t.inputs.map(jt.from) : [], !!t.payable, t.gas != null ? t.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(t) {
    return t && t[br] === Nm;
  }
}
class wn extends Gs {
  constructor(t, n, s) {
    super(t, "fallback", n);
    /**
     *  If the function can be sent value during invocation.
     */
    Q(this, "payable");
    Object.defineProperty(this, br, { value: Sm }), _e(this, { payable: s });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(t) {
    const n = this.inputs.length === 0 ? "receive" : "fallback";
    if (t === "json") {
      const s = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type: n, stateMutability: s });
    }
    return `${n}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(t) {
    if (wn.isFragment(t))
      return t;
    if (typeof t == "string")
      try {
        return wn.from(Mi(t));
      } catch {
        ue(!1, "invalid fallback fragment", "obj", t);
      }
    else if (t instanceof kn) {
      const n = t.toString(), s = t.peekKeyword(ur(["fallback", "receive"]));
      if (ue(s, "type must be fallback or receive", "obj", n), t.popKeyword(ur(["fallback", "receive"])) === "receive") {
        const u = _s(t);
        return ue(u.length === 0, "receive cannot have arguments", "obj.inputs", u), Hs(t, ur(["payable"])), go(t), new wn(Pt, [], !0);
      }
      let a = _s(t);
      a.length ? ue(a.length === 1 && a[0].type === "bytes", "invalid fallback inputs", "obj.inputs", a.map((u) => u.format("minimal")).join(", ")) : a = [jt.from("bytes")];
      const o = Y3(t);
      if (ue(o === "nonpayable" || o === "payable", "fallback cannot be constants", "obj.stateMutability", o), Hs(t, ur(["returns"])).has("returns")) {
        const u = _s(t);
        ue(u.length === 1 && u[0].type === "bytes", "invalid fallback outputs", "obj.outputs", u.map((c) => c.format("minimal")).join(", "));
      }
      return go(t), new wn(Pt, a, o === "payable");
    }
    if (t.type === "receive")
      return new wn(Pt, [], !0);
    if (t.type === "fallback") {
      const n = [jt.from("bytes")], s = t.stateMutability === "payable";
      return new wn(Pt, n, s);
    }
    ue(!1, "invalid fallback description", "obj", t);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(t) {
    return t && t[br] === Sm;
  }
}
class Zr extends _u {
  /**
   *  @private
   */
  constructor(t, n, s, i, a, o) {
    super(t, "function", n, i);
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */
    Q(this, "constant");
    /**
     *  The returned types for the result of calling this function.
     */
    Q(this, "outputs");
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */
    Q(this, "stateMutability");
    /**
     *  If the function can be sent value during invocation.
     */
    Q(this, "payable");
    /**
     *  The recommended gas limit to send when calling this function.
     */
    Q(this, "gas");
    Object.defineProperty(this, br, { value: Cm }), a = Object.freeze(a.slice()), _e(this, { constant: s === "view" || s === "pure", gas: o, outputs: a, payable: s === "payable", stateMutability: s });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return vn(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((s) => JSON.parse(s.format(t))),
        outputs: this.outputs.map((s) => JSON.parse(s.format(t)))
      });
    const n = [];
    return t !== "sighash" && n.push("function"), n.push(this.name + B0(t, this.inputs)), t !== "sighash" && (this.stateMutability !== "nonpayable" && n.push(this.stateMutability), this.outputs && this.outputs.length && (n.push("returns"), n.push(B0(t, this.outputs))), this.gas != null && n.push(`@${this.gas.toString()}`)), n.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(t, n) {
    return n = (n || []).map((i) => jt.from(i)), new Zr(Pt, t, "view", n, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(t) {
    if (Zr.isFragment(t))
      return t;
    if (typeof t == "string")
      try {
        return Zr.from(Mi(t));
      } catch {
        ue(!1, "invalid function fragment", "obj", t);
      }
    else if (t instanceof kn) {
      const s = th("function", t), i = _s(t), a = Y3(t);
      let o = [];
      Hs(t, ur(["returns"])).has("returns") && (o = _s(t));
      const u = Z3(t);
      return go(t), new Zr(Pt, s, a, i, o, u);
    }
    let n = t.stateMutability;
    return n == null && (n = "payable", typeof t.constant == "boolean" ? (n = "view", t.constant || (n = "payable", typeof t.payable == "boolean" && !t.payable && (n = "nonpayable"))) : typeof t.payable == "boolean" && !t.payable && (n = "nonpayable")), new Zr(Pt, t.name, n, t.inputs ? t.inputs.map(jt.from) : [], t.outputs ? t.outputs.map(jt.from) : [], t.gas != null ? t.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(t) {
    return t && t[br] === Cm;
  }
}
class Us extends _u {
  /**
   *  @private
   */
  constructor(e, t, n) {
    super(e, "struct", t, n), Object.defineProperty(this, br, { value: Rm });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(e) {
    if (typeof e == "string")
      try {
        return Us.from(Mi(e));
      } catch {
        ue(!1, "invalid struct fragment", "obj", e);
      }
    else if (e instanceof kn) {
      const t = th("struct", e), n = _s(e);
      return go(e), new Us(Pt, t, n);
    }
    return new Us(Pt, e.name, e.inputs ? e.inputs.map(jt.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(e) {
    return e && e[br] === Rm;
  }
}
const Nn = /* @__PURE__ */ new Map();
Nn.set(0, "GENERIC_PANIC");
Nn.set(1, "ASSERT_FALSE");
Nn.set(17, "OVERFLOW");
Nn.set(18, "DIVIDE_BY_ZERO");
Nn.set(33, "ENUM_RANGE_ERROR");
Nn.set(34, "BAD_STORAGE_DATA");
Nn.set(49, "STACK_UNDERFLOW");
Nn.set(50, "ARRAY_RANGE_ERROR");
Nn.set(65, "OUT_OF_MEMORY");
Nn.set(81, "UNINITIALIZED_FUNCTION_CALL");
const P7 = new RegExp(/^bytes([0-9]*)$/), v7 = new RegExp(/^(u?int)([0-9]*)$/);
let $h = null, Im = 1024;
function k7(r, e, t, n) {
  let s = "missing revert data", i = null;
  const a = null;
  let o = null;
  if (t) {
    s = "execution reverted";
    const c = Ce(t);
    if (t = Oe(t), c.length === 0)
      s += " (no data present; likely require(false) occurred", i = "require(false)";
    else if (c.length % 32 !== 4)
      s += " (could not decode reason; invalid data length)";
    else if (Oe(c.slice(0, 4)) === "0x08c379a0")
      try {
        i = n.decode(["string"], c.slice(4))[0], o = {
          signature: "Error(string)",
          name: "Error",
          args: [i]
        }, s += `: ${JSON.stringify(i)}`;
      } catch {
        s += " (could not decode reason; invalid string data)";
      }
    else if (Oe(c.slice(0, 4)) === "0x4e487b71")
      try {
        const l = Number(n.decode(["uint256"], c.slice(4))[0]);
        o = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [l]
        }, i = `Panic due to ${Nn.get(l) || "UNKNOWN"}(${l})`, s += `: ${i}`;
      } catch {
        s += " (could not decode panic code)";
      }
    else
      s += " (unknown custom error)";
  }
  const u = {
    to: e.to ? et(e.to) : null,
    data: e.data || "0x"
  };
  return e.from && (u.from = et(e.from)), xt(s, "CALL_EXCEPTION", {
    action: r,
    data: t,
    reason: i,
    transaction: u,
    invocation: a,
    revert: o
  });
}
var pi, tc;
const _d = class _d {
  constructor() {
    Z(this, pi);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(e) {
    const t = e.map((s) => de(this, pi, tc).call(this, jt.from(s)));
    return new kf(t, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(e, t) {
    Dd(t.length, e.length, "types/values length mismatch");
    const n = e.map((a) => de(this, pi, tc).call(this, jt.from(a))), s = new kf(n, "_"), i = new Fp();
    return s.encode(i, t), i.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(e, t, n) {
    const s = e.map((a) => de(this, pi, tc).call(this, jt.from(a)));
    return new kf(s, "_").decode(new Dp(t, n, Im));
  }
  static _setDefaultMaxInflation(e) {
    ue(typeof e == "number" && Number.isInteger(e), "invalid defaultMaxInflation factor", "value", e), Im = e;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return $h == null && ($h = new _d()), $h;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(e, t, n) {
    return k7(e, t, n, _d.defaultAbiCoder());
  }
};
pi = new WeakSet(), tc = function(e) {
  if (e.isArray())
    return new q5(de(this, pi, tc).call(this, e.arrayChildren), e.arrayLength, e.name);
  if (e.isTuple())
    return new kf(e.components.map((n) => de(this, pi, tc).call(this, n)), e.name);
  switch (e.baseType) {
    case "address":
      return new J5(e.name);
    case "bool":
      return new W5(e.name);
    case "string":
      return new iE(e.name);
    case "bytes":
      return new Y5(e.name);
    case "":
      return new eE(e.name);
  }
  let t = e.type.match(v7);
  if (t) {
    let n = parseInt(t[2] || "256");
    return ue(n !== 0 && n <= 256 && n % 8 === 0, "invalid " + t[1] + " bit length", "param", e), new sE(n / 8, t[1] === "int", e.name);
  }
  if (t = e.type.match(P7), t) {
    let n = parseInt(t[1]);
    return ue(n !== 0 && n <= 32, "invalid bytes length", "param", e), new Z5(n, e.name);
  }
  ue(!1, "invalid type", "type", e.type);
};
let _i = _d;
function X3(r) {
  const e = It(r);
  if (e.length > 31)
    throw new Error("bytes32 string must be less than 32 bytes");
  return W0(e, 32);
}
function e4(r) {
  const e = Ce(r, "bytes");
  if (e.length !== 32)
    throw new Error("invalid bytes32 - not 32 bytes long");
  if (e[31] !== 0)
    throw new Error("invalid bytes32 string - no null terminator");
  let t = 31;
  for (; e[t - 1] === 0; )
    t--;
  return Fs(e.slice(0, t));
}
class Bg {
  /**
   *  @_ignore:
   */
  constructor(e, t, n) {
    /**
     *  The matching fragment for the ``topic0``.
     */
    Q(this, "fragment");
    /**
     *  The name of the Event.
     */
    Q(this, "name");
    /**
     *  The full Event signature.
     */
    Q(this, "signature");
    /**
     *  The topic hash for the Event.
     */
    Q(this, "topic");
    /**
     *  The arguments passed into the Event with ``emit``.
     */
    Q(this, "args");
    const s = e.name, i = e.format();
    _e(this, {
      fragment: e,
      name: s,
      signature: i,
      topic: t,
      args: n
    });
  }
}
class Og {
  /**
   *  @_ignore:
   */
  constructor(e, t, n, s) {
    /**
     *  The matching fragment from the transaction ``data``.
     */
    Q(this, "fragment");
    /**
     *  The name of the Function from the transaction ``data``.
     */
    Q(this, "name");
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */
    Q(this, "args");
    /**
     *  The full Function signature from the transaction ``data``.
     */
    Q(this, "signature");
    /**
     *  The selector for the Function from the transaction ``data``.
     */
    Q(this, "selector");
    /**
     *  The ``value`` (in wei) from the transaction.
     */
    Q(this, "value");
    const i = e.name, a = e.format();
    _e(this, {
      fragment: e,
      name: i,
      args: n,
      signature: a,
      selector: t,
      value: s
    });
  }
}
class Ng {
  /**
   *  @_ignore:
   */
  constructor(e, t, n) {
    /**
     *  The matching fragment.
     */
    Q(this, "fragment");
    /**
     *  The name of the Error.
     */
    Q(this, "name");
    /**
     *  The arguments passed to the Error with ``revert``.
     */
    Q(this, "args");
    /**
     *  The full Error signature.
     */
    Q(this, "signature");
    /**
     *  The selector for the Error.
     */
    Q(this, "selector");
    const s = e.name, i = e.format();
    _e(this, {
      fragment: e,
      name: s,
      args: n,
      signature: i,
      selector: t
    });
  }
}
class pd {
  /**
   *  @_ignore:
   */
  constructor(e) {
    /**
     *  The ``keccak256`` of the value logged.
     */
    Q(this, "hash");
    /**
     *  @_ignore:
     */
    Q(this, "_isIndexed");
    _e(this, { hash: e, _isIndexed: !0 });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(e) {
    return !!(e && e._isIndexed);
  }
}
const _m = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, Um = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (r) => `reverted with reason string ${JSON.stringify(r)}`
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (r) => {
      let e = "unknown panic code";
      return r >= 0 && r <= 255 && _m[r.toString()] && (e = _m[r.toString()]), `reverted with panic code 0x${r.toString(16)} (${e})`;
    }
  }
};
var Gn, Vn, $n, Xt, Zn, $f, Kf;
const _a = class _a {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(e) {
    Z(this, Zn);
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */
    Q(this, "fragments");
    /**
     *  The Contract constructor.
     */
    Q(this, "deploy");
    /**
     *  The Fallback method, if any.
     */
    Q(this, "fallback");
    /**
     *  If receiving ether is supported.
     */
    Q(this, "receive");
    Z(this, Gn);
    Z(this, Vn);
    Z(this, $n);
    //    #structs: Map<string, StructFragment>;
    Z(this, Xt);
    let t = [];
    typeof e == "string" ? t = JSON.parse(e) : t = e, F(this, $n, /* @__PURE__ */ new Map()), F(this, Gn, /* @__PURE__ */ new Map()), F(this, Vn, /* @__PURE__ */ new Map());
    const n = [];
    for (const a of t)
      try {
        n.push(Gs.from(a));
      } catch (o) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, o.message);
      }
    _e(this, {
      fragments: Object.freeze(n)
    });
    let s = null, i = !1;
    F(this, Xt, this.getAbiCoder()), this.fragments.forEach((a, o) => {
      let u;
      switch (a.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          _e(this, { deploy: a });
          return;
        case "fallback":
          a.inputs.length === 0 ? i = !0 : (ue(!s || a.payable !== s.payable, "conflicting fallback fragments", `fragments[${o}]`, a), s = a, i = s.payable);
          return;
        case "function":
          u = x(this, $n);
          break;
        case "event":
          u = x(this, Vn);
          break;
        case "error":
          u = x(this, Gn);
          break;
        default:
          return;
      }
      const c = a.format();
      u.has(c) || u.set(c, a);
    }), this.deploy || _e(this, {
      deploy: En.from("constructor()")
    }), _e(this, { fallback: s, receive: i });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(e) {
    const t = e ? "minimal" : "full";
    return this.fragments.map((s) => s.format(t));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const e = this.fragments.map((t) => t.format("json"));
    return JSON.stringify(e.map((t) => JSON.parse(t)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return _i.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(e) {
    const t = de(this, Zn, $f).call(this, e, null, !1);
    return ue(t, "no matching function", "key", e), t.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(e) {
    return !!de(this, Zn, $f).call(this, e, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(e, t) {
    return de(this, Zn, $f).call(this, e, t || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(e) {
    const t = Array.from(x(this, $n).keys());
    t.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      e(x(this, $n).get(s), n);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(e) {
    const t = de(this, Zn, Kf).call(this, e, null, !1);
    return ue(t, "no matching event", "key", e), t.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(e) {
    return !!de(this, Zn, Kf).call(this, e, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(e, t) {
    return de(this, Zn, Kf).call(this, e, t || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(e) {
    const t = Array.from(x(this, Vn).keys());
    t.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      e(x(this, Vn).get(s), n);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(e, t) {
    if (dt(e)) {
      const s = e.toLowerCase();
      if (Um[s])
        return rr.from(Um[s].signature);
      for (const i of x(this, Gn).values())
        if (s === i.selector)
          return i;
      return null;
    }
    if (e.indexOf("(") === -1) {
      const s = [];
      for (const [i, a] of x(this, Gn))
        i.split(
          "("
          /* fix:) */
        )[0] === e && s.push(a);
      if (s.length === 0)
        return e === "Error" ? rr.from("error Error(string)") : e === "Panic" ? rr.from("error Panic(uint256)") : null;
      if (s.length > 1) {
        const i = s.map((a) => JSON.stringify(a.format())).join(", ");
        ue(!1, `ambiguous error description (i.e. ${i})`, "name", e);
      }
      return s[0];
    }
    if (e = rr.from(e).format(), e === "Error(string)")
      return rr.from("error Error(string)");
    if (e === "Panic(uint256)")
      return rr.from("error Panic(uint256)");
    const n = x(this, Gn).get(e);
    return n || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(e) {
    const t = Array.from(x(this, Gn).keys());
    t.sort((n, s) => n.localeCompare(s));
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      e(x(this, Gn).get(s), n);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(e, t) {
    return x(this, Xt).decode(e, t);
  }
  _encodeParams(e, t) {
    return x(this, Xt).encode(e, t);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(e) {
    return this._encodeParams(this.deploy.inputs, e || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(e, t) {
    if (typeof e == "string") {
      const n = this.getError(e);
      ue(n, "unknown error", "fragment", e), e = n;
    }
    return ue(lt(t, 0, 4) === e.selector, `data signature does not match error ${e.name}.`, "data", t), this._decodeParams(e.inputs, lt(t, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(e, t) {
    if (typeof e == "string") {
      const n = this.getError(e);
      ue(n, "unknown error", "fragment", e), e = n;
    }
    return it([
      e.selector,
      this._encodeParams(e.inputs, t || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(e, t) {
    if (typeof e == "string") {
      const n = this.getFunction(e);
      ue(n, "unknown function", "fragment", e), e = n;
    }
    return ue(lt(t, 0, 4) === e.selector, `data signature does not match function ${e.name}.`, "data", t), this._decodeParams(e.inputs, lt(t, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(e, t) {
    if (typeof e == "string") {
      const n = this.getFunction(e);
      ue(n, "unknown function", "fragment", e), e = n;
    }
    return it([
      e.selector,
      this._encodeParams(e.inputs, t || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(e, t) {
    if (typeof e == "string") {
      const i = this.getFunction(e);
      ue(i, "unknown function", "fragment", e), e = i;
    }
    let n = "invalid length for result data";
    const s = Mt(t);
    if (s.length % 32 === 0)
      try {
        return x(this, Xt).decode(e.outputs, s);
      } catch {
        n = "could not decode result data";
      }
    Ee(!1, n, "BAD_DATA", {
      value: Oe(s),
      info: { method: e.name, signature: e.format() }
    });
  }
  makeError(e, t) {
    const n = Ce(e, "data"), s = _i.getBuiltinCallException("call", t, n);
    if (s.message.startsWith("execution reverted (unknown custom error)")) {
      const o = Oe(n.slice(0, 4)), u = this.getError(o);
      if (u)
        try {
          const c = x(this, Xt).decode(u.inputs, n.slice(4));
          s.revert = {
            name: u.name,
            signature: u.format(),
            args: c
          }, s.reason = s.revert.signature, s.message = `execution reverted: ${s.reason}`;
        } catch {
          s.message = "execution reverted (coult not decode custom error)";
        }
    }
    const a = this.parseTransaction(t);
    return a && (s.invocation = {
      method: a.name,
      signature: a.signature,
      args: a.args
    }), s;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(e, t) {
    if (typeof e == "string") {
      const n = this.getFunction(e);
      ue(n, "unknown function", "fragment", e), e = n;
    }
    return Oe(x(this, Xt).encode(e.outputs, t || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(e, t) {
    if (typeof e == "string") {
      const i = this.getEvent(e);
      ue(i, "unknown event", "eventFragment", e), e = i;
    }
    Ee(t.length <= e.inputs.length, `too many arguments for ${e.format()}`, "UNEXPECTED_ARGUMENT", { count: t.length, expectedCount: e.inputs.length });
    const n = [];
    e.anonymous || n.push(e.topicHash);
    const s = (i, a) => i.type === "string" ? vn(a) : i.type === "bytes" ? ft(Oe(a)) : (i.type === "bool" && typeof a == "boolean" ? a = a ? "0x01" : "0x00" : i.type.match(/^u?int/) ? a = tn(a) : i.type.match(/^bytes/) ? a = W0(a, 32) : i.type === "address" && x(this, Xt).encode(["address"], [a]), Xr(Oe(a), 32));
    for (t.forEach((i, a) => {
      const o = e.inputs[a];
      if (!o.indexed) {
        ue(i == null, "cannot filter non-indexed parameters; must be null", "contract." + o.name, i);
        return;
      }
      i == null ? n.push(null) : o.baseType === "array" || o.baseType === "tuple" ? ue(!1, "filtering with tuples or arrays not supported", "contract." + o.name, i) : Array.isArray(i) ? n.push(i.map((u) => s(o, u))) : n.push(s(o, i));
    }); n.length && n[n.length - 1] === null; )
      n.pop();
    return n;
  }
  encodeEventLog(e, t) {
    if (typeof e == "string") {
      const a = this.getEvent(e);
      ue(a, "unknown event", "eventFragment", e), e = a;
    }
    const n = [], s = [], i = [];
    return e.anonymous || n.push(e.topicHash), ue(t.length === e.inputs.length, "event arguments/values mismatch", "values", t), e.inputs.forEach((a, o) => {
      const u = t[o];
      if (a.indexed)
        if (a.type === "string")
          n.push(vn(u));
        else if (a.type === "bytes")
          n.push(ft(u));
        else {
          if (a.baseType === "tuple" || a.baseType === "array")
            throw new Error("not implemented");
          n.push(x(this, Xt).encode([a.type], [u]));
        }
      else
        s.push(a), i.push(u);
    }), {
      data: x(this, Xt).encode(s, i),
      topics: n
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(e, t, n) {
    if (typeof e == "string") {
      const h = this.getEvent(e);
      ue(h, "unknown event", "eventFragment", e), e = h;
    }
    if (n != null && !e.anonymous) {
      const h = e.topicHash;
      ue(dt(n[0], 32) && n[0].toLowerCase() === h, "fragment/topic mismatch", "topics[0]", n[0]), n = n.slice(1);
    }
    const s = [], i = [], a = [];
    e.inputs.forEach((h, p) => {
      h.indexed ? h.type === "string" || h.type === "bytes" || h.baseType === "tuple" || h.baseType === "array" ? (s.push(jt.from({ type: "bytes32", name: h.name })), a.push(!0)) : (s.push(h), a.push(!1)) : (i.push(h), a.push(!1));
    });
    const o = n != null ? x(this, Xt).decode(s, it(n)) : null, u = x(this, Xt).decode(i, t, !0), c = [], l = [];
    let f = 0, d = 0;
    return e.inputs.forEach((h, p) => {
      let g = null;
      if (h.indexed)
        if (o == null)
          g = new pd(null);
        else if (a[p])
          g = new pd(o[d++]);
        else
          try {
            g = o[d++];
          } catch (k) {
            g = k;
          }
      else
        try {
          g = u[f++];
        } catch (k) {
          g = k;
        }
      c.push(g), l.push(h.name || null);
    }), Ri.fromItems(c, l);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(e) {
    const t = Ce(e.data, "tx.data"), n = De(e.value != null ? e.value : 0, "tx.value"), s = this.getFunction(Oe(t.slice(0, 4)));
    if (!s)
      return null;
    const i = x(this, Xt).decode(s.inputs, t.slice(4));
    return new Og(s, s.selector, i, n);
  }
  parseCallResult(e) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(e) {
    const t = this.getEvent(e.topics[0]);
    return !t || t.anonymous ? null : new Bg(t, t.topicHash, this.decodeEventLog(t, e.data, e.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(e) {
    const t = Oe(e), n = this.getError(lt(t, 0, 4));
    if (!n)
      return null;
    const s = x(this, Xt).decode(n.inputs, lt(t, 4));
    return new Ng(n, n.selector, s);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(e) {
    return e instanceof _a ? e : typeof e == "string" ? new _a(JSON.parse(e)) : typeof e.formatJson == "function" ? new _a(e.formatJson()) : typeof e.format == "function" ? new _a(e.format("json")) : new _a(e);
  }
};
Gn = new WeakMap(), Vn = new WeakMap(), $n = new WeakMap(), Xt = new WeakMap(), Zn = new WeakSet(), // Find a function definition by any means necessary (unless it is ambiguous)
$f = function(e, t, n) {
  if (dt(e)) {
    const i = e.toLowerCase();
    for (const a of x(this, $n).values())
      if (i === a.selector)
        return a;
    return null;
  }
  if (e.indexOf("(") === -1) {
    const i = [];
    for (const [a, o] of x(this, $n))
      a.split(
        "("
        /* fix:) */
      )[0] === e && i.push(o);
    if (t) {
      const a = t.length > 0 ? t[t.length - 1] : null;
      let o = t.length, u = !0;
      $t.isTyped(a) && a.type === "overrides" && (u = !1, o--);
      for (let c = i.length - 1; c >= 0; c--) {
        const l = i[c].inputs.length;
        l !== o && (!u || l !== o - 1) && i.splice(c, 1);
      }
      for (let c = i.length - 1; c >= 0; c--) {
        const l = i[c].inputs;
        for (let f = 0; f < t.length; f++)
          if ($t.isTyped(t[f])) {
            if (f >= l.length) {
              if (t[f].type === "overrides")
                continue;
              i.splice(c, 1);
              break;
            }
            if (t[f].type !== l[f].baseType) {
              i.splice(c, 1);
              break;
            }
          }
      }
    }
    if (i.length === 1 && t && t.length !== i[0].inputs.length) {
      const a = t[t.length - 1];
      (a == null || Array.isArray(a) || typeof a != "object") && i.splice(0, 1);
    }
    if (i.length === 0)
      return null;
    if (i.length > 1 && n) {
      const a = i.map((o) => JSON.stringify(o.format())).join(", ");
      ue(!1, `ambiguous function description (i.e. matches ${a})`, "key", e);
    }
    return i[0];
  }
  const s = x(this, $n).get(Zr.from(e).format());
  return s || null;
}, // Find an event definition by any means necessary (unless it is ambiguous)
Kf = function(e, t, n) {
  if (dt(e)) {
    const i = e.toLowerCase();
    for (const a of x(this, Vn).values())
      if (i === a.topicHash)
        return a;
    return null;
  }
  if (e.indexOf("(") === -1) {
    const i = [];
    for (const [a, o] of x(this, Vn))
      a.split(
        "("
        /* fix:) */
      )[0] === e && i.push(o);
    if (t) {
      for (let a = i.length - 1; a >= 0; a--)
        i[a].inputs.length < t.length && i.splice(a, 1);
      for (let a = i.length - 1; a >= 0; a--) {
        const o = i[a].inputs;
        for (let u = 0; u < t.length; u++)
          if ($t.isTyped(t[u]) && t[u].type !== o[u].baseType) {
            i.splice(a, 1);
            break;
          }
      }
    }
    if (i.length === 0)
      return null;
    if (i.length > 1 && n) {
      const a = i.map((o) => JSON.stringify(o.format())).join(", ");
      ue(!1, `ambiguous event description (i.e. matches ${a})`, "key", e);
    }
    return i[0];
  }
  const s = x(this, Vn).get(Yr.from(e).format());
  return s || null;
};
let gu = _a;
const t4 = BigInt(0);
function pc(r) {
  return r ?? null;
}
function Ot(r) {
  return r == null ? null : r.toString();
}
class bd {
  /**
   *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
   *  %%maxPriorityFeePerGas%%.
   */
  constructor(e, t, n) {
    /**
     *  The gas price for legacy networks.
     */
    Q(this, "gasPrice");
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    Q(this, "maxFeePerGas");
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    Q(this, "maxPriorityFeePerGas");
    _e(this, {
      gasPrice: pc(e),
      maxFeePerGas: pc(t),
      maxPriorityFeePerGas: pc(n)
    });
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { gasPrice: e, maxFeePerGas: t, maxPriorityFeePerGas: n } = this;
    return {
      _type: "FeeData",
      gasPrice: Ot(e),
      maxFeePerGas: Ot(t),
      maxPriorityFeePerGas: Ot(n)
    };
  }
}
function xo(r) {
  const e = {};
  r.to && (e.to = r.to), r.from && (e.from = r.from), r.data && (e.data = Oe(r.data));
  const t = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const s of t)
    !(s in r) || r[s] == null || (e[s] = De(r[s], `request.${s}`));
  const n = "type,nonce".split(/,/);
  for (const s of n)
    !(s in r) || r[s] == null || (e[s] = Ve(r[s], `request.${s}`));
  return r.accessList && (e.accessList = ts(r.accessList)), "blockTag" in r && (e.blockTag = r.blockTag), "enableCcipRead" in r && (e.enableCcipRead = !!r.enableCcipRead), "customData" in r && (e.customData = r.customData), "blobVersionedHashes" in r && r.blobVersionedHashes && (e.blobVersionedHashes = r.blobVersionedHashes.slice()), "kzg" in r && (e.kzg = r.kzg), "blobs" in r && r.blobs && (e.blobs = r.blobs.map((s) => Su(s) ? Oe(s) : Object.assign({}, s))), e;
}
var Ps;
class Sg {
  /**
   *  Create a new **Block** object.
   *
   *  This should generally not be necessary as the unless implementing a
   *  low-level library.
   */
  constructor(e, t) {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */
    Q(this, "provider");
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */
    Q(this, "number");
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */
    Q(this, "hash");
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */
    Q(this, "timestamp");
    /**
     *  The block hash of the parent block.
     */
    Q(this, "parentHash");
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */
    Q(this, "parentBeaconBlockRoot");
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */
    Q(this, "nonce");
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */
    Q(this, "difficulty");
    /**
     *  The total gas limit for this block.
     */
    Q(this, "gasLimit");
    /**
     *  The total gas used in this block.
     */
    Q(this, "gasUsed");
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */
    Q(this, "stateRoot");
    /**
     *  The hash of the transaction receipts trie.
     */
    Q(this, "receiptsRoot");
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */
    Q(this, "blobGasUsed");
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */
    Q(this, "excessBlobGas");
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */
    Q(this, "miner");
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */
    Q(this, "prevRandao");
    /**
     *  Any extra data the validator wished to include.
     */
    Q(this, "extraData");
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */
    Q(this, "baseFeePerGas");
    Z(this, Ps);
    F(this, Ps, e.transactions.map((n) => typeof n != "string" ? new mo(n, t) : n)), _e(this, {
      provider: t,
      hash: pc(e.hash),
      number: e.number,
      timestamp: e.timestamp,
      parentHash: e.parentHash,
      parentBeaconBlockRoot: e.parentBeaconBlockRoot,
      nonce: e.nonce,
      difficulty: e.difficulty,
      gasLimit: e.gasLimit,
      gasUsed: e.gasUsed,
      blobGasUsed: e.blobGasUsed,
      excessBlobGas: e.excessBlobGas,
      miner: e.miner,
      prevRandao: pc(e.prevRandao),
      extraData: e.extraData,
      baseFeePerGas: pc(e.baseFeePerGas),
      stateRoot: e.stateRoot,
      receiptsRoot: e.receiptsRoot
    });
  }
  /**
   *  Returns the list of transaction hashes, in the order
   *  they were executed within the block.
   */
  get transactions() {
    return x(this, Ps).map((e) => typeof e == "string" ? e : e.hash);
  }
  /**
   *  Returns the complete transactions, in the order they
   *  were executed within the block.
   *
   *  This is only available for blocks which prefetched
   *  transactions, by passing ``true`` to %%prefetchTxs%%
   *  into [[Provider-getBlock]].
   */
  get prefetchedTransactions() {
    const e = x(this, Ps).slice();
    return e.length === 0 ? [] : (Ee(typeof e[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
      operation: "transactionResponses()"
    }), e);
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { baseFeePerGas: e, difficulty: t, extraData: n, gasLimit: s, gasUsed: i, hash: a, miner: o, prevRandao: u, nonce: c, number: l, parentHash: f, parentBeaconBlockRoot: d, stateRoot: h, receiptsRoot: p, timestamp: g, transactions: k } = this;
    return {
      _type: "Block",
      baseFeePerGas: Ot(e),
      difficulty: Ot(t),
      extraData: n,
      gasLimit: Ot(s),
      gasUsed: Ot(i),
      blobGasUsed: Ot(this.blobGasUsed),
      excessBlobGas: Ot(this.excessBlobGas),
      hash: a,
      miner: o,
      prevRandao: u,
      nonce: c,
      number: l,
      parentHash: f,
      timestamp: g,
      parentBeaconBlockRoot: d,
      stateRoot: h,
      receiptsRoot: p,
      transactions: k
    };
  }
  [Symbol.iterator]() {
    let e = 0;
    const t = this.transactions;
    return {
      next: () => e < this.length ? {
        value: t[e++],
        done: !1
      } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The number of transactions in this block.
   */
  get length() {
    return x(this, Ps).length;
  }
  /**
   *  The [[link-js-date]] this block was included at.
   */
  get date() {
    return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
  }
  /**
   *  Get the transaction at %%indexe%% within this block.
   */
  async getTransaction(e) {
    let t;
    if (typeof e == "number")
      t = x(this, Ps)[e];
    else {
      const n = e.toLowerCase();
      for (const s of x(this, Ps))
        if (typeof s == "string") {
          if (s !== n)
            continue;
          t = s;
          break;
        } else {
          if (s.hash !== n)
            continue;
          t = s;
          break;
        }
    }
    if (t == null)
      throw new Error("no such tx");
    return typeof t == "string" ? await this.provider.getTransaction(t) : t;
  }
  /**
   *  If a **Block** was fetched with a request to include the transactions
   *  this will allow synchronous access to those transactions.
   *
   *  If the transactions were not prefetched, this will throw.
   */
  getPrefetchedTransaction(e) {
    const t = this.prefetchedTransactions;
    if (typeof e == "number")
      return t[e];
    e = e.toLowerCase();
    for (const n of t)
      if (n.hash === e)
        return n;
    ue(!1, "no matching transaction", "indexOrHash", e);
  }
  /**
   *  Returns true if this block been mined. This provides a type guard
   *  for all properties on a [[MinedBlock]].
   */
  isMined() {
    return !!this.hash;
  }
  /**
   *  Returns true if this block is an [[link-eip-2930]] block.
   */
  isLondon() {
    return !!this.baseFeePerGas;
  }
  /**
   *  @_ignore:
   */
  orphanedEvent() {
    if (!this.isMined())
      throw new Error("");
    return T7(this);
  }
}
Ps = new WeakMap();
class No {
  /**
   *  @_ignore:
   */
  constructor(e, t) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    Q(this, "provider");
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */
    Q(this, "transactionHash");
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */
    Q(this, "blockHash");
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */
    Q(this, "blockNumber");
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */
    Q(this, "removed");
    /**
     *  The address of the contract that emitted this log.
     */
    Q(this, "address");
    /**
     *  The data included in this log when it was emitted.
     */
    Q(this, "data");
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */
    Q(this, "topics");
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */
    Q(this, "index");
    /**
     *  The index within the transaction of this log.
     */
    Q(this, "transactionIndex");
    this.provider = t;
    const n = Object.freeze(e.topics.slice());
    _e(this, {
      transactionHash: e.transactionHash,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      removed: e.removed,
      address: e.address,
      data: e.data,
      topics: n,
      index: e.index,
      transactionIndex: e.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: e, blockHash: t, blockNumber: n, data: s, index: i, removed: a, topics: o, transactionHash: u, transactionIndex: c } = this;
    return {
      _type: "log",
      address: e,
      blockHash: t,
      blockNumber: n,
      data: s,
      index: i,
      removed: a,
      topics: o,
      transactionHash: u,
      transactionIndex: c
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    return Ee(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.transactionHash);
    return Ee(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const e = await this.provider.getTransactionReceipt(this.transactionHash);
    return Ee(!!e, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return B7(this);
  }
}
var U0;
class rh {
  /**
   *  @_ignore:
   */
  constructor(e, t) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    Q(this, "provider");
    /**
     *  The address the transaction was sent to.
     */
    Q(this, "to");
    /**
     *  The sender of the transaction.
     */
    Q(this, "from");
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */
    Q(this, "contractAddress");
    /**
     *  The transaction hash.
     */
    Q(this, "hash");
    /**
     *  The index of this transaction within the block transactions.
     */
    Q(this, "index");
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */
    Q(this, "blockHash");
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */
    Q(this, "blockNumber");
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */
    Q(this, "logsBloom");
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */
    Q(this, "gasUsed");
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */
    Q(this, "blobGasUsed");
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */
    Q(this, "cumulativeGasUsed");
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */
    Q(this, "gasPrice");
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */
    Q(this, "blobGasPrice");
    /**
     *  The [[link-eip-2718]] transaction type.
     */
    Q(this, "type");
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */
    Q(this, "status");
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */
    Q(this, "root");
    Z(this, U0);
    F(this, U0, Object.freeze(e.logs.map((s) => new No(s, t))));
    let n = t4;
    e.effectiveGasPrice != null ? n = e.effectiveGasPrice : e.gasPrice != null && (n = e.gasPrice), _e(this, {
      provider: t,
      to: e.to,
      from: e.from,
      contractAddress: e.contractAddress,
      hash: e.hash,
      index: e.index,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      logsBloom: e.logsBloom,
      gasUsed: e.gasUsed,
      cumulativeGasUsed: e.cumulativeGasUsed,
      blobGasUsed: e.blobGasUsed,
      gasPrice: n,
      blobGasPrice: e.blobGasPrice,
      type: e.type,
      //byzantium: tx.byzantium,
      status: e.status,
      root: e.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return x(this, U0);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to: e,
      from: t,
      contractAddress: n,
      hash: s,
      index: i,
      blockHash: a,
      blockNumber: o,
      logsBloom: u,
      logs: c,
      //byzantium, 
      status: l,
      root: f
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: a,
      blockNumber: o,
      //byzantium, 
      contractAddress: n,
      cumulativeGasUsed: Ot(this.cumulativeGasUsed),
      from: t,
      gasPrice: Ot(this.gasPrice),
      blobGasUsed: Ot(this.blobGasUsed),
      blobGasPrice: Ot(this.blobGasPrice),
      gasUsed: Ot(this.gasUsed),
      hash: s,
      index: i,
      logs: c,
      logsBloom: u,
      root: f,
      status: l,
      to: e
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let e = 0;
    return {
      next: () => e < this.length ? { value: this.logs[e++], done: !1 } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.hash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return n4(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(e) {
    return Ee(!e || e.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), r4(this, e);
  }
}
U0 = new WeakMap();
var bi;
const Px = class Px {
  /**
   *  @_ignore:
   */
  constructor(e, t) {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */
    Q(this, "provider");
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    Q(this, "blockNumber");
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    Q(this, "blockHash");
    /**
     *  The index within the block that this transaction resides at.
     */
    Q(this, "index");
    /**
     *  The transaction hash.
     */
    Q(this, "hash");
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */
    Q(this, "type");
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */
    Q(this, "to");
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */
    Q(this, "from");
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */
    Q(this, "nonce");
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */
    Q(this, "gasLimit");
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */
    Q(this, "gasPrice");
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */
    Q(this, "maxPriorityFeePerGas");
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */
    Q(this, "maxFeePerGas");
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */
    Q(this, "maxFeePerBlobGas");
    /**
     *  The data.
     */
    Q(this, "data");
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */
    Q(this, "value");
    /**
     *  The chain ID.
     */
    Q(this, "chainId");
    /**
     *  The signature.
     */
    Q(this, "signature");
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */
    Q(this, "accessList");
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */
    Q(this, "blobVersionedHashes");
    Z(this, bi);
    this.provider = t, this.blockNumber = e.blockNumber != null ? e.blockNumber : null, this.blockHash = e.blockHash != null ? e.blockHash : null, this.hash = e.hash, this.index = e.index, this.type = e.type, this.from = e.from, this.to = e.to || null, this.gasLimit = e.gasLimit, this.nonce = e.nonce, this.data = e.data, this.value = e.value, this.gasPrice = e.gasPrice, this.maxPriorityFeePerGas = e.maxPriorityFeePerGas != null ? e.maxPriorityFeePerGas : null, this.maxFeePerGas = e.maxFeePerGas != null ? e.maxFeePerGas : null, this.maxFeePerBlobGas = e.maxFeePerBlobGas != null ? e.maxFeePerBlobGas : null, this.chainId = e.chainId, this.signature = e.signature, this.accessList = e.accessList != null ? e.accessList : null, this.blobVersionedHashes = e.blobVersionedHashes != null ? e.blobVersionedHashes : null, F(this, bi, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: e, blockHash: t, index: n, hash: s, type: i, to: a, from: o, nonce: u, data: c, signature: l, accessList: f, blobVersionedHashes: d } = this;
    return {
      _type: "TransactionResponse",
      accessList: f,
      blockNumber: e,
      blockHash: t,
      blobVersionedHashes: d,
      chainId: Ot(this.chainId),
      data: c,
      from: o,
      gasLimit: Ot(this.gasLimit),
      gasPrice: Ot(this.gasPrice),
      hash: s,
      maxFeePerGas: Ot(this.maxFeePerGas),
      maxPriorityFeePerGas: Ot(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: Ot(this.maxFeePerBlobGas),
      nonce: u,
      signature: l,
      to: a,
      index: n,
      type: i,
      value: Ot(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let e = this.blockNumber;
    if (e == null) {
      const n = await this.getTransaction();
      n && (e = n.blockNumber);
    }
    if (e == null)
      return null;
    const t = this.provider.getBlock(e);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: t, blockNumber: n } = await Lt({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return t == null || t.blockNumber == null ? 0 : n - t.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(e, t) {
    const n = e ?? 1, s = t ?? 0;
    let i = x(this, bi), a = -1, o = i === -1;
    const u = async () => {
      if (o)
        return null;
      const { blockNumber: d, nonce: h } = await Lt({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (h < this.nonce) {
        i = d;
        return;
      }
      if (o)
        return null;
      const p = await this.getTransaction();
      if (!(p && p.blockNumber != null))
        for (a === -1 && (a = i - 3, a < x(this, bi) && (a = x(this, bi))); a <= d; ) {
          if (o)
            return null;
          const g = await this.provider.getBlock(a, !0);
          if (g == null)
            return;
          for (const k of g)
            if (k === this.hash)
              return;
          for (let k = 0; k < g.length; k++) {
            const A = await g.getTransaction(k);
            if (A.from === this.from && A.nonce === this.nonce) {
              if (o)
                return null;
              const y = await this.provider.getTransactionReceipt(A.hash);
              if (y == null || d - y.blockNumber + 1 < n)
                return;
              let E = "replaced";
              A.data === this.data && A.to === this.to && A.value === this.value ? E = "repriced" : A.data === "0x" && A.from === A.to && A.value === t4 && (E = "cancelled"), Ee(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: E === "replaced" || E === "cancelled",
                reason: E,
                replacement: A.replaceableTransaction(i),
                hash: A.hash,
                receipt: y
              });
            }
          }
          a++;
        }
    }, c = (d) => {
      if (d == null || d.status !== 0)
        return d;
      Ee(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: d.to,
          from: d.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: d
      });
    }, l = await this.provider.getTransactionReceipt(this.hash);
    if (n === 0)
      return c(l);
    if (l) {
      if (await l.confirmations() >= n)
        return c(l);
    } else if (await u(), n === 0)
      return null;
    return await new Promise((d, h) => {
      const p = [], g = () => {
        p.forEach((A) => A());
      };
      if (p.push(() => {
        o = !0;
      }), s > 0) {
        const A = setTimeout(() => {
          g(), h(xt("wait for transaction timeout", "TIMEOUT"));
        }, s);
        p.push(() => {
          clearTimeout(A);
        });
      }
      const k = async (A) => {
        if (await A.confirmations() >= n) {
          g();
          try {
            d(c(A));
          } catch (y) {
            h(y);
          }
        }
      };
      if (p.push(() => {
        this.provider.off(this.hash, k);
      }), this.provider.on(this.hash, k), i >= 0) {
        const A = async () => {
          try {
            await u();
          } catch (y) {
            if (Ct(y, "TRANSACTION_REPLACED")) {
              g(), h(y);
              return;
            }
          }
          o || this.provider.once("block", A);
        };
        p.push(() => {
          this.provider.off("block", A);
        }), this.provider.once("block", A);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return Ee(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), n4(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(e) {
    return Ee(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), Ee(!e || e.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), r4(this, e);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(e) {
    ue(Number.isInteger(e) && e >= 0, "invalid startBlock", "startBlock", e);
    const t = new Px(this, this.provider);
    return F(t, bi, e), t;
  }
};
bi = new WeakMap();
let mo = Px;
function T7(r) {
  return { orphan: "drop-block", hash: r.hash, number: r.number };
}
function r4(r, e) {
  return { orphan: "reorder-transaction", tx: r, other: e };
}
function n4(r) {
  return { orphan: "drop-transaction", tx: r };
}
function B7(r) {
  return { orphan: "drop-log", log: {
    transactionHash: r.transactionHash,
    blockHash: r.blockHash,
    blockNumber: r.blockNumber,
    address: r.address,
    data: r.data,
    topics: Object.freeze(r.topics.slice()),
    index: r.index
  } };
}
class nf extends No {
  /**
   * @_ignore:
   */
  constructor(t, n, s) {
    super(t, t.provider);
    /**
     *  The Contract Interface.
     */
    Q(this, "interface");
    /**
     *  The matching event.
     */
    Q(this, "fragment");
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */
    Q(this, "args");
    const i = n.decodeEventLog(s, t.data, t.topics);
    _e(this, { args: i, fragment: s, interface: n });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
class nh extends No {
  /**
   * @_ignore:
   */
  constructor(t, n) {
    super(t, t.provider);
    /**
     *  The error encounted when trying to decode the log.
     */
    Q(this, "error");
    _e(this, { error: n });
  }
}
var jc;
class Cg extends rh {
  /**
   *  @_ignore:
   */
  constructor(t, n, s) {
    super(s, n);
    Z(this, jc);
    F(this, jc, t);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((t) => {
      const n = t.topics.length ? x(this, jc).getEvent(t.topics[0]) : null;
      if (n)
        try {
          return new nf(t, x(this, jc), n);
        } catch (s) {
          return new nh(t, s);
        }
      return t;
    });
  }
}
jc = new WeakMap();
var L0;
class sf extends mo {
  /**
   *  @_ignore:
   */
  constructor(t, n, s) {
    super(s, n);
    Z(this, L0);
    F(this, L0, t);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(t, n) {
    const s = await super.wait(t, n);
    return s == null ? null : new Cg(x(this, L0), this.provider, s);
  }
}
L0 = new WeakMap();
class sh extends Vd {
  /**
   *  @_event:
   */
  constructor(t, n, s, i) {
    super(t, n, s);
    /**
     *  The log with no matching events.
     */
    Q(this, "log");
    _e(this, { log: i });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
}
class Rg extends sh {
  /**
   *  @_ignore:
   */
  constructor(e, t, n, s, i) {
    super(e, t, n, new nf(i, e.interface, s));
    const a = e.interface.decodeEventLog(s, this.log.data, this.log.topics);
    _e(this, { args: a, fragment: s });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
const Lm = BigInt(0);
function s4(r) {
  return r && typeof r.call == "function";
}
function i4(r) {
  return r && typeof r.estimateGas == "function";
}
function ih(r) {
  return r && typeof r.resolveName == "function";
}
function a4(r) {
  return r && typeof r.sendTransaction == "function";
}
function o4(r) {
  if (r != null) {
    if (ih(r))
      return r;
    if (r.provider)
      return r.provider;
  }
}
var M0;
class O7 {
  constructor(e, t, n) {
    Z(this, M0);
    Q(this, "fragment");
    if (_e(this, { fragment: t }), t.inputs.length < n.length)
      throw new Error("too many arguments");
    const s = yo(e.runner, "resolveName"), i = ih(s) ? s : null;
    F(this, M0, async function() {
      const a = await Promise.all(t.inputs.map((o, u) => n[u] == null ? null : o.walkAsync(n[u], (l, f) => l === "address" ? Array.isArray(f) ? Promise.all(f.map((d) => Dt(d, i))) : Dt(f, i) : f)));
      return e.interface.encodeFilterTopics(t, a);
    }());
  }
  getTopicFilter() {
    return x(this, M0);
  }
}
M0 = new WeakMap();
function yo(r, e) {
  return r == null ? null : typeof r[e] == "function" ? r : r.provider && typeof r.provider[e] == "function" ? r.provider : null;
}
function Fa(r) {
  return r == null ? null : r.provider || null;
}
async function Ig(r, e) {
  const t = $t.dereference(r, "overrides");
  ue(typeof t == "object", "invalid overrides parameter", "overrides", r);
  const n = xo(t);
  return ue(n.to == null || (e || []).indexOf("to") >= 0, "cannot override to", "overrides.to", n.to), ue(n.data == null || (e || []).indexOf("data") >= 0, "cannot override data", "overrides.data", n.data), n.from && (n.from = n.from), n;
}
async function c4(r, e, t) {
  const n = yo(r, "resolveName"), s = ih(n) ? n : null;
  return await Promise.all(e.map((i, a) => i.walkAsync(t[a], (o, u) => (u = $t.dereference(u, o), o === "address" ? Dt(u, s) : u))));
}
function N7(r) {
  const e = async function(a) {
    const o = await Ig(a, ["data"]);
    o.to = await r.getAddress(), o.from && (o.from = await Dt(o.from, o4(r.runner)));
    const u = r.interface, c = De(o.value || Lm, "overrides.value") === Lm, l = (o.data || "0x") === "0x";
    u.fallback && !u.fallback.payable && u.receive && !l && !c && ue(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", a), ue(u.fallback || l, "cannot send data to receive-only contract", "overrides.data", o.data);
    const f = u.receive || u.fallback && u.fallback.payable;
    return ue(f || c, "cannot send value to non-payable fallback", "overrides.value", o.value), ue(u.fallback || l, "cannot send data to receive-only contract", "overrides.data", o.data), o;
  }, t = async function(a) {
    const o = yo(r.runner, "call");
    Ee(s4(o), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const u = await e(a);
    try {
      return await o.call(u);
    } catch (c) {
      throw q0(c) && c.data ? r.interface.makeError(c.data, u) : c;
    }
  }, n = async function(a) {
    const o = r.runner;
    Ee(a4(o), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const u = await o.sendTransaction(await e(a)), c = Fa(r.runner);
    return new sf(r.interface, c, u);
  }, s = async function(a) {
    const o = yo(r.runner, "estimateGas");
    return Ee(i4(o), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await o.estimateGas(await e(a));
  }, i = async (a) => await n(a);
  return _e(i, {
    _contract: r,
    estimateGas: s,
    populateTransaction: e,
    send: n,
    staticCall: t
  }), i;
}
function S7(r, e) {
  const t = function(...c) {
    const l = r.interface.getFunction(e, c);
    return Ee(l, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: e, args: c }
    }), l;
  }, n = async function(...c) {
    const l = t(...c);
    let f = {};
    if (l.inputs.length + 1 === c.length && (f = await Ig(c.pop()), f.from && (f.from = await Dt(f.from, o4(r.runner)))), l.inputs.length !== c.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const d = await c4(r.runner, l.inputs, c);
    return Object.assign({}, f, await Lt({
      to: r.getAddress(),
      data: r.interface.encodeFunctionData(l, d)
    }));
  }, s = async function(...c) {
    const l = await o(...c);
    return l.length === 1 ? l[0] : l;
  }, i = async function(...c) {
    const l = r.runner;
    Ee(a4(l), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const f = await l.sendTransaction(await n(...c)), d = Fa(r.runner);
    return new sf(r.interface, d, f);
  }, a = async function(...c) {
    const l = yo(r.runner, "estimateGas");
    return Ee(i4(l), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await l.estimateGas(await n(...c));
  }, o = async function(...c) {
    const l = yo(r.runner, "call");
    Ee(s4(l), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const f = await n(...c);
    let d = "0x";
    try {
      d = await l.call(f);
    } catch (p) {
      throw q0(p) && p.data ? r.interface.makeError(p.data, f) : p;
    }
    const h = t(...c);
    return r.interface.decodeFunctionResult(h, d);
  }, u = async (...c) => t(...c).constant ? await s(...c) : await i(...c);
  return _e(u, {
    name: r.interface.getFunctionName(e),
    _contract: r,
    _key: e,
    getFragment: t,
    estimateGas: a,
    populateTransaction: n,
    send: i,
    staticCall: s,
    staticCallResult: o
  }), Object.defineProperty(u, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const c = r.interface.getFunction(e);
      return Ee(c, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: e }
      }), c;
    }
  }), u;
}
function C7(r, e) {
  const t = function(...s) {
    const i = r.interface.getEvent(e, s);
    return Ee(i, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: e, args: s }
    }), i;
  }, n = function(...s) {
    return new O7(r, t(...s), s);
  };
  return _e(n, {
    name: r.interface.getEventName(e),
    _contract: r,
    _key: e,
    getFragment: t
  }), Object.defineProperty(n, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const s = r.interface.getEvent(e);
      return Ee(s, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: e }
      }), s;
    }
  }), n;
}
const gd = Symbol.for("_ethersInternal_contract"), u4 = /* @__PURE__ */ new WeakMap();
function R7(r, e) {
  u4.set(r[gd], e);
}
function Br(r) {
  return u4.get(r[gd]);
}
function I7(r) {
  return r && typeof r == "object" && "getTopicFilter" in r && typeof r.getTopicFilter == "function" && r.fragment;
}
async function _g(r, e) {
  let t, n = null;
  if (Array.isArray(e)) {
    const i = function(a) {
      if (dt(a, 32))
        return a;
      const o = r.interface.getEvent(a);
      return ue(o, "unknown fragment", "name", a), o.topicHash;
    };
    t = e.map((a) => a == null ? null : Array.isArray(a) ? a.map(i) : i(a));
  } else e === "*" ? t = [null] : typeof e == "string" ? dt(e, 32) ? t = [e] : (n = r.interface.getEvent(e), ue(n, "unknown fragment", "event", e), t = [n.topicHash]) : I7(e) ? t = await e.getTopicFilter() : "fragment" in e ? (n = e.fragment, t = [n.topicHash]) : ue(!1, "unknown event name", "event", e);
  t = t.map((i) => {
    if (i == null)
      return null;
    if (Array.isArray(i)) {
      const a = Array.from(new Set(i.map((o) => o.toLowerCase())).values());
      return a.length === 1 ? a[0] : (a.sort(), a);
    }
    return i.toLowerCase();
  });
  const s = t.map((i) => i == null ? "null" : Array.isArray(i) ? i.join("|") : i).join("&");
  return { fragment: n, tag: s, topics: t };
}
async function i0(r, e) {
  const { subs: t } = Br(r);
  return t.get((await _g(r, e)).tag) || null;
}
async function Mm(r, e, t) {
  const n = Fa(r.runner);
  Ee(n, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: e });
  const { fragment: s, tag: i, topics: a } = await _g(r, t), { addr: o, subs: u } = Br(r);
  let c = u.get(i);
  if (!c) {
    const f = { address: o || r, topics: a }, d = (k) => {
      let A = s;
      if (A == null)
        try {
          A = r.interface.getEvent(k.topics[0]);
        } catch {
        }
      if (A) {
        const y = A, E = s ? r.interface.decodeEventLog(s, k.data, k.topics) : [];
        Xp(r, t, E, (m) => new Rg(r, m, t, y, k));
      } else
        Xp(r, t, [], (y) => new sh(r, y, t, k));
    };
    let h = [];
    c = { tag: i, listeners: [], start: () => {
      h.length || h.push(n.on(f, d));
    }, stop: async () => {
      if (h.length == 0)
        return;
      let k = h;
      h = [], await Promise.all(k), n.off(f, d);
    } }, u.set(i, c);
  }
  return c;
}
let Zp = Promise.resolve();
async function _7(r, e, t, n) {
  await Zp;
  const s = await i0(r, e);
  if (!s)
    return !1;
  const i = s.listeners.length;
  return s.listeners = s.listeners.filter(({ listener: a, once: o }) => {
    const u = Array.from(t);
    n && u.push(n(o ? null : a));
    try {
      a.call(r, ...u);
    } catch {
    }
    return !o;
  }), s.listeners.length === 0 && (s.stop(), Br(r).subs.delete(s.tag)), i > 0;
}
async function Xp(r, e, t, n) {
  try {
    await Zp;
  } catch {
  }
  const s = _7(r, e, t, n);
  return Zp = s, await s;
}
const Bf = ["then"];
var U2;
U2 = gd;
const w0 = class w0 {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(e, t, n, s) {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */
    Q(this, "target");
    /**
     *  The contract Interface.
     */
    Q(this, "interface");
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */
    Q(this, "runner");
    /**
     *  All the Events available on this contract.
     */
    Q(this, "filters");
    /**
     *  @_ignore:
     */
    Q(this, U2);
    /**
     *  The fallback or receive function if any.
     */
    Q(this, "fallback");
    ue(typeof e == "string" || Wd(e), "invalid value for Contract target", "target", e), n == null && (n = null);
    const i = gu.from(t);
    _e(this, { target: e, runner: n, interface: i }), Object.defineProperty(this, gd, { value: {} });
    let a, o = null, u = null;
    if (s) {
      const f = Fa(n);
      u = new sf(this.interface, f, s);
    }
    let c = /* @__PURE__ */ new Map();
    if (typeof e == "string")
      if (dt(e))
        o = e, a = Promise.resolve(e);
      else {
        const f = yo(n, "resolveName");
        if (!ih(f))
          throw xt("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        a = f.resolveName(e).then((d) => {
          if (d == null)
            throw xt("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: e
            });
          return Br(this).addr = d, d;
        });
      }
    else
      a = e.getAddress().then((f) => {
        if (f == null)
          throw new Error("TODO");
        return Br(this).addr = f, f;
      });
    R7(this, { addrPromise: a, addr: o, deployTx: u, subs: c });
    const l = new Proxy({}, {
      get: (f, d, h) => {
        if (typeof d == "symbol" || Bf.indexOf(d) >= 0)
          return Reflect.get(f, d, h);
        try {
          return this.getEvent(d);
        } catch (p) {
          if (!Ct(p, "INVALID_ARGUMENT") || p.argument !== "key")
            throw p;
        }
      },
      has: (f, d) => Bf.indexOf(d) >= 0 ? Reflect.has(f, d) : Reflect.has(f, d) || this.interface.hasEvent(String(d))
    });
    return _e(this, { filters: l }), _e(this, {
      fallback: i.receive || i.fallback ? N7(this) : null
    }), new Proxy(this, {
      get: (f, d, h) => {
        if (typeof d == "symbol" || d in f || Bf.indexOf(d) >= 0)
          return Reflect.get(f, d, h);
        try {
          return f.getFunction(d);
        } catch (p) {
          if (!Ct(p, "INVALID_ARGUMENT") || p.argument !== "key")
            throw p;
        }
      },
      has: (f, d) => typeof d == "symbol" || d in f || Bf.indexOf(d) >= 0 ? Reflect.has(f, d) : f.interface.hasFunction(d)
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(e) {
    return new w0(this.target, this.interface, e);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(e) {
    return new w0(e, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await Br(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const e = Fa(this.runner);
    Ee(e, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const t = await e.getCode(await this.getAddress());
    return t === "0x" ? null : t;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const e = this.deploymentTransaction();
    if (e)
      return await e.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const n = Fa(this.runner);
    return Ee(n != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((s, i) => {
      const a = async () => {
        try {
          if (await this.getDeployedCode() != null)
            return s(this);
          n.once("block", a);
        } catch (o) {
          i(o);
        }
      };
      a();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return Br(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(e) {
    return typeof e != "string" && (e = e.format()), S7(this, e);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(e) {
    return typeof e != "string" && (e = e.format()), C7(this, e);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(e) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(e, t, n) {
    t == null && (t = 0), n == null && (n = "latest");
    const { addr: s, addrPromise: i } = Br(this), a = s || await i, { fragment: o, topics: u } = await _g(this, e), c = { address: a, topics: u, fromBlock: t, toBlock: n }, l = Fa(this.runner);
    return Ee(l, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await l.getLogs(c)).map((f) => {
      let d = o;
      if (d == null)
        try {
          d = this.interface.getEvent(f.topics[0]);
        } catch {
        }
      if (d)
        try {
          return new nf(f, this.interface, d);
        } catch (h) {
          return new nh(f, h);
        }
      return new No(f, l);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(e, t) {
    const n = await Mm(this, "on", e);
    return n.listeners.push({ listener: t, once: !1 }), n.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(e, t) {
    const n = await Mm(this, "once", e);
    return n.listeners.push({ listener: t, once: !0 }), n.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(e, ...t) {
    return await Xp(this, e, t, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(e) {
    if (e) {
      const s = await i0(this, e);
      return s ? s.listeners.length : 0;
    }
    const { subs: t } = Br(this);
    let n = 0;
    for (const { listeners: s } of t.values())
      n += s.length;
    return n;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(e) {
    if (e) {
      const s = await i0(this, e);
      return s ? s.listeners.map(({ listener: i }) => i) : [];
    }
    const { subs: t } = Br(this);
    let n = [];
    for (const { listeners: s } of t.values())
      n = n.concat(s.map(({ listener: i }) => i));
    return n;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(e, t) {
    const n = await i0(this, e);
    if (!n)
      return this;
    if (t) {
      const s = n.listeners.map(({ listener: i }) => i).indexOf(t);
      s >= 0 && n.listeners.splice(s, 1);
    }
    return (t == null || n.listeners.length === 0) && (n.stop(), Br(this).subs.delete(n.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(e) {
    if (e) {
      const t = await i0(this, e);
      if (!t)
        return this;
      t.stop(), Br(this).subs.delete(t.tag);
    } else {
      const { subs: t } = Br(this);
      for (const { tag: n, stop: s } of t.values())
        s(), t.delete(n);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(e, t) {
    return await this.on(e, t);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(e, t) {
    return await this.off(e, t);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(e) {
    class t extends w0 {
      constructor(s, i = null) {
        super(s, e, i);
      }
    }
    return t;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(e, t, n) {
    return n == null && (n = null), new this(e, t, n);
  }
};
let wo = w0;
function U7() {
  return wo;
}
class Ci extends U7() {
}
class ah {
  /**
   *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
   *  optionally connected to %%runner%%.
   *
   *  The %%bytecode%% may be the ``bytecode`` property within the
   *  standard Solidity JSON output.
   */
  constructor(e, t, n) {
    /**
     *  The Contract Interface.
     */
    Q(this, "interface");
    /**
     *  The Contract deployment bytecode. Often called the initcode.
     */
    Q(this, "bytecode");
    /**
     *  The ContractRunner to deploy the Contract as.
     */
    Q(this, "runner");
    const s = gu.from(e);
    t instanceof Uint8Array || (typeof t == "object" && (t = t.object), t.startsWith("0x") || (t = "0x" + t)), t = Oe(Ce(t)), _e(this, {
      bytecode: t,
      interface: s,
      runner: n || null
    });
  }
  attach(e) {
    return new wo(e, this.interface, this.runner);
  }
  /**
   *  Resolves to the transaction to deploy the contract, passing %%args%%
   *  into the constructor.
   */
  async getDeployTransaction(...e) {
    let t = {};
    const n = this.interface.deploy;
    if (n.inputs.length + 1 === e.length && (t = await Ig(e.pop())), n.inputs.length !== e.length)
      throw new Error("incorrect number of arguments to constructor");
    const s = await c4(this.runner, n.inputs, e), i = it([this.bytecode, this.interface.encodeDeploy(s)]);
    return Object.assign({}, t, { data: i });
  }
  /**
   *  Resolves to the Contract deployed by passing %%args%% into the
   *  constructor.
   *
   *  This will resolve to the Contract before it has been deployed to the
   *  network, so the [[BaseContract-waitForDeployment]] should be used before
   *  sending any transactions to it.
   */
  async deploy(...e) {
    const t = await this.getDeployTransaction(...e);
    Ee(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
      operation: "sendTransaction"
    });
    const n = await this.runner.sendTransaction(t), s = qd(n);
    return new wo(s, this.interface, this.runner, n);
  }
  /**
   *  Return a new **ContractFactory** with the same ABI and bytecode,
   *  but connected to %%runner%%.
   */
  connect(e) {
    return new ah(this.interface, this.bytecode, e);
  }
  /**
   *  Create a new **ContractFactory** from the standard Solidity JSON output.
   */
  static fromSolidity(e, t) {
    ue(e != null, "bad compiler output", "output", e), typeof e == "string" && (e = JSON.parse(e));
    const n = e.abi;
    let s = "";
    return e.bytecode ? s = e.bytecode : e.evm && e.evm.bytecode && (s = e.evm.bytecode), new this(n, s, t);
  }
}
function Kh(r) {
  return r.match(/^ipfs:\/\/ipfs\//i) ? r = r.substring(12) : r.match(/^ipfs:\/\//i) ? r = r.substring(7) : ue(!1, "unsupported IPFS format", "link", r), `https://gateway.ipfs.io/ipfs/${r}`;
}
class Ug {
  /**
   *  Creates a new **MulticoinProviderPluing** for %%name%%.
   */
  constructor(e) {
    /**
     *  The name.
     */
    Q(this, "name");
    _e(this, { name: e });
  }
  connect(e) {
    return this;
  }
  /**
   *  Returns ``true`` if %%coinType%% is supported by this plugin.
   */
  supportsCoinType(e) {
    return !1;
  }
  /**
   *  Resolves to the encoded %%address%% for %%coinType%%.
   */
  async encodeAddress(e, t) {
    throw new Error("unsupported coin");
  }
  /**
   *  Resolves to the decoded %%data%% for %%coinType%%.
   */
  async decodeAddress(e, t) {
    throw new Error("unsupported coin");
  }
}
const l4 = new RegExp("^(ipfs)://(.*)$", "i"), Fm = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  l4,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
var gi, Ya, xi, rc, Ud, f4;
const uc = class uc {
  constructor(e, t, n) {
    Z(this, xi);
    /**
     *  The connected provider.
     */
    Q(this, "provider");
    /**
     *  The address of the resolver.
     */
    Q(this, "address");
    /**
     *  The name this resolver was resolved against.
     */
    Q(this, "name");
    // For EIP-2544 names, the ancestor that provided the resolver
    Z(this, gi);
    Z(this, Ya);
    _e(this, { provider: e, address: t, name: n }), F(this, gi, null), F(this, Ya, new Ci(t, [
      "function supportsInterface(bytes4) view returns (bool)",
      "function resolve(bytes, bytes) view returns (bytes)",
      "function addr(bytes32) view returns (address)",
      "function addr(bytes32, uint) view returns (bytes)",
      "function text(bytes32, string) view returns (string)",
      "function contenthash(bytes32) view returns (bytes)"
    ], e));
  }
  /**
   *  Resolves to true if the resolver supports wildcard resolution.
   */
  async supportsWildcard() {
    return x(this, gi) == null && F(this, gi, (async () => {
      try {
        return await x(this, Ya).supportsInterface("0x9061b923");
      } catch (e) {
        if (Ct(e, "CALL_EXCEPTION"))
          return !1;
        throw F(this, gi, null), e;
      }
    })()), await x(this, gi);
  }
  /**
   *  Resolves to the address for %%coinType%% or null if the
   *  provided %%coinType%% has not been configured.
   */
  async getAddress(e) {
    if (e == null && (e = 60), e === 60)
      try {
        const i = await de(this, xi, rc).call(this, "addr(bytes32)");
        return i == null || i === bo ? null : i;
      } catch (i) {
        if (Ct(i, "CALL_EXCEPTION"))
          return null;
        throw i;
      }
    if (e >= 0 && e < 2147483648) {
      let i = e + 2147483648;
      const a = await de(this, xi, rc).call(this, "addr(bytes32,uint)", [i]);
      if (dt(a, 20))
        return et(a);
    }
    let t = null;
    for (const i of this.provider.plugins)
      if (i instanceof Ug && i.supportsCoinType(e)) {
        t = i;
        break;
      }
    if (t == null)
      return null;
    const n = await de(this, xi, rc).call(this, "addr(bytes32,uint)", [e]);
    if (n == null || n === "0x")
      return null;
    const s = await t.decodeAddress(e, n);
    if (s != null)
      return s;
    Ee(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
      operation: `getAddress(${e})`,
      info: { coinType: e, data: n }
    });
  }
  /**
   *  Resolves to the EIP-634 text record for %%key%%, or ``null``
   *  if unconfigured.
   */
  async getText(e) {
    const t = await de(this, xi, rc).call(this, "text(bytes32,string)", [e]);
    return t == null || t === "0x" ? null : t;
  }
  /**
   *  Rsolves to the content-hash or ``null`` if unconfigured.
   */
  async getContentHash() {
    const e = await de(this, xi, rc).call(this, "contenthash(bytes32)");
    if (e == null || e === "0x")
      return null;
    const t = e.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
    if (t) {
      const s = t[1] === "e3010170" ? "ipfs" : "ipns", i = parseInt(t[4], 16);
      if (t[5].length === i * 2)
        return `${s}://${Gd("0x" + t[2])}`;
    }
    const n = e.match(/^0xe40101fa011b20([0-9a-f]*)$/);
    if (n && n[1].length === 64)
      return `bzz://${n[1]}`;
    Ee(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
      operation: "getContentHash()",
      info: { data: e }
    });
  }
  /**
   *  Resolves to the avatar url or ``null`` if the avatar is either
   *  unconfigured or incorrectly configured (e.g. references an NFT
   *  not owned by the address).
   *
   *  If diagnosing issues with configurations, the [[_getAvatar]]
   *  method may be useful.
   */
  async getAvatar() {
    return (await this._getAvatar()).url;
  }
  /**
   *  When resolving an avatar, there are many steps involved, such
   *  fetching metadata and possibly validating ownership of an
   *  NFT.
   *
   *  This method can be used to examine each step and the value it
   *  was working from.
   */
  async _getAvatar() {
    const e = [{ type: "name", value: this.name }];
    try {
      const t = await this.getText("avatar");
      if (t == null)
        return e.push({ type: "!avatar", value: "" }), { url: null, linkage: e };
      e.push({ type: "avatar", value: t });
      for (let n = 0; n < Fm.length; n++) {
        const s = t.match(Fm[n]);
        if (s == null)
          continue;
        const i = s[1].toLowerCase();
        switch (i) {
          case "https":
          case "data":
            return e.push({ type: "url", value: t }), { linkage: e, url: t };
          case "ipfs": {
            const a = Kh(t);
            return e.push({ type: "ipfs", value: t }), e.push({ type: "url", value: a }), { linkage: e, url: a };
          }
          case "erc721":
          case "erc1155": {
            const a = i === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
            e.push({ type: i, value: t });
            const o = await this.getAddress();
            if (o == null)
              return e.push({ type: "!owner", value: "" }), { url: null, linkage: e };
            const u = (s[2] || "").split("/");
            if (u.length !== 2)
              return e.push({ type: `!${i}caip`, value: s[2] || "" }), { url: null, linkage: e };
            const c = u[1], l = new Ci(u[0], [
              // ERC-721
              "function tokenURI(uint) view returns (string)",
              "function ownerOf(uint) view returns (address)",
              // ERC-1155
              "function uri(uint) view returns (string)",
              "function balanceOf(address, uint256) view returns (uint)"
            ], this.provider);
            if (i === "erc721") {
              const g = await l.ownerOf(c);
              if (o !== g)
                return e.push({ type: "!owner", value: g }), { url: null, linkage: e };
              e.push({ type: "owner", value: g });
            } else if (i === "erc1155") {
              const g = await l.balanceOf(o, c);
              if (!g)
                return e.push({ type: "!balance", value: "0" }), { url: null, linkage: e };
              e.push({ type: "balance", value: g.toString() });
            }
            let f = await l[a](c);
            if (f == null || f === "0x")
              return e.push({ type: "!metadata-url", value: "" }), { url: null, linkage: e };
            e.push({ type: "metadata-url-base", value: f }), i === "erc1155" && (f = f.replace("{id}", tn(c, 32).substring(2)), e.push({ type: "metadata-url-expanded", value: f })), f.match(/^ipfs:/i) && (f = Kh(f)), e.push({ type: "metadata-url", value: f });
            let d = {};
            const h = await new Kt(f).send();
            h.assertOk();
            try {
              d = h.bodyJson;
            } catch {
              try {
                e.push({ type: "!metadata", value: h.bodyText });
              } catch {
                const A = h.body;
                return A && e.push({ type: "!metadata", value: Oe(A) }), { url: null, linkage: e };
              }
              return { url: null, linkage: e };
            }
            if (!d)
              return e.push({ type: "!metadata", value: "" }), { url: null, linkage: e };
            e.push({ type: "metadata", value: JSON.stringify(d) });
            let p = d.image;
            if (typeof p != "string")
              return e.push({ type: "!imageUrl", value: "" }), { url: null, linkage: e };
            if (!p.match(/^(https:\/\/|data:)/i)) {
              if (p.match(l4) == null)
                return e.push({ type: "!imageUrl-ipfs", value: p }), { url: null, linkage: e };
              e.push({ type: "imageUrl-ipfs", value: p }), p = Kh(p);
            }
            return e.push({ type: "url", value: p }), { linkage: e, url: p };
          }
        }
      }
    } catch {
    }
    return { linkage: e, url: null };
  }
  static async getEnsAddress(e) {
    const t = await e.getNetwork(), n = t.getPlugin("org.ethers.plugins.network.Ens");
    return Ee(n, "network does not support ENS", "UNSUPPORTED_OPERATION", {
      operation: "getEnsAddress",
      info: { network: t }
    }), n.address;
  }
  /**
   *  Resolve to the ENS resolver for %%name%% using %%provider%% or
   *  ``null`` if unconfigured.
   */
  static async fromName(e, t) {
    var s;
    let n = t;
    for (; ; ) {
      if (n === "" || n === "." || t !== "eth" && n === "eth")
        return null;
      const i = await de(s = uc, Ud, f4).call(s, e, n);
      if (i != null) {
        const a = new uc(e, i, t);
        return n !== t && !await a.supportsWildcard() ? null : a;
      }
      n = n.split(".").slice(1).join(".");
    }
  }
};
gi = new WeakMap(), Ya = new WeakMap(), xi = new WeakSet(), rc = async function(e, t) {
  t = (t || []).slice();
  const n = x(this, Ya).interface;
  t.unshift(T0(this.name));
  let s = null;
  await this.supportsWildcard() && (s = n.getFunction(e), Ee(s, "missing fragment", "UNKNOWN_ERROR", {
    info: { funcName: e }
  }), t = [
    Pg(this.name, 255),
    n.encodeFunctionData(s, t)
  ], e = "resolve(bytes,bytes)"), t.push({
    enableCcipRead: !0
  });
  try {
    const i = await x(this, Ya)[e](...t);
    return s ? n.decodeFunctionResult(s, i)[0] : i;
  } catch (i) {
    if (!Ct(i, "CALL_EXCEPTION"))
      throw i;
  }
  return null;
}, Ud = new WeakSet(), f4 = async function(e, t) {
  const n = await uc.getEnsAddress(e);
  try {
    const i = await new Ci(n, [
      "function resolver(bytes32) view returns (address)"
    ], e).resolver(T0(t), {
      enableCcipRead: !0
    });
    return i === bo ? null : i;
  } catch (s) {
    throw s;
  }
  return null;
}, Z(uc, Ud);
let xu = uc;
const Dm = BigInt(0);
function st(r, e) {
  return function(t) {
    return t == null ? e : r(t);
  };
}
function oh(r, e) {
  return (t) => {
    if (e && t == null)
      return null;
    if (!Array.isArray(t))
      throw new Error("not an array");
    return t.map((n) => r(n));
  };
}
function af(r, e) {
  return (t) => {
    const n = {};
    for (const s in r) {
      let i = s;
      if (e && s in e && !(i in t)) {
        for (const a of e[s])
          if (a in t) {
            i = a;
            break;
          }
      }
      try {
        const a = r[s](t[i]);
        a !== void 0 && (n[s] = a);
      } catch (a) {
        const o = a instanceof Error ? a.message : "not-an-error";
        Ee(!1, `invalid value for value.${s} (${o})`, "BAD_DATA", { value: t });
      }
    }
    return n;
  };
}
function L7(r) {
  switch (r) {
    case !0:
    case "true":
      return !0;
    case !1:
    case "false":
      return !1;
  }
  ue(!1, `invalid boolean; ${JSON.stringify(r)}`, "value", r);
}
function mu(r) {
  return ue(dt(r, !0), "invalid data", "value", r), r;
}
function Wt(r) {
  return ue(dt(r, 32), "invalid hash", "value", r), r;
}
const M7 = af({
  address: et,
  blockHash: Wt,
  blockNumber: Ve,
  data: mu,
  index: Ve,
  removed: st(L7, !1),
  topics: oh(Wt),
  transactionHash: Wt,
  transactionIndex: Ve
}, {
  index: ["logIndex"]
});
function F7(r) {
  return M7(r);
}
const D7 = af({
  hash: st(Wt),
  parentHash: Wt,
  parentBeaconBlockRoot: st(Wt, null),
  number: Ve,
  timestamp: Ve,
  nonce: st(mu),
  difficulty: De,
  gasLimit: De,
  gasUsed: De,
  stateRoot: st(Wt, null),
  receiptsRoot: st(Wt, null),
  blobGasUsed: st(De, null),
  excessBlobGas: st(De, null),
  miner: st(et),
  prevRandao: st(Wt, null),
  extraData: mu,
  baseFeePerGas: st(De)
}, {
  prevRandao: ["mixHash"]
});
function j7(r) {
  const e = D7(r);
  return e.transactions = r.transactions.map((t) => typeof t == "string" ? t : d4(t)), e;
}
const H7 = af({
  transactionIndex: Ve,
  blockNumber: Ve,
  transactionHash: Wt,
  address: et,
  topics: oh(Wt),
  data: mu,
  index: Ve,
  blockHash: Wt
}, {
  index: ["logIndex"]
});
function G7(r) {
  return H7(r);
}
const V7 = af({
  to: st(et, null),
  from: st(et, null),
  contractAddress: st(et, null),
  // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
  index: Ve,
  root: st(Oe),
  gasUsed: De,
  blobGasUsed: st(De, null),
  logsBloom: st(mu),
  blockHash: Wt,
  hash: Wt,
  logs: oh(G7),
  blockNumber: Ve,
  //confirmations: allowNull(getNumber, null),
  cumulativeGasUsed: De,
  effectiveGasPrice: st(De),
  blobGasPrice: st(De, null),
  status: st(Ve),
  type: st(Ve, 0)
}, {
  effectiveGasPrice: ["gasPrice"],
  hash: ["transactionHash"],
  index: ["transactionIndex"]
});
function $7(r) {
  return V7(r);
}
function d4(r) {
  r.to && De(r.to) === Dm && (r.to = "0x0000000000000000000000000000000000000000");
  const e = af({
    hash: Wt,
    // Some nodes do not return this, usually test nodes (like Ganache)
    index: st(Ve, void 0),
    type: (t) => t === "0x" || t == null ? 0 : Ve(t),
    accessList: st(ts, null),
    blobVersionedHashes: st(oh(Wt, !0), null),
    blockHash: st(Wt, null),
    blockNumber: st(Ve, null),
    transactionIndex: st(Ve, null),
    from: et,
    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
    gasPrice: st(De),
    maxPriorityFeePerGas: st(De),
    maxFeePerGas: st(De),
    maxFeePerBlobGas: st(De, null),
    gasLimit: De,
    to: st(et, null),
    value: De,
    nonce: Ve,
    data: mu,
    creates: st(et, null),
    chainId: st(De, null)
  }, {
    data: ["input"],
    gasLimit: ["gas"],
    index: ["transactionIndex"]
  })(r);
  if (e.to == null && e.creates == null && (e.creates = qd(e)), (r.type === 1 || r.type === 2) && r.accessList == null && (e.accessList = []), r.signature ? e.signature = Ur.from(r.signature) : e.signature = Ur.from(r), e.chainId == null) {
    const t = e.signature.legacyChainId;
    t != null && (e.chainId = t);
  }
  return e.blockHash && De(e.blockHash) === Dm && (e.blockHash = null), e;
}
const K7 = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class Qs {
  /**
   *  Creates a new **NetworkPlugin**.
   */
  constructor(e) {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */
    Q(this, "name");
    _e(this, { name: e });
  }
  /**
   *  Creates a copy of this plugin.
   */
  clone() {
    return new Qs(this.name);
  }
}
class Uu extends Qs {
  /**
   *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
   *  latest block or another GasCostPlugin supercedes that block number,
   *  with the associated %%costs%%.
   */
  constructor(t, n) {
    t == null && (t = 0);
    super(`org.ethers.network.plugins.GasCost#${t || 0}`);
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */
    Q(this, "effectiveBlock");
    /**
     *  The transactions base fee.
     */
    Q(this, "txBase");
    /**
     *  The fee for creating a new account.
     */
    Q(this, "txCreate");
    /**
     *  The fee per zero-byte in the data.
     */
    Q(this, "txDataZero");
    /**
     *  The fee per non-zero-byte in the data.
     */
    Q(this, "txDataNonzero");
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */
    Q(this, "txAccessListStorageKey");
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */
    Q(this, "txAccessListAddress");
    const s = { effectiveBlock: t };
    function i(a, o) {
      let u = (n || {})[a];
      u == null && (u = o), ue(typeof u == "number", `invalud value for ${a}`, "costs", n), s[a] = u;
    }
    i("txBase", 21e3), i("txCreate", 32e3), i("txDataZero", 4), i("txDataNonzero", 16), i("txAccessListStorageKey", 1900), i("txAccessListAddress", 2400), _e(this, s);
  }
  clone() {
    return new Uu(this.effectiveBlock, this);
  }
}
class Lu extends Qs {
  /**
   *  Creates a new **EnsPlugin** connected to %%address%% on the
   *  %%targetNetwork%%. The default ENS address and mainnet is used
   *  if unspecified.
   */
  constructor(t, n) {
    super("org.ethers.plugins.network.Ens");
    /**
     *  The ENS Registrty Contract address.
     */
    Q(this, "address");
    /**
     *  The chain ID that the ENS contract lives on.
     */
    Q(this, "targetNetwork");
    _e(this, {
      address: t || K7,
      targetNetwork: n ?? 1
    });
  }
  clone() {
    return new Lu(this.address, this.targetNetwork);
  }
}
var Za;
const vx = class vx extends Qs {
  /**
   *  Creates a new **FeeDataNetworkPlugin**.
   */
  constructor(t) {
    super("org.ethers.plugins.network.FeeData");
    Z(this, Za);
    F(this, Za, t);
  }
  /**
   *  The fee data function provided to the constructor.
   */
  get feeDataFunc() {
    return x(this, Za);
  }
  /**
   *  Resolves to the fee data.
   */
  async getFeeData(t) {
    return await x(this, Za).call(this, t);
  }
  clone() {
    return new vx(x(this, Za));
  }
};
Za = new WeakMap();
let xd = vx;
var F0, D0;
class Lg extends Qs {
  /**
   *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
   *  be used when computing the fee data for the network.
   */
  constructor(t, n) {
    super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    Z(this, F0);
    Z(this, D0);
    F(this, F0, t), F(this, D0, n);
  }
  /**
   *  The URL to initialize the FetchRequest with in %%processFunc%%.
   */
  get url() {
    return x(this, F0);
  }
  /**
   *  The callback to use when computing the FeeData.
   */
  get processFunc() {
    return x(this, D0);
  }
  // We are immutable, so we can serve as our own clone
  clone() {
    return this;
  }
}
F0 = new WeakMap(), D0 = new WeakMap();
const zh = /* @__PURE__ */ new Map();
var Hc, Gc, mi;
const lc = class lc {
  /**
   *  Creates a new **Network** for %%name%% and %%chainId%%.
   */
  constructor(e, t) {
    Z(this, Hc);
    Z(this, Gc);
    Z(this, mi);
    F(this, Hc, e), F(this, Gc, De(t)), F(this, mi, /* @__PURE__ */ new Map());
  }
  /**
   *  Returns a JSON-compatible representation of a Network.
   */
  toJSON() {
    return { name: this.name, chainId: String(this.chainId) };
  }
  /**
   *  The network common name.
   *
   *  This is the canonical name, as networks migh have multiple
   *  names.
   */
  get name() {
    return x(this, Hc);
  }
  set name(e) {
    F(this, Hc, e);
  }
  /**
   *  The network chain ID.
   */
  get chainId() {
    return x(this, Gc);
  }
  set chainId(e) {
    F(this, Gc, De(e, "chainId"));
  }
  /**
   *  Returns true if %%other%% matches this network. Any chain ID
   *  must match, and if no chain ID is present, the name must match.
   *
   *  This method does not currently check for additional properties,
   *  such as ENS address or plug-in compatibility.
   */
  matches(e) {
    if (e == null)
      return !1;
    if (typeof e == "string") {
      try {
        return this.chainId === De(e);
      } catch {
      }
      return this.name === e;
    }
    if (typeof e == "number" || typeof e == "bigint") {
      try {
        return this.chainId === De(e);
      } catch {
      }
      return !1;
    }
    if (typeof e == "object") {
      if (e.chainId != null) {
        try {
          return this.chainId === De(e.chainId);
        } catch {
        }
        return !1;
      }
      return e.name != null ? this.name === e.name : !1;
    }
    return !1;
  }
  /**
   *  Returns the list of plugins currently attached to this Network.
   */
  get plugins() {
    return Array.from(x(this, mi).values());
  }
  /**
   *  Attach a new %%plugin%% to this Network. The network name
   *  must be unique, excluding any fragment.
   */
  attachPlugin(e) {
    if (x(this, mi).get(e.name))
      throw new Error(`cannot replace existing plugin: ${e.name} `);
    return x(this, mi).set(e.name, e.clone()), this;
  }
  /**
   *  Return the plugin, if any, matching %%name%% exactly. Plugins
   *  with fragments will not be returned unless %%name%% includes
   *  a fragment.
   */
  getPlugin(e) {
    return x(this, mi).get(e) || null;
  }
  /**
   *  Gets a list of all plugins that match %%name%%, with otr without
   *  a fragment.
   */
  getPlugins(e) {
    return this.plugins.filter((t) => t.name.split("#")[0] === e);
  }
  /**
   *  Create a copy of this Network.
   */
  clone() {
    const e = new lc(this.name, this.chainId);
    return this.plugins.forEach((t) => {
      e.attachPlugin(t.clone());
    }), e;
  }
  /**
   *  Compute the intrinsic gas required for a transaction.
   *
   *  A GasCostPlugin can be attached to override the default
   *  values.
   */
  computeIntrinsicGas(e) {
    const t = this.getPlugin("org.ethers.plugins.network.GasCost") || new Uu();
    let n = t.txBase;
    if (e.to == null && (n += t.txCreate), e.data)
      for (let s = 2; s < e.data.length; s += 2)
        e.data.substring(s, s + 2) === "00" ? n += t.txDataZero : n += t.txDataNonzero;
    if (e.accessList) {
      const s = ts(e.accessList);
      for (const i in s)
        n += t.txAccessListAddress + t.txAccessListStorageKey * s[i].storageKeys.length;
    }
    return n;
  }
  /**
   *  Returns a new Network for the %%network%% name or chainId.
   */
  static from(e) {
    if (z7(), e == null)
      return lc.from("mainnet");
    if (typeof e == "number" && (e = BigInt(e)), typeof e == "string" || typeof e == "bigint") {
      const t = zh.get(e);
      if (t)
        return t();
      if (typeof e == "bigint")
        return new lc("unknown", e);
      ue(!1, "unknown network", "network", e);
    }
    if (typeof e.clone == "function")
      return e.clone();
    if (typeof e == "object") {
      ue(typeof e.name == "string" && typeof e.chainId == "number", "invalid network object name or chainId", "network", e);
      const t = new lc(e.name, e.chainId);
      return (e.ensAddress || e.ensNetwork != null) && t.attachPlugin(new Lu(e.ensAddress, e.ensNetwork)), t;
    }
    ue(!1, "invalid network", "network", e);
  }
  /**
   *  Register %%nameOrChainId%% with a function which returns
   *  an instance of a Network representing that chain.
   */
  static register(e, t) {
    typeof e == "number" && (e = BigInt(e));
    const n = zh.get(e);
    n && ue(!1, `conflicting network for ${JSON.stringify(n.name)}`, "nameOrChainId", e), zh.set(e, t);
  }
};
Hc = new WeakMap(), Gc = new WeakMap(), mi = new WeakMap();
let vt = lc;
function jm(r, e) {
  const t = String(r);
  if (!t.match(/^[0-9.]+$/))
    throw new Error(`invalid gwei value: ${r}`);
  const n = t.split(".");
  if (n.length === 1 && n.push(""), n.length !== 2)
    throw new Error(`invalid gwei value: ${r}`);
  for (; n[1].length < e; )
    n[1] += "0";
  if (n[1].length > 9) {
    let s = BigInt(n[1].substring(0, 9));
    n[1].substring(9).match(/^0+$/) || s++, n[1] = s.toString();
  }
  return BigInt(n[0] + n[1]);
}
function Hm(r) {
  return new Lg(r, async (e, t, n) => {
    n.setHeader("User-Agent", "ethers");
    let s;
    try {
      const [i, a] = await Promise.all([
        n.send(),
        e()
      ]);
      s = i;
      const o = s.bodyJson.standard;
      return {
        gasPrice: a.gasPrice,
        maxFeePerGas: jm(o.maxFee, 9),
        maxPriorityFeePerGas: jm(o.maxPriorityFee, 9)
      };
    } catch (i) {
      Ee(!1, `error encountered with polygon gas station (${JSON.stringify(n.url)})`, "SERVER_ERROR", { request: n, response: s, error: i });
    }
  });
}
let Gm = !1;
function z7() {
  if (Gm)
    return;
  Gm = !0;
  function r(e, t, n) {
    const s = function() {
      const i = new vt(e, t);
      return n.ensNetwork != null && i.attachPlugin(new Lu(null, n.ensNetwork)), i.attachPlugin(new Uu()), (n.plugins || []).forEach((a) => {
        i.attachPlugin(a);
      }), i;
    };
    vt.register(e, s), vt.register(t, s), n.altNames && n.altNames.forEach((i) => {
      vt.register(i, s);
    });
  }
  r("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), r("ropsten", 3, { ensNetwork: 3 }), r("rinkeby", 4, { ensNetwork: 4 }), r("goerli", 5, { ensNetwork: 5 }), r("kovan", 42, { ensNetwork: 42 }), r("sepolia", 11155111, { ensNetwork: 11155111 }), r("holesky", 17e3, { ensNetwork: 17e3 }), r("classic", 61, {}), r("classicKotti", 6, {}), r("arbitrum", 42161, {
    ensNetwork: 1
  }), r("arbitrum-goerli", 421613, {}), r("arbitrum-sepolia", 421614, {}), r("base", 8453, { ensNetwork: 1 }), r("base-goerli", 84531, {}), r("base-sepolia", 84532, {}), r("bnb", 56, { ensNetwork: 1 }), r("bnbt", 97, {}), r("linea", 59144, { ensNetwork: 1 }), r("linea-goerli", 59140, {}), r("linea-sepolia", 59141, {}), r("matic", 137, {
    ensNetwork: 1,
    plugins: [
      Hm("https://gasstation.polygon.technology/v2")
    ]
  }), r("matic-amoy", 80002, {}), r("matic-mumbai", 80001, {
    altNames: ["maticMumbai", "maticmum"],
    plugins: [
      Hm("https://gasstation-testnet.polygon.technology/v2")
    ]
  }), r("optimism", 10, {
    ensNetwork: 1,
    plugins: []
  }), r("optimism-goerli", 420, {}), r("optimism-sepolia", 11155420, {}), r("xdai", 100, { ensNetwork: 1 });
}
function eb(r) {
  return JSON.parse(JSON.stringify(r));
}
var vs, zr, yi, Kn, Vc, zf;
class J7 {
  /**
   *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
   */
  constructor(e) {
    Z(this, Vc);
    Z(this, vs);
    Z(this, zr);
    Z(this, yi);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    Z(this, Kn);
    F(this, vs, e), F(this, zr, null), F(this, yi, 4e3), F(this, Kn, -2);
  }
  /**
   *  The polling interval.
   */
  get pollingInterval() {
    return x(this, yi);
  }
  set pollingInterval(e) {
    F(this, yi, e);
  }
  start() {
    x(this, zr) || (F(this, zr, x(this, vs)._setTimeout(de(this, Vc, zf).bind(this), x(this, yi))), de(this, Vc, zf).call(this));
  }
  stop() {
    x(this, zr) && (x(this, vs)._clearTimeout(x(this, zr)), F(this, zr, null));
  }
  pause(e) {
    this.stop(), e && F(this, Kn, -2);
  }
  resume() {
    this.start();
  }
}
vs = new WeakMap(), zr = new WeakMap(), yi = new WeakMap(), Kn = new WeakMap(), Vc = new WeakSet(), zf = async function() {
  try {
    const e = await x(this, vs).getBlockNumber();
    if (x(this, Kn) === -2) {
      F(this, Kn, e);
      return;
    }
    if (e !== x(this, Kn)) {
      for (let t = x(this, Kn) + 1; t <= e; t++) {
        if (x(this, zr) == null)
          return;
        await x(this, vs).emit("block", t);
      }
      F(this, Kn, e);
    }
  } catch {
  }
  x(this, zr) != null && F(this, zr, x(this, vs)._setTimeout(de(this, Vc, zf).bind(this), x(this, yi)));
};
var Xa, eo, wi;
class Mg {
  /**
   *  Create a new **OnBlockSubscriber** attached to %%provider%%.
   */
  constructor(e) {
    Z(this, Xa);
    Z(this, eo);
    Z(this, wi);
    F(this, Xa, e), F(this, wi, !1), F(this, eo, (t) => {
      this._poll(t, x(this, Xa));
    });
  }
  /**
   *  Called on every new block.
   */
  async _poll(e, t) {
    throw new Error("sub-classes must override this");
  }
  start() {
    x(this, wi) || (F(this, wi, !0), x(this, eo).call(this, -2), x(this, Xa).on("block", x(this, eo)));
  }
  stop() {
    x(this, wi) && (F(this, wi, !1), x(this, Xa).off("block", x(this, eo)));
  }
  pause(e) {
    this.stop();
  }
  resume() {
    this.start();
  }
}
Xa = new WeakMap(), eo = new WeakMap(), wi = new WeakMap();
var $c, ks;
class Q7 extends Mg {
  constructor(t, n) {
    super(t);
    Z(this, $c);
    Z(this, ks);
    F(this, $c, n), F(this, ks, -2);
  }
  pause(t) {
    t && F(this, ks, -2), super.pause(t);
  }
  async _poll(t, n) {
    const s = await n.getBlock(x(this, $c));
    s != null && (x(this, ks) === -2 ? F(this, ks, s.number) : s.number > x(this, ks) && (n.emit(x(this, $c), s.number), F(this, ks, s.number)));
  }
}
$c = new WeakMap(), ks = new WeakMap();
var Ld;
class q7 extends Mg {
  constructor(t, n) {
    super(t);
    Z(this, Ld);
    F(this, Ld, eb(n));
  }
  async _poll(t, n) {
    throw new Error("@TODO");
  }
}
Ld = new WeakMap();
var Kc;
class W7 extends Mg {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%hash%%.
   */
  constructor(t, n) {
    super(t);
    Z(this, Kc);
    F(this, Kc, n);
  }
  async _poll(t, n) {
    const s = await n.getTransactionReceipt(x(this, Kc));
    s && n.emit(x(this, Kc), s);
  }
}
Kc = new WeakMap();
var Ts, zc, Jc, Ai, Jr, Md, h4;
class Fg {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%filter%%.
   */
  constructor(e, t) {
    Z(this, Md);
    Z(this, Ts);
    Z(this, zc);
    Z(this, Jc);
    Z(this, Ai);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    Z(this, Jr);
    F(this, Ts, e), F(this, zc, eb(t)), F(this, Jc, de(this, Md, h4).bind(this)), F(this, Ai, !1), F(this, Jr, -2);
  }
  start() {
    x(this, Ai) || (F(this, Ai, !0), x(this, Jr) === -2 && x(this, Ts).getBlockNumber().then((e) => {
      F(this, Jr, e);
    }), x(this, Ts).on("block", x(this, Jc)));
  }
  stop() {
    x(this, Ai) && (F(this, Ai, !1), x(this, Ts).off("block", x(this, Jc)));
  }
  pause(e) {
    this.stop(), e && F(this, Jr, -2);
  }
  resume() {
    this.start();
  }
}
Ts = new WeakMap(), zc = new WeakMap(), Jc = new WeakMap(), Ai = new WeakMap(), Jr = new WeakMap(), Md = new WeakSet(), h4 = async function(e) {
  if (x(this, Jr) === -2)
    return;
  const t = eb(x(this, zc));
  t.fromBlock = x(this, Jr) + 1, t.toBlock = e;
  const n = await x(this, Ts).getLogs(t);
  if (n.length === 0) {
    x(this, Jr) < e - 60 && F(this, Jr, e - 60);
    return;
  }
  for (const s of n)
    x(this, Ts).emit(x(this, zc), s), F(this, Jr, s.blockNumber);
};
const Y7 = BigInt(2), Z7 = 10;
function Of(r) {
  return r && typeof r.then == "function";
}
function Jf(r, e) {
  return r + ":" + JSON.stringify(e, (t, n) => {
    if (n == null)
      return "null";
    if (typeof n == "bigint")
      return `bigint:${n.toString()}`;
    if (typeof n == "string")
      return n.toLowerCase();
    if (typeof n == "object" && !Array.isArray(n)) {
      const s = Object.keys(n);
      return s.sort(), s.reduce((i, a) => (i[a] = n[a], i), {});
    }
    return n;
  });
}
class yu {
  /**
   *  Create a new UnmanagedSubscriber with %%name%%.
   */
  constructor(e) {
    /**
     *  The name fof the event.
     */
    Q(this, "name");
    _e(this, { name: e });
  }
  start() {
  }
  stop() {
  }
  pause(e) {
  }
  resume() {
  }
}
function X7(r) {
  return JSON.parse(JSON.stringify(r));
}
function tb(r) {
  return r = Array.from(new Set(r).values()), r.sort(), r;
}
async function Jh(r, e) {
  if (r == null)
    throw new Error("invalid event");
  if (Array.isArray(r) && (r = { topics: r }), typeof r == "string")
    switch (r) {
      case "block":
      case "debug":
      case "error":
      case "finalized":
      case "network":
      case "pending":
      case "safe":
        return { type: r, tag: r };
    }
  if (dt(r, 32)) {
    const t = r.toLowerCase();
    return { type: "transaction", tag: Jf("tx", { hash: t }), hash: t };
  }
  if (r.orphan) {
    const t = r;
    return { type: "orphan", tag: Jf("orphan", t), filter: X7(t) };
  }
  if (r.address || r.topics) {
    const t = r, n = {
      topics: (t.topics || []).map((s) => s == null ? null : Array.isArray(s) ? tb(s.map((i) => i.toLowerCase())) : s.toLowerCase())
    };
    if (t.address) {
      const s = [], i = [], a = (o) => {
        dt(o) ? s.push(o) : i.push((async () => {
          s.push(await Dt(o, e));
        })());
      };
      Array.isArray(t.address) ? t.address.forEach(a) : a(t.address), i.length && await Promise.all(i), n.address = tb(s.map((o) => o.toLowerCase()));
    }
    return { filter: n, tag: Jf("event", n), type: "event" };
  }
  ue(!1, "unknown ProviderEvent", "event", r);
}
function Qh() {
  return (/* @__PURE__ */ new Date()).getTime();
}
const e9 = {
  cacheTimeout: 250,
  pollingInterval: 4e3
};
var er, Ei, tr, Qc, Cr, to, Pi, Bs, j0, Qr, qc, Wc, Xe, kr, rb, nb, a0, sb, o0, Qf;
class wu {
  /**
   *  Create a new **AbstractProvider** connected to %%network%%, or
   *  use the various network detection capabilities to discover the
   *  [[Network]] if necessary.
   */
  constructor(e, t) {
    Z(this, Xe);
    Z(this, er);
    Z(this, Ei);
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    Z(this, tr);
    Z(this, Qc);
    Z(this, Cr);
    Z(this, to);
    Z(this, Pi);
    // The most recent block number if running an event or -1 if no "block" event
    Z(this, Bs);
    Z(this, j0);
    Z(this, Qr);
    Z(this, qc);
    Z(this, Wc);
    if (F(this, Wc, Object.assign({}, e9, t || {})), e === "any")
      F(this, to, !0), F(this, Cr, null);
    else if (e) {
      const n = vt.from(e);
      F(this, to, !1), F(this, Cr, Promise.resolve(n)), setTimeout(() => {
        this.emit("network", n, null);
      }, 0);
    } else
      F(this, to, !1), F(this, Cr, null);
    F(this, Bs, -1), F(this, Pi, /* @__PURE__ */ new Map()), F(this, er, /* @__PURE__ */ new Map()), F(this, Ei, /* @__PURE__ */ new Map()), F(this, tr, null), F(this, Qc, !1), F(this, j0, 1), F(this, Qr, /* @__PURE__ */ new Map()), F(this, qc, !1);
  }
  get pollingInterval() {
    return x(this, Wc).pollingInterval;
  }
  /**
   *  Returns ``this``, to allow an **AbstractProvider** to implement
   *  the [[ContractRunner]] interface.
   */
  get provider() {
    return this;
  }
  /**
   *  Returns all the registered plug-ins.
   */
  get plugins() {
    return Array.from(x(this, Ei).values());
  }
  /**
   *  Attach a new plug-in.
   */
  attachPlugin(e) {
    if (x(this, Ei).get(e.name))
      throw new Error(`cannot replace existing plugin: ${e.name} `);
    return x(this, Ei).set(e.name, e.connect(this)), this;
  }
  /**
   *  Get a plugin by name.
   */
  getPlugin(e) {
    return x(this, Ei).get(e) || null;
  }
  /**
   *  Prevent any CCIP-read operation, regardless of whether requested
   *  in a [[call]] using ``enableCcipRead``.
   */
  get disableCcipRead() {
    return x(this, qc);
  }
  set disableCcipRead(e) {
    F(this, qc, !!e);
  }
  /**
   *  Resolves to the data for executing the CCIP-read operations.
   */
  async ccipReadFetch(e, t, n) {
    if (this.disableCcipRead || n.length === 0 || e.to == null)
      return null;
    const s = e.to.toLowerCase(), i = t.toLowerCase(), a = [];
    for (let o = 0; o < n.length; o++) {
      const u = n[o], c = u.replace("{sender}", s).replace("{data}", i), l = new Kt(c);
      u.indexOf("{data}") === -1 && (l.body = { data: i, sender: s }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: l, index: o, urls: n });
      let f = "unknown error", d;
      try {
        d = await l.send();
      } catch (h) {
        a.push(h.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: l, result: { error: h } });
        continue;
      }
      try {
        const h = d.bodyJson;
        if (h.data)
          return this.emit("debug", { action: "receiveCcipReadFetchResult", request: l, result: h }), h.data;
        h.message && (f = h.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: l, result: h });
      } catch {
      }
      Ee(d.statusCode < 400 || d.statusCode >= 500, `response not found during CCIP fetch: ${f}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: e, info: { url: u, errorMessage: f } }), a.push(f);
    }
    Ee(!1, `error encountered during CCIP fetch: ${a.map((o) => JSON.stringify(o)).join(", ")}`, "OFFCHAIN_FAULT", {
      reason: "500_SERVER_ERROR",
      transaction: e,
      info: { urls: n, errorMessages: a }
    });
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a block before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Block]].
   */
  _wrapBlock(e, t) {
    return new Sg(j7(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a log before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Log]].
   */
  _wrapLog(e, t) {
    return new No(F7(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  receipt before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionReceipt]].
   */
  _wrapTransactionReceipt(e, t) {
    return new rh($7(e), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  response before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionResponse]].
   */
  _wrapTransactionResponse(e, t) {
    return new mo(d4(e), this);
  }
  /**
   *  Resolves to the Network, forcing a network detection using whatever
   *  technique the sub-class requires.
   *
   *  Sub-classes **must** override this.
   */
  _detectNetwork() {
    Ee(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
      operation: "_detectNetwork"
    });
  }
  /**
   *  Sub-classes should use this to perform all built-in operations. All
   *  methods sanitizes and normalizes the values passed into this.
   *
   *  Sub-classes **must** override this.
   */
  async _perform(e) {
    Ee(!1, `unsupported method: ${e.method}`, "UNSUPPORTED_OPERATION", {
      operation: e.method,
      info: e
    });
  }
  // State
  async getBlockNumber() {
    const e = Ve(await de(this, Xe, kr).call(this, { method: "getBlockNumber" }), "%response");
    return x(this, Bs) >= 0 && F(this, Bs, e), e;
  }
  /**
   *  Returns or resolves to the address for %%address%%, resolving ENS
   *  names and [[Addressable]] objects and returning if already an
   *  address.
   */
  _getAddress(e) {
    return Dt(e, this);
  }
  /**
   *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
   *  negative values and returning if already a valid block tag.
   */
  _getBlockTag(e) {
    if (e == null)
      return "latest";
    switch (e) {
      case "earliest":
        return "0x0";
      case "finalized":
      case "latest":
      case "pending":
      case "safe":
        return e;
    }
    if (dt(e))
      return dt(e, 32) ? e : Rs(e);
    if (typeof e == "bigint" && (e = Ve(e, "blockTag")), typeof e == "number")
      return e >= 0 ? Rs(e) : x(this, Bs) >= 0 ? Rs(x(this, Bs) + e) : this.getBlockNumber().then((t) => Rs(t + e));
    ue(!1, "invalid blockTag", "blockTag", e);
  }
  /**
   *  Returns or resolves to a filter for %%filter%%, resolving any ENS
   *  names or [[Addressable]] object and returning if already a valid
   *  filter.
   */
  _getFilter(e) {
    const t = (e.topics || []).map((u) => u == null ? null : Array.isArray(u) ? tb(u.map((c) => c.toLowerCase())) : u.toLowerCase()), n = "blockHash" in e ? e.blockHash : void 0, s = (u, c, l) => {
      let f;
      switch (u.length) {
        case 0:
          break;
        case 1:
          f = u[0];
          break;
        default:
          u.sort(), f = u;
      }
      if (n && (c != null || l != null))
        throw new Error("invalid filter");
      const d = {};
      return f && (d.address = f), t.length && (d.topics = t), c && (d.fromBlock = c), l && (d.toBlock = l), n && (d.blockHash = n), d;
    };
    let i = [];
    if (e.address)
      if (Array.isArray(e.address))
        for (const u of e.address)
          i.push(this._getAddress(u));
      else
        i.push(this._getAddress(e.address));
    let a;
    "fromBlock" in e && (a = this._getBlockTag(e.fromBlock));
    let o;
    return "toBlock" in e && (o = this._getBlockTag(e.toBlock)), i.filter((u) => typeof u != "string").length || a != null && typeof a != "string" || o != null && typeof o != "string" ? Promise.all([Promise.all(i), a, o]).then((u) => s(u[0], u[1], u[2])) : s(i, a, o);
  }
  /**
   *  Returns or resolves to a transaction for %%request%%, resolving
   *  any ENS names or [[Addressable]] and returning if already a valid
   *  transaction.
   */
  _getTransactionRequest(e) {
    const t = xo(e), n = [];
    if (["to", "from"].forEach((s) => {
      if (t[s] == null)
        return;
      const i = Dt(t[s], this);
      Of(i) ? n.push(async function() {
        t[s] = await i;
      }()) : t[s] = i;
    }), t.blockTag != null) {
      const s = this._getBlockTag(t.blockTag);
      Of(s) ? n.push(async function() {
        t.blockTag = await s;
      }()) : t.blockTag = s;
    }
    return n.length ? async function() {
      return await Promise.all(n), t;
    }() : t;
  }
  async getNetwork() {
    if (x(this, Cr) == null) {
      const s = (async () => {
        try {
          const i = await this._detectNetwork();
          return this.emit("network", i, null), i;
        } catch (i) {
          throw x(this, Cr) === s && F(this, Cr, null), i;
        }
      })();
      return F(this, Cr, s), (await s).clone();
    }
    const e = x(this, Cr), [t, n] = await Promise.all([
      e,
      this._detectNetwork()
      // The actual connected network
    ]);
    return t.chainId !== n.chainId && (x(this, to) ? (this.emit("network", n, t), x(this, Cr) === e && F(this, Cr, Promise.resolve(n))) : Ee(!1, `network changed: ${t.chainId} => ${n.chainId} `, "NETWORK_ERROR", {
      event: "changed"
    })), t.clone();
  }
  async getFeeData() {
    const e = await this.getNetwork(), t = async () => {
      const { _block: s, gasPrice: i, priorityFee: a } = await Lt({
        _block: de(this, Xe, sb).call(this, "latest", !1),
        gasPrice: (async () => {
          try {
            const l = await de(this, Xe, kr).call(this, { method: "getGasPrice" });
            return De(l, "%response");
          } catch {
          }
          return null;
        })(),
        priorityFee: (async () => {
          try {
            const l = await de(this, Xe, kr).call(this, { method: "getPriorityFee" });
            return De(l, "%response");
          } catch {
          }
          return null;
        })()
      });
      let o = null, u = null;
      const c = this._wrapBlock(s, e);
      return c && c.baseFeePerGas && (u = a ?? BigInt("1000000000"), o = c.baseFeePerGas * Y7 + u), new bd(i, o, u);
    }, n = e.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    if (n) {
      const s = new Kt(n.url), i = await n.processFunc(t, this, s);
      return new bd(i.gasPrice, i.maxFeePerGas, i.maxPriorityFeePerGas);
    }
    return await t();
  }
  async estimateGas(e) {
    let t = this._getTransactionRequest(e);
    return Of(t) && (t = await t), De(await de(this, Xe, kr).call(this, {
      method: "estimateGas",
      transaction: t
    }), "%response");
  }
  async call(e) {
    const { tx: t, blockTag: n } = await Lt({
      tx: this._getTransactionRequest(e),
      blockTag: this._getBlockTag(e.blockTag)
    });
    return await de(this, Xe, nb).call(this, de(this, Xe, rb).call(this, t, n, e.enableCcipRead ? 0 : -1));
  }
  async getBalance(e, t) {
    return De(await de(this, Xe, a0).call(this, { method: "getBalance" }, e, t), "%response");
  }
  async getTransactionCount(e, t) {
    return Ve(await de(this, Xe, a0).call(this, { method: "getTransactionCount" }, e, t), "%response");
  }
  async getCode(e, t) {
    return Oe(await de(this, Xe, a0).call(this, { method: "getCode" }, e, t));
  }
  async getStorage(e, t, n) {
    const s = De(t, "position");
    return Oe(await de(this, Xe, a0).call(this, { method: "getStorage", position: s }, e, n));
  }
  // Write
  async broadcastTransaction(e) {
    const { blockNumber: t, hash: n, network: s } = await Lt({
      blockNumber: this.getBlockNumber(),
      hash: this._perform({
        method: "broadcastTransaction",
        signedTransaction: e
      }),
      network: this.getNetwork()
    }), i = Ii.from(e);
    if (i.hash !== n)
      throw new Error("@TODO: the returned hash did not match");
    return this._wrapTransactionResponse(i, s).replaceableTransaction(t);
  }
  // Queries
  async getBlock(e, t) {
    const { network: n, params: s } = await Lt({
      network: this.getNetwork(),
      params: de(this, Xe, sb).call(this, e, !!t)
    });
    return s == null ? null : this._wrapBlock(s, n);
  }
  async getTransaction(e) {
    const { network: t, params: n } = await Lt({
      network: this.getNetwork(),
      params: de(this, Xe, kr).call(this, { method: "getTransaction", hash: e })
    });
    return n == null ? null : this._wrapTransactionResponse(n, t);
  }
  async getTransactionReceipt(e) {
    const { network: t, params: n } = await Lt({
      network: this.getNetwork(),
      params: de(this, Xe, kr).call(this, { method: "getTransactionReceipt", hash: e })
    });
    if (n == null)
      return null;
    if (n.gasPrice == null && n.effectiveGasPrice == null) {
      const s = await de(this, Xe, kr).call(this, { method: "getTransaction", hash: e });
      if (s == null)
        throw new Error("report this; could not find tx or effectiveGasPrice");
      n.effectiveGasPrice = s.gasPrice;
    }
    return this._wrapTransactionReceipt(n, t);
  }
  async getTransactionResult(e) {
    const { result: t } = await Lt({
      network: this.getNetwork(),
      result: de(this, Xe, kr).call(this, { method: "getTransactionResult", hash: e })
    });
    return t == null ? null : Oe(t);
  }
  // Bloom-filter Queries
  async getLogs(e) {
    let t = this._getFilter(e);
    Of(t) && (t = await t);
    const { network: n, params: s } = await Lt({
      network: this.getNetwork(),
      params: de(this, Xe, kr).call(this, { method: "getLogs", filter: t })
    });
    return s.map((i) => this._wrapLog(i, n));
  }
  // ENS
  _getProvider(e) {
    Ee(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
      operation: "_getProvider()"
    });
  }
  async getResolver(e) {
    return await xu.fromName(this, e);
  }
  async getAvatar(e) {
    const t = await this.getResolver(e);
    return t ? await t.getAvatar() : null;
  }
  async resolveName(e) {
    const t = await this.getResolver(e);
    return t ? await t.getAddress() : null;
  }
  async lookupAddress(e) {
    e = et(e);
    const t = T0(e.substring(2).toLowerCase() + ".addr.reverse");
    try {
      const n = await xu.getEnsAddress(this), i = await new Ci(n, [
        "function resolver(bytes32) view returns (address)"
      ], this).resolver(t);
      if (i == null || i === bo)
        return null;
      const o = await new Ci(i, [
        "function name(bytes32) view returns (string)"
      ], this).name(t);
      return await this.resolveName(o) !== e ? null : o;
    } catch (n) {
      if (Ct(n, "BAD_DATA") && n.value === "0x" || Ct(n, "CALL_EXCEPTION"))
        return null;
      throw n;
    }
    return null;
  }
  async waitForTransaction(e, t, n) {
    const s = t ?? 1;
    return s === 0 ? this.getTransactionReceipt(e) : new Promise(async (i, a) => {
      let o = null;
      const u = async (c) => {
        try {
          const l = await this.getTransactionReceipt(e);
          if (l != null && c - l.blockNumber + 1 >= s) {
            i(l), o && (clearTimeout(o), o = null);
            return;
          }
        } catch (l) {
          console.log("EEE", l);
        }
        this.once("block", u);
      };
      n != null && (o = setTimeout(() => {
        o != null && (o = null, this.off("block", u), a(xt("timeout", "TIMEOUT", { reason: "timeout" })));
      }, n)), u(await this.getBlockNumber());
    });
  }
  async waitForBlock(e) {
    Ee(!1, "not implemented yet", "NOT_IMPLEMENTED", {
      operation: "waitForBlock"
    });
  }
  /**
   *  Clear a timer created using the [[_setTimeout]] method.
   */
  _clearTimeout(e) {
    const t = x(this, Qr).get(e);
    t && (t.timer && clearTimeout(t.timer), x(this, Qr).delete(e));
  }
  /**
   *  Create a timer that will execute %%func%% after at least %%timeout%%
   *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
   *  in the next event loop.
   *
   *  [Pausing](AbstractProvider-paused) the provider will pause any
   *  associated timers.
   */
  _setTimeout(e, t) {
    t == null && (t = 0);
    const n = rn(this, j0)._++, s = () => {
      x(this, Qr).delete(n), e();
    };
    if (this.paused)
      x(this, Qr).set(n, { timer: null, func: s, time: t });
    else {
      const i = setTimeout(s, t);
      x(this, Qr).set(n, { timer: i, func: s, time: Qh() });
    }
    return n;
  }
  /**
   *  Perform %%func%% on each subscriber.
   */
  _forEachSubscriber(e) {
    for (const t of x(this, er).values())
      e(t.subscriber);
  }
  /**
   *  Sub-classes may override this to customize subscription
   *  implementations.
   */
  _getSubscriber(e) {
    switch (e.type) {
      case "debug":
      case "error":
      case "network":
        return new yu(e.type);
      case "block": {
        const t = new J7(this);
        return t.pollingInterval = this.pollingInterval, t;
      }
      case "safe":
      case "finalized":
        return new Q7(this, e.type);
      case "event":
        return new Fg(this, e.filter);
      case "transaction":
        return new W7(this, e.hash);
      case "orphan":
        return new q7(this, e.filter);
    }
    throw new Error(`unsupported event: ${e.type}`);
  }
  /**
   *  If a [[Subscriber]] fails and needs to replace itself, this
   *  method may be used.
   *
   *  For example, this is used for providers when using the
   *  ``eth_getFilterChanges`` method, which can return null if state
   *  filters are not supported by the backend, allowing the Subscriber
   *  to swap in a [[PollingEventSubscriber]].
   */
  _recoverSubscriber(e, t) {
    for (const n of x(this, er).values())
      if (n.subscriber === e) {
        n.started && n.subscriber.stop(), n.subscriber = t, n.started && t.start(), x(this, tr) != null && t.pause(x(this, tr));
        break;
      }
  }
  async on(e, t) {
    const n = await de(this, Xe, Qf).call(this, e);
    return n.listeners.push({ listener: t, once: !1 }), n.started || (n.subscriber.start(), n.started = !0, x(this, tr) != null && n.subscriber.pause(x(this, tr))), this;
  }
  async once(e, t) {
    const n = await de(this, Xe, Qf).call(this, e);
    return n.listeners.push({ listener: t, once: !0 }), n.started || (n.subscriber.start(), n.started = !0, x(this, tr) != null && n.subscriber.pause(x(this, tr))), this;
  }
  async emit(e, ...t) {
    const n = await de(this, Xe, o0).call(this, e, t);
    if (!n || n.listeners.length === 0)
      return !1;
    const s = n.listeners.length;
    return n.listeners = n.listeners.filter(({ listener: i, once: a }) => {
      const o = new Vd(this, a ? null : i, e);
      try {
        i.call(this, ...t, o);
      } catch {
      }
      return !a;
    }), n.listeners.length === 0 && (n.started && n.subscriber.stop(), x(this, er).delete(n.tag)), s > 0;
  }
  async listenerCount(e) {
    if (e) {
      const n = await de(this, Xe, o0).call(this, e);
      return n ? n.listeners.length : 0;
    }
    let t = 0;
    for (const { listeners: n } of x(this, er).values())
      t += n.length;
    return t;
  }
  async listeners(e) {
    if (e) {
      const n = await de(this, Xe, o0).call(this, e);
      return n ? n.listeners.map(({ listener: s }) => s) : [];
    }
    let t = [];
    for (const { listeners: n } of x(this, er).values())
      t = t.concat(n.map(({ listener: s }) => s));
    return t;
  }
  async off(e, t) {
    const n = await de(this, Xe, o0).call(this, e);
    if (!n)
      return this;
    if (t) {
      const s = n.listeners.map(({ listener: i }) => i).indexOf(t);
      s >= 0 && n.listeners.splice(s, 1);
    }
    return (!t || n.listeners.length === 0) && (n.started && n.subscriber.stop(), x(this, er).delete(n.tag)), this;
  }
  async removeAllListeners(e) {
    if (e) {
      const { tag: t, started: n, subscriber: s } = await de(this, Xe, Qf).call(this, e);
      n && s.stop(), x(this, er).delete(t);
    } else
      for (const [t, { started: n, subscriber: s }] of x(this, er))
        n && s.stop(), x(this, er).delete(t);
    return this;
  }
  // Alias for "on"
  async addListener(e, t) {
    return await this.on(e, t);
  }
  // Alias for "off"
  async removeListener(e, t) {
    return this.off(e, t);
  }
  /**
   *  If this provider has been destroyed using the [[destroy]] method.
   *
   *  Once destroyed, all resources are reclaimed, internal event loops
   *  and timers are cleaned up and no further requests may be sent to
   *  the provider.
   */
  get destroyed() {
    return x(this, Qc);
  }
  /**
   *  Sub-classes may use this to shutdown any sockets or release their
   *  resources and reject any pending requests.
   *
   *  Sub-classes **must** call ``super.destroy()``.
   */
  destroy() {
    this.removeAllListeners();
    for (const e of x(this, Qr).keys())
      this._clearTimeout(e);
    F(this, Qc, !0);
  }
  /**
   *  Whether the provider is currently paused.
   *
   *  A paused provider will not emit any events, and generally should
   *  not make any requests to the network, but that is up to sub-classes
   *  to manage.
   *
   *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
   *  which will buffer any events that occur while paused until the
   *  provider is unpaused.
   */
  get paused() {
    return x(this, tr) != null;
  }
  set paused(e) {
    !!e !== this.paused && (this.paused ? this.resume() : this.pause(!1));
  }
  /**
   *  Pause the provider. If %%dropWhilePaused%%, any events that occur
   *  while paused are dropped, otherwise all events will be emitted once
   *  the provider is unpaused.
   */
  pause(e) {
    if (F(this, Bs, -1), x(this, tr) != null) {
      if (x(this, tr) == !!e)
        return;
      Ee(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
        operation: "pause"
      });
    }
    this._forEachSubscriber((t) => t.pause(e)), F(this, tr, !!e);
    for (const t of x(this, Qr).values())
      t.timer && clearTimeout(t.timer), t.time = Qh() - t.time;
  }
  /**
   *  Resume the provider.
   */
  resume() {
    if (x(this, tr) != null) {
      this._forEachSubscriber((e) => e.resume()), F(this, tr, null);
      for (const e of x(this, Qr).values()) {
        let t = e.time;
        t < 0 && (t = 0), e.time = Qh(), setTimeout(e.func, t);
      }
    }
  }
}
er = new WeakMap(), Ei = new WeakMap(), tr = new WeakMap(), Qc = new WeakMap(), Cr = new WeakMap(), to = new WeakMap(), Pi = new WeakMap(), Bs = new WeakMap(), j0 = new WeakMap(), Qr = new WeakMap(), qc = new WeakMap(), Wc = new WeakMap(), Xe = new WeakSet(), kr = async function(e) {
  const t = x(this, Wc).cacheTimeout;
  if (t < 0)
    return await this._perform(e);
  const n = Jf(e.method, e);
  let s = x(this, Pi).get(n);
  return s || (s = this._perform(e), x(this, Pi).set(n, s), setTimeout(() => {
    x(this, Pi).get(n) === s && x(this, Pi).delete(n);
  }, t)), await s;
}, rb = async function(e, t, n) {
  Ee(n < Z7, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
    reason: "TOO_MANY_REDIRECTS",
    transaction: Object.assign({}, e, { blockTag: t, enableCcipRead: !0 })
  });
  const s = xo(e);
  try {
    return Oe(await this._perform({ method: "call", transaction: s, blockTag: t }));
  } catch (i) {
    if (!this.disableCcipRead && q0(i) && i.data && n >= 0 && t === "latest" && s.to != null && lt(i.data, 0, 4) === "0x556f1830") {
      const a = i.data, o = await Dt(s.to, this);
      let u;
      try {
        u = i9(lt(i.data, 4));
      } catch (f) {
        Ee(!1, f.message, "OFFCHAIN_FAULT", {
          reason: "BAD_DATA",
          transaction: s,
          info: { data: a }
        });
      }
      Ee(u.sender.toLowerCase() === o.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
        action: "call",
        data: a,
        reason: "OffchainLookup",
        transaction: s,
        invocation: null,
        revert: {
          signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
          name: "OffchainLookup",
          args: u.errorArgs
        }
      });
      const c = await this.ccipReadFetch(s, u.calldata, u.urls);
      Ee(c != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
        reason: "FETCH_FAILED",
        transaction: s,
        info: { data: i.data, errorArgs: u.errorArgs }
      });
      const l = {
        to: o,
        data: it([u.selector, s9([c, u.extraData])])
      };
      this.emit("debug", { action: "sendCcipReadCall", transaction: l });
      try {
        const f = await de(this, Xe, rb).call(this, l, t, n + 1);
        return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, l), result: f }), f;
      } catch (f) {
        throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, l), error: f }), f;
      }
    }
    throw i;
  }
}, nb = async function(e) {
  const { value: t } = await Lt({
    network: this.getNetwork(),
    value: e
  });
  return t;
}, a0 = async function(e, t, n) {
  let s = this._getAddress(t), i = this._getBlockTag(n);
  return (typeof s != "string" || typeof i != "string") && ([s, i] = await Promise.all([s, i])), await de(this, Xe, nb).call(this, de(this, Xe, kr).call(this, Object.assign(e, { address: s, blockTag: i })));
}, sb = async function(e, t) {
  if (dt(e, 32))
    return await de(this, Xe, kr).call(this, {
      method: "getBlock",
      blockHash: e,
      includeTransactions: t
    });
  let n = this._getBlockTag(e);
  return typeof n != "string" && (n = await n), await de(this, Xe, kr).call(this, {
    method: "getBlock",
    blockTag: n,
    includeTransactions: t
  });
}, o0 = async function(e, t) {
  let n = await Jh(e, this);
  return n.type === "event" && t && t.length > 0 && t[0].removed === !0 && (n = await Jh({ orphan: "drop-log", log: t[0] }, this)), x(this, er).get(n.tag) || null;
}, Qf = async function(e) {
  const t = await Jh(e, this), n = t.tag;
  let s = x(this, er).get(n);
  return s || (s = { subscriber: this._getSubscriber(t), tag: n, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, x(this, er).set(n, s)), s;
};
function t9(r, e) {
  try {
    const t = ib(r, e);
    if (t)
      return Fs(t);
  } catch {
  }
  return null;
}
function ib(r, e) {
  if (r === "0x")
    return null;
  try {
    const t = Ve(lt(r, e, e + 32)), n = Ve(lt(r, t, t + 32));
    return lt(r, t + 32, t + 32 + n);
  } catch {
  }
  return null;
}
function Vm(r) {
  const e = Ft(r);
  if (e.length > 32)
    throw new Error("internal; should not happen");
  const t = new Uint8Array(32);
  return t.set(e, 32 - e.length), t;
}
function r9(r) {
  if (r.length % 32 === 0)
    return r;
  const e = new Uint8Array(Math.ceil(r.length / 32) * 32);
  return e.set(r), e;
}
const n9 = new Uint8Array([]);
function s9(r) {
  const e = [];
  let t = 0;
  for (let n = 0; n < r.length; n++)
    e.push(n9), t += 32;
  for (let n = 0; n < r.length; n++) {
    const s = Ce(r[n]);
    e[n] = Vm(t), e.push(Vm(s.length)), e.push(r9(s)), t += 32 + Math.ceil(s.length / 32) * 32;
  }
  return it(e);
}
const $m = "0x0000000000000000000000000000000000000000000000000000000000000000";
function i9(r) {
  const e = {
    sender: "",
    urls: [],
    calldata: "",
    selector: "",
    extraData: "",
    errorArgs: []
  };
  Ee(Is(r) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
    reason: "insufficient OffchainLookup data"
  });
  const t = lt(r, 0, 32);
  Ee(lt(t, 0, 12) === lt($m, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup sender"
  }), e.sender = lt(t, 12);
  try {
    const n = [], s = Ve(lt(r, 32, 64)), i = Ve(lt(r, s, s + 32)), a = lt(r, s + 32);
    for (let o = 0; o < i; o++) {
      const u = t9(a, o * 32);
      if (u == null)
        throw new Error("abort");
      n.push(u);
    }
    e.urls = n;
  } catch {
    Ee(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup urls"
    });
  }
  try {
    const n = ib(r, 64);
    if (n == null)
      throw new Error("abort");
    e.calldata = n;
  } catch {
    Ee(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup calldata"
    });
  }
  Ee(lt(r, 100, 128) === lt($m, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup callbaackSelector"
  }), e.selector = lt(r, 96, 100);
  try {
    const n = ib(r, 128);
    if (n == null)
      throw new Error("abort");
    e.extraData = n;
  } catch {
    Ee(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup extraData"
    });
  }
  return e.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((n) => e[n]), e;
}
function Jo(r, e) {
  if (r.provider)
    return r.provider;
  Ee(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: e });
}
async function Km(r, e) {
  let t = xo(e);
  if (t.to != null && (t.to = Dt(t.to, r)), t.from != null) {
    const n = t.from;
    t.from = Promise.all([
      r.getAddress(),
      Dt(n, r)
    ]).then(([s, i]) => (ue(s.toLowerCase() === i.toLowerCase(), "transaction from mismatch", "tx.from", i), s));
  } else
    t.from = r.getAddress();
  return await Lt(t);
}
class Mu {
  /**
   *  Creates a new Signer connected to %%provider%%.
   */
  constructor(e) {
    /**
     *  The provider this signer is connected to.
     */
    Q(this, "provider");
    _e(this, { provider: e || null });
  }
  async getNonce(e) {
    return Jo(this, "getTransactionCount").getTransactionCount(await this.getAddress(), e);
  }
  async populateCall(e) {
    return await Km(this, e);
  }
  async populateTransaction(e) {
    const t = Jo(this, "populateTransaction"), n = await Km(this, e);
    n.nonce == null && (n.nonce = await this.getNonce("pending")), n.gasLimit == null && (n.gasLimit = await this.estimateGas(n));
    const s = await this.provider.getNetwork();
    if (n.chainId != null) {
      const a = De(n.chainId);
      ue(a === s.chainId, "transaction chainId mismatch", "tx.chainId", e.chainId);
    } else
      n.chainId = s.chainId;
    const i = n.maxFeePerGas != null || n.maxPriorityFeePerGas != null;
    if (n.gasPrice != null && (n.type === 2 || i) ? ue(!1, "eip-1559 transaction do not support gasPrice", "tx", e) : (n.type === 0 || n.type === 1) && i && ue(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", e), (n.type === 2 || n.type == null) && n.maxFeePerGas != null && n.maxPriorityFeePerGas != null)
      n.type = 2;
    else if (n.type === 0 || n.type === 1) {
      const a = await t.getFeeData();
      Ee(a.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
        operation: "getGasPrice"
      }), n.gasPrice == null && (n.gasPrice = a.gasPrice);
    } else {
      const a = await t.getFeeData();
      if (n.type == null)
        if (a.maxFeePerGas != null && a.maxPriorityFeePerGas != null)
          if (n.type = 2, n.gasPrice != null) {
            const o = n.gasPrice;
            delete n.gasPrice, n.maxFeePerGas = o, n.maxPriorityFeePerGas = o;
          } else
            n.maxFeePerGas == null && (n.maxFeePerGas = a.maxFeePerGas), n.maxPriorityFeePerGas == null && (n.maxPriorityFeePerGas = a.maxPriorityFeePerGas);
        else a.gasPrice != null ? (Ee(!i, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
          operation: "populateTransaction"
        }), n.gasPrice == null && (n.gasPrice = a.gasPrice), n.type = 0) : Ee(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
          operation: "signer.getFeeData"
        });
      else (n.type === 2 || n.type === 3) && (n.maxFeePerGas == null && (n.maxFeePerGas = a.maxFeePerGas), n.maxPriorityFeePerGas == null && (n.maxPriorityFeePerGas = a.maxPriorityFeePerGas));
    }
    return await Lt(n);
  }
  async estimateGas(e) {
    return Jo(this, "estimateGas").estimateGas(await this.populateCall(e));
  }
  async call(e) {
    return Jo(this, "call").call(await this.populateCall(e));
  }
  async resolveName(e) {
    return await Jo(this, "resolveName").resolveName(e);
  }
  async sendTransaction(e) {
    const t = Jo(this, "sendTransaction"), n = await this.populateTransaction(e);
    delete n.from;
    const s = Ii.from(n);
    return await t.broadcastTransaction(await this.signTransaction(s));
  }
}
var Yc, qf;
const kx = class kx extends Mu {
  /**
   *  Creates a new **VoidSigner** with %%address%% attached to
   *  %%provider%%.
   */
  constructor(t, n) {
    super(n);
    Z(this, Yc);
    /**
     *  The signer address.
     */
    Q(this, "address");
    _e(this, { address: t });
  }
  async getAddress() {
    return this.address;
  }
  connect(t) {
    return new kx(this.address, t);
  }
  async signTransaction(t) {
    de(this, Yc, qf).call(this, "transactions", "signTransaction");
  }
  async signMessage(t) {
    de(this, Yc, qf).call(this, "messages", "signMessage");
  }
  async signTypedData(t, n, s) {
    de(this, Yc, qf).call(this, "typed-data", "signTypedData");
  }
};
Yc = new WeakSet(), qf = function(t, n) {
  Ee(!1, `VoidSigner cannot sign ${t}`, "UNSUPPORTED_OPERATION", { operation: n });
};
let Au = kx;
const zm = /* @__PURE__ */ new Set();
function qs(r) {
  zm.has(r) || (zm.add(r), console.log("========= NOTICE ========="), console.log(`Request-Rate Exceeded for ${r} (this message will not be repeated)`), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.org/api-keys/"), console.log("=========================="));
}
function a9(r) {
  return JSON.parse(JSON.stringify(r));
}
var or, zn, ro, vi, no, Zc, Li, ab, ob;
class p4 {
  /**
   *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
   *  and [[_emitResults]] to setup the subscription and provide the event
   *  to the %%provider%%.
   */
  constructor(e) {
    Z(this, Li);
    Z(this, or);
    Z(this, zn);
    Z(this, ro);
    Z(this, vi);
    Z(this, no);
    Z(this, Zc);
    F(this, or, e), F(this, zn, null), F(this, ro, de(this, Li, ab).bind(this)), F(this, vi, !1), F(this, no, null), F(this, Zc, !1);
  }
  /**
   *  Sub-classes **must** override this to begin the subscription.
   */
  _subscribe(e) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle the events.
   */
  _emitResults(e, t) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle recovery on errors.
   */
  _recover(e) {
    throw new Error("subclasses must override this");
  }
  start() {
    x(this, vi) || (F(this, vi, !0), de(this, Li, ab).call(this, -2));
  }
  stop() {
    x(this, vi) && (F(this, vi, !1), F(this, Zc, !0), de(this, Li, ob).call(this), x(this, or).off("block", x(this, ro)));
  }
  pause(e) {
    e && de(this, Li, ob).call(this), x(this, or).off("block", x(this, ro));
  }
  resume() {
    this.start();
  }
}
or = new WeakMap(), zn = new WeakMap(), ro = new WeakMap(), vi = new WeakMap(), no = new WeakMap(), Zc = new WeakMap(), Li = new WeakSet(), ab = async function(e) {
  try {
    x(this, zn) == null && F(this, zn, this._subscribe(x(this, or)));
    let t = null;
    try {
      t = await x(this, zn);
    } catch (i) {
      if (!Ct(i, "UNSUPPORTED_OPERATION") || i.operation !== "eth_newFilter")
        throw i;
    }
    if (t == null) {
      F(this, zn, null), x(this, or)._recoverSubscriber(this, this._recover(x(this, or)));
      return;
    }
    const n = await x(this, or).getNetwork();
    if (x(this, no) || F(this, no, n), x(this, no).chainId !== n.chainId)
      throw new Error("chaid changed");
    if (x(this, Zc))
      return;
    const s = await x(this, or).send("eth_getFilterChanges", [t]);
    await this._emitResults(x(this, or), s);
  } catch (t) {
    console.log("@TODO", t);
  }
  x(this, or).once("block", x(this, ro));
}, ob = function() {
  const e = x(this, zn);
  e && (F(this, zn, null), e.then((t) => {
    x(this, or).destroyed || x(this, or).send("eth_uninstallFilter", [t]);
  }));
};
var so;
class o9 extends p4 {
  /**
   *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
   *  listening for %%filter%%.
   */
  constructor(t, n) {
    super(t);
    Z(this, so);
    F(this, so, a9(n));
  }
  _recover(t) {
    return new Fg(t, x(this, so));
  }
  async _subscribe(t) {
    return await t.send("eth_newFilter", [x(this, so)]);
  }
  async _emitResults(t, n) {
    for (const s of n)
      t.emit(x(this, so), t._wrapLog(s, t._network));
  }
}
so = new WeakMap();
class c9 extends p4 {
  async _subscribe(e) {
    return await e.send("eth_newPendingTransactionFilter", []);
  }
  async _emitResults(e, t) {
    for (const n of t)
      e.emit("pending", n);
  }
}
const u9 = "bigint,boolean,function,number,string,symbol".split(/,/g);
function Wf(r) {
  if (r == null || u9.indexOf(typeof r) >= 0 || typeof r.getAddress == "function")
    return r;
  if (Array.isArray(r))
    return r.map(Wf);
  if (typeof r == "object")
    return Object.keys(r).reduce((e, t) => (e[t] = r[t], e), {});
  throw new Error(`should not happen: ${r} (${typeof r})`);
}
function l9(r) {
  return new Promise((e) => {
    setTimeout(e, r);
  });
}
function Qo(r) {
  return r && r.toLowerCase();
}
function Jm(r) {
  return r && typeof r.pollingInterval == "number";
}
const b4 = {
  polling: !1,
  staticNetwork: null,
  batchStallTime: 10,
  batchMaxSize: 1 << 20,
  batchMaxCount: 100,
  cacheTimeout: 250,
  pollingInterval: 4e3
};
class x0 extends Mu {
  constructor(t, n) {
    super(t);
    Q(this, "address");
    n = et(n), _e(this, { address: n });
  }
  connect(t) {
    Ee(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
      operation: "signer.connect"
    });
  }
  async getAddress() {
    return this.address;
  }
  // JSON-RPC will automatially fill in nonce, etc. so we just check from
  async populateTransaction(t) {
    return await this.populateCall(t);
  }
  // Returns just the hash of the transaction after sent, which is what
  // the bare JSON-RPC API does;
  async sendUncheckedTransaction(t) {
    const n = Wf(t), s = [];
    if (n.from) {
      const a = n.from;
      s.push((async () => {
        const o = await Dt(a, this.provider);
        ue(o != null && o.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", t), n.from = o;
      })());
    } else
      n.from = this.address;
    if (n.gasLimit == null && s.push((async () => {
      n.gasLimit = await this.provider.estimateGas({ ...n, from: this.address });
    })()), n.to != null) {
      const a = n.to;
      s.push((async () => {
        n.to = await Dt(a, this.provider);
      })());
    }
    s.length && await Promise.all(s);
    const i = this.provider.getRpcTransaction(n);
    return this.provider.send("eth_sendTransaction", [i]);
  }
  async sendTransaction(t) {
    const n = await this.provider.getBlockNumber(), s = await this.sendUncheckedTransaction(t);
    return await new Promise((i, a) => {
      const o = [1e3, 100];
      let u = 0;
      const c = async () => {
        try {
          const l = await this.provider.getTransaction(s);
          if (l != null) {
            i(l.replaceableTransaction(n));
            return;
          }
        } catch (l) {
          if (Ct(l, "CANCELLED") || Ct(l, "BAD_DATA") || Ct(l, "NETWORK_ERROR") || Ct(l, "UNSUPPORTED_OPERATION")) {
            l.info == null && (l.info = {}), l.info.sendTransactionHash = s, a(l);
            return;
          }
          if (Ct(l, "INVALID_ARGUMENT") && (u++, l.info == null && (l.info = {}), l.info.sendTransactionHash = s, u > 10)) {
            a(l);
            return;
          }
          this.provider.emit("error", xt("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: l }));
        }
        this.provider._setTimeout(() => {
          c();
        }, o.pop() || 4e3);
      };
      c();
    });
  }
  async signTransaction(t) {
    const n = Wf(t);
    if (n.from) {
      const i = await Dt(n.from, this.provider);
      ue(i != null && i.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", t), n.from = i;
    } else
      n.from = this.address;
    const s = this.provider.getRpcTransaction(n);
    return await this.provider.send("eth_signTransaction", [s]);
  }
  async signMessage(t) {
    const n = typeof t == "string" ? It(t) : t;
    return await this.provider.send("personal_sign", [
      Oe(n),
      this.address.toLowerCase()
    ]);
  }
  async signTypedData(t, n, s) {
    const i = Wf(s), a = await js.resolveNames(t, n, i, async (o) => {
      const u = await Dt(o);
      return ue(u != null, "TypedData does not support null address", "value", o), u;
    });
    return await this.provider.send("eth_signTypedData_v4", [
      this.address.toLowerCase(),
      JSON.stringify(js.getPayload(a.domain, n, a.value))
    ]);
  }
  async unlock(t) {
    return this.provider.send("personal_unlockAccount", [
      this.address.toLowerCase(),
      t,
      null
    ]);
  }
  // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
  async _legacySignMessage(t) {
    const n = typeof t == "string" ? It(t) : t;
    return await this.provider.send("eth_sign", [
      this.address.toLowerCase(),
      Oe(n)
    ]);
  }
}
var io, Xc, Os, Jn, mn, qr, dr, H0, cb;
class ch extends wu {
  constructor(t, n) {
    super(t, n);
    Z(this, H0);
    Z(this, io);
    // The next ID to use for the JSON-RPC ID field
    Z(this, Xc);
    // Payloads are queued and triggered in batches using the drainTimer
    Z(this, Os);
    Z(this, Jn);
    Z(this, mn);
    Z(this, qr);
    Z(this, dr);
    F(this, Xc, 1), F(this, io, Object.assign({}, b4, n || {})), F(this, Os, []), F(this, Jn, null), F(this, qr, null), F(this, dr, null);
    {
      let i = null;
      const a = new Promise((o) => {
        i = o;
      });
      F(this, mn, { promise: a, resolve: i });
    }
    const s = this._getOption("staticNetwork");
    typeof s == "boolean" ? (ue(!s || t !== "any", "staticNetwork cannot be used on special network 'any'", "options", n), s && t != null && F(this, qr, vt.from(t))) : s && (ue(t == null || s.matches(t), "staticNetwork MUST match network object", "options", n), F(this, qr, s));
  }
  /**
   *  Returns the value associated with the option %%key%%.
   *
   *  Sub-classes can use this to inquire about configuration options.
   */
  _getOption(t) {
    return x(this, io)[t];
  }
  /**
   *  Gets the [[Network]] this provider has committed to. On each call, the network
   *  is detected, and if it has changed, the call will reject.
   */
  get _network() {
    return Ee(x(this, qr), "network is not available yet", "NETWORK_ERROR"), x(this, qr);
  }
  /**
   *  Resolves to the non-normalized value by performing %%req%%.
   *
   *  Sub-classes may override this to modify behavior of actions,
   *  and should generally call ``super._perform`` as a fallback.
   */
  async _perform(t) {
    if (t.method === "call" || t.method === "estimateGas") {
      let s = t.transaction;
      if (s && s.type != null && De(s.type) && s.maxFeePerGas == null && s.maxPriorityFeePerGas == null) {
        const i = await this.getFeeData();
        i.maxFeePerGas == null && i.maxPriorityFeePerGas == null && (t = Object.assign({}, t, {
          transaction: Object.assign({}, s, { type: void 0 })
        }));
      }
    }
    const n = this.getRpcRequest(t);
    return n != null ? await this.send(n.method, n.args) : super._perform(t);
  }
  /**
   *  Sub-classes may override this; it detects the *actual* network that
   *  we are **currently** connected to.
   *
   *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
   *  _send primitive must be used instead.
   */
  async _detectNetwork() {
    const t = this._getOption("staticNetwork");
    if (t)
      if (t === !0) {
        if (x(this, qr))
          return x(this, qr);
      } else
        return t;
    return x(this, dr) ? await x(this, dr) : this.ready ? (F(this, dr, (async () => {
      try {
        const n = vt.from(De(await this.send("eth_chainId", [])));
        return F(this, dr, null), n;
      } catch (n) {
        throw F(this, dr, null), n;
      }
    })()), await x(this, dr)) : (F(this, dr, (async () => {
      const n = {
        id: rn(this, Xc)._++,
        method: "eth_chainId",
        params: [],
        jsonrpc: "2.0"
      };
      this.emit("debug", { action: "sendRpcPayload", payload: n });
      let s;
      try {
        s = (await this._send(n))[0], F(this, dr, null);
      } catch (i) {
        throw F(this, dr, null), this.emit("debug", { action: "receiveRpcError", error: i }), i;
      }
      if (this.emit("debug", { action: "receiveRpcResult", result: s }), "result" in s)
        return vt.from(De(s.result));
      throw this.getRpcError(n, s);
    })()), await x(this, dr));
  }
  /**
   *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
   *  will be passed to [[_send]] from [[send]]. If it is overridden, then
   *  ``super._start()`` **MUST** be called.
   *
   *  Calling it multiple times is safe and has no effect.
   */
  _start() {
    x(this, mn) == null || x(this, mn).resolve == null || (x(this, mn).resolve(), F(this, mn, null), (async () => {
      for (; x(this, qr) == null && !this.destroyed; )
        try {
          F(this, qr, await this._detectNetwork());
        } catch (t) {
          if (this.destroyed)
            break;
          console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", xt("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: t } })), await l9(1e3);
        }
      de(this, H0, cb).call(this);
    })());
  }
  /**
   *  Resolves once the [[_start]] has been called. This can be used in
   *  sub-classes to defer sending data until the connection has been
   *  established.
   */
  async _waitUntilReady() {
    if (x(this, mn) != null)
      return await x(this, mn).promise;
  }
  /**
   *  Return a Subscriber that will manage the %%sub%%.
   *
   *  Sub-classes may override this to modify the behavior of
   *  subscription management.
   */
  _getSubscriber(t) {
    return t.type === "pending" ? new c9(this) : t.type === "event" ? this._getOption("polling") ? new Fg(this, t.filter) : new o9(this, t.filter) : t.type === "orphan" && t.filter.orphan === "drop-log" ? new yu("orphan") : super._getSubscriber(t);
  }
  /**
   *  Returns true only if the [[_start]] has been called.
   */
  get ready() {
    return x(this, mn) == null;
  }
  /**
   *  Returns %%tx%% as a normalized JSON-RPC transaction request,
   *  which has all values hexlified and any numeric values converted
   *  to Quantity values.
   */
  getRpcTransaction(t) {
    const n = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((s) => {
      if (t[s] == null)
        return;
      let i = s;
      s === "gasLimit" && (i = "gas"), n[i] = Rs(De(t[s], `tx.${s}`));
    }), ["from", "to", "data"].forEach((s) => {
      t[s] != null && (n[s] = Oe(t[s]));
    }), t.accessList && (n.accessList = ts(t.accessList)), t.blobVersionedHashes && (n.blobVersionedHashes = t.blobVersionedHashes.map((s) => s.toLowerCase())), n;
  }
  /**
   *  Returns the request method and arguments required to perform
   *  %%req%%.
   */
  getRpcRequest(t) {
    switch (t.method) {
      case "chainId":
        return { method: "eth_chainId", args: [] };
      case "getBlockNumber":
        return { method: "eth_blockNumber", args: [] };
      case "getGasPrice":
        return { method: "eth_gasPrice", args: [] };
      case "getPriorityFee":
        return { method: "eth_maxPriorityFeePerGas", args: [] };
      case "getBalance":
        return {
          method: "eth_getBalance",
          args: [Qo(t.address), t.blockTag]
        };
      case "getTransactionCount":
        return {
          method: "eth_getTransactionCount",
          args: [Qo(t.address), t.blockTag]
        };
      case "getCode":
        return {
          method: "eth_getCode",
          args: [Qo(t.address), t.blockTag]
        };
      case "getStorage":
        return {
          method: "eth_getStorageAt",
          args: [
            Qo(t.address),
            "0x" + t.position.toString(16),
            t.blockTag
          ]
        };
      case "broadcastTransaction":
        return {
          method: "eth_sendRawTransaction",
          args: [t.signedTransaction]
        };
      case "getBlock":
        if ("blockTag" in t)
          return {
            method: "eth_getBlockByNumber",
            args: [t.blockTag, !!t.includeTransactions]
          };
        if ("blockHash" in t)
          return {
            method: "eth_getBlockByHash",
            args: [t.blockHash, !!t.includeTransactions]
          };
        break;
      case "getTransaction":
        return {
          method: "eth_getTransactionByHash",
          args: [t.hash]
        };
      case "getTransactionReceipt":
        return {
          method: "eth_getTransactionReceipt",
          args: [t.hash]
        };
      case "call":
        return {
          method: "eth_call",
          args: [this.getRpcTransaction(t.transaction), t.blockTag]
        };
      case "estimateGas":
        return {
          method: "eth_estimateGas",
          args: [this.getRpcTransaction(t.transaction)]
        };
      case "getLogs":
        return t.filter && t.filter.address != null && (Array.isArray(t.filter.address) ? t.filter.address = t.filter.address.map(Qo) : t.filter.address = Qo(t.filter.address)), { method: "eth_getLogs", args: [t.filter] };
    }
    return null;
  }
  /**
   *  Returns an ethers-style Error for the given JSON-RPC error
   *  %%payload%%, coalescing the various strings and error shapes
   *  that different nodes return, coercing them into a machine-readable
   *  standardized error.
   */
  getRpcError(t, n) {
    const { method: s } = t, { error: i } = n;
    if (s === "eth_estimateGas" && i.message) {
      const u = i.message;
      if (!u.match(/revert/i) && u.match(/insufficient funds/i))
        return xt("insufficient funds", "INSUFFICIENT_FUNDS", {
          transaction: t.params[0],
          info: { payload: t, error: i }
        });
    }
    if (s === "eth_call" || s === "eth_estimateGas") {
      const u = ub(i), c = _i.getBuiltinCallException(s === "eth_call" ? "call" : "estimateGas", t.params[0], u ? u.data : null);
      return c.info = { error: i, payload: t }, c;
    }
    const a = JSON.stringify(f9(i));
    if (typeof i.message == "string" && i.message.match(/user denied|ethers-user-denied/i))
      return xt("user rejected action", "ACTION_REJECTED", {
        action: {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        }[s] || "unknown",
        reason: "rejected",
        info: { payload: t, error: i }
      });
    if (s === "eth_sendRawTransaction" || s === "eth_sendTransaction") {
      const u = t.params[0];
      if (a.match(/insufficient funds|base fee exceeds gas limit/i))
        return xt("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: u,
          info: { error: i }
        });
      if (a.match(/nonce/i) && a.match(/too low/i))
        return xt("nonce has already been used", "NONCE_EXPIRED", { transaction: u, info: { error: i } });
      if (a.match(/replacement transaction/i) && a.match(/underpriced/i))
        return xt("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: u, info: { error: i } });
      if (a.match(/only replay-protected/i))
        return xt("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
          operation: s,
          info: { transaction: u, info: { error: i } }
        });
    }
    let o = !!a.match(/the method .* does not exist/i);
    return o || i && i.details && i.details.startsWith("Unauthorized method:") && (o = !0), o ? xt("unsupported operation", "UNSUPPORTED_OPERATION", {
      operation: t.method,
      info: { error: i, payload: t }
    }) : xt("could not coalesce error", "UNKNOWN_ERROR", { error: i, payload: t });
  }
  /**
   *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
   *  over the underlying channel. This can be used to call methods
   *  on the backend that do not have a high-level API within the Provider
   *  API.
   *
   *  This method queues requests according to the batch constraints
   *  in the options, assigns the request a unique ID.
   *
   *  **Do NOT override** this method in sub-classes; instead
   *  override [[_send]] or force the options values in the
   *  call to the constructor to modify this method's behavior.
   */
  send(t, n) {
    if (this.destroyed)
      return Promise.reject(xt("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: t }));
    const s = rn(this, Xc)._++, i = new Promise((a, o) => {
      x(this, Os).push({
        resolve: a,
        reject: o,
        payload: { method: t, params: n, id: s, jsonrpc: "2.0" }
      });
    });
    return de(this, H0, cb).call(this), i;
  }
  /**
   *  Resolves to the [[Signer]] account for  %%address%% managed by
   *  the client.
   *
   *  If the %%address%% is a number, it is used as an index in the
   *  the accounts from [[listAccounts]].
   *
   *  This can only be used on clients which manage accounts (such as
   *  Geth with imported account or MetaMask).
   *
   *  Throws if the account doesn't exist.
   */
  async getSigner(t) {
    t == null && (t = 0);
    const n = this.send("eth_accounts", []);
    if (typeof t == "number") {
      const i = await n;
      if (t >= i.length)
        throw new Error("no such account");
      return new x0(this, i[t]);
    }
    const { accounts: s } = await Lt({
      network: this.getNetwork(),
      accounts: n
    });
    t = et(t);
    for (const i of s)
      if (et(i) === t)
        return new x0(this, t);
    throw new Error("invalid account");
  }
  async listAccounts() {
    return (await this.send("eth_accounts", [])).map((n) => new x0(this, n));
  }
  destroy() {
    x(this, Jn) && (clearTimeout(x(this, Jn)), F(this, Jn, null));
    for (const { payload: t, reject: n } of x(this, Os))
      n(xt("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: t.method }));
    F(this, Os, []), super.destroy();
  }
}
io = new WeakMap(), Xc = new WeakMap(), Os = new WeakMap(), Jn = new WeakMap(), mn = new WeakMap(), qr = new WeakMap(), dr = new WeakMap(), H0 = new WeakSet(), cb = function() {
  if (x(this, Jn))
    return;
  const t = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
  F(this, Jn, setTimeout(() => {
    F(this, Jn, null);
    const n = x(this, Os);
    for (F(this, Os, []); n.length; ) {
      const s = [n.shift()];
      for (; n.length && s.length !== x(this, io).batchMaxCount; )
        if (s.push(n.shift()), JSON.stringify(s.map((a) => a.payload)).length > x(this, io).batchMaxSize) {
          n.unshift(s.pop());
          break;
        }
      (async () => {
        const i = s.length === 1 ? s[0].payload : s.map((a) => a.payload);
        this.emit("debug", { action: "sendRpcPayload", payload: i });
        try {
          const a = await this._send(i);
          this.emit("debug", { action: "receiveRpcResult", result: a });
          for (const { resolve: o, reject: u, payload: c } of s) {
            if (this.destroyed) {
              u(xt("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: c.method }));
              continue;
            }
            const l = a.filter((f) => f.id === c.id)[0];
            if (l == null) {
              const f = xt("missing response for request", "BAD_DATA", {
                value: a,
                info: { payload: c }
              });
              this.emit("error", f), u(f);
              continue;
            }
            if ("error" in l) {
              u(this.getRpcError(c, l));
              continue;
            }
            o(l.result);
          }
        } catch (a) {
          this.emit("debug", { action: "receiveRpcError", error: a });
          for (const { reject: o } of s)
            o(a);
        }
      })();
    }
  }, t));
};
var ki;
class g4 extends ch {
  constructor(t, n) {
    super(t, n);
    Z(this, ki);
    let s = this._getOption("pollingInterval");
    s == null && (s = b4.pollingInterval), F(this, ki, s);
  }
  _getSubscriber(t) {
    const n = super._getSubscriber(t);
    return Jm(n) && (n.pollingInterval = x(this, ki)), n;
  }
  /**
   *  The polling interval (default: 4000 ms)
   */
  get pollingInterval() {
    return x(this, ki);
  }
  set pollingInterval(t) {
    if (!Number.isInteger(t) || t < 0)
      throw new Error("invalid interval");
    F(this, ki, t), this._forEachSubscriber((n) => {
      Jm(n) && (n.pollingInterval = x(this, ki));
    });
  }
}
ki = new WeakMap();
var eu;
class _r extends g4 {
  constructor(t, n, s) {
    t == null && (t = "http://localhost:8545");
    super(n, s);
    Z(this, eu);
    typeof t == "string" ? F(this, eu, new Kt(t)) : F(this, eu, t.clone());
  }
  _getConnection() {
    return x(this, eu).clone();
  }
  async send(t, n) {
    return await this._start(), await super.send(t, n);
  }
  async _send(t) {
    const n = this._getConnection();
    n.body = JSON.stringify(t), n.setHeader("content-type", "application/json");
    const s = await n.send();
    s.assertOk();
    let i = s.bodyJson;
    return Array.isArray(i) || (i = [i]), i;
  }
}
eu = new WeakMap();
function ub(r) {
  if (r == null)
    return null;
  if (typeof r.message == "string" && r.message.match(/revert/i) && dt(r.data))
    return { message: r.message, data: r.data };
  if (typeof r == "object") {
    for (const e in r) {
      const t = ub(r[e]);
      if (t)
        return t;
    }
    return null;
  }
  if (typeof r == "string")
    try {
      return ub(JSON.parse(r));
    } catch {
    }
  return null;
}
function lb(r, e) {
  if (r != null) {
    if (typeof r.message == "string" && e.push(r.message), typeof r == "object")
      for (const t in r)
        lb(r[t], e);
    if (typeof r == "string")
      try {
        return lb(JSON.parse(r), e);
      } catch {
      }
  }
}
function f9(r) {
  const e = [];
  return lb(r, e), e;
}
const Nf = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function d9(r) {
  switch (r) {
    case "mainnet":
      return "rpc.ankr.com/eth";
    case "goerli":
      return "rpc.ankr.com/eth_goerli";
    case "sepolia":
      return "rpc.ankr.com/eth_sepolia";
    case "arbitrum":
      return "rpc.ankr.com/arbitrum";
    case "base":
      return "rpc.ankr.com/base";
    case "base-goerli":
      return "rpc.ankr.com/base_goerli";
    case "base-sepolia":
      return "rpc.ankr.com/base_sepolia";
    case "bnb":
      return "rpc.ankr.com/bsc";
    case "bnbt":
      return "rpc.ankr.com/bsc_testnet_chapel";
    case "matic":
      return "rpc.ankr.com/polygon";
    case "matic-mumbai":
      return "rpc.ankr.com/polygon_mumbai";
    case "optimism":
      return "rpc.ankr.com/optimism";
    case "optimism-goerli":
      return "rpc.ankr.com/optimism_testnet";
    case "optimism-sepolia":
      return "rpc.ankr.com/optimism_sepolia";
  }
  ue(!1, "unsupported network", "network", r);
}
class Eu extends _r {
  /**
   *  Create a new **AnkrProvider**.
   *
   *  By default connecting to ``mainnet`` with a highly throttled
   *  API key.
   */
  constructor(t, n) {
    t == null && (t = "mainnet");
    const s = vt.from(t);
    n == null && (n = Nf);
    const i = { polling: !0, staticNetwork: s }, a = Eu.getRequest(s, n);
    super(a, s, i);
    /**
     *  The API key for the Ankr connection.
     */
    Q(this, "apiKey");
    _e(this, { apiKey: n });
  }
  _getProvider(t) {
    try {
      return new Eu(t, this.apiKey);
    } catch {
    }
    return super._getProvider(t);
  }
  /**
   *  Returns a prepared request for connecting to %%network%% with
   *  %%apiKey%%.
   */
  static getRequest(t, n) {
    n == null && (n = Nf);
    const s = new Kt(`https://${d9(t.name)}/${n}`);
    return s.allowGzip = !0, n === Nf && (s.retryFunc = async (i, a, o) => (qs("AnkrProvider"), !0)), s;
  }
  getRpcError(t, n) {
    return t.method === "eth_sendRawTransaction" && n && n.error && n.error.message === "INTERNAL_ERROR: could not replace existing tx" && (n.error.message = "replacement transaction underpriced"), super.getRpcError(t, n);
  }
  isCommunityResource() {
    return this.apiKey === Nf;
  }
}
const Sf = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
function h9(r) {
  switch (r) {
    case "mainnet":
      return "eth-mainnet.alchemyapi.io";
    case "goerli":
      return "eth-goerli.g.alchemy.com";
    case "sepolia":
      return "eth-sepolia.g.alchemy.com";
    case "arbitrum":
      return "arb-mainnet.g.alchemy.com";
    case "arbitrum-goerli":
      return "arb-goerli.g.alchemy.com";
    case "arbitrum-sepolia":
      return "arb-sepolia.g.alchemy.com";
    case "base":
      return "base-mainnet.g.alchemy.com";
    case "base-goerli":
      return "base-goerli.g.alchemy.com";
    case "base-sepolia":
      return "base-sepolia.g.alchemy.com";
    case "matic":
      return "polygon-mainnet.g.alchemy.com";
    case "matic-amoy":
      return "polygon-amoy.g.alchemy.com";
    case "matic-mumbai":
      return "polygon-mumbai.g.alchemy.com";
    case "optimism":
      return "opt-mainnet.g.alchemy.com";
    case "optimism-goerli":
      return "opt-goerli.g.alchemy.com";
    case "optimism-sepolia":
      return "opt-sepolia.g.alchemy.com";
  }
  ue(!1, "unsupported network", "network", r);
}
class Pu extends _r {
  constructor(t, n) {
    t == null && (t = "mainnet");
    const s = vt.from(t);
    n == null && (n = Sf);
    const i = Pu.getRequest(s, n);
    super(i, s, { staticNetwork: s });
    Q(this, "apiKey");
    _e(this, { apiKey: n });
  }
  _getProvider(t) {
    try {
      return new Pu(t, this.apiKey);
    } catch {
    }
    return super._getProvider(t);
  }
  async _perform(t) {
    if (t.method === "getTransactionResult") {
      const { trace: n, tx: s } = await Lt({
        trace: this.send("trace_transaction", [t.hash]),
        tx: this.getTransaction(t.hash)
      });
      if (n == null || s == null)
        return null;
      let i, a = !1;
      try {
        i = n[0].result.output, a = n[0].error === "Reverted";
      } catch {
      }
      if (i)
        return Ee(!a, "an error occurred during transaction executions", "CALL_EXCEPTION", {
          action: "getTransactionResult",
          data: i,
          reason: null,
          transaction: s,
          invocation: null,
          revert: null
          // @TODO
        }), i;
      Ee(!1, "could not parse trace result", "BAD_DATA", { value: n });
    }
    return await super._perform(t);
  }
  isCommunityResource() {
    return this.apiKey === Sf;
  }
  static getRequest(t, n) {
    n == null && (n = Sf);
    const s = new Kt(`https://${h9(t.name)}/v2/${n}`);
    return s.allowGzip = !0, n === Sf && (s.retryFunc = async (i, a, o) => (qs("alchemy"), !0)), s;
  }
}
function Cf(r) {
  switch (r) {
    case "mainnet":
      return "39f1d67cedf8b7831010a665328c9197";
    case "arbitrum":
      return "0550c209db33c3abf4cc927e1e18cea1";
    case "bnb":
      return "98b5a77e531614387366f6fc5da097f8";
    case "matic":
      return "cd9d4d70377471aa7c142ec4a4205249";
  }
  ue(!1, "unsupported network", "network", r);
}
function p9(r) {
  switch (r) {
    case "mainnet":
      return "ethereum-mainnet.core.chainstack.com";
    case "arbitrum":
      return "arbitrum-mainnet.core.chainstack.com";
    case "bnb":
      return "bsc-mainnet.core.chainstack.com";
    case "matic":
      return "polygon-mainnet.core.chainstack.com";
  }
  ue(!1, "unsupported network", "network", r);
}
class vu extends _r {
  /**
   *  Creates a new **ChainstackProvider**.
   */
  constructor(t, n) {
    t == null && (t = "mainnet");
    const s = vt.from(t);
    n == null && (n = Cf(s.name));
    const i = vu.getRequest(s, n);
    super(i, s, { staticNetwork: s });
    /**
     *  The API key for the Chainstack connection.
     */
    Q(this, "apiKey");
    _e(this, { apiKey: n });
  }
  _getProvider(t) {
    try {
      return new vu(t, this.apiKey);
    } catch {
    }
    return super._getProvider(t);
  }
  isCommunityResource() {
    return this.apiKey === Cf(this._network.name);
  }
  /**
   *  Returns a prepared request for connecting to %%network%%
   *  with %%apiKey%% and %%projectSecret%%.
   */
  static getRequest(t, n) {
    n == null && (n = Cf(t.name));
    const s = new Kt(`https://${p9(t.name)}/${n}`);
    return s.allowGzip = !0, n === Cf(t.name) && (s.retryFunc = async (i, a, o) => (qs("ChainstackProvider"), !0)), s;
  }
}
class Dg extends _r {
  constructor(e) {
    e == null && (e = "mainnet");
    const t = vt.from(e);
    ue(t.name === "mainnet", "unsupported network", "network", e), super("https://cloudflare-eth.com/", t, { staticNetwork: t });
  }
}
const Qm = 2e3;
function b9(r) {
  return r && typeof r.then == "function";
}
const x4 = "org.ethers.plugins.provider.Etherscan";
class uh extends Qs {
  /**
   *  Creates a new **EtherscanProvider** which will use
   *  %%baseUrl%%.
   */
  constructor(t) {
    super(x4);
    /**
     *  The Etherscan API base URL.
     */
    Q(this, "baseUrl");
    _e(this, { baseUrl: t });
  }
  clone() {
    return new uh(this.baseUrl);
  }
}
const g9 = ["enableCcipRead"];
let x9 = 1;
var tu;
class jg extends wu {
  /**
   *  Creates a new **EtherscanBaseProvider**.
   */
  constructor(t, n) {
    const s = n ?? null;
    super();
    /**
     *  The connected network.
     */
    Q(this, "network");
    /**
     *  The API key or null if using the community provided bandwidth.
     */
    Q(this, "apiKey");
    Z(this, tu);
    const i = vt.from(t);
    F(this, tu, i.getPlugin(x4)), _e(this, { apiKey: s, network: i }), this.getBaseUrl();
  }
  /**
   *  Returns the base URL.
   *
   *  If an [[EtherscanPlugin]] is configured on the
   *  [[EtherscanBaseProvider_network]], returns the plugin's
   *  baseUrl.
   */
  getBaseUrl() {
    if (x(this, tu))
      return x(this, tu).baseUrl;
    switch (this.network.name) {
      case "mainnet":
        return "https://api.etherscan.io";
      case "goerli":
        return "https://api-goerli.etherscan.io";
      case "sepolia":
        return "https://api-sepolia.etherscan.io";
      case "holesky":
        return "https://api-holesky.etherscan.io";
      case "arbitrum":
        return "https://api.arbiscan.io";
      case "arbitrum-goerli":
        return "https://api-goerli.arbiscan.io";
      case "base":
        return "https://api.basescan.org";
      case "base-sepolia":
        return "https://api-sepolia.basescan.org";
      case "bnb":
        return "https://api.bscscan.com";
      case "bnbt":
        return "https://api-testnet.bscscan.com";
      case "matic":
        return "https://api.polygonscan.com";
      case "matic-amoy":
        return "https://api-amoy.polygonscan.com";
      case "matic-mumbai":
        return "https://api-testnet.polygonscan.com";
      case "optimism":
        return "https://api-optimistic.etherscan.io";
      case "optimism-goerli":
        return "https://api-goerli-optimistic.etherscan.io";
    }
    ue(!1, "unsupported network", "network", this.network);
  }
  /**
   *  Returns the URL for the %%module%% and %%params%%.
   */
  getUrl(t, n) {
    const s = Object.keys(n).reduce((a, o) => {
      const u = n[o];
      return u != null && (a += `&${o}=${u}`), a;
    }, ""), i = this.apiKey ? `&apikey=${this.apiKey}` : "";
    return `${this.getBaseUrl()}/api?module=${t}${s}${i}`;
  }
  /**
   *  Returns the URL for using POST requests.
   */
  getPostUrl() {
    return `${this.getBaseUrl()}/api`;
  }
  /**
   *  Returns the parameters for using POST requests.
   */
  getPostData(t, n) {
    return n.module = t, n.apikey = this.apiKey, n;
  }
  async detectNetwork() {
    return this.network;
  }
  /**
   *  Resolves to the result of calling %%module%% with %%params%%.
   *
   *  If %%post%%, the request is made as a POST request.
   */
  async fetch(t, n, s) {
    const i = x9++, a = s ? this.getPostUrl() : this.getUrl(t, n), o = s ? this.getPostData(t, n) : null;
    this.emit("debug", { action: "sendRequest", id: i, url: a, payload: o });
    const u = new Kt(a);
    u.setThrottleParams({ slotInterval: 1e3 }), u.retryFunc = (f, d, h) => (this.isCommunityResource() && qs("Etherscan"), Promise.resolve(!0)), u.processFunc = async (f, d) => {
      const h = d.hasBody() ? JSON.parse(Fs(d.body)) : {}, p = (typeof h.result == "string" ? h.result : "").toLowerCase().indexOf("rate limit") >= 0;
      return t === "proxy" ? h && h.status == 0 && h.message == "NOTOK" && p && (this.emit("debug", { action: "receiveError", id: i, reason: "proxy-NOTOK", error: h }), d.throwThrottleError(h.result, Qm)) : p && (this.emit("debug", { action: "receiveError", id: i, reason: "null result", error: h.result }), d.throwThrottleError(h.result, Qm)), d;
    }, o && (u.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8"), u.body = Object.keys(o).map((f) => `${f}=${o[f]}`).join("&"));
    const c = await u.send();
    try {
      c.assertOk();
    } catch (f) {
      this.emit("debug", { action: "receiveError", id: i, error: f, reason: "assertOk" }), Ee(!1, "response error", "SERVER_ERROR", { request: u, response: c });
    }
    c.hasBody() || (this.emit("debug", { action: "receiveError", id: i, error: "missing body", reason: "null body" }), Ee(!1, "missing response", "SERVER_ERROR", { request: u, response: c }));
    const l = JSON.parse(Fs(c.body));
    return t === "proxy" ? (l.jsonrpc != "2.0" && (this.emit("debug", { action: "receiveError", id: i, result: l, reason: "invalid JSON-RPC" }), Ee(!1, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", { request: u, response: c, info: { result: l } })), l.error && (this.emit("debug", { action: "receiveError", id: i, result: l, reason: "JSON-RPC error" }), Ee(!1, "error response", "SERVER_ERROR", { request: u, response: c, info: { result: l } })), this.emit("debug", { action: "receiveRequest", id: i, result: l }), l.result) : l.status == 0 && (l.message === "No records found" || l.message === "No transactions found") ? (this.emit("debug", { action: "receiveRequest", id: i, result: l }), l.result) : ((l.status != 1 || typeof l.message == "string" && !l.message.match(/^OK/)) && (this.emit("debug", { action: "receiveError", id: i, result: l }), Ee(!1, "error response", "SERVER_ERROR", { request: u, response: c, info: { result: l } })), this.emit("debug", { action: "receiveRequest", id: i, result: l }), l.result);
  }
  /**
   *  Returns %%transaction%% normalized for the Etherscan API.
   */
  _getTransactionPostData(t) {
    const n = {};
    for (let s in t) {
      if (g9.indexOf(s) >= 0 || t[s] == null)
        continue;
      let i = t[s];
      if (!(s === "type" && i === 0) && !(s === "blockTag" && i === "latest")) {
        if ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[s])
          i = Rs(i);
        else if (s === "accessList")
          i = "[" + ts(i).map((a) => `{address:"${a.address}",storageKeys:["${a.storageKeys.join('","')}"]}`).join(",") + "]";
        else if (s === "blobVersionedHashes") {
          if (i.length === 0)
            continue;
          Ee(!1, "Etherscan API does not support blobVersionedHashes", "UNSUPPORTED_OPERATION", {
            operation: "_getTransactionPostData",
            info: { transaction: t }
          });
        } else
          i = Oe(i);
        n[s] = i;
      }
    }
    return n;
  }
  /**
   *  Throws the normalized Etherscan error.
   */
  _checkError(t, n, s) {
    let i = "";
    if (Ct(n, "SERVER_ERROR")) {
      try {
        i = n.info.result.error.message;
      } catch {
      }
      if (!i)
        try {
          i = n.info.message;
        } catch {
        }
    }
    if (t.method === "estimateGas" && !i.match(/revert/i) && i.match(/insufficient funds/i) && Ee(!1, "insufficient funds", "INSUFFICIENT_FUNDS", {
      transaction: t.transaction
    }), (t.method === "call" || t.method === "estimateGas") && i.match(/execution reverted/i)) {
      let a = "";
      try {
        a = n.info.result.error.data;
      } catch {
      }
      const o = _i.getBuiltinCallException(t.method, t.transaction, a);
      throw o.info = { request: t, error: n }, o;
    }
    if (i && t.method === "broadcastTransaction") {
      const a = Ii.from(t.signedTransaction);
      i.match(/replacement/i) && i.match(/underpriced/i) && Ee(!1, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
        transaction: a
      }), i.match(/insufficient funds/) && Ee(!1, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
        transaction: a
      }), i.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && Ee(!1, "nonce has already been used", "NONCE_EXPIRED", {
        transaction: a
      });
    }
    throw n;
  }
  async _detectNetwork() {
    return this.network;
  }
  async _perform(t) {
    switch (t.method) {
      case "chainId":
        return this.network.chainId;
      case "getBlockNumber":
        return this.fetch("proxy", { action: "eth_blockNumber" });
      case "getGasPrice":
        return this.fetch("proxy", { action: "eth_gasPrice" });
      case "getPriorityFee":
        if (this.network.name === "mainnet")
          return "1000000000";
        if (this.network.name === "optimism")
          return "1000000";
        throw new Error("fallback onto the AbstractProvider default");
      case "getBalance":
        return this.fetch("account", {
          action: "balance",
          address: t.address,
          tag: t.blockTag
        });
      case "getTransactionCount":
        return this.fetch("proxy", {
          action: "eth_getTransactionCount",
          address: t.address,
          tag: t.blockTag
        });
      case "getCode":
        return this.fetch("proxy", {
          action: "eth_getCode",
          address: t.address,
          tag: t.blockTag
        });
      case "getStorage":
        return this.fetch("proxy", {
          action: "eth_getStorageAt",
          address: t.address,
          position: t.position,
          tag: t.blockTag
        });
      case "broadcastTransaction":
        return this.fetch("proxy", {
          action: "eth_sendRawTransaction",
          hex: t.signedTransaction
        }, !0).catch((n) => this._checkError(t, n, t.signedTransaction));
      case "getBlock":
        if ("blockTag" in t)
          return this.fetch("proxy", {
            action: "eth_getBlockByNumber",
            tag: t.blockTag,
            boolean: t.includeTransactions ? "true" : "false"
          });
        Ee(!1, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
          operation: "getBlock(blockHash)"
        });
      case "getTransaction":
        return this.fetch("proxy", {
          action: "eth_getTransactionByHash",
          txhash: t.hash
        });
      case "getTransactionReceipt":
        return this.fetch("proxy", {
          action: "eth_getTransactionReceipt",
          txhash: t.hash
        });
      case "call": {
        if (t.blockTag !== "latest")
          throw new Error("EtherscanProvider does not support blockTag for call");
        const n = this._getTransactionPostData(t.transaction);
        n.module = "proxy", n.action = "eth_call";
        try {
          return await this.fetch("proxy", n, !0);
        } catch (s) {
          return this._checkError(t, s, t.transaction);
        }
      }
      case "estimateGas": {
        const n = this._getTransactionPostData(t.transaction);
        n.module = "proxy", n.action = "eth_estimateGas";
        try {
          return await this.fetch("proxy", n, !0);
        } catch (s) {
          return this._checkError(t, s, t.transaction);
        }
      }
    }
    return super._perform(t);
  }
  async getNetwork() {
    return this.network;
  }
  /**
   *  Resolves to the current price of ether.
   *
   *  This returns ``0`` on any network other than ``mainnet``.
   */
  async getEtherPrice() {
    return this.network.name !== "mainnet" ? 0 : parseFloat((await this.fetch("stats", { action: "ethprice" })).ethusd);
  }
  /**
   *  Resolves to a [Contract]] for %%address%%, using the
   *  Etherscan API to retreive the Contract ABI.
   */
  async getContract(t) {
    let n = this._getAddress(t);
    b9(n) && (n = await n);
    try {
      const s = await this.fetch("contract", {
        action: "getabi",
        address: n
      }), i = JSON.parse(s);
      return new Ci(n, i, this);
    } catch {
      return null;
    }
  }
  isCommunityResource() {
    return this.apiKey == null;
  }
}
tu = new WeakMap();
function m9() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}
const y9 = m9().WebSocket;
var Qn, G0, Ti, ao, Bi;
class of {
  /**
   *  Creates a new **SocketSubscriber** attached to %%provider%% listening
   *  to %%filter%%.
   */
  constructor(e, t) {
    Z(this, Qn);
    Z(this, G0);
    Z(this, Ti);
    Z(this, ao);
    Z(this, Bi);
    F(this, Qn, e), F(this, G0, JSON.stringify(t)), F(this, Ti, null), F(this, ao, null), F(this, Bi, null);
  }
  /**
   *  The filter.
   */
  get filter() {
    return JSON.parse(x(this, G0));
  }
  start() {
    F(this, Ti, x(this, Qn).send("eth_subscribe", this.filter).then((e) => (x(this, Qn)._register(e, this), e)));
  }
  stop() {
    x(this, Ti).then((e) => {
      x(this, Qn).destroyed || x(this, Qn).send("eth_unsubscribe", [e]);
    }), F(this, Ti, null);
  }
  // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
  //        and resume
  pause(e) {
    Ee(e, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", { operation: "pause(false)" }), F(this, ao, !!e);
  }
  resume() {
    F(this, ao, null);
  }
  /**
   *  @_ignore:
   */
  _handleMessage(e) {
    if (x(this, Ti) != null && x(this, ao) === null) {
      let t = x(this, Bi);
      t == null ? t = this._emit(x(this, Qn), e) : t = t.then(async () => {
        await this._emit(x(this, Qn), e);
      }), F(this, Bi, t.then(() => {
        x(this, Bi) === t && F(this, Bi, null);
      }));
    }
  }
  /**
   *  Sub-classes **must** override this to emit the events on the
   *  provider.
   */
  async _emit(e, t) {
    throw new Error("sub-classes must implemente this; _emit");
  }
}
Qn = new WeakMap(), G0 = new WeakMap(), Ti = new WeakMap(), ao = new WeakMap(), Bi = new WeakMap();
class Hg extends of {
  /**
   *  @_ignore:
   */
  constructor(e) {
    super(e, ["newHeads"]);
  }
  async _emit(e, t) {
    e.emit("block", parseInt(t.number));
  }
}
class Gg extends of {
  /**
   *  @_ignore:
   */
  constructor(e) {
    super(e, ["newPendingTransactions"]);
  }
  async _emit(e, t) {
    e.emit("pending", t);
  }
}
var V0;
class Vg extends of {
  /**
   *  @_ignore:
   */
  constructor(t, n) {
    super(t, ["logs", n]);
    Z(this, V0);
    F(this, V0, JSON.stringify(n));
  }
  /**
   *  The filter.
   */
  get logFilter() {
    return JSON.parse(x(this, V0));
  }
  async _emit(t, n) {
    t.emit(this.logFilter, t._wrapLog(n, t._network));
  }
}
V0 = new WeakMap();
var oo, ru, Oi;
class $g extends ch {
  /**
   *  Creates a new **SocketProvider** connected to %%network%%.
   *
   *  If unspecified, the network will be discovered.
   */
  constructor(t, n) {
    const s = Object.assign({}, n ?? {});
    ue(s.batchMaxCount == null || s.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", n), s.batchMaxCount = 1, s.staticNetwork == null && (s.staticNetwork = !0);
    super(t, s);
    Z(this, oo);
    // Maps each filterId to its subscriber
    Z(this, ru);
    // If any events come in before a subscriber has finished
    // registering, queue them
    Z(this, Oi);
    F(this, oo, /* @__PURE__ */ new Map()), F(this, ru, /* @__PURE__ */ new Map()), F(this, Oi, /* @__PURE__ */ new Map());
  }
  // This value is only valid after _start has been called
  /*
  get _network(): Network {
      if (this.#network == null) {
          throw new Error("this shouldn't happen");
      }
      return this.#network.clone();
  }
  */
  _getSubscriber(t) {
    switch (t.type) {
      case "close":
        return new yu("close");
      case "block":
        return new Hg(this);
      case "pending":
        return new Gg(this);
      case "event":
        return new Vg(this, t.filter);
      case "orphan":
        if (t.filter.orphan === "drop-log")
          return new yu("drop-log");
    }
    return super._getSubscriber(t);
  }
  /**
   *  Register a new subscriber. This is used internalled by Subscribers
   *  and generally is unecessary unless extending capabilities.
   */
  _register(t, n) {
    x(this, ru).set(t, n);
    const s = x(this, Oi).get(t);
    if (s) {
      for (const i of s)
        n._handleMessage(i);
      x(this, Oi).delete(t);
    }
  }
  async _send(t) {
    ue(!Array.isArray(t), "WebSocket does not support batch send", "payload", t);
    const n = new Promise((s, i) => {
      x(this, oo).set(t.id, { payload: t, resolve: s, reject: i });
    });
    return await this._waitUntilReady(), await this._write(JSON.stringify(t)), [await n];
  }
  // Sub-classes must call this once they are connected
  /*
      async _start(): Promise<void> {
          if (this.#ready) { return; }
  
          for (const { payload } of this.#callbacks.values()) {
              await this._write(JSON.stringify(payload));
          }
  
          this.#ready = (async function() {
              await super._start();
          })();
      }
      */
  /**
   *  Sub-classes **must** call this with messages received over their
   *  transport to be processed and dispatched.
   */
  async _processMessage(t) {
    const n = JSON.parse(t);
    if (n && typeof n == "object" && "id" in n) {
      const s = x(this, oo).get(n.id);
      if (s == null) {
        this.emit("error", xt("received result for unknown id", "UNKNOWN_ERROR", {
          reasonCode: "UNKNOWN_ID",
          result: n
        }));
        return;
      }
      x(this, oo).delete(n.id), s.resolve(n);
    } else if (n && n.method === "eth_subscription") {
      const s = n.params.subscription, i = x(this, ru).get(s);
      if (i)
        i._handleMessage(n.params.result);
      else {
        let a = x(this, Oi).get(s);
        a == null && (a = [], x(this, Oi).set(s, a)), a.push(n.params.result);
      }
    } else {
      this.emit("error", xt("received unexpected message", "UNKNOWN_ERROR", {
        reasonCode: "UNEXPECTED_MESSAGE",
        result: n
      }));
      return;
    }
  }
  /**
   *  Sub-classes **must** override this to send %%message%% over their
   *  transport.
   */
  async _write(t) {
    throw new Error("sub-classes must override this");
  }
}
oo = new WeakMap(), ru = new WeakMap(), Oi = new WeakMap();
var co, yn;
class lh extends $g {
  constructor(t, n, s) {
    super(n, s);
    Z(this, co);
    Z(this, yn);
    typeof t == "string" ? (F(this, co, () => new y9(t)), F(this, yn, x(this, co).call(this))) : typeof t == "function" ? (F(this, co, t), F(this, yn, t())) : (F(this, co, null), F(this, yn, t)), this.websocket.onopen = async () => {
      try {
        await this._start(), this.resume();
      } catch (i) {
        console.log("failed to start WebsocketProvider", i);
      }
    }, this.websocket.onmessage = (i) => {
      this._processMessage(i.data);
    };
  }
  get websocket() {
    if (x(this, yn) == null)
      throw new Error("websocket closed");
    return x(this, yn);
  }
  async _write(t) {
    this.websocket.send(t);
  }
  async destroy() {
    x(this, yn) != null && (x(this, yn).close(), F(this, yn, null)), super.destroy();
  }
}
co = new WeakMap(), yn = new WeakMap();
const c0 = "84842078b09946638c03157f83405213";
function w9(r) {
  switch (r) {
    case "mainnet":
      return "mainnet.infura.io";
    case "goerli":
      return "goerli.infura.io";
    case "sepolia":
      return "sepolia.infura.io";
    case "arbitrum":
      return "arbitrum-mainnet.infura.io";
    case "arbitrum-goerli":
      return "arbitrum-goerli.infura.io";
    case "arbitrum-sepolia":
      return "arbitrum-sepolia.infura.io";
    case "base":
      return "base-mainnet.infura.io";
    case "base-goerlia":
      return "base-goerli.infura.io";
    case "base-sepolia":
      return "base-sepolia.infura.io";
    case "bnb":
      return "bnbsmartchain-mainnet.infura.io";
    case "bnbt":
      return "bnbsmartchain-testnet.infura.io";
    case "linea":
      return "linea-mainnet.infura.io";
    case "linea-goerli":
      return "linea-goerli.infura.io";
    case "linea-sepolia":
      return "linea-sepolia.infura.io";
    case "matic":
      return "polygon-mainnet.infura.io";
    case "matic-amoy":
      return "polygon-amoy.infura.io";
    case "matic-mumbai":
      return "polygon-mumbai.infura.io";
    case "optimism":
      return "optimism-mainnet.infura.io";
    case "optimism-goerli":
      return "optimism-goerli.infura.io";
    case "optimism-sepolia":
      return "optimism-sepolia.infura.io";
  }
  ue(!1, "unsupported network", "network", r);
}
class Kg extends lh {
  /**
   *  Creates a new **InfuraWebSocketProvider**.
   */
  constructor(t, n) {
    const s = new Ao(t, n), i = s._getConnection();
    Ee(!i.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", { operation: "InfuraProvider.getWebSocketProvider()" });
    const a = i.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
    super(a, s._network);
    /**
     *  The Project ID for the INFURA connection.
     */
    Q(this, "projectId");
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */
    Q(this, "projectSecret");
    _e(this, {
      projectId: s.projectId,
      projectSecret: s.projectSecret
    });
  }
  isCommunityResource() {
    return this.projectId === c0;
  }
}
class Ao extends _r {
  /**
   *  Creates a new **InfuraProvider**.
   */
  constructor(t, n, s) {
    t == null && (t = "mainnet");
    const i = vt.from(t);
    n == null && (n = c0), s == null && (s = null);
    const a = Ao.getRequest(i, n, s);
    super(a, i, { staticNetwork: i });
    /**
     *  The Project ID for the INFURA connection.
     */
    Q(this, "projectId");
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */
    Q(this, "projectSecret");
    _e(this, { projectId: n, projectSecret: s });
  }
  _getProvider(t) {
    try {
      return new Ao(t, this.projectId, this.projectSecret);
    } catch {
    }
    return super._getProvider(t);
  }
  isCommunityResource() {
    return this.projectId === c0;
  }
  /**
   *  Creates a new **InfuraWebSocketProvider**.
   */
  static getWebSocketProvider(t, n) {
    return new Kg(t, n);
  }
  /**
   *  Returns a prepared request for connecting to %%network%%
   *  with %%projectId%% and %%projectSecret%%.
   */
  static getRequest(t, n, s) {
    n == null && (n = c0), s == null && (s = null);
    const i = new Kt(`https://${w9(t.name)}/v3/${n}`);
    return i.allowGzip = !0, s && i.setCredentials("", s), n === c0 && (i.retryFunc = async (a, o, u) => (qs("InfuraProvider"), !0)), i;
  }
}
const Rf = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
function A9(r) {
  switch (r) {
    case "mainnet":
      return "ethers.quiknode.pro";
    case "goerli":
      return "ethers.ethereum-goerli.quiknode.pro";
    case "sepolia":
      return "ethers.ethereum-sepolia.quiknode.pro";
    case "holesky":
      return "ethers.ethereum-holesky.quiknode.pro";
    case "arbitrum":
      return "ethers.arbitrum-mainnet.quiknode.pro";
    case "arbitrum-goerli":
      return "ethers.arbitrum-goerli.quiknode.pro";
    case "arbitrum-sepolia":
      return "ethers.arbitrum-sepolia.quiknode.pro";
    case "base":
      return "ethers.base-mainnet.quiknode.pro";
    case "base-goerli":
      return "ethers.base-goerli.quiknode.pro";
    case "base-spolia":
      return "ethers.base-sepolia.quiknode.pro";
    case "bnb":
      return "ethers.bsc.quiknode.pro";
    case "bnbt":
      return "ethers.bsc-testnet.quiknode.pro";
    case "matic":
      return "ethers.matic.quiknode.pro";
    case "matic-mumbai":
      return "ethers.matic-testnet.quiknode.pro";
    case "optimism":
      return "ethers.optimism.quiknode.pro";
    case "optimism-goerli":
      return "ethers.optimism-goerli.quiknode.pro";
    case "optimism-sepolia":
      return "ethers.optimism-sepolia.quiknode.pro";
    case "xdai":
      return "ethers.xdai.quiknode.pro";
  }
  ue(!1, "unsupported network", "network", r);
}
class ku extends _r {
  /**
   *  Creates a new **QuickNodeProvider**.
   */
  constructor(t, n) {
    t == null && (t = "mainnet");
    const s = vt.from(t);
    n == null && (n = Rf);
    const i = ku.getRequest(s, n);
    super(i, s, { staticNetwork: s });
    /**
     *  The API token.
     */
    Q(this, "token");
    _e(this, { token: n });
  }
  _getProvider(t) {
    try {
      return new ku(t, this.token);
    } catch {
    }
    return super._getProvider(t);
  }
  isCommunityResource() {
    return this.token === Rf;
  }
  /**
   *  Returns a new request prepared for %%network%% and the
   *  %%token%%.
   */
  static getRequest(t, n) {
    n == null && (n = Rf);
    const s = new Kt(`https://${A9(t.name)}/${n}`);
    return s.allowGzip = !0, n === Rf && (s.retryFunc = async (i, a, o) => (qs("QuickNodeProvider"), !0)), s;
  }
}
const E9 = BigInt("1"), P9 = BigInt("2");
function v9(r) {
  for (let e = r.length - 1; e > 0; e--) {
    const t = Math.floor(Math.random() * (e + 1)), n = r[e];
    r[e] = r[t], r[t] = n;
  }
}
function k9(r) {
  return new Promise((e) => {
    setTimeout(e, r);
  });
}
function fb() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function qh(r) {
  return JSON.stringify(r, (e, t) => typeof t == "bigint" ? { type: "bigint", value: t.toString() } : t);
}
const qm = { stallTimeout: 400, priority: 1, weight: 1 }, Wm = {
  blockNumber: -2,
  requests: 0,
  lateResponses: 0,
  errorResponses: 0,
  outOfSync: -1,
  unsupportedEvents: 0,
  rollingDuration: 0,
  score: 0,
  _network: null,
  _updateNumber: null,
  _totalTime: 0,
  _lastFatalError: null,
  _lastFatalErrorTimestamp: 0
};
async function T9(r, e) {
  for (; (r.blockNumber < 0 || r.blockNumber < e) && (r._updateNumber || (r._updateNumber = (async () => {
    try {
      const t = await r.provider.getBlockNumber();
      t > r.blockNumber && (r.blockNumber = t);
    } catch (t) {
      r.blockNumber = -2, r._lastFatalError = t, r._lastFatalErrorTimestamp = fb();
    }
    r._updateNumber = null;
  })()), await r._updateNumber, r.outOfSync++, !r._lastFatalError); )
    ;
}
function m0(r) {
  if (r == null)
    return "null";
  if (Array.isArray(r))
    return "[" + r.map(m0).join(",") + "]";
  if (typeof r == "object" && typeof r.toJSON == "function")
    return m0(r.toJSON());
  switch (typeof r) {
    case "boolean":
    case "symbol":
      return r.toString();
    case "bigint":
    case "number":
      return BigInt(r).toString();
    case "string":
      return JSON.stringify(r);
    case "object": {
      const e = Object.keys(r);
      return e.sort(), "{" + e.map((t) => `${JSON.stringify(t)}:${m0(r[t])}`).join(",") + "}";
    }
  }
  throw console.log("Could not serialize", r), new Error("Hmm...");
}
function Wh(r) {
  if ("error" in r) {
    const t = r.error;
    return { tag: m0(t), value: t };
  }
  const e = r.result;
  return { tag: m0(e), value: e };
}
function Yf(r, e) {
  const t = /* @__PURE__ */ new Map();
  for (const { value: s, tag: i, weight: a } of e) {
    const o = t.get(i) || { value: s, weight: 0 };
    o.weight += a, t.set(i, o);
  }
  let n = null;
  for (const s of t.values())
    s.weight >= r && (!n || s.weight > n.weight) && (n = s);
  if (n)
    return n.value;
}
function db(r, e) {
  let t = 0;
  const n = /* @__PURE__ */ new Map();
  let s = null;
  const i = [];
  for (const { value: o, tag: u, weight: c } of e)
    if (o instanceof Error) {
      const l = n.get(u) || { value: o, weight: 0 };
      l.weight += c, n.set(u, l), (s == null || l.weight > s.weight) && (s = l);
    } else
      i.push(BigInt(o)), t += c;
  if (t < r)
    return s && s.weight >= r ? s.value : void 0;
  i.sort((o, u) => o < u ? -1 : u > o ? 1 : 0);
  const a = Math.floor(i.length / 2);
  return i.length % 2 ? i[a] : (i[a - 1] + i[a] + E9) / P9;
}
function Yh(r, e) {
  const t = Yf(r, e);
  if (t !== void 0)
    return t;
  for (const n of e)
    if (n.value)
      return n.value;
}
function B9(r, e) {
  if (r === 1)
    return Ve(db(r, e), "%internal");
  const t = /* @__PURE__ */ new Map(), n = (a, o) => {
    const u = t.get(a) || { result: a, weight: 0 };
    u.weight += o, t.set(a, u);
  };
  for (const { weight: a, value: o } of e) {
    const u = Ve(o);
    n(u - 1, a), n(u, a), n(u + 1, a);
  }
  let s = 0, i;
  for (const { weight: a, result: o } of t.values())
    a >= r && (a > s || i != null && a === s && o > i) && (s = a, i = o);
  return i;
}
var hr, Ns, nu, gr, m4, hb, y4, w4, pb;
class zg extends wu {
  /**
   *  Creates a new **FallbackProvider** with %%providers%% connected to
   *  %%network%%.
   *
   *  If a [[Provider]] is included in %%providers%%, defaults are used
   *  for the configuration.
   */
  constructor(t, n, s) {
    super(n, s);
    Z(this, gr);
    /**
     *  The number of backends that must agree on a value before it is
     *  accpeted.
     */
    Q(this, "quorum");
    /**
     *  @_ignore:
     */
    Q(this, "eventQuorum");
    /**
     *  @_ignore:
     */
    Q(this, "eventWorkers");
    Z(this, hr);
    Z(this, Ns);
    Z(this, nu);
    F(this, hr, t.map((i) => i instanceof wu ? Object.assign({ provider: i }, qm, Wm) : Object.assign({}, qm, i, Wm))), F(this, Ns, -2), F(this, nu, null), s && s.quorum != null ? this.quorum = s.quorum : this.quorum = Math.ceil(x(this, hr).reduce((i, a) => (i += a.weight, i), 0) / 2), this.eventQuorum = 1, this.eventWorkers = 1, ue(this.quorum <= x(this, hr).reduce((i, a) => i + a.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
  }
  get providerConfigs() {
    return x(this, hr).map((t) => {
      const n = Object.assign({}, t);
      for (const s in n)
        s[0] === "_" && delete n[s];
      return n;
    });
  }
  async _detectNetwork() {
    return vt.from(De(await this._perform({ method: "chainId" })));
  }
  // @TODO: Add support to select providers to be the event subscriber
  //_getSubscriber(sub: Subscription): Subscriber {
  //    throw new Error("@TODO");
  //}
  /**
   *  Transforms a %%req%% into the correct method call on %%provider%%.
   */
  async _translatePerform(t, n) {
    switch (n.method) {
      case "broadcastTransaction":
        return await t.broadcastTransaction(n.signedTransaction);
      case "call":
        return await t.call(Object.assign({}, n.transaction, { blockTag: n.blockTag }));
      case "chainId":
        return (await t.getNetwork()).chainId;
      case "estimateGas":
        return await t.estimateGas(n.transaction);
      case "getBalance":
        return await t.getBalance(n.address, n.blockTag);
      case "getBlock": {
        const s = "blockHash" in n ? n.blockHash : n.blockTag;
        return await t.getBlock(s, n.includeTransactions);
      }
      case "getBlockNumber":
        return await t.getBlockNumber();
      case "getCode":
        return await t.getCode(n.address, n.blockTag);
      case "getGasPrice":
        return (await t.getFeeData()).gasPrice;
      case "getPriorityFee":
        return (await t.getFeeData()).maxPriorityFeePerGas;
      case "getLogs":
        return await t.getLogs(n.filter);
      case "getStorage":
        return await t.getStorage(n.address, n.position, n.blockTag);
      case "getTransaction":
        return await t.getTransaction(n.hash);
      case "getTransactionCount":
        return await t.getTransactionCount(n.address, n.blockTag);
      case "getTransactionReceipt":
        return await t.getTransactionReceipt(n.hash);
      case "getTransactionResult":
        return await t.getTransactionResult(n.hash);
    }
  }
  async _perform(t) {
    if (t.method === "broadcastTransaction") {
      const a = x(this, hr).map((c) => null), o = x(this, hr).map(async ({ provider: c, weight: l }, f) => {
        try {
          const d = await c._perform(t);
          a[f] = Object.assign(Wh({ result: d }), { weight: l });
        } catch (d) {
          a[f] = Object.assign(Wh({ error: d }), { weight: l });
        }
      });
      for (; ; ) {
        const c = a.filter((d) => d != null);
        for (const { value: d } of c)
          if (!(d instanceof Error))
            return d;
        const l = Yf(this.quorum, a.filter((d) => d != null));
        if (Ct(l, "INSUFFICIENT_FUNDS"))
          throw l;
        const f = o.filter((d, h) => a[h] == null);
        if (f.length === 0)
          break;
        await Promise.race(f);
      }
      const u = Yh(this.quorum, a);
      if (Ee(u !== void 0, "problem multi-broadcasting", "SERVER_ERROR", {
        request: "%sub-requests",
        info: { request: t, results: a.map(qh) }
      }), u instanceof Error)
        throw u;
      return u;
    }
    await de(this, gr, y4).call(this);
    const n = /* @__PURE__ */ new Set();
    let s = 0;
    for (; ; ) {
      const a = de(this, gr, hb).call(this, n, t);
      if (a == null || (s += a.config.weight, s >= this.quorum))
        break;
    }
    const i = await de(this, gr, pb).call(this, n, t);
    for (const a of n)
      a.perform && a.result == null && a.config.lateResponses++;
    return i;
  }
  async destroy() {
    for (const { provider: t } of x(this, hr))
      t.destroy();
    super.destroy();
  }
}
hr = new WeakMap(), Ns = new WeakMap(), nu = new WeakMap(), gr = new WeakSet(), // Grab the next (random) config that is not already part of
// the running set
m4 = function(t) {
  const n = Array.from(t).map((i) => i.config), s = x(this, hr).slice();
  v9(s), s.sort((i, a) => i.priority - a.priority);
  for (const i of s)
    if (!i._lastFatalError && n.indexOf(i) === -1)
      return i;
  return null;
}, // Adds a new runner (if available) to running.
hb = function(t, n) {
  const s = de(this, gr, m4).call(this, t);
  if (s == null)
    return null;
  const i = {
    config: s,
    result: null,
    didBump: !1,
    perform: null,
    staller: null
  }, a = fb();
  return i.perform = (async () => {
    try {
      s.requests++;
      const u = await this._translatePerform(s.provider, n);
      i.result = { result: u };
    } catch (u) {
      s.errorResponses++, i.result = { error: u };
    }
    const o = fb() - a;
    s._totalTime += o, s.rollingDuration = 0.95 * s.rollingDuration + 0.05 * o, i.perform = null;
  })(), i.staller = (async () => {
    await k9(s.stallTimeout), i.staller = null;
  })(), t.add(i), i;
}, y4 = async function() {
  let t = x(this, nu);
  if (!t) {
    const n = [];
    x(this, hr).forEach((s) => {
      n.push((async () => {
        await T9(s, 0), s._lastFatalError || (s._network = await s.provider.getNetwork());
      })());
    }), F(this, nu, t = (async () => {
      await Promise.all(n);
      let s = null;
      for (const i of x(this, hr)) {
        if (i._lastFatalError)
          continue;
        const a = i._network;
        s == null ? s = a.chainId : a.chainId !== s && Ee(!1, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
          operation: "new FallbackProvider"
        });
      }
    })());
  }
  await t;
}, w4 = async function(t, n) {
  const s = [];
  for (const i of t)
    if (i.result != null) {
      const { tag: a, value: o } = Wh(i.result);
      s.push({ tag: a, value: o, weight: i.config.weight });
    }
  if (!(s.reduce((i, a) => i + a.weight, 0) < this.quorum)) {
    switch (n.method) {
      case "getBlockNumber": {
        x(this, Ns) === -2 && F(this, Ns, Math.ceil(Ve(db(this.quorum, x(this, hr).filter((a) => !a._lastFatalError).map((a) => ({
          value: a.blockNumber,
          tag: Ve(a.blockNumber).toString(),
          weight: a.weight
        }))))));
        const i = B9(this.quorum, s);
        return i === void 0 ? void 0 : (i > x(this, Ns) && F(this, Ns, i), x(this, Ns));
      }
      case "getGasPrice":
      case "getPriorityFee":
      case "estimateGas":
        return db(this.quorum, s);
      case "getBlock":
        return "blockTag" in n && n.blockTag === "pending" ? Yh(this.quorum, s) : Yf(this.quorum, s);
      case "call":
      case "chainId":
      case "getBalance":
      case "getTransactionCount":
      case "getCode":
      case "getStorage":
      case "getTransaction":
      case "getTransactionReceipt":
      case "getLogs":
        return Yf(this.quorum, s);
      case "broadcastTransaction":
        return Yh(this.quorum, s);
    }
    Ee(!1, "unsupported method", "UNSUPPORTED_OPERATION", {
      operation: `_perform(${qh(n.method)})`
    });
  }
}, pb = async function(t, n) {
  if (t.size === 0)
    throw new Error("no runners?!");
  const s = [];
  let i = 0;
  for (const o of t) {
    if (o.perform && s.push(o.perform), o.staller) {
      s.push(o.staller);
      continue;
    }
    o.didBump || (o.didBump = !0, i++);
  }
  const a = await de(this, gr, w4).call(this, t, n);
  if (a !== void 0) {
    if (a instanceof Error)
      throw a;
    return a;
  }
  for (let o = 0; o < i; o++)
    de(this, gr, hb).call(this, t, n);
  return Ee(s.length > 0, "quorum not met", "SERVER_ERROR", {
    request: "%sub-requests",
    info: { request: n, results: Array.from(t).map((o) => qh(o.result)) }
  }), await Promise.race(s), await de(this, gr, pb).call(this, t, n);
};
function O9(r) {
  return r && typeof r.send == "function" && typeof r.close == "function";
}
const N9 = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
function A4(r, e) {
  e == null && (e = {});
  const t = (a) => e[a] === "-" ? !1 : typeof e.exclusive == "string" ? a === e.exclusive : Array.isArray(e.exclusive) ? e.exclusive.indexOf(a) !== -1 : !0;
  if (typeof r == "string" && r.match(/^https?:/))
    return new _r(r);
  if (typeof r == "string" && r.match(/^wss?:/) || O9(r))
    return new lh(r);
  let n = null;
  try {
    n = vt.from(r);
  } catch {
  }
  const s = [];
  if (t("publicPolygon") && n && (n.name === "matic" ? s.push(new _r("https://polygon-rpc.com/", n, { staticNetwork: n })) : n.name === "matic-amoy" && s.push(new _r("https://rpc-amoy.polygon.technology/", n, { staticNetwork: n }))), t("alchemy"))
    try {
      s.push(new Pu(r, e.alchemy));
    } catch {
    }
  if (t("ankr") && e.ankr != null)
    try {
      s.push(new Eu(r, e.ankr));
    } catch {
    }
  if (t("chainstack"))
    try {
      s.push(new vu(r, e.chainstack));
    } catch {
    }
  if (t("cloudflare"))
    try {
      s.push(new Dg(r));
    } catch {
    }
  if (t("etherscan"))
    try {
      s.push(new jg(r, e.etherscan));
    } catch {
    }
  if (t("infura"))
    try {
      let a = e.infura, o;
      typeof a == "object" && (o = a.projectSecret, a = a.projectId), s.push(new Ao(r, a, o));
    } catch {
    }
  if (t("quicknode"))
    try {
      let a = e.quicknode;
      s.push(new ku(r, a));
    } catch {
    }
  if (Ee(s.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
    operation: "getDefaultProvider"
  }), s.length === 1)
    return s[0];
  let i = Math.floor(s.length / 2);
  return i > 2 && (i = 2), n && N9.indexOf(n.name) !== -1 && (i = 1), e && e.quorum && (i = e.quorum), new zg(s, void 0, { quorum: i });
}
var Ni, uo;
const Tx = class Tx extends Mu {
  /**
   *  Creates a new **NonceManager** to manage %%signer%%.
   */
  constructor(t) {
    super(t.provider);
    /**
     *  The Signer being managed.
     */
    Q(this, "signer");
    Z(this, Ni);
    Z(this, uo);
    _e(this, { signer: t }), F(this, Ni, null), F(this, uo, 0);
  }
  async getAddress() {
    return this.signer.getAddress();
  }
  connect(t) {
    return new Tx(this.signer.connect(t));
  }
  async getNonce(t) {
    if (t === "pending") {
      x(this, Ni) == null && F(this, Ni, super.getNonce("pending"));
      const n = x(this, uo);
      return await x(this, Ni) + n;
    }
    return super.getNonce(t);
  }
  /**
   *  Manually increment the nonce. This may be useful when managng
   *  offline transactions.
   */
  increment() {
    rn(this, uo)._++;
  }
  /**
   *  Resets the nonce, causing the **NonceManager** to reload the current
   *  nonce from the blockchain on the next transaction.
   */
  reset() {
    F(this, uo, 0), F(this, Ni, null);
  }
  async sendTransaction(t) {
    const n = this.getNonce("pending");
    return this.increment(), t = await this.signer.populateTransaction(t), t.nonce = await n, await this.signer.sendTransaction(t);
  }
  signTransaction(t) {
    return this.signer.signTransaction(t);
  }
  signMessage(t) {
    return this.signer.signMessage(t);
  }
  signTypedData(t, n, s) {
    return this.signer.signTypedData(t, n, s);
  }
};
Ni = new WeakMap(), uo = new WeakMap();
let md = Tx;
var su;
class Jg extends g4 {
  /**
   *  Connect to the %%ethereum%% provider, optionally forcing the
   *  %%network%%.
   */
  constructor(t, n, s) {
    const i = Object.assign({}, s ?? {}, { batchMaxCount: 1 });
    ue(t && t.request, "invalid EIP-1193 provider", "ethereum", t);
    super(n, i);
    Z(this, su);
    F(this, su, async (a, o) => {
      const u = { method: a, params: o };
      this.emit("debug", { action: "sendEip1193Request", payload: u });
      try {
        const c = await t.request(u);
        return this.emit("debug", { action: "receiveEip1193Result", result: c }), c;
      } catch (c) {
        const l = new Error(c.message);
        throw l.code = c.code, l.data = c.data, l.payload = u, this.emit("debug", { action: "receiveEip1193Error", error: l }), l;
      }
    });
  }
  async send(t, n) {
    return await this._start(), await super.send(t, n);
  }
  async _send(t) {
    ue(!Array.isArray(t), "EIP-1193 does not support batch request", "payload", t);
    try {
      const n = await x(this, su).call(this, t.method, t.params || []);
      return [{ id: t.id, result: n }];
    } catch (n) {
      return [{
        id: t.id,
        error: { code: n.code, data: n.data, message: n.message }
      }];
    }
  }
  getRpcError(t, n) {
    switch (n = JSON.parse(JSON.stringify(n)), n.error.code || -1) {
      case 4001:
        n.error.message = `ethers-user-denied: ${n.error.message}`;
        break;
      case 4200:
        n.error.message = `ethers-unsupported: ${n.error.message}`;
        break;
    }
    return super.getRpcError(t, n);
  }
  /**
   *  Resolves to ``true`` if the provider manages the %%address%%.
   */
  async hasSigner(t) {
    t == null && (t = 0);
    const n = await this.send("eth_accounts", []);
    return typeof t == "number" ? n.length > t : (t = t.toLowerCase(), n.filter((s) => s.toLowerCase() === t).length !== 0);
  }
  async getSigner(t) {
    if (t == null && (t = 0), !await this.hasSigner(t))
      try {
        await x(this, su).call(this, "eth_requestAccounts", []);
      } catch (n) {
        const s = n.payload;
        throw this.getRpcError(s, { id: s.id, error: n });
      }
    return await super.getSigner(t);
  }
}
su = new WeakMap();
const If = "62e1ad51b37b8e00394bda3b";
function S9(r) {
  switch (r) {
    case "mainnet":
      return "eth-mainnet.gateway.pokt.network";
    case "goerli":
      return "eth-goerli.gateway.pokt.network";
    case "matic":
      return "poly-mainnet.gateway.pokt.network";
    case "matic-mumbai":
      return "polygon-mumbai-rpc.gateway.pokt.network";
  }
  ue(!1, "unsupported network", "network", r);
}
class O0 extends _r {
  /**
   *  Create a new **PocketProvider**.
   *
   *  By default connecting to ``mainnet`` with a highly throttled
   *  API key.
   */
  constructor(t, n, s) {
    t == null && (t = "mainnet");
    const i = vt.from(t);
    n == null && (n = If), s == null && (s = null);
    const a = { staticNetwork: i }, o = O0.getRequest(i, n, s);
    super(o, i, a);
    /**
     *  The Application ID for the Pocket connection.
     */
    Q(this, "applicationId");
    /**
     *  The Application Secret for making authenticated requests
     *  to the Pocket connection.
     */
    Q(this, "applicationSecret");
    _e(this, { applicationId: n, applicationSecret: s });
  }
  _getProvider(t) {
    try {
      return new O0(t, this.applicationId, this.applicationSecret);
    } catch {
    }
    return super._getProvider(t);
  }
  /**
   *  Returns a prepared request for connecting to %%network%% with
   *  %%applicationId%%.
   */
  static getRequest(t, n, s) {
    n == null && (n = If);
    const i = new Kt(`https://${S9(t.name)}/v1/lb/${n}`);
    return i.allowGzip = !0, s && i.setCredentials("", s), n === If && (i.retryFunc = async (a, o, u) => (qs("PocketProvider"), !0)), i;
  }
  isCommunityResource() {
    return this.applicationId === If;
  }
}
const E4 = void 0;
var iu;
const Bx = class Bx extends Mu {
  /**
   *  Creates a new BaseWallet for %%privateKey%%, optionally
   *  connected to %%provider%%.
   *
   *  If %%provider%% is not specified, only offline methods can
   *  be used.
   */
  constructor(t, n) {
    super(n);
    /**
     *  The wallet address.
     */
    Q(this, "address");
    Z(this, iu);
    ue(t && typeof t.sign == "function", "invalid private key", "privateKey", "[ REDACTED ]"), F(this, iu, t);
    const s = Oo(this.signingKey.publicKey);
    _e(this, { address: s });
  }
  // Store private values behind getters to reduce visibility
  // in console.log
  /**
   *  The [[SigningKey]] used for signing payloads.
   */
  get signingKey() {
    return x(this, iu);
  }
  /**
   *  The private key for this wallet.
   */
  get privateKey() {
    return this.signingKey.privateKey;
  }
  async getAddress() {
    return this.address;
  }
  connect(t) {
    return new Bx(x(this, iu), t);
  }
  async signTransaction(t) {
    t = xo(t);
    const { to: n, from: s } = await Lt({
      to: t.to ? Dt(t.to, this.provider) : void 0,
      from: t.from ? Dt(t.from, this.provider) : void 0
    });
    n != null && (t.to = n), s != null && (t.from = s), t.from != null && (ue(et(t.from) === this.address, "transaction from address mismatch", "tx.from", t.from), delete t.from);
    const i = Ii.from(t);
    return i.signature = this.signingKey.sign(i.unsignedHash), i.serialized;
  }
  async signMessage(t) {
    return this.signMessageSync(t);
  }
  // @TODO: Add a secialized signTx and signTyped sync that enforces
  // all parameters are known?
  /**
   *  Returns the signature for %%message%% signed with this wallet.
   */
  signMessageSync(t) {
    return this.signingKey.sign(Xd(t)).serialized;
  }
  async signTypedData(t, n, s) {
    const i = await js.resolveNames(t, n, s, async (a) => {
      Ee(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
        operation: "resolveName",
        info: { name: a }
      });
      const o = await this.provider.resolveName(a);
      return Ee(o != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
        value: a
      }), o;
    });
    return this.signingKey.sign(js.hash(i.domain, n, i.value)).serialized;
  }
};
iu = new WeakMap();
let Tu = Bx;
const yd = " !#$%&'()*+,-./<=>?@[]^_`{|}~", C9 = /^[a-z]*$/i;
function Ym(r, e) {
  let t = 97;
  return r.reduce((n, s) => (s === e ? t++ : s.match(C9) ? n.push(String.fromCharCode(t) + s) : (t = 97, n.push(s)), n), []);
}
function R9(r, e) {
  for (let s = yd.length - 1; s >= 0; s--)
    r = r.split(yd[s]).join(e.substring(2 * s, 2 * s + 2));
  const t = [], n = r.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (s, i, a, o) => {
    if (a)
      for (let u = parseInt(a); u >= 0; u--)
        t.push(";");
    else
      t.push(i.toLowerCase());
    return "";
  });
  if (n)
    throw new Error(`leftovers: ${JSON.stringify(n)}`);
  return Ym(Ym(t, ";"), ":");
}
function P4(r) {
  return ue(r[0] === "0", "unsupported auwl data", "data", r), R9(r.substring(1 + 2 * yd.length), r.substring(1, 1 + 2 * yd.length));
}
class Qg {
  /**
   *  Creates a new Wordlist instance.
   *
   *  Sub-classes MUST call this if they provide their own constructor,
   *  passing in the locale string of the language.
   *
   *  Generally there is no need to create instances of a Wordlist,
   *  since each language-specific Wordlist creates an instance and
   *  there is no state kept internally, so they are safe to share.
   */
  constructor(e) {
    Q(this, "locale");
    _e(this, { locale: e });
  }
  /**
   *  Sub-classes may override this to provide a language-specific
   *  method for spliting %%phrase%% into individual words.
   *
   *  By default, %%phrase%% is split using any sequences of
   *  white-space as defined by regular expressions (i.e. ``/\s+/``).
   */
  split(e) {
    return e.toLowerCase().split(/\s+/g);
  }
  /**
   *  Sub-classes may override this to provider a language-specific
   *  method for joining %%words%% into a phrase.
   *
   *  By default, %%words%% are joined by a single space.
   */
  join(e) {
    return e.join(" ");
  }
}
var au, $0, lo, K0, bb;
class fh extends Qg {
  /**
   *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
   *  and validated against the %%checksum%%.
   */
  constructor(t, n, s) {
    super(t);
    Z(this, K0);
    Z(this, au);
    Z(this, $0);
    Z(this, lo);
    F(this, au, n), F(this, $0, s), F(this, lo, null);
  }
  /**
   *  The OWL-encoded data.
   */
  get _data() {
    return x(this, au);
  }
  /**
   *  Decode all the words for the wordlist.
   */
  _decodeWords() {
    return P4(x(this, au));
  }
  getWord(t) {
    const n = de(this, K0, bb).call(this);
    return ue(t >= 0 && t < n.length, `invalid word index: ${t}`, "index", t), n[t];
  }
  getWordIndex(t) {
    return de(this, K0, bb).call(this).indexOf(t);
  }
}
au = new WeakMap(), $0 = new WeakMap(), lo = new WeakMap(), K0 = new WeakSet(), bb = function() {
  if (x(this, lo) == null) {
    const t = this._decodeWords();
    if (vn(t.join(`
`) + `
`) !== x(this, $0))
      throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
    F(this, lo, t);
  }
  return x(this, lo);
};
const I9 = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO", _9 = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
let Zh = null;
class Xn extends fh {
  /**
   *  Creates a new instance of the English language Wordlist.
   *
   *  This should be unnecessary most of the time as the exported
   *  [[langEn]] should suffice.
   *
   *  @_ignore:
   */
  constructor() {
    super("en", I9, _9);
  }
  /**
   *  Returns a singleton instance of a ``LangEn``, creating it
   *  if this is the first time being called.
   */
  static wordlist() {
    return Zh == null && (Zh = new Xn()), Zh;
  }
}
function v4(r) {
  return (1 << r) - 1 << 8 - r & 255;
}
function U9(r) {
  return (1 << r) - 1 & 255;
}
function Xh(r, e) {
  jd("NFKD"), e == null && (e = Xn.wordlist());
  const t = e.split(r);
  ue(t.length % 3 === 0 && t.length >= 12 && t.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
  const n = new Uint8Array(Math.ceil(11 * t.length / 8));
  let s = 0;
  for (let c = 0; c < t.length; c++) {
    let l = e.getWordIndex(t[c].normalize("NFKD"));
    ue(l >= 0, `invalid mnemonic word at index ${c}`, "mnemonic", "[ REDACTED ]");
    for (let f = 0; f < 11; f++)
      l & 1 << 10 - f && (n[s >> 3] |= 1 << 7 - s % 8), s++;
  }
  const i = 32 * t.length / 3, a = t.length / 3, o = v4(a), u = Ce(nr(n.slice(0, i / 8)))[0] & o;
  return ue(u === (n[n.length - 1] & o), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]"), Oe(n.slice(0, i / 8));
}
function ep(r, e) {
  ue(r.length % 4 === 0 && r.length >= 16 && r.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]"), e == null && (e = Xn.wordlist());
  const t = [0];
  let n = 11;
  for (let a = 0; a < r.length; a++)
    n > 8 ? (t[t.length - 1] <<= 8, t[t.length - 1] |= r[a], n -= 8) : (t[t.length - 1] <<= n, t[t.length - 1] |= r[a] >> 8 - n, t.push(r[a] & U9(8 - n)), n += 3);
  const s = r.length / 4, i = parseInt(nr(r).substring(2, 4), 16) & v4(s);
  return t[t.length - 1] <<= s, t[t.length - 1] |= i >> 8 - s, e.join(t.map((a) => e.getWord(a)));
}
const tp = {};
class Ui {
  /**
   *  @private
   */
  constructor(e, t, n, s, i) {
    /**
     *  The mnemonic phrase of 12, 15, 18, 21 or 24 words.
     *
     *  Use the [[wordlist]] ``split`` method to get the individual words.
     */
    Q(this, "phrase");
    /**
     *  The password used for this mnemonic. If no password is used this
     *  is the empty string (i.e. ``""``) as per the specification.
     */
    Q(this, "password");
    /**
     *  The wordlist for this mnemonic.
     */
    Q(this, "wordlist");
    /**
     *  The underlying entropy which the mnemonic encodes.
     */
    Q(this, "entropy");
    s == null && (s = ""), i == null && (i = Xn.wordlist()), es(e, tp, "Mnemonic"), _e(this, { phrase: n, password: s, wordlist: i, entropy: t });
  }
  /**
   *  Returns the seed for the mnemonic.
   */
  computeSeed() {
    const e = It("mnemonic" + this.password, "NFKD");
    return Bn(It(this.phrase, "NFKD"), e, 2048, 64, "sha512");
  }
  /**
   *  Creates a new Mnemonic for the %%phrase%%.
   *
   *  The default %%password%% is the empty string and the default
   *  wordlist is the [English wordlists](LangEn).
   */
  static fromPhrase(e, t, n) {
    const s = Xh(e, n);
    return e = ep(Ce(s), n), new Ui(tp, s, e, t, n);
  }
  /**
   *  Create a new **Mnemonic** from the %%entropy%%.
   *
   *  The default %%password%% is the empty string and the default
   *  wordlist is the [English wordlists](LangEn).
   */
  static fromEntropy(e, t, n) {
    const s = Ce(e, "entropy"), i = ep(s, n);
    return new Ui(tp, Oe(s), i, t, n);
  }
  /**
   *  Returns the phrase for %%mnemonic%%.
   */
  static entropyToPhrase(e, t) {
    const n = Ce(e, "entropy");
    return ep(n, t);
  }
  /**
   *  Returns the entropy for %%phrase%%.
   */
  static phraseToEntropy(e, t) {
    return Xh(e, t);
  }
  /**
   *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
   *
   *  This checks all the provided words belong to the %%wordlist%%,
   *  that the length is valid and the checksum is correct.
   */
  static isValidMnemonic(e, t) {
    try {
      return Xh(e, t), !0;
    } catch {
    }
    return !1;
  }
}
/*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
var Jt = function(r, e, t, n) {
  if (t === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? r !== e || !n : !e.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? n : t === "a" ? n.call(r) : n ? n.value : e.get(r);
}, rp = function(r, e, t, n, s) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? r !== e || !s : !e.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(r, t) : s ? s.value = t : e.set(r, t), t;
}, Zf, Hr, Fn;
const L9 = { 16: 10, 24: 12, 32: 14 }, M9 = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], Dr = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], _f = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], F9 = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], D9 = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], j9 = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], H9 = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], G9 = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], V9 = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], $9 = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], K9 = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], z9 = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], J9 = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], Q9 = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], q9 = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
function np(r) {
  const e = [];
  for (let t = 0; t < r.length; t += 4)
    e.push(r[t] << 24 | r[t + 1] << 16 | r[t + 2] << 8 | r[t + 3]);
  return e;
}
class qg {
  get key() {
    return Jt(this, Zf, "f").slice();
  }
  constructor(e) {
    if (Zf.set(this, void 0), Hr.set(this, void 0), Fn.set(this, void 0), !(this instanceof qg))
      throw Error("AES must be instanitated with `new`");
    rp(this, Zf, new Uint8Array(e), "f");
    const t = L9[this.key.length];
    if (t == null)
      throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
    rp(this, Fn, [], "f"), rp(this, Hr, [], "f");
    for (let l = 0; l <= t; l++)
      Jt(this, Fn, "f").push([0, 0, 0, 0]), Jt(this, Hr, "f").push([0, 0, 0, 0]);
    const n = (t + 1) * 4, s = this.key.length / 4, i = np(this.key);
    let a;
    for (let l = 0; l < s; l++)
      a = l >> 2, Jt(this, Fn, "f")[a][l % 4] = i[l], Jt(this, Hr, "f")[t - a][l % 4] = i[l];
    let o = 0, u = s, c;
    for (; u < n; ) {
      if (c = i[s - 1], i[0] ^= Dr[c >> 16 & 255] << 24 ^ Dr[c >> 8 & 255] << 16 ^ Dr[c & 255] << 8 ^ Dr[c >> 24 & 255] ^ M9[o] << 24, o += 1, s != 8)
        for (let h = 1; h < s; h++)
          i[h] ^= i[h - 1];
      else {
        for (let h = 1; h < s / 2; h++)
          i[h] ^= i[h - 1];
        c = i[s / 2 - 1], i[s / 2] ^= Dr[c & 255] ^ Dr[c >> 8 & 255] << 8 ^ Dr[c >> 16 & 255] << 16 ^ Dr[c >> 24 & 255] << 24;
        for (let h = s / 2 + 1; h < s; h++)
          i[h] ^= i[h - 1];
      }
      let l = 0, f, d;
      for (; l < s && u < n; )
        f = u >> 2, d = u % 4, Jt(this, Fn, "f")[f][d] = i[l], Jt(this, Hr, "f")[t - f][d] = i[l++], u++;
    }
    for (let l = 1; l < t; l++)
      for (let f = 0; f < 4; f++)
        c = Jt(this, Hr, "f")[l][f], Jt(this, Hr, "f")[l][f] = z9[c >> 24 & 255] ^ J9[c >> 16 & 255] ^ Q9[c >> 8 & 255] ^ q9[c & 255];
  }
  encrypt(e) {
    if (e.length != 16)
      throw new TypeError("invalid plaintext size (must be 16 bytes)");
    const t = Jt(this, Fn, "f").length - 1, n = [0, 0, 0, 0];
    let s = np(e);
    for (let o = 0; o < 4; o++)
      s[o] ^= Jt(this, Fn, "f")[0][o];
    for (let o = 1; o < t; o++) {
      for (let u = 0; u < 4; u++)
        n[u] = F9[s[u] >> 24 & 255] ^ D9[s[(u + 1) % 4] >> 16 & 255] ^ j9[s[(u + 2) % 4] >> 8 & 255] ^ H9[s[(u + 3) % 4] & 255] ^ Jt(this, Fn, "f")[o][u];
      s = n.slice();
    }
    const i = new Uint8Array(16);
    let a = 0;
    for (let o = 0; o < 4; o++)
      a = Jt(this, Fn, "f")[t][o], i[4 * o] = (Dr[s[o] >> 24 & 255] ^ a >> 24) & 255, i[4 * o + 1] = (Dr[s[(o + 1) % 4] >> 16 & 255] ^ a >> 16) & 255, i[4 * o + 2] = (Dr[s[(o + 2) % 4] >> 8 & 255] ^ a >> 8) & 255, i[4 * o + 3] = (Dr[s[(o + 3) % 4] & 255] ^ a) & 255;
    return i;
  }
  decrypt(e) {
    if (e.length != 16)
      throw new TypeError("invalid ciphertext size (must be 16 bytes)");
    const t = Jt(this, Hr, "f").length - 1, n = [0, 0, 0, 0];
    let s = np(e);
    for (let o = 0; o < 4; o++)
      s[o] ^= Jt(this, Hr, "f")[0][o];
    for (let o = 1; o < t; o++) {
      for (let u = 0; u < 4; u++)
        n[u] = G9[s[u] >> 24 & 255] ^ V9[s[(u + 3) % 4] >> 16 & 255] ^ $9[s[(u + 2) % 4] >> 8 & 255] ^ K9[s[(u + 1) % 4] & 255] ^ Jt(this, Hr, "f")[o][u];
      s = n.slice();
    }
    const i = new Uint8Array(16);
    let a = 0;
    for (let o = 0; o < 4; o++)
      a = Jt(this, Hr, "f")[t][o], i[4 * o] = (_f[s[o] >> 24 & 255] ^ a >> 24) & 255, i[4 * o + 1] = (_f[s[(o + 3) % 4] >> 16 & 255] ^ a >> 16) & 255, i[4 * o + 2] = (_f[s[(o + 2) % 4] >> 8 & 255] ^ a >> 8) & 255, i[4 * o + 3] = (_f[s[(o + 1) % 4] & 255] ^ a) & 255;
    return i;
  }
}
Zf = /* @__PURE__ */ new WeakMap(), Hr = /* @__PURE__ */ new WeakMap(), Fn = /* @__PURE__ */ new WeakMap();
class k4 {
  constructor(e, t, n) {
    if (n && !(this instanceof n))
      throw new Error(`${e} must be instantiated with "new"`);
    Object.defineProperties(this, {
      aes: { enumerable: !0, value: new qg(t) },
      name: { enumerable: !0, value: e }
    });
  }
}
var Uf = function(r, e, t, n, s) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? r !== e || !s : !e.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(r, t) : s ? s.value = t : e.set(r, t), t;
}, qo = function(r, e, t, n) {
  if (t === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? r !== e || !n : !e.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? n : t === "a" ? n.call(r) : n ? n.value : e.get(r);
}, u0, fs;
class Wg extends k4 {
  constructor(e, t) {
    if (super("ECC", e, Wg), u0.set(this, void 0), fs.set(this, void 0), t) {
      if (t.length % 16)
        throw new TypeError("invalid iv size (must be 16 bytes)");
      Uf(this, u0, new Uint8Array(t), "f");
    } else
      Uf(this, u0, new Uint8Array(16), "f");
    Uf(this, fs, this.iv, "f");
  }
  get iv() {
    return new Uint8Array(qo(this, u0, "f"));
  }
  encrypt(e) {
    if (e.length % 16)
      throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
    const t = new Uint8Array(e.length);
    for (let n = 0; n < e.length; n += 16) {
      for (let s = 0; s < 16; s++)
        qo(this, fs, "f")[s] ^= e[n + s];
      Uf(this, fs, this.aes.encrypt(qo(this, fs, "f")), "f"), t.set(qo(this, fs, "f"), n);
    }
    return t;
  }
  decrypt(e) {
    if (e.length % 16)
      throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
    const t = new Uint8Array(e.length);
    for (let n = 0; n < e.length; n += 16) {
      const s = this.aes.decrypt(e.subarray(n, n + 16));
      for (let i = 0; i < 16; i++)
        t[n + i] = s[i] ^ qo(this, fs, "f")[i], qo(this, fs, "f")[i] = e[n + i];
    }
    return t;
  }
}
u0 = /* @__PURE__ */ new WeakMap(), fs = /* @__PURE__ */ new WeakMap();
var Wo = function(r, e, t, n, s) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? r !== e || !s : !e.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(r, t) : s ? s.value = t : e.set(r, t), t;
}, jr = function(r, e, t, n) {
  if (t === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? r !== e || !n : !e.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? n : t === "a" ? n.call(r) : n ? n.value : e.get(r);
}, l0, Oa, Gr;
class Bu extends k4 {
  constructor(e, t) {
    super("CTR", e, Bu), l0.set(this, void 0), Oa.set(this, void 0), Gr.set(this, void 0), Wo(this, Gr, new Uint8Array(16), "f"), jr(this, Gr, "f").fill(0), Wo(this, l0, jr(this, Gr, "f"), "f"), Wo(this, Oa, 16, "f"), t == null && (t = 1), typeof t == "number" ? this.setCounterValue(t) : this.setCounterBytes(t);
  }
  get counter() {
    return new Uint8Array(jr(this, Gr, "f"));
  }
  setCounterValue(e) {
    if (!Number.isInteger(e) || e < 0 || e > Number.MAX_SAFE_INTEGER)
      throw new TypeError("invalid counter initial integer value");
    for (let t = 15; t >= 0; --t)
      jr(this, Gr, "f")[t] = e % 256, e = Math.floor(e / 256);
  }
  setCounterBytes(e) {
    if (e.length !== 16)
      throw new TypeError("invalid counter initial Uint8Array value length");
    jr(this, Gr, "f").set(e);
  }
  increment() {
    for (let e = 15; e >= 0; e--)
      if (jr(this, Gr, "f")[e] === 255)
        jr(this, Gr, "f")[e] = 0;
      else {
        jr(this, Gr, "f")[e]++;
        break;
      }
  }
  encrypt(e) {
    var t, n;
    const s = new Uint8Array(e);
    for (let i = 0; i < s.length; i++)
      jr(this, Oa, "f") === 16 && (Wo(this, l0, this.aes.encrypt(jr(this, Gr, "f")), "f"), Wo(this, Oa, 0, "f"), this.increment()), s[i] ^= jr(this, l0, "f")[Wo(this, Oa, (n = jr(this, Oa, "f"), t = n++, n), "f"), t];
    return s;
  }
  decrypt(e) {
    return this.encrypt(e);
  }
}
l0 = /* @__PURE__ */ new WeakMap(), Oa = /* @__PURE__ */ new WeakMap(), Gr = /* @__PURE__ */ new WeakMap();
function W9(r) {
  if (r.length < 16)
    throw new TypeError("PKCS#7 invalid length");
  const e = r[r.length - 1];
  if (e > 16)
    throw new TypeError("PKCS#7 padding byte out of range");
  const t = r.length - e;
  for (let n = 0; n < e; n++)
    if (r[t + n] !== e)
      throw new TypeError("PKCS#7 invalid padding byte");
  return new Uint8Array(r.subarray(0, t));
}
function T4(r) {
  return typeof r == "string" && !r.startsWith("0x") && (r = "0x" + r), Mt(r);
}
function zu(r, e) {
  for (r = String(r); r.length < e; )
    r = "0" + r;
  return r;
}
function cf(r) {
  return typeof r == "string" ? It(r, "NFKC") : Mt(r);
}
function Bt(r, e) {
  const t = e.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
  ue(t != null, "invalid path", "path", e);
  const n = t[1], s = t[3], i = t[4] === "!";
  let a = r;
  for (const o of n.toLowerCase().split(".")) {
    if (Array.isArray(a)) {
      if (!o.match(/^[0-9]+$/))
        break;
      a = a[parseInt(o)];
    } else if (typeof a == "object") {
      let u = null;
      for (const c in a)
        if (c.toLowerCase() === o) {
          u = a[c];
          break;
        }
      a = u;
    } else
      a = null;
    if (a == null)
      break;
  }
  if (ue(!i || a != null, "missing required value", "path", n), s && a != null) {
    if (s === "int") {
      if (typeof a == "string" && a.match(/^-?[0-9]+$/))
        return parseInt(a);
      if (Number.isSafeInteger(a))
        return a;
    }
    if (s === "number" && typeof a == "string" && a.match(/^-?[0-9.]*$/))
      return parseFloat(a);
    if (s === "data" && typeof a == "string")
      return T4(a);
    if (s === "array" && Array.isArray(a) || s === typeof a)
      return a;
    ue(!1, `wrong type found for ${s} `, "path", n);
  }
  return a;
}
const B4 = "m/44'/60'/0'/0/0";
function wd(r) {
  try {
    const e = JSON.parse(r);
    if ((e.version != null ? parseInt(e.version) : 0) === 3)
      return !0;
  } catch {
  }
  return !1;
}
function Y9(r, e, t) {
  if (Bt(r, "crypto.cipher:string") === "aes-128-ctr") {
    const s = Bt(r, "crypto.cipherparams.iv:data!"), i = new Bu(e, s);
    return Oe(i.decrypt(t));
  }
  Ee(!1, "unsupported cipher", "UNSUPPORTED_OPERATION", {
    operation: "decrypt"
  });
}
function Ad(r, e) {
  const t = Ce(e), n = Bt(r, "crypto.ciphertext:data!"), s = Oe(ft(it([t.slice(16, 32), n]))).substring(2);
  ue(s === Bt(r, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
  const i = Y9(r, t.slice(0, 16), n), a = Oo(i);
  if (r.address) {
    let c = r.address.toLowerCase();
    c.startsWith("0x") || (c = "0x" + c), ue(et(c) === a, "keystore address/privateKey mismatch", "address", r.address);
  }
  const o = { address: a, privateKey: i };
  if (Bt(r, "x-ethers.version:string") === "0.1") {
    const c = t.slice(32, 64), l = Bt(r, "x-ethers.mnemonicCiphertext:data!"), f = Bt(r, "x-ethers.mnemonicCounter:data!"), d = new Bu(c, f);
    o.mnemonic = {
      path: Bt(r, "x-ethers.path:string") || B4,
      locale: Bt(r, "x-ethers.locale:string") || "en",
      entropy: Oe(Ce(d.decrypt(l)))
    };
  }
  return o;
}
function O4(r) {
  const e = Bt(r, "crypto.kdf:string");
  if (e && typeof e == "string") {
    if (e.toLowerCase() === "scrypt") {
      const t = Bt(r, "crypto.kdfparams.salt:data!"), n = Bt(r, "crypto.kdfparams.n:int!"), s = Bt(r, "crypto.kdfparams.r:int!"), i = Bt(r, "crypto.kdfparams.p:int!");
      ue(n > 0 && (n & n - 1) === 0, "invalid kdf.N", "kdf.N", n), ue(s > 0 && i > 0, "invalid kdf", "kdf", e);
      const a = Bt(r, "crypto.kdfparams.dklen:int!");
      return ue(a === 32, "invalid kdf.dklen", "kdf.dflen", a), { name: "scrypt", salt: t, N: n, r: s, p: i, dkLen: 64 };
    } else if (e.toLowerCase() === "pbkdf2") {
      const t = Bt(r, "crypto.kdfparams.salt:data!"), n = Bt(r, "crypto.kdfparams.prf:string!"), s = n.split("-").pop();
      ue(s === "sha256" || s === "sha512", "invalid kdf.pdf", "kdf.pdf", n);
      const i = Bt(r, "crypto.kdfparams.c:int!"), a = Bt(r, "crypto.kdfparams.dklen:int!");
      return ue(a === 32, "invalid kdf.dklen", "kdf.dklen", a), { name: "pbkdf2", salt: t, count: i, dkLen: a, algorithm: s };
    }
  }
  ue(!1, "unsupported key-derivation function", "kdf", e);
}
function Yg(r, e) {
  const t = JSON.parse(r), n = cf(e), s = O4(t);
  if (s.name === "pbkdf2") {
    const { salt: f, count: d, dkLen: h, algorithm: p } = s, g = Bn(n, f, d, h, p);
    return Ad(t, g);
  }
  Ee(s.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: s });
  const { salt: i, N: a, r: o, p: u, dkLen: c } = s, l = Js(n, i, a, o, u, c);
  return Ad(t, l);
}
function Zm(r) {
  return new Promise((e) => {
    setTimeout(() => {
      e();
    }, r);
  });
}
async function Zg(r, e, t) {
  const n = JSON.parse(r), s = cf(e), i = O4(n);
  if (i.name === "pbkdf2") {
    t && (t(0), await Zm(0));
    const { salt: d, count: h, dkLen: p, algorithm: g } = i, k = Bn(s, d, h, p, g);
    return t && (t(1), await Zm(0)), Ad(n, k);
  }
  Ee(i.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: i });
  const { salt: a, N: o, r: u, p: c, dkLen: l } = i, f = await zs(s, a, o, u, c, l, t);
  return Ad(n, f);
}
function N4(r) {
  const e = r.salt != null ? Ce(r.salt, "options.salt") : Ir(32);
  let t = 1 << 17, n = 8, s = 1;
  return r.scrypt && (r.scrypt.N && (t = r.scrypt.N), r.scrypt.r && (n = r.scrypt.r), r.scrypt.p && (s = r.scrypt.p)), ue(typeof t == "number" && t > 0 && Number.isSafeInteger(t) && (BigInt(t) & BigInt(t - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", t), ue(typeof n == "number" && n > 0 && Number.isSafeInteger(n), "invalid scrypt r parameter", "options.r", n), ue(typeof s == "number" && s > 0 && Number.isSafeInteger(s), "invalid scrypt p parameter", "options.p", s), { name: "scrypt", dkLen: 32, salt: e, N: t, r: n, p: s };
}
function S4(r, e, t, n) {
  const s = Ce(t.privateKey, "privateKey"), i = n.iv != null ? Ce(n.iv, "options.iv") : Ir(16);
  ue(i.length === 16, "invalid options.iv length", "options.iv", n.iv);
  const a = n.uuid != null ? Ce(n.uuid, "options.uuid") : Ir(16);
  ue(a.length === 16, "invalid options.uuid length", "options.uuid", n.iv);
  const o = r.slice(0, 16), u = r.slice(16, 32), c = new Bu(o, i), l = Ce(c.encrypt(s)), f = ft(it([u, l])), d = {
    address: t.address.substring(2).toLowerCase(),
    id: rg(a),
    version: 3,
    Crypto: {
      cipher: "aes-128-ctr",
      cipherparams: {
        iv: Oe(i).substring(2)
      },
      ciphertext: Oe(l).substring(2),
      kdf: "scrypt",
      kdfparams: {
        salt: Oe(e.salt).substring(2),
        n: e.N,
        dklen: 32,
        p: e.p,
        r: e.r
      },
      mac: f.substring(2)
    }
  };
  if (t.mnemonic) {
    const h = n.client != null ? n.client : `ethers/${Fd}`, p = t.mnemonic.path || B4, g = t.mnemonic.locale || "en", k = r.slice(32, 64), A = Ce(t.mnemonic.entropy, "account.mnemonic.entropy"), y = Ir(16), E = new Bu(k, y), m = Ce(E.encrypt(A)), N = /* @__PURE__ */ new Date(), U = "UTC--" + (N.getUTCFullYear() + "-" + zu(N.getUTCMonth() + 1, 2) + "-" + zu(N.getUTCDate(), 2) + "T" + zu(N.getUTCHours(), 2) + "-" + zu(N.getUTCMinutes(), 2) + "-" + zu(N.getUTCSeconds(), 2) + ".0Z") + "--" + d.address;
    d["x-ethers"] = {
      client: h,
      gethFilename: U,
      path: p,
      locale: g,
      mnemonicCounter: Oe(y).substring(2),
      mnemonicCiphertext: Oe(m).substring(2),
      version: "0.1"
    };
  }
  return JSON.stringify(d);
}
function dh(r, e, t) {
  t == null && (t = {});
  const n = cf(e), s = N4(t), i = Js(n, s.salt, s.N, s.r, s.p, 64);
  return S4(Ce(i), s, r, t);
}
async function hh(r, e, t) {
  t == null && (t = {});
  const n = cf(e), s = N4(t), i = await zs(n, s.salt, s.N, s.r, s.p, 64, t.progressCallback);
  return S4(Ce(i), s, r, t);
}
const y0 = "m/44'/60'/0'/0/0", Z9 = new Uint8Array([66, 105, 116, 99, 111, 105, 110, 32, 115, 101, 101, 100]), Yn = 2147483648, X9 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), eP = "0123456789abcdef";
function Ed(r, e) {
  let t = "";
  for (; r; )
    t = eP[r % 16] + t, r = Math.trunc(r / 16);
  for (; t.length < e * 2; )
    t = "0" + t;
  return "0x" + t;
}
function gb(r) {
  const e = Ce(r), t = lt(nr(nr(e)), 0, 4), n = it([e, t]);
  return Gd(n);
}
const Dn = {};
function C4(r, e, t, n) {
  const s = new Uint8Array(37);
  r & Yn ? (Ee(n != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
    operation: "deriveChild"
  }), s.set(Ce(n), 1)) : s.set(Ce(t));
  for (let a = 24; a >= 0; a -= 8)
    s[33 + (a >> 3)] = r >> 24 - a & 255;
  const i = Ce($s("sha512", e, s));
  return { IL: i.slice(0, 32), IR: i.slice(32) };
}
function R4(r, e) {
  const t = e.split("/");
  ue(t.length > 0, "invalid path", "path", e), t[0] === "m" && (ue(r.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${r.depth}`, "path", e), t.shift());
  let n = r;
  for (let s = 0; s < t.length; s++) {
    const i = t[s];
    if (i.match(/^[0-9]+'$/)) {
      const a = parseInt(i.substring(0, i.length - 1));
      ue(a < Yn, "invalid path index", `path[${s}]`, i), n = n.deriveChild(Yn + a);
    } else if (i.match(/^[0-9]+$/)) {
      const a = parseInt(i);
      ue(a < Yn, "invalid path index", `path[${s}]`, i), n = n.deriveChild(a);
    } else
      ue(!1, "invalid path component", `path[${s}]`, i);
  }
  return n;
}
var z0, xb, fo, f0;
const dn = class dn extends Tu {
  /**
   *  @private
   */
  constructor(t, n, s, i, a, o, u, c, l) {
    super(n, l);
    Z(this, z0);
    /**
     *  The compressed public key.
     */
    Q(this, "publicKey");
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */
    Q(this, "fingerprint");
    /**
     *  The parent fingerprint.
     */
    Q(this, "parentFingerprint");
    /**
     *  The mnemonic used to create this HD Node, if available.
     *
     *  Sources such as extended keys do not encode the mnemonic, in
     *  which case this will be ``null``.
     */
    Q(this, "mnemonic");
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */
    Q(this, "chainCode");
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provide full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  encode it.
     */
    Q(this, "path");
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */
    Q(this, "index");
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */
    Q(this, "depth");
    es(t, Dn, "HDNodeWallet"), _e(this, { publicKey: n.compressedPublicKey });
    const f = lt(Ks(nr(this.publicKey)), 0, 4);
    _e(this, {
      parentFingerprint: s,
      fingerprint: f,
      chainCode: i,
      path: a,
      index: o,
      depth: u
    }), _e(this, { mnemonic: c });
  }
  connect(t) {
    return new dn(Dn, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, t);
  }
  /**
   *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
   *  %%password%%.
   *
   *  If %%progressCallback%% is specified, it will receive periodic
   *  updates as the encryption process progreses.
   */
  async encrypt(t, n) {
    return await hh(de(this, z0, xb).call(this), t, { progressCallback: n });
  }
  /**
   *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
   *  %%password%%.
   *
   *  It is preferred to use the [async version](encrypt) instead,
   *  which allows a [[ProgressCallback]] to keep the user informed.
   *
   *  This method will block the event loop (freezing all UI) until
   *  it is complete, which may be a non-trivial duration.
   */
  encryptSync(t) {
    return dh(de(this, z0, xb).call(this), t);
  }
  /**
   *  The extended key.
   *
   *  This key will begin with the prefix ``xpriv`` and can be used to
   *  reconstruct this HD Node to derive its children.
   */
  get extendedKey() {
    return Ee(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), gb(it([
      "0x0488ADE4",
      Ed(this.depth, 1),
      this.parentFingerprint,
      Ed(this.index, 4),
      this.chainCode,
      it(["0x00", this.privateKey])
    ]));
  }
  /**
   *  Returns true if this wallet has a path, providing a Type Guard
   *  that the path is non-null.
   */
  hasPath() {
    return this.path != null;
  }
  /**
   *  Returns a neutered HD Node, which removes the private details
   *  of an HD Node.
   *
   *  A neutered node has no private key, but can be used to derive
   *  child addresses and other public data about the HD Node.
   */
  neuter() {
    return new Eo(Dn, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
  }
  /**
   *  Return the child for %%index%%.
   */
  deriveChild(t) {
    const n = Ve(t, "index");
    ue(n <= 4294967295, "invalid index", "index", n);
    let s = this.path;
    s && (s += "/" + (n & ~Yn), n & Yn && (s += "'"));
    const { IR: i, IL: a } = C4(n, this.chainCode, this.publicKey, this.privateKey), o = new en(tn((Bo(a) + BigInt(this.privateKey)) % X9, 32));
    return new dn(Dn, o, this.fingerprint, Oe(i), s, n, this.depth + 1, this.mnemonic, this.provider);
  }
  /**
   *  Return the HDNode for %%path%% from this node.
   */
  derivePath(t) {
    return R4(this, t);
  }
  /**
   *  Creates a new HD Node from %%extendedKey%%.
   *
   *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
   *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
   *  or full HD Node ([[HDNodeWallet) respectively.
   */
  static fromExtendedKey(t) {
    const n = Ft(qb(t));
    ue(n.length === 82 || gb(n.slice(0, 78)) === t, "invalid extended key", "extendedKey", "[ REDACTED ]");
    const s = n[4], i = Oe(n.slice(5, 9)), a = parseInt(Oe(n.slice(9, 13)).substring(2), 16), o = Oe(n.slice(13, 45)), u = n.slice(45, 78);
    switch (Oe(n.slice(0, 4))) {
      case "0x0488b21e":
      case "0x043587cf": {
        const c = Oe(u);
        return new Eo(Dn, Oo(c), c, i, o, null, a, s, null);
      }
      case "0x0488ade4":
      case "0x04358394 ":
        if (u[0] !== 0)
          break;
        return new dn(Dn, new en(u.slice(1)), i, o, null, a, s, null, null);
    }
    ue(!1, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
  }
  /**
   *  Creates a new random HDNode.
   */
  static createRandom(t, n, s) {
    var a;
    t == null && (t = ""), n == null && (n = y0), s == null && (s = Xn.wordlist());
    const i = Ui.fromEntropy(Ir(16), t, s);
    return de(a = dn, fo, f0).call(a, i.computeSeed(), i).derivePath(n);
  }
  /**
   *  Create an HD Node from %%mnemonic%%.
   */
  static fromMnemonic(t, n) {
    var s;
    return n || (n = y0), de(s = dn, fo, f0).call(s, t.computeSeed(), t).derivePath(n);
  }
  /**
   *  Creates an HD Node from a mnemonic %%phrase%%.
   */
  static fromPhrase(t, n, s, i) {
    var o;
    n == null && (n = ""), s == null && (s = y0), i == null && (i = Xn.wordlist());
    const a = Ui.fromPhrase(t, n, i);
    return de(o = dn, fo, f0).call(o, a.computeSeed(), a).derivePath(s);
  }
  /**
   *  Creates an HD Node from a %%seed%%.
   */
  static fromSeed(t) {
    var n;
    return de(n = dn, fo, f0).call(n, t, null);
  }
};
z0 = new WeakSet(), xb = function() {
  const t = { address: this.address, privateKey: this.privateKey }, n = this.mnemonic;
  return this.path && n && n.wordlist.locale === "en" && n.password === "" && (t.mnemonic = {
    path: this.path,
    locale: "en",
    entropy: n.entropy
  }), t;
}, fo = new WeakSet(), f0 = function(t, n) {
  ue(Su(t), "invalid seed", "seed", "[REDACTED]");
  const s = Ce(t, "seed");
  ue(s.length >= 16 && s.length <= 64, "invalid seed", "seed", "[REDACTED]");
  const i = Ce($s("sha512", Z9, s)), a = new en(Oe(i.slice(0, 32)));
  return new dn(Dn, a, "0x00000000", Oe(i.slice(32)), "m", 0, 0, n, null);
}, Z(dn, fo);
let po = dn;
class Eo extends Au {
  /**
   *  @private
   */
  constructor(t, n, s, i, a, o, u, c, l) {
    super(n, l);
    /**
     *  The compressed public key.
     */
    Q(this, "publicKey");
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */
    Q(this, "fingerprint");
    /**
     *  The parent node fingerprint.
     */
    Q(this, "parentFingerprint");
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */
    Q(this, "chainCode");
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provider full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  enocde it.
     */
    Q(this, "path");
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */
    Q(this, "index");
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */
    Q(this, "depth");
    es(t, Dn, "HDNodeVoidWallet"), _e(this, { publicKey: s });
    const f = lt(Ks(nr(s)), 0, 4);
    _e(this, {
      publicKey: s,
      fingerprint: f,
      parentFingerprint: i,
      chainCode: a,
      path: o,
      index: u,
      depth: c
    });
  }
  connect(t) {
    return new Eo(Dn, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, t);
  }
  /**
   *  The extended key.
   *
   *  This key will begin with the prefix ``xpub`` and can be used to
   *  reconstruct this neutered key to derive its children addresses.
   */
  get extendedKey() {
    return Ee(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), gb(it([
      "0x0488B21E",
      Ed(this.depth, 1),
      this.parentFingerprint,
      Ed(this.index, 4),
      this.chainCode,
      this.publicKey
    ]));
  }
  /**
   *  Returns true if this wallet has a path, providing a Type Guard
   *  that the path is non-null.
   */
  hasPath() {
    return this.path != null;
  }
  /**
   *  Return the child for %%index%%.
   */
  deriveChild(t) {
    const n = Ve(t, "index");
    ue(n <= 4294967295, "invalid index", "index", n);
    let s = this.path;
    s && (s += "/" + (n & ~Yn), n & Yn && (s += "'"));
    const { IR: i, IL: a } = C4(n, this.chainCode, this.publicKey, null), o = en.addPoints(a, this.publicKey, !0), u = Oo(o);
    return new Eo(Dn, u, o, this.fingerprint, Oe(i), s, n, this.depth + 1, this.provider);
  }
  /**
   *  Return the signer for %%path%% from this node.
   */
  derivePath(t) {
    return R4(this, t);
  }
}
function I4(r) {
  const e = Ve(r, "index");
  return ue(e >= 0 && e < Yn, "invalid account index", "index", e), `m/44'/60'/${e}'/0/0`;
}
function _4(r) {
  const e = Ve(r, "index");
  return ue(e >= 0 && e < Yn, "invalid account index", "index", e), `m/44'/60'/0'/0/${e}`;
}
function Pd(r) {
  try {
    if (JSON.parse(r).encseed)
      return !0;
  } catch {
  }
  return !1;
}
function vd(r, e) {
  const t = JSON.parse(r), n = cf(e), s = et(Bt(t, "ethaddr:string!")), i = T4(Bt(t, "encseed:string!"));
  ue(i && i.length % 16 === 0, "invalid encseed", "json", r);
  const a = Ce(Bn(n, n, 2e3, 32, "sha256")).slice(0, 16), o = i.slice(0, 16), u = i.slice(16), c = new Wg(a, o), l = W9(Ce(c.decrypt(u)));
  let f = "";
  for (let d = 0; d < l.length; d++)
    f += String.fromCharCode(l[d]);
  return { address: s, privateKey: vn(f) };
}
function Xm(r) {
  return new Promise((e) => {
    setTimeout(() => {
      e();
    }, r);
  });
}
var J0, mb;
const Ua = class Ua extends Tu {
  /**
   *  Create a new wallet for the private %%key%%, optionally connected
   *  to %%provider%%.
   */
  constructor(e, t) {
    typeof e == "string" && !e.startsWith("0x") && (e = "0x" + e);
    let n = typeof e == "string" ? new en(e) : e;
    super(n, t);
  }
  connect(e) {
    return new Ua(this.signingKey, e);
  }
  /**
   *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
   *  %%password%%.
   *
   *  If %%progressCallback%% is specified, it will receive periodic
   *  updates as the encryption process progreses.
   */
  async encrypt(e, t) {
    const n = { address: this.address, privateKey: this.privateKey };
    return await hh(n, e, { progressCallback: t });
  }
  /**
   *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
   *  %%password%%.
   *
   *  It is preferred to use the [async version](encrypt) instead,
   *  which allows a [[ProgressCallback]] to keep the user informed.
   *
   *  This method will block the event loop (freezing all UI) until
   *  it is complete, which may be a non-trivial duration.
   */
  encryptSync(e) {
    const t = { address: this.address, privateKey: this.privateKey };
    return dh(t, e);
  }
  /**
   *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
   *  with %%password%%.
   *
   *  If %%progress%% is provided, it is called periodically during
   *  decryption so that any UI can be updated.
   */
  static async fromEncryptedJson(e, t, n) {
    var i;
    let s = null;
    return wd(e) ? s = await Zg(e, t, n) : Pd(e) && (n && (n(0), await Xm(0)), s = vd(e, t), n && (n(1), await Xm(0))), de(i = Ua, J0, mb).call(i, s);
  }
  /**
   *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
   *
   *  The [[fromEncryptedJson]] method is preferred, as this method
   *  will lock up and freeze the UI during decryption, which may take
   *  some time.
   */
  static fromEncryptedJsonSync(e, t) {
    var s;
    let n = null;
    return wd(e) ? n = Yg(e, t) : Pd(e) ? n = vd(e, t) : ue(!1, "invalid JSON wallet", "json", "[ REDACTED ]"), de(s = Ua, J0, mb).call(s, n);
  }
  /**
   *  Creates a new random [[HDNodeWallet]] using the available
   *  [cryptographic random source](randomBytes).
   *
   *  If there is no crytographic random source, this will throw.
   */
  static createRandom(e) {
    const t = po.createRandom();
    return e ? t.connect(e) : t;
  }
  /**
   *  Creates a [[HDNodeWallet]] for %%phrase%%.
   */
  static fromPhrase(e, t) {
    const n = po.fromPhrase(e);
    return t ? n.connect(t) : n;
  }
};
J0 = new WeakSet(), mb = function(e) {
  if (ue(e, "invalid JSON wallet", "json", "[ REDACTED ]"), "mnemonic" in e && e.mnemonic && e.mnemonic.locale === "en") {
    const n = Ui.fromEntropy(e.mnemonic.entropy), s = po.fromMnemonic(n, e.mnemonic.path);
    if (s.address === e.address && s.privateKey === e.privateKey)
      return s;
    console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
  }
  const t = new Ua(e.privateKey);
  return ue(t.address === e.address, "address/privateKey mismatch", "json", "[ REDACTED ]"), t;
}, Z(Ua, J0);
let kd = Ua;
const tP = ")!@#$%^&*(ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
function rP(r, e) {
  const t = (1 << r) - 1, n = [];
  let s = 0, i = 0, a = 0;
  for (let o = 0; o < e.length; o++)
    for (s = s << 6 | tP.indexOf(e[o]), i += 6; i >= r; ) {
      const u = s >> i - r;
      s &= (1 << i - r) - 1, i -= r, u === 0 ? a += t : (n.push(u + a), a = 0);
    }
  return n;
}
function nP(r, e) {
  let t = P4(r).join(",");
  return e.split(/,/g).forEach((n) => {
    const s = n.match(/^([a-z]*)([0-9]+)([0-9])(.*)$/);
    ue(s !== null, "internal error parsing accents", "accents", e);
    let i = 0;
    const a = rP(parseInt(s[3]), s[4]), o = parseInt(s[2]), u = new RegExp(`([${s[1]}])`, "g");
    t = t.replace(u, (c, l) => (--a[i] === 0 && (l = String.fromCharCode(l.charCodeAt(0), o), i++), l));
  }), t.split(",");
}
var Q0;
class U4 extends fh {
  /**
   *  Creates a new Wordlist for %%locale%% using the OWLA %%data%%
   *  and %%accent%% data and validated against the %%checksum%%.
   */
  constructor(t, n, s, i) {
    super(t, n, i);
    Z(this, Q0);
    F(this, Q0, s);
  }
  /**
   *  The OWLA-encoded accent data.
   */
  get _accent() {
    return x(this, Q0);
  }
  /**
   *  Decode all the words for the wordlist.
   */
  _decodeWords() {
    return nP(this._data, this._accent);
  }
}
Q0 = new WeakMap();
const L4 = {
  en: Xn.wordlist()
}, sP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder: _i,
  AbstractProvider: wu,
  AbstractSigner: Mu,
  AlchemyProvider: Pu,
  AnkrProvider: Eu,
  BaseContract: wo,
  BaseWallet: Tu,
  Block: Sg,
  BrowserProvider: Jg,
  ChainstackProvider: vu,
  CloudflareProvider: Dg,
  ConstructorFragment: En,
  Contract: Ci,
  ContractEventPayload: Rg,
  ContractFactory: ah,
  ContractTransactionReceipt: Cg,
  ContractTransactionResponse: sf,
  ContractUnknownEventPayload: sh,
  EnsPlugin: Lu,
  EnsResolver: xu,
  ErrorDescription: Ng,
  ErrorFragment: rr,
  EtherSymbol: a3,
  EtherscanPlugin: uh,
  EtherscanProvider: jg,
  EventFragment: Yr,
  EventLog: nf,
  EventPayload: Vd,
  FallbackFragment: wn,
  FallbackProvider: zg,
  FeeData: bd,
  FeeDataNetworkPlugin: xd,
  FetchCancelSignal: Xb,
  FetchRequest: Kt,
  FetchResponse: Wn,
  FetchUrlFeeDataNetworkPlugin: Lg,
  FixedNumber: cu,
  Fragment: Gs,
  FunctionFragment: Zr,
  GasCostPlugin: Uu,
  HDNodeVoidWallet: Eo,
  HDNodeWallet: po,
  Indexed: pd,
  InfuraProvider: Ao,
  InfuraWebSocketProvider: Kg,
  Interface: gu,
  IpcSocketProvider: E4,
  JsonRpcApiProvider: ch,
  JsonRpcProvider: _r,
  JsonRpcSigner: x0,
  LangEn: Xn,
  Log: No,
  LogDescription: Bg,
  MaxInt256: i3,
  MaxUint256: n3,
  MessagePrefix: gg,
  MinInt256: s3,
  Mnemonic: Ui,
  MulticoinProviderPlugin: Ug,
  N: t3,
  NamedFragment: _u,
  Network: vt,
  NetworkPlugin: Qs,
  NonceManager: md,
  ParamType: jt,
  PocketProvider: O0,
  QuickNodeProvider: ku,
  Result: Ri,
  Signature: Ur,
  SigningKey: en,
  SocketBlockSubscriber: Hg,
  SocketEventSubscriber: Vg,
  SocketPendingSubscriber: Gg,
  SocketProvider: $g,
  SocketSubscriber: of,
  StructFragment: Us,
  Transaction: Ii,
  TransactionDescription: Og,
  TransactionReceipt: rh,
  TransactionResponse: mo,
  Typed: $t,
  TypedDataEncoder: js,
  UndecodedEventLog: nh,
  UnmanagedSubscriber: yu,
  Utf8ErrorFuncs: Zb,
  VoidSigner: Au,
  Wallet: kd,
  WebSocketProvider: lh,
  WeiPerEther: r3,
  Wordlist: Qg,
  WordlistOwl: fh,
  WordlistOwlA: U4,
  ZeroAddress: bo,
  ZeroHash: cd,
  accessListify: ts,
  assert: Ee,
  assertArgument: ue,
  assertArgumentCount: Dd,
  assertNormalize: jd,
  assertPrivate: es,
  checkResultErrors: Z2,
  computeAddress: Oo,
  computeHmac: $s,
  concat: it,
  copyRequest: xo,
  dataLength: Is,
  dataSlice: lt,
  decodeBase58: qb,
  decodeBase64: Wb,
  decodeBytes32String: e4,
  decodeRlp: Ru,
  decryptCrowdsaleJson: vd,
  decryptKeystoreJson: Zg,
  decryptKeystoreJsonSync: Yg,
  defaultPath: y0,
  defineProperties: _e,
  dnsEncode: Pg,
  encodeBase58: Gd,
  encodeBase64: Yb,
  encodeBytes32String: X3,
  encodeRlp: Ds,
  encryptKeystoreJson: hh,
  encryptKeystoreJsonSync: dh,
  ensNormalize: Eg,
  formatEther: q2,
  formatUnits: eg,
  fromTwos: ou,
  getAccountPath: I4,
  getAddress: et,
  getBigInt: De,
  getBytes: Ce,
  getBytesCopy: Mt,
  getCreate2Address: l3,
  getCreateAddress: qd,
  getDefaultProvider: A4,
  getIcapAddress: u3,
  getIndexedAccountPath: _4,
  getNumber: Ve,
  getUint: Cu,
  hashMessage: Xd,
  hexlify: Oe,
  id: vn,
  isAddress: f3,
  isAddressable: Wd,
  isBytesLike: Su,
  isCallException: q0,
  isCrowdsaleJson: Pd,
  isError: Ct,
  isHexString: dt,
  isKeystoreJson: wd,
  isValidName: U3,
  keccak256: ft,
  lock: o3,
  makeError: xt,
  mask: Cs,
  namehash: T0,
  parseEther: W2,
  parseUnits: tg,
  pbkdf2: Bn,
  randomBytes: Ir,
  recoverAddress: tf,
  resolveAddress: Dt,
  resolveProperties: Lt,
  ripemd160: Ks,
  scrypt: zs,
  scryptSync: Js,
  sha256: nr,
  sha512: Iu,
  showThrottleMessage: qs,
  solidityPacked: eh,
  solidityPackedKeccak256: F3,
  solidityPackedSha256: D3,
  stripZerosLeft: M2,
  toBeArray: Ft,
  toBeHex: tn,
  toBigInt: Bo,
  toNumber: Qb,
  toQuantity: Rs,
  toTwos: Y0,
  toUtf8Bytes: It,
  toUtf8CodePoints: H2,
  toUtf8String: Fs,
  uuidV4: rg,
  verifyMessage: L3,
  verifyTypedData: $3,
  version: Fd,
  wordlists: L4,
  zeroPadBytes: W0,
  zeroPadValue: Xr
}, Symbol.toStringTag, { value: "Module" })), hT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder: _i,
  AbstractProvider: wu,
  AbstractSigner: Mu,
  AlchemyProvider: Pu,
  AnkrProvider: Eu,
  BaseContract: wo,
  BaseWallet: Tu,
  Block: Sg,
  BrowserProvider: Jg,
  ChainstackProvider: vu,
  CloudflareProvider: Dg,
  ConstructorFragment: En,
  Contract: Ci,
  ContractEventPayload: Rg,
  ContractFactory: ah,
  ContractTransactionReceipt: Cg,
  ContractTransactionResponse: sf,
  ContractUnknownEventPayload: sh,
  EnsPlugin: Lu,
  EnsResolver: xu,
  ErrorDescription: Ng,
  ErrorFragment: rr,
  EtherSymbol: a3,
  EtherscanPlugin: uh,
  EtherscanProvider: jg,
  EventFragment: Yr,
  EventLog: nf,
  EventPayload: Vd,
  FallbackFragment: wn,
  FallbackProvider: zg,
  FeeData: bd,
  FeeDataNetworkPlugin: xd,
  FetchCancelSignal: Xb,
  FetchRequest: Kt,
  FetchResponse: Wn,
  FetchUrlFeeDataNetworkPlugin: Lg,
  FixedNumber: cu,
  Fragment: Gs,
  FunctionFragment: Zr,
  GasCostPlugin: Uu,
  HDNodeVoidWallet: Eo,
  HDNodeWallet: po,
  Indexed: pd,
  InfuraProvider: Ao,
  InfuraWebSocketProvider: Kg,
  Interface: gu,
  IpcSocketProvider: E4,
  JsonRpcApiProvider: ch,
  JsonRpcProvider: _r,
  JsonRpcSigner: x0,
  LangEn: Xn,
  Log: No,
  LogDescription: Bg,
  MaxInt256: i3,
  MaxUint256: n3,
  MessagePrefix: gg,
  MinInt256: s3,
  Mnemonic: Ui,
  MulticoinProviderPlugin: Ug,
  N: t3,
  NamedFragment: _u,
  Network: vt,
  NetworkPlugin: Qs,
  NonceManager: md,
  ParamType: jt,
  PocketProvider: O0,
  QuickNodeProvider: ku,
  Result: Ri,
  Signature: Ur,
  SigningKey: en,
  SocketBlockSubscriber: Hg,
  SocketEventSubscriber: Vg,
  SocketPendingSubscriber: Gg,
  SocketProvider: $g,
  SocketSubscriber: of,
  StructFragment: Us,
  Transaction: Ii,
  TransactionDescription: Og,
  TransactionReceipt: rh,
  TransactionResponse: mo,
  Typed: $t,
  TypedDataEncoder: js,
  UndecodedEventLog: nh,
  UnmanagedSubscriber: yu,
  Utf8ErrorFuncs: Zb,
  VoidSigner: Au,
  Wallet: kd,
  WebSocketProvider: lh,
  WeiPerEther: r3,
  Wordlist: Qg,
  WordlistOwl: fh,
  WordlistOwlA: U4,
  ZeroAddress: bo,
  ZeroHash: cd,
  accessListify: ts,
  assert: Ee,
  assertArgument: ue,
  assertArgumentCount: Dd,
  assertNormalize: jd,
  assertPrivate: es,
  checkResultErrors: Z2,
  computeAddress: Oo,
  computeHmac: $s,
  concat: it,
  copyRequest: xo,
  dataLength: Is,
  dataSlice: lt,
  decodeBase58: qb,
  decodeBase64: Wb,
  decodeBytes32String: e4,
  decodeRlp: Ru,
  decryptCrowdsaleJson: vd,
  decryptKeystoreJson: Zg,
  decryptKeystoreJsonSync: Yg,
  defaultPath: y0,
  defineProperties: _e,
  dnsEncode: Pg,
  encodeBase58: Gd,
  encodeBase64: Yb,
  encodeBytes32String: X3,
  encodeRlp: Ds,
  encryptKeystoreJson: hh,
  encryptKeystoreJsonSync: dh,
  ensNormalize: Eg,
  ethers: sP,
  formatEther: q2,
  formatUnits: eg,
  fromTwos: ou,
  getAccountPath: I4,
  getAddress: et,
  getBigInt: De,
  getBytes: Ce,
  getBytesCopy: Mt,
  getCreate2Address: l3,
  getCreateAddress: qd,
  getDefaultProvider: A4,
  getIcapAddress: u3,
  getIndexedAccountPath: _4,
  getNumber: Ve,
  getUint: Cu,
  hashMessage: Xd,
  hexlify: Oe,
  id: vn,
  isAddress: f3,
  isAddressable: Wd,
  isBytesLike: Su,
  isCallException: q0,
  isCrowdsaleJson: Pd,
  isError: Ct,
  isHexString: dt,
  isKeystoreJson: wd,
  isValidName: U3,
  keccak256: ft,
  lock: o3,
  makeError: xt,
  mask: Cs,
  namehash: T0,
  parseEther: W2,
  parseUnits: tg,
  pbkdf2: Bn,
  randomBytes: Ir,
  recoverAddress: tf,
  resolveAddress: Dt,
  resolveProperties: Lt,
  ripemd160: Ks,
  scrypt: zs,
  scryptSync: Js,
  sha256: nr,
  sha512: Iu,
  showThrottleMessage: qs,
  solidityPacked: eh,
  solidityPackedKeccak256: F3,
  solidityPackedSha256: D3,
  stripZerosLeft: M2,
  toBeArray: Ft,
  toBeHex: tn,
  toBigInt: Bo,
  toNumber: Qb,
  toQuantity: Rs,
  toTwos: Y0,
  toUtf8Bytes: It,
  toUtf8CodePoints: H2,
  toUtf8String: Fs,
  uuidV4: rg,
  verifyMessage: L3,
  verifyTypedData: $3,
  version: Fd,
  wordlists: L4,
  zeroPadBytes: W0,
  zeroPadValue: Xr
}, Symbol.toStringTag, { value: "Module" }));
async function iP({ apiUrl: r, accessToken: e }) {
  if (!e) throw new Error("Access token is required");
  try {
    const t = await fetch(`${r}/accounts/address`, {
      headers: {
        Authorization: e
      }
    });
    if (!t.ok) throw new Error(t.statusText);
    return [(await t.json()).address];
  } catch (t) {
    throw new Error(`Error requesting accounts: ${t.message}`);
  }
}
async function Lf({ apiUrl: r, accessToken: e }, t) {
  if (!e) throw new Error("Access token is required");
  if (!t.method) throw new Error("Invalid method");
  if (!t.params) throw new Error("Invalid signature parameter");
  const n = JSON.stringify(t, (a, o) => typeof o == "bigint" ? tn(o) : o), s = await fetch(`${r}/accounts/sign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: e
    },
    body: n
  });
  if (!s.ok) throw new Error(s.statusText);
  const { signature: i } = await s.json();
  return i;
}
var Na = /* @__PURE__ */ ((r) => (r.ACCOUNTS_CHANGED = "accounts_changed", r.PERSONAL_SIGN = "personal_sign", r.SIGN_TRANSACTION = "sign_transaction", r.SEND_TRANSACTION = "send_transaction", r.SIGN_TYPED_DATA = "sign_typed_data", r))(Na || {});
const Ls = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, sp = {
  PROD: "https://evm.credenza3.com",
  STAGING: "https://evm.staging.credenza3.com",
  LOCAL: "http://localhost:8082"
};
function aP(r) {
  switch (r) {
    case Ls.LOCAL:
      return sp.LOCAL;
    case Ls.STAGING:
      return sp.STAGING;
    case Ls.PROD:
      return sp.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
class yb {
  constructor(e) {
    Q(this, "addresses", []);
    Q(this, "provider");
    Q(this, "apiUrl");
    Q(this, "accessToken");
    Q(this, "rpcUrl");
    Q(this, "listeners", {});
    if (!e.env) throw new Error("Env is required");
    this.apiUrl = aP(e.env), this.setRpcUrl(e.rpcUrl), e.accessToken && (this.accessToken = e.accessToken);
  }
  _getRequestFields() {
    return {
      accessToken: `Bearer ${this.accessToken}`,
      apiUrl: this.apiUrl
    };
  }
  _emit(e, ...t) {
    for (const n of this.listeners[e] ?? [])
      n(...t);
  }
  setRpcUrl(e) {
    this.rpcUrl = e, this.provider = new _r(e);
  }
  getRpcUrl() {
    return this.rpcUrl;
  }
  on(e, t) {
    var n;
    return (n = this.listeners)[e] ?? (n[e] = []), this.listeners[e].push(t), this;
  }
  removeListener(e, t) {
    return this.listeners[e] = (this.listeners[e] ?? []).filter((n) => n !== t), this;
  }
  setAccessToken(e) {
    this.accessToken = e, this.addresses = [];
  }
  async _populateTransaction(e) {
    const [t] = await this.listAccounts();
    return await new Au(t, this.provider).populateTransaction(e);
  }
  async getRpcProvider() {
    return this.provider;
  }
  async listAccounts() {
    var e;
    return (e = this.addresses) != null && e.length || (this.addresses = await iP(this._getRequestFields()), this._emit(Na.ACCOUNTS_CHANGED, this.addresses)), this.addresses;
  }
  // eslint-disable-next-line complexity
  async request({ method: e, params: t }) {
    var n;
    switch (e) {
      case "eth_requestAccounts":
      case "eth_accounts":
        try {
          return await this.listAccounts();
        } catch (s) {
          throw new Error(`Error listing accounts: ${s.message}`);
        }
      case "eth_sign":
      case "personal_sign":
        try {
          const s = await Lf(this._getRequestFields(), { method: "personal_sign", params: t });
          return this._emit(Na.PERSONAL_SIGN, t), s;
        } catch (s) {
          throw new Error(`Sign message error: ${s.message}`);
        }
      case "account_signTransaction":
      case "eth_signRawTransaction":
      case "eth_signTransaction":
        try {
          const s = await this._populateTransaction(t == null ? void 0 : t[0]), i = await Lf(this._getRequestFields(), { method: "eth_signTransaction", params: [s] });
          return this._emit(Na.SIGN_TRANSACTION, s), i;
        } catch (s) {
          throw new Error(`Sign tx error: ${s.message}`);
        }
      case "account_sendTransaction":
      case "eth_sendRawTransaction":
      case "eth_sendTransaction":
        try {
          const s = await this._populateTransaction(t == null ? void 0 : t[0]), i = await Lf(this._getRequestFields(), {
            method: "eth_signTransaction",
            params: [s]
          }), a = await this.provider.broadcastTransaction(i);
          return this._emit(Na.SEND_TRANSACTION, s), a.hash;
        } catch (s) {
          throw new Error(`Send tx error: ${s.message}`);
        }
      case "account_signTypedData":
      case "eth_signTypedData_v4":
      case "eth_signTypedData":
        try {
          const s = await Lf(this._getRequestFields(), { method: "eth_signTypedData", params: t });
          return this._emit(Na.SIGN_TYPED_DATA, t), s;
        } catch (s) {
          throw new Error(`Sign typed data failed: ${s.message}`);
        }
      case "wallet_switchEthereumChain": {
        const s = Number((n = t == null ? void 0 : t[0]) == null ? void 0 : n.chainId), i = await this.provider.getNetwork();
        if (s !== Number(i.chainId))
          throw new Error(
            "wallet_switchEthereumChain not supported manually. Use .setRpcUrl() or re-init provider with new RPC url"
          );
        return null;
      }
      default:
        return await this.provider.send(e, t ?? []);
    }
  }
}
Q(yb, "EVM_PROVIDER_EVENT", Na);
const Ju = {
  OAUTH: "oauth",
  METAMASK: "metamask",
  EVM_PROVIDER: "evm_provider"
}, Po = /* @__PURE__ */ new Map();
let Si = 0;
function Xg(r, e) {
  const t = Po.get(r);
  if (t != null && t.length) {
    for (let n = t.length - 1; n >= 0; n--)
      if (t[n].id === e) {
        t.splice(n, 1), Po.set(r, t);
        return;
      }
  }
}
function oP(r, e) {
  const t = Po.get(r) ?? [];
  return Si = Si + 1, t.push({ callback: e, id: Si, once: !0 }), Po.set(r, t), () => Xg(r, Si);
}
function cP(r, e) {
  const t = Po.get(r) ?? [];
  return Si = Si + 1, t.push({ callback: e, id: Si }), Po.set(r, t), () => Xg(r, Si);
}
function uP(r, e) {
  const t = Po.get(r);
  if (t != null && t.length)
    for (const n of t)
      n.callback(e), n.once && Xg(r, n.id);
}
const ip = {
  EVM_ERROR: "EVM_ERROR",
  EVM_SWITCH_CHAIN: "EVM_SWITCH_CHAIN"
}, lP = {
  ERROR: "ERROR",
  INIT: "INIT",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
}, ap = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
}, op = {
  PROD: "https://auth.credenza3.com",
  STAGING: "https://auth.staging.credenza3.com",
  LOCAL: "https://auth.staging.credenza3.com"
};
function fP(r) {
  switch (r.env) {
    case Ls.LOCAL:
      return ap.LOCAL;
    case Ls.STAGING:
      return ap.STAGING;
    case Ls.PROD:
      return ap.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
function dP(r) {
  switch (r.env) {
    case Ls.LOCAL:
      return op.LOCAL;
    case Ls.STAGING:
      return op.STAGING;
    case Ls.PROD:
      return op.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
function wb(r = 64) {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = new Uint8Array(r);
  return crypto.getRandomValues(t), Array.from(t, (n) => e[n % e.length]).join("");
}
const hP = "credenza_web_sdk:";
function pP(r, e) {
  return sessionStorage.setItem(`${hP}${r}`, e);
}
const bP = "oauth:client_code_verifier";
async function gP(r, e, t) {
  if (e.searchParams.append("response_type", t.responseType || "token"), t.responseType === "code") {
    const n = wb();
    pP(bP, n);
    const { codeChallenge: s, codeChallengeMethod: i } = await r.oauth.buildS256CodeChallenge(n);
    e.searchParams.append("code_challenge", s), e.searchParams.append("code_challenge_method", i);
  }
}
function xP(r) {
  return r != null && r.is_evm ? "/evm" : r != null && r.is_jwt ? "/jwt" : "";
}
async function mP(r, e, t = {}) {
  const n = t != null && t.is_jwt || t != null && t.is_evm ? fP : dP, s = new URL(n(r) + "/oauth2/authorize" + xP(t));
  return s.searchParams.append("client_id", r.clientId), s.searchParams.append("scope", e.scope), s.searchParams.append("nonce", e.nonce || wb(32)), s.searchParams.append("state", e.state || wb(32)), await gP(r, s, e), s;
}
function yP(r, e) {
  r.searchParams.append("redirect_uri", e.redirectUrl);
}
var M4 = {}, ph = {}, F4 = {}, vo = {}, bh = {};
Object.defineProperty(bh, "__esModule", { value: !0 });
bh.grammar = void 0;
function wP() {
  this.grammarObject = "grammarObject", this.rules = [], this.rules[0] = { name: "sign-in-with-ethereum", lower: "sign-in-with-ethereum", index: 0, isBkr: !1 }, this.rules[1] = { name: "ex-title", lower: "ex-title", index: 1, isBkr: !1 }, this.rules[2] = { name: "nb-title", lower: "nb-title", index: 2, isBkr: !1 }, this.rules[3] = { name: "ri-title", lower: "ri-title", index: 3, isBkr: !1 }, this.rules[4] = { name: "re-title", lower: "re-title", index: 4, isBkr: !1 }, this.rules[5] = { name: "oscheme", lower: "oscheme", index: 5, isBkr: !1 }, this.rules[6] = { name: "domain", lower: "domain", index: 6, isBkr: !1 }, this.rules[7] = { name: "address", lower: "address", index: 7, isBkr: !1 }, this.rules[8] = { name: "statement", lower: "statement", index: 8, isBkr: !1 }, this.rules[9] = { name: "empty-statement", lower: "empty-statement", index: 9, isBkr: !1 }, this.rules[10] = { name: "version", lower: "version", index: 10, isBkr: !1 }, this.rules[11] = { name: "nonce", lower: "nonce", index: 11, isBkr: !1 }, this.rules[12] = { name: "issued-at", lower: "issued-at", index: 12, isBkr: !1 }, this.rules[13] = { name: "expiration-time", lower: "expiration-time", index: 13, isBkr: !1 }, this.rules[14] = { name: "not-before", lower: "not-before", index: 14, isBkr: !1 }, this.rules[15] = { name: "request-id", lower: "request-id", index: 15, isBkr: !1 }, this.rules[16] = { name: "chain-id", lower: "chain-id", index: 16, isBkr: !1 }, this.rules[17] = { name: "resources", lower: "resources", index: 17, isBkr: !1 }, this.rules[18] = { name: "resource", lower: "resource", index: 18, isBkr: !1 }, this.rules[19] = { name: "URI", lower: "uri", index: 19, isBkr: !1 }, this.rules[20] = { name: "hier-part", lower: "hier-part", index: 20, isBkr: !1 }, this.rules[21] = { name: "scheme", lower: "scheme", index: 21, isBkr: !1 }, this.rules[22] = { name: "authority", lower: "authority", index: 22, isBkr: !1 }, this.rules[23] = { name: "path-abempty", lower: "path-abempty", index: 23, isBkr: !1 }, this.rules[24] = { name: "path-absolute", lower: "path-absolute", index: 24, isBkr: !1 }, this.rules[25] = { name: "path-rootless", lower: "path-rootless", index: 25, isBkr: !1 }, this.rules[26] = { name: "path-empty", lower: "path-empty", index: 26, isBkr: !1 }, this.rules[27] = { name: "userinfo-at", lower: "userinfo-at", index: 27, isBkr: !1 }, this.rules[28] = { name: "userinfo", lower: "userinfo", index: 28, isBkr: !1 }, this.rules[29] = { name: "host", lower: "host", index: 29, isBkr: !1 }, this.rules[30] = { name: "IP-literal", lower: "ip-literal", index: 30, isBkr: !1 }, this.rules[31] = { name: "IPvFuture", lower: "ipvfuture", index: 31, isBkr: !1 }, this.rules[32] = { name: "IPv6address", lower: "ipv6address", index: 32, isBkr: !1 }, this.rules[33] = { name: "nodcolon", lower: "nodcolon", index: 33, isBkr: !1 }, this.rules[34] = { name: "dcolon", lower: "dcolon", index: 34, isBkr: !1 }, this.rules[35] = { name: "h16", lower: "h16", index: 35, isBkr: !1 }, this.rules[36] = { name: "h16c", lower: "h16c", index: 36, isBkr: !1 }, this.rules[37] = { name: "h16n", lower: "h16n", index: 37, isBkr: !1 }, this.rules[38] = { name: "h16cn", lower: "h16cn", index: 38, isBkr: !1 }, this.rules[39] = { name: "IPv4address", lower: "ipv4address", index: 39, isBkr: !1 }, this.rules[40] = { name: "dec-octet", lower: "dec-octet", index: 40, isBkr: !1 }, this.rules[41] = { name: "dec-digit", lower: "dec-digit", index: 41, isBkr: !1 }, this.rules[42] = { name: "reg-name", lower: "reg-name", index: 42, isBkr: !1 }, this.rules[43] = { name: "reg-name-char", lower: "reg-name-char", index: 43, isBkr: !1 }, this.rules[44] = { name: "port", lower: "port", index: 44, isBkr: !1 }, this.rules[45] = { name: "query", lower: "query", index: 45, isBkr: !1 }, this.rules[46] = { name: "fragment", lower: "fragment", index: 46, isBkr: !1 }, this.rules[47] = { name: "URI-r", lower: "uri-r", index: 47, isBkr: !1 }, this.rules[48] = { name: "hier-part-r", lower: "hier-part-r", index: 48, isBkr: !1 }, this.rules[49] = { name: "scheme-r", lower: "scheme-r", index: 49, isBkr: !1 }, this.rules[50] = { name: "query-r", lower: "query-r", index: 50, isBkr: !1 }, this.rules[51] = { name: "fragment-r", lower: "fragment-r", index: 51, isBkr: !1 }, this.rules[52] = { name: "authority-d", lower: "authority-d", index: 52, isBkr: !1 }, this.rules[53] = { name: "userinfo-d", lower: "userinfo-d", index: 53, isBkr: !1 }, this.rules[54] = { name: "host-d", lower: "host-d", index: 54, isBkr: !1 }, this.rules[55] = { name: "port-d", lower: "port-d", index: 55, isBkr: !1 }, this.rules[56] = { name: "path-abempty-r", lower: "path-abempty-r", index: 56, isBkr: !1 }, this.rules[57] = { name: "path-absolute-r", lower: "path-absolute-r", index: 57, isBkr: !1 }, this.rules[58] = { name: "path-rootless-r", lower: "path-rootless-r", index: 58, isBkr: !1 }, this.rules[59] = { name: "path-empty-r", lower: "path-empty-r", index: 59, isBkr: !1 }, this.rules[60] = { name: "segment", lower: "segment", index: 60, isBkr: !1 }, this.rules[61] = { name: "segment-nz", lower: "segment-nz", index: 61, isBkr: !1 }, this.rules[62] = { name: "pchar", lower: "pchar", index: 62, isBkr: !1 }, this.rules[63] = { name: "pct-encoded", lower: "pct-encoded", index: 63, isBkr: !1 }, this.rules[64] = { name: "date-fullyear", lower: "date-fullyear", index: 64, isBkr: !1 }, this.rules[65] = { name: "date-month", lower: "date-month", index: 65, isBkr: !1 }, this.rules[66] = { name: "date-mday", lower: "date-mday", index: 66, isBkr: !1 }, this.rules[67] = { name: "time-hour", lower: "time-hour", index: 67, isBkr: !1 }, this.rules[68] = { name: "time-minute", lower: "time-minute", index: 68, isBkr: !1 }, this.rules[69] = { name: "time-second", lower: "time-second", index: 69, isBkr: !1 }, this.rules[70] = { name: "time-secfrac", lower: "time-secfrac", index: 70, isBkr: !1 }, this.rules[71] = { name: "time-numoffset", lower: "time-numoffset", index: 71, isBkr: !1 }, this.rules[72] = { name: "time-offset", lower: "time-offset", index: 72, isBkr: !1 }, this.rules[73] = { name: "partial-time", lower: "partial-time", index: 73, isBkr: !1 }, this.rules[74] = { name: "full-date", lower: "full-date", index: 74, isBkr: !1 }, this.rules[75] = { name: "full-time", lower: "full-time", index: 75, isBkr: !1 }, this.rules[76] = { name: "date-time", lower: "date-time", index: 76, isBkr: !1 }, this.rules[77] = { name: "ALPHA", lower: "alpha", index: 77, isBkr: !1 }, this.rules[78] = { name: "LF", lower: "lf", index: 78, isBkr: !1 }, this.rules[79] = { name: "DIGIT", lower: "digit", index: 79, isBkr: !1 }, this.rules[80] = { name: "HEXDIG", lower: "hexdig", index: 80, isBkr: !1 }, this.udts = [], this.rules[0].opcodes = [], this.rules[0].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 5, 6, 7, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 36, 41, 46] }, this.rules[0].opcodes[1] = { type: 4, index: 5 }, this.rules[0].opcodes[2] = { type: 4, index: 6 }, this.rules[0].opcodes[3] = { type: 6, string: [32, 119, 97, 110, 116, 115, 32, 121, 111, 117, 32, 116, 111, 32, 115, 105, 103, 110, 32, 105, 110, 32, 119, 105, 116, 104, 32, 121, 111, 117, 114, 32, 69, 116, 104, 101, 114, 101, 117, 109, 32, 97, 99, 99, 111, 117, 110, 116, 58] }, this.rules[0].opcodes[4] = { type: 4, index: 78 }, this.rules[0].opcodes[5] = { type: 4, index: 7 }, this.rules[0].opcodes[6] = { type: 4, index: 78 }, this.rules[0].opcodes[7] = { type: 1, children: [8, 13, 14] }, this.rules[0].opcodes[8] = { type: 2, children: [9, 10, 11, 12] }, this.rules[0].opcodes[9] = { type: 4, index: 78 }, this.rules[0].opcodes[10] = { type: 4, index: 8 }, this.rules[0].opcodes[11] = { type: 4, index: 78 }, this.rules[0].opcodes[12] = { type: 4, index: 78 }, this.rules[0].opcodes[13] = { type: 4, index: 9 }, this.rules[0].opcodes[14] = { type: 2, children: [15, 16] }, this.rules[0].opcodes[15] = { type: 4, index: 78 }, this.rules[0].opcodes[16] = { type: 4, index: 78 }, this.rules[0].opcodes[17] = { type: 6, string: [85, 82, 73, 58, 32] }, this.rules[0].opcodes[18] = { type: 4, index: 19 }, this.rules[0].opcodes[19] = { type: 4, index: 78 }, this.rules[0].opcodes[20] = { type: 6, string: [86, 101, 114, 115, 105, 111, 110, 58, 32] }, this.rules[0].opcodes[21] = { type: 4, index: 10 }, this.rules[0].opcodes[22] = { type: 4, index: 78 }, this.rules[0].opcodes[23] = { type: 6, string: [67, 104, 97, 105, 110, 32, 73, 68, 58, 32] }, this.rules[0].opcodes[24] = { type: 4, index: 16 }, this.rules[0].opcodes[25] = { type: 4, index: 78 }, this.rules[0].opcodes[26] = { type: 6, string: [78, 111, 110, 99, 101, 58, 32] }, this.rules[0].opcodes[27] = { type: 4, index: 11 }, this.rules[0].opcodes[28] = { type: 4, index: 78 }, this.rules[0].opcodes[29] = { type: 6, string: [73, 115, 115, 117, 101, 100, 32, 65, 116, 58, 32] }, this.rules[0].opcodes[30] = { type: 4, index: 12 }, this.rules[0].opcodes[31] = { type: 3, min: 0, max: 1 }, this.rules[0].opcodes[32] = { type: 2, children: [33, 34, 35] }, this.rules[0].opcodes[33] = { type: 4, index: 78 }, this.rules[0].opcodes[34] = { type: 4, index: 1 }, this.rules[0].opcodes[35] = { type: 4, index: 13 }, this.rules[0].opcodes[36] = { type: 3, min: 0, max: 1 }, this.rules[0].opcodes[37] = { type: 2, children: [38, 39, 40] }, this.rules[0].opcodes[38] = { type: 4, index: 78 }, this.rules[0].opcodes[39] = { type: 4, index: 2 }, this.rules[0].opcodes[40] = { type: 4, index: 14 }, this.rules[0].opcodes[41] = { type: 3, min: 0, max: 1 }, this.rules[0].opcodes[42] = { type: 2, children: [43, 44, 45] }, this.rules[0].opcodes[43] = { type: 4, index: 78 }, this.rules[0].opcodes[44] = { type: 4, index: 3 }, this.rules[0].opcodes[45] = { type: 4, index: 15 }, this.rules[0].opcodes[46] = { type: 3, min: 0, max: 1 }, this.rules[0].opcodes[47] = { type: 2, children: [48, 49, 50] }, this.rules[0].opcodes[48] = { type: 4, index: 78 }, this.rules[0].opcodes[49] = { type: 4, index: 4 }, this.rules[0].opcodes[50] = { type: 4, index: 17 }, this.rules[1].opcodes = [], this.rules[1].opcodes[0] = { type: 6, string: [69, 120, 112, 105, 114, 97, 116, 105, 111, 110, 32, 84, 105, 109, 101, 58, 32] }, this.rules[2].opcodes = [], this.rules[2].opcodes[0] = { type: 6, string: [78, 111, 116, 32, 66, 101, 102, 111, 114, 101, 58, 32] }, this.rules[3].opcodes = [], this.rules[3].opcodes[0] = { type: 6, string: [82, 101, 113, 117, 101, 115, 116, 32, 73, 68, 58, 32] }, this.rules[4].opcodes = [], this.rules[4].opcodes[0] = { type: 6, string: [82, 101, 115, 111, 117, 114, 99, 101, 115, 58] }, this.rules[5].opcodes = [], this.rules[5].opcodes[0] = { type: 3, min: 0, max: 1 }, this.rules[5].opcodes[1] = { type: 2, children: [2, 3, 9] }, this.rules[5].opcodes[2] = { type: 4, index: 77 }, this.rules[5].opcodes[3] = { type: 3, min: 0, max: 1 / 0 }, this.rules[5].opcodes[4] = { type: 1, children: [5, 6, 7, 8] }, this.rules[5].opcodes[5] = { type: 4, index: 77 }, this.rules[5].opcodes[6] = { type: 4, index: 79 }, this.rules[5].opcodes[7] = { type: 6, string: [43] }, this.rules[5].opcodes[8] = { type: 5, min: 45, max: 46 }, this.rules[5].opcodes[9] = { type: 7, string: [58, 47, 47] }, this.rules[6].opcodes = [], this.rules[6].opcodes[0] = { type: 4, index: 52 }, this.rules[7].opcodes = [], this.rules[7].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[7].opcodes[1] = { type: 7, string: [48, 120] }, this.rules[7].opcodes[2] = { type: 3, min: 40, max: 40 }, this.rules[7].opcodes[3] = { type: 4, index: 80 }, this.rules[8].opcodes = [], this.rules[8].opcodes[0] = { type: 3, min: 1, max: 1 / 0 }, this.rules[8].opcodes[1] = { type: 1, children: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] }, this.rules[8].opcodes[2] = { type: 5, min: 97, max: 122 }, this.rules[8].opcodes[3] = { type: 5, min: 65, max: 90 }, this.rules[8].opcodes[4] = { type: 5, min: 48, max: 57 }, this.rules[8].opcodes[5] = { type: 5, min: 32, max: 33 }, this.rules[8].opcodes[6] = { type: 5, min: 35, max: 36 }, this.rules[8].opcodes[7] = { type: 5, min: 38, max: 59 }, this.rules[8].opcodes[8] = { type: 6, string: [61] }, this.rules[8].opcodes[9] = { type: 5, min: 63, max: 64 }, this.rules[8].opcodes[10] = { type: 6, string: [91] }, this.rules[8].opcodes[11] = { type: 6, string: [93] }, this.rules[8].opcodes[12] = { type: 6, string: [95] }, this.rules[8].opcodes[13] = { type: 6, string: [126] }, this.rules[9].opcodes = [], this.rules[9].opcodes[0] = { type: 2, children: [1, 2, 3] }, this.rules[9].opcodes[1] = { type: 4, index: 78 }, this.rules[9].opcodes[2] = { type: 4, index: 78 }, this.rules[9].opcodes[3] = { type: 4, index: 78 }, this.rules[10].opcodes = [], this.rules[10].opcodes[0] = { type: 7, string: [49] }, this.rules[11].opcodes = [], this.rules[11].opcodes[0] = { type: 3, min: 8, max: 1 / 0 }, this.rules[11].opcodes[1] = { type: 1, children: [2, 3] }, this.rules[11].opcodes[2] = { type: 4, index: 77 }, this.rules[11].opcodes[3] = { type: 4, index: 79 }, this.rules[12].opcodes = [], this.rules[12].opcodes[0] = { type: 4, index: 76 }, this.rules[13].opcodes = [], this.rules[13].opcodes[0] = { type: 4, index: 76 }, this.rules[14].opcodes = [], this.rules[14].opcodes[0] = { type: 4, index: 76 }, this.rules[15].opcodes = [], this.rules[15].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[15].opcodes[1] = { type: 4, index: 62 }, this.rules[16].opcodes = [], this.rules[16].opcodes[0] = { type: 3, min: 1, max: 1 / 0 }, this.rules[16].opcodes[1] = { type: 4, index: 79 }, this.rules[17].opcodes = [], this.rules[17].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[17].opcodes[1] = { type: 2, children: [2, 3] }, this.rules[17].opcodes[2] = { type: 4, index: 78 }, this.rules[17].opcodes[3] = { type: 4, index: 18 }, this.rules[18].opcodes = [], this.rules[18].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[18].opcodes[1] = { type: 7, string: [45, 32] }, this.rules[18].opcodes[2] = { type: 4, index: 47 }, this.rules[19].opcodes = [], this.rules[19].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 8] }, this.rules[19].opcodes[1] = { type: 4, index: 21 }, this.rules[19].opcodes[2] = { type: 7, string: [58] }, this.rules[19].opcodes[3] = { type: 4, index: 20 }, this.rules[19].opcodes[4] = { type: 3, min: 0, max: 1 }, this.rules[19].opcodes[5] = { type: 2, children: [6, 7] }, this.rules[19].opcodes[6] = { type: 7, string: [63] }, this.rules[19].opcodes[7] = { type: 4, index: 45 }, this.rules[19].opcodes[8] = { type: 3, min: 0, max: 1 }, this.rules[19].opcodes[9] = { type: 2, children: [10, 11] }, this.rules[19].opcodes[10] = { type: 7, string: [35] }, this.rules[19].opcodes[11] = { type: 4, index: 46 }, this.rules[20].opcodes = [], this.rules[20].opcodes[0] = { type: 1, children: [1, 5, 6, 7] }, this.rules[20].opcodes[1] = { type: 2, children: [2, 3, 4] }, this.rules[20].opcodes[2] = { type: 7, string: [47, 47] }, this.rules[20].opcodes[3] = { type: 4, index: 22 }, this.rules[20].opcodes[4] = { type: 4, index: 23 }, this.rules[20].opcodes[5] = { type: 4, index: 24 }, this.rules[20].opcodes[6] = { type: 4, index: 25 }, this.rules[20].opcodes[7] = { type: 4, index: 26 }, this.rules[21].opcodes = [], this.rules[21].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[21].opcodes[1] = { type: 4, index: 77 }, this.rules[21].opcodes[2] = { type: 3, min: 0, max: 1 / 0 }, this.rules[21].opcodes[3] = { type: 1, children: [4, 5, 6, 7] }, this.rules[21].opcodes[4] = { type: 4, index: 77 }, this.rules[21].opcodes[5] = { type: 4, index: 79 }, this.rules[21].opcodes[6] = { type: 6, string: [43] }, this.rules[21].opcodes[7] = { type: 5, min: 45, max: 46 }, this.rules[22].opcodes = [], this.rules[22].opcodes[0] = { type: 2, children: [1, 3, 4] }, this.rules[22].opcodes[1] = { type: 3, min: 0, max: 1 }, this.rules[22].opcodes[2] = { type: 4, index: 27 }, this.rules[22].opcodes[3] = { type: 4, index: 29 }, this.rules[22].opcodes[4] = { type: 3, min: 0, max: 1 }, this.rules[22].opcodes[5] = { type: 2, children: [6, 7] }, this.rules[22].opcodes[6] = { type: 7, string: [58] }, this.rules[22].opcodes[7] = { type: 4, index: 44 }, this.rules[23].opcodes = [], this.rules[23].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[23].opcodes[1] = { type: 2, children: [2, 3] }, this.rules[23].opcodes[2] = { type: 7, string: [47] }, this.rules[23].opcodes[3] = { type: 4, index: 60 }, this.rules[24].opcodes = [], this.rules[24].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[24].opcodes[1] = { type: 7, string: [47] }, this.rules[24].opcodes[2] = { type: 3, min: 0, max: 1 }, this.rules[24].opcodes[3] = { type: 2, children: [4, 5] }, this.rules[24].opcodes[4] = { type: 4, index: 61 }, this.rules[24].opcodes[5] = { type: 3, min: 0, max: 1 / 0 }, this.rules[24].opcodes[6] = { type: 2, children: [7, 8] }, this.rules[24].opcodes[7] = { type: 7, string: [47] }, this.rules[24].opcodes[8] = { type: 4, index: 60 }, this.rules[25].opcodes = [], this.rules[25].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[25].opcodes[1] = { type: 4, index: 61 }, this.rules[25].opcodes[2] = { type: 3, min: 0, max: 1 / 0 }, this.rules[25].opcodes[3] = { type: 2, children: [4, 5] }, this.rules[25].opcodes[4] = { type: 7, string: [47] }, this.rules[25].opcodes[5] = { type: 4, index: 60 }, this.rules[26].opcodes = [], this.rules[26].opcodes[0] = { type: 7, string: [] }, this.rules[27].opcodes = [], this.rules[27].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[27].opcodes[1] = { type: 4, index: 28 }, this.rules[27].opcodes[2] = { type: 6, string: [64] }, this.rules[28].opcodes = [], this.rules[28].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[28].opcodes[1] = { type: 1, children: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] }, this.rules[28].opcodes[2] = { type: 5, min: 97, max: 122 }, this.rules[28].opcodes[3] = { type: 5, min: 65, max: 90 }, this.rules[28].opcodes[4] = { type: 5, min: 48, max: 57 }, this.rules[28].opcodes[5] = { type: 4, index: 63 }, this.rules[28].opcodes[6] = { type: 6, string: [33] }, this.rules[28].opcodes[7] = { type: 6, string: [36] }, this.rules[28].opcodes[8] = { type: 5, min: 38, max: 46 }, this.rules[28].opcodes[9] = { type: 5, min: 58, max: 59 }, this.rules[28].opcodes[10] = { type: 6, string: [61] }, this.rules[28].opcodes[11] = { type: 6, string: [95] }, this.rules[28].opcodes[12] = { type: 6, string: [126] }, this.rules[29].opcodes = [], this.rules[29].opcodes[0] = { type: 1, children: [1, 2, 6] }, this.rules[29].opcodes[1] = { type: 4, index: 30 }, this.rules[29].opcodes[2] = { type: 2, children: [3, 4] }, this.rules[29].opcodes[3] = { type: 4, index: 39 }, this.rules[29].opcodes[4] = { type: 13 }, this.rules[29].opcodes[5] = { type: 4, index: 43 }, this.rules[29].opcodes[6] = { type: 4, index: 42 }, this.rules[30].opcodes = [], this.rules[30].opcodes[0] = { type: 2, children: [1, 2, 5] }, this.rules[30].opcodes[1] = { type: 7, string: [91] }, this.rules[30].opcodes[2] = { type: 1, children: [3, 4] }, this.rules[30].opcodes[3] = { type: 4, index: 32 }, this.rules[30].opcodes[4] = { type: 4, index: 31 }, this.rules[30].opcodes[5] = { type: 7, string: [93] }, this.rules[31].opcodes = [], this.rules[31].opcodes[0] = { type: 2, children: [1, 2, 4, 5] }, this.rules[31].opcodes[1] = { type: 7, string: [118] }, this.rules[31].opcodes[2] = { type: 3, min: 1, max: 1 / 0 }, this.rules[31].opcodes[3] = { type: 4, index: 80 }, this.rules[31].opcodes[4] = { type: 7, string: [46] }, this.rules[31].opcodes[5] = { type: 3, min: 1, max: 1 / 0 }, this.rules[31].opcodes[6] = { type: 1, children: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16] }, this.rules[31].opcodes[7] = { type: 5, min: 97, max: 122 }, this.rules[31].opcodes[8] = { type: 5, min: 65, max: 90 }, this.rules[31].opcodes[9] = { type: 5, min: 48, max: 57 }, this.rules[31].opcodes[10] = { type: 6, string: [33] }, this.rules[31].opcodes[11] = { type: 6, string: [36] }, this.rules[31].opcodes[12] = { type: 5, min: 38, max: 46 }, this.rules[31].opcodes[13] = { type: 5, min: 58, max: 59 }, this.rules[31].opcodes[14] = { type: 6, string: [61] }, this.rules[31].opcodes[15] = { type: 6, string: [95] }, this.rules[31].opcodes[16] = { type: 6, string: [126] }, this.rules[32].opcodes = [], this.rules[32].opcodes[0] = { type: 1, children: [1, 2] }, this.rules[32].opcodes[1] = { type: 4, index: 33 }, this.rules[32].opcodes[2] = { type: 4, index: 34 }, this.rules[33].opcodes = [], this.rules[33].opcodes[0] = { type: 2, children: [1, 5] }, this.rules[33].opcodes[1] = { type: 2, children: [2, 3] }, this.rules[33].opcodes[2] = { type: 4, index: 37 }, this.rules[33].opcodes[3] = { type: 3, min: 0, max: 1 / 0 }, this.rules[33].opcodes[4] = { type: 4, index: 38 }, this.rules[33].opcodes[5] = { type: 3, min: 0, max: 1 }, this.rules[33].opcodes[6] = { type: 2, children: [7, 8] }, this.rules[33].opcodes[7] = { type: 6, string: [58] }, this.rules[33].opcodes[8] = { type: 4, index: 39 }, this.rules[34].opcodes = [], this.rules[34].opcodes[0] = { type: 2, children: [1, 6, 7] }, this.rules[34].opcodes[1] = { type: 3, min: 0, max: 1 }, this.rules[34].opcodes[2] = { type: 2, children: [3, 4] }, this.rules[34].opcodes[3] = { type: 4, index: 35 }, this.rules[34].opcodes[4] = { type: 3, min: 0, max: 1 / 0 }, this.rules[34].opcodes[5] = { type: 4, index: 36 }, this.rules[34].opcodes[6] = { type: 6, string: [58, 58] }, this.rules[34].opcodes[7] = { type: 1, children: [8, 17] }, this.rules[34].opcodes[8] = { type: 2, children: [9, 13] }, this.rules[34].opcodes[9] = { type: 2, children: [10, 11] }, this.rules[34].opcodes[10] = { type: 4, index: 37 }, this.rules[34].opcodes[11] = { type: 3, min: 0, max: 1 / 0 }, this.rules[34].opcodes[12] = { type: 4, index: 38 }, this.rules[34].opcodes[13] = { type: 3, min: 0, max: 1 }, this.rules[34].opcodes[14] = { type: 2, children: [15, 16] }, this.rules[34].opcodes[15] = { type: 6, string: [58] }, this.rules[34].opcodes[16] = { type: 4, index: 39 }, this.rules[34].opcodes[17] = { type: 3, min: 0, max: 1 }, this.rules[34].opcodes[18] = { type: 4, index: 39 }, this.rules[35].opcodes = [], this.rules[35].opcodes[0] = { type: 3, min: 1, max: 4 }, this.rules[35].opcodes[1] = { type: 4, index: 80 }, this.rules[36].opcodes = [], this.rules[36].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[36].opcodes[1] = { type: 6, string: [58] }, this.rules[36].opcodes[2] = { type: 3, min: 1, max: 4 }, this.rules[36].opcodes[3] = { type: 4, index: 80 }, this.rules[37].opcodes = [], this.rules[37].opcodes[0] = { type: 2, children: [1, 3] }, this.rules[37].opcodes[1] = { type: 3, min: 1, max: 4 }, this.rules[37].opcodes[2] = { type: 4, index: 80 }, this.rules[37].opcodes[3] = { type: 13 }, this.rules[37].opcodes[4] = { type: 6, string: [46] }, this.rules[38].opcodes = [], this.rules[38].opcodes[0] = { type: 2, children: [1, 2, 4] }, this.rules[38].opcodes[1] = { type: 6, string: [58] }, this.rules[38].opcodes[2] = { type: 3, min: 1, max: 4 }, this.rules[38].opcodes[3] = { type: 4, index: 80 }, this.rules[38].opcodes[4] = { type: 13 }, this.rules[38].opcodes[5] = { type: 6, string: [46] }, this.rules[39].opcodes = [], this.rules[39].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 5, 6, 7] }, this.rules[39].opcodes[1] = { type: 4, index: 40 }, this.rules[39].opcodes[2] = { type: 7, string: [46] }, this.rules[39].opcodes[3] = { type: 4, index: 40 }, this.rules[39].opcodes[4] = { type: 7, string: [46] }, this.rules[39].opcodes[5] = { type: 4, index: 40 }, this.rules[39].opcodes[6] = { type: 7, string: [46] }, this.rules[39].opcodes[7] = { type: 4, index: 40 }, this.rules[40].opcodes = [], this.rules[40].opcodes[0] = { type: 3, min: 0, max: 3 }, this.rules[40].opcodes[1] = { type: 4, index: 41 }, this.rules[41].opcodes = [], this.rules[41].opcodes[0] = { type: 5, min: 48, max: 57 }, this.rules[42].opcodes = [], this.rules[42].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[42].opcodes[1] = { type: 4, index: 43 }, this.rules[43].opcodes = [], this.rules[43].opcodes[0] = { type: 1, children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }, this.rules[43].opcodes[1] = { type: 5, min: 97, max: 122 }, this.rules[43].opcodes[2] = { type: 5, min: 65, max: 90 }, this.rules[43].opcodes[3] = { type: 5, min: 48, max: 57 }, this.rules[43].opcodes[4] = { type: 4, index: 63 }, this.rules[43].opcodes[5] = { type: 6, string: [33] }, this.rules[43].opcodes[6] = { type: 6, string: [36] }, this.rules[43].opcodes[7] = { type: 5, min: 38, max: 46 }, this.rules[43].opcodes[8] = { type: 6, string: [59] }, this.rules[43].opcodes[9] = { type: 6, string: [61] }, this.rules[43].opcodes[10] = { type: 6, string: [95] }, this.rules[43].opcodes[11] = { type: 6, string: [126] }, this.rules[44].opcodes = [], this.rules[44].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[44].opcodes[1] = { type: 4, index: 79 }, this.rules[45].opcodes = [], this.rules[45].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[45].opcodes[1] = { type: 1, children: [2, 3, 4] }, this.rules[45].opcodes[2] = { type: 4, index: 62 }, this.rules[45].opcodes[3] = { type: 6, string: [47] }, this.rules[45].opcodes[4] = { type: 6, string: [63] }, this.rules[46].opcodes = [], this.rules[46].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[46].opcodes[1] = { type: 1, children: [2, 3, 4] }, this.rules[46].opcodes[2] = { type: 4, index: 62 }, this.rules[46].opcodes[3] = { type: 6, string: [47] }, this.rules[46].opcodes[4] = { type: 6, string: [63] }, this.rules[47].opcodes = [], this.rules[47].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 8] }, this.rules[47].opcodes[1] = { type: 4, index: 49 }, this.rules[47].opcodes[2] = { type: 7, string: [58] }, this.rules[47].opcodes[3] = { type: 4, index: 48 }, this.rules[47].opcodes[4] = { type: 3, min: 0, max: 1 }, this.rules[47].opcodes[5] = { type: 2, children: [6, 7] }, this.rules[47].opcodes[6] = { type: 7, string: [63] }, this.rules[47].opcodes[7] = { type: 4, index: 50 }, this.rules[47].opcodes[8] = { type: 3, min: 0, max: 1 }, this.rules[47].opcodes[9] = { type: 2, children: [10, 11] }, this.rules[47].opcodes[10] = { type: 7, string: [35] }, this.rules[47].opcodes[11] = { type: 4, index: 51 }, this.rules[48].opcodes = [], this.rules[48].opcodes[0] = { type: 1, children: [1, 5, 6, 7] }, this.rules[48].opcodes[1] = { type: 2, children: [2, 3, 4] }, this.rules[48].opcodes[2] = { type: 7, string: [47, 47] }, this.rules[48].opcodes[3] = { type: 4, index: 52 }, this.rules[48].opcodes[4] = { type: 4, index: 56 }, this.rules[48].opcodes[5] = { type: 4, index: 57 }, this.rules[48].opcodes[6] = { type: 4, index: 58 }, this.rules[48].opcodes[7] = { type: 4, index: 59 }, this.rules[49].opcodes = [], this.rules[49].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[49].opcodes[1] = { type: 4, index: 77 }, this.rules[49].opcodes[2] = { type: 3, min: 0, max: 1 / 0 }, this.rules[49].opcodes[3] = { type: 1, children: [4, 5, 6, 7] }, this.rules[49].opcodes[4] = { type: 4, index: 77 }, this.rules[49].opcodes[5] = { type: 4, index: 79 }, this.rules[49].opcodes[6] = { type: 6, string: [43] }, this.rules[49].opcodes[7] = { type: 5, min: 45, max: 46 }, this.rules[50].opcodes = [], this.rules[50].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[50].opcodes[1] = { type: 1, children: [2, 3, 4] }, this.rules[50].opcodes[2] = { type: 4, index: 62 }, this.rules[50].opcodes[3] = { type: 6, string: [47] }, this.rules[50].opcodes[4] = { type: 6, string: [63] }, this.rules[51].opcodes = [], this.rules[51].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[51].opcodes[1] = { type: 1, children: [2, 3, 4] }, this.rules[51].opcodes[2] = { type: 4, index: 62 }, this.rules[51].opcodes[3] = { type: 6, string: [47] }, this.rules[51].opcodes[4] = { type: 6, string: [63] }, this.rules[52].opcodes = [], this.rules[52].opcodes[0] = { type: 2, children: [1, 5, 6] }, this.rules[52].opcodes[1] = { type: 3, min: 0, max: 1 }, this.rules[52].opcodes[2] = { type: 2, children: [3, 4] }, this.rules[52].opcodes[3] = { type: 4, index: 53 }, this.rules[52].opcodes[4] = { type: 6, string: [64] }, this.rules[52].opcodes[5] = { type: 4, index: 54 }, this.rules[52].opcodes[6] = { type: 3, min: 0, max: 1 }, this.rules[52].opcodes[7] = { type: 2, children: [8, 9] }, this.rules[52].opcodes[8] = { type: 7, string: [58] }, this.rules[52].opcodes[9] = { type: 4, index: 55 }, this.rules[53].opcodes = [], this.rules[53].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[53].opcodes[1] = { type: 1, children: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] }, this.rules[53].opcodes[2] = { type: 5, min: 97, max: 122 }, this.rules[53].opcodes[3] = { type: 5, min: 65, max: 90 }, this.rules[53].opcodes[4] = { type: 5, min: 48, max: 57 }, this.rules[53].opcodes[5] = { type: 4, index: 63 }, this.rules[53].opcodes[6] = { type: 6, string: [33] }, this.rules[53].opcodes[7] = { type: 6, string: [36] }, this.rules[53].opcodes[8] = { type: 5, min: 38, max: 46 }, this.rules[53].opcodes[9] = { type: 5, min: 58, max: 59 }, this.rules[53].opcodes[10] = { type: 6, string: [61] }, this.rules[53].opcodes[11] = { type: 6, string: [95] }, this.rules[53].opcodes[12] = { type: 6, string: [126] }, this.rules[54].opcodes = [], this.rules[54].opcodes[0] = { type: 1, children: [1, 2, 6] }, this.rules[54].opcodes[1] = { type: 4, index: 30 }, this.rules[54].opcodes[2] = { type: 2, children: [3, 4] }, this.rules[54].opcodes[3] = { type: 4, index: 39 }, this.rules[54].opcodes[4] = { type: 13 }, this.rules[54].opcodes[5] = { type: 4, index: 43 }, this.rules[54].opcodes[6] = { type: 4, index: 42 }, this.rules[55].opcodes = [], this.rules[55].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[55].opcodes[1] = { type: 4, index: 79 }, this.rules[56].opcodes = [], this.rules[56].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[56].opcodes[1] = { type: 2, children: [2, 3] }, this.rules[56].opcodes[2] = { type: 7, string: [47] }, this.rules[56].opcodes[3] = { type: 4, index: 60 }, this.rules[57].opcodes = [], this.rules[57].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[57].opcodes[1] = { type: 7, string: [47] }, this.rules[57].opcodes[2] = { type: 3, min: 0, max: 1 }, this.rules[57].opcodes[3] = { type: 2, children: [4, 5] }, this.rules[57].opcodes[4] = { type: 4, index: 61 }, this.rules[57].opcodes[5] = { type: 3, min: 0, max: 1 / 0 }, this.rules[57].opcodes[6] = { type: 2, children: [7, 8] }, this.rules[57].opcodes[7] = { type: 7, string: [47] }, this.rules[57].opcodes[8] = { type: 4, index: 60 }, this.rules[58].opcodes = [], this.rules[58].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[58].opcodes[1] = { type: 4, index: 61 }, this.rules[58].opcodes[2] = { type: 3, min: 0, max: 1 / 0 }, this.rules[58].opcodes[3] = { type: 2, children: [4, 5] }, this.rules[58].opcodes[4] = { type: 7, string: [47] }, this.rules[58].opcodes[5] = { type: 4, index: 60 }, this.rules[59].opcodes = [], this.rules[59].opcodes[0] = { type: 7, string: [] }, this.rules[60].opcodes = [], this.rules[60].opcodes[0] = { type: 3, min: 0, max: 1 / 0 }, this.rules[60].opcodes[1] = { type: 4, index: 62 }, this.rules[61].opcodes = [], this.rules[61].opcodes[0] = { type: 3, min: 1, max: 1 / 0 }, this.rules[61].opcodes[1] = { type: 4, index: 62 }, this.rules[62].opcodes = [], this.rules[62].opcodes[0] = { type: 1, children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] }, this.rules[62].opcodes[1] = { type: 5, min: 97, max: 122 }, this.rules[62].opcodes[2] = { type: 5, min: 65, max: 90 }, this.rules[62].opcodes[3] = { type: 5, min: 48, max: 57 }, this.rules[62].opcodes[4] = { type: 4, index: 63 }, this.rules[62].opcodes[5] = { type: 6, string: [33] }, this.rules[62].opcodes[6] = { type: 6, string: [36] }, this.rules[62].opcodes[7] = { type: 5, min: 38, max: 46 }, this.rules[62].opcodes[8] = { type: 5, min: 58, max: 59 }, this.rules[62].opcodes[9] = { type: 6, string: [61] }, this.rules[62].opcodes[10] = { type: 6, string: [64] }, this.rules[62].opcodes[11] = { type: 6, string: [95] }, this.rules[62].opcodes[12] = { type: 6, string: [126] }, this.rules[63].opcodes = [], this.rules[63].opcodes[0] = { type: 2, children: [1, 2, 3] }, this.rules[63].opcodes[1] = { type: 6, string: [37] }, this.rules[63].opcodes[2] = { type: 4, index: 80 }, this.rules[63].opcodes[3] = { type: 4, index: 80 }, this.rules[64].opcodes = [], this.rules[64].opcodes[0] = { type: 3, min: 4, max: 4 }, this.rules[64].opcodes[1] = { type: 4, index: 79 }, this.rules[65].opcodes = [], this.rules[65].opcodes[0] = { type: 3, min: 2, max: 2 }, this.rules[65].opcodes[1] = { type: 4, index: 79 }, this.rules[66].opcodes = [], this.rules[66].opcodes[0] = { type: 3, min: 2, max: 2 }, this.rules[66].opcodes[1] = { type: 4, index: 79 }, this.rules[67].opcodes = [], this.rules[67].opcodes[0] = { type: 3, min: 2, max: 2 }, this.rules[67].opcodes[1] = { type: 4, index: 79 }, this.rules[68].opcodes = [], this.rules[68].opcodes[0] = { type: 3, min: 2, max: 2 }, this.rules[68].opcodes[1] = { type: 4, index: 79 }, this.rules[69].opcodes = [], this.rules[69].opcodes[0] = { type: 3, min: 2, max: 2 }, this.rules[69].opcodes[1] = { type: 4, index: 79 }, this.rules[70].opcodes = [], this.rules[70].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[70].opcodes[1] = { type: 7, string: [46] }, this.rules[70].opcodes[2] = { type: 3, min: 1, max: 1 / 0 }, this.rules[70].opcodes[3] = { type: 4, index: 79 }, this.rules[71].opcodes = [], this.rules[71].opcodes[0] = { type: 2, children: [1, 4, 5, 6] }, this.rules[71].opcodes[1] = { type: 1, children: [2, 3] }, this.rules[71].opcodes[2] = { type: 7, string: [43] }, this.rules[71].opcodes[3] = { type: 7, string: [45] }, this.rules[71].opcodes[4] = { type: 4, index: 67 }, this.rules[71].opcodes[5] = { type: 7, string: [58] }, this.rules[71].opcodes[6] = { type: 4, index: 68 }, this.rules[72].opcodes = [], this.rules[72].opcodes[0] = { type: 1, children: [1, 2] }, this.rules[72].opcodes[1] = { type: 7, string: [122] }, this.rules[72].opcodes[2] = { type: 4, index: 71 }, this.rules[73].opcodes = [], this.rules[73].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 5, 6] }, this.rules[73].opcodes[1] = { type: 4, index: 67 }, this.rules[73].opcodes[2] = { type: 7, string: [58] }, this.rules[73].opcodes[3] = { type: 4, index: 68 }, this.rules[73].opcodes[4] = { type: 7, string: [58] }, this.rules[73].opcodes[5] = { type: 4, index: 69 }, this.rules[73].opcodes[6] = { type: 3, min: 0, max: 1 }, this.rules[73].opcodes[7] = { type: 4, index: 70 }, this.rules[74].opcodes = [], this.rules[74].opcodes[0] = { type: 2, children: [1, 2, 3, 4, 5] }, this.rules[74].opcodes[1] = { type: 4, index: 64 }, this.rules[74].opcodes[2] = { type: 7, string: [45] }, this.rules[74].opcodes[3] = { type: 4, index: 65 }, this.rules[74].opcodes[4] = { type: 7, string: [45] }, this.rules[74].opcodes[5] = { type: 4, index: 66 }, this.rules[75].opcodes = [], this.rules[75].opcodes[0] = { type: 2, children: [1, 2] }, this.rules[75].opcodes[1] = { type: 4, index: 73 }, this.rules[75].opcodes[2] = { type: 4, index: 72 }, this.rules[76].opcodes = [], this.rules[76].opcodes[0] = { type: 2, children: [1, 2, 3] }, this.rules[76].opcodes[1] = { type: 4, index: 74 }, this.rules[76].opcodes[2] = { type: 7, string: [116] }, this.rules[76].opcodes[3] = { type: 4, index: 75 }, this.rules[77].opcodes = [], this.rules[77].opcodes[0] = { type: 1, children: [1, 2] }, this.rules[77].opcodes[1] = { type: 5, min: 65, max: 90 }, this.rules[77].opcodes[2] = { type: 5, min: 97, max: 122 }, this.rules[78].opcodes = [], this.rules[78].opcodes[0] = { type: 6, string: [10] }, this.rules[79].opcodes = [], this.rules[79].opcodes[0] = { type: 5, min: 48, max: 57 }, this.rules[80].opcodes = [], this.rules[80].opcodes[0] = { type: 1, children: [1, 2, 3] }, this.rules[80].opcodes[1] = { type: 5, min: 48, max: 57 }, this.rules[80].opcodes[2] = { type: 5, min: 65, max: 70 }, this.rules[80].opcodes[3] = { type: 5, min: 97, max: 102 }, this.toString = function() {
    let e = "";
    return e += `; LDT 05/06/2024 
`, e += `; modified in several significant ways
`, e += `; 1) Literal strings are replaced with numbers and ranges (%d32 & %d32-126, etc.) when possible.
`, e += `;    TRB and especially TRG operators are much more efficient than TLS operators.
`, e += `; 2) Two rules, authority and URI, are used multiple times in different contexts. These rules will be reproduced and renamed
`, e += `;    in order to a) recognize the context and b) remove unneccary callback functions for certain contexts.
`, e += `;    This will simiplify recognizing contexts AND remove unneccesary callbacks
`, e += `; 2.a) domain is defined as authority-d which is identical to authority except that there will be no
`, e += `;      callback functions defined on authority-d or any of its *-d components.
`, e += `; 2.b) The resource URI is defined as URI-r and its components defined as *-r.
`, e += `;      In this way, callback functions can be defined on URI and is components while
`, e += `;      leaving URI-r to be parsed identically with no unnecessary callback functions to slow it down.
`, e += `; 3) IPv6address does not work because of APG's "first-success disambiguation" and "greedy" repetitions.
`, e += `;    IPv6address redefined and validations moved to callback functions (semantic vs syntactic validation)
`, e += `;    Redefinition requires negative look-ahead operators, https://en.wikipedia.org/wiki/Syntactic_predicate
`, e += `;    That is SABNF instead of simple ABNF.
`, e += `; 4) IPv4address fails because of "first-success disambiguation".
`, e += `;    This could be fixed with rearrangement of the alternative terms. However, it would still not
`, e += `;    accept zero-padded (leading zeros) decimal octets.
`, e += `;    Therefore, IPv4address is also done with callback functions and semantic validation.
`, e += `; 5) The negative look-ahead operator is also needed in the definition of host to
`, e += `;    prevent failure with a reg-name that begins with an IPv4 address.
`, e += `; 6) NOTE: host = 1.1.1.256 is a valid host name even though it is an invalid IPv4address.
`, e += `;          The IPv4address alternative fails but the reg-name alternative succeeds.
`, e += `; 7) The Ethereum spec (https://eips.ethereum.org/EIPS/eip-4361) message format ABNF
`, e += `;    allows for empty statements. Because of the "first success disambiguation" of APG
`, e += `;    the an explicit "empty-statement" rule is required to match the spec's intent.
`, e += `
`, e += `
`, e += `sign-in-with-ethereum =
`, e += `    oscheme domain %s" wants you to sign in with your Ethereum account:" LF
`, e += `    address LF
`, e += `    ((LF statement LF LF) / empty-statement / (LF LF))
`, e += `    %s"URI: " URI LF
`, e += `    %s"Version: " version LF
`, e += `    %s"Chain ID: " chain-id LF
`, e += `    %s"Nonce: " nonce LF
`, e += `    %s"Issued At: " issued-at
`, e += `    [ LF ex-title expiration-time ]
`, e += `    [ LF nb-title not-before ]
`, e += `    [ LF ri-title request-id ]
`, e += `    [ LF re-title resources ]
`, e += `ex-title        = %s"Expiration Time: "
`, e += `nb-title        = %s"Not Before: "
`, e += `ri-title        = %s"Request ID: "
`, e += `re-title        = %s"Resources:"
`, e += `oscheme         = [ ALPHA *( ALPHA / DIGIT / %d43 / %d45-46 ) "://" ]
`, e += `domain          = authority-d
`, e += `address         = "0x" 40*40HEXDIG
`, e += `    ; Must also conform to captilization
`, e += `    ; checksum encoding specified in EIP-55
`, e += `    ; where applicable (EOAs).
`, e += `
`, e += `statement       = 1*( %d97-122 / %d65-90 / %d48-57 / %d32-33 / %d35-36 / %d38-59 / %d61 / %d63-64 / %d91 / %d93 / %d95 / %d126)
`, e += `    ; The purpose is to exclude LF (line breaks).
`, e += `    ; LDT 10/04/2023: Do you mean %d32-126? All printing characters
`, e += `empty-statement = LF LF LF
`, e += `version         = "1"
`, e += `nonce           = 8*( ALPHA / DIGIT )
`, e += `issued-at       = date-time
`, e += `expiration-time = date-time
`, e += `not-before      = date-time
`, e += `request-id      = *pchar
`, e += `chain-id        = 1*DIGIT
`, e += `    ; See EIP-155 for valid CHAIN_IDs.
`, e += `resources       = *( LF resource )
`, e += `resource        = "- " URI-r
`, e += `
`, e += `; ------------------------------------------------------------------------------
`, e += `; RFC 3986
`, e += `
`, e += `URI           = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
`, e += `hier-part     = "//" authority path-abempty
`, e += `              / path-absolute
`, e += `              / path-rootless
`, e += `              / path-empty
`, e += `scheme        = ALPHA *( ALPHA / DIGIT / %d43 / %d45-46 )
`, e += `authority     = [ userinfo-at ] host [ ":" port ]
`, e += `path-abempty  = *( "/" segment )
`, e += `path-absolute = "/" [ segment-nz *( "/" segment ) ]
`, e += `path-rootless = segment-nz *( "/" segment )
`, e += `path-empty    = ""
`, e += `userinfo-at   = userinfo %d64
`, e += `                ; userinfo redefined to include the "@" so that it will fail without it
`, e += `                ; otherwise userinfo can match host and then the parser will backtrack
`, e += `                ; incorrectly keeping the captured userinfo phrase
`, e += `userinfo      = *(%d97-122 / %d65-90 / %d48-57 / pct-encoded / %d33 / %d36 / %d38-46 / %d58-59 / %d61 / %d95 / %d126)
`, e += `host          = IP-literal / (IPv4address !reg-name-char) / reg-name
`, e += `                ; negative look-ahead required to prevent IPv4address from being recognized as first part of reg-name
`, e += `                ; same fix as https://github.com/garycourt/uri-js/issues/4
`, e += `IP-literal    = "[" ( IPv6address / IPvFuture  ) "]"
`, e += `IPvFuture     = "v" 1*HEXDIG "." 1*( %d97-122 / %d65-90 / %d48-57 / %d33 / %d36 /%d38-46 / %d58-59 /%d61 /%d95 / %d126 )
`, e += `IPv6address   = nodcolon / dcolon
`, e += `nodcolon      = (h16n *h16cn) [%d58 IPv4address]
`, e += `dcolon        = [h16 *h16c] %d58.58 (((h16n *h16cn) [%d58 IPv4address]) / [IPv4address])
`, e += `h16           = 1*4HEXDIG
`, e += `h16c          = %d58 1*4HEXDIG
`, e += `h16n          = 1*4HEXDIG !%d46
`, e += `h16cn         = %d58 1*4HEXDIG !%d46
`, e += `IPv4address   = dec-octet "." dec-octet "." dec-octet "." dec-octet
`, e += `; Here we will will use callback functions to evaluate and validate the (possibly zero-padded) dec-octet.
`, e += `dec-octet     =  *3dec-digit
`, e += `dec-digit     = %d48-57
`, e += `reg-name      = *reg-name-char
`, e += `reg-name-char = %d97-122 / %d65-90 / %d48-57 / pct-encoded / %d33 / %d36 / %d38-46 / %d59 / %d61 /%d95 / %d126
`, e += `port          = *DIGIT
`, e += `query         = *(pchar / %d47 / %d63)
`, e += `fragment      = *(pchar / %d47 / %d63)
`, e += `
`, e += `; URI-r is a redefiniton of URI but without the callback functions attached to it
`, e += `; it reuses athority-d from domain 
`, e += `URI-r         = scheme-r ":" hier-part-r [ "?" query-r ] [ "#" fragment-r ]
`, e += `hier-part-r   = "//" authority-d path-abempty-r
`, e += `              / path-absolute-r
`, e += `              / path-rootless-r
`, e += `              / path-empty-r
`, e += `scheme-r      = ALPHA *( ALPHA / DIGIT / %d43 / %d45-46 )
`, e += `query-r       = *(pchar / %d47 / %d63)
`, e += `fragment-r    = *(pchar / %d47 / %d63)
`, e += `
`, e += `; authority-d is a redefinition of authority for capturing the domian phrase
`, e += `; but without callback functions 
`, e += `; it is reused for URI- for the same reason               
`, e += `authority-d   = [ userinfo-d %d64 ] host-d [ ":" port-d ]
`, e += `userinfo-d    = *(%d97-122 / %d65-90 / %d48-57 / pct-encoded / %d33 / %d36 / %d38-46 / %d58-59 / %d61 / %d95 / %d126)
`, e += `host-d        = IP-literal / (IPv4address !reg-name-char) / reg-name
`, e += `port-d        = *DIGIT
`, e += `
`, e += `; for use with URI-r
`, e += `path-abempty-r  = *( "/" segment )
`, e += `path-absolute-r = "/" [ segment-nz *( "/" segment ) ]
`, e += `path-rootless-r = segment-nz *( "/" segment )
`, e += `path-empty-r    = ""
`, e += `segment       = *pchar
`, e += `segment-nz    = 1*pchar
`, e += `pchar         = (%d97-122 / %d65-90 / %d48-57 / pct-encoded / %d33 / %d36 / %d38-46 /%d58-59 / %d61 / %d64 / %d95 / %d126)
`, e += `pct-encoded   = %d37 HEXDIG HEXDIG
`, e += `
`, e += `; no longer needed - expanded for all usage for fewer branches in the parse there
`, e += `; and more efficient use of the TBS & TRG operators in place of TLS and rule names
`, e += `; does not work with APG probably because of "first-success disambiguation" and greedy repetitions.
`, e += `; will replace with semantic checking of valid number of h16s
`, e += `;IPv6address   =                            6( h16 ":" ) ls32
`, e += `;              /                       "::" 5( h16 ":" ) ls32
`, e += `;              / [               h16 ] "::" 4( h16 ":" ) ls32
`, e += `;              / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
`, e += `;              / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
`, e += `;              / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
`, e += `;              / [ *4( h16 ":" ) h16 ] "::"              ls32
`, e += `;              / [ *5( h16 ":" ) h16 ] "::"              h16
`, e += `;              / [ *6( h16 ":" ) h16 ] "::"
`, e += `;ls32          = ( h16 ":" h16 ) / IPv4address
`, e += `; dec-octet does not work because of "first-success disambiguation".
`, e += `; Must have the longest (3-digit) numbers first.
`, e += `; Even so, this form does not accept leading zeros.
`, e += `; There does not seem to be a clear standard for this (https://en.wikipedia.org/wiki/Dot-decimal_notation)
`, e += `; however and early RFC 790 did show leading-zero padding of the three digits.
`, e += `;dec-octet     = DIGIT                 ; 0-9
`, e += `;                 / %x31-39 DIGIT         ; 10-99
`, e += `;                 / "1" 2DIGIT            ; 100-199
`, e += `;                 / "2" %x30-34 DIGIT     ; 200-249
`, e += `;                 / "25" %x30-35          ; 250-255
`, e += `;statement = 1*( reserved / unreserved / " " )
`, e += `;scheme        = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
`, e += `;authority     = [ userinfo "@" ] host [ ":" port ]
`, e += `;userinfo      = *( unreserved / pct-encoded / sub-delims / ":" )
`, e += `;query         = *( pchar / "/" / "?" )
`, e += `;fragment      = *( pchar / "/" / "?" )
`, e += `;IPvFuture     = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )
`, e += `;reg-name      = *( unreserved / pct-encoded / sub-delims )
`, e += `;pct-encoded   = "%" HEXDIG HEXDIG
`, e += `;pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
`, e += `;path-empty    = 0pchar; deprecated - empty literal string, "", is more efficient 
`, e += `;unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
`, e += `;reserved      = gen-delims / sub-delims
`, e += `;gen-delims    = ":" / "/" / "?" / "#" / "[" / "]" / "@"
`, e += `;sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
`, e += `;              / "*" / "+" / "," / ";" / "="
`, e += `;HEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
`, e += `
`, e += `; ------------------------------------------------------------------------------
`, e += `; RFC 3339
`, e += `
`, e += `date-fullyear   = 4DIGIT
`, e += `date-month      = 2DIGIT  ; 01-12
`, e += `date-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on
`, e += `                          ; month/year
`, e += `time-hour       = 2DIGIT  ; 00-23
`, e += `time-minute     = 2DIGIT  ; 00-59
`, e += `time-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second
`, e += `                          ; rules
`, e += `time-secfrac    = "." 1*DIGIT
`, e += `time-numoffset  = ("+" / "-") time-hour ":" time-minute
`, e += `time-offset     = "Z" / time-numoffset
`, e += `
`, e += `partial-time    = time-hour ":" time-minute ":" time-second
`, e += `                  [time-secfrac]
`, e += `full-date       = date-fullyear "-" date-month "-" date-mday
`, e += `full-time       = partial-time time-offset
`, e += `
`, e += `date-time       = full-date "T" full-time
`, e += `
`, e += `; ------------------------------------------------------------------------------
`, e += `; RFC 5234
`, e += `
`, e += `ALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z
`, e += `LF             =  %x0A
`, e += `                  ; linefeed
`, e += `DIGIT          =  %x30-39
`, e += `                  ; 0-9
`, e += `HEXDIG         = %d48-57 / %d65-70 / %d97-102
`, e += `
`, e;
  };
}
bh.grammar = wP;
var gh = {}, Fu = {
  // Identifies the operator type. Used by the generator
  // to indicate operator types in the grammar object.
  // Used by the [parser](./parser.html) when interpreting the grammar object.
  /* the original ABNF operators */
  ALT: 1,
  CAT: 2,
  REP: 3,
  RNM: 4,
  TRG: 5,
  TBS: 6,
  TLS: 7,
  /* the super set, SABNF operators */
  UDT: 11,
  AND: 12,
  NOT: 13,
  BKR: 14,
  BKA: 15,
  BKN: 16,
  ABG: 17,
  AEN: 18,
  // Used by the parser and the user's `RNM` and `UDT` callback functions.
  // Identifies the parser state as it traverses the parse tree nodes.
  // - *ACTIVE* - indicates the downward direction through the parse tree node.
  // - *MATCH* - indicates the upward direction and a phrase, of length \> 0, has been successfully matched
  // - *EMPTY* - indicates the upward direction and a phrase, of length = 0, has been successfully matched
  // - *NOMATCH* - indicates the upward direction and the parser failed to match any phrase at all
  ACTIVE: 100,
  MATCH: 101,
  EMPTY: 102,
  NOMATCH: 103,
  // Used by [`AST` translator](./ast.html) (semantic analysis) and the user's callback functions
  // to indicate the direction of flow through the `AST` nodes.
  // - *SEM_PRE* - indicates the downward (pre-branch) direction through the `AST` node.
  // - *SEM_POST* - indicates the upward (post-branch) direction through the `AST` node.
  SEM_PRE: 200,
  SEM_POST: 201,
  // Used by the user's callback functions to indicate to the `AST` translator (semantic analysis) how to proceed.
  // - *SEM_OK* - normal return value
  // - *SEM_SKIP* - if a callback function returns this value from the SEM_PRE state,
  // the translator will skip processing all `AST` nodes in the branch below the current node.
  // Ignored if returned from the SEM_POST state.
  SEM_OK: 300,
  SEM_SKIP: 301,
  // Used in attribute generation to distinguish the necessary attribute categories.
  // - *ATTR_N* - non-recursive
  // - *ATTR_R* - recursive
  // - *ATTR_MR* - belongs to a mutually-recursive set
  ATTR_N: 400,
  ATTR_R: 401,
  ATTR_MR: 402,
  // Look around values indicate whether the parser is in look ahead or look behind mode.
  // Used by the tracing facility to indicate the look around mode in the trace records display.
  // - *LOOKAROUND_NONE* - the parser is in normal parsing mode
  // - *LOOKAROUND_AHEAD* - the parse is in look-ahead mode, phrase matching for operator `AND(&)` or `NOT(!)`
  // - *LOOKAROUND_BEHIND* - the parse is in look-behind mode, phrase matching for operator `BKA(&&)` or `BKN(!!)`
  LOOKAROUND_NONE: 500,
  LOOKAROUND_AHEAD: 501,
  LOOKAROUND_BEHIND: 502,
  // Back reference rule mode indicators
  // - *BKR_MODE_UM* - the back reference is using universal mode
  // - *BKR_MODE_PM* - the back reference is using parent frame mode
  // - *BKR_MODE_CS* - the back reference is using case-sensitive phrase matching
  // - *BKR_MODE_CI* - the back reference is using case-insensitive phrase matching
  BKR_MODE_UM: 601,
  BKR_MODE_PM: 602,
  BKR_MODE_CS: 603,
  BKR_MODE_CI: 604
}, Du = {}, xh = {
  // Generated by apglib/style.js 
  CLASS_MONOSPACE: "apg-mono",
  CLASS_ACTIVE: "apg-active",
  CLASS_EMPTY: "apg-empty",
  CLASS_MATCH: "apg-match",
  CLASS_NOMATCH: "apg-nomatch",
  CLASS_LOOKAHEAD: "apg-lh-match",
  CLASS_LOOKBEHIND: "apg-lb-match",
  CLASS_REMAINDER: "apg-remainder",
  CLASS_CTRLCHAR: "apg-ctrl-char",
  CLASS_LINEEND: "apg-line-end",
  CLASS_ERROR: "apg-error",
  CLASS_PHRASE: "apg-phrase",
  CLASS_EMPTYPHRASE: "apg-empty-phrase",
  CLASS_STATE: "apg-state",
  CLASS_STATS: "apg-stats",
  CLASS_TRACE: "apg-trace",
  CLASS_GRAMMAR: "apg-grammar",
  CLASS_RULES: "apg-rules",
  CLASS_RULESLINK: "apg-rules-link",
  CLASS_ATTRIBUTES: "apg-attrs"
}, D4 = {}, ex = {}, mh = {};
mh.byteLength = PP;
mh.toByteArray = kP;
mh.fromByteArray = OP;
var qn = [], Kr = [], AP = typeof Uint8Array < "u" ? Uint8Array : Array, cp = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Yo = 0, EP = cp.length; Yo < EP; ++Yo)
  qn[Yo] = cp[Yo], Kr[cp.charCodeAt(Yo)] = Yo;
Kr[45] = 62;
Kr[95] = 63;
function j4(r) {
  var e = r.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = r.indexOf("=");
  t === -1 && (t = e);
  var n = t === e ? 0 : 4 - t % 4;
  return [t, n];
}
function PP(r) {
  var e = j4(r), t = e[0], n = e[1];
  return (t + n) * 3 / 4 - n;
}
function vP(r, e, t) {
  return (e + t) * 3 / 4 - t;
}
function kP(r) {
  var e, t = j4(r), n = t[0], s = t[1], i = new AP(vP(r, n, s)), a = 0, o = s > 0 ? n - 4 : n, u;
  for (u = 0; u < o; u += 4)
    e = Kr[r.charCodeAt(u)] << 18 | Kr[r.charCodeAt(u + 1)] << 12 | Kr[r.charCodeAt(u + 2)] << 6 | Kr[r.charCodeAt(u + 3)], i[a++] = e >> 16 & 255, i[a++] = e >> 8 & 255, i[a++] = e & 255;
  return s === 2 && (e = Kr[r.charCodeAt(u)] << 2 | Kr[r.charCodeAt(u + 1)] >> 4, i[a++] = e & 255), s === 1 && (e = Kr[r.charCodeAt(u)] << 10 | Kr[r.charCodeAt(u + 1)] << 4 | Kr[r.charCodeAt(u + 2)] >> 2, i[a++] = e >> 8 & 255, i[a++] = e & 255), i;
}
function TP(r) {
  return qn[r >> 18 & 63] + qn[r >> 12 & 63] + qn[r >> 6 & 63] + qn[r & 63];
}
function BP(r, e, t) {
  for (var n, s = [], i = e; i < t; i += 3)
    n = (r[i] << 16 & 16711680) + (r[i + 1] << 8 & 65280) + (r[i + 2] & 255), s.push(TP(n));
  return s.join("");
}
function OP(r) {
  for (var e, t = r.length, n = t % 3, s = [], i = 16383, a = 0, o = t - n; a < o; a += i)
    s.push(BP(r, a, a + i > o ? o : a + i));
  return n === 1 ? (e = r[t - 1], s.push(
    qn[e >> 2] + qn[e << 4 & 63] + "=="
  )) : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], s.push(
    qn[e >> 10] + qn[e >> 4 & 63] + qn[e << 2 & 63] + "="
  )), s.join("");
}
var tx = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
tx.read = function(r, e, t, n, s) {
  var i, a, o = s * 8 - n - 1, u = (1 << o) - 1, c = u >> 1, l = -7, f = t ? s - 1 : 0, d = t ? -1 : 1, h = r[e + f];
  for (f += d, i = h & (1 << -l) - 1, h >>= -l, l += o; l > 0; i = i * 256 + r[e + f], f += d, l -= 8)
    ;
  for (a = i & (1 << -l) - 1, i >>= -l, l += n; l > 0; a = a * 256 + r[e + f], f += d, l -= 8)
    ;
  if (i === 0)
    i = 1 - c;
  else {
    if (i === u)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), i = i - c;
  }
  return (h ? -1 : 1) * a * Math.pow(2, i - n);
};
tx.write = function(r, e, t, n, s, i) {
  var a, o, u, c = i * 8 - s - 1, l = (1 << c) - 1, f = l >> 1, d = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : i - 1, p = n ? 1 : -1, g = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = l) : (a = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), a + f >= 1 ? e += d / u : e += d * Math.pow(2, 1 - f), e * u >= 2 && (a++, u /= 2), a + f >= l ? (o = 0, a = l) : a + f >= 1 ? (o = (e * u - 1) * Math.pow(2, s), a = a + f) : (o = e * Math.pow(2, f - 1) * Math.pow(2, s), a = 0)); s >= 8; r[t + h] = o & 255, h += p, o /= 256, s -= 8)
    ;
  for (a = a << s | o, c += s; c > 0; r[t + h] = a & 255, h += p, a /= 256, c -= 8)
    ;
  r[t + h - p] |= g * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(r) {
  const e = mh, t = tx, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  r.Buffer = o, r.SlowBuffer = y, r.INSPECT_MAX_BYTES = 50;
  const s = 2147483647;
  r.kMaxLength = s, o.TYPED_ARRAY_SUPPORT = i(), !o.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const _ = new Uint8Array(1), b = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(b, Uint8Array.prototype), Object.setPrototypeOf(_, b), _.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(o.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (o.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(o.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (o.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(_) {
    if (_ > s)
      throw new RangeError('The value "' + _ + '" is invalid for option "size"');
    const b = new Uint8Array(_);
    return Object.setPrototypeOf(b, o.prototype), b;
  }
  function o(_, b, w) {
    if (typeof _ == "number") {
      if (typeof b == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return f(_);
    }
    return u(_, b, w);
  }
  o.poolSize = 8192;
  function u(_, b, w) {
    if (typeof _ == "string")
      return d(_, b);
    if (ArrayBuffer.isView(_))
      return p(_);
    if (_ == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof _
      );
    if (Ae(_, ArrayBuffer) || _ && Ae(_.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ae(_, SharedArrayBuffer) || _ && Ae(_.buffer, SharedArrayBuffer)))
      return g(_, b, w);
    if (typeof _ == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const $ = _.valueOf && _.valueOf();
    if ($ != null && $ !== _)
      return o.from($, b, w);
    const Y = k(_);
    if (Y) return Y;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof _[Symbol.toPrimitive] == "function")
      return o.from(_[Symbol.toPrimitive]("string"), b, w);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof _
    );
  }
  o.from = function(_, b, w) {
    return u(_, b, w);
  }, Object.setPrototypeOf(o.prototype, Uint8Array.prototype), Object.setPrototypeOf(o, Uint8Array);
  function c(_) {
    if (typeof _ != "number")
      throw new TypeError('"size" argument must be of type number');
    if (_ < 0)
      throw new RangeError('The value "' + _ + '" is invalid for option "size"');
  }
  function l(_, b, w) {
    return c(_), _ <= 0 ? a(_) : b !== void 0 ? typeof w == "string" ? a(_).fill(b, w) : a(_).fill(b) : a(_);
  }
  o.alloc = function(_, b, w) {
    return l(_, b, w);
  };
  function f(_) {
    return c(_), a(_ < 0 ? 0 : A(_) | 0);
  }
  o.allocUnsafe = function(_) {
    return f(_);
  }, o.allocUnsafeSlow = function(_) {
    return f(_);
  };
  function d(_, b) {
    if ((typeof b != "string" || b === "") && (b = "utf8"), !o.isEncoding(b))
      throw new TypeError("Unknown encoding: " + b);
    const w = E(_, b) | 0;
    let $ = a(w);
    const Y = $.write(_, b);
    return Y !== w && ($ = $.slice(0, Y)), $;
  }
  function h(_) {
    const b = _.length < 0 ? 0 : A(_.length) | 0, w = a(b);
    for (let $ = 0; $ < b; $ += 1)
      w[$] = _[$] & 255;
    return w;
  }
  function p(_) {
    if (Ae(_, Uint8Array)) {
      const b = new Uint8Array(_);
      return g(b.buffer, b.byteOffset, b.byteLength);
    }
    return h(_);
  }
  function g(_, b, w) {
    if (b < 0 || _.byteLength < b)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (_.byteLength < b + (w || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let $;
    return b === void 0 && w === void 0 ? $ = new Uint8Array(_) : w === void 0 ? $ = new Uint8Array(_, b) : $ = new Uint8Array(_, b, w), Object.setPrototypeOf($, o.prototype), $;
  }
  function k(_) {
    if (o.isBuffer(_)) {
      const b = A(_.length) | 0, w = a(b);
      return w.length === 0 || _.copy(w, 0, 0, b), w;
    }
    if (_.length !== void 0)
      return typeof _.length != "number" || ie(_.length) ? a(0) : h(_);
    if (_.type === "Buffer" && Array.isArray(_.data))
      return h(_.data);
  }
  function A(_) {
    if (_ >= s)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
    return _ | 0;
  }
  function y(_) {
    return +_ != _ && (_ = 0), o.alloc(+_);
  }
  o.isBuffer = function(b) {
    return b != null && b._isBuffer === !0 && b !== o.prototype;
  }, o.compare = function(b, w) {
    if (Ae(b, Uint8Array) && (b = o.from(b, b.offset, b.byteLength)), Ae(w, Uint8Array) && (w = o.from(w, w.offset, w.byteLength)), !o.isBuffer(b) || !o.isBuffer(w))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (b === w) return 0;
    let $ = b.length, Y = w.length;
    for (let ce = 0, xe = Math.min($, Y); ce < xe; ++ce)
      if (b[ce] !== w[ce]) {
        $ = b[ce], Y = w[ce];
        break;
      }
    return $ < Y ? -1 : Y < $ ? 1 : 0;
  }, o.isEncoding = function(b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, o.concat = function(b, w) {
    if (!Array.isArray(b))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (b.length === 0)
      return o.alloc(0);
    let $;
    if (w === void 0)
      for (w = 0, $ = 0; $ < b.length; ++$)
        w += b[$].length;
    const Y = o.allocUnsafe(w);
    let ce = 0;
    for ($ = 0; $ < b.length; ++$) {
      let xe = b[$];
      if (Ae(xe, Uint8Array))
        ce + xe.length > Y.length ? (o.isBuffer(xe) || (xe = o.from(xe)), xe.copy(Y, ce)) : Uint8Array.prototype.set.call(
          Y,
          xe,
          ce
        );
      else if (o.isBuffer(xe))
        xe.copy(Y, ce);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ce += xe.length;
    }
    return Y;
  };
  function E(_, b) {
    if (o.isBuffer(_))
      return _.length;
    if (ArrayBuffer.isView(_) || Ae(_, ArrayBuffer))
      return _.byteLength;
    if (typeof _ != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof _
      );
    const w = _.length, $ = arguments.length > 2 && arguments[2] === !0;
    if (!$ && w === 0) return 0;
    let Y = !1;
    for (; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return w;
        case "utf8":
        case "utf-8":
          return q(_).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return w * 2;
        case "hex":
          return w >>> 1;
        case "base64":
          return ve(_).length;
        default:
          if (Y)
            return $ ? -1 : q(_).length;
          b = ("" + b).toLowerCase(), Y = !0;
      }
  }
  o.byteLength = E;
  function m(_, b, w) {
    let $ = !1;
    if ((b === void 0 || b < 0) && (b = 0), b > this.length || ((w === void 0 || w > this.length) && (w = this.length), w <= 0) || (w >>>= 0, b >>>= 0, w <= b))
      return "";
    for (_ || (_ = "utf8"); ; )
      switch (_) {
        case "hex":
          return J(this, b, w);
        case "utf8":
        case "utf-8":
          return S(this, b, w);
        case "ascii":
          return H(this, b, w);
        case "latin1":
        case "binary":
          return V(this, b, w);
        case "base64":
          return P(this, b, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return M(this, b, w);
        default:
          if ($) throw new TypeError("Unknown encoding: " + _);
          _ = (_ + "").toLowerCase(), $ = !0;
      }
  }
  o.prototype._isBuffer = !0;
  function N(_, b, w) {
    const $ = _[b];
    _[b] = _[w], _[w] = $;
  }
  o.prototype.swap16 = function() {
    const b = this.length;
    if (b % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let w = 0; w < b; w += 2)
      N(this, w, w + 1);
    return this;
  }, o.prototype.swap32 = function() {
    const b = this.length;
    if (b % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let w = 0; w < b; w += 4)
      N(this, w, w + 3), N(this, w + 1, w + 2);
    return this;
  }, o.prototype.swap64 = function() {
    const b = this.length;
    if (b % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let w = 0; w < b; w += 8)
      N(this, w, w + 7), N(this, w + 1, w + 6), N(this, w + 2, w + 5), N(this, w + 3, w + 4);
    return this;
  }, o.prototype.toString = function() {
    const b = this.length;
    return b === 0 ? "" : arguments.length === 0 ? S(this, 0, b) : m.apply(this, arguments);
  }, o.prototype.toLocaleString = o.prototype.toString, o.prototype.equals = function(b) {
    if (!o.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : o.compare(this, b) === 0;
  }, o.prototype.inspect = function() {
    let b = "";
    const w = r.INSPECT_MAX_BYTES;
    return b = this.toString("hex", 0, w).replace(/(.{2})/g, "$1 ").trim(), this.length > w && (b += " ... "), "<Buffer " + b + ">";
  }, n && (o.prototype[n] = o.prototype.inspect), o.prototype.compare = function(b, w, $, Y, ce) {
    if (Ae(b, Uint8Array) && (b = o.from(b, b.offset, b.byteLength)), !o.isBuffer(b))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof b
      );
    if (w === void 0 && (w = 0), $ === void 0 && ($ = b ? b.length : 0), Y === void 0 && (Y = 0), ce === void 0 && (ce = this.length), w < 0 || $ > b.length || Y < 0 || ce > this.length)
      throw new RangeError("out of range index");
    if (Y >= ce && w >= $)
      return 0;
    if (Y >= ce)
      return -1;
    if (w >= $)
      return 1;
    if (w >>>= 0, $ >>>= 0, Y >>>= 0, ce >>>= 0, this === b) return 0;
    let xe = ce - Y, Ie = $ - w;
    const He = Math.min(xe, Ie), Ue = this.slice(Y, ce), je = b.slice(w, $);
    for (let Je = 0; Je < He; ++Je)
      if (Ue[Je] !== je[Je]) {
        xe = Ue[Je], Ie = je[Je];
        break;
      }
    return xe < Ie ? -1 : Ie < xe ? 1 : 0;
  };
  function T(_, b, w, $, Y) {
    if (_.length === 0) return -1;
    if (typeof w == "string" ? ($ = w, w = 0) : w > 2147483647 ? w = 2147483647 : w < -2147483648 && (w = -2147483648), w = +w, ie(w) && (w = Y ? 0 : _.length - 1), w < 0 && (w = _.length + w), w >= _.length) {
      if (Y) return -1;
      w = _.length - 1;
    } else if (w < 0)
      if (Y) w = 0;
      else return -1;
    if (typeof b == "string" && (b = o.from(b, $)), o.isBuffer(b))
      return b.length === 0 ? -1 : U(_, b, w, $, Y);
    if (typeof b == "number")
      return b = b & 255, typeof Uint8Array.prototype.indexOf == "function" ? Y ? Uint8Array.prototype.indexOf.call(_, b, w) : Uint8Array.prototype.lastIndexOf.call(_, b, w) : U(_, [b], w, $, Y);
    throw new TypeError("val must be string, number or Buffer");
  }
  function U(_, b, w, $, Y) {
    let ce = 1, xe = _.length, Ie = b.length;
    if ($ !== void 0 && ($ = String($).toLowerCase(), $ === "ucs2" || $ === "ucs-2" || $ === "utf16le" || $ === "utf-16le")) {
      if (_.length < 2 || b.length < 2)
        return -1;
      ce = 2, xe /= 2, Ie /= 2, w /= 2;
    }
    function He(je, Je) {
      return ce === 1 ? je[Je] : je.readUInt16BE(Je * ce);
    }
    let Ue;
    if (Y) {
      let je = -1;
      for (Ue = w; Ue < xe; Ue++)
        if (He(_, Ue) === He(b, je === -1 ? 0 : Ue - je)) {
          if (je === -1 && (je = Ue), Ue - je + 1 === Ie) return je * ce;
        } else
          je !== -1 && (Ue -= Ue - je), je = -1;
    } else
      for (w + Ie > xe && (w = xe - Ie), Ue = w; Ue >= 0; Ue--) {
        let je = !0;
        for (let Je = 0; Je < Ie; Je++)
          if (He(_, Ue + Je) !== He(b, Je)) {
            je = !1;
            break;
          }
        if (je) return Ue;
      }
    return -1;
  }
  o.prototype.includes = function(b, w, $) {
    return this.indexOf(b, w, $) !== -1;
  }, o.prototype.indexOf = function(b, w, $) {
    return T(this, b, w, $, !0);
  }, o.prototype.lastIndexOf = function(b, w, $) {
    return T(this, b, w, $, !1);
  };
  function R(_, b, w, $) {
    w = Number(w) || 0;
    const Y = _.length - w;
    $ ? ($ = Number($), $ > Y && ($ = Y)) : $ = Y;
    const ce = b.length;
    $ > ce / 2 && ($ = ce / 2);
    let xe;
    for (xe = 0; xe < $; ++xe) {
      const Ie = parseInt(b.substr(xe * 2, 2), 16);
      if (ie(Ie)) return xe;
      _[w + xe] = Ie;
    }
    return xe;
  }
  function j(_, b, w, $) {
    return Be(q(b, _.length - w), _, w, $);
  }
  function D(_, b, w, $) {
    return Be(le(b), _, w, $);
  }
  function O(_, b, w, $) {
    return Be(ve(b), _, w, $);
  }
  function I(_, b, w, $) {
    return Be(be(b, _.length - w), _, w, $);
  }
  o.prototype.write = function(b, w, $, Y) {
    if (w === void 0)
      Y = "utf8", $ = this.length, w = 0;
    else if ($ === void 0 && typeof w == "string")
      Y = w, $ = this.length, w = 0;
    else if (isFinite(w))
      w = w >>> 0, isFinite($) ? ($ = $ >>> 0, Y === void 0 && (Y = "utf8")) : (Y = $, $ = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const ce = this.length - w;
    if (($ === void 0 || $ > ce) && ($ = ce), b.length > 0 && ($ < 0 || w < 0) || w > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Y || (Y = "utf8");
    let xe = !1;
    for (; ; )
      switch (Y) {
        case "hex":
          return R(this, b, w, $);
        case "utf8":
        case "utf-8":
          return j(this, b, w, $);
        case "ascii":
        case "latin1":
        case "binary":
          return D(this, b, w, $);
        case "base64":
          return O(this, b, w, $);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return I(this, b, w, $);
        default:
          if (xe) throw new TypeError("Unknown encoding: " + Y);
          Y = ("" + Y).toLowerCase(), xe = !0;
      }
  }, o.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function P(_, b, w) {
    return b === 0 && w === _.length ? e.fromByteArray(_) : e.fromByteArray(_.slice(b, w));
  }
  function S(_, b, w) {
    w = Math.min(_.length, w);
    const $ = [];
    let Y = b;
    for (; Y < w; ) {
      const ce = _[Y];
      let xe = null, Ie = ce > 239 ? 4 : ce > 223 ? 3 : ce > 191 ? 2 : 1;
      if (Y + Ie <= w) {
        let He, Ue, je, Je;
        switch (Ie) {
          case 1:
            ce < 128 && (xe = ce);
            break;
          case 2:
            He = _[Y + 1], (He & 192) === 128 && (Je = (ce & 31) << 6 | He & 63, Je > 127 && (xe = Je));
            break;
          case 3:
            He = _[Y + 1], Ue = _[Y + 2], (He & 192) === 128 && (Ue & 192) === 128 && (Je = (ce & 15) << 12 | (He & 63) << 6 | Ue & 63, Je > 2047 && (Je < 55296 || Je > 57343) && (xe = Je));
            break;
          case 4:
            He = _[Y + 1], Ue = _[Y + 2], je = _[Y + 3], (He & 192) === 128 && (Ue & 192) === 128 && (je & 192) === 128 && (Je = (ce & 15) << 18 | (He & 63) << 12 | (Ue & 63) << 6 | je & 63, Je > 65535 && Je < 1114112 && (xe = Je));
        }
      }
      xe === null ? (xe = 65533, Ie = 1) : xe > 65535 && (xe -= 65536, $.push(xe >>> 10 & 1023 | 55296), xe = 56320 | xe & 1023), $.push(xe), Y += Ie;
    }
    return C($);
  }
  const B = 4096;
  function C(_) {
    const b = _.length;
    if (b <= B)
      return String.fromCharCode.apply(String, _);
    let w = "", $ = 0;
    for (; $ < b; )
      w += String.fromCharCode.apply(
        String,
        _.slice($, $ += B)
      );
    return w;
  }
  function H(_, b, w) {
    let $ = "";
    w = Math.min(_.length, w);
    for (let Y = b; Y < w; ++Y)
      $ += String.fromCharCode(_[Y] & 127);
    return $;
  }
  function V(_, b, w) {
    let $ = "";
    w = Math.min(_.length, w);
    for (let Y = b; Y < w; ++Y)
      $ += String.fromCharCode(_[Y]);
    return $;
  }
  function J(_, b, w) {
    const $ = _.length;
    (!b || b < 0) && (b = 0), (!w || w < 0 || w > $) && (w = $);
    let Y = "";
    for (let ce = b; ce < w; ++ce)
      Y += se[_[ce]];
    return Y;
  }
  function M(_, b, w) {
    const $ = _.slice(b, w);
    let Y = "";
    for (let ce = 0; ce < $.length - 1; ce += 2)
      Y += String.fromCharCode($[ce] + $[ce + 1] * 256);
    return Y;
  }
  o.prototype.slice = function(b, w) {
    const $ = this.length;
    b = ~~b, w = w === void 0 ? $ : ~~w, b < 0 ? (b += $, b < 0 && (b = 0)) : b > $ && (b = $), w < 0 ? (w += $, w < 0 && (w = 0)) : w > $ && (w = $), w < b && (w = b);
    const Y = this.subarray(b, w);
    return Object.setPrototypeOf(Y, o.prototype), Y;
  };
  function G(_, b, w) {
    if (_ % 1 !== 0 || _ < 0) throw new RangeError("offset is not uint");
    if (_ + b > w) throw new RangeError("Trying to access beyond buffer length");
  }
  o.prototype.readUintLE = o.prototype.readUIntLE = function(b, w, $) {
    b = b >>> 0, w = w >>> 0, $ || G(b, w, this.length);
    let Y = this[b], ce = 1, xe = 0;
    for (; ++xe < w && (ce *= 256); )
      Y += this[b + xe] * ce;
    return Y;
  }, o.prototype.readUintBE = o.prototype.readUIntBE = function(b, w, $) {
    b = b >>> 0, w = w >>> 0, $ || G(b, w, this.length);
    let Y = this[b + --w], ce = 1;
    for (; w > 0 && (ce *= 256); )
      Y += this[b + --w] * ce;
    return Y;
  }, o.prototype.readUint8 = o.prototype.readUInt8 = function(b, w) {
    return b = b >>> 0, w || G(b, 1, this.length), this[b];
  }, o.prototype.readUint16LE = o.prototype.readUInt16LE = function(b, w) {
    return b = b >>> 0, w || G(b, 2, this.length), this[b] | this[b + 1] << 8;
  }, o.prototype.readUint16BE = o.prototype.readUInt16BE = function(b, w) {
    return b = b >>> 0, w || G(b, 2, this.length), this[b] << 8 | this[b + 1];
  }, o.prototype.readUint32LE = o.prototype.readUInt32LE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), (this[b] | this[b + 1] << 8 | this[b + 2] << 16) + this[b + 3] * 16777216;
  }, o.prototype.readUint32BE = o.prototype.readUInt32BE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), this[b] * 16777216 + (this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3]);
  }, o.prototype.readBigUInt64LE = me(function(b) {
    b = b >>> 0, ee(b, "offset");
    const w = this[b], $ = this[b + 7];
    (w === void 0 || $ === void 0) && W(b, this.length - 8);
    const Y = w + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + this[++b] * 2 ** 24, ce = this[++b] + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + $ * 2 ** 24;
    return BigInt(Y) + (BigInt(ce) << BigInt(32));
  }), o.prototype.readBigUInt64BE = me(function(b) {
    b = b >>> 0, ee(b, "offset");
    const w = this[b], $ = this[b + 7];
    (w === void 0 || $ === void 0) && W(b, this.length - 8);
    const Y = w * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + this[++b], ce = this[++b] * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + $;
    return (BigInt(Y) << BigInt(32)) + BigInt(ce);
  }), o.prototype.readIntLE = function(b, w, $) {
    b = b >>> 0, w = w >>> 0, $ || G(b, w, this.length);
    let Y = this[b], ce = 1, xe = 0;
    for (; ++xe < w && (ce *= 256); )
      Y += this[b + xe] * ce;
    return ce *= 128, Y >= ce && (Y -= Math.pow(2, 8 * w)), Y;
  }, o.prototype.readIntBE = function(b, w, $) {
    b = b >>> 0, w = w >>> 0, $ || G(b, w, this.length);
    let Y = w, ce = 1, xe = this[b + --Y];
    for (; Y > 0 && (ce *= 256); )
      xe += this[b + --Y] * ce;
    return ce *= 128, xe >= ce && (xe -= Math.pow(2, 8 * w)), xe;
  }, o.prototype.readInt8 = function(b, w) {
    return b = b >>> 0, w || G(b, 1, this.length), this[b] & 128 ? (255 - this[b] + 1) * -1 : this[b];
  }, o.prototype.readInt16LE = function(b, w) {
    b = b >>> 0, w || G(b, 2, this.length);
    const $ = this[b] | this[b + 1] << 8;
    return $ & 32768 ? $ | 4294901760 : $;
  }, o.prototype.readInt16BE = function(b, w) {
    b = b >>> 0, w || G(b, 2, this.length);
    const $ = this[b + 1] | this[b] << 8;
    return $ & 32768 ? $ | 4294901760 : $;
  }, o.prototype.readInt32LE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), this[b] | this[b + 1] << 8 | this[b + 2] << 16 | this[b + 3] << 24;
  }, o.prototype.readInt32BE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), this[b] << 24 | this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3];
  }, o.prototype.readBigInt64LE = me(function(b) {
    b = b >>> 0, ee(b, "offset");
    const w = this[b], $ = this[b + 7];
    (w === void 0 || $ === void 0) && W(b, this.length - 8);
    const Y = this[b + 4] + this[b + 5] * 2 ** 8 + this[b + 6] * 2 ** 16 + ($ << 24);
    return (BigInt(Y) << BigInt(32)) + BigInt(w + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + this[++b] * 2 ** 24);
  }), o.prototype.readBigInt64BE = me(function(b) {
    b = b >>> 0, ee(b, "offset");
    const w = this[b], $ = this[b + 7];
    (w === void 0 || $ === void 0) && W(b, this.length - 8);
    const Y = (w << 24) + // Overflow
    this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + this[++b];
    return (BigInt(Y) << BigInt(32)) + BigInt(this[++b] * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + $);
  }), o.prototype.readFloatLE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), t.read(this, b, !0, 23, 4);
  }, o.prototype.readFloatBE = function(b, w) {
    return b = b >>> 0, w || G(b, 4, this.length), t.read(this, b, !1, 23, 4);
  }, o.prototype.readDoubleLE = function(b, w) {
    return b = b >>> 0, w || G(b, 8, this.length), t.read(this, b, !0, 52, 8);
  }, o.prototype.readDoubleBE = function(b, w) {
    return b = b >>> 0, w || G(b, 8, this.length), t.read(this, b, !1, 52, 8);
  };
  function K(_, b, w, $, Y, ce) {
    if (!o.isBuffer(_)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > Y || b < ce) throw new RangeError('"value" argument is out of bounds');
    if (w + $ > _.length) throw new RangeError("Index out of range");
  }
  o.prototype.writeUintLE = o.prototype.writeUIntLE = function(b, w, $, Y) {
    if (b = +b, w = w >>> 0, $ = $ >>> 0, !Y) {
      const Ie = Math.pow(2, 8 * $) - 1;
      K(this, b, w, $, Ie, 0);
    }
    let ce = 1, xe = 0;
    for (this[w] = b & 255; ++xe < $ && (ce *= 256); )
      this[w + xe] = b / ce & 255;
    return w + $;
  }, o.prototype.writeUintBE = o.prototype.writeUIntBE = function(b, w, $, Y) {
    if (b = +b, w = w >>> 0, $ = $ >>> 0, !Y) {
      const Ie = Math.pow(2, 8 * $) - 1;
      K(this, b, w, $, Ie, 0);
    }
    let ce = $ - 1, xe = 1;
    for (this[w + ce] = b & 255; --ce >= 0 && (xe *= 256); )
      this[w + ce] = b / xe & 255;
    return w + $;
  }, o.prototype.writeUint8 = o.prototype.writeUInt8 = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 1, 255, 0), this[w] = b & 255, w + 1;
  }, o.prototype.writeUint16LE = o.prototype.writeUInt16LE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 2, 65535, 0), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, o.prototype.writeUint16BE = o.prototype.writeUInt16BE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 2, 65535, 0), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, o.prototype.writeUint32LE = o.prototype.writeUInt32LE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 4, 4294967295, 0), this[w + 3] = b >>> 24, this[w + 2] = b >>> 16, this[w + 1] = b >>> 8, this[w] = b & 255, w + 4;
  }, o.prototype.writeUint32BE = o.prototype.writeUInt32BE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 4, 4294967295, 0), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  };
  function X(_, b, w, $, Y) {
    oe(b, $, Y, _, w, 7);
    let ce = Number(b & BigInt(4294967295));
    _[w++] = ce, ce = ce >> 8, _[w++] = ce, ce = ce >> 8, _[w++] = ce, ce = ce >> 8, _[w++] = ce;
    let xe = Number(b >> BigInt(32) & BigInt(4294967295));
    return _[w++] = xe, xe = xe >> 8, _[w++] = xe, xe = xe >> 8, _[w++] = xe, xe = xe >> 8, _[w++] = xe, w;
  }
  function te(_, b, w, $, Y) {
    oe(b, $, Y, _, w, 7);
    let ce = Number(b & BigInt(4294967295));
    _[w + 7] = ce, ce = ce >> 8, _[w + 6] = ce, ce = ce >> 8, _[w + 5] = ce, ce = ce >> 8, _[w + 4] = ce;
    let xe = Number(b >> BigInt(32) & BigInt(4294967295));
    return _[w + 3] = xe, xe = xe >> 8, _[w + 2] = xe, xe = xe >> 8, _[w + 1] = xe, xe = xe >> 8, _[w] = xe, w + 8;
  }
  o.prototype.writeBigUInt64LE = me(function(b, w = 0) {
    return X(this, b, w, BigInt(0), BigInt("0xffffffffffffffff"));
  }), o.prototype.writeBigUInt64BE = me(function(b, w = 0) {
    return te(this, b, w, BigInt(0), BigInt("0xffffffffffffffff"));
  }), o.prototype.writeIntLE = function(b, w, $, Y) {
    if (b = +b, w = w >>> 0, !Y) {
      const He = Math.pow(2, 8 * $ - 1);
      K(this, b, w, $, He - 1, -He);
    }
    let ce = 0, xe = 1, Ie = 0;
    for (this[w] = b & 255; ++ce < $ && (xe *= 256); )
      b < 0 && Ie === 0 && this[w + ce - 1] !== 0 && (Ie = 1), this[w + ce] = (b / xe >> 0) - Ie & 255;
    return w + $;
  }, o.prototype.writeIntBE = function(b, w, $, Y) {
    if (b = +b, w = w >>> 0, !Y) {
      const He = Math.pow(2, 8 * $ - 1);
      K(this, b, w, $, He - 1, -He);
    }
    let ce = $ - 1, xe = 1, Ie = 0;
    for (this[w + ce] = b & 255; --ce >= 0 && (xe *= 256); )
      b < 0 && Ie === 0 && this[w + ce + 1] !== 0 && (Ie = 1), this[w + ce] = (b / xe >> 0) - Ie & 255;
    return w + $;
  }, o.prototype.writeInt8 = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 1, 127, -128), b < 0 && (b = 255 + b + 1), this[w] = b & 255, w + 1;
  }, o.prototype.writeInt16LE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 2, 32767, -32768), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, o.prototype.writeInt16BE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 2, 32767, -32768), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, o.prototype.writeInt32LE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 4, 2147483647, -2147483648), this[w] = b & 255, this[w + 1] = b >>> 8, this[w + 2] = b >>> 16, this[w + 3] = b >>> 24, w + 4;
  }, o.prototype.writeInt32BE = function(b, w, $) {
    return b = +b, w = w >>> 0, $ || K(this, b, w, 4, 2147483647, -2147483648), b < 0 && (b = 4294967295 + b + 1), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  }, o.prototype.writeBigInt64LE = me(function(b, w = 0) {
    return X(this, b, w, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), o.prototype.writeBigInt64BE = me(function(b, w = 0) {
    return te(this, b, w, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function pe(_, b, w, $, Y, ce) {
    if (w + $ > _.length) throw new RangeError("Index out of range");
    if (w < 0) throw new RangeError("Index out of range");
  }
  function he(_, b, w, $, Y) {
    return b = +b, w = w >>> 0, Y || pe(_, b, w, 4), t.write(_, b, w, $, 23, 4), w + 4;
  }
  o.prototype.writeFloatLE = function(b, w, $) {
    return he(this, b, w, !0, $);
  }, o.prototype.writeFloatBE = function(b, w, $) {
    return he(this, b, w, !1, $);
  };
  function ye(_, b, w, $, Y) {
    return b = +b, w = w >>> 0, Y || pe(_, b, w, 8), t.write(_, b, w, $, 52, 8), w + 8;
  }
  o.prototype.writeDoubleLE = function(b, w, $) {
    return ye(this, b, w, !0, $);
  }, o.prototype.writeDoubleBE = function(b, w, $) {
    return ye(this, b, w, !1, $);
  }, o.prototype.copy = function(b, w, $, Y) {
    if (!o.isBuffer(b)) throw new TypeError("argument should be a Buffer");
    if ($ || ($ = 0), !Y && Y !== 0 && (Y = this.length), w >= b.length && (w = b.length), w || (w = 0), Y > 0 && Y < $ && (Y = $), Y === $ || b.length === 0 || this.length === 0) return 0;
    if (w < 0)
      throw new RangeError("targetStart out of bounds");
    if ($ < 0 || $ >= this.length) throw new RangeError("Index out of range");
    if (Y < 0) throw new RangeError("sourceEnd out of bounds");
    Y > this.length && (Y = this.length), b.length - w < Y - $ && (Y = b.length - w + $);
    const ce = Y - $;
    return this === b && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(w, $, Y) : Uint8Array.prototype.set.call(
      b,
      this.subarray($, Y),
      w
    ), ce;
  }, o.prototype.fill = function(b, w, $, Y) {
    if (typeof b == "string") {
      if (typeof w == "string" ? (Y = w, w = 0, $ = this.length) : typeof $ == "string" && (Y = $, $ = this.length), Y !== void 0 && typeof Y != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Y == "string" && !o.isEncoding(Y))
        throw new TypeError("Unknown encoding: " + Y);
      if (b.length === 1) {
        const xe = b.charCodeAt(0);
        (Y === "utf8" && xe < 128 || Y === "latin1") && (b = xe);
      }
    } else typeof b == "number" ? b = b & 255 : typeof b == "boolean" && (b = Number(b));
    if (w < 0 || this.length < w || this.length < $)
      throw new RangeError("Out of range index");
    if ($ <= w)
      return this;
    w = w >>> 0, $ = $ === void 0 ? this.length : $ >>> 0, b || (b = 0);
    let ce;
    if (typeof b == "number")
      for (ce = w; ce < $; ++ce)
        this[ce] = b;
    else {
      const xe = o.isBuffer(b) ? b : o.from(b, Y), Ie = xe.length;
      if (Ie === 0)
        throw new TypeError('The value "' + b + '" is invalid for argument "value"');
      for (ce = 0; ce < $ - w; ++ce)
        this[ce + w] = xe[ce % Ie];
    }
    return this;
  };
  const re = {};
  function ae(_, b, w) {
    re[_] = class extends w {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: b.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${_}]`, this.stack, delete this.name;
      }
      get code() {
        return _;
      }
      set code(Y) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Y,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${_}]: ${this.message}`;
      }
    };
  }
  ae(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(_) {
      return _ ? `${_} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), ae(
    "ERR_INVALID_ARG_TYPE",
    function(_, b) {
      return `The "${_}" argument must be of type number. Received type ${typeof b}`;
    },
    TypeError
  ), ae(
    "ERR_OUT_OF_RANGE",
    function(_, b, w) {
      let $ = `The value of "${_}" is out of range.`, Y = w;
      return Number.isInteger(w) && Math.abs(w) > 2 ** 32 ? Y = L(String(w)) : typeof w == "bigint" && (Y = String(w), (w > BigInt(2) ** BigInt(32) || w < -(BigInt(2) ** BigInt(32))) && (Y = L(Y)), Y += "n"), $ += ` It must be ${b}. Received ${Y}`, $;
    },
    RangeError
  );
  function L(_) {
    let b = "", w = _.length;
    const $ = _[0] === "-" ? 1 : 0;
    for (; w >= $ + 4; w -= 3)
      b = `_${_.slice(w - 3, w)}${b}`;
    return `${_.slice(0, w)}${b}`;
  }
  function ne(_, b, w) {
    ee(b, "offset"), (_[b] === void 0 || _[b + w] === void 0) && W(b, _.length - (w + 1));
  }
  function oe(_, b, w, $, Y, ce) {
    if (_ > w || _ < b) {
      const xe = typeof b == "bigint" ? "n" : "";
      let Ie;
      throw b === 0 || b === BigInt(0) ? Ie = `>= 0${xe} and < 2${xe} ** ${(ce + 1) * 8}${xe}` : Ie = `>= -(2${xe} ** ${(ce + 1) * 8 - 1}${xe}) and < 2 ** ${(ce + 1) * 8 - 1}${xe}`, new re.ERR_OUT_OF_RANGE("value", Ie, _);
    }
    ne($, Y, ce);
  }
  function ee(_, b) {
    if (typeof _ != "number")
      throw new re.ERR_INVALID_ARG_TYPE(b, "number", _);
  }
  function W(_, b, w) {
    throw Math.floor(_) !== _ ? (ee(_, w), new re.ERR_OUT_OF_RANGE("offset", "an integer", _)) : b < 0 ? new re.ERR_BUFFER_OUT_OF_BOUNDS() : new re.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${b}`,
      _
    );
  }
  const v = /[^+/0-9A-Za-z-_]/g;
  function z(_) {
    if (_ = _.split("=")[0], _ = _.trim().replace(v, ""), _.length < 2) return "";
    for (; _.length % 4 !== 0; )
      _ = _ + "=";
    return _;
  }
  function q(_, b) {
    b = b || 1 / 0;
    let w;
    const $ = _.length;
    let Y = null;
    const ce = [];
    for (let xe = 0; xe < $; ++xe) {
      if (w = _.charCodeAt(xe), w > 55295 && w < 57344) {
        if (!Y) {
          if (w > 56319) {
            (b -= 3) > -1 && ce.push(239, 191, 189);
            continue;
          } else if (xe + 1 === $) {
            (b -= 3) > -1 && ce.push(239, 191, 189);
            continue;
          }
          Y = w;
          continue;
        }
        if (w < 56320) {
          (b -= 3) > -1 && ce.push(239, 191, 189), Y = w;
          continue;
        }
        w = (Y - 55296 << 10 | w - 56320) + 65536;
      } else Y && (b -= 3) > -1 && ce.push(239, 191, 189);
      if (Y = null, w < 128) {
        if ((b -= 1) < 0) break;
        ce.push(w);
      } else if (w < 2048) {
        if ((b -= 2) < 0) break;
        ce.push(
          w >> 6 | 192,
          w & 63 | 128
        );
      } else if (w < 65536) {
        if ((b -= 3) < 0) break;
        ce.push(
          w >> 12 | 224,
          w >> 6 & 63 | 128,
          w & 63 | 128
        );
      } else if (w < 1114112) {
        if ((b -= 4) < 0) break;
        ce.push(
          w >> 18 | 240,
          w >> 12 & 63 | 128,
          w >> 6 & 63 | 128,
          w & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ce;
  }
  function le(_) {
    const b = [];
    for (let w = 0; w < _.length; ++w)
      b.push(_.charCodeAt(w) & 255);
    return b;
  }
  function be(_, b) {
    let w, $, Y;
    const ce = [];
    for (let xe = 0; xe < _.length && !((b -= 2) < 0); ++xe)
      w = _.charCodeAt(xe), $ = w >> 8, Y = w % 256, ce.push(Y), ce.push($);
    return ce;
  }
  function ve(_) {
    return e.toByteArray(z(_));
  }
  function Be(_, b, w, $) {
    let Y;
    for (Y = 0; Y < $ && !(Y + w >= b.length || Y >= _.length); ++Y)
      b[Y + w] = _[Y];
    return Y;
  }
  function Ae(_, b) {
    return _ instanceof b || _ != null && _.constructor != null && _.constructor.name != null && _.constructor.name === b.name;
  }
  function ie(_) {
    return _ !== _;
  }
  const se = function() {
    const _ = "0123456789abcdef", b = new Array(256);
    for (let w = 0; w < 16; ++w) {
      const $ = w * 16;
      for (let Y = 0; Y < 16; ++Y)
        b[$ + Y] = _[w] + _[Y];
    }
    return b;
  }();
  function me(_) {
    return typeof BigInt > "u" ? fe : _;
  }
  function fe() {
    throw new Error("BigInt not supported");
  }
})(ex);
var H4 = {};
(function(r) {
  "use strict;";
  const { Buffer: e } = ex, t = 4294967292, n = 4294967293, s = 4294967294, i = 4294967295, a = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023], o = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0A",
    "0B",
    "0C",
    "0D",
    "0E",
    "0F",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1A",
    "1B",
    "1C",
    "1D",
    "1E",
    "1F",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2A",
    "2B",
    "2C",
    "2D",
    "2E",
    "2F",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3A",
    "3B",
    "3C",
    "3D",
    "3E",
    "3F",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4A",
    "4B",
    "4C",
    "4D",
    "4E",
    "4F",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5A",
    "5B",
    "5C",
    "5D",
    "5E",
    "5F",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6A",
    "6B",
    "6C",
    "6D",
    "6E",
    "6F",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7A",
    "7B",
    "7C",
    "7D",
    "7E",
    "7F",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8A",
    "8B",
    "8C",
    "8D",
    "8E",
    "8F",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9A",
    "9B",
    "9C",
    "9D",
    "9E",
    "9F",
    "A0",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "B0",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "C0",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "C6",
    "C7",
    "C8",
    "C9",
    "CA",
    "CB",
    "CC",
    "CD",
    "CE",
    "CF",
    "D0",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
    "DA",
    "DB",
    "DC",
    "DD",
    "DE",
    "DF",
    "E0",
    "E1",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "EA",
    "EB",
    "EC",
    "ED",
    "EE",
    "EF",
    "F0",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "FA",
    "FB",
    "FC",
    "FD",
    "FE",
    "FF"
  ], u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split(""), c = [];
  u.forEach((d) => {
    c.push(d.charCodeAt(0));
  }), r.utf8 = {
    encode(d) {
      const h = [];
      return d.forEach((p) => {
        if (p >= 0 && p <= 127)
          h.push(p);
        else if (p <= 2047)
          h.push(192 + (p >> 6 & a[5])), h.push(128 + (p & a[6]));
        else if (p < 55296 || p > 57343 && p <= 65535)
          h.push(224 + (p >> 12 & a[4])), h.push(128 + (p >> 6 & a[6])), h.push(128 + (p & a[6]));
        else if (p >= 65536 && p <= 1114111) {
          const g = p >> 16 & a[5];
          h.push(240 + (g >> 2)), h.push(128 + ((g & a[2]) << 4) + (p >> 12 & a[4])), h.push(128 + (p >> 6 & a[6])), h.push(128 + (p & a[6]));
        } else
          throw new RangeError(`utf8.encode: character out of range: char: ${p}`);
      }), e.from(h);
    },
    decode(d, h) {
      function p(D, O) {
        if ((O & 192) !== 128)
          return n;
        const I = ((D & a[5]) << 6) + (O & a[6]);
        return I < 128 ? t : I;
      }
      function g(D, O, I) {
        if ((I & 192) !== 128 || (O & 192) !== 128)
          return n;
        const P = ((D & a[4]) << 12) + ((O & a[6]) << 6) + (I & a[6]);
        return P < 2048 ? t : P >= 55296 && P <= 57343 ? s : P;
      }
      function k(D, O, I, P) {
        if ((P & 192) !== 128 || (I & 192) !== 128 || (O & 192) !== 128)
          return n;
        const S = (((D & a[3]) << 2) + (O >> 4 & a[2]) << 16) + ((O & a[4]) << 12) + ((I & a[6]) << 6) + (P & a[6]);
        return S < 65536 ? t : S > 1114111 ? s : S;
      }
      let A, y, E, m, N, T;
      const U = d.length;
      let R = h ? 3 : 0;
      const j = [];
      for (; R < U; ) {
        y = d[R], A = i;
        const D = !0;
        for (; D; ) {
          if (y >= 0 && y <= 127) {
            A = y, T = 1;
            break;
          }
          if (E = R + 1, E < U && y >= 194 && y <= 223) {
            A = p(y, d[E]), T = 2;
            break;
          }
          if (m = R + 2, m < U && y >= 224 && y <= 239) {
            A = g(y, d[E], d[m]), T = 3;
            break;
          }
          if (N = R + 3, N < U && y >= 240 && y <= 244) {
            A = k(y, d[E], d[m], d[N]), T = 4;
            break;
          }
          break;
        }
        if (A > 1114111) {
          const O = `byte[${R}]`;
          throw A === i ? new RangeError(`utf8.decode: ill-formed UTF8 byte sequence found at: ${O}`) : A === n ? new RangeError(`utf8.decode: illegal trailing byte found at: ${O}`) : A === s ? new RangeError(`utf8.decode: code point out of range found at: ${O}`) : A === t ? new RangeError(`utf8.decode: non-shortest form found at: ${O}`) : new RangeError(`utf8.decode: unrecognized error found at: ${O}`);
        }
        j.push(A), R += T;
      }
      return j;
    }
  }, r.utf16be = {
    encode(d) {
      const h = [];
      let p, g, k;
      for (let A = 0; A < d.length; A += 1)
        if (p = d[A], p >= 0 && p <= 55295 || p >= 57344 && p <= 65535)
          h.push(p >> 8 & a[8]), h.push(p & a[8]);
        else if (p >= 65536 && p <= 1114111)
          k = p - 65536, g = 55296 + (k >> 10), k = 56320 + (k & a[10]), h.push(g >> 8 & a[8]), h.push(g & a[8]), h.push(k >> 8 & a[8]), h.push(k & a[8]);
        else
          throw new RangeError(`utf16be.encode: UTF16BE value out of range: char[${A}]: ${p}`);
      return e.from(h);
    },
    decode(d, h) {
      if (d.length % 2 > 0)
        throw new RangeError(`utf16be.decode: data length must be even multiple of 2: length: ${d.length}`);
      const p = [], g = d.length;
      let k = h ? 2 : 0, A = 0, y, E, m, N, T, U;
      for (; k < g; ) {
        for (; ; ) {
          if (m = k + 1, m < g) {
            if (T = (d[k] << 8) + d[m], T < 55296 || T > 57343) {
              y = T, E = 2;
              break;
            }
            if (N = k + 3, N < g && (U = (d[k + 2] << 8) + d[N], T <= 56319 && U >= 56320 && U <= 57343)) {
              y = 65536 + (T - 55296 << 10) + (U - 56320), E = 4;
              break;
            }
          }
          throw new RangeError(`utf16be.decode: ill-formed UTF16BE byte sequence found: byte[${k}]`);
        }
        p[A++] = y, k += E;
      }
      return p;
    }
  }, r.utf16le = {
    encode(d) {
      const h = [];
      let p, g, k;
      for (let A = 0; A < d.length; A += 1)
        if (p = d[A], p >= 0 && p <= 55295 || p >= 57344 && p <= 65535)
          h.push(p & a[8]), h.push(p >> 8 & a[8]);
        else if (p >= 65536 && p <= 1114111)
          k = p - 65536, g = 55296 + (k >> 10), k = 56320 + (k & a[10]), h.push(g & a[8]), h.push(g >> 8 & a[8]), h.push(k & a[8]), h.push(k >> 8 & a[8]);
        else
          throw new RangeError(`utf16le.encode: UTF16LE value out of range: char[${A}]: ${p}`);
      return e.from(h);
    },
    decode(d, h) {
      if (d.length % 2 > 0)
        throw new RangeError(`utf16le.decode: data length must be even multiple of 2: length: ${d.length}`);
      const p = [], g = d.length;
      let k = h ? 2 : 0, A = 0, y, E, m, N, T, U;
      for (; k < g; ) {
        for (; ; ) {
          if (m = k + 1, m < g) {
            if (T = (d[m] << 8) + d[k], T < 55296 || T > 57343) {
              y = T, E = 2;
              break;
            }
            if (N = k + 3, N < g && (U = (d[N] << 8) + d[k + 2], T <= 56319 && U >= 56320 && U <= 57343)) {
              y = 65536 + (T - 55296 << 10) + (U - 56320), E = 4;
              break;
            }
          }
          throw new RangeError(`utf16le.decode: ill-formed UTF16LE byte sequence found: byte[${k}]`);
        }
        p[A++] = y, k += E;
      }
      return p;
    }
  }, r.utf32be = {
    encode(d) {
      const h = e.alloc(d.length * 4);
      let p = 0;
      return d.forEach((g) => {
        if (g >= 55296 && g <= 57343 || g > 1114111)
          throw new RangeError(`utf32be.encode: UTF32BE character code out of range: char[${p / 4}]: ${g}`);
        h[p++] = g >> 24 & a[8], h[p++] = g >> 16 & a[8], h[p++] = g >> 8 & a[8], h[p++] = g & a[8];
      }), h;
    },
    decode(d, h) {
      if (d.length % 4 > 0)
        throw new RangeError(`utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ${d.length}`);
      const p = [];
      let g = h ? 4 : 0;
      for (; g < d.length; g += 4) {
        const k = (d[g] << 24) + (d[g + 1] << 16) + (d[g + 2] << 8) + d[g + 3];
        if (k >= 55296 && k <= 57343 || k > 1114111)
          throw new RangeError(`utf32be.decode: UTF32BE character code out of range: char[${g / 4}]: ${k}`);
        p.push(k);
      }
      return p;
    }
  }, r.utf32le = {
    encode(d) {
      const h = e.alloc(d.length * 4);
      let p = 0;
      return d.forEach((g) => {
        if (g >= 55296 && g <= 57343 || g > 1114111)
          throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${p / 4}]: ${g}`);
        h[p++] = g & a[8], h[p++] = g >> 8 & a[8], h[p++] = g >> 16 & a[8], h[p++] = g >> 24 & a[8];
      }), h;
    },
    decode(d, h) {
      if (d.length % 4 > 0)
        throw new RangeError(`utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ${d.length}`);
      const p = [];
      let g = h ? 4 : 0;
      for (; g < d.length; g += 4) {
        const k = (d[g + 3] << 24) + (d[g + 2] << 16) + (d[g + 1] << 8) + d[g];
        if (k >= 55296 && k <= 57343 || k > 1114111)
          throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${g / 4}]: ${k}`);
        p.push(k);
      }
      return p;
    }
  }, r.uint7 = {
    encode(d) {
      const h = e.alloc(d.length);
      for (let p = 0; p < d.length; p += 1) {
        if (d[p] > 127)
          throw new RangeError(`uint7.encode: UINT7 character code out of range: char[${p}]: ${d[p]}`);
        h[p] = d[p];
      }
      return h;
    },
    decode(d) {
      const h = [];
      for (let p = 0; p < d.length; p += 1) {
        if (d[p] > 127)
          throw new RangeError(`uint7.decode: UINT7 character code out of range: byte[${p}]: ${d[p]}`);
        h[p] = d[p];
      }
      return h;
    }
  }, r.uint8 = {
    encode(d) {
      const h = e.alloc(d.length);
      for (let p = 0; p < d.length; p += 1) {
        if (d[p] > 255)
          throw new RangeError(`uint8.encode: UINT8 character code out of range: char[${p}]: ${d[p]}`);
        h[p] = d[p];
      }
      return h;
    },
    decode(d) {
      const h = [];
      for (let p = 0; p < d.length; p += 1)
        h[p] = d[p];
      return h;
    }
  }, r.uint16be = {
    encode(d) {
      const h = e.alloc(d.length * 2);
      let p = 0;
      return d.forEach((g) => {
        if (g > 65535)
          throw new RangeError(`uint16be.encode: UINT16BE character code out of range: char[${p / 2}]: ${g}`);
        h[p++] = g >> 8 & a[8], h[p++] = g & a[8];
      }), h;
    },
    decode(d) {
      if (d.length % 2 > 0)
        throw new RangeError(`uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ${d.length}`);
      const h = [];
      for (let p = 0; p < d.length; p += 2)
        h.push((d[p] << 8) + d[p + 1]);
      return h;
    }
  }, r.uint16le = {
    encode(d) {
      const h = e.alloc(d.length * 2);
      let p = 0;
      return d.forEach((g) => {
        if (g > 65535)
          throw new RangeError(`uint16le.encode: UINT16LE character code out of range: char[${p / 2}]: ${g}`);
        h[p++] = g & a[8], h[p++] = g >> 8 & a[8];
      }), h;
    },
    decode(d) {
      if (d.length % 2 > 0)
        throw new RangeError(`uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ${d.length}`);
      const h = [];
      for (let p = 0; p < d.length; p += 2)
        h.push((d[p + 1] << 8) + d[p]);
      return h;
    }
  }, r.uint32be = {
    encode(d) {
      const h = e.alloc(d.length * 4);
      let p = 0;
      return d.forEach((g) => {
        h[p++] = g >> 24 & a[8], h[p++] = g >> 16 & a[8], h[p++] = g >> 8 & a[8], h[p++] = g & a[8];
      }), h;
    },
    decode(d) {
      if (d.length % 4 > 0)
        throw new RangeError(`uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ${d.length}`);
      const h = [];
      for (let p = 0; p < d.length; p += 4)
        h.push((d[p] << 24) + (d[p + 1] << 16) + (d[p + 2] << 8) + d[p + 3]);
      return h;
    }
  }, r.uint32le = {
    encode(d) {
      const h = e.alloc(d.length * 4);
      let p = 0;
      return d.forEach((g) => {
        h[p++] = g & a[8], h[p++] = g >> 8 & a[8], h[p++] = g >> 16 & a[8], h[p++] = g >> 24 & a[8];
      }), h;
    },
    decode(d) {
      if (d.length % 4 > 0)
        throw new RangeError(`uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ${d.length}`);
      const h = [];
      for (let p = 0; p < d.length; p += 4)
        h.push((d[p + 3] << 24) + (d[p + 2] << 16) + (d[p + 1] << 8) + d[p]);
      return h;
    }
  }, r.string = {
    encode(d) {
      return r.utf16le.encode(d).toString("utf16le");
    },
    decode(d) {
      return r.utf16le.decode(e.from(d, "utf16le"), 0);
    }
  }, r.escaped = {
    // Encodes an Array of 32-bit integers into ESCAPED format.
    encode(d) {
      const h = [];
      for (let p = 0; p < d.length; p += 1) {
        const g = d[p];
        if (g === 96)
          h.push(g), h.push(g);
        else if (g === 10)
          h.push(g);
        else if (g >= 32 && g <= 126)
          h.push(g);
        else {
          let k = "";
          if (g >= 0 && g <= 31)
            k += `\`x${o[g]}`;
          else if (g >= 127 && g <= 255)
            k += `\`x${o[g]}`;
          else if (g >= 256 && g <= 65535)
            k += `\`u${o[g >> 8 & a[8]]}${o[g & a[8]]}`;
          else if (g >= 65536 && g <= 4294967295) {
            k += "`u{";
            const y = g >> 24 & a[8];
            y > 0 && (k += o[y]), k += `${o[g >> 16 & a[8]] + o[g >> 8 & a[8]] + o[g & a[8]]}}`;
          } else
            throw new Error("escape.encode(char): char > 0xffffffff not allowed");
          e.from(k).forEach((y) => {
            h.push(y);
          });
        }
      }
      return e.from(h);
    },
    // Decodes ESCAPED format from a Buffer of bytes to an Array of 32-bit integers.
    decode(d) {
      function h(U) {
        return U >= 48 && U <= 57 || U >= 65 && U <= 70 || U >= 97 && U <= 102;
      }
      function p(U, R, j) {
        const D = { char: null, nexti: U + 2, error: !0 };
        if (U + 1 < R && h(j[U]) && h(j[U + 1])) {
          const O = String.fromCodePoint(j[U], j[U + 1]);
          D.char = parseInt(O, 16), Number.isNaN(D.char) || (D.error = !1);
        }
        return D;
      }
      function g(U, R, j) {
        const D = { char: null, nexti: U + 4, error: !0 };
        if (U + 3 < R && h(j[U]) && h(j[U + 1]) && h(j[U + 2]) && h(j[U + 3])) {
          const O = String.fromCodePoint(j[U], j[U + 1], j[U + 2], j[U + 3]);
          D.char = parseInt(O, 16), Number.isNaN(D.char) || (D.error = !1);
        }
        return D;
      }
      function k(U, R, j) {
        const D = { char: null, nexti: U + 4, error: !0 };
        let O = "";
        for (; U < R && h(j[U]); )
          O += String.fromCodePoint(j[U]), U += 1;
        return D.char = parseInt(O, 16), j[U] === 125 && !Number.isNaN(D.char) && (D.error = !1), D.nexti = U + 1, D;
      }
      const A = [], y = d.length;
      let E, m, N, T = 0;
      for (; T < y; ) {
        for (; ; ) {
          if (N = !0, d[T] !== 96) {
            A.push(d[T]), T += 1, N = !1;
            break;
          }
          if (E = T + 1, E >= y)
            break;
          if (d[E] === 96) {
            A.push(96), T += 2, N = !1;
            break;
          }
          if (d[E] === 120) {
            if (m = p(E + 1, y, d), m.error)
              break;
            A.push(m.char), T = m.nexti, N = !1;
            break;
          }
          if (d[E] === 117) {
            if (d[E + 1] === 123) {
              if (m = k(E + 2, y, d), m.error)
                break;
              A.push(m.char), T = m.nexti, N = !1;
              break;
            }
            if (m = g(E + 1, y, d), m.error)
              break;
            A.push(m.char), T = m.nexti, N = !1;
            break;
          }
          break;
        }
        if (N)
          throw new Error(`escaped.decode: ill-formed escape sequence at buf[${T}]`);
      }
      return A;
    }
  };
  const l = 13, f = 10;
  r.lineEnds = {
    crlf(d) {
      const h = [];
      let p = 0;
      for (; p < d.length; )
        switch (d[p]) {
          case l:
            p + 1 < d.length && d[p + 1] === f ? p += 2 : p += 1, h.push(l), h.push(f);
            break;
          case f:
            h.push(l), h.push(f), p += 1;
            break;
          default:
            h.push(d[p]), p += 1;
            break;
        }
      return h.length > 0 && h[h.length - 1] !== f && (h.push(l), h.push(f)), h;
    },
    lf(d) {
      const h = [];
      let p = 0;
      for (; p < d.length; )
        switch (d[p]) {
          case l:
            p + 1 < d.length && d[p + 1] === f ? p += 2 : p += 1, h.push(f);
            break;
          case f:
            h.push(f), p += 1;
            break;
          default:
            h.push(d[p]), p += 1;
            break;
        }
      return h.length > 0 && h[h.length - 1] !== f && h.push(f), h;
    }
  }, r.base64 = {
    encode(d) {
      if (d.length === 0)
        return e.alloc(0);
      let h, p, g, k = d.length % 3;
      k = k > 0 ? 3 - k : 0;
      let A = (d.length + k) / 3;
      const y = e.alloc(A * 4);
      k > 0 && (A -= 1), h = 0, p = 0;
      for (let E = 0; E < A; E += 1)
        g = d[h++] << 16, g += d[h++] << 8, g += d[h++], y[p++] = c[g >> 18 & a[6]], y[p++] = c[g >> 12 & a[6]], y[p++] = c[g >> 6 & a[6]], y[p++] = c[g & a[6]];
      if (k === 0)
        return y;
      if (k === 1)
        return g = d[h++] << 16, g += d[h] << 8, y[p++] = c[g >> 18 & a[6]], y[p++] = c[g >> 12 & a[6]], y[p++] = c[g >> 6 & a[6]], y[p] = c[64], y;
      if (k === 2)
        return g = d[h] << 16, y[p++] = c[g >> 18 & a[6]], y[p++] = c[g >> 12 & a[6]], y[p++] = c[64], y[p] = c[64], y;
    },
    decode(d) {
      function h(T) {
        const U = [];
        let R = 0;
        for (let j = 0; j < T.length; j += 1) {
          const D = T[j], O = !0;
          for (; O && !(D === 32 || D === 9 || D === 10 || D === 13); ) {
            if (D >= 65 && D <= 90) {
              U.push(D - 65);
              break;
            }
            if (D >= 97 && D <= 122) {
              U.push(D - 71);
              break;
            }
            if (D >= 48 && D <= 57) {
              U.push(D + 4);
              break;
            }
            if (D === 43) {
              U.push(62);
              break;
            }
            if (D === 47) {
              U.push(63);
              break;
            }
            if (D === 61) {
              U.push(64), R += 1;
              break;
            }
            throw new RangeError(`base64.decode: invalid character buf[${j}]: ${D}`);
          }
        }
        if (U.length % 4 > 0)
          throw new RangeError(`base64.decode: string length not integral multiple of 4: ${U.length}`);
        switch (R) {
          case 0:
            break;
          case 1:
            if (U[U.length - 1] !== 64)
              throw new RangeError("base64.decode: one tail character found: not last character");
            break;
          case 2:
            if (U[U.length - 1] !== 64 || U[U.length - 2] !== 64)
              throw new RangeError("base64.decode: two tail characters found: not last characters");
            break;
          default:
            throw new RangeError(`base64.decode: more than two tail characters found: ${R}`);
        }
        return { tail: R, buf: e.from(U) };
      }
      if (d.length === 0)
        return e.alloc(0);
      const p = h(d), { tail: g } = p, k = p.buf;
      let A, y, E, m = k.length / 4;
      const N = e.alloc(m * 3 - g);
      g > 0 && (m -= 1), y = 0, A = 0;
      for (let T = 0; T < m; T += 1)
        E = k[A++] << 18, E += k[A++] << 12, E += k[A++] << 6, E += k[A++], N[y++] = E >> 16 & a[8], N[y++] = E >> 8 & a[8], N[y++] = E & a[8];
      return g === 1 && (E = k[A++] << 18, E += k[A++] << 12, E += k[A] << 6, N[y++] = E >> 16 & a[8], N[y] = E >> 8 & a[8]), g === 2 && (E = k[A++] << 18, E += k[A++] << 12, N[y] = E >> 16 & a[8]), N;
    },
    // Converts a base 64 Buffer of bytes to a JavaScript string with line breaks.
    toString(d) {
      if (d.length % 4 > 0)
        throw new RangeError(`base64.toString: input buffer length not multiple of 4: ${d.length}`);
      let h = "", p = 0;
      function g(A, y, E, m) {
        switch (p) {
          case 76:
            h += `\r
${A}${y}${E}${m}`, p = 4;
            break;
          case 75:
            h += `${A}\r
${y}${E}${m}`, p = 3;
            break;
          case 74:
            h += `${A + y}\r
${E}${m}`, p = 2;
            break;
          case 73:
            h += `${A + y + E}\r
${m}`, p = 1;
            break;
          default:
            h += A + y + E + m, p += 4;
            break;
        }
      }
      function k(A) {
        return A >= 65 && A <= 90 || A >= 97 && A <= 122 || A >= 48 && A <= 57 || A === 43 || A === 47 || A === 61;
      }
      for (let A = 0; A < d.length; A += 4) {
        for (let y = A; y < A + 4; y += 1)
          if (!k(d[y]))
            throw new RangeError(`base64.toString: buf[${y}]: ${d[y]} : not valid base64 character code`);
        g(
          String.fromCharCode(d[A]),
          String.fromCharCode(d[A + 1]),
          String.fromCharCode(d[A + 2]),
          String.fromCharCode(d[A + 3])
        );
      }
      return h;
    }
  };
})(H4);
(function(r) {
  "use strict;";
  const { Buffer: e } = ex, t = H4, n = "UTF8", s = "UTF16", i = "UTF16BE", a = "UTF16LE", o = "UTF32", u = "UTF32BE", c = "UTF32LE", l = "UINT7", f = "ASCII", d = "BINARY", h = "UINT8", p = "UINT16", g = "UINT16LE", k = "UINT16BE", A = "UINT32", y = "UINT32LE", E = "UINT32BE", m = "ESCAPED", N = "STRING", T = function(B) {
    B.type = n;
    const C = B.data;
    B.bom = 0, C.length >= 3 && C[0] === 239 && C[1] === 187 && C[2] === 191 && (B.bom = 3);
  }, U = function(B) {
    const C = B.data;
    switch (B.bom = 0, B.type) {
      case s:
        B.type = i, C.length >= 2 && (C[0] === 254 && C[1] === 255 ? B.bom = 2 : C[0] === 255 && C[1] === 254 && (B.type = a, B.bom = 2));
        break;
      case i:
        if (B.type = i, C.length >= 2) {
          if (C[0] === 254 && C[1] === 255)
            B.bom = 2;
          else if (C[0] === 255 && C[1] === 254)
            throw new TypeError(`src type: "${i}" specified but BOM is for "${a}"`);
        }
        break;
      case a:
        if (B.type = a, C.length >= 0) {
          if (C[0] === 254 && C[1] === 255)
            throw new TypeError(`src type: "${a}" specified but BOM is for "${i}"`);
          C[0] === 255 && C[1] === 254 && (B.bom = 2);
        }
        break;
      default:
        throw new TypeError(`UTF16 BOM: src type "${B.type}" unrecognized`);
    }
  }, R = function(B) {
    const C = B.data;
    switch (B.bom = 0, B.type) {
      case o:
        B.type = u, C.length >= 4 && (C[0] === 0 && C[1] === 0 && C[2] === 254 && C[3] === 255 && (B.bom = 4), C[0] === 255 && C[1] === 254 && C[2] === 0 && C[3] === 0 && (B.type = c, B.bom = 4));
        break;
      case u:
        if (B.type = u, C.length >= 4 && (C[0] === 0 && C[1] === 0 && C[2] === 254 && C[3] === 255 && (B.bom = 4), C[0] === 255 && C[1] === 254 && C[2] === 0 && C[3] === 0))
          throw new TypeError(`src type: ${u} specified but BOM is for ${c}"`);
        break;
      case c:
        if (B.type = c, C.length >= 4) {
          if (C[0] === 0 && C[1] === 0 && C[2] === 254 && C[3] === 255)
            throw new TypeError(`src type: "${c}" specified but BOM is for "${u}"`);
          C[0] === 255 && C[1] === 254 && C[2] === 0 && C[3] === 0 && (B.bom = 4);
        }
        break;
      default:
        throw new TypeError(`UTF32 BOM: src type "${B.type}" unrecognized`);
    }
  }, j = function(B, C) {
    function H(J) {
      const M = {
        type: "",
        base64: !1
      }, K = /^(base64:)?([a-zA-Z0-9]+)$/i.exec(J);
      return K && (K[2] && (M.type = K[2].toUpperCase()), K[1] && (M.base64 = !0)), M;
    }
    const V = H(B.toUpperCase());
    if (V.base64) {
      if (V.type === N)
        throw new TypeError(`type: "${B} "BASE64:" prefix not allowed with type ${N}`);
      if (e.isBuffer(C))
        V.data = t.base64.decode(C);
      else if (typeof C == "string") {
        const J = e.from(C, "ascii");
        V.data = t.base64.decode(J);
      } else
        throw new TypeError(`type: "${B} unrecognized data type: typeof(data): ${typeof C}`);
    } else
      V.data = C;
    switch (V.type) {
      case n:
        T(V);
        break;
      case s:
      case i:
      case a:
        U(V);
        break;
      case o:
      case u:
      case c:
        R(V);
        break;
      case p:
        V.type = k;
        break;
      case A:
        V.type = E;
        break;
      case f:
        V.type = l;
        break;
      case d:
        V.type = h;
        break;
      case l:
      case h:
      case g:
      case k:
      case y:
      case E:
      case N:
      case m:
        break;
      default:
        throw new TypeError(`type: "${B}" not recognized`);
    }
    if (V.type === N) {
      if (typeof V.data != "string")
        throw new TypeError(`type: "${B}" but data is not a string`);
    } else if (!e.isBuffer(V.data))
      throw new TypeError(`type: "${B}" but data is not a Buffer`);
    return V;
  }, D = function(B, C) {
    function H(J) {
      let M, G;
      const K = {
        crlf: !1,
        lf: !1,
        base64: !1,
        type: ""
      }, X = !0;
      for (; X; ) {
        if (G = J, M = J.slice(0, 5), M === "CRLF:") {
          K.crlf = !0, G = J.slice(5);
          break;
        }
        if (M = J.slice(0, 3), M === "LF:") {
          K.lf = !0, G = J.slice(3);
          break;
        }
        break;
      }
      return M = G.split(":"), M.length === 1 ? K.type = M[0] : M.length === 2 && M[1] === "BASE64" && (K.base64 = !0, K.type = M[0]), K;
    }
    if (!Array.isArray(C))
      throw new TypeError(`dst chars: not array: "${typeof C}`);
    if (typeof B != "string")
      throw new TypeError(`dst type: not string: "${typeof B}`);
    const V = H(B.toUpperCase());
    switch (V.type) {
      case n:
      case i:
      case a:
      case u:
      case c:
      case l:
      case h:
      case g:
      case k:
      case y:
      case E:
      case m:
        break;
      case N:
        if (V.base64)
          throw new TypeError(`":BASE64" suffix not allowed with type ${N}`);
        break;
      case f:
        V.type = l;
        break;
      case d:
        V.type = h;
        break;
      case s:
        V.type = i;
        break;
      case o:
        V.type = u;
        break;
      case p:
        V.type = k;
        break;
      case A:
        V.type = E;
        break;
      default:
        throw new TypeError(`dst type unrecognized: "${B}" : must have form [crlf:|lf:]type[:base64]`);
    }
    return V;
  }, O = function(B, C) {
    switch (B) {
      case n:
        return t.utf8.encode(C);
      case i:
        return t.utf16be.encode(C);
      case a:
        return t.utf16le.encode(C);
      case u:
        return t.utf32be.encode(C);
      case c:
        return t.utf32le.encode(C);
      case l:
        return t.uint7.encode(C);
      case h:
        return t.uint8.encode(C);
      case k:
        return t.uint16be.encode(C);
      case g:
        return t.uint16le.encode(C);
      case E:
        return t.uint32be.encode(C);
      case y:
        return t.uint32le.encode(C);
      case N:
        return t.string.encode(C);
      case m:
        return t.escaped.encode(C);
      default:
        throw new TypeError(`encode type "${B}" not recognized`);
    }
  }, I = function(B) {
    switch (B.type) {
      case n:
        return t.utf8.decode(B.data, B.bom);
      case a:
        return t.utf16le.decode(B.data, B.bom);
      case i:
        return t.utf16be.decode(B.data, B.bom);
      case u:
        return t.utf32be.decode(B.data, B.bom);
      case c:
        return t.utf32le.decode(B.data, B.bom);
      case l:
        return t.uint7.decode(B.data);
      case h:
        return t.uint8.decode(B.data);
      case k:
        return t.uint16be.decode(B.data);
      case g:
        return t.uint16le.decode(B.data);
      case E:
        return t.uint32be.decode(B.data);
      case y:
        return t.uint32le.decode(B.data);
      case N:
        return t.string.decode(B.data);
      case m:
        return t.escaped.decode(B.data);
      default:
        throw new TypeError(`decode type "${B.type}" not recognized`);
    }
  };
  r.decode = function(B, C) {
    const H = j(B, C);
    return I(H);
  }, r.encode = function(B, C) {
    let H, V;
    const J = D(B, C);
    return J.crlf ? (H = t.lineEnds.crlf(C), V = O(J.type, H)) : J.lf ? (H = t.lineEnds.lf(C), V = O(J.type, H)) : V = O(J.type, C), J.base64 && (V = t.base64.encode(V)), V;
  };
  const P = function(B, C, H) {
    return r.encode(H, r.decode(B, C));
  };
  r.convert = P;
})(D4);
var G4 = function() {
  return `/* This file automatically generated by jsonToless() and LESS. */
.apg-mono {
  font-family: monospace;
}
.apg-active {
  font-weight: bold;
  color: #000000;
}
.apg-match {
  font-weight: bold;
  color: #264BFF;
}
.apg-empty {
  font-weight: bold;
  color: #0fbd0f;
}
.apg-nomatch {
  font-weight: bold;
  color: #FF4000;
}
.apg-lh-match {
  font-weight: bold;
  color: #1A97BA;
}
.apg-lb-match {
  font-weight: bold;
  color: #5F1687;
}
.apg-remainder {
  font-weight: bold;
  color: #999999;
}
.apg-ctrl-char {
  font-weight: bolder;
  font-style: italic;
  font-size: 0.6em;
}
.apg-line-end {
  font-weight: bold;
  color: #000000;
}
.apg-error {
  font-weight: bold;
  color: #FF4000;
}
.apg-phrase {
  color: #000000;
  background-color: #8caae6;
}
.apg-empty-phrase {
  color: #0fbd0f;
}
table.apg-state {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: left;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-state th,
table.apg-state td {
  text-align: left;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-state th:nth-last-child(2),
table.apg-state td:nth-last-child(2) {
  text-align: right;
}
table.apg-state caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-stats {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-stats th,
table.apg-stats td {
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-stats caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-trace {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-trace caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-trace th,
table.apg-trace td {
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-trace th:last-child,
table.apg-trace th:nth-last-child(2),
table.apg-trace td:last-child,
table.apg-trace td:nth-last-child(2) {
  text-align: left;
}
table.apg-grammar {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-grammar caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-grammar th,
table.apg-grammar td {
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-grammar th:last-child,
table.apg-grammar td:last-child {
  text-align: left;
}
table.apg-rules {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-rules caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-rules th,
table.apg-rules td {
  text-align: right;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-rules a {
  color: #003399 !important;
}
table.apg-rules a:hover {
  color: #8caae6 !important;
}
table.apg-attrs {
  font-family: monospace;
  margin-top: 5px;
  font-size: 11px;
  line-height: 130%;
  text-align: center;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-attrs caption {
  font-size: 125%;
  line-height: 130%;
  font-weight: bold;
  text-align: left;
}
table.apg-attrs th,
table.apg-attrs td {
  text-align: center;
  border: 1px solid black;
  border-collapse: collapse;
}
table.apg-attrs th:nth-child(1),
table.apg-attrs th:nth-child(2),
table.apg-attrs th:nth-child(3) {
  text-align: right;
}
table.apg-attrs td:nth-child(1),
table.apg-attrs td:nth-child(2),
table.apg-attrs td:nth-child(3) {
  text-align: right;
}
table.apg-attrs a {
  color: #003399 !important;
}
table.apg-attrs a:hover {
  color: #8caae6 !important;
}
`;
};
(function(r) {
  const e = xh, t = D4, n = G4, s = Fu, i = "utilities.js: ", a = function(u, c, l) {
    let f, d = c;
    const h = !0;
    for (; h; ) {
      if (u <= 0) {
        d = 0, f = 0;
        break;
      }
      if (typeof d != "number") {
        d = 0, f = u;
        break;
      }
      if (d >= u) {
        d = u, f = u;
        break;
      }
      if (typeof l != "number") {
        f = u;
        break;
      }
      if (f = d + l, f > u) {
        f = u;
        break;
      }
      break;
    }
    return {
      beg: d,
      end: f
    };
  };
  r.htmlToPage = function(u, c) {
    let l;
    if (typeof u != "string")
      throw new Error(`${i}htmlToPage: input HTML is not a string`);
    typeof c != "string" ? l = "htmlToPage" : l = c;
    let f = "";
    return f += `<!DOCTYPE html>
`, f += `<html lang="en">
`, f += `<head>
`, f += `<meta charset="utf-8">
`, f += `<title>${l}</title>
`, f += `<style>
`, f += n(), f += `</style>
`, f += `</head>
<body>
`, f += `<p>${/* @__PURE__ */ new Date()}</p>
`, f += u, f += `</body>
</html>
`, f;
  }, r.parserResultToHtml = function(u, c) {
    let l = null;
    typeof c == "string" && c !== "" && (l = c);
    let f, d;
    u.success === !0 ? f = `<span class="${e.CLASS_MATCH}">true</span>` : f = `<span class="${e.CLASS_NOMATCH}">false</span>`, u.state === s.EMPTY ? d = `<span class="${e.CLASS_EMPTY}">EMPTY</span>` : u.state === s.MATCH ? d = `<span class="${e.CLASS_MATCH}">MATCH</span>` : u.state === s.NOMATCH ? d = `<span class="${e.CLASS_NOMATCH}">NOMATCH</span>` : d = `<span class="${e.CLASS_NOMATCH}">unrecognized</span>`;
    let h = "";
    return h += `<table class="${e.CLASS_STATE}">
`, l && (h += `<caption>${l}</caption>
`), h += `<tr><th>state item</th><th>value</th><th>description</th></tr>
`, h += `<tr><td>parser success</td><td>${f}</td>
`, h += `<td><span class="${e.CLASS_MATCH}">true</span> if the parse succeeded,
`, h += ` <span class="${e.CLASS_NOMATCH}">false</span> otherwise`, h += `<br><i>NOTE: for success, entire string must be matched</i></td></tr>
`, h += `<tr><td>parser state</td><td>${d}</td>
`, h += `<td><span class="${e.CLASS_EMPTY}">EMPTY</span>, `, h += `<span class="${e.CLASS_MATCH}">MATCH</span> or 
`, h += `<span class="${e.CLASS_NOMATCH}">NOMATCH</span></td></tr>
`, h += `<tr><td>string length</td><td>${u.length}</td><td>length of the input (sub)string</td></tr>
`, h += `<tr><td>matched length</td><td>${u.matched}</td><td>number of input string characters matched</td></tr>
`, h += `<tr><td>max matched</td><td>${u.maxMatched}</td><td>maximum number of input string characters matched</td></tr>
`, h += `<tr><td>max tree depth</td><td>${u.maxTreeDepth}</td><td>maximum depth of the parse tree reached</td></tr>
`, h += `<tr><td>node hits</td><td>${u.nodeHits}</td><td>number of parse tree node hits (opcode function calls)</td></tr>
`, h += `<tr><td>input length</td><td>${u.inputLength}</td><td>length of full input string</td></tr>
`, h += `<tr><td>sub-string begin</td><td>${u.subBegin}</td><td>sub-string first character index</td></tr>
`, h += `<tr><td>sub-string end</td><td>${u.subEnd}</td><td>sub-string end-of-string index</td></tr>
`, h += `<tr><td>sub-string length</td><td>${u.subLength}</td><td>sub-string length</td></tr>
`, h += `</table>
`, h;
  }, r.charsToString = function(u, c, l) {
    let f, d;
    if (typeof c == "number") {
      if (c >= u.length)
        return "";
      f = c < 0 ? 0 : c;
    } else
      f = 0;
    if (typeof l == "number") {
      if (l <= 0)
        return "";
      d = l > u.length - f ? u.length : f + l;
    } else
      d = u.length;
    return f < d ? t.encode("UTF16LE", u.slice(f, d)).toString("utf16le") : "";
  }, r.stringToChars = function(u) {
    return t.decode("STRING", u);
  }, r.opcodeToString = function(u) {
    let c = "unknown";
    switch (u) {
      case s.ALT:
        c = "ALT";
        break;
      case s.CAT:
        c = "CAT";
        break;
      case s.RNM:
        c = "RNM";
        break;
      case s.UDT:
        c = "UDT";
        break;
      case s.AND:
        c = "AND";
        break;
      case s.NOT:
        c = "NOT";
        break;
      case s.REP:
        c = "REP";
        break;
      case s.TRG:
        c = "TRG";
        break;
      case s.TBS:
        c = "TBS";
        break;
      case s.TLS:
        c = "TLS";
        break;
      case s.BKR:
        c = "BKR";
        break;
      case s.BKA:
        c = "BKA";
        break;
      case s.BKN:
        c = "BKN";
        break;
      case s.ABG:
        c = "ABG";
        break;
      case s.AEN:
        c = "AEN";
        break;
      default:
        throw new Error("unrecognized opcode");
    }
    return c;
  }, r.stateToString = function(u) {
    let c = "unknown";
    switch (u) {
      case s.ACTIVE:
        c = "ACTIVE";
        break;
      case s.MATCH:
        c = "MATCH";
        break;
      case s.EMPTY:
        c = "EMPTY";
        break;
      case s.NOMATCH:
        c = "NOMATCH";
        break;
      default:
        throw new Error("unrecognized state");
    }
    return c;
  }, r.asciiChars = [
    "NUL",
    "SOH",
    "STX",
    "ETX",
    "EOT",
    "ENQ",
    "ACK",
    "BEL",
    "BS",
    "TAB",
    "LF",
    "VT",
    "FF",
    "CR",
    "SO",
    "SI",
    "DLE",
    "DC1",
    "DC2",
    "DC3",
    "DC4",
    "NAK",
    "SYN",
    "ETB",
    "CAN",
    "EM",
    "SUB",
    "ESC",
    "FS",
    "GS",
    "RS",
    "US",
    "&nbsp;",
    "!",
    "&#34;",
    "#",
    "$",
    "%",
    "&#38;",
    "&#39;",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "&#60;",
    "=",
    "&#62;",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "&#92;",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "DEL"
  ], r.charToHex = function(u) {
    let c = u.toString(16).toUpperCase();
    switch (c.length) {
      case 1:
      case 3:
      case 7:
        c = `0${c}`;
        break;
      case 2:
      case 6:
        c = `00${c}`;
        break;
      case 4:
        break;
      case 5:
        c = `000${c}`;
        break;
      default:
        throw new Error("unrecognized option");
    }
    return c;
  }, r.charsToDec = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToDec: input must be an array of integers`);
    const d = a(u.length, c, l);
    if (d.end > d.beg) {
      f += u[d.beg];
      for (let h = d.beg + 1; h < d.end; h += 1)
        f += `,${u[h]}`;
    }
    return f;
  }, r.charsToHex = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToHex: input must be an array of integers`);
    const d = a(u.length, c, l);
    if (d.end > d.beg) {
      f += `\\x${r.charToHex(u[d.beg])}`;
      for (let h = d.beg + 1; h < d.end; h += 1)
        f += `,\\x${r.charToHex(u[h])}`;
    }
    return f;
  }, r.charsToHtmlEntities = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToHex: input must be an array of integers`);
    const d = a(u.length, c, l);
    if (d.end > d.beg)
      for (let h = d.beg; h < d.end; h += 1)
        f += `&#x${u[h].toString(16)};`;
    return f;
  };
  function o(u) {
    return !(u >= 55296 && u <= 57343 || u > 1114111);
  }
  r.charsToUnicode = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToUnicode: input must be an array of integers`);
    const d = a(u.length, c, l);
    if (d.end > d.beg)
      for (let h = d.beg; h < d.end; h += 1)
        o(u[h]) ? f += `&#${u[h]};` : f += ` U+${r.charToHex(u[h])}`;
    return f;
  }, r.charsToJsUnicode = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToJsUnicode: input must be an array of integers`);
    const d = a(u.length, c, l);
    if (d.end > d.beg) {
      f += `\\u${r.charToHex(u[d.beg])}`;
      for (let h = d.beg + 1; h < d.end; h += 1)
        f += `,\\u${r.charToHex(u[h])}`;
    }
    return f;
  }, r.charsToAscii = function(u, c, l) {
    let f = "";
    if (!Array.isArray(u))
      throw new Error(`${i}charsToAscii: input must be an array of integers`);
    const d = a(u.length, c, l);
    for (let h = d.beg; h < d.end; h += 1) {
      const p = u[h];
      p >= 32 && p <= 126 ? f += String.fromCharCode(p) : f += `\\x${r.charToHex(p)}`;
    }
    return f;
  }, r.charsToAsciiHtml = function(u, c, l) {
    if (!Array.isArray(u))
      throw new Error(`${i}charsToAsciiHtml: input must be an array of integers`);
    let f = "", d;
    const h = a(u.length, c, l);
    for (let p = h.beg; p < h.end; p += 1)
      d = u[p], d < 32 || d === 127 ? f += `<span class="${e.CLASS_CTRLCHAR}">${r.asciiChars[d]}</span>` : d > 127 ? f += `<span class="${e.CLASS_CTRLCHAR}">U+${r.charToHex(d)}</span>` : f += r.asciiChars[d];
    return f;
  }, r.stringToAsciiHtml = function(u) {
    const c = t.decode("STRING", u);
    return this.charsToAsciiHtml(c);
  };
})(Du);
var NP = function() {
  const e = Fu, t = Du, n = "ast.js: ", s = this;
  let i = null, a = null, o = null, u = 0;
  const c = [], l = [], f = [], d = [];
  this.callbacks = [], this.astObject = "astObject", this.init = function(g, k, A) {
    f.length = 0, d.length = 0, c.length = 0, u = 0, i = g, a = k, o = A;
    let y;
    const E = [];
    for (y = 0; y < i.length; y += 1)
      E.push(i[y].lower);
    for (y = 0; y < a.length; y += 1)
      E.push(a[y].lower);
    for (u = i.length + a.length, y = 0; y < u; y += 1)
      c[y] = !1, l[y] = null;
    for (const m in s.callbacks) {
      const N = m.toLowerCase();
      if (y = E.indexOf(N), y < 0)
        throw new Error(`${n}init: node '${m}' not a rule or udt name`);
      typeof s.callbacks[m] == "function" && (c[y] = !0, l[y] = s.callbacks[m]), s.callbacks[m] === !0 && (c[y] = !0);
    }
  }, this.ruleDefined = function(g) {
    return c[g] !== !1;
  }, this.udtDefined = function(g) {
    return c[i.length + g] !== !1;
  }, this.down = function(g, k) {
    const A = d.length;
    return f.push(A), d.push({
      name: k,
      thisIndex: A,
      thatIndex: null,
      state: e.SEM_PRE,
      callbackIndex: g,
      phraseIndex: null,
      phraseLength: null,
      stack: f.length
    }), A;
  }, this.up = function(g, k, A, y) {
    const E = d.length, m = f.pop();
    return d.push({
      name: k,
      thisIndex: E,
      thatIndex: m,
      state: e.SEM_POST,
      callbackIndex: g,
      phraseIndex: A,
      phraseLength: y,
      stack: f.length
    }), d[m].thatIndex = E, d[m].phraseIndex = A, d[m].phraseLength = y, E;
  }, this.translate = function(g) {
    let k, A, y;
    for (let E = 0; E < d.length; E += 1)
      y = d[E], A = l[y.callbackIndex], y.state === e.SEM_PRE ? A !== null && (k = A(e.SEM_PRE, o, y.phraseIndex, y.phraseLength, g), k === e.SEM_SKIP && (E = y.thatIndex)) : A !== null && A(e.SEM_POST, o, y.phraseIndex, y.phraseLength, g);
  }, this.setLength = function(g) {
    d.length = g, g > 0 ? f.length = d[g - 1].stack : f.length = 0;
  }, this.getLength = function() {
    return d.length;
  };
  function h(p) {
    let g = "";
    for (let k = 0; k < p; k += 1)
      g += " ";
    return g;
  }
  this.toXml = function(g) {
    let k = t.charsToDec, A = "decimal integer character codes";
    if (typeof g == "string" && g.length >= 3) {
      const m = g.slice(0, 3).toLowerCase();
      m === "asc" ? (k = t.charsToAscii, A = "ASCII for printing characters, hex for non-printing") : m === "hex" ? (k = t.charsToHex, A = "hexadecimal integer character codes") : m === "uni" && (k = t.charsToUnicode, A = "Unicode UTF-32 integer character codes");
    }
    let y = "", E = 0;
    return y += `<?xml version="1.0" encoding="utf-8"?>
`, y += `<root nodes="${d.length / 2}" characters="${o.length}">
`, y += `<!-- input string, ${A} -->
`, y += h(E + 2), y += k(o), y += `
`, d.forEach((m) => {
      m.state === e.SEM_PRE ? (E += 1, y += h(E), y += `<node name="${m.name}" index="${m.phraseIndex}" length="${m.phraseLength}">
`, y += h(E + 2), y += k(o, m.phraseIndex, m.phraseLength), y += `
`) : (y += h(E), y += `</node><!-- name="${m.name}" -->
`, E -= 1);
    }), y += `</root>
`, y;
  }, this.phrases = function() {
    const g = {};
    let k, A;
    for (k = 0; k < d.length; k += 1)
      A = d[k], A.state === e.SEM_PRE && (Array.isArray(g[A.name]) || (g[A.name] = []), g[A.name].push({
        index: A.phraseIndex,
        length: A.phraseLength
      }));
    return g;
  };
}, V4 = function() {
  "use strict;";
  const e = "circular-buffer.js: ";
  let t = -1, n = 0;
  this.init = function(i) {
    if (typeof i != "number" || i <= 0)
      throw new Error(`${e}init: circular buffer size must an integer > 0`);
    n = Math.ceil(i), t = -1;
  }, this.increment = function() {
    return t += 1, (t + n) % n;
  }, this.maxSize = function() {
    return n;
  }, this.items = function() {
    return t + 1;
  }, this.getListIndex = function(i) {
    return t === -1 || i < 0 || i > t || t - i >= n ? -1 : (i + n) % n;
  }, this.forEach = function(i) {
    if (t !== -1) {
      if (t < n) {
        for (let a = 0; a <= t; a += 1)
          i(a, a);
        return;
      }
      for (let a = t - n + 1; a <= t; a += 1) {
        const o = (a + n) % n;
        i(o, a);
      }
    }
  };
}, SP = function() {
  const e = Fu, t = Du, n = "parser.js: ", s = this;
  let i;
  this.ast = null, this.stats = null, this.trace = null, this.callbacks = [];
  let a = null, o = null, u, c, l, f, d = 0, h = 0, p = 0, g = null, k = null, A = null, y = null, E = null, m = 0, N = 1 / 0, T = 1 / 0;
  const U = function(_, b, w) {
    const $ = `${n}evaluateRule(): `;
    if (_ >= A.length)
      throw new Error(`${$}rule index: ${_} out of range`);
    if (b >= l)
      throw new Error(`${$}phrase index: ${b} out of range`);
    const { length: Y } = a;
    a.push({
      type: e.RNM,
      index: _
    }), i(Y, b, w), a.pop();
  }, R = function(fe, _, b) {
    const w = `${n}evaluateUdt(): `;
    if (fe >= y.length)
      throw new Error(`${w}udt index: ${fe} out of range`);
    if (_ >= l)
      throw new Error(`${w}phrase index: ${_} out of range`);
    const { length: $ } = a;
    a.push({
      type: e.UDT,
      empty: y[fe].empty,
      index: fe
    }), i($, _, b), a.pop();
  }, j = function() {
    d = 0, h = 0, p = 0, m = 0, f = [
      {
        lookAround: e.LOOKAROUND_NONE,
        anchor: 0,
        charsEnd: 0,
        charsLength: 0
      }
    ], A = null, y = null, o = null, u = 0, c = 0, l = 0, g = null, k = null, E = null, a = null;
  }, D = function() {
    const fe = [], _ = function() {
      const w = {};
      A.forEach(($) => {
        $.isBkr && (w[$.lower] = null);
      }), y.length > 0 && y.forEach(($) => {
        $.isBkr && (w[$.lower] = null);
      }), fe.push(w);
    }, b = function() {
      const w = fe[fe.length - 1], $ = {};
      for (const Y in w)
        $[Y] = w[Y];
      return $;
    };
    this.push = function() {
      fe.push(b());
    }, this.pop = function($) {
      let Y = $;
      if (Y || (Y = fe.length - 1), Y < 1 || Y > fe.length)
        throw new Error(`${n}backRef.pop(): bad length: ${Y}`);
      return fe.length = Y, fe[fe.length - 1];
    }, this.length = function() {
      return fe.length;
    }, this.savePhrase = function($, Y, ce) {
      fe[fe.length - 1][$] = {
        phraseIndex: Y,
        phraseLength: ce
      };
    }, this.getPhrase = function(w) {
      return fe[fe.length - 1][w];
    }, _();
  }, O = function() {
    const _ = this;
    this.state = e.ACTIVE, this.phraseLength = 0, this.ruleIndex = 0, this.udtIndex = 0, this.lookAround = f[f.length - 1], this.uFrame = new D(), this.pFrame = new D(), this.evaluateRule = U, this.evaluateUdt = R, this.refresh = function() {
      _.state = e.ACTIVE, _.phraseLength = 0, _.lookAround = f[f.length - 1];
    };
  }, I = function() {
    return f[f.length - 1];
  }, P = function() {
    return f.length > 1;
  }, S = function() {
    return f[f.length - 1].lookAround === e.LOOKAROUND_BEHIND;
  }, B = function() {
    const fe = `${n}initializeAst(): `, _ = !0;
    for (; _; ) {
      if (s.ast === void 0) {
        s.ast = null;
        break;
      }
      if (s.ast === null)
        break;
      if (s.ast.astObject !== "astObject")
        throw new Error(`${fe}ast object not recognized`);
      break;
    }
    s.ast !== null && s.ast.init(A, y, o);
  }, C = function() {
    const fe = `${n}initializeTrace(): `, _ = !0;
    for (; _; ) {
      if (s.trace === void 0) {
        s.trace = null;
        break;
      }
      if (s.trace === null)
        break;
      if (s.trace.traceObject !== "traceObject")
        throw new Error(`${fe}trace object not recognized`);
      break;
    }
    s.trace !== null && s.trace.init(A, y, o);
  }, H = function() {
    const fe = `${n}initializeStats(): `, _ = !0;
    for (; _; ) {
      if (s.stats === void 0) {
        s.stats = null;
        break;
      }
      if (s.stats === null)
        break;
      if (s.stats.statsObject !== "statsObject")
        throw new Error(`${fe}stats object not recognized`);
      break;
    }
    s.stats !== null && s.stats.init(A, y);
  }, V = function(fe) {
    const _ = `${n}initializeGrammar(): `;
    if (!fe)
      throw new Error(`${_}grammar object undefined`);
    if (fe.grammarObject !== "grammarObject")
      throw new Error(`${_}bad grammar object`);
    A = fe.rules, y = fe.udts;
  }, J = function(fe) {
    const _ = `${n}initializeStartRule(): `;
    let b = null;
    if (typeof fe == "number") {
      if (fe >= A.length)
        throw new Error(`${_}start rule index too large: max: ${A.length}: index: ${fe}`);
      b = fe;
    } else if (typeof fe == "string") {
      const w = fe.toLowerCase();
      for (let $ = 0; $ < A.length; $ += 1)
        if (w === A[$].lower) {
          b = A[$].index;
          break;
        }
      if (b === null)
        throw new Error(`${_}start rule name '${fe}' not recognized`);
    } else
      throw new Error(`${_}type of start rule '${typeof fe}' not recognized`);
    return b;
  }, M = function(_, b, w) {
    const $ = `${n}initializeInputChars(): `;
    let Y = _, ce = b, xe = w;
    if (Y === void 0)
      throw new Error(`${$}input string is undefined`);
    if (Y === null)
      throw new Error(`${$}input string is null`);
    if (typeof Y == "string")
      Y = t.stringToChars(Y);
    else if (!Array.isArray(Y))
      throw new Error(`${$}input string is not a string or array`);
    if (Y.length > 0 && typeof Y[0] != "number")
      throw new Error(`${$}input string not an array of integers`);
    if (typeof ce != "number")
      ce = 0;
    else if (ce = Math.floor(ce), ce < 0 || ce > Y.length)
      throw new Error(`${$}input beginning index out of range: ${ce}`);
    if (typeof xe != "number")
      xe = Y.length - ce;
    else if (xe = Math.floor(xe), xe < 0 || xe > Y.length - ce)
      throw new Error(`${$}input length out of range: ${xe}`);
    o = Y, u = ce, c = xe, l = u + c;
  }, G = function() {
    const fe = `${n}initializeCallbacks(): `;
    let _;
    for (g = [], k = [], _ = 0; _ < A.length; _ += 1)
      g[_] = null;
    for (_ = 0; _ < y.length; _ += 1)
      k[_] = null;
    let b;
    const w = [];
    for (_ = 0; _ < A.length; _ += 1)
      w.push(A[_].lower);
    for (_ = 0; _ < y.length; _ += 1)
      w.push(y[_].lower);
    for (const $ in s.callbacks) {
      if (_ = w.indexOf($.toLowerCase()), _ < 0)
        throw new Error(`${fe}syntax callback '${$}' not a rule or udt name`);
      if (b = s.callbacks[$], b || (b = null), typeof b == "function" || b === null)
        _ < A.length ? g[_] = b : k[_ - A.length] = b;
      else
        throw new Error(
          `${fe}syntax callback[${$}] must be function reference or 'false' (false/null/undefined/etc.)`
        );
    }
    for (_ = 0; _ < y.length; _ += 1)
      if (k[_] === null)
        throw new Error(
          `${fe}all UDT callbacks must be defined. UDT callback[${y[_].lower}] not a function reference`
        );
  };
  this.setMaxTreeDepth = function(fe) {
    if (typeof fe != "number")
      throw new Error(`parser: max tree depth must be integer > 0: ${fe}`);
    if (N = Math.floor(fe), N <= 0)
      throw new Error(`parser: max tree depth must be integer > 0: ${fe}`);
  }, this.setMaxNodeHits = function(fe) {
    if (typeof fe != "number")
      throw new Error(`parser: max node hits must be integer > 0: ${fe}`);
    if (T = Math.floor(fe), T <= 0)
      throw new Error(`parser: max node hits must be integer > 0: ${fe}`);
  };
  const K = function(fe, _, b) {
    let w;
    const $ = `${n}parse(): `;
    V(fe);
    const Y = J(_);
    G(), C(), H(), B();
    const ce = new O();
    switch (b != null && (E = b), a = [
      {
        type: e.RNM,
        index: Y
      }
    ], i(0, u, ce), a = null, ce.state) {
      case e.ACTIVE:
        throw new Error(`${$}final state should never be 'ACTIVE'`);
      case e.NOMATCH:
        w = !1;
        break;
      case e.EMPTY:
      case e.MATCH:
        ce.phraseLength === c ? w = !0 : w = !1;
        break;
      default:
        throw new Error("unrecognized state");
    }
    return {
      success: w,
      state: ce.state,
      length: c,
      matched: ce.phraseLength,
      maxMatched: m,
      maxTreeDepth: h,
      nodeHits: p,
      inputLength: o.length,
      subBegin: u,
      subEnd: l,
      subLength: c
    };
  };
  this.parseSubstring = function(_, b, w, $, Y, ce) {
    return j(), M(w, $, Y), K(_, b, ce);
  }, this.parse = function(_, b, w, $) {
    return j(), M(w, 0, w.length), K(_, b, $);
  };
  const X = function(fe, _, b) {
    const w = a[fe];
    for (let $ = 0; $ < w.children.length && (i(w.children[$], _, b), b.state === e.NOMATCH); $ += 1)
      ;
  }, te = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe], Ie = b.uFrame.length(), He = b.pFrame.length();
    s.ast && ($ = s.ast.getLength()), w = !0, Y = _, ce = 0;
    for (let Ue = 0; Ue < xe.children.length; Ue += 1)
      if (i(xe.children[Ue], Y, b), b.state === e.NOMATCH) {
        w = !1;
        break;
      } else
        Y += b.phraseLength, ce += b.phraseLength;
    w ? (b.state = ce === 0 ? e.EMPTY : e.MATCH, b.phraseLength = ce) : (b.state = e.NOMATCH, b.phraseLength = 0, b.uFrame.pop(Ie), b.pFrame.pop(He), s.ast && s.ast.setLength($));
  }, pe = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe];
    if (xe.max === 0) {
      b.state = e.EMPTY, b.phraseLength = 0;
      return;
    }
    $ = _, Y = 0, ce = 0;
    const Ie = b.uFrame.length(), He = b.pFrame.length();
    s.ast && (w = s.ast.getLength());
    const Ue = !0;
    for (; Ue && !($ >= l || (i(fe + 1, $, b), b.state === e.NOMATCH) || b.state === e.EMPTY || (ce += 1, Y += b.phraseLength, $ += b.phraseLength, ce === xe.max)); )
      ;
    b.state === e.EMPTY || ce >= xe.min ? (b.state = Y === 0 ? e.EMPTY : e.MATCH, b.phraseLength = Y) : (b.state = e.NOMATCH, b.phraseLength = 0, b.uFrame.pop(Ie), b.pFrame.pop(He), s.ast && s.ast.setLength(w));
  }, he = function(fe, _, b, w) {
    if (_.phraseLength > b) {
      let $ = `${n}opRNM(${fe.name}): callback function error: `;
      throw $ += `sysData.phraseLength: ${_.phraseLength}`, $ += ` must be <= remaining chars: ${b}`, new Error($);
    }
    switch (_.state) {
      case e.ACTIVE:
        if (w !== !0)
          throw new Error(
            `${n}opRNM(${fe.name}): callback function return error. ACTIVE state not allowed.`
          );
        break;
      case e.EMPTY:
        _.phraseLength = 0;
        break;
      case e.MATCH:
        _.phraseLength === 0 && (_.state = e.EMPTY);
        break;
      case e.NOMATCH:
        _.phraseLength = 0;
        break;
      default:
        throw new Error(
          `${n}opRNM(${fe.name}): callback function return error. Unrecognized return state: ${_.state}`
        );
    }
  }, ye = function(fe, _, b) {
    let w, $, Y, ce, xe, Ie;
    const He = a[fe], Ue = A[He.index], je = g[Ue.index], Je = !P();
    if (Je && ($ = s.ast && s.ast.ruleDefined(He.index), $ && (w = s.ast.getLength(), s.ast.down(He.index, A[He.index].name)), ce = b.uFrame.length(), xe = b.pFrame.length(), b.uFrame.push(), b.pFrame.push(), Ie = b.pFrame, b.pFrame = new D()), je === null)
      Y = a, a = Ue.opcodes, i(0, _, b), a = Y;
    else {
      const xr = l - _;
      b.ruleIndex = Ue.index, je(b, o, _, E), he(Ue, b, xr, !0), b.state === e.ACTIVE && (Y = a, a = Ue.opcodes, i(0, _, b), a = Y, b.ruleIndex = Ue.index, je(b, o, _, E), he(Ue, b, xr, !1));
    }
    Je && ($ && (b.state === e.NOMATCH ? s.ast.setLength(w) : s.ast.up(He.index, Ue.name, _, b.phraseLength)), b.pFrame = Ie, b.state === e.NOMATCH ? (b.uFrame.pop(ce), b.pFrame.pop(xe)) : Ue.isBkr && (b.pFrame.savePhrase(Ue.lower, _, b.phraseLength), b.uFrame.savePhrase(Ue.lower, _, b.phraseLength)));
  }, re = function(fe, _, b) {
    if (_.phraseLength > b) {
      let w = `${n}opUDT(${fe.name}): callback function error: `;
      throw w += `sysData.phraseLength: ${_.phraseLength}`, w += ` must be <= remaining chars: ${b}`, new Error(w);
    }
    switch (_.state) {
      case e.ACTIVE:
        throw new Error(`${n}opUDT(${fe.name}): callback function return error. ACTIVE state not allowed.`);
      case e.EMPTY:
        if (fe.empty === !1)
          throw new Error(`${n}opUDT(${fe.name}): callback function return error. May not return EMPTY.`);
        _.phraseLength = 0;
        break;
      case e.MATCH:
        if (_.phraseLength === 0) {
          if (fe.empty === !1)
            throw new Error(`${n}opUDT(${fe.name}): callback function return error. May not return EMPTY.`);
          _.state = e.EMPTY;
        }
        break;
      case e.NOMATCH:
        _.phraseLength = 0;
        break;
      default:
        throw new Error(
          `${n}opUDT(${fe.name}): callback function return error. Unrecognized return state: ${_.state}`
        );
    }
  }, ae = function(fe, _, b) {
    let w, $, Y, ce, xe, Ie;
    const He = a[fe], Ue = y[He.index];
    b.UdtIndex = Ue.index;
    const je = !P();
    je && (Y = s.ast && s.ast.udtDefined(He.index), Y && ($ = A.length + He.index, w = s.ast.getLength(), s.ast.down($, Ue.name)), ce = b.uFrame.length(), xe = b.pFrame.length(), b.uFrame.push(), b.pFrame.push(), Ie = b.pFrame, b.pFrame = new D());
    const Je = l - _;
    k[He.index](b, o, _, E), re(Ue, b, Je), je && (Y && (b.state === e.NOMATCH ? s.ast.setLength(w) : s.ast.up($, Ue.name, _, b.phraseLength)), b.pFrame = Ie, b.state === e.NOMATCH ? (b.uFrame.pop(ce), b.pFrame.pop(xe)) : Ue.isBkr && (b.pFrame.savePhrase(Ue.lower, _, b.phraseLength), b.uFrame.savePhrase(Ue.lower, _, b.phraseLength)));
  }, L = function(fe, _, b) {
    f.push({
      lookAround: e.LOOKAROUND_AHEAD,
      anchor: _,
      charsEnd: l,
      charsLength: c
    }), l = o.length, c = o.length - u, i(fe + 1, _, b);
    const w = f.pop();
    switch (l = w.charsEnd, c = w.charsLength, b.phraseLength = 0, b.state) {
      case e.EMPTY:
        b.state = e.EMPTY;
        break;
      case e.MATCH:
        b.state = e.EMPTY;
        break;
      case e.NOMATCH:
        b.state = e.NOMATCH;
        break;
      default:
        throw new Error(`opAND: invalid state ${b.state}`);
    }
  }, ne = function(fe, _, b) {
    f.push({
      lookAround: e.LOOKAROUND_AHEAD,
      anchor: _,
      charsEnd: l,
      charsLength: c
    }), l = o.length, c = o.length - u, i(fe + 1, _, b);
    const w = f.pop();
    switch (l = w.charsEnd, c = w.charsLength, b.phraseLength = 0, b.state) {
      case e.EMPTY:
      case e.MATCH:
        b.state = e.NOMATCH;
        break;
      case e.NOMATCH:
        b.state = e.EMPTY;
        break;
      default:
        throw new Error(`opNOT: invalid state ${b.state}`);
    }
  }, oe = function(fe, _, b) {
    const w = a[fe];
    b.state = e.NOMATCH, _ < l && w.min <= o[_] && o[_] <= w.max && (b.state = e.MATCH, b.phraseLength = 1);
  }, ee = function(fe, _, b) {
    let w;
    const $ = a[fe], Y = $.string.length;
    if (b.state = e.NOMATCH, _ + Y <= l) {
      for (w = 0; w < Y; w += 1)
        if (o[_ + w] !== $.string[w])
          return;
      b.state = e.MATCH, b.phraseLength = Y;
    }
  }, W = function(fe, _, b) {
    let w, $;
    const Y = a[fe];
    b.state = e.NOMATCH;
    const ce = Y.string.length;
    if (ce === 0) {
      b.state = e.EMPTY;
      return;
    }
    if (_ + ce <= l) {
      for (w = 0; w < ce; w += 1)
        if ($ = o[_ + w], $ >= 65 && $ <= 90 && ($ += 32), $ !== Y.string[w])
          return;
      b.state = e.MATCH, b.phraseLength = ce;
    }
  }, v = function(fe, _, b) {
    b.state = e.NOMATCH, b.phraseLength = 0, b.state = _ === 0 ? e.EMPTY : e.NOMATCH;
  }, z = function(fe, _, b) {
    b.state = e.NOMATCH, b.phraseLength = 0, b.state = _ === o.length ? e.EMPTY : e.NOMATCH;
  }, q = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe];
    b.state = e.NOMATCH, xe.index < A.length ? ce = A[xe.index].lower : ce = y[xe.index - A.length].lower;
    const Ie = xe.bkrMode === e.BKR_MODE_PM ? b.pFrame.getPhrase(ce) : b.uFrame.getPhrase(ce), He = xe.bkrCase === e.BKR_MODE_CI;
    if (Ie === null)
      return;
    const Ue = Ie.phraseIndex, je = Ie.phraseLength;
    if (je === 0) {
      b.state = e.EMPTY;
      return;
    }
    if (_ + je <= l) {
      if (He) {
        for (w = 0; w < je; w += 1)
          if ($ = o[_ + w], Y = o[Ue + w], $ >= 65 && $ <= 90 && ($ += 32), Y >= 65 && Y <= 90 && (Y += 32), $ !== Y)
            return;
        b.state = e.MATCH, b.phraseLength = je;
      } else
        for (w = 0; w < je; w += 1)
          if ($ = o[_ + w], Y = o[Ue + w], $ !== Y)
            return;
      b.state = e.MATCH, b.phraseLength = je;
    }
  }, le = function(fe, _, b) {
    switch (f.push({
      lookAround: e.LOOKAROUND_BEHIND,
      anchor: _
    }), i(fe + 1, _, b), f.pop(), b.phraseLength = 0, b.state) {
      case e.EMPTY:
        b.state = e.EMPTY;
        break;
      case e.MATCH:
        b.state = e.EMPTY;
        break;
      case e.NOMATCH:
        b.state = e.NOMATCH;
        break;
      default:
        throw new Error(`opBKA: invalid state ${b.state}`);
    }
  }, be = function(fe, _, b) {
    switch (f.push({
      lookAround: e.LOOKAROUND_BEHIND,
      anchor: _
    }), i(fe + 1, _, b), f.pop(), b.phraseLength = 0, b.state) {
      case e.EMPTY:
      case e.MATCH:
        b.state = e.NOMATCH;
        break;
      case e.NOMATCH:
        b.state = e.EMPTY;
        break;
      default:
        throw new Error(`opBKN: invalid state ${b.state}`);
    }
  }, ve = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe], Ie = b.uFrame.length(), He = b.pFrame.length();
    s.ast && ($ = s.ast.getLength()), w = !0, Y = _, ce = 0;
    for (let Ue = xe.children.length - 1; Ue >= 0; Ue -= 1)
      if (i(xe.children[Ue], Y, b), Y -= b.phraseLength, ce += b.phraseLength, b.state === e.NOMATCH) {
        w = !1;
        break;
      }
    w ? (b.state = ce === 0 ? e.EMPTY : e.MATCH, b.phraseLength = ce) : (b.state = e.NOMATCH, b.phraseLength = 0, b.uFrame.pop(Ie), b.pFrame.pop(He), s.ast && s.ast.setLength($));
  }, Be = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe];
    $ = _, Y = 0, ce = 0;
    const Ie = b.uFrame.length(), He = b.pFrame.length();
    s.ast && (w = s.ast.getLength());
    const Ue = !0;
    for (; Ue && !($ <= 0 || (i(fe + 1, $, b), b.state === e.NOMATCH) || b.state === e.EMPTY || (ce += 1, Y += b.phraseLength, $ -= b.phraseLength, ce === xe.max)); )
      ;
    b.state === e.EMPTY || ce >= xe.min ? (b.state = Y === 0 ? e.EMPTY : e.MATCH, b.phraseLength = Y) : (b.state = e.NOMATCH, b.phraseLength = 0, b.uFrame.pop(Ie), b.pFrame.pop(He), s.ast && s.ast.setLength(w));
  }, Ae = function(fe, _, b) {
    const w = a[fe];
    if (b.state = e.NOMATCH, b.phraseLength = 0, _ > 0) {
      const $ = o[_ - 1];
      w.min <= $ && $ <= w.max && (b.state = e.MATCH, b.phraseLength = 1);
    }
  }, ie = function(fe, _, b) {
    let w;
    const $ = a[fe];
    b.state = e.NOMATCH;
    const Y = $.string.length, ce = _ - Y;
    if (ce >= 0) {
      for (w = 0; w < Y; w += 1)
        if (o[ce + w] !== $.string[w])
          return;
      b.state = e.MATCH, b.phraseLength = Y;
    }
  }, se = function(fe, _, b) {
    let w;
    const $ = a[fe];
    b.state = e.NOMATCH;
    const Y = $.string.length;
    if (Y === 0) {
      b.state = e.EMPTY;
      return;
    }
    const ce = _ - Y;
    if (ce >= 0) {
      for (let xe = 0; xe < Y; xe += 1)
        if (w = o[ce + xe], w >= 65 && w <= 90 && (w += 32), w !== $.string[xe])
          return;
      b.state = e.MATCH, b.phraseLength = Y;
    }
  }, me = function(fe, _, b) {
    let w, $, Y, ce;
    const xe = a[fe];
    b.state = e.NOMATCH, b.phraseLength = 0, xe.index < A.length ? ce = A[xe.index].lower : ce = y[xe.index - A.length].lower;
    const Ie = xe.bkrMode === e.BKR_MODE_PM ? b.pFrame.getPhrase(ce) : b.uFrame.getPhrase(ce), He = xe.bkrCase === e.BKR_MODE_CI;
    if (Ie === null)
      return;
    const Ue = Ie.phraseIndex, je = Ie.phraseLength;
    if (je === 0) {
      b.state = e.EMPTY, b.phraseLength = 0;
      return;
    }
    const Je = _ - je;
    if (Je >= 0) {
      if (He) {
        for (w = 0; w < je; w += 1)
          if ($ = o[Je + w], Y = o[Ue + w], $ >= 65 && $ <= 90 && ($ += 32), Y >= 65 && Y <= 90 && (Y += 32), $ !== Y)
            return;
        b.state = e.MATCH, b.phraseLength = je;
      } else
        for (w = 0; w < je; w += 1)
          if ($ = o[Je + w], Y = o[Ue + w], $ !== Y)
            return;
      b.state = e.MATCH, b.phraseLength = je;
    }
  };
  i = function(_, b, w) {
    let $ = !0;
    const Y = a[_];
    if (p += 1, p > T)
      throw new Error(`parser: maximum number of node hits exceeded: ${T}`);
    if (d += 1, d > h && (h = d, h > N))
      throw new Error(`parser: maximum parse tree depth exceeded: ${N}`);
    if (w.refresh(), s.trace !== null) {
      const ce = I();
      s.trace.down(Y, w.state, b, w.phraseLength, ce.anchor, ce.lookAround);
    }
    if (S())
      switch (Y.type) {
        case e.ALT:
          X(_, b, w);
          break;
        case e.CAT:
          ve(_, b, w);
          break;
        case e.REP:
          Be(_, b, w);
          break;
        case e.RNM:
          ye(_, b, w);
          break;
        case e.UDT:
          ae(_, b, w);
          break;
        case e.AND:
          L(_, b, w);
          break;
        case e.NOT:
          ne(_, b, w);
          break;
        case e.TRG:
          Ae(_, b, w);
          break;
        case e.TBS:
          ie(_, b, w);
          break;
        case e.TLS:
          se(_, b, w);
          break;
        case e.BKR:
          me(_, b, w);
          break;
        case e.BKA:
          le(_, b, w);
          break;
        case e.BKN:
          be(_, b, w);
          break;
        case e.ABG:
          v(_, b, w);
          break;
        case e.AEN:
          z(_, b, w);
          break;
        default:
          $ = !1;
          break;
      }
    else
      switch (Y.type) {
        case e.ALT:
          X(_, b, w);
          break;
        case e.CAT:
          te(_, b, w);
          break;
        case e.REP:
          pe(_, b, w);
          break;
        case e.RNM:
          ye(_, b, w);
          break;
        case e.UDT:
          ae(_, b, w);
          break;
        case e.AND:
          L(_, b, w);
          break;
        case e.NOT:
          ne(_, b, w);
          break;
        case e.TRG:
          oe(_, b, w);
          break;
        case e.TBS:
          ee(_, b, w);
          break;
        case e.TLS:
          W(_, b, w);
          break;
        case e.BKR:
          q(_, b, w);
          break;
        case e.BKA:
          le(_, b, w);
          break;
        case e.BKN:
          be(_, b, w);
          break;
        case e.ABG:
          v(_, b, w);
          break;
        case e.AEN:
          z(_, b, w);
          break;
        default:
          $ = !1;
          break;
      }
    if (!P() && b + w.phraseLength > m && (m = b + w.phraseLength), s.stats !== null && s.stats.collect(Y, w), s.trace !== null) {
      const ce = I();
      s.trace.up(Y, w.state, b, w.phraseLength, ce.anchor, ce.lookAround);
    }
    return d -= 1, $;
  };
}, CP = function() {
  const e = Fu, t = Du, n = xh, s = "stats.js: ";
  let i = [], a = [];
  const o = [];
  let u;
  const c = [], l = [];
  this.statsObject = "statsObject";
  const f = "stats", d = function(T, U) {
    return T.lower < U.lower ? -1 : T.lower > U.lower ? 1 : 0;
  }, h = function(T, U) {
    return T.total < U.total ? 1 : T.total > U.total ? -1 : d(T, U);
  }, p = function(T, U) {
    return T.index < U.index ? -1 : T.index > U.index ? 1 : 0;
  }, g = function() {
    this.empty = 0, this.match = 0, this.nomatch = 0, this.total = 0;
  }, k = function() {
    o.length = 0, u = new g(), o[e.ALT] = new g(), o[e.CAT] = new g(), o[e.REP] = new g(), o[e.RNM] = new g(), o[e.TRG] = new g(), o[e.TBS] = new g(), o[e.TLS] = new g(), o[e.UDT] = new g(), o[e.AND] = new g(), o[e.NOT] = new g(), o[e.BKR] = new g(), o[e.BKA] = new g(), o[e.BKN] = new g(), o[e.ABG] = new g(), o[e.AEN] = new g(), c.length = 0;
    for (let T = 0; T < i.length; T += 1)
      c.push({
        empty: 0,
        match: 0,
        nomatch: 0,
        total: 0,
        name: i[T].name,
        lower: i[T].lower,
        index: i[T].index
      });
    if (a.length > 0) {
      l.length = 0;
      for (let T = 0; T < a.length; T += 1)
        l.push({
          empty: 0,
          match: 0,
          nomatch: 0,
          total: 0,
          name: a[T].name,
          lower: a[T].lower,
          index: a[T].index
        });
    }
  }, A = function(T, U) {
    switch (T.total += 1, U) {
      case e.EMPTY:
        T.empty += 1;
        break;
      case e.MATCH:
        T.match += 1;
        break;
      case e.NOMATCH:
        T.nomatch += 1;
        break;
      default:
        throw new Error(`${s}collect(): incStat(): unrecognized state: ${U}`);
    }
  }, y = function(T, U) {
    let R = "";
    return R += "<tr>", R += `<td class="${n.CLASS_ACTIVE}">${T}</td>`, R += `<td class="${n.CLASS_EMPTY}">${U.empty}</td>`, R += `<td class="${n.CLASS_MATCH}">${U.match}</td>`, R += `<td class="${n.CLASS_NOMATCH}">${U.nomatch}</td>`, R += `<td class="${n.CLASS_ACTIVE}">${U.total}</td>`, R += `</tr>
`, R;
  }, E = function() {
    let T = "";
    return T += y("ALT", o[e.ALT]), T += y("CAT", o[e.CAT]), T += y("REP", o[e.REP]), T += y("RNM", o[e.RNM]), T += y("TRG", o[e.TRG]), T += y("TBS", o[e.TBS]), T += y("TLS", o[e.TLS]), T += y("UDT", o[e.UDT]), T += y("AND", o[e.AND]), T += y("NOT", o[e.NOT]), T += y("BKR", o[e.BKR]), T += y("BKA", o[e.BKA]), T += y("BKN", o[e.BKN]), T += y("ABG", o[e.ABG]), T += y("AEN", o[e.AEN]), T += y("totals", u), T;
  }, m = function() {
    let T = "";
    T += `<tr><th></th><th></th><th></th><th></th><th></th></tr>
`, T += `<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>
`;
    for (let U = 0; U < i.length; U += 1)
      c[U].total > 0 && (T += "<tr>", T += `<td class="${n.CLASS_ACTIVE}">${c[U].name}</td>`, T += `<td class="${n.CLASS_EMPTY}">${c[U].empty}</td>`, T += `<td class="${n.CLASS_MATCH}">${c[U].match}</td>`, T += `<td class="${n.CLASS_NOMATCH}">${c[U].nomatch}</td>`, T += `<td class="${n.CLASS_ACTIVE}">${c[U].total}</td>`, T += `</tr>
`);
    if (a.length > 0) {
      T += `<tr><th></th><th></th><th></th><th></th><th></th></tr>
`, T += `<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>
`;
      for (let U = 0; U < a.length; U += 1)
        l[U].total > 0 && (T += "<tr>", T += `<td class="${n.CLASS_ACTIVE}">${l[U].name}</td>`, T += `<td class="${n.CLASS_EMPTY}">${l[U].empty}</td>`, T += `<td class="${n.CLASS_MATCH}">${l[U].match}</td>`, T += `<td class="${n.CLASS_NOMATCH}">${l[U].nomatch}</td>`, T += `<td class="${n.CLASS_ACTIVE}">${l[U].total}</td>`, T += `</tr>
`);
    }
    return T;
  };
  this.validate = function(T) {
    let U = !1;
    return typeof T == "string" && f === T && (U = !0), U;
  }, this.init = function(T, U) {
    i = T, a = U, k();
  }, this.collect = function(T, U) {
    A(u, U.state, U.phraseLength), A(o[T.type], U.state, U.phraseLength), T.type === e.RNM && A(c[T.index], U.state, U.phraseLength), T.type === e.UDT && A(l[T.index], U.state, U.phraseLength);
  }, this.toHtml = function(T, U) {
    let R = "";
    R += `<table class="${n.CLASS_STATS}">
`, typeof U == "string" && (R += `<caption>${U}</caption>
`), R += `<tr><th class="${n.CLASS_ACTIVE}">ops</th>
`, R += `<th class="${n.CLASS_EMPTY}">EMPTY</th>
`, R += `<th class="${n.CLASS_MATCH}">MATCH</th>
`, R += `<th class="${n.CLASS_NOMATCH}">NOMATCH</th>
`, R += `<th class="${n.CLASS_ACTIVE}">totals</th></tr>
`;
    const j = !0;
    for (; j; ) {
      if (T === void 0) {
        R += E();
        break;
      }
      if (T === null) {
        R += E();
        break;
      }
      if (T === "ops") {
        R += E();
        break;
      }
      if (T === "index") {
        c.sort(p), l.length > 0 && l.sort(p), R += E(), R += m();
        break;
      }
      if (T === "hits") {
        c.sort(h), l.length > 0 && l.sort(p), R += E(), R += m();
        break;
      }
      if (T === "alpha") {
        c.sort(d), l.length > 0 && l.sort(d), R += E(), R += m();
        break;
      }
      break;
    }
    return R += `</table>
`, R;
  }, this.toHtmlPage = function(T, U, R) {
    return t.htmlToPage(this.toHtml(T, U), R);
  };
}, RP = function() {
  const e = Du, t = xh, n = new V4(), s = Fu, i = "trace.js: ", a = this, o = 16, u = 10, c = 8, l = 32, f = 80, d = 5, h = [];
  let p = 5e3, g = -1, k = 0, A = 0;
  const y = [];
  let E = null, m = null, N = null;
  const T = [], U = [], R = `<span class="${t.CLASS_LINEEND}">&bull;</span>`, j = `<span class="${t.CLASS_LINEEND}">&hellip;</span>`, D = `<span class="${t.CLASS_EMPTY}">&#120634;</span>`, O = function() {
    const re = function(L) {
      T[s.ALT] = L, T[s.CAT] = L, T[s.REP] = L, T[s.TLS] = L, T[s.TBS] = L, T[s.TRG] = L, T[s.AND] = L, T[s.NOT] = L, T[s.BKR] = L, T[s.BKA] = L, T[s.BKN] = L, T[s.ABG] = L, T[s.AEN] = L;
    };
    let ae = 0;
    for (const L in a.filter.operators)
      ae += 1;
    if (ae === 0) {
      re(!1);
      return;
    }
    for (const L in a.filter.operators) {
      const ne = L.toUpperCase();
      if (ne === "<ALL>") {
        re(!0);
        return;
      }
      if (ne === "<NONE>") {
        re(!1);
        return;
      }
    }
    re(!1);
    for (const L in a.filter.operators) {
      const ne = L.toUpperCase();
      if (ne === "ALT")
        T[s.ALT] = a.filter.operators[L] === !0;
      else if (ne === "CAT")
        T[s.CAT] = a.filter.operators[L] === !0;
      else if (ne === "REP")
        T[s.REP] = a.filter.operators[L] === !0;
      else if (ne === "AND")
        T[s.AND] = a.filter.operators[L] === !0;
      else if (ne === "NOT")
        T[s.NOT] = a.filter.operators[L] === !0;
      else if (ne === "TLS")
        T[s.TLS] = a.filter.operators[L] === !0;
      else if (ne === "TBS")
        T[s.TBS] = a.filter.operators[L] === !0;
      else if (ne === "TRG")
        T[s.TRG] = a.filter.operators[L] === !0;
      else if (ne === "BKR")
        T[s.BKR] = a.filter.operators[L] === !0;
      else if (ne === "BKA")
        T[s.BKA] = a.filter.operators[L] === !0;
      else if (ne === "BKN")
        T[s.BKN] = a.filter.operators[L] === !0;
      else if (ne === "ABG")
        T[s.ABG] = a.filter.operators[L] === !0;
      else if (ne === "AEN")
        T[s.AEN] = a.filter.operators[L] === !0;
      else
        throw new Error(
          `${i}initOpratorFilter: '${L}' not a valid operator name. Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn`
        );
    }
  }, I = function() {
    const re = function(oe) {
      T[s.RNM] = oe, T[s.UDT] = oe;
      const ee = m.length + N.length;
      U.length = 0;
      for (let W = 0; W < ee; W += 1)
        U.push(oe);
    };
    let ae, L;
    const ne = [];
    for (L = 0; L < m.length; L += 1)
      ne.push(m[L].lower);
    for (L = 0; L < N.length; L += 1)
      ne.push(N[L].lower);
    U.length = 0, ae = 0;
    for (const oe in a.filter.rules)
      ae += 1;
    if (ae === 0) {
      re(!0);
      return;
    }
    for (const oe in a.filter.rules) {
      const ee = oe.toLowerCase();
      if (ee === "<all>") {
        re(!0);
        return;
      }
      if (ee === "<none>") {
        re(!1);
        return;
      }
    }
    re(!1), T[s.RNM] = !0, T[s.UDT] = !0;
    for (const oe in a.filter.rules) {
      const ee = oe.toLowerCase();
      if (L = ne.indexOf(ee), L < 0)
        throw new Error(`${i}initRuleFilter: '${oe}' not a valid rule or udt name`);
      U[L] = a.filter.rules[oe] === !0;
    }
  };
  this.traceObject = "traceObject", this.filter = {
    operators: [],
    rules: []
  }, this.setMaxRecords = function(re, ae) {
    if (g = -1, typeof re == "number" && re > 0)
      p = Math.ceil(re);
    else {
      p = 0;
      return;
    }
    typeof ae == "number" && (g = Math.floor(ae), g < 0 && (g = -1));
  }, this.getMaxRecords = function() {
    return p;
  }, this.getLastRecord = function() {
    return g;
  }, this.init = function(re, ae, L) {
    h.length = 0, y.length = 0, k = 0, A = 0, E = L, m = re, N = ae, O(), I(), n.init(p);
  };
  const P = function(re) {
    let ae = !1;
    return re.type === s.RNM ? T[re.type] && U[re.index] ? ae = !0 : ae = !1 : re.type === s.UDT ? T[re.type] && U[m.length + re.index] ? ae = !0 : ae = !1 : ae = T[re.type], ae;
  }, S = function(re) {
    return g === -1 || re <= g;
  };
  this.down = function(re, ae, L, ne, oe, ee) {
    S(k) && P(re) && (y.push(k), h[n.increment()] = {
      dirUp: !1,
      depth: A,
      thisLine: k,
      thatLine: void 0,
      opcode: re,
      state: ae,
      phraseIndex: L,
      phraseLength: ne,
      lookAnchor: oe,
      lookAround: ee
    }, k += 1, A += 1);
  }, this.up = function(re, ae, L, ne, oe, ee) {
    if (S(k) && P(re)) {
      const W = k, v = y.pop(), z = n.getListIndex(v);
      z !== -1 && (h[z].thatLine = W), A -= 1, h[n.increment()] = {
        dirUp: !0,
        depth: A,
        thisLine: W,
        thatLine: v,
        opcode: re,
        state: ae,
        phraseIndex: L,
        phraseLength: ne,
        lookAnchor: oe,
        lookAround: ee
      }, k += 1;
    }
  };
  const B = function() {
    function re(b, w) {
      let $, Y, ce;
      if (w)
        switch (b.op = { id: w.type, name: e.opcodeToString(w.type) }, b.opData = void 0, w.type) {
          case s.RNM:
            b.opData = m[w.index].name;
            break;
          case s.UDT:
            b.opData = N[w.index].name;
            break;
          case s.BKR:
            w.index < m.length ? $ = m[w.index].name : $ = N[w.index - m.length].name, Y = w.bkrCase === s.BKR_MODE_CI ? "%i" : "%s", ce = w.bkrMode === s.BKR_MODE_UM ? "%u" : "%p", b.opData = `\\\\${Y}${ce}${$}`;
            break;
          case s.TLS:
            b.opData = [];
            for (let xe = 0; xe < w.string.length; xe += 1)
              b.opData.push(w.string[xe]);
            break;
          case s.TBS:
            b.opData = [];
            for (let xe = 0; xe < w.string.length; xe += 1)
              b.opData.push(w.string[xe]);
            break;
          case s.TRG:
            b.opData = [w.min, w.max];
            break;
          case s.REP:
            b.opData = [w.min, w.max];
            break;
          default:
            throw new Error("unrecognized opcode");
        }
      else
        b.op = { id: void 0, name: void 0 }, b.opData = void 0;
    }
    function ae(b, w, $) {
      return b === s.MATCH ? {
        index: w,
        length: $
      } : b === s.NOMATCH ? {
        index: w,
        length: 0
      } : b === s.EMPTY ? {
        index: w,
        length: 0
      } : null;
    }
    let L = -1;
    function ne(b, w, $) {
      const Y = {
        // eslint-disable-next-line no-plusplus
        id: L++,
        branch: -1,
        parent: b,
        up: !1,
        down: !1,
        depth: $,
        children: []
      };
      return w ? (Y.down = !0, Y.state = { id: w.state, name: e.stateToString(w.state) }, Y.phrase = null, re(Y, w.opcode)) : (Y.state = { id: void 0, name: void 0 }, Y.phrase = ae(), re(Y, void 0)), Y;
    }
    function oe(b, w) {
      w && (b.up = !0, b.state = { id: w.state, name: e.stateToString(w.state) }, b.phrase = ae(w.state, w.phraseIndex, w.phraseLength), b.down || re(b, w.opcode));
    }
    let ee = 0, W = -1, v = 1;
    function z(b) {
      if (W += 1, b.branch = v, W > A && (A = W), b.children.length === 0)
        ee += 1;
      else
        for (let w = 0; w < b.children.length; w += 1)
          w > 0 && (v += 1), b.children[w].leftMost = !1, b.children[w].rightMost = !1, b.leftMost && (b.children[w].leftMost = w === 0), b.rightMost && (b.children[w].rightMost = w === b.children.length - 1), z(b.children[w]);
      W -= 1;
    }
    function q(b, w) {
      let $;
      const Y = {};
      if (Y.id = b.id, Y.branch = b.branch, Y.leftMost = b.leftMost, Y.rightMost = b.rightMost, $ = b.state.name ? b.state.name : "ACTIVE", Y.state = { id: b.state.id, name: $ }, $ = b.op.name ? b.op.name : "?", Y.op = { id: b.op.id, name: $ }, typeof b.opData == "string")
        Y.opData = b.opData;
      else if (Array.isArray(b.opData)) {
        Y.opData = [];
        for (let ce = 0; ce < b.opData.length; ce += 1)
          Y.opData[ce] = b.opData[ce];
      } else
        Y.opData = void 0;
      b.phrase ? Y.phrase = { index: b.phrase.index, length: b.phrase.length } : Y.phrase = null, Y.depth = b.depth, Y.children = [];
      for (let ce = 0; ce < b.children.length; ce += 1)
        b.children.length - 1, Y.children[ce] = q(b.children[ce]);
      return Y;
    }
    const le = [];
    let be, ve, Be, Ae, ie = !0;
    const se = ne(null, null, -1);
    for (le.push(se), ve = se, n.forEach((b) => {
      if (Ae = h[b], ie && (ie = !1, Ae.depth > 0)) {
        const w = Ae.dirUp ? Ae.depth + 1 : Ae.depth;
        for (let $ = 0; $ < w; $ += 1)
          Be = ve, ve = ne(ve, null, $), le.push(ve), Be.children.push(ve);
      }
      Ae.dirUp ? (ve = le.pop(), oe(ve, Ae), ve = le[le.length - 1]) : (Be = ve, ve = ne(ve, Ae, Ae.depth), le.push(ve), Be.children.push(ve));
    }); le.length > 1; )
      ve = le.pop(), oe(ve, null);
    if (se.children.length === 0)
      throw new Error("trace.toTree(): parse tree has no nodes");
    if (le.length === 0)
      throw new Error("trace.toTree(): integrity check: dummy root node disappeared?");
    be = se.children[0];
    let me = be;
    for (; be && !be.down && !be.up; )
      me = be, be = be.children[0];
    be = me, be.leftMost = !0, be.rightMost = !0, z(be), be.branch = 0;
    const fe = {};
    fe.string = [];
    for (let b = 0; b < E.length; b += 1)
      fe.string[b] = E[b];
    fe.rules = [];
    for (let b = 0; b < m.length; b += 1)
      fe.rules[b] = m[b].name;
    fe.udts = [];
    for (let b = 0; b < N.length; b += 1)
      fe.udts[b] = N[b].name;
    fe.id = {}, fe.id.ALT = { id: s.ALT, name: "ALT" }, fe.id.CAT = { id: s.CAT, name: "CAT" }, fe.id.REP = { id: s.REP, name: "REP" }, fe.id.RNM = { id: s.RNM, name: "RNM" }, fe.id.TLS = { id: s.TLS, name: "TLS" }, fe.id.TBS = { id: s.TBS, name: "TBS" }, fe.id.TRG = { id: s.TRG, name: "TRG" }, fe.id.UDT = { id: s.UDT, name: "UDT" }, fe.id.AND = { id: s.AND, name: "AND" }, fe.id.NOT = { id: s.NOT, name: "NOT" }, fe.id.BKR = { id: s.BKR, name: "BKR" }, fe.id.BKA = { id: s.BKA, name: "BKA" }, fe.id.BKN = { id: s.BKN, name: "BKN" }, fe.id.ABG = { id: s.ABG, name: "ABG" }, fe.id.AEN = { id: s.AEN, name: "AEN" }, fe.id.ACTIVE = { id: s.ACTIVE, name: "ACTIVE" }, fe.id.MATCH = { id: s.MATCH, name: "MATCH" }, fe.id.EMPTY = { id: s.EMPTY, name: "EMPTY" }, fe.id.NOMATCH = { id: s.NOMATCH, name: "NOMATCH" }, fe.treeDepth = A, fe.leafNodes = ee;
    let _;
    return be.down ? be.up ? _ = "none" : _ = "right" : be.up ? _ = "left" : _ = "both", fe.branchesIncomplete = _, fe.tree = q(be, be.depth), fe;
  };
  this.toTree = function(re) {
    const ae = B();
    return re ? JSON.stringify(ae) : ae;
  }, this.toHtmlPage = function(re, ae, L) {
    return e.htmlToPage(this.toHtml(re, ae), L);
  };
  const C = function(re, ae) {
    let L;
    switch (re) {
      case o:
        L = "hexadecimal";
        break;
      case u:
        L = "decimal";
        break;
      case c:
        L = "ASCII";
        break;
      case l:
        L = "UNICODE";
        break;
      default:
        throw new Error(`${i}htmlHeader: unrecognized mode: ${re}`);
    }
    let ne = "";
    return ne += `<p>display mode: ${L}</p>
`, ne += `<table class="${t.CLASS_TRACE}">
`, typeof ae == "string" && (ne += `<caption>${ae}</caption>`), ne;
  }, H = function() {
    let re = "";
    return re += `</table>
`, re += `<p class="${t.CLASS_MONOSPACE}">legend:<br>
`, re += `(a)&nbsp;-&nbsp;line number<br>
`, re += `(b)&nbsp;-&nbsp;matching line number<br>
`, re += `(c)&nbsp;-&nbsp;phrase offset<br>
`, re += `(d)&nbsp;-&nbsp;phrase length<br>
`, re += `(e)&nbsp;-&nbsp;tree depth<br>
`, re += `(f)&nbsp;-&nbsp;operator state<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_ACTIVE}">&darr;</span>&nbsp;&nbsp;phrase opened<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_MATCH}">&uarr;M</span> phrase matched<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_EMPTY}">&uarr;E</span> empty phrase matched<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_NOMATCH}">&uarr;N</span> phrase not matched<br>
`, re += `operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>
`, re += `phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to ${f} characters of the phrase being matched<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_MATCH}">matched characters</span><br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_LOOKAHEAD}">matched characters in look ahead mode</span><br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_LOOKBEHIND}">matched characters in look behind mode</span><br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_REMAINDER}">remainder characters(not yet examined by parser)</span><br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${t.CLASS_CTRLCHAR}">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${D} empty string<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${R} end of input string<br>
`, re += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${j} input string display truncated<br>
`, re += `</p>
`, re += `<p class="${t.CLASS_MONOSPACE}">
`, re += `<sup>&dagger;</sup>original ABNF operators:<br>
`, re += `ALT - alternation<br>
`, re += `CAT - concatenation<br>
`, re += `REP - repetition<br>
`, re += `RNM - rule name<br>
`, re += `TRG - terminal range<br>
`, re += `TLS - terminal literal string (case insensitive)<br>
`, re += `TBS - terminal binary string (case sensitive)<br>
`, re += `<br>
`, re += `<sup>&Dagger;</sup>super set SABNF operators:<br>
`, re += `UDT - user-defined terminal<br>
`, re += `AND - positive look ahead<br>
`, re += `NOT - negative look ahead<br>
`, re += `BKA - positive look behind<br>
`, re += `BKN - negative look behind<br>
`, re += `BKR - back reference<br>
`, re += `ABG - anchor - begin of input string<br>
`, re += `AEN - anchor - end of input string<br>
`, re += `</p>
`, re;
  };
  this.indent = function(re) {
    let ae = "";
    for (let L = 0; L < re; L += 1)
      ae += ".";
    return ae;
  };
  const V = function(re, ae) {
    let L = "";
    if (ae.type === s.TRG)
      if (re === o || re === l) {
        let ne = ae.min.toString(16).toUpperCase();
        ne.length % 2 !== 0 && (ne = `0${ne}`), L += re === o ? "%x" : "U+", L += ne, ne = ae.max.toString(16).toUpperCase(), ne.length % 2 !== 0 && (ne = `0${ne}`), L += `&ndash;${ne}`;
      } else
        L = `%d${ae.min.toString(10)}&ndash;${ae.max.toString(10)}`;
    return L;
  }, J = function(re, ae) {
    let L = "";
    if (ae.type === s.REP)
      if (re === o) {
        let ne = ae.min.toString(16).toUpperCase();
        ne.length % 2 !== 0 && (ne = `0${ne}`), L = `x${ne}`, ae.max < 1 / 0 ? (ne = ae.max.toString(16).toUpperCase(), ne.length % 2 !== 0 && (ne = `0${ne}`)) : ne = "inf", L += `&ndash;${ne}`;
      } else ae.max < 1 / 0 ? L = `${ae.min.toString(10)}&ndash;${ae.max.toString(10)}` : L = `${ae.min.toString(10)}&ndash;inf`;
    return L;
  }, M = function(re, ae) {
    let L = "";
    if (ae.type === s.TBS) {
      const ne = Math.min(ae.string.length, d * 2);
      if (re === o || re === l) {
        L += re === o ? "%x" : "U+";
        for (let oe = 0; oe < ne; oe += 1) {
          let ee;
          oe > 0 && (L += "."), ee = ae.string[oe].toString(16).toUpperCase(), ee.length % 2 !== 0 && (ee = `0${ee}`), L += ee;
        }
      } else {
        L = "%d";
        for (let oe = 0; oe < ne; oe += 1)
          oe > 0 && (L += "."), L += ae.string[oe].toString(10);
      }
      ne < ae.string.length && (L += j);
    }
    return L;
  }, G = function(re, ae) {
    let L = "";
    if (ae.type === s.TLS) {
      const ne = Math.min(ae.string.length, d);
      if (re === o || re === u) {
        let oe, ee, W;
        re === o ? (L = "%x", W = 16) : (L = "%d", W = 10);
        for (let v = 0; v < ne; v += 1)
          v > 0 && (L += "."), ee = ae.string[v], ee >= 97 && ee <= 122 ? (oe = ee - 32, L += `${oe.toString(W)}/${ee.toString(W)}`.toUpperCase()) : ee >= 65 && ee <= 90 ? (oe = ee, ee += 32, L += `${oe.toString(W)}/${ee.toString(W)}`.toUpperCase()) : L += ee.toString(W).toUpperCase();
        ne < ae.string.length && (L += j);
      } else {
        L = '"';
        for (let oe = 0; oe < ne; oe += 1)
          L += e.asciiChars[ae.string[oe]];
        ne < ae.string.length && (L += j), L += '"';
      }
    }
    return L;
  }, K = function(re, ae, L, ne, oe) {
    if (ne === 0)
      return "";
    let ee = "";
    const W = oe ? "," : "";
    switch (re) {
      case o:
        ee = W + e.charsToHex(ae, L, ne);
        break;
      case u:
        if (oe)
          return `,${e.charsToDec(ae, L, ne)}`;
        ee = W + e.charsToDec(ae, L, ne);
        break;
      case l:
        ee = e.charsToUnicode(ae, L, ne);
        break;
      case c:
      default:
        ee = e.charsToAsciiHtml(ae, L, ne);
        break;
    }
    return ee;
  }, X = function(re, ae, L, ne, oe, ee) {
    let W = "", v, z, q, le, be = R;
    const ve = `<span class="${t.CLASS_LOOKBEHIND}">`, Be = `<span class="${t.CLASS_REMAINDER}">`, Ae = "</span>";
    let ie = !1;
    switch (L) {
      case s.EMPTY:
        W += D;
      case s.NOMATCH:
      case s.MATCH:
      case s.ACTIVE:
        v = ne - oe, z = ee - v, q = ee, le = ae.length - q;
        break;
      default:
        throw new Error("unrecognized state");
    }
    return be = R, z > f ? (z = f, be = j, le = 0) : z + le > f && (be = j, le = f - z), z > 0 && (W += ve, W += K(re, ae, v, z, ie), W += Ae, ie = !0), le > 0 && (W += Be, W += K(re, ae, q, le, ie), W += Ae), W + be;
  }, te = function(re, ae, L, ne, oe, ee) {
    let W = "", v, z, q, le, be = R;
    const ve = `<span class="${t.CLASS_REMAINDER}">`, Be = "</span>";
    let Ae = !1;
    switch (L) {
      case s.EMPTY:
        W += D;
      case s.NOMATCH:
      case s.ACTIVE:
        v = ne, z = 0, q = ne, le = ae.length - q;
        break;
      case s.MATCH:
        v = ne, z = oe, q = ne + z, le = ae.length - q;
        break;
      default:
        throw new Error("unrecognized state");
    }
    return be = R, z > f ? (z = f, be = j, le = 0) : z + le > f && (be = j, le = f - z), z > 0 && (W += ee, W += K(re, ae, v, z, Ae), W += Be, Ae = !0), le > 0 && (W += ve, W += K(re, ae, q, le, Ae), W += Be), W + be;
  }, pe = function(re, ae, L, ne, oe) {
    const ee = `<span class="${t.CLASS_LOOKAHEAD}">`;
    return te(re, ae, L, ne, oe, ee);
  }, he = function(re, ae, L, ne, oe) {
    const ee = `<span class="${t.CLASS_MATCH}">`;
    return te(re, ae, L, ne, oe, ee);
  }, ye = function(re) {
    if (m === null)
      return "";
    let ae = "", L, ne, oe, ee, W, v;
    return ae += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>", ae += `<th>operator</th><th>phrase</th></tr>
`, n.forEach((z) => {
      const q = h[z];
      switch (L = q.thisLine, ne = q.thatLine !== void 0 ? q.thatLine : "--", oe = !1, ee = !1, W = !1, q.lookAround === s.LOOKAROUND_AHEAD && (oe = !0, W = !0, v = q.lookAnchor), (q.opcode.type === s.AND || q.opcode.type === s.NOT) && (oe = !0, W = !0, v = q.phraseIndex), q.lookAround === s.LOOKAROUND_BEHIND && (ee = !0, W = !0, v = q.lookAnchor), (q.opcode.type === s.BKA || q.opcode.type === s.BKN) && (ee = !0, W = !0, v = q.phraseIndex), ae += "<tr>", ae += `<td>${L}</td><td>${ne}</td>`, ae += `<td>${q.phraseIndex}</td>`, ae += `<td>${q.phraseLength}</td>`, ae += `<td>${q.depth}</td>`, ae += "<td>", q.state) {
        case s.ACTIVE:
          ae += `<span class="${t.CLASS_ACTIVE}">&darr;&nbsp;</span>`;
          break;
        case s.MATCH:
          ae += `<span class="${t.CLASS_MATCH}">&uarr;M</span>`;
          break;
        case s.NOMATCH:
          ae += `<span class="${t.CLASS_NOMATCH}">&uarr;N</span>`;
          break;
        case s.EMPTY:
          ae += `<span class="${t.CLASS_EMPTY}">&uarr;E</span>`;
          break;
        default:
          ae += `<span class="${t.CLASS_ACTIVE}">--</span>`;
          break;
      }
      if (ae += "</td>", ae += "<td>", ae += a.indent(q.depth), oe ? ae += `<span class="${t.CLASS_LOOKAHEAD}">` : ee && (ae += `<span class="${t.CLASS_LOOKBEHIND}">`), ae += e.opcodeToString(q.opcode.type), q.opcode.type === s.RNM && (ae += `(${m[q.opcode.index].name}) `), q.opcode.type === s.BKR) {
        const le = q.opcode.bkrCase === s.BKR_MODE_CI ? "%i" : "%s", be = q.opcode.bkrMode === s.BKR_MODE_UM ? "%u" : "%p";
        ae += `(\\${le}${be}${m[q.opcode.index].name}) `;
      }
      q.opcode.type === s.UDT && (ae += `(${N[q.opcode.index].name}) `), q.opcode.type === s.TRG && (ae += `(${V(re, q.opcode)}) `), q.opcode.type === s.TBS && (ae += `(${M(re, q.opcode)}) `), q.opcode.type === s.TLS && (ae += `(${G(re, q.opcode)}) `), q.opcode.type === s.REP && (ae += `(${J(re, q.opcode)}) `), W && (ae += "</span>"), ae += "</td>", ae += "<td>", ee ? ae += X(re, E, q.state, q.phraseIndex, q.phraseLength, v) : oe ? ae += pe(re, E, q.state, q.phraseIndex, q.phraseLength) : ae += he(re, E, q.state, q.phraseIndex, q.phraseLength), ae += `</td></tr>
`;
    }), ae += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>", ae += `<th>operator</th><th>phrase</th></tr>
`, ae += `</table>
`, ae;
  };
  this.toHtml = function(re, ae) {
    let L = c;
    if (typeof re == "string" && re.length >= 3) {
      const oe = re.toLowerCase().slice(0, 3);
      oe === "hex" ? L = o : oe === "dec" ? L = u : oe === "uni" && (L = l);
    }
    let ne = "";
    return ne += C(L, ae), ne += ye(L), ne += H(), ne;
  };
}, $4 = {
  ast: NP,
  circular: V4,
  ids: Fu,
  parser: SP,
  stats: CP,
  trace: RP,
  utils: Du,
  emitcss: G4,
  style: xh
}, ko = {}, wt = {}, Sn = {};
Object.defineProperty(Sn, "__esModule", { value: !0 });
Sn.isBytes = z4;
Sn.number = Td;
Sn.bool = K4;
Sn.bytes = rx;
Sn.hash = J4;
Sn.exists = Q4;
Sn.output = q4;
function Td(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error(`positive integer expected, not ${r}`);
}
function K4(r) {
  if (typeof r != "boolean")
    throw new Error(`boolean expected, not ${r}`);
}
function z4(r) {
  return r instanceof Uint8Array || r != null && typeof r == "object" && r.constructor.name === "Uint8Array";
}
function rx(r, ...e) {
  if (!z4(r))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(r.length))
    throw new Error(`Uint8Array expected of length ${e}, not of length=${r.length}`);
}
function J4(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Td(r.outputLen), Td(r.blockLen);
}
function Q4(r, e = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function q4(r, e) {
  rx(r);
  const t = e.outputLen;
  if (r.length < t)
    throw new Error(`digestInto() expects output buffer of length at least ${t}`);
}
const IP = { number: Td, bool: K4, bytes: rx, hash: J4, exists: Q4, output: q4 };
Sn.default = IP;
var ze = {};
Object.defineProperty(ze, "__esModule", { value: !0 });
ze.add5L = ze.add5H = ze.add4H = ze.add4L = ze.add3H = ze.add3L = ze.rotlBL = ze.rotlBH = ze.rotlSL = ze.rotlSH = ze.rotr32L = ze.rotr32H = ze.rotrBL = ze.rotrBH = ze.rotrSL = ze.rotrSH = ze.shrSL = ze.shrSH = ze.toBig = void 0;
ze.fromBig = nx;
ze.split = W4;
ze.add = lA;
const Mf = /* @__PURE__ */ BigInt(2 ** 32 - 1), Ab = /* @__PURE__ */ BigInt(32);
function nx(r, e = !1) {
  return e ? { h: Number(r & Mf), l: Number(r >> Ab & Mf) } : { h: Number(r >> Ab & Mf) | 0, l: Number(r & Mf) | 0 };
}
function W4(r, e = !1) {
  let t = new Uint32Array(r.length), n = new Uint32Array(r.length);
  for (let s = 0; s < r.length; s++) {
    const { h: i, l: a } = nx(r[s], e);
    [t[s], n[s]] = [i, a];
  }
  return [t, n];
}
const Y4 = (r, e) => BigInt(r >>> 0) << Ab | BigInt(e >>> 0);
ze.toBig = Y4;
const Z4 = (r, e, t) => r >>> t;
ze.shrSH = Z4;
const X4 = (r, e, t) => r << 32 - t | e >>> t;
ze.shrSL = X4;
const eA = (r, e, t) => r >>> t | e << 32 - t;
ze.rotrSH = eA;
const tA = (r, e, t) => r << 32 - t | e >>> t;
ze.rotrSL = tA;
const rA = (r, e, t) => r << 64 - t | e >>> t - 32;
ze.rotrBH = rA;
const nA = (r, e, t) => r >>> t - 32 | e << 64 - t;
ze.rotrBL = nA;
const sA = (r, e) => e;
ze.rotr32H = sA;
const iA = (r, e) => r;
ze.rotr32L = iA;
const aA = (r, e, t) => r << t | e >>> 32 - t;
ze.rotlSH = aA;
const oA = (r, e, t) => e << t | r >>> 32 - t;
ze.rotlSL = oA;
const cA = (r, e, t) => e << t - 32 | r >>> 64 - t;
ze.rotlBH = cA;
const uA = (r, e, t) => r << t - 32 | e >>> 64 - t;
ze.rotlBL = uA;
function lA(r, e, t, n) {
  const s = (e >>> 0) + (n >>> 0);
  return { h: r + t + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const fA = (r, e, t) => (r >>> 0) + (e >>> 0) + (t >>> 0);
ze.add3L = fA;
const dA = (r, e, t, n) => e + t + n + (r / 2 ** 32 | 0) | 0;
ze.add3H = dA;
const hA = (r, e, t, n) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0);
ze.add4L = hA;
const pA = (r, e, t, n, s) => e + t + n + s + (r / 2 ** 32 | 0) | 0;
ze.add4H = pA;
const bA = (r, e, t, n, s) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0) + (s >>> 0);
ze.add5L = bA;
const gA = (r, e, t, n, s, i) => e + t + n + s + i + (r / 2 ** 32 | 0) | 0;
ze.add5H = gA;
const _P = {
  fromBig: nx,
  split: W4,
  toBig: Y4,
  shrSH: Z4,
  shrSL: X4,
  rotrSH: eA,
  rotrSL: tA,
  rotrBH: rA,
  rotrBL: nA,
  rotr32H: sA,
  rotr32L: iA,
  rotlSH: aA,
  rotlSL: oA,
  rotlBH: cA,
  rotlBL: uA,
  add: lA,
  add3L: fA,
  add3H: dA,
  add4L: hA,
  add4H: pA,
  add5H: gA,
  add5L: bA
};
ze.default = _P;
var sx = {}, yh = {};
Object.defineProperty(yh, "__esModule", { value: !0 });
yh.crypto = void 0;
yh.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(r) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Hash = r.nextTick = r.byteSwapIfBE = r.byteSwap = r.isLE = r.rotl = r.rotr = r.createView = r.u32 = r.u8 = void 0, r.isBytes = n, r.byteSwap32 = l, r.bytesToHex = d, r.hexToBytes = g, r.asyncLoop = A, r.utf8ToBytes = y, r.toBytes = E, r.concatBytes = m, r.checkOpts = U, r.wrapConstructor = R, r.wrapConstructorWithOpts = j, r.wrapXOFConstructorWithOpts = D, r.randomBytes = O;
  const e = yh, t = Sn;
  function n(I) {
    return I instanceof Uint8Array || I != null && typeof I == "object" && I.constructor.name === "Uint8Array";
  }
  const s = (I) => new Uint8Array(I.buffer, I.byteOffset, I.byteLength);
  r.u8 = s;
  const i = (I) => new Uint32Array(I.buffer, I.byteOffset, Math.floor(I.byteLength / 4));
  r.u32 = i;
  const a = (I) => new DataView(I.buffer, I.byteOffset, I.byteLength);
  r.createView = a;
  const o = (I, P) => I << 32 - P | I >>> P;
  r.rotr = o;
  const u = (I, P) => I << P | I >>> 32 - P >>> 0;
  r.rotl = u, r.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  const c = (I) => I << 24 & 4278190080 | I << 8 & 16711680 | I >>> 8 & 65280 | I >>> 24 & 255;
  r.byteSwap = c, r.byteSwapIfBE = r.isLE ? (I) => I : (I) => (0, r.byteSwap)(I);
  function l(I) {
    for (let P = 0; P < I.length; P++)
      I[P] = (0, r.byteSwap)(I[P]);
  }
  const f = /* @__PURE__ */ Array.from({ length: 256 }, (I, P) => P.toString(16).padStart(2, "0"));
  function d(I) {
    (0, t.bytes)(I);
    let P = "";
    for (let S = 0; S < I.length; S++)
      P += f[I[S]];
    return P;
  }
  const h = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
  function p(I) {
    if (I >= h._0 && I <= h._9)
      return I - h._0;
    if (I >= h._A && I <= h._F)
      return I - (h._A - 10);
    if (I >= h._a && I <= h._f)
      return I - (h._a - 10);
  }
  function g(I) {
    if (typeof I != "string")
      throw new Error("hex string expected, got " + typeof I);
    const P = I.length, S = P / 2;
    if (P % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + P);
    const B = new Uint8Array(S);
    for (let C = 0, H = 0; C < S; C++, H += 2) {
      const V = p(I.charCodeAt(H)), J = p(I.charCodeAt(H + 1));
      if (V === void 0 || J === void 0) {
        const M = I[H] + I[H + 1];
        throw new Error('hex string expected, got non-hex character "' + M + '" at index ' + H);
      }
      B[C] = V * 16 + J;
    }
    return B;
  }
  const k = async () => {
  };
  r.nextTick = k;
  async function A(I, P, S) {
    let B = Date.now();
    for (let C = 0; C < I; C++) {
      S(C);
      const H = Date.now() - B;
      H >= 0 && H < P || (await (0, r.nextTick)(), B += H);
    }
  }
  function y(I) {
    if (typeof I != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof I}`);
    return new Uint8Array(new TextEncoder().encode(I));
  }
  function E(I) {
    return typeof I == "string" && (I = y(I)), (0, t.bytes)(I), I;
  }
  function m(...I) {
    let P = 0;
    for (let B = 0; B < I.length; B++) {
      const C = I[B];
      (0, t.bytes)(C), P += C.length;
    }
    const S = new Uint8Array(P);
    for (let B = 0, C = 0; B < I.length; B++) {
      const H = I[B];
      S.set(H, C), C += H.length;
    }
    return S;
  }
  class N {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  r.Hash = N;
  const T = {}.toString;
  function U(I, P) {
    if (P !== void 0 && T.call(P) !== "[object Object]")
      throw new Error("Options should be object or undefined");
    return Object.assign(I, P);
  }
  function R(I) {
    const P = (B) => I().update(E(B)).digest(), S = I();
    return P.outputLen = S.outputLen, P.blockLen = S.blockLen, P.create = () => I(), P;
  }
  function j(I) {
    const P = (B, C) => I(C).update(E(B)).digest(), S = I({});
    return P.outputLen = S.outputLen, P.blockLen = S.blockLen, P.create = (B) => I(B), P;
  }
  function D(I) {
    const P = (B, C) => I(C).update(E(B)).digest(), S = I({});
    return P.outputLen = S.outputLen, P.blockLen = S.blockLen, P.create = (B) => I(B), P;
  }
  function O(I = 32) {
    if (e.crypto && typeof e.crypto.getRandomValues == "function")
      return e.crypto.getRandomValues(new Uint8Array(I));
    if (e.crypto && typeof e.crypto.randomBytes == "function")
      return e.crypto.randomBytes(I);
    throw new Error("crypto.getRandomValues must be defined");
  }
})(sx);
Object.defineProperty(wt, "__esModule", { value: !0 });
wt.shake256 = wt.shake128 = wt.keccak_512 = wt.keccak_384 = wt.keccak_256 = wt.keccak_224 = wt.sha3_512 = wt.sha3_384 = wt.sha3_256 = wt.sha3_224 = wt.Keccak = void 0;
wt.keccakP = wA;
const Zo = Sn, N0 = ze, ps = sx, xA = [], mA = [], yA = [], UP = /* @__PURE__ */ BigInt(0), Qu = /* @__PURE__ */ BigInt(1), LP = /* @__PURE__ */ BigInt(2), MP = /* @__PURE__ */ BigInt(7), FP = /* @__PURE__ */ BigInt(256), DP = /* @__PURE__ */ BigInt(113);
for (let r = 0, e = Qu, t = 1, n = 0; r < 24; r++) {
  [t, n] = [n, (2 * t + 3 * n) % 5], xA.push(2 * (5 * n + t)), mA.push((r + 1) * (r + 2) / 2 % 64);
  let s = UP;
  for (let i = 0; i < 7; i++)
    e = (e << Qu ^ (e >> MP) * DP) % FP, e & LP && (s ^= Qu << (Qu << /* @__PURE__ */ BigInt(i)) - Qu);
  yA.push(s);
}
const [jP, HP] = /* @__PURE__ */ (0, N0.split)(yA, !0), e1 = (r, e, t) => t > 32 ? (0, N0.rotlBH)(r, e, t) : (0, N0.rotlSH)(r, e, t), t1 = (r, e, t) => t > 32 ? (0, N0.rotlBL)(r, e, t) : (0, N0.rotlSL)(r, e, t);
function wA(r, e = 24) {
  const t = new Uint32Array(10);
  for (let n = 24 - e; n < 24; n++) {
    for (let a = 0; a < 10; a++)
      t[a] = r[a] ^ r[a + 10] ^ r[a + 20] ^ r[a + 30] ^ r[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const o = (a + 8) % 10, u = (a + 2) % 10, c = t[u], l = t[u + 1], f = e1(c, l, 1) ^ t[o], d = t1(c, l, 1) ^ t[o + 1];
      for (let h = 0; h < 50; h += 10)
        r[a + h] ^= f, r[a + h + 1] ^= d;
    }
    let s = r[2], i = r[3];
    for (let a = 0; a < 24; a++) {
      const o = mA[a], u = e1(s, i, o), c = t1(s, i, o), l = xA[a];
      s = r[l], i = r[l + 1], r[l] = u, r[l + 1] = c;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let o = 0; o < 10; o++)
        t[o] = r[a + o];
      for (let o = 0; o < 10; o++)
        r[a + o] ^= ~t[(o + 2) % 10] & t[(o + 4) % 10];
    }
    r[0] ^= jP[n], r[1] ^= HP[n];
  }
  t.fill(0);
}
class uf extends ps.Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, t, n, s = !1, i = 24) {
    if (super(), this.blockLen = e, this.suffix = t, this.outputLen = n, this.enableXOF = s, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, Zo.number)(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = (0, ps.u32)(this.state);
  }
  keccak() {
    ps.isLE || (0, ps.byteSwap32)(this.state32), wA(this.state32, this.rounds), ps.isLE || (0, ps.byteSwap32)(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    (0, Zo.exists)(this);
    const { blockLen: t, state: n } = this;
    e = (0, ps.toBytes)(e);
    const s = e.length;
    for (let i = 0; i < s; ) {
      const a = Math.min(t - this.pos, s - i);
      for (let o = 0; o < a; o++)
        n[this.pos++] ^= e[i++];
      this.pos === t && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: t, pos: n, blockLen: s } = this;
    e[n] ^= t, t & 128 && n === s - 1 && this.keccak(), e[s - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    (0, Zo.exists)(this, !1), (0, Zo.bytes)(e), this.finish();
    const t = this.state, { blockLen: n } = this;
    for (let s = 0, i = e.length; s < i; ) {
      this.posOut >= n && this.keccak();
      const a = Math.min(n - this.posOut, i - s);
      e.set(t.subarray(this.posOut, this.posOut + a), s), this.posOut += a, s += a;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return (0, Zo.number)(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if ((0, Zo.output)(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: t, suffix: n, outputLen: s, rounds: i, enableXOF: a } = this;
    return e || (e = new uf(t, n, s, a, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = n, e.outputLen = s, e.enableXOF = a, e.destroyed = this.destroyed, e;
  }
}
wt.Keccak = uf;
const Fi = (r, e, t) => (0, ps.wrapConstructor)(() => new uf(e, r, t));
wt.sha3_224 = Fi(6, 144, 224 / 8);
wt.sha3_256 = Fi(6, 136, 256 / 8);
wt.sha3_384 = Fi(6, 104, 384 / 8);
wt.sha3_512 = Fi(6, 72, 512 / 8);
wt.keccak_224 = Fi(1, 144, 224 / 8);
wt.keccak_256 = Fi(1, 136, 256 / 8);
wt.keccak_384 = Fi(1, 104, 384 / 8);
wt.keccak_512 = Fi(1, 72, 512 / 8);
const AA = (r, e, t) => (0, ps.wrapXOFConstructorWithOpts)((n = {}) => new uf(e, r, n.dkLen === void 0 ? t : n.dkLen, !0));
wt.shake128 = AA(31, 168, 128 / 8);
wt.shake256 = AA(31, 136, 256 / 8);
Object.defineProperty(ko, "__esModule", { value: !0 });
ko.parseIntegerNumber = ko.isEIP55Address = void 0;
const GP = wt, VP = sx, $P = (r) => {
  if (r.length != 42)
    return !1;
  const e = `${r}`.toLowerCase().replace("0x", ""), t = (0, VP.bytesToHex)((0, GP.keccak_256)(e));
  let n = "0x";
  for (let s = 0; s < e.length; s++)
    parseInt(t[s], 16) >= 8 ? n += e[s].toUpperCase() : n += e[s];
  return r === n;
};
ko.isEIP55Address = $P;
const KP = (r) => {
  const e = parseInt(r);
  if (isNaN(e))
    throw new Error("Invalid number.");
  if (e === 1 / 0)
    throw new Error("Invalid number.");
  return e;
};
ko.parseIntegerNumber = KP;
var zP = nt && nt.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(gh, "__esModule", { value: !0 });
gh.cb = void 0;
const EA = zP($4), Et = EA.default.utils, Re = EA.default.ids, up = ko, r1 = /^(?<date>[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(.[0-9]+)?(([Zz])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/, lp = (r) => {
  const e = r1.exec(r);
  if (!e)
    return !1;
  const t = new Date(e.groups.date).toISOString(), n = r1.exec(t);
  return e.groups.date === n.groups.date;
};
gh.cb = {
  signInWithEtherium: function(r, e, t, n) {
    switch (r.state) {
      case Re.ACTIVE:
        if (typeof n != "object" || n === null)
          throw new Error("data must be an object");
        break;
      case Re.NOMATCH:
        n.errors.push(`invalid message: max line number was ${n.lineno}`);
    }
  },
  lineno: function(e, t, n, s) {
    e.state === Re.MATCH && (s.lineno += 1);
  },
  exTitle: function(e, t, n, s) {
    e.state === Re.NOMATCH && (s.lineno -= 1);
  },
  nbTitle: function(e, t, n, s) {
    e.state === Re.NOMATCH && (s.lineno -= 1);
  },
  riTitle: function(e, t, n, s) {
    e.state === Re.NOMATCH && (s.lineno -= 1);
  },
  reTitle: function(e, t, n, s) {
    e.state === Re.MATCH ? s.resources = [] : e.state === Re.NOMATCH && (s.lineno -= 1);
  },
  oscheme: function(e, t, n, s) {
    e.state === Re.MATCH && (s.scheme = Et.charsToString(t, n, e.phraseLength - 3));
  },
  domain: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.domain = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.errors.push(`line ${s.lineno}: domain cannot be empty`);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid domain`);
    }
  },
  address: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.address = Et.charsToString(t, n, e.phraseLength), (0, up.isEIP55Address)(s.address) || s.errors.push(`line ${s.lineno}: invalid EIP-55 address - ${s.address}`);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid address`);
        break;
    }
  },
  statement: function(e, t, n, s) {
    e.state === Re.MATCH && (s.statement = Et.charsToString(t, n, e.phraseLength));
  },
  emptyStatement: function(e, t, n, s) {
    e.state === Re.MATCH && (s.statement = "");
  },
  version: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.version = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid version`);
        break;
    }
  },
  nonce: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.nonce = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid nonce`);
        break;
    }
  },
  issuedAt: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.issuedAt = Et.charsToString(t, n, e.phraseLength), lp(s.issuedAt) || s.errors.push(`line ${s.lineno}: invalid issued-at date time semantics`);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid issued-at date time syntax`);
        break;
    }
  },
  expirationTime: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.expirationTime = Et.charsToString(t, n, e.phraseLength), lp(s.expirationTime) || s.errors.push(`line ${s.lineno}: invalid expiration-time date time semantics`);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid expiration-time date time syntax`);
        break;
    }
  },
  notBefore: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.notBefore = Et.charsToString(t, n, e.phraseLength), lp(s.notBefore) || s.errors.push(`line ${s.lineno}: invalid not-before date time semantics`);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid not-before date time syntax`);
        break;
    }
  },
  requestId: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.requestId = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.requestId = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid requestID`);
        break;
    }
  },
  chainId: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.chainId = (0, up.parseIntegerNumber)(Et.charsToString(t, n, e.phraseLength));
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid chain-id`);
        break;
    }
  },
  uriR: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriR = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid resource URI`);
        break;
    }
  },
  resource: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.resources.push(s.uriR), delete s.uriR;
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid resource`);
        break;
    }
  },
  // handle the URI
  scheme: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.scheme = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI scheme`);
        break;
    }
  },
  userinfo: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.userinfo = Et.charsToString(t, n, e.phraseLength - 1);
        break;
    }
  },
  host: function(e, t, n, s) {
    switch (e.state) {
      case Re.ACTIVE:
        s.iplit = !1;
        break;
      case Re.MATCH:
        s.iplit ? s.uriElements.host = Et.charsToString(t, n + 1, e.phraseLength - 2) : s.uriElements.host = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.uriElements.host = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI host`);
        break;
    }
  },
  ipLiteral: function(e, t, n, s) {
    e.state === Re.MATCH && (s.iplit = !0);
  },
  port: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.port = (0, up.parseIntegerNumber)(Et.charsToString(t, n, e.phraseLength));
        break;
      case Re.EMPTY:
        s.uriElements.port = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI port`);
        break;
    }
  },
  pathAbempty: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.path = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.uriElements.path = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI path-abempty`);
        break;
    }
  },
  pathAbsolute: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.path = Et.charsToString(t, n, e.phraseLength);
        break;
    }
  },
  pathRootless: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.path = Et.charsToString(t, n, e.phraseLength);
        break;
    }
  },
  pathEmpty: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI - path-empty must be empty`);
        break;
      case Re.EMPTY:
        s.uriElements.path = "";
        break;
    }
  },
  query: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.query = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.uriElements.query = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI query`);
        break;
    }
  },
  fragment: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uriElements.fragment = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
        s.uriElements.fragment = "";
        break;
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI fragment`);
        break;
    }
  },
  uri: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.uri = Et.charsToString(t, n, e.phraseLength);
        break;
      case Re.EMPTY:
      case Re.NOMATCH:
        s.errors.push(`line ${s.lineno}: invalid URI`);
        break;
    }
  },
  ipv4: function(e, t, n, s) {
    e.state === Re.MATCH && (s.ipv4 = !0);
  },
  h16: function(e, t, n, s) {
    e.state === Re.MATCH && (s.h16count += 1);
  },
  nodcolon: function(e, t, n, s) {
    switch (e.state) {
      case Re.ACTIVE:
        s.h16count = 0, s.ipv4 = !1;
        break;
      case Re.MATCH:
        s.ipv4 ? s.h16count === 6 ? e.state = Re.MATCH : (e.state = Re.NOMATCH, e.phraseLength = 0) : s.h16count === 8 ? e.state = Re.MATCH : (e.state = Re.NOMATCH, e.phraseLength = 0);
        break;
    }
  },
  dcolon: function(e, t, n, s) {
    switch (e.state) {
      case Re.ACTIVE:
        s.h16count = 0, s.ipv4 = !1;
        break;
      case Re.MATCH:
        s.ipv4 ? s.h16count < 6 ? e.state = Re.MATCH : (e.state = Re.NOMATCH, e.phraseLength = 0) : s.h16count < 8 ? e.state = Re.MATCH : (e.state = Re.NOMATCH, e.phraseLength = 0);
        break;
    }
  },
  decOctet: function(e, t, n, s) {
    switch (e.state) {
      case Re.ACTIVE:
        s.octet = 0;
        break;
      case Re.MATCH:
        s.octet > 255 ? (e.state = Re.NOMATCH, e.phraseLength = 0) : e.state = Re.MATCH;
        break;
    }
  },
  decDigit: function(e, t, n, s) {
    switch (e.state) {
      case Re.MATCH:
        s.octet = 10 * s.octet + t[n] - 48;
        break;
    }
  }
};
var JP = nt && nt.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(vo, "__esModule", { value: !0 });
vo.isUri = vo.ParsedMessage = void 0;
const QP = bh, Ge = gh, PA = JP($4), vA = new QP.grammar();
class qP {
  // and display it on an HTML page.
  constructor(e) {
    const t = new PA.default.parser();
    t.callbacks["sign-in-with-ethereum"] = Ge.cb.signInWithEtherium, t.callbacks.oscheme = Ge.cb.oscheme, t.callbacks.domain = Ge.cb.domain, t.callbacks.LF = Ge.cb.lineno, t.callbacks["ex-title"] = Ge.cb.exTitle, t.callbacks["nb-title"] = Ge.cb.nbTitle, t.callbacks["ri-title"] = Ge.cb.riTitle, t.callbacks["re-title"] = Ge.cb.reTitle, t.callbacks.address = Ge.cb.address, t.callbacks.statement = Ge.cb.statement, t.callbacks["empty-statement"] = Ge.cb.emptyStatement, t.callbacks.version = Ge.cb.version, t.callbacks["chain-id"] = Ge.cb.chainId, t.callbacks.nonce = Ge.cb.nonce, t.callbacks["issued-at"] = Ge.cb.issuedAt, t.callbacks["expiration-time"] = Ge.cb.expirationTime, t.callbacks["not-before"] = Ge.cb.notBefore, t.callbacks["request-id"] = Ge.cb.requestId, t.callbacks.uri = Ge.cb.uri, t.callbacks["uri-r"] = Ge.cb.uriR, t.callbacks.resource = Ge.cb.resource, t.callbacks.scheme = Ge.cb.scheme, t.callbacks["userinfo-at"] = Ge.cb.userinfo, t.callbacks.host = Ge.cb.host, t.callbacks["IP-literal"] = Ge.cb.ipLiteral, t.callbacks.port = Ge.cb.port, t.callbacks["path-abempty"] = Ge.cb.pathAbempty, t.callbacks["path-absolute"] = Ge.cb.pathAbsolute, t.callbacks["path-rootless"] = Ge.cb.pathRootless, t.callbacks["path-empty"] = Ge.cb.pathEmpty, t.callbacks.query = Ge.cb.query, t.callbacks.fragment = Ge.cb.fragment, t.callbacks.IPv4address = Ge.cb.ipv4, t.callbacks.nodcolon = Ge.cb.nodcolon, t.callbacks.dcolon = Ge.cb.dcolon, t.callbacks.h16 = Ge.cb.h16, t.callbacks.h16c = Ge.cb.h16, t.callbacks.h16n = Ge.cb.h16, t.callbacks.h16cn = Ge.cb.h16, t.callbacks["dec-octet"] = Ge.cb.decOctet, t.callbacks["dec-digit"] = Ge.cb.decDigit;
    const n = {
      errors: [],
      lineno: 1,
      scheme: void 0,
      domain: void 0,
      address: void 0,
      statement: void 0,
      uri: void 0,
      version: void 0,
      chainId: void 0,
      nonce: void 0,
      issuedAt: void 0,
      expirationTime: void 0,
      notBefore: void 0,
      requestId: void 0,
      resources: void 0,
      uriElements: {
        scheme: void 0,
        userinfo: void 0,
        host: void 0,
        port: void 0,
        path: void 0,
        query: void 0,
        fragment: void 0
      }
    }, s = t.parse(vA, 0, e, n);
    let i = "";
    for (let a = 0; a < n.errors.length; a += 1)
      i += n.errors[a] + `
`;
    if (s.success || (i += `Invalid message: ${JSON.stringify(s)}`), i !== "")
      throw new Error(i);
    this.scheme = n.scheme, this.domain = n.domain, this.address = n.address, this.statement = n.statement, this.uri = n.uri, this.version = n.version, this.chainId = n.chainId, this.nonce = n.nonce, this.issuedAt = n.issuedAt, this.expirationTime = n.expirationTime, this.notBefore = n.notBefore, this.requestId = n.requestId, this.resources = n.resources, this.uriElements = n.uriElements;
  }
}
vo.ParsedMessage = qP;
const WP = (r) => {
  const e = new PA.default.parser();
  e.callbacks["IP-literal"] = Ge.cb.ipLiteral, e.callbacks.IPv4address = Ge.cb.ipv4, e.callbacks.nodcolon = Ge.cb.nodcolon, e.callbacks.dcolon = Ge.cb.dcolon, e.callbacks.h16 = Ge.cb.h16, e.callbacks.h16c = Ge.cb.h16, e.callbacks.h16n = Ge.cb.h16, e.callbacks.h16cn = Ge.cb.h16, e.callbacks["dec-octet"] = Ge.cb.decOctet, e.callbacks["dec-digit"] = Ge.cb.decDigit;
  const t = { errors: [] };
  return e.parse(vA, "uri-r", r, t).success;
};
vo.isUri = WP;
(function(r) {
  var e = nt && nt.__createBinding || (Object.create ? function(i, a, o, u) {
    u === void 0 && (u = o);
    var c = Object.getOwnPropertyDescriptor(a, o);
    (!c || ("get" in c ? !a.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return a[o];
    } }), Object.defineProperty(i, u, c);
  } : function(i, a, o, u) {
    u === void 0 && (u = o), i[u] = a[o];
  }), t = nt && nt.__exportStar || function(i, a) {
    for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && e(a, i, o);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.isUri = r.ParsedMessage = void 0;
  const n = vo;
  Object.defineProperty(r, "ParsedMessage", { enumerable: !0, get: function() {
    return n.ParsedMessage;
  } });
  const s = vo;
  Object.defineProperty(r, "isUri", { enumerable: !0, get: function() {
    return s.isUri;
  } }), t(ko, r);
})(F4);
var Ms = {}, ix = {}, Eb = function(r, e) {
  return Eb = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
  }, Eb(r, e);
};
function kA(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Eb(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var Bd = function() {
  return Bd = Object.assign || function(e) {
    for (var t, n = 1, s = arguments.length; n < s; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Bd.apply(this, arguments);
};
function TA(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(r); s < n.length; s++)
      e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[s]) && (t[n[s]] = r[n[s]]);
  return t;
}
function BA(r, e, t, n) {
  var s = arguments.length, i = s < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(r, e, t, n);
  else for (var o = r.length - 1; o >= 0; o--) (a = r[o]) && (i = (s < 3 ? a(i) : s > 3 ? a(e, t, i) : a(e, t)) || i);
  return s > 3 && i && Object.defineProperty(e, t, i), i;
}
function OA(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}
function YP(r, e, t, n, s, i) {
  function a(A) {
    if (A !== void 0 && typeof A != "function") throw new TypeError("Function expected");
    return A;
  }
  for (var o = n.kind, u = o === "getter" ? "get" : o === "setter" ? "set" : "value", c = !e && r ? n.static ? r : r.prototype : null, l = e || (c ? Object.getOwnPropertyDescriptor(c, n.name) : {}), f, d = !1, h = t.length - 1; h >= 0; h--) {
    var p = {};
    for (var g in n) p[g] = g === "access" ? {} : n[g];
    for (var g in n.access) p.access[g] = n.access[g];
    p.addInitializer = function(A) {
      if (d) throw new TypeError("Cannot add initializers after decoration has completed");
      i.push(a(A || null));
    };
    var k = (0, t[h])(o === "accessor" ? { get: l.get, set: l.set } : l[u], p);
    if (o === "accessor") {
      if (k === void 0) continue;
      if (k === null || typeof k != "object") throw new TypeError("Object expected");
      (f = a(k.get)) && (l.get = f), (f = a(k.set)) && (l.set = f), (f = a(k.init)) && s.unshift(f);
    } else (f = a(k)) && (o === "field" ? s.unshift(f) : l[u] = f);
  }
  c && Object.defineProperty(c, n.name, l), d = !0;
}
function ZP(r, e, t) {
  for (var n = arguments.length > 2, s = 0; s < e.length; s++)
    t = n ? e[s].call(r, t) : e[s].call(r);
  return n ? t : void 0;
}
function XP(r) {
  return typeof r == "symbol" ? r : "".concat(r);
}
function ev(r, e, t) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(r, "name", { configurable: !0, value: t ? "".concat(t, " ", e) : e });
}
function NA(r, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(r, e);
}
function SA(r, e, t, n) {
  function s(i) {
    return i instanceof t ? i : new t(function(a) {
      a(i);
    });
  }
  return new (t || (t = Promise))(function(i, a) {
    function o(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? i(l.value) : s(l.value).then(o, u);
    }
    c((n = n.apply(r, e || [])).next());
  });
}
function CA(r, e) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, s, i, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (t = 0)), t; ) try {
      if (n = 1, s && (i = c[0] & 2 ? s.return : c[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, c[1])).done) return i;
      switch (s = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return t.label++, { value: c[1], done: !1 };
        case 5:
          t.label++, s = c[1], c = [0];
          continue;
        case 7:
          c = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            t = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            t.label = c[1];
            break;
          }
          if (c[0] === 6 && t.label < i[1]) {
            t.label = i[1], i = c;
            break;
          }
          if (i && t.label < i[2]) {
            t.label = i[2], t.ops.push(c);
            break;
          }
          i[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      c = e.call(r, t);
    } catch (l) {
      c = [6, l], s = 0;
    } finally {
      n = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var wh = Object.create ? function(r, e, t, n) {
  n === void 0 && (n = t);
  var s = Object.getOwnPropertyDescriptor(e, t);
  (!s || ("get" in s ? !e.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, n, s);
} : function(r, e, t, n) {
  n === void 0 && (n = t), r[n] = e[t];
};
function RA(r, e) {
  for (var t in r) t !== "default" && !Object.prototype.hasOwnProperty.call(e, t) && wh(e, r, t);
}
function Od(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ax(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), s, i = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(s = n.next()).done; ) i.push(s.value);
  } catch (o) {
    a = { error: o };
  } finally {
    try {
      s && !s.done && (t = n.return) && t.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}
function IA() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r = r.concat(ax(arguments[e]));
  return r;
}
function _A() {
  for (var r = 0, e = 0, t = arguments.length; e < t; e++) r += arguments[e].length;
  for (var n = Array(r), s = 0, e = 0; e < t; e++)
    for (var i = arguments[e], a = 0, o = i.length; a < o; a++, s++)
      n[s] = i[a];
  return n;
}
function UA(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, s = e.length, i; n < s; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return r.concat(i || Array.prototype.slice.call(e));
}
function Ou(r) {
  return this instanceof Ou ? (this.v = r, this) : new Ou(r);
}
function LA(r, e, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = t.apply(r, e || []), s, i = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), o("next"), o("throw"), o("return", a), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function a(h) {
    return function(p) {
      return Promise.resolve(p).then(h, f);
    };
  }
  function o(h, p) {
    n[h] && (s[h] = function(g) {
      return new Promise(function(k, A) {
        i.push([h, g, k, A]) > 1 || u(h, g);
      });
    }, p && (s[h] = p(s[h])));
  }
  function u(h, p) {
    try {
      c(n[h](p));
    } catch (g) {
      d(i[0][3], g);
    }
  }
  function c(h) {
    h.value instanceof Ou ? Promise.resolve(h.value.v).then(l, f) : d(i[0][2], h);
  }
  function l(h) {
    u("next", h);
  }
  function f(h) {
    u("throw", h);
  }
  function d(h, p) {
    h(p), i.shift(), i.length && u(i[0][0], i[0][1]);
  }
}
function MA(r) {
  var e, t;
  return e = {}, n("next"), n("throw", function(s) {
    throw s;
  }), n("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function n(s, i) {
    e[s] = r[s] ? function(a) {
      return (t = !t) ? { value: Ou(r[s](a)), done: !1 } : i ? i(a) : a;
    } : i;
  }
}
function FA(r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = r[Symbol.asyncIterator], t;
  return e ? e.call(r) : (r = typeof Od == "function" ? Od(r) : r[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(i) {
    t[i] = r[i] && function(a) {
      return new Promise(function(o, u) {
        a = r[i](a), s(o, u, a.done, a.value);
      });
    };
  }
  function s(i, a, o, u) {
    Promise.resolve(u).then(function(c) {
      i({ value: c, done: o });
    }, a);
  }
}
function DA(r, e) {
  return Object.defineProperty ? Object.defineProperty(r, "raw", { value: e }) : r.raw = e, r;
}
var tv = Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
};
function jA(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && wh(e, r, t);
  return tv(e, r), e;
}
function HA(r) {
  return r && r.__esModule ? r : { default: r };
}
function GA(r, e, t, n) {
  if (t === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? r !== e || !n : !e.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? n : t === "a" ? n.call(r) : n ? n.value : e.get(r);
}
function VA(r, e, t, n, s) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? r !== e || !s : !e.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(r, t) : s ? s.value = t : e.set(r, t), t;
}
function $A(r, e) {
  if (e === null || typeof e != "object" && typeof e != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof r == "function" ? e === r : r.has(e);
}
function KA(r, e, t) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function") throw new TypeError("Object expected.");
    var n, s;
    if (t) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      n = e[Symbol.asyncDispose];
    }
    if (n === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      n = e[Symbol.dispose], t && (s = n);
    }
    if (typeof n != "function") throw new TypeError("Object not disposable.");
    s && (n = function() {
      try {
        s.call(this);
      } catch (i) {
        return Promise.reject(i);
      }
    }), r.stack.push({ value: e, dispose: n, async: t });
  } else t && r.stack.push({ async: !0 });
  return e;
}
var rv = typeof SuppressedError == "function" ? SuppressedError : function(r, e, t) {
  var n = new Error(t);
  return n.name = "SuppressedError", n.error = r, n.suppressed = e, n;
};
function zA(r) {
  function e(i) {
    r.error = r.hasError ? new rv(i, r.error, "An error was suppressed during disposal.") : i, r.hasError = !0;
  }
  var t, n = 0;
  function s() {
    for (; t = r.stack.pop(); )
      try {
        if (!t.async && n === 1) return n = 0, r.stack.push(t), Promise.resolve().then(s);
        if (t.dispose) {
          var i = t.dispose.call(t.value);
          if (t.async) return n |= 2, Promise.resolve(i).then(s, function(a) {
            return e(a), s();
          });
        } else n |= 1;
      } catch (a) {
        e(a);
      }
    if (n === 1) return r.hasError ? Promise.reject(r.error) : Promise.resolve();
    if (r.hasError) throw r.error;
  }
  return s();
}
const nv = {
  __extends: kA,
  __assign: Bd,
  __rest: TA,
  __decorate: BA,
  __param: OA,
  __metadata: NA,
  __awaiter: SA,
  __generator: CA,
  __createBinding: wh,
  __exportStar: RA,
  __values: Od,
  __read: ax,
  __spread: IA,
  __spreadArrays: _A,
  __spreadArray: UA,
  __await: Ou,
  __asyncGenerator: LA,
  __asyncDelegator: MA,
  __asyncValues: FA,
  __makeTemplateObject: DA,
  __importStar: jA,
  __importDefault: HA,
  __classPrivateFieldGet: GA,
  __classPrivateFieldSet: VA,
  __classPrivateFieldIn: $A,
  __addDisposableResource: KA,
  __disposeResources: zA
}, sv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: KA,
  get __assign() {
    return Bd;
  },
  __asyncDelegator: MA,
  __asyncGenerator: LA,
  __asyncValues: FA,
  __await: Ou,
  __awaiter: SA,
  __classPrivateFieldGet: GA,
  __classPrivateFieldIn: $A,
  __classPrivateFieldSet: VA,
  __createBinding: wh,
  __decorate: BA,
  __disposeResources: zA,
  __esDecorate: YP,
  __exportStar: RA,
  __extends: kA,
  __generator: CA,
  __importDefault: HA,
  __importStar: jA,
  __makeTemplateObject: DA,
  __metadata: NA,
  __param: OA,
  __propKey: XP,
  __read: ax,
  __rest: TA,
  __runInitializers: ZP,
  __setFunctionName: ev,
  __spread: IA,
  __spreadArray: UA,
  __spreadArrays: _A,
  __values: Od,
  default: nv
}, Symbol.toStringTag, { value: "Module" })), iv = /* @__PURE__ */ zw(sv);
var fp = {}, qu = {}, n1;
function ox() {
  return n1 || (n1 = 1, Object.defineProperty(qu, "__esModule", { value: !0 }), qu.version = void 0, qu.version = "6.13.4"), qu;
}
var dp = {}, Wu = {}, hp = {}, ea = {}, mt = {}, Ut = {}, ta = {}, s1;
function So() {
  if (s1) return ta;
  s1 = 1, Object.defineProperty(ta, "__esModule", { value: !0 }), ta.defineProperties = ta.resolveProperties = void 0;
  function r(n, s, i) {
    const a = s.split("|").map((u) => u.trim());
    for (let u = 0; u < a.length; u++)
      switch (s) {
        case "any":
          return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
          if (typeof n === s)
            return;
      }
    const o = new Error(`invalid value for type ${s}`);
    throw o.code = "INVALID_ARGUMENT", o.argument = `value.${i}`, o.value = n, o;
  }
  async function e(n) {
    const s = Object.keys(n);
    return (await Promise.all(s.map((a) => Promise.resolve(n[a])))).reduce((a, o, u) => (a[s[u]] = o, a), {});
  }
  ta.resolveProperties = e;
  function t(n, s, i) {
    for (let a in s) {
      let o = s[a];
      const u = i ? i[a] : null;
      u && r(o, u, a), Object.defineProperty(n, a, { enumerable: !0, value: o, writable: !1 });
    }
  }
  return ta.defineProperties = t, ta;
}
var i1;
function rs() {
  if (i1) return Ut;
  i1 = 1, Object.defineProperty(Ut, "__esModule", { value: !0 }), Ut.assertPrivate = Ut.assertNormalize = Ut.assertArgumentCount = Ut.assertArgument = Ut.assert = Ut.makeError = Ut.isCallException = Ut.isError = void 0;
  const r = ox(), e = So();
  function t(d) {
    if (d == null)
      return "null";
    if (Array.isArray(d))
      return "[ " + d.map(t).join(", ") + " ]";
    if (d instanceof Uint8Array) {
      const h = "0123456789abcdef";
      let p = "0x";
      for (let g = 0; g < d.length; g++)
        p += h[d[g] >> 4], p += h[d[g] & 15];
      return p;
    }
    if (typeof d == "object" && typeof d.toJSON == "function")
      return t(d.toJSON());
    switch (typeof d) {
      case "boolean":
      case "symbol":
        return d.toString();
      case "bigint":
        return BigInt(d).toString();
      case "number":
        return d.toString();
      case "string":
        return JSON.stringify(d);
      case "object": {
        const h = Object.keys(d);
        return h.sort(), "{ " + h.map((p) => `${t(p)}: ${t(d[p])}`).join(", ") + " }";
      }
    }
    return "[ COULD NOT SERIALIZE ]";
  }
  function n(d, h) {
    return d && d.code === h;
  }
  Ut.isError = n;
  function s(d) {
    return n(d, "CALL_EXCEPTION");
  }
  Ut.isCallException = s;
  function i(d, h, p) {
    let g = d;
    {
      const A = [];
      if (p) {
        if ("message" in p || "code" in p || "name" in p)
          throw new Error(`value will overwrite populated values: ${t(p)}`);
        for (const y in p) {
          if (y === "shortMessage")
            continue;
          const E = p[y];
          A.push(y + "=" + t(E));
        }
      }
      A.push(`code=${h}`), A.push(`version=${r.version}`), A.length && (d += " (" + A.join(", ") + ")");
    }
    let k;
    switch (h) {
      case "INVALID_ARGUMENT":
        k = new TypeError(d);
        break;
      case "NUMERIC_FAULT":
      case "BUFFER_OVERRUN":
        k = new RangeError(d);
        break;
      default:
        k = new Error(d);
    }
    return (0, e.defineProperties)(k, { code: h }), p && Object.assign(k, p), k.shortMessage == null && (0, e.defineProperties)(k, { shortMessage: g }), k;
  }
  Ut.makeError = i;
  function a(d, h, p, g) {
    if (!d)
      throw i(h, p, g);
  }
  Ut.assert = a;
  function o(d, h, p, g) {
    a(d, h, "INVALID_ARGUMENT", { argument: p, value: g });
  }
  Ut.assertArgument = o;
  function u(d, h, p) {
    p == null && (p = ""), p && (p = ": " + p), a(d >= h, "missing arguemnt" + p, "MISSING_ARGUMENT", {
      count: d,
      expectedCount: h
    }), a(d <= h, "too many arguments" + p, "UNEXPECTED_ARGUMENT", {
      count: d,
      expectedCount: h
    });
  }
  Ut.assertArgumentCount = u;
  const c = ["NFD", "NFC", "NFKD", "NFKC"].reduce((d, h) => {
    try {
      if ("test".normalize(h) !== "test")
        throw new Error("bad");
      if (h === "NFD" && "é".normalize("NFD") !== "é")
        throw new Error("broken");
      d.push(h);
    } catch {
    }
    return d;
  }, []);
  function l(d) {
    a(c.indexOf(d) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
      operation: "String.prototype.normalize",
      info: { form: d }
    });
  }
  Ut.assertNormalize = l;
  function f(d, h, p) {
    if (p == null && (p = ""), d !== h) {
      let g = p, k = "new";
      p && (g += ".", k += " " + p), a(!1, `private constructor; use ${g}from* methods`, "UNSUPPORTED_OPERATION", {
        operation: k
      });
    }
  }
  return Ut.assertPrivate = f, Ut;
}
var a1;
function Tn() {
  if (a1) return mt;
  a1 = 1, Object.defineProperty(mt, "__esModule", { value: !0 }), mt.zeroPadBytes = mt.zeroPadValue = mt.stripZerosLeft = mt.dataSlice = mt.dataLength = mt.concat = mt.hexlify = mt.isBytesLike = mt.isHexString = mt.getBytesCopy = mt.getBytes = void 0;
  const r = rs();
  function e(g, k, A) {
    if (g instanceof Uint8Array)
      return A ? new Uint8Array(g) : g;
    if (typeof g == "string" && g.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
      const y = new Uint8Array((g.length - 2) / 2);
      let E = 2;
      for (let m = 0; m < y.length; m++)
        y[m] = parseInt(g.substring(E, E + 2), 16), E += 2;
      return y;
    }
    (0, r.assertArgument)(!1, "invalid BytesLike value", k || "value", g);
  }
  function t(g, k) {
    return e(g, k, !1);
  }
  mt.getBytes = t;
  function n(g, k) {
    return e(g, k, !0);
  }
  mt.getBytesCopy = n;
  function s(g, k) {
    return !(typeof g != "string" || !g.match(/^0x[0-9A-Fa-f]*$/) || typeof k == "number" && g.length !== 2 + 2 * k || k === !0 && g.length % 2 !== 0);
  }
  mt.isHexString = s;
  function i(g) {
    return s(g, !0) || g instanceof Uint8Array;
  }
  mt.isBytesLike = i;
  const a = "0123456789abcdef";
  function o(g) {
    const k = t(g);
    let A = "0x";
    for (let y = 0; y < k.length; y++) {
      const E = k[y];
      A += a[(E & 240) >> 4] + a[E & 15];
    }
    return A;
  }
  mt.hexlify = o;
  function u(g) {
    return "0x" + g.map((k) => o(k).substring(2)).join("");
  }
  mt.concat = u;
  function c(g) {
    return s(g, !0) ? (g.length - 2) / 2 : t(g).length;
  }
  mt.dataLength = c;
  function l(g, k, A) {
    const y = t(g);
    return A != null && A > y.length && (0, r.assert)(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
      buffer: y,
      length: y.length,
      offset: A
    }), o(y.slice(k ?? 0, A ?? y.length));
  }
  mt.dataSlice = l;
  function f(g) {
    let k = o(g).substring(2);
    for (; k.startsWith("00"); )
      k = k.substring(2);
    return "0x" + k;
  }
  mt.stripZerosLeft = f;
  function d(g, k, A) {
    const y = t(g);
    (0, r.assert)(k >= y.length, "padding exceeds data length", "BUFFER_OVERRUN", {
      buffer: new Uint8Array(y),
      length: k,
      offset: k + 1
    });
    const E = new Uint8Array(k);
    return E.fill(0), A ? E.set(y, k - y.length) : E.set(y, 0), o(E);
  }
  function h(g, k) {
    return d(g, k, !0);
  }
  mt.zeroPadValue = h;
  function p(g, k) {
    return d(g, k, !1);
  }
  return mt.zeroPadBytes = p, mt;
}
var yt = {}, o1;
function lf() {
  if (o1) return yt;
  o1 = 1, Object.defineProperty(yt, "__esModule", { value: !0 }), yt.toQuantity = yt.toBeArray = yt.toBeHex = yt.toNumber = yt.getNumber = yt.toBigInt = yt.getUint = yt.getBigInt = yt.mask = yt.toTwos = yt.fromTwos = void 0;
  const r = Tn(), e = rs(), t = BigInt(0), n = BigInt(1), s = 9007199254740991;
  function i(A, y) {
    const E = c(A, "value"), m = BigInt(d(y, "width"));
    if ((0, e.assert)(E >> m === t, "overflow", "NUMERIC_FAULT", {
      operation: "fromTwos",
      fault: "overflow",
      value: A
    }), E >> m - n) {
      const N = (n << m) - n;
      return -((~E & N) + n);
    }
    return E;
  }
  yt.fromTwos = i;
  function a(A, y) {
    let E = u(A, "value");
    const m = BigInt(d(y, "width")), N = n << m - n;
    if (E < t) {
      E = -E, (0, e.assert)(E <= N, "too low", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: A
      });
      const T = (n << m) - n;
      return (~E & T) + n;
    } else
      (0, e.assert)(E < N, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: A
      });
    return E;
  }
  yt.toTwos = a;
  function o(A, y) {
    const E = c(A, "value"), m = BigInt(d(y, "bits"));
    return E & (n << m) - n;
  }
  yt.mask = o;
  function u(A, y) {
    switch (typeof A) {
      case "bigint":
        return A;
      case "number":
        return (0, e.assertArgument)(Number.isInteger(A), "underflow", y || "value", A), (0, e.assertArgument)(A >= -s && A <= s, "overflow", y || "value", A), BigInt(A);
      case "string":
        try {
          if (A === "")
            throw new Error("empty string");
          return A[0] === "-" && A[1] !== "-" ? -BigInt(A.substring(1)) : BigInt(A);
        } catch (E) {
          (0, e.assertArgument)(!1, `invalid BigNumberish string: ${E.message}`, y || "value", A);
        }
    }
    (0, e.assertArgument)(!1, "invalid BigNumberish value", y || "value", A);
  }
  yt.getBigInt = u;
  function c(A, y) {
    const E = u(A, y);
    return (0, e.assert)(E >= t, "unsigned value cannot be negative", "NUMERIC_FAULT", {
      fault: "overflow",
      operation: "getUint",
      value: A
    }), E;
  }
  yt.getUint = c;
  const l = "0123456789abcdef";
  function f(A) {
    if (A instanceof Uint8Array) {
      let y = "0x0";
      for (const E of A)
        y += l[E >> 4], y += l[E & 15];
      return BigInt(y);
    }
    return u(A);
  }
  yt.toBigInt = f;
  function d(A, y) {
    switch (typeof A) {
      case "bigint":
        return (0, e.assertArgument)(A >= -s && A <= s, "overflow", y || "value", A), Number(A);
      case "number":
        return (0, e.assertArgument)(Number.isInteger(A), "underflow", y || "value", A), (0, e.assertArgument)(A >= -s && A <= s, "overflow", y || "value", A), A;
      case "string":
        try {
          if (A === "")
            throw new Error("empty string");
          return d(BigInt(A), y);
        } catch (E) {
          (0, e.assertArgument)(!1, `invalid numeric string: ${E.message}`, y || "value", A);
        }
    }
    (0, e.assertArgument)(!1, "invalid numeric value", y || "value", A);
  }
  yt.getNumber = d;
  function h(A) {
    return d(f(A));
  }
  yt.toNumber = h;
  function p(A, y) {
    let m = c(A, "value").toString(16);
    if (y == null)
      m.length % 2 && (m = "0" + m);
    else {
      const N = d(y, "width");
      for ((0, e.assert)(N * 2 >= m.length, `value exceeds width (${N} bytes)`, "NUMERIC_FAULT", {
        operation: "toBeHex",
        fault: "overflow",
        value: A
      }); m.length < N * 2; )
        m = "0" + m;
    }
    return "0x" + m;
  }
  yt.toBeHex = p;
  function g(A) {
    const y = c(A, "value");
    if (y === t)
      return new Uint8Array([]);
    let E = y.toString(16);
    E.length % 2 && (E = "0" + E);
    const m = new Uint8Array(E.length / 2);
    for (let N = 0; N < m.length; N++) {
      const T = N * 2;
      m[N] = parseInt(E.substring(T, T + 2), 16);
    }
    return m;
  }
  yt.toBeArray = g;
  function k(A) {
    let y = (0, r.hexlify)((0, r.isBytesLike)(A) ? A : g(A)).substring(2);
    for (; y.startsWith("0"); )
      y = y.substring(1);
    return y === "" && (y = "0"), "0x" + y;
  }
  return yt.toQuantity = k, yt;
}
var c1;
function av() {
  if (c1) return ea;
  c1 = 1, Object.defineProperty(ea, "__esModule", { value: !0 }), ea.decodeBase58 = ea.encodeBase58 = void 0;
  const r = Tn(), e = rs(), t = lf(), n = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  let s = null;
  function i(l) {
    if (s == null) {
      s = {};
      for (let d = 0; d < n.length; d++)
        s[n[d]] = BigInt(d);
    }
    const f = s[l];
    return (0, e.assertArgument)(f != null, "invalid base58 value", "letter", l), f;
  }
  const a = BigInt(0), o = BigInt(58);
  function u(l) {
    const f = (0, r.getBytes)(l);
    let d = (0, t.toBigInt)(f), h = "";
    for (; d; )
      h = n[Number(d % o)] + h, d /= o;
    for (let p = 0; p < f.length && !f[p]; p++)
      h = n[0] + h;
    return h;
  }
  ea.encodeBase58 = u;
  function c(l) {
    let f = a;
    for (let d = 0; d < l.length; d++)
      f *= o, f += i(l[d]);
    return f;
  }
  return ea.decodeBase58 = c, ea;
}
var ra = {}, u1;
function JA() {
  if (u1) return ra;
  u1 = 1, Object.defineProperty(ra, "__esModule", { value: !0 }), ra.encodeBase64 = ra.decodeBase64 = void 0;
  const r = Tn();
  function e(n) {
    n = atob(n);
    const s = new Uint8Array(n.length);
    for (let i = 0; i < n.length; i++)
      s[i] = n.charCodeAt(i);
    return (0, r.getBytes)(s);
  }
  ra.decodeBase64 = e;
  function t(n) {
    const s = (0, r.getBytes)(n);
    let i = "";
    for (let a = 0; a < s.length; a++)
      i += String.fromCharCode(s[a]);
    return btoa(i);
  }
  return ra.encodeBase64 = t, ra;
}
var Yu = {}, l1;
function ov() {
  var t;
  if (l1) return Yu;
  l1 = 1, Object.defineProperty(Yu, "__esModule", { value: !0 }), Yu.EventPayload = void 0;
  const r = So();
  class e {
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */
    constructor(s, i, a) {
      /**
       *  The event filter.
       */
      Q(this, "filter");
      /**
       *  The **EventEmitterable**.
       */
      Q(this, "emitter");
      Z(this, t);
      F(this, t, i), (0, r.defineProperties)(this, { emitter: s, filter: a });
    }
    /**
     *  Unregister the triggered listener for future events.
     */
    async removeListener() {
      x(this, t) != null && await this.emitter.off(this.filter, x(this, t));
    }
  }
  return t = new WeakMap(), Yu.EventPayload = e, Yu;
}
var ss = {}, pp = {}, f1;
function cx() {
  return f1 || (f1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.toUtf8CodePoints = r.toUtf8String = r.toUtf8Bytes = r.Utf8ErrorFuncs = void 0;
    const e = Tn(), t = rs();
    function n(f, d, h, p, g) {
      (0, t.assertArgument)(!1, `invalid codepoint at offset ${d}; ${f}`, "bytes", h);
    }
    function s(f, d, h, p, g) {
      if (f === "BAD_PREFIX" || f === "UNEXPECTED_CONTINUE") {
        let k = 0;
        for (let A = d + 1; A < h.length && h[A] >> 6 === 2; A++)
          k++;
        return k;
      }
      return f === "OVERRUN" ? h.length - d - 1 : 0;
    }
    function i(f, d, h, p, g) {
      return f === "OVERLONG" ? ((0, t.assertArgument)(typeof g == "number", "invalid bad code point for replacement", "badCodepoint", g), p.push(g), 0) : (p.push(65533), s(f, d, h));
    }
    r.Utf8ErrorFuncs = Object.freeze({
      error: n,
      ignore: s,
      replace: i
    });
    function a(f, d) {
      d == null && (d = r.Utf8ErrorFuncs.error);
      const h = (0, e.getBytes)(f, "bytes"), p = [];
      let g = 0;
      for (; g < h.length; ) {
        const k = h[g++];
        if (!(k >> 7)) {
          p.push(k);
          continue;
        }
        let A = null, y = null;
        if ((k & 224) === 192)
          A = 1, y = 127;
        else if ((k & 240) === 224)
          A = 2, y = 2047;
        else if ((k & 248) === 240)
          A = 3, y = 65535;
        else {
          (k & 192) === 128 ? g += d("UNEXPECTED_CONTINUE", g - 1, h, p) : g += d("BAD_PREFIX", g - 1, h, p);
          continue;
        }
        if (g - 1 + A >= h.length) {
          g += d("OVERRUN", g - 1, h, p);
          continue;
        }
        let E = k & (1 << 8 - A - 1) - 1;
        for (let m = 0; m < A; m++) {
          let N = h[g];
          if ((N & 192) != 128) {
            g += d("MISSING_CONTINUE", g, h, p), E = null;
            break;
          }
          E = E << 6 | N & 63, g++;
        }
        if (E !== null) {
          if (E > 1114111) {
            g += d("OUT_OF_RANGE", g - 1 - A, h, p, E);
            continue;
          }
          if (E >= 55296 && E <= 57343) {
            g += d("UTF16_SURROGATE", g - 1 - A, h, p, E);
            continue;
          }
          if (E <= y) {
            g += d("OVERLONG", g - 1 - A, h, p, E);
            continue;
          }
          p.push(E);
        }
      }
      return p;
    }
    function o(f, d) {
      (0, t.assertArgument)(typeof f == "string", "invalid string value", "str", f), d != null && ((0, t.assertNormalize)(d), f = f.normalize(d));
      let h = [];
      for (let p = 0; p < f.length; p++) {
        const g = f.charCodeAt(p);
        if (g < 128)
          h.push(g);
        else if (g < 2048)
          h.push(g >> 6 | 192), h.push(g & 63 | 128);
        else if ((g & 64512) == 55296) {
          p++;
          const k = f.charCodeAt(p);
          (0, t.assertArgument)(p < f.length && (k & 64512) === 56320, "invalid surrogate pair", "str", f);
          const A = 65536 + ((g & 1023) << 10) + (k & 1023);
          h.push(A >> 18 | 240), h.push(A >> 12 & 63 | 128), h.push(A >> 6 & 63 | 128), h.push(A & 63 | 128);
        } else
          h.push(g >> 12 | 224), h.push(g >> 6 & 63 | 128), h.push(g & 63 | 128);
      }
      return new Uint8Array(h);
    }
    r.toUtf8Bytes = o;
    function u(f) {
      return f.map((d) => d <= 65535 ? String.fromCharCode(d) : (d -= 65536, String.fromCharCode((d >> 10 & 1023) + 55296, (d & 1023) + 56320))).join("");
    }
    function c(f, d) {
      return u(a(f, d));
    }
    r.toUtf8String = c;
    function l(f, d) {
      return a(o(f, d));
    }
    r.toUtf8CodePoints = l;
  }(pp)), pp;
}
var na = {}, d1;
function cv() {
  if (d1) return na;
  d1 = 1, Object.defineProperty(na, "__esModule", { value: !0 }), na.getUrl = na.createGetUrl = void 0;
  const r = rs();
  function e(s) {
    async function i(a, o) {
      (0, r.assert)(o == null || !o.cancelled, "request cancelled before sending", "CANCELLED");
      const u = a.url.split(":")[0].toLowerCase();
      (0, r.assert)(u === "http" || u === "https", `unsupported protocol ${u}`, "UNSUPPORTED_OPERATION", {
        info: { protocol: u },
        operation: "request"
      }), (0, r.assert)(u === "https" || !a.credentials || a.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
        operation: "request"
      });
      let c = null;
      const l = new AbortController(), f = setTimeout(() => {
        c = (0, r.makeError)("request timeout", "TIMEOUT"), l.abort();
      }, a.timeout);
      o && o.addListener(() => {
        c = (0, r.makeError)("request cancelled", "CANCELLED"), l.abort();
      });
      const d = {
        method: a.method,
        headers: new Headers(Array.from(a)),
        body: a.body || void 0,
        signal: l.signal
      };
      let h;
      try {
        h = await fetch(a.url, d);
      } catch (A) {
        throw clearTimeout(f), c || A;
      }
      clearTimeout(f);
      const p = {};
      h.headers.forEach((A, y) => {
        p[y.toLowerCase()] = A;
      });
      const g = await h.arrayBuffer(), k = g == null ? null : new Uint8Array(g);
      return {
        statusCode: h.status,
        statusMessage: h.statusText,
        headers: p,
        body: k
      };
    }
    return i;
  }
  na.createGetUrl = e;
  const t = e();
  async function n(s, i) {
    return t(s, i);
  }
  return na.getUrl = n, na;
}
var h1;
function uv() {
  var U, R, j, D, O, I, P, S, B, C, H, V, J, M, G, K, X, te, d0, ye, re, ae, L, ne, oe;
  if (h1) return ss;
  h1 = 1, Object.defineProperty(ss, "__esModule", { value: !0 }), ss.FetchResponse = ss.FetchRequest = ss.FetchCancelSignal = void 0;
  const r = JA(), e = Tn(), t = rs(), n = So(), s = cx(), i = cv(), a = 12, o = 250;
  let u = (0, i.createGetUrl)();
  const c = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), l = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
  let f = !1;
  async function d(W, v) {
    try {
      const z = W.match(c);
      if (!z)
        throw new Error("invalid data");
      return new E(200, "OK", {
        "content-type": z[1] || "text/plain"
      }, z[2] ? (0, r.decodeBase64)(z[3]) : N(z[3]));
    } catch {
      return new E(599, "BAD REQUEST (invalid data: URI)", {}, null, new y(W));
    }
  }
  function h(W) {
    async function v(z, q) {
      try {
        const le = z.match(l);
        if (!le)
          throw new Error("invalid link");
        return new y(`${W}${le[2]}`);
      } catch {
        return new E(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new y(z));
      }
    }
    return v;
  }
  const p = {
    data: d,
    ipfs: h("https://gateway.ipfs.io/ipfs/")
  }, g = /* @__PURE__ */ new WeakMap();
  class k {
    constructor(v) {
      Z(this, U);
      Z(this, R);
      F(this, U, []), F(this, R, !1), g.set(v, () => {
        if (!x(this, R)) {
          F(this, R, !0);
          for (const z of x(this, U))
            setTimeout(() => {
              z();
            }, 0);
          F(this, U, []);
        }
      });
    }
    addListener(v) {
      (0, t.assert)(!x(this, R), "singal already cancelled", "UNSUPPORTED_OPERATION", {
        operation: "fetchCancelSignal.addCancelListener"
      }), x(this, U).push(v);
    }
    get cancelled() {
      return x(this, R);
    }
    checkSignal() {
      (0, t.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
  }
  U = new WeakMap(), R = new WeakMap(), ss.FetchCancelSignal = k;
  function A(W) {
    if (W == null)
      throw new Error("missing signal; should not happen");
    return W.checkSignal(), W;
  }
  const he = class he {
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */
    constructor(v) {
      Z(this, te);
      Z(this, j);
      Z(this, D);
      Z(this, O);
      Z(this, I);
      Z(this, P);
      Z(this, S);
      Z(this, B);
      Z(this, C);
      Z(this, H);
      // Hooks
      Z(this, V);
      Z(this, J);
      Z(this, M);
      Z(this, G);
      Z(this, K);
      Z(this, X);
      F(this, S, String(v)), F(this, j, !1), F(this, D, !0), F(this, O, {}), F(this, I, ""), F(this, P, 3e5), F(this, K, {
        slotInterval: o,
        maxAttempts: a
      }), F(this, X, null);
    }
    /**
     *  The fetch URL to request.
     */
    get url() {
      return x(this, S);
    }
    set url(v) {
      F(this, S, String(v));
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */
    get body() {
      return x(this, B) == null ? null : new Uint8Array(x(this, B));
    }
    set body(v) {
      if (v == null)
        F(this, B, void 0), F(this, C, void 0);
      else if (typeof v == "string")
        F(this, B, (0, s.toUtf8Bytes)(v)), F(this, C, "text/plain");
      else if (v instanceof Uint8Array)
        F(this, B, v), F(this, C, "application/octet-stream");
      else if (typeof v == "object")
        F(this, B, (0, s.toUtf8Bytes)(JSON.stringify(v))), F(this, C, "application/json");
      else
        throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */
    hasBody() {
      return x(this, B) != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */
    get method() {
      return x(this, I) ? x(this, I) : this.hasBody() ? "POST" : "GET";
    }
    set method(v) {
      v == null && (v = ""), F(this, I, String(v).toUpperCase());
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */
    get headers() {
      const v = Object.assign({}, x(this, O));
      return x(this, H) && (v.authorization = `Basic ${(0, r.encodeBase64)((0, s.toUtf8Bytes)(x(this, H)))}`), this.allowGzip && (v["accept-encoding"] = "gzip"), v["content-type"] == null && x(this, C) && (v["content-type"] = x(this, C)), this.body && (v["content-length"] = String(this.body.length)), v;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */
    getHeader(v) {
      return this.headers[v.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */
    setHeader(v, z) {
      x(this, O)[String(v).toLowerCase()] = String(z);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */
    clearHeaders() {
      F(this, O, {});
    }
    [Symbol.iterator]() {
      const v = this.headers, z = Object.keys(v);
      let q = 0;
      return {
        next: () => {
          if (q < z.length) {
            const le = z[q++];
            return {
              value: [le, v[le]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */
    get credentials() {
      return x(this, H) || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */
    setCredentials(v, z) {
      (0, t.assertArgument)(!v.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), F(this, H, `${v}:${z}`);
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */
    get allowGzip() {
      return x(this, D);
    }
    set allowGzip(v) {
      F(this, D, !!v);
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */
    get allowInsecureAuthentication() {
      return !!x(this, j);
    }
    set allowInsecureAuthentication(v) {
      F(this, j, !!v);
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */
    get timeout() {
      return x(this, P);
    }
    set timeout(v) {
      (0, t.assertArgument)(v >= 0, "timeout must be non-zero", "timeout", v), F(this, P, v);
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */
    get preflightFunc() {
      return x(this, V) || null;
    }
    set preflightFunc(v) {
      F(this, V, v);
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */
    get processFunc() {
      return x(this, J) || null;
    }
    set processFunc(v) {
      F(this, J, v);
    }
    /**
     *  This function is called on each retry attempt.
     */
    get retryFunc() {
      return x(this, M) || null;
    }
    set retryFunc(v) {
      F(this, M, v);
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */
    get getUrlFunc() {
      return x(this, X) || u;
    }
    set getUrlFunc(v) {
      F(this, X, v);
    }
    toString() {
      return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${x(this, B) ? (0, e.hexlify)(x(this, B)) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */
    setThrottleParams(v) {
      v.slotInterval != null && (x(this, K).slotInterval = v.slotInterval), v.maxAttempts != null && (x(this, K).maxAttempts = v.maxAttempts);
    }
    /**
     *  Resolves to the response by sending the request.
     */
    send() {
      return (0, t.assert)(x(this, G) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), F(this, G, new k(this)), de(this, te, d0).call(this, 0, m() + this.timeout, 0, this, new E(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */
    cancel() {
      (0, t.assert)(x(this, G) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
      const v = g.get(this);
      if (!v)
        throw new Error("missing signal; should not happen");
      v();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */
    redirect(v) {
      const z = this.url.split(":")[0].toLowerCase(), q = v.split(":")[0].toLowerCase();
      (0, t.assert)(this.method === "GET" && (z !== "https" || q !== "http") && v.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
        operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(v)})`
      });
      const le = new he(v);
      return le.method = "GET", le.allowGzip = this.allowGzip, le.timeout = this.timeout, F(le, O, Object.assign({}, x(this, O))), x(this, B) && F(le, B, new Uint8Array(x(this, B))), F(le, C, x(this, C)), le;
    }
    /**
     *  Create a new copy of this request.
     */
    clone() {
      const v = new he(this.url);
      return F(v, I, x(this, I)), x(this, B) && F(v, B, x(this, B)), F(v, C, x(this, C)), F(v, O, Object.assign({}, x(this, O))), F(v, H, x(this, H)), this.allowGzip && (v.allowGzip = !0), v.timeout = this.timeout, this.allowInsecureAuthentication && (v.allowInsecureAuthentication = !0), F(v, V, x(this, V)), F(v, J, x(this, J)), F(v, M, x(this, M)), F(v, K, Object.assign({}, x(this, K))), F(v, X, x(this, X)), v;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */
    static lockConfig() {
      f = !0;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */
    static getGateway(v) {
      return p[v.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGateway(v, z) {
      if (v = v.toLowerCase(), v === "http" || v === "https")
        throw new Error(`cannot intercept ${v}; use registerGetUrl`);
      if (f)
        throw new Error("gateways locked");
      p[v] = z;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */
    static registerGetUrl(v) {
      if (f)
        throw new Error("gateways locked");
      u = v;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */
    static createGetUrlFunc(v) {
      return (0, i.createGetUrl)(v);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */
    static createDataGateway() {
      return d;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */
    static createIpfsGatewayFunc(v) {
      return h(v);
    }
  };
  j = new WeakMap(), D = new WeakMap(), O = new WeakMap(), I = new WeakMap(), P = new WeakMap(), S = new WeakMap(), B = new WeakMap(), C = new WeakMap(), H = new WeakMap(), V = new WeakMap(), J = new WeakMap(), M = new WeakMap(), G = new WeakMap(), K = new WeakMap(), X = new WeakMap(), te = new WeakSet(), d0 = async function(v, z, q, le, be) {
    var se, me, fe;
    if (v >= x(this, K).maxAttempts)
      return be.makeServerError("exceeded maximum retry limit");
    (0, t.assert)(m() <= z, "timeout", "TIMEOUT", {
      operation: "request.send",
      reason: "timeout",
      request: le
    }), q > 0 && await T(q);
    let ve = this.clone();
    const Be = (ve.url.split(":")[0] || "").toLowerCase();
    if (Be in p) {
      const _ = await p[Be](ve.url, A(x(le, G)));
      if (_ instanceof E) {
        let b = _;
        if (this.processFunc) {
          A(x(le, G));
          try {
            b = await this.processFunc(ve, b);
          } catch (w) {
            (w.throttle == null || typeof w.stall != "number") && b.makeServerError("error in post-processing function", w).assertOk();
          }
        }
        return b;
      }
      ve = _;
    }
    this.preflightFunc && (ve = await this.preflightFunc(ve));
    const Ae = await this.getUrlFunc(ve, A(x(le, G)));
    let ie = new E(Ae.statusCode, Ae.statusMessage, Ae.headers, Ae.body, le);
    if (ie.statusCode === 301 || ie.statusCode === 302) {
      try {
        const _ = ie.headers.location || "";
        return de(se = ve.redirect(_), te, d0).call(se, v + 1, z, 0, le, ie);
      } catch {
      }
      return ie;
    } else if (ie.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(ve, ie, v))) {
      const _ = ie.headers["retry-after"];
      let b = x(this, K).slotInterval * Math.trunc(Math.random() * Math.pow(2, v));
      return typeof _ == "string" && _.match(/^[1-9][0-9]*$/) && (b = parseInt(_)), de(me = ve.clone(), te, d0).call(me, v + 1, z, b, le, ie);
    }
    if (this.processFunc) {
      A(x(le, G));
      try {
        ie = await this.processFunc(ve, ie);
      } catch (_) {
        (_.throttle == null || typeof _.stall != "number") && ie.makeServerError("error in post-processing function", _).assertOk();
        let b = x(this, K).slotInterval * Math.trunc(Math.random() * Math.pow(2, v));
        return _.stall >= 0 && (b = _.stall), de(fe = ve.clone(), te, d0).call(fe, v + 1, z, b, le, ie);
      }
    }
    return ie;
  };
  let y = he;
  ss.FetchRequest = y;
  const ee = class ee {
    constructor(v, z, q, le, be) {
      Z(this, ye);
      Z(this, re);
      Z(this, ae);
      Z(this, L);
      Z(this, ne);
      Z(this, oe);
      F(this, ye, v), F(this, re, z), F(this, ae, Object.keys(q).reduce((ve, Be) => (ve[Be.toLowerCase()] = String(q[Be]), ve), {})), F(this, L, le == null ? null : new Uint8Array(le)), F(this, ne, be || null), F(this, oe, { message: "" });
    }
    toString() {
      return `<FetchResponse status=${this.statusCode} body=${x(this, L) ? (0, e.hexlify)(x(this, L)) : "null"}>`;
    }
    /**
     *  The response status code.
     */
    get statusCode() {
      return x(this, ye);
    }
    /**
     *  The response status message.
     */
    get statusMessage() {
      return x(this, re);
    }
    /**
     *  The response headers. All keys are lower-case.
     */
    get headers() {
      return Object.assign({}, x(this, ae));
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */
    get body() {
      return x(this, L) == null ? null : new Uint8Array(x(this, L));
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */
    get bodyText() {
      try {
        return x(this, L) == null ? "" : (0, s.toUtf8String)(x(this, L));
      } catch {
        (0, t.assert)(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
          operation: "bodyText",
          info: { response: this }
        });
      }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */
    get bodyJson() {
      try {
        return JSON.parse(this.bodyText);
      } catch {
        (0, t.assert)(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
          operation: "bodyJson",
          info: { response: this }
        });
      }
    }
    [Symbol.iterator]() {
      const v = this.headers, z = Object.keys(v);
      let q = 0;
      return {
        next: () => {
          if (q < z.length) {
            const le = z[q++];
            return {
              value: [le, v[le]],
              done: !1
            };
          }
          return { value: void 0, done: !0 };
        }
      };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */
    makeServerError(v, z) {
      let q;
      v ? q = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${v})` : (v = `${this.statusCode} ${this.statusMessage}`, q = `CLIENT ESCALATED SERVER ERROR (${v})`);
      const le = new ee(599, q, this.headers, this.body, x(this, ne) || void 0);
      return F(le, oe, { message: v, error: z }), le;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */
    throwThrottleError(v, z) {
      z == null ? z = -1 : (0, t.assertArgument)(Number.isInteger(z) && z >= 0, "invalid stall timeout", "stall", z);
      const q = new Error(v || "throttling requests");
      throw (0, n.defineProperties)(q, { stall: z, throttle: !0 }), q;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */
    getHeader(v) {
      return this.headers[v.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */
    hasBody() {
      return x(this, L) != null;
    }
    /**
     *  The request made for this response.
     */
    get request() {
      return x(this, ne);
    }
    /**
     *  Returns true if this response was a success statusCode.
     */
    ok() {
      return x(this, oe).message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */
    assertOk() {
      if (this.ok())
        return;
      let { message: v, error: z } = x(this, oe);
      v === "" && (v = `server response ${this.statusCode} ${this.statusMessage}`);
      let q = null;
      this.request && (q = this.request.url);
      let le = null;
      try {
        x(this, L) && (le = (0, s.toUtf8String)(x(this, L)));
      } catch {
      }
      (0, t.assert)(!1, v, "SERVER_ERROR", {
        request: this.request || "unknown request",
        response: this,
        error: z,
        info: {
          requestUrl: q,
          responseBody: le,
          responseStatus: `${this.statusCode} ${this.statusMessage}`
        }
      });
    }
  };
  ye = new WeakMap(), re = new WeakMap(), ae = new WeakMap(), L = new WeakMap(), ne = new WeakMap(), oe = new WeakMap();
  let E = ee;
  ss.FetchResponse = E;
  function m() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function N(W) {
    return (0, s.toUtf8Bytes)(W.replace(/%([0-9a-f][0-9a-f])/gi, (v, z) => String.fromCharCode(parseInt(z, 16))));
  }
  function T(W) {
    return new Promise((v) => setTimeout(v, W));
  }
  return ss;
}
var Zu = {}, p1;
function QA() {
  var g, k, A, y, Sa, ds, Pb, vb, kb, Tb;
  if (p1) return Zu;
  p1 = 1, Object.defineProperty(Zu, "__esModule", { value: !0 }), Zu.FixedNumber = void 0;
  const r = Tn(), e = rs(), t = lf(), n = So(), s = BigInt(-1), i = BigInt(0), a = BigInt(1), o = BigInt(5), u = {};
  let c = "0000";
  for (; c.length < 80; )
    c += c;
  function l(D) {
    let O = c;
    for (; O.length < D; )
      O += O;
    return BigInt("1" + O.substring(0, D));
  }
  function f(D, O, I) {
    const P = BigInt(O.width);
    if (O.signed) {
      const S = a << P - a;
      (0, e.assert)(I == null || D >= -S && D < S, "overflow", "NUMERIC_FAULT", {
        operation: I,
        fault: "overflow",
        value: D
      }), D > i ? D = (0, t.fromTwos)((0, t.mask)(D, P), P) : D = -(0, t.fromTwos)((0, t.mask)(-D, P), P);
    } else {
      const S = a << P;
      (0, e.assert)(I == null || D >= 0 && D < S, "overflow", "NUMERIC_FAULT", {
        operation: I,
        fault: "overflow",
        value: D
      }), D = (D % S + S) % S & S - a;
    }
    return D;
  }
  function d(D) {
    typeof D == "number" && (D = `fixed128x${D}`);
    let O = !0, I = 128, P = 18;
    if (typeof D == "string") {
      if (D !== "fixed") if (D === "ufixed")
        O = !1;
      else {
        const B = D.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        (0, e.assertArgument)(B, "invalid fixed format", "format", D), O = B[1] !== "u", I = parseInt(B[2]), P = parseInt(B[3]);
      }
    } else if (D) {
      const B = D, C = (H, V, J) => B[H] == null ? J : ((0, e.assertArgument)(typeof B[H] === V, "invalid fixed format (" + H + " not " + V + ")", "format." + H, B[H]), B[H]);
      O = C("signed", "boolean", O), I = C("width", "number", I), P = C("decimals", "number", P);
    }
    (0, e.assertArgument)(I % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", I), (0, e.assertArgument)(P <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", P);
    const S = (O ? "" : "u") + "fixed" + String(I) + "x" + String(P);
    return { signed: O, width: I, decimals: P, name: S };
  }
  function h(D, O) {
    let I = "";
    D < i && (I = "-", D *= s);
    let P = D.toString();
    if (O === 0)
      return I + P;
    for (; P.length <= O; )
      P = c + P;
    const S = P.length - O;
    for (P = P.substring(0, S) + "." + P.substring(S); P[0] === "0" && P[1] !== "."; )
      P = P.substring(1);
    for (; P[P.length - 1] === "0" && P[P.length - 2] !== "."; )
      P = P.substring(0, P.length - 1);
    return I + P;
  }
  const j = class j {
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */
    constructor(O, I, P) {
      Z(this, y);
      /**
       *  The specific fixed-point arithmetic field for this value.
       */
      Q(this, "format");
      Z(this, g);
      // The actual value (accounting for decimals)
      Z(this, k);
      // A base-10 value to multiple values by to maintain the magnitude
      Z(this, A);
      /**
       *  This is a property so console.log shows a human-meaningful value.
       *
       *  @private
       */
      Q(this, "_value");
      (0, e.assertPrivate)(O, u, "FixedNumber"), F(this, k, I), F(this, g, P);
      const S = h(I, P.decimals);
      (0, n.defineProperties)(this, { format: P.name, _value: S }), F(this, A, l(P.decimals));
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */
    get signed() {
      return x(this, g).signed;
    }
    /**
     *  The number of bits available to store the value.
     */
    get width() {
      return x(this, g).width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */
    get decimals() {
      return x(this, g).decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */
    get value() {
      return x(this, k);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */
    addUnsafe(O) {
      return de(this, y, Pb).call(this, O);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    add(O) {
      return de(this, y, Pb).call(this, O, "add");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */
    subUnsafe(O) {
      return de(this, y, vb).call(this, O);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    sub(O) {
      return de(this, y, vb).call(this, O, "sub");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */
    mulUnsafe(O) {
      return de(this, y, kb).call(this, O);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */
    mul(O) {
      return de(this, y, kb).call(this, O, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */
    mulSignal(O) {
      de(this, y, Sa).call(this, O);
      const I = x(this, k) * x(O, k);
      return (0, e.assert)(I % x(this, A) === i, "precision lost during signalling mul", "NUMERIC_FAULT", {
        operation: "mulSignal",
        fault: "underflow",
        value: this
      }), de(this, y, ds).call(this, I / x(this, A), "mulSignal");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    divUnsafe(O) {
      return de(this, y, Tb).call(this, O);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */
    div(O) {
      return de(this, y, Tb).call(this, O, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */
    divSignal(O) {
      (0, e.assert)(x(O, k) !== i, "division by zero", "NUMERIC_FAULT", {
        operation: "div",
        fault: "divide-by-zero",
        value: this
      }), de(this, y, Sa).call(this, O);
      const I = x(this, k) * x(this, A);
      return (0, e.assert)(I % x(O, k) === i, "precision lost during signalling div", "NUMERIC_FAULT", {
        operation: "divSignal",
        fault: "underflow",
        value: this
      }), de(this, y, ds).call(this, I / x(O, k), "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */
    cmp(O) {
      let I = this.value, P = O.value;
      const S = this.decimals - O.decimals;
      return S > 0 ? P *= l(S) : S < 0 && (I *= l(-S)), I < P ? -1 : I > P ? 1 : 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */
    eq(O) {
      return this.cmp(O) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */
    lt(O) {
      return this.cmp(O) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */
    lte(O) {
      return this.cmp(O) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */
    gt(O) {
      return this.cmp(O) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */
    gte(O) {
      return this.cmp(O) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    floor() {
      let O = x(this, k);
      return x(this, k) < i && (O -= x(this, A) - a), O = x(this, k) / x(this, A) * x(this, A), de(this, y, ds).call(this, O, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */
    ceiling() {
      let O = x(this, k);
      return x(this, k) > i && (O += x(this, A) - a), O = x(this, k) / x(this, A) * x(this, A), de(this, y, ds).call(this, O, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */
    round(O) {
      if (O == null && (O = 0), O >= this.decimals)
        return this;
      const I = this.decimals - O, P = o * l(I - 1);
      let S = this.value + P;
      const B = l(I);
      return S = S / B * B, f(S, x(this, g), "round"), new j(u, S, x(this, g));
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */
    isZero() {
      return x(this, k) === i;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */
    isNegative() {
      return x(this, k) < i;
    }
    /**
     *  Returns the string representation of %%this%%.
     */
    toString() {
      return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */
    toUnsafeFloat() {
      return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */
    toFormat(O) {
      return j.fromString(this.toString(), O);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */
    static fromValue(O, I, P) {
      const S = I == null ? 0 : (0, t.getNumber)(I), B = d(P);
      let C = (0, t.getBigInt)(O, "value");
      const H = S - B.decimals;
      if (H > 0) {
        const V = l(H);
        (0, e.assert)(C % V === i, "value loses precision for format", "NUMERIC_FAULT", {
          operation: "fromValue",
          fault: "underflow",
          value: O
        }), C /= V;
      } else H < 0 && (C *= l(-H));
      return f(C, B, "fromValue"), new j(u, C, B);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */
    static fromString(O, I) {
      const P = O.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
      (0, e.assertArgument)(P && P[2].length + P[3].length > 0, "invalid FixedNumber string value", "value", O);
      const S = d(I);
      let B = P[2] || "0", C = P[3] || "";
      for (; C.length < S.decimals; )
        C += c;
      (0, e.assert)(C.substring(S.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
        operation: "fromString",
        fault: "underflow",
        value: O
      }), C = C.substring(0, S.decimals);
      const H = BigInt(P[1] + B + C);
      return f(H, S, "fromString"), new j(u, H, S);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */
    static fromBytes(O, I) {
      let P = (0, t.toBigInt)((0, r.getBytes)(O, "value"));
      const S = d(I);
      return S.signed && (P = (0, t.fromTwos)(P, S.width)), f(P, S, "fromBytes"), new j(u, P, S);
    }
  };
  g = new WeakMap(), k = new WeakMap(), A = new WeakMap(), y = new WeakSet(), Sa = function(O) {
    (0, e.assertArgument)(this.format === O.format, "incompatible format; use fixedNumber.toFormat", "other", O);
  }, ds = function(O, I) {
    return O = f(O, x(this, g), I), new j(u, O, x(this, g));
  }, Pb = function(O, I) {
    return de(this, y, Sa).call(this, O), de(this, y, ds).call(this, x(this, k) + x(O, k), I);
  }, vb = function(O, I) {
    return de(this, y, Sa).call(this, O), de(this, y, ds).call(this, x(this, k) - x(O, k), I);
  }, kb = function(O, I) {
    return de(this, y, Sa).call(this, O), de(this, y, ds).call(this, x(this, k) * x(O, k) / x(this, A), I);
  }, Tb = function(O, I) {
    return (0, e.assert)(x(O, k) !== i, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), de(this, y, Sa).call(this, O), de(this, y, ds).call(this, x(this, k) * x(this, A) / x(O, k), I);
  };
  let p = j;
  return Zu.FixedNumber = p, Zu;
}
var Xu = {}, b1;
function lv() {
  if (b1) return Xu;
  b1 = 1, Object.defineProperty(Xu, "__esModule", { value: !0 }), Xu.decodeRlp = void 0;
  const r = Tn(), e = rs(), t = Tn();
  function n(u) {
    let c = u.toString(16);
    for (; c.length < 2; )
      c = "0" + c;
    return "0x" + c;
  }
  function s(u, c, l) {
    let f = 0;
    for (let d = 0; d < l; d++)
      f = f * 256 + u[c + d];
    return f;
  }
  function i(u, c, l, f) {
    const d = [];
    for (; l < c + 1 + f; ) {
      const h = a(u, l);
      d.push(h.result), l += h.consumed, (0, e.assert)(l <= c + 1 + f, "child data too short", "BUFFER_OVERRUN", {
        buffer: u,
        length: f,
        offset: c
      });
    }
    return { consumed: 1 + f, result: d };
  }
  function a(u, c) {
    (0, e.assert)(u.length !== 0, "data too short", "BUFFER_OVERRUN", {
      buffer: u,
      length: 0,
      offset: 1
    });
    const l = (f) => {
      (0, e.assert)(f <= u.length, "data short segment too short", "BUFFER_OVERRUN", {
        buffer: u,
        length: u.length,
        offset: f
      });
    };
    if (u[c] >= 248) {
      const f = u[c] - 247;
      l(c + 1 + f);
      const d = s(u, c + 1, f);
      return l(c + 1 + f + d), i(u, c, c + 1 + f, f + d);
    } else if (u[c] >= 192) {
      const f = u[c] - 192;
      return l(c + 1 + f), i(u, c, c + 1, f);
    } else if (u[c] >= 184) {
      const f = u[c] - 183;
      l(c + 1 + f);
      const d = s(u, c + 1, f);
      l(c + 1 + f + d);
      const h = (0, r.hexlify)(u.slice(c + 1 + f, c + 1 + f + d));
      return { consumed: 1 + f + d, result: h };
    } else if (u[c] >= 128) {
      const f = u[c] - 128;
      l(c + 1 + f);
      const d = (0, r.hexlify)(u.slice(c + 1, c + 1 + f));
      return { consumed: 1 + f, result: d };
    }
    return { consumed: 1, result: n(u[c]) };
  }
  function o(u) {
    const c = (0, t.getBytes)(u, "data"), l = a(c, 0);
    return (0, e.assertArgument)(l.consumed === c.length, "unexpected junk after rlp payload", "data", u), l.result;
  }
  return Xu.decodeRlp = o, Xu;
}
var el = {}, g1;
function fv() {
  if (g1) return el;
  g1 = 1, Object.defineProperty(el, "__esModule", { value: !0 }), el.encodeRlp = void 0;
  const r = Tn();
  function e(i) {
    const a = [];
    for (; i; )
      a.unshift(i & 255), i >>= 8;
    return a;
  }
  function t(i) {
    if (Array.isArray(i)) {
      let u = [];
      if (i.forEach(function(l) {
        u = u.concat(t(l));
      }), u.length <= 55)
        return u.unshift(192 + u.length), u;
      const c = e(u.length);
      return c.unshift(247 + c.length), c.concat(u);
    }
    const a = Array.prototype.slice.call((0, r.getBytes)(i, "object"));
    if (a.length === 1 && a[0] <= 127)
      return a;
    if (a.length <= 55)
      return a.unshift(128 + a.length), a;
    const o = e(a.length);
    return o.unshift(183 + o.length), o.concat(a);
  }
  const n = "0123456789abcdef";
  function s(i) {
    let a = "0x";
    for (const o of t(i))
      a += n[o >> 4], a += n[o & 15];
    return a;
  }
  return el.encodeRlp = s, el;
}
var nn = {}, x1;
function dv() {
  if (x1) return nn;
  x1 = 1, Object.defineProperty(nn, "__esModule", { value: !0 }), nn.parseEther = nn.formatEther = nn.parseUnits = nn.formatUnits = void 0;
  const r = rs(), e = QA(), t = lf(), n = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
  ];
  function s(u, c) {
    let l = 18;
    if (typeof c == "string") {
      const f = n.indexOf(c);
      (0, r.assertArgument)(f >= 0, "invalid unit", "unit", c), l = 3 * f;
    } else c != null && (l = (0, t.getNumber)(c, "unit"));
    return e.FixedNumber.fromValue(u, l, { decimals: l, width: 512 }).toString();
  }
  nn.formatUnits = s;
  function i(u, c) {
    (0, r.assertArgument)(typeof u == "string", "value must be a string", "value", u);
    let l = 18;
    if (typeof c == "string") {
      const f = n.indexOf(c);
      (0, r.assertArgument)(f >= 0, "invalid unit", "unit", c), l = 3 * f;
    } else c != null && (l = (0, t.getNumber)(c, "unit"));
    return e.FixedNumber.fromString(u, { decimals: l, width: 512 }).value;
  }
  nn.parseUnits = i;
  function a(u) {
    return s(u, 18);
  }
  nn.formatEther = a;
  function o(u) {
    return i(u, 18);
  }
  return nn.parseEther = o, nn;
}
var tl = {}, m1;
function hv() {
  if (m1) return tl;
  m1 = 1, Object.defineProperty(tl, "__esModule", { value: !0 }), tl.uuidV4 = void 0;
  const r = Tn();
  function e(t) {
    const n = (0, r.getBytes)(t, "randomBytes");
    n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128;
    const s = (0, r.hexlify)(n);
    return [
      s.substring(2, 10),
      s.substring(10, 14),
      s.substring(14, 18),
      s.substring(18, 22),
      s.substring(22, 34)
    ].join("-");
  }
  return tl.uuidV4 = e, tl;
}
var y1;
function Me() {
  return y1 || (y1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.toUtf8String = r.toUtf8CodePoints = r.toUtf8Bytes = r.parseUnits = r.formatUnits = r.parseEther = r.formatEther = r.encodeRlp = r.decodeRlp = r.defineProperties = r.resolveProperties = r.toQuantity = r.toBeArray = r.toBeHex = r.toNumber = r.toBigInt = r.getUint = r.getNumber = r.getBigInt = r.mask = r.toTwos = r.fromTwos = r.FixedNumber = r.FetchCancelSignal = r.FetchResponse = r.FetchRequest = r.EventPayload = r.makeError = r.assertNormalize = r.assertPrivate = r.assertArgumentCount = r.assertArgument = r.assert = r.isError = r.isCallException = r.zeroPadBytes = r.zeroPadValue = r.stripZerosLeft = r.dataSlice = r.dataLength = r.concat = r.hexlify = r.isBytesLike = r.isHexString = r.getBytesCopy = r.getBytes = r.encodeBase64 = r.decodeBase64 = r.encodeBase58 = r.decodeBase58 = void 0, r.uuidV4 = r.Utf8ErrorFuncs = void 0;
    var e = av();
    Object.defineProperty(r, "decodeBase58", { enumerable: !0, get: function() {
      return e.decodeBase58;
    } }), Object.defineProperty(r, "encodeBase58", { enumerable: !0, get: function() {
      return e.encodeBase58;
    } });
    var t = JA();
    Object.defineProperty(r, "decodeBase64", { enumerable: !0, get: function() {
      return t.decodeBase64;
    } }), Object.defineProperty(r, "encodeBase64", { enumerable: !0, get: function() {
      return t.encodeBase64;
    } });
    var n = Tn();
    Object.defineProperty(r, "getBytes", { enumerable: !0, get: function() {
      return n.getBytes;
    } }), Object.defineProperty(r, "getBytesCopy", { enumerable: !0, get: function() {
      return n.getBytesCopy;
    } }), Object.defineProperty(r, "isHexString", { enumerable: !0, get: function() {
      return n.isHexString;
    } }), Object.defineProperty(r, "isBytesLike", { enumerable: !0, get: function() {
      return n.isBytesLike;
    } }), Object.defineProperty(r, "hexlify", { enumerable: !0, get: function() {
      return n.hexlify;
    } }), Object.defineProperty(r, "concat", { enumerable: !0, get: function() {
      return n.concat;
    } }), Object.defineProperty(r, "dataLength", { enumerable: !0, get: function() {
      return n.dataLength;
    } }), Object.defineProperty(r, "dataSlice", { enumerable: !0, get: function() {
      return n.dataSlice;
    } }), Object.defineProperty(r, "stripZerosLeft", { enumerable: !0, get: function() {
      return n.stripZerosLeft;
    } }), Object.defineProperty(r, "zeroPadValue", { enumerable: !0, get: function() {
      return n.zeroPadValue;
    } }), Object.defineProperty(r, "zeroPadBytes", { enumerable: !0, get: function() {
      return n.zeroPadBytes;
    } });
    var s = rs();
    Object.defineProperty(r, "isCallException", { enumerable: !0, get: function() {
      return s.isCallException;
    } }), Object.defineProperty(r, "isError", { enumerable: !0, get: function() {
      return s.isError;
    } }), Object.defineProperty(r, "assert", { enumerable: !0, get: function() {
      return s.assert;
    } }), Object.defineProperty(r, "assertArgument", { enumerable: !0, get: function() {
      return s.assertArgument;
    } }), Object.defineProperty(r, "assertArgumentCount", { enumerable: !0, get: function() {
      return s.assertArgumentCount;
    } }), Object.defineProperty(r, "assertPrivate", { enumerable: !0, get: function() {
      return s.assertPrivate;
    } }), Object.defineProperty(r, "assertNormalize", { enumerable: !0, get: function() {
      return s.assertNormalize;
    } }), Object.defineProperty(r, "makeError", { enumerable: !0, get: function() {
      return s.makeError;
    } });
    var i = ov();
    Object.defineProperty(r, "EventPayload", { enumerable: !0, get: function() {
      return i.EventPayload;
    } });
    var a = uv();
    Object.defineProperty(r, "FetchRequest", { enumerable: !0, get: function() {
      return a.FetchRequest;
    } }), Object.defineProperty(r, "FetchResponse", { enumerable: !0, get: function() {
      return a.FetchResponse;
    } }), Object.defineProperty(r, "FetchCancelSignal", { enumerable: !0, get: function() {
      return a.FetchCancelSignal;
    } });
    var o = QA();
    Object.defineProperty(r, "FixedNumber", { enumerable: !0, get: function() {
      return o.FixedNumber;
    } });
    var u = lf();
    Object.defineProperty(r, "fromTwos", { enumerable: !0, get: function() {
      return u.fromTwos;
    } }), Object.defineProperty(r, "toTwos", { enumerable: !0, get: function() {
      return u.toTwos;
    } }), Object.defineProperty(r, "mask", { enumerable: !0, get: function() {
      return u.mask;
    } }), Object.defineProperty(r, "getBigInt", { enumerable: !0, get: function() {
      return u.getBigInt;
    } }), Object.defineProperty(r, "getNumber", { enumerable: !0, get: function() {
      return u.getNumber;
    } }), Object.defineProperty(r, "getUint", { enumerable: !0, get: function() {
      return u.getUint;
    } }), Object.defineProperty(r, "toBigInt", { enumerable: !0, get: function() {
      return u.toBigInt;
    } }), Object.defineProperty(r, "toNumber", { enumerable: !0, get: function() {
      return u.toNumber;
    } }), Object.defineProperty(r, "toBeHex", { enumerable: !0, get: function() {
      return u.toBeHex;
    } }), Object.defineProperty(r, "toBeArray", { enumerable: !0, get: function() {
      return u.toBeArray;
    } }), Object.defineProperty(r, "toQuantity", { enumerable: !0, get: function() {
      return u.toQuantity;
    } });
    var c = So();
    Object.defineProperty(r, "resolveProperties", { enumerable: !0, get: function() {
      return c.resolveProperties;
    } }), Object.defineProperty(r, "defineProperties", { enumerable: !0, get: function() {
      return c.defineProperties;
    } });
    var l = lv();
    Object.defineProperty(r, "decodeRlp", { enumerable: !0, get: function() {
      return l.decodeRlp;
    } });
    var f = fv();
    Object.defineProperty(r, "encodeRlp", { enumerable: !0, get: function() {
      return f.encodeRlp;
    } });
    var d = dv();
    Object.defineProperty(r, "formatEther", { enumerable: !0, get: function() {
      return d.formatEther;
    } }), Object.defineProperty(r, "parseEther", { enumerable: !0, get: function() {
      return d.parseEther;
    } }), Object.defineProperty(r, "formatUnits", { enumerable: !0, get: function() {
      return d.formatUnits;
    } }), Object.defineProperty(r, "parseUnits", { enumerable: !0, get: function() {
      return d.parseUnits;
    } });
    var h = cx();
    Object.defineProperty(r, "toUtf8Bytes", { enumerable: !0, get: function() {
      return h.toUtf8Bytes;
    } }), Object.defineProperty(r, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return h.toUtf8CodePoints;
    } }), Object.defineProperty(r, "toUtf8String", { enumerable: !0, get: function() {
      return h.toUtf8String;
    } }), Object.defineProperty(r, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return h.Utf8ErrorFuncs;
    } });
    var p = hv();
    Object.defineProperty(r, "uuidV4", { enumerable: !0, get: function() {
      return p.uuidV4;
    } });
  }(hp)), hp;
}
var bp = {}, w1;
function Cn() {
  return w1 || (w1 = 1, function(r) {
    var k, y, E, m, Xf, T, U, R, j, D, O, Bb, qA;
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Reader = r.Writer = r.Coder = r.checkResultErrors = r.Result = r.WordSize = void 0;
    const e = Me();
    r.WordSize = 32;
    const t = new Uint8Array(r.WordSize), n = ["then"], s = {}, i = /* @__PURE__ */ new WeakMap();
    function a(B) {
      return i.get(B);
    }
    function o(B, C) {
      i.set(B, C);
    }
    function u(B, C) {
      const H = new Error(`deferred error during ABI decoding triggered accessing ${B}`);
      throw H.error = C, H;
    }
    function c(B, C, H) {
      return B.indexOf(null) >= 0 ? C.map((V, J) => V instanceof l ? c(a(V), V, H) : V) : B.reduce((V, J, M) => {
        let G = C.getValue(J);
        return J in V || (H && G instanceof l && (G = c(a(G), G, H)), V[J] = G), V;
      }, {});
    }
    const A = class A extends Array {
      /**
       *  @private
       */
      constructor(...H) {
        const V = H[0];
        let J = H[1], M = (H[2] || []).slice(), G = !0;
        V !== s && (J = H, M = [], G = !1);
        super(J.length);
        // No longer used; but cannot be removed as it will remove the
        // #private field from the .d.ts which may break backwards
        // compatibility
        Z(this, k);
        J.forEach((te, pe) => {
          this[pe] = te;
        });
        const K = M.reduce((te, pe) => (typeof pe == "string" && te.set(pe, (te.get(pe) || 0) + 1), te), /* @__PURE__ */ new Map());
        if (o(this, Object.freeze(J.map((te, pe) => {
          const he = M[pe];
          return he != null && K.get(he) === 1 ? he : null;
        }))), F(this, k, []), x(this, k) == null && x(this, k), !G)
          return;
        Object.freeze(this);
        const X = new Proxy(this, {
          get: (te, pe, he) => {
            if (typeof pe == "string") {
              if (pe.match(/^[0-9]+$/)) {
                const re = (0, e.getNumber)(pe, "%index");
                if (re < 0 || re >= this.length)
                  throw new RangeError("out of result range");
                const ae = te[re];
                return ae instanceof Error && u(`index ${re}`, ae), ae;
              }
              if (n.indexOf(pe) >= 0)
                return Reflect.get(te, pe, he);
              const ye = te[pe];
              if (ye instanceof Function)
                return function(...re) {
                  return ye.apply(this === he ? te : this, re);
                };
              if (!(pe in te))
                return te.getValue.apply(this === he ? te : this, [pe]);
            }
            return Reflect.get(te, pe, he);
          }
        });
        return o(X, a(this)), X;
      }
      /**
       *  Returns the Result as a normal Array. If %%deep%%, any children
       *  which are Result objects are also converted to a normal Array.
       *
       *  This will throw if there are any outstanding deferred
       *  errors.
       */
      toArray(H) {
        const V = [];
        return this.forEach((J, M) => {
          J instanceof Error && u(`index ${M}`, J), H && J instanceof A && (J = J.toArray(H)), V.push(J);
        }), V;
      }
      /**
       *  Returns the Result as an Object with each name-value pair. If
       *  %%deep%%, any children which are Result objects are also
       *  converted to an Object.
       *
       *  This will throw if any value is unnamed, or if there are
       *  any outstanding deferred errors.
       */
      toObject(H) {
        const V = a(this);
        return V.reduce((J, M, G) => ((0, e.assert)(M != null, `value at index ${G} unnamed`, "UNSUPPORTED_OPERATION", {
          operation: "toObject()"
        }), c(V, this, H)), {});
      }
      /**
       *  @_ignore
       */
      slice(H, V) {
        H == null && (H = 0), H < 0 && (H += this.length, H < 0 && (H = 0)), V == null && (V = this.length), V < 0 && (V += this.length, V < 0 && (V = 0)), V > this.length && (V = this.length);
        const J = a(this), M = [], G = [];
        for (let K = H; K < V; K++)
          M.push(this[K]), G.push(J[K]);
        return new A(s, M, G);
      }
      /**
       *  @_ignore
       */
      filter(H, V) {
        const J = a(this), M = [], G = [];
        for (let K = 0; K < this.length; K++) {
          const X = this[K];
          X instanceof Error && u(`index ${K}`, X), H.call(V, X, K, this) && (M.push(X), G.push(J[K]));
        }
        return new A(s, M, G);
      }
      /**
       *  @_ignore
       */
      map(H, V) {
        const J = [];
        for (let M = 0; M < this.length; M++) {
          const G = this[M];
          G instanceof Error && u(`index ${M}`, G), J.push(H.call(V, G, M, this));
        }
        return J;
      }
      /**
       *  Returns the value for %%name%%.
       *
       *  Since it is possible to have a key whose name conflicts with
       *  a method on a [[Result]] or its superclass Array, or any
       *  JavaScript keyword, this ensures all named values are still
       *  accessible by name.
       */
      getValue(H) {
        const V = a(this).indexOf(H);
        if (V === -1)
          return;
        const J = this[V];
        return J instanceof Error && u(`property ${JSON.stringify(H)}`, J.error), J;
      }
      /**
       *  Creates a new [[Result]] for %%items%% with each entry
       *  also accessible by its corresponding name in %%keys%%.
       */
      static fromItems(H, V) {
        return new A(s, H, V);
      }
    };
    k = new WeakMap();
    let l = A;
    r.Result = l;
    function f(B) {
      const C = [], H = function(V, J) {
        if (Array.isArray(J))
          for (let M in J) {
            const G = V.slice();
            G.push(M);
            try {
              H(G, J[M]);
            } catch (K) {
              C.push({ path: G, error: K });
            }
          }
      };
      return H([], B), C;
    }
    r.checkResultErrors = f;
    function d(B) {
      let C = (0, e.toBeArray)(B);
      return (0, e.assert)(C.length <= r.WordSize, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: C, length: r.WordSize, offset: C.length }), C.length !== r.WordSize && (C = (0, e.getBytesCopy)((0, e.concat)([t.slice(C.length % r.WordSize), C]))), C;
    }
    class h {
      constructor(C, H, V, J) {
        // The coder name:
        //   - address, uint256, tuple, array, etc.
        Q(this, "name");
        // The fully expanded type, including composite types:
        //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
        Q(this, "type");
        // The localName bound in the signature, in this example it is "baz":
        //   - tuple(address foo, uint bar) baz
        Q(this, "localName");
        // Whether this type is dynamic:
        //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
        //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
        Q(this, "dynamic");
        (0, e.defineProperties)(this, { name: C, type: H, localName: V, dynamic: J }, {
          name: "string",
          type: "string",
          localName: "string",
          dynamic: "boolean"
        });
      }
      _throwError(C, H) {
        (0, e.assertArgument)(!1, C, this.localName, H);
      }
    }
    r.Coder = h;
    class p {
      constructor() {
        Z(this, m);
        // An array of WordSize lengthed objects to concatenation
        Z(this, y);
        Z(this, E);
        F(this, y, []), F(this, E, 0);
      }
      get data() {
        return (0, e.concat)(x(this, y));
      }
      get length() {
        return x(this, E);
      }
      appendWriter(C) {
        return de(this, m, Xf).call(this, (0, e.getBytesCopy)(C.data));
      }
      // Arrayish item; pad on the right to *nearest* WordSize
      writeBytes(C) {
        let H = (0, e.getBytesCopy)(C);
        const V = H.length % r.WordSize;
        return V && (H = (0, e.getBytesCopy)((0, e.concat)([H, t.slice(V)]))), de(this, m, Xf).call(this, H);
      }
      // Numeric item; pad on the left *to* WordSize
      writeValue(C) {
        return de(this, m, Xf).call(this, d(C));
      }
      // Inserts a numeric place-holder, returning a callback that can
      // be used to asjust the value later
      writeUpdatableValue() {
        const C = x(this, y).length;
        return x(this, y).push(t), F(this, E, x(this, E) + r.WordSize), (H) => {
          x(this, y)[C] = d(H);
        };
      }
    }
    y = new WeakMap(), E = new WeakMap(), m = new WeakSet(), Xf = function(C) {
      return x(this, y).push(C), F(this, E, x(this, E) + C.length), C.length;
    }, r.Writer = p;
    const S = class S {
      constructor(C, H, V) {
        Z(this, O);
        // Allows incomplete unpadded data to be read; otherwise an error
        // is raised if attempting to overrun the buffer. This is required
        // to deal with an old Solidity bug, in which event data for
        // external (not public thoguh) was tightly packed.
        Q(this, "allowLoose");
        Z(this, T);
        Z(this, U);
        Z(this, R);
        Z(this, j);
        Z(this, D);
        (0, e.defineProperties)(this, { allowLoose: !!H }), F(this, T, (0, e.getBytesCopy)(C)), F(this, R, 0), F(this, j, null), F(this, D, V ?? 1024), F(this, U, 0);
      }
      get data() {
        return (0, e.hexlify)(x(this, T));
      }
      get dataLength() {
        return x(this, T).length;
      }
      get consumed() {
        return x(this, U);
      }
      get bytes() {
        return new Uint8Array(x(this, T));
      }
      // Create a sub-reader with the same underlying data, but offset
      subReader(C) {
        const H = new S(x(this, T).slice(x(this, U) + C), this.allowLoose, x(this, D));
        return F(H, j, this), H;
      }
      // Read bytes
      readBytes(C, H) {
        let V = de(this, O, qA).call(this, 0, C, !!H);
        return de(this, O, Bb).call(this, C), F(this, U, x(this, U) + V.length), V.slice(0, C);
      }
      // Read a numeric values
      readValue() {
        return (0, e.toBigInt)(this.readBytes(r.WordSize));
      }
      readIndex() {
        return (0, e.toNumber)(this.readBytes(r.WordSize));
      }
    };
    T = new WeakMap(), U = new WeakMap(), R = new WeakMap(), j = new WeakMap(), D = new WeakMap(), O = new WeakSet(), Bb = function(C) {
      var H;
      if (x(this, j))
        return de(H = x(this, j), O, Bb).call(H, C);
      F(this, R, x(this, R) + C), (0, e.assert)(x(this, D) < 1 || x(this, R) <= x(this, D) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${x(this, D)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
        buffer: (0, e.getBytesCopy)(x(this, T)),
        offset: x(this, U),
        length: C,
        info: {
          bytesRead: x(this, R),
          dataLength: this.dataLength
        }
      });
    }, qA = function(C, H, V) {
      let J = Math.ceil(H / r.WordSize) * r.WordSize;
      return x(this, U) + J > x(this, T).length && (this.allowLoose && V && x(this, U) + H <= x(this, T).length ? J = H : (0, e.assert)(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
        buffer: (0, e.getBytesCopy)(x(this, T)),
        length: x(this, T).length,
        offset: x(this, U) + J
      })), x(this, T).slice(x(this, U), x(this, U) + J);
    };
    let g = S;
    r.Reader = g;
  }(bp)), bp;
}
var rl = {}, gp = {}, sa = {}, xp = {}, nl = {}, sn = {}, ia = {}, A1;
function WA() {
  if (A1) return ia;
  A1 = 1, Object.defineProperty(ia, "__esModule", { value: !0 }), ia.pbkdf2Async = ia.pbkdf2 = void 0;
  const r = X0(), e = Qd(), t = On();
  function n(o, u, c, l) {
    (0, r.hash)(o);
    const f = (0, t.checkOpts)({ dkLen: 32, asyncTick: 10 }, l), { c: d, dkLen: h, asyncTick: p } = f;
    if ((0, r.number)(d), (0, r.number)(h), (0, r.number)(p), d < 1)
      throw new Error("PBKDF2: iterations (c) should be >= 1");
    const g = (0, t.toBytes)(u), k = (0, t.toBytes)(c), A = new Uint8Array(h), y = e.hmac.create(o, g), E = y._cloneInto().update(k);
    return { c: d, dkLen: h, asyncTick: p, DK: A, PRF: y, PRFSalt: E };
  }
  function s(o, u, c, l, f) {
    return o.destroy(), u.destroy(), l && l.destroy(), f.fill(0), c;
  }
  function i(o, u, c, l) {
    const { c: f, dkLen: d, DK: h, PRF: p, PRFSalt: g } = n(o, u, c, l);
    let k;
    const A = new Uint8Array(4), y = (0, t.createView)(A), E = new Uint8Array(p.outputLen);
    for (let m = 1, N = 0; N < d; m++, N += p.outputLen) {
      const T = h.subarray(N, N + p.outputLen);
      y.setInt32(0, m, !1), (k = g._cloneInto(k)).update(A).digestInto(E), T.set(E.subarray(0, T.length));
      for (let U = 1; U < f; U++) {
        p._cloneInto(k).update(E).digestInto(E);
        for (let R = 0; R < T.length; R++)
          T[R] ^= E[R];
      }
    }
    return s(p, g, h, k, E);
  }
  ia.pbkdf2 = i;
  async function a(o, u, c, l) {
    const { c: f, dkLen: d, asyncTick: h, DK: p, PRF: g, PRFSalt: k } = n(o, u, c, l);
    let A;
    const y = new Uint8Array(4), E = (0, t.createView)(y), m = new Uint8Array(g.outputLen);
    for (let N = 1, T = 0; T < d; N++, T += g.outputLen) {
      const U = p.subarray(T, T + g.outputLen);
      E.setInt32(0, N, !1), (A = k._cloneInto(A)).update(y).digestInto(m), U.set(m.subarray(0, U.length)), await (0, t.asyncLoop)(f - 1, h, () => {
        g._cloneInto(A).update(m).digestInto(m);
        for (let R = 0; R < U.length; R++)
          U[R] ^= m[R];
      });
    }
    return s(g, k, p, A, m);
  }
  return ia.pbkdf2Async = a, ia;
}
var mr = {}, Ke = {}, E1;
function YA() {
  if (E1) return Ke;
  E1 = 1, Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.add5L = Ke.add5H = Ke.add4H = Ke.add4L = Ke.add3H = Ke.add3L = Ke.add = Ke.rotlBL = Ke.rotlBH = Ke.rotlSL = Ke.rotlSH = Ke.rotr32L = Ke.rotr32H = Ke.rotrBL = Ke.rotrBH = Ke.rotrSL = Ke.rotrSH = Ke.shrSL = Ke.shrSH = Ke.toBig = Ke.split = Ke.fromBig = void 0;
  const r = /* @__PURE__ */ BigInt(2 ** 32 - 1), e = /* @__PURE__ */ BigInt(32);
  function t(j, D = !1) {
    return D ? { h: Number(j & r), l: Number(j >> e & r) } : { h: Number(j >> e & r) | 0, l: Number(j & r) | 0 };
  }
  Ke.fromBig = t;
  function n(j, D = !1) {
    let O = new Uint32Array(j.length), I = new Uint32Array(j.length);
    for (let P = 0; P < j.length; P++) {
      const { h: S, l: B } = t(j[P], D);
      [O[P], I[P]] = [S, B];
    }
    return [O, I];
  }
  Ke.split = n;
  const s = (j, D) => BigInt(j >>> 0) << e | BigInt(D >>> 0);
  Ke.toBig = s;
  const i = (j, D, O) => j >>> O;
  Ke.shrSH = i;
  const a = (j, D, O) => j << 32 - O | D >>> O;
  Ke.shrSL = a;
  const o = (j, D, O) => j >>> O | D << 32 - O;
  Ke.rotrSH = o;
  const u = (j, D, O) => j << 32 - O | D >>> O;
  Ke.rotrSL = u;
  const c = (j, D, O) => j << 64 - O | D >>> O - 32;
  Ke.rotrBH = c;
  const l = (j, D, O) => j >>> O - 32 | D << 64 - O;
  Ke.rotrBL = l;
  const f = (j, D) => D;
  Ke.rotr32H = f;
  const d = (j, D) => j;
  Ke.rotr32L = d;
  const h = (j, D, O) => j << O | D >>> 32 - O;
  Ke.rotlSH = h;
  const p = (j, D, O) => D << O | j >>> 32 - O;
  Ke.rotlSL = p;
  const g = (j, D, O) => D << O - 32 | j >>> 64 - O;
  Ke.rotlBH = g;
  const k = (j, D, O) => j << O - 32 | D >>> 64 - O;
  Ke.rotlBL = k;
  function A(j, D, O, I) {
    const P = (D >>> 0) + (I >>> 0);
    return { h: j + O + (P / 2 ** 32 | 0) | 0, l: P | 0 };
  }
  Ke.add = A;
  const y = (j, D, O) => (j >>> 0) + (D >>> 0) + (O >>> 0);
  Ke.add3L = y;
  const E = (j, D, O, I) => D + O + I + (j / 2 ** 32 | 0) | 0;
  Ke.add3H = E;
  const m = (j, D, O, I) => (j >>> 0) + (D >>> 0) + (O >>> 0) + (I >>> 0);
  Ke.add4L = m;
  const N = (j, D, O, I, P) => D + O + I + P + (j / 2 ** 32 | 0) | 0;
  Ke.add4H = N;
  const T = (j, D, O, I, P) => (j >>> 0) + (D >>> 0) + (O >>> 0) + (I >>> 0) + (P >>> 0);
  Ke.add5L = T;
  const U = (j, D, O, I, P, S) => D + O + I + P + S + (j / 2 ** 32 | 0) | 0;
  Ke.add5H = U;
  const R = {
    fromBig: t,
    split: n,
    toBig: s,
    shrSH: i,
    shrSL: a,
    rotrSH: o,
    rotrSL: u,
    rotrBH: c,
    rotrBL: l,
    rotr32H: f,
    rotr32L: d,
    rotlSH: h,
    rotlSL: p,
    rotlBH: g,
    rotlBL: k,
    add: A,
    add3L: y,
    add3H: E,
    add4L: m,
    add4H: N,
    add5H: U,
    add5L: T
  };
  return Ke.default = R, Ke;
}
var P1;
function pv() {
  if (P1) return mr;
  P1 = 1, Object.defineProperty(mr, "__esModule", { value: !0 }), mr.sha384 = mr.sha512_256 = mr.sha512_224 = mr.sha512 = mr.SHA512 = void 0;
  const r = fg(), e = YA(), t = On(), [n, s] = e.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((f) => BigInt(f))), i = /* @__PURE__ */ new Uint32Array(80), a = /* @__PURE__ */ new Uint32Array(80);
  class o extends r.SHA2 {
    constructor() {
      super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
      const { Ah: d, Al: h, Bh: p, Bl: g, Ch: k, Cl: A, Dh: y, Dl: E, Eh: m, El: N, Fh: T, Fl: U, Gh: R, Gl: j, Hh: D, Hl: O } = this;
      return [d, h, p, g, k, A, y, E, m, N, T, U, R, j, D, O];
    }
    // prettier-ignore
    set(d, h, p, g, k, A, y, E, m, N, T, U, R, j, D, O) {
      this.Ah = d | 0, this.Al = h | 0, this.Bh = p | 0, this.Bl = g | 0, this.Ch = k | 0, this.Cl = A | 0, this.Dh = y | 0, this.Dl = E | 0, this.Eh = m | 0, this.El = N | 0, this.Fh = T | 0, this.Fl = U | 0, this.Gh = R | 0, this.Gl = j | 0, this.Hh = D | 0, this.Hl = O | 0;
    }
    process(d, h) {
      for (let S = 0; S < 16; S++, h += 4)
        i[S] = d.getUint32(h), a[S] = d.getUint32(h += 4);
      for (let S = 16; S < 80; S++) {
        const B = i[S - 15] | 0, C = a[S - 15] | 0, H = e.default.rotrSH(B, C, 1) ^ e.default.rotrSH(B, C, 8) ^ e.default.shrSH(B, C, 7), V = e.default.rotrSL(B, C, 1) ^ e.default.rotrSL(B, C, 8) ^ e.default.shrSL(B, C, 7), J = i[S - 2] | 0, M = a[S - 2] | 0, G = e.default.rotrSH(J, M, 19) ^ e.default.rotrBH(J, M, 61) ^ e.default.shrSH(J, M, 6), K = e.default.rotrSL(J, M, 19) ^ e.default.rotrBL(J, M, 61) ^ e.default.shrSL(J, M, 6), X = e.default.add4L(V, K, a[S - 7], a[S - 16]), te = e.default.add4H(X, H, G, i[S - 7], i[S - 16]);
        i[S] = te | 0, a[S] = X | 0;
      }
      let { Ah: p, Al: g, Bh: k, Bl: A, Ch: y, Cl: E, Dh: m, Dl: N, Eh: T, El: U, Fh: R, Fl: j, Gh: D, Gl: O, Hh: I, Hl: P } = this;
      for (let S = 0; S < 80; S++) {
        const B = e.default.rotrSH(T, U, 14) ^ e.default.rotrSH(T, U, 18) ^ e.default.rotrBH(T, U, 41), C = e.default.rotrSL(T, U, 14) ^ e.default.rotrSL(T, U, 18) ^ e.default.rotrBL(T, U, 41), H = T & R ^ ~T & D, V = U & j ^ ~U & O, J = e.default.add5L(P, C, V, s[S], a[S]), M = e.default.add5H(J, I, B, H, n[S], i[S]), G = J | 0, K = e.default.rotrSH(p, g, 28) ^ e.default.rotrBH(p, g, 34) ^ e.default.rotrBH(p, g, 39), X = e.default.rotrSL(p, g, 28) ^ e.default.rotrBL(p, g, 34) ^ e.default.rotrBL(p, g, 39), te = p & k ^ p & y ^ k & y, pe = g & A ^ g & E ^ A & E;
        I = D | 0, P = O | 0, D = R | 0, O = j | 0, R = T | 0, j = U | 0, { h: T, l: U } = e.default.add(m | 0, N | 0, M | 0, G | 0), m = y | 0, N = E | 0, y = k | 0, E = A | 0, k = p | 0, A = g | 0;
        const he = e.default.add3L(G, X, pe);
        p = e.default.add3H(he, M, K, te), g = he | 0;
      }
      ({ h: p, l: g } = e.default.add(this.Ah | 0, this.Al | 0, p | 0, g | 0)), { h: k, l: A } = e.default.add(this.Bh | 0, this.Bl | 0, k | 0, A | 0), { h: y, l: E } = e.default.add(this.Ch | 0, this.Cl | 0, y | 0, E | 0), { h: m, l: N } = e.default.add(this.Dh | 0, this.Dl | 0, m | 0, N | 0), { h: T, l: U } = e.default.add(this.Eh | 0, this.El | 0, T | 0, U | 0), { h: R, l: j } = e.default.add(this.Fh | 0, this.Fl | 0, R | 0, j | 0), { h: D, l: O } = e.default.add(this.Gh | 0, this.Gl | 0, D | 0, O | 0), { h: I, l: P } = e.default.add(this.Hh | 0, this.Hl | 0, I | 0, P | 0), this.set(p, g, k, A, y, E, m, N, T, U, R, j, D, O, I, P);
    }
    roundClean() {
      i.fill(0), a.fill(0);
    }
    destroy() {
      this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  mr.SHA512 = o;
  class u extends o {
    constructor() {
      super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
    }
  }
  class c extends o {
    constructor() {
      super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
    }
  }
  class l extends o {
    constructor() {
      super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
  }
  return mr.sha512 = (0, t.wrapConstructor)(() => new o()), mr.sha512_224 = (0, t.wrapConstructor)(() => new u()), mr.sha512_256 = (0, t.wrapConstructor)(() => new c()), mr.sha384 = (0, t.wrapConstructor)(() => new l()), mr;
}
var v1;
function Ah() {
  if (v1) return sn;
  v1 = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.randomBytes = sn.pbkdf2Sync = sn.createHmac = sn.createHash = void 0;
  const r = Qd(), e = WA(), t = Kd(), n = pv(), s = Me();
  function i() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof nt < "u")
      return nt;
    throw new Error("unable to locate global object");
  }
  const a = i(), o = a.crypto || a.msCrypto;
  function u(d) {
    switch (d) {
      case "sha256":
        return t.sha256.create();
      case "sha512":
        return n.sha512.create();
    }
    (0, s.assertArgument)(!1, "invalid hashing algorithm name", "algorithm", d);
  }
  sn.createHash = u;
  function c(d, h) {
    const p = { sha256: t.sha256, sha512: n.sha512 }[d];
    return (0, s.assertArgument)(p != null, "invalid hmac algorithm", "algorithm", d), r.hmac.create(p, h);
  }
  sn.createHmac = c;
  function l(d, h, p, g, k) {
    const A = { sha256: t.sha256, sha512: n.sha512 }[k];
    return (0, s.assertArgument)(A != null, "invalid pbkdf2 algorithm", "algorithm", k), (0, e.pbkdf2)(A, d, h, { c: p, dkLen: g });
  }
  sn.pbkdf2Sync = l;
  function f(d) {
    (0, s.assert)(o != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
      operation: "randomBytes"
    }), (0, s.assertArgument)(Number.isInteger(d) && d > 0 && d <= 1024, "invalid length", "length", d);
    const h = new Uint8Array(d);
    return o.getRandomValues(h), h;
  }
  return sn.randomBytes = f, sn;
}
var k1;
function bv() {
  if (k1) return nl;
  k1 = 1, Object.defineProperty(nl, "__esModule", { value: !0 }), nl.computeHmac = void 0;
  const r = Ah(), e = Me();
  let t = !1;
  const n = function(a, o, u) {
    return (0, r.createHmac)(a, o).update(u).digest();
  };
  let s = n;
  function i(a, o, u) {
    const c = (0, e.getBytes)(o, "key"), l = (0, e.getBytes)(u, "data");
    return (0, e.hexlify)(s(a, c, l));
  }
  return nl.computeHmac = i, i._ = n, i.lock = function() {
    t = !0;
  }, i.register = function(a) {
    if (t)
      throw new Error("computeHmac is locked");
    s = a;
  }, Object.freeze(i), nl;
}
var sl = {}, pt = {}, T1;
function gv() {
  if (T1) return pt;
  T1 = 1, Object.defineProperty(pt, "__esModule", { value: !0 }), pt.shake256 = pt.shake128 = pt.keccak_512 = pt.keccak_384 = pt.keccak_256 = pt.keccak_224 = pt.sha3_512 = pt.sha3_384 = pt.sha3_256 = pt.sha3_224 = pt.Keccak = pt.keccakP = void 0;
  const r = X0(), e = YA(), t = On(), [n, s, i] = [[], [], []], a = /* @__PURE__ */ BigInt(0), o = /* @__PURE__ */ BigInt(1), u = /* @__PURE__ */ BigInt(2), c = /* @__PURE__ */ BigInt(7), l = /* @__PURE__ */ BigInt(256), f = /* @__PURE__ */ BigInt(113);
  for (let m = 0, N = o, T = 1, U = 0; m < 24; m++) {
    [T, U] = [U, (2 * T + 3 * U) % 5], n.push(2 * (5 * U + T)), s.push((m + 1) * (m + 2) / 2 % 64);
    let R = a;
    for (let j = 0; j < 7; j++)
      N = (N << o ^ (N >> c) * f) % l, N & u && (R ^= o << (o << /* @__PURE__ */ BigInt(j)) - o);
    i.push(R);
  }
  const [d, h] = /* @__PURE__ */ (0, e.split)(i, !0), p = (m, N, T) => T > 32 ? (0, e.rotlBH)(m, N, T) : (0, e.rotlSH)(m, N, T), g = (m, N, T) => T > 32 ? (0, e.rotlBL)(m, N, T) : (0, e.rotlSL)(m, N, T);
  function k(m, N = 24) {
    const T = new Uint32Array(10);
    for (let U = 24 - N; U < 24; U++) {
      for (let D = 0; D < 10; D++)
        T[D] = m[D] ^ m[D + 10] ^ m[D + 20] ^ m[D + 30] ^ m[D + 40];
      for (let D = 0; D < 10; D += 2) {
        const O = (D + 8) % 10, I = (D + 2) % 10, P = T[I], S = T[I + 1], B = p(P, S, 1) ^ T[O], C = g(P, S, 1) ^ T[O + 1];
        for (let H = 0; H < 50; H += 10)
          m[D + H] ^= B, m[D + H + 1] ^= C;
      }
      let R = m[2], j = m[3];
      for (let D = 0; D < 24; D++) {
        const O = s[D], I = p(R, j, O), P = g(R, j, O), S = n[D];
        R = m[S], j = m[S + 1], m[S] = I, m[S + 1] = P;
      }
      for (let D = 0; D < 50; D += 10) {
        for (let O = 0; O < 10; O++)
          T[O] = m[D + O];
        for (let O = 0; O < 10; O++)
          m[D + O] ^= ~T[(O + 2) % 10] & T[(O + 4) % 10];
      }
      m[0] ^= d[U], m[1] ^= h[U];
    }
    T.fill(0);
  }
  pt.keccakP = k;
  class A extends t.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(N, T, U, R = !1, j = 24) {
      if (super(), this.blockLen = N, this.suffix = T, this.outputLen = U, this.enableXOF = R, this.rounds = j, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, r.number)(U), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, t.u32)(this.state);
    }
    keccak() {
      k(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
    }
    update(N) {
      (0, r.exists)(this);
      const { blockLen: T, state: U } = this;
      N = (0, t.toBytes)(N);
      const R = N.length;
      for (let j = 0; j < R; ) {
        const D = Math.min(T - this.pos, R - j);
        for (let O = 0; O < D; O++)
          U[this.pos++] ^= N[j++];
        this.pos === T && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: N, suffix: T, pos: U, blockLen: R } = this;
      N[U] ^= T, T & 128 && U === R - 1 && this.keccak(), N[R - 1] ^= 128, this.keccak();
    }
    writeInto(N) {
      (0, r.exists)(this, !1), (0, r.bytes)(N), this.finish();
      const T = this.state, { blockLen: U } = this;
      for (let R = 0, j = N.length; R < j; ) {
        this.posOut >= U && this.keccak();
        const D = Math.min(U - this.posOut, j - R);
        N.set(T.subarray(this.posOut, this.posOut + D), R), this.posOut += D, R += D;
      }
      return N;
    }
    xofInto(N) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(N);
    }
    xof(N) {
      return (0, r.number)(N), this.xofInto(new Uint8Array(N));
    }
    digestInto(N) {
      if ((0, r.output)(N, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(N), this.destroy(), N;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(N) {
      const { blockLen: T, suffix: U, outputLen: R, rounds: j, enableXOF: D } = this;
      return N || (N = new A(T, U, R, D, j)), N.state32.set(this.state32), N.pos = this.pos, N.posOut = this.posOut, N.finished = this.finished, N.rounds = j, N.suffix = U, N.outputLen = R, N.enableXOF = D, N.destroyed = this.destroyed, N;
    }
  }
  pt.Keccak = A;
  const y = (m, N, T) => (0, t.wrapConstructor)(() => new A(N, m, T));
  pt.sha3_224 = y(6, 144, 224 / 8), pt.sha3_256 = y(6, 136, 256 / 8), pt.sha3_384 = y(6, 104, 384 / 8), pt.sha3_512 = y(6, 72, 512 / 8), pt.keccak_224 = y(1, 144, 224 / 8), pt.keccak_256 = y(1, 136, 256 / 8), pt.keccak_384 = y(1, 104, 384 / 8), pt.keccak_512 = y(1, 72, 512 / 8);
  const E = (m, N, T) => (0, t.wrapXOFConstructorWithOpts)((U = {}) => new A(N, m, U.dkLen === void 0 ? T : U.dkLen, !0));
  return pt.shake128 = E(31, 168, 128 / 8), pt.shake256 = E(31, 136, 256 / 8), pt;
}
var B1;
function xv() {
  if (B1) return sl;
  B1 = 1, Object.defineProperty(sl, "__esModule", { value: !0 }), sl.keccak256 = void 0;
  const r = gv(), e = Me();
  let t = !1;
  const n = function(a) {
    return (0, r.keccak_256)(a);
  };
  let s = n;
  function i(a) {
    const o = (0, e.getBytes)(a, "data");
    return (0, e.hexlify)(s(o));
  }
  return sl.keccak256 = i, i._ = n, i.lock = function() {
    t = !0;
  }, i.register = function(a) {
    if (t)
      throw new TypeError("keccak256 is locked");
    s = a;
  }, Object.freeze(i), sl;
}
var il = {}, aa = {}, O1;
function mv() {
  if (O1) return aa;
  O1 = 1, Object.defineProperty(aa, "__esModule", { value: !0 }), aa.ripemd160 = aa.RIPEMD160 = void 0;
  const r = fg(), e = On(), t = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), n = /* @__PURE__ */ Uint8Array.from({ length: 16 }, (k, A) => A), s = /* @__PURE__ */ n.map((k) => (9 * k + 5) % 16);
  let i = [n], a = [s];
  for (let k = 0; k < 4; k++)
    for (let A of [i, a])
      A.push(A[k].map((y) => t[y]));
  const o = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((k) => new Uint8Array(k)), u = /* @__PURE__ */ i.map((k, A) => k.map((y) => o[A][y])), c = /* @__PURE__ */ a.map((k, A) => k.map((y) => o[A][y])), l = /* @__PURE__ */ new Uint32Array([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
  ]), f = /* @__PURE__ */ new Uint32Array([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]), d = (k, A) => k << A | k >>> 32 - A;
  function h(k, A, y, E) {
    return k === 0 ? A ^ y ^ E : k === 1 ? A & y | ~A & E : k === 2 ? (A | ~y) ^ E : k === 3 ? A & E | y & ~E : A ^ (y | ~E);
  }
  const p = /* @__PURE__ */ new Uint32Array(16);
  class g extends r.SHA2 {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: A, h1: y, h2: E, h3: m, h4: N } = this;
      return [A, y, E, m, N];
    }
    set(A, y, E, m, N) {
      this.h0 = A | 0, this.h1 = y | 0, this.h2 = E | 0, this.h3 = m | 0, this.h4 = N | 0;
    }
    process(A, y) {
      for (let P = 0; P < 16; P++, y += 4)
        p[P] = A.getUint32(y, !0);
      let E = this.h0 | 0, m = E, N = this.h1 | 0, T = N, U = this.h2 | 0, R = U, j = this.h3 | 0, D = j, O = this.h4 | 0, I = O;
      for (let P = 0; P < 5; P++) {
        const S = 4 - P, B = l[P], C = f[P], H = i[P], V = a[P], J = u[P], M = c[P];
        for (let G = 0; G < 16; G++) {
          const K = d(E + h(P, N, U, j) + p[H[G]] + B, J[G]) + O | 0;
          E = O, O = j, j = d(U, 10) | 0, U = N, N = K;
        }
        for (let G = 0; G < 16; G++) {
          const K = d(m + h(S, T, R, D) + p[V[G]] + C, M[G]) + I | 0;
          m = I, I = D, D = d(R, 10) | 0, R = T, T = K;
        }
      }
      this.set(this.h1 + U + D | 0, this.h2 + j + I | 0, this.h3 + O + m | 0, this.h4 + E + T | 0, this.h0 + N + R | 0);
    }
    roundClean() {
      p.fill(0);
    }
    destroy() {
      this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
  }
  return aa.RIPEMD160 = g, aa.ripemd160 = (0, e.wrapConstructor)(() => new g()), aa;
}
var N1;
function yv() {
  if (N1) return il;
  N1 = 1, Object.defineProperty(il, "__esModule", { value: !0 }), il.ripemd160 = void 0;
  const r = mv(), e = Me();
  let t = !1;
  const n = function(a) {
    return (0, r.ripemd160)(a);
  };
  let s = n;
  function i(a) {
    const o = (0, e.getBytes)(a, "data");
    return (0, e.hexlify)(s(o));
  }
  return il.ripemd160 = i, i._ = n, i.lock = function() {
    t = !0;
  }, i.register = function(a) {
    if (t)
      throw new TypeError("ripemd160 is locked");
    s = a;
  }, Object.freeze(i), il;
}
var al = {}, S1;
function wv() {
  if (S1) return al;
  S1 = 1, Object.defineProperty(al, "__esModule", { value: !0 }), al.pbkdf2 = void 0;
  const r = Ah(), e = Me();
  let t = !1;
  const n = function(a, o, u, c, l) {
    return (0, r.pbkdf2Sync)(a, o, u, c, l);
  };
  let s = n;
  function i(a, o, u, c, l) {
    const f = (0, e.getBytes)(a, "password"), d = (0, e.getBytes)(o, "salt");
    return (0, e.hexlify)(s(f, d, u, c, l));
  }
  return al.pbkdf2 = i, i._ = n, i.lock = function() {
    t = !0;
  }, i.register = function(a) {
    if (t)
      throw new Error("pbkdf2 is locked");
    s = a;
  }, Object.freeze(i), al;
}
var ol = {}, C1;
function Av() {
  if (C1) return ol;
  C1 = 1, Object.defineProperty(ol, "__esModule", { value: !0 }), ol.randomBytes = void 0;
  const r = Ah();
  let e = !1;
  const t = function(i) {
    return new Uint8Array((0, r.randomBytes)(i));
  };
  let n = t;
  function s(i) {
    return n(i);
  }
  return ol.randomBytes = s, s._ = t, s.lock = function() {
    e = !0;
  }, s.register = function(i) {
    if (e)
      throw new Error("randomBytes is locked");
    n = i;
  }, Object.freeze(s), ol;
}
var oa = {}, ca = {}, R1;
function Ev() {
  if (R1) return ca;
  R1 = 1, Object.defineProperty(ca, "__esModule", { value: !0 }), ca.scryptAsync = ca.scrypt = void 0;
  const r = X0(), e = Kd(), t = WA(), n = On(), s = (f, d) => f << d | f >>> 32 - d;
  function i(f, d, h, p, g, k) {
    let A = f[d++] ^ h[p++], y = f[d++] ^ h[p++], E = f[d++] ^ h[p++], m = f[d++] ^ h[p++], N = f[d++] ^ h[p++], T = f[d++] ^ h[p++], U = f[d++] ^ h[p++], R = f[d++] ^ h[p++], j = f[d++] ^ h[p++], D = f[d++] ^ h[p++], O = f[d++] ^ h[p++], I = f[d++] ^ h[p++], P = f[d++] ^ h[p++], S = f[d++] ^ h[p++], B = f[d++] ^ h[p++], C = f[d++] ^ h[p++], H = A, V = y, J = E, M = m, G = N, K = T, X = U, te = R, pe = j, he = D, ye = O, re = I, ae = P, L = S, ne = B, oe = C;
    for (let ee = 0; ee < 8; ee += 2)
      G ^= s(H + ae | 0, 7), pe ^= s(G + H | 0, 9), ae ^= s(pe + G | 0, 13), H ^= s(ae + pe | 0, 18), he ^= s(K + V | 0, 7), L ^= s(he + K | 0, 9), V ^= s(L + he | 0, 13), K ^= s(V + L | 0, 18), ne ^= s(ye + X | 0, 7), J ^= s(ne + ye | 0, 9), X ^= s(J + ne | 0, 13), ye ^= s(X + J | 0, 18), M ^= s(oe + re | 0, 7), te ^= s(M + oe | 0, 9), re ^= s(te + M | 0, 13), oe ^= s(re + te | 0, 18), V ^= s(H + M | 0, 7), J ^= s(V + H | 0, 9), M ^= s(J + V | 0, 13), H ^= s(M + J | 0, 18), X ^= s(K + G | 0, 7), te ^= s(X + K | 0, 9), G ^= s(te + X | 0, 13), K ^= s(G + te | 0, 18), re ^= s(ye + he | 0, 7), pe ^= s(re + ye | 0, 9), he ^= s(pe + re | 0, 13), ye ^= s(he + pe | 0, 18), ae ^= s(oe + ne | 0, 7), L ^= s(ae + oe | 0, 9), ne ^= s(L + ae | 0, 13), oe ^= s(ne + L | 0, 18);
    g[k++] = A + H | 0, g[k++] = y + V | 0, g[k++] = E + J | 0, g[k++] = m + M | 0, g[k++] = N + G | 0, g[k++] = T + K | 0, g[k++] = U + X | 0, g[k++] = R + te | 0, g[k++] = j + pe | 0, g[k++] = D + he | 0, g[k++] = O + ye | 0, g[k++] = I + re | 0, g[k++] = P + ae | 0, g[k++] = S + L | 0, g[k++] = B + ne | 0, g[k++] = C + oe | 0;
  }
  function a(f, d, h, p, g) {
    let k = p + 0, A = p + 16 * g;
    for (let y = 0; y < 16; y++)
      h[A + y] = f[d + (2 * g - 1) * 16 + y];
    for (let y = 0; y < g; y++, k += 16, d += 16)
      i(h, A, f, d, h, k), y > 0 && (A += 16), i(h, k, f, d += 16, h, A);
  }
  function o(f, d, h) {
    const p = (0, n.checkOpts)({
      dkLen: 32,
      asyncTick: 10,
      maxmem: 1073742848
    }, h), { N: g, r: k, p: A, dkLen: y, asyncTick: E, maxmem: m, onProgress: N } = p;
    if ((0, r.number)(g), (0, r.number)(k), (0, r.number)(A), (0, r.number)(y), (0, r.number)(E), (0, r.number)(m), N !== void 0 && typeof N != "function")
      throw new Error("progressCb should be function");
    const T = 128 * k, U = T / 4;
    if (g <= 1 || g & g - 1 || g >= 2 ** (T / 8) || g > 2 ** 32)
      throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (A < 0 || A > (2 ** 32 - 1) * 32 / T)
      throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (y < 0 || y > (2 ** 32 - 1) * 32)
      throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const R = T * (g + A);
    if (R > m)
      throw new Error(`Scrypt: parameters too large, ${R} (128 * r * (N + p)) > ${m} (maxmem)`);
    const j = (0, t.pbkdf2)(e.sha256, f, d, { c: 1, dkLen: T * A }), D = (0, n.u32)(j), O = (0, n.u32)(new Uint8Array(T * g)), I = (0, n.u32)(new Uint8Array(T));
    let P = () => {
    };
    if (N) {
      const S = 2 * g * A, B = Math.max(Math.floor(S / 1e4), 1);
      let C = 0;
      P = () => {
        C++, N && (!(C % B) || C === S) && N(C / S);
      };
    }
    return { N: g, r: k, p: A, dkLen: y, blockSize32: U, V: O, B32: D, B: j, tmp: I, blockMixCb: P, asyncTick: E };
  }
  function u(f, d, h, p, g) {
    const k = (0, t.pbkdf2)(e.sha256, f, h, { c: 1, dkLen: d });
    return h.fill(0), p.fill(0), g.fill(0), k;
  }
  function c(f, d, h) {
    const { N: p, r: g, p: k, dkLen: A, blockSize32: y, V: E, B32: m, B: N, tmp: T, blockMixCb: U } = o(f, d, h);
    for (let R = 0; R < k; R++) {
      const j = y * R;
      for (let D = 0; D < y; D++)
        E[D] = m[j + D];
      for (let D = 0, O = 0; D < p - 1; D++)
        a(E, O, E, O += y, g), U();
      a(E, (p - 1) * y, m, j, g), U();
      for (let D = 0; D < p; D++) {
        const O = m[j + y - 16] % p;
        for (let I = 0; I < y; I++)
          T[I] = m[j + I] ^ E[O * y + I];
        a(T, 0, m, j, g), U();
      }
    }
    return u(f, A, N, E, T);
  }
  ca.scrypt = c;
  async function l(f, d, h) {
    const { N: p, r: g, p: k, dkLen: A, blockSize32: y, V: E, B32: m, B: N, tmp: T, blockMixCb: U, asyncTick: R } = o(f, d, h);
    for (let j = 0; j < k; j++) {
      const D = y * j;
      for (let I = 0; I < y; I++)
        E[I] = m[D + I];
      let O = 0;
      await (0, n.asyncLoop)(p - 1, R, () => {
        a(E, O, E, O += y, g), U();
      }), a(E, (p - 1) * y, m, D, g), U(), await (0, n.asyncLoop)(p, R, () => {
        const I = m[D + y - 16] % p;
        for (let P = 0; P < y; P++)
          T[P] = m[D + P] ^ E[I * y + P];
        a(T, 0, m, D, g), U();
      });
    }
    return u(f, A, N, E, T);
  }
  return ca.scryptAsync = l, ca;
}
var I1;
function Pv() {
  if (I1) return oa;
  I1 = 1, Object.defineProperty(oa, "__esModule", { value: !0 }), oa.scryptSync = oa.scrypt = void 0;
  const r = Ev(), e = Me();
  let t = !1, n = !1;
  const s = async function(l, f, d, h, p, g, k) {
    return await (0, r.scryptAsync)(l, f, { N: d, r: h, p, dkLen: g, onProgress: k });
  }, i = function(l, f, d, h, p, g) {
    return (0, r.scrypt)(l, f, { N: d, r: h, p, dkLen: g });
  };
  let a = s, o = i;
  async function u(l, f, d, h, p, g, k) {
    const A = (0, e.getBytes)(l, "passwd"), y = (0, e.getBytes)(f, "salt");
    return (0, e.hexlify)(await a(A, y, d, h, p, g, k));
  }
  oa.scrypt = u, u._ = s, u.lock = function() {
    n = !0;
  }, u.register = function(l) {
    if (n)
      throw new Error("scrypt is locked");
    a = l;
  }, Object.freeze(u);
  function c(l, f, d, h, p, g) {
    const k = (0, e.getBytes)(l, "passwd"), A = (0, e.getBytes)(f, "salt");
    return (0, e.hexlify)(o(k, A, d, h, p, g));
  }
  return oa.scryptSync = c, c._ = i, c.lock = function() {
    t = !0;
  }, c.register = function(l) {
    if (t)
      throw new Error("scryptSync is locked");
    o = l;
  }, Object.freeze(c), oa;
}
var ua = {}, _1;
function vv() {
  if (_1) return ua;
  _1 = 1, Object.defineProperty(ua, "__esModule", { value: !0 }), ua.sha512 = ua.sha256 = void 0;
  const r = Ah(), e = Me(), t = function(l) {
    return (0, r.createHash)("sha256").update(l).digest();
  }, n = function(l) {
    return (0, r.createHash)("sha512").update(l).digest();
  };
  let s = t, i = n, a = !1, o = !1;
  function u(l) {
    const f = (0, e.getBytes)(l, "data");
    return (0, e.hexlify)(s(f));
  }
  ua.sha256 = u, u._ = t, u.lock = function() {
    a = !0;
  }, u.register = function(l) {
    if (a)
      throw new Error("sha256 is locked");
    s = l;
  }, Object.freeze(u);
  function c(l) {
    const f = (0, e.getBytes)(l, "data");
    return (0, e.hexlify)(i(f));
  }
  return ua.sha512 = c, c._ = n, c.lock = function() {
    o = !0;
  }, c.register = function(l) {
    if (o)
      throw new Error("sha512 is locked");
    i = l;
  }, Object.freeze(u), ua;
}
var cl = {}, mp = {}, Qe = {}, qe = {}, U1;
function Nu() {
  if (U1) return qe;
  U1 = 1, Object.defineProperty(qe, "__esModule", { value: !0 }), qe.validateObject = qe.createHmacDrbg = qe.bitMask = qe.bitSet = qe.bitGet = qe.bitLen = qe.utf8ToBytes = qe.equalBytes = qe.concatBytes = qe.ensureBytes = qe.numberToVarBytesBE = qe.numberToBytesLE = qe.numberToBytesBE = qe.bytesToNumberLE = qe.bytesToNumberBE = qe.hexToBytes = qe.hexToNumber = qe.numberToHexUnpadded = qe.bytesToHex = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const r = BigInt(0), e = BigInt(1), t = BigInt(2), n = (O) => O instanceof Uint8Array, s = /* @__PURE__ */ Array.from({ length: 256 }, (O, I) => I.toString(16).padStart(2, "0"));
  function i(O) {
    if (!n(O))
      throw new Error("Uint8Array expected");
    let I = "";
    for (let P = 0; P < O.length; P++)
      I += s[O[P]];
    return I;
  }
  qe.bytesToHex = i;
  function a(O) {
    const I = O.toString(16);
    return I.length & 1 ? `0${I}` : I;
  }
  qe.numberToHexUnpadded = a;
  function o(O) {
    if (typeof O != "string")
      throw new Error("hex string expected, got " + typeof O);
    return BigInt(O === "" ? "0" : `0x${O}`);
  }
  qe.hexToNumber = o;
  function u(O) {
    if (typeof O != "string")
      throw new Error("hex string expected, got " + typeof O);
    const I = O.length;
    if (I % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + I);
    const P = new Uint8Array(I / 2);
    for (let S = 0; S < P.length; S++) {
      const B = S * 2, C = O.slice(B, B + 2), H = Number.parseInt(C, 16);
      if (Number.isNaN(H) || H < 0)
        throw new Error("Invalid byte sequence");
      P[S] = H;
    }
    return P;
  }
  qe.hexToBytes = u;
  function c(O) {
    return o(i(O));
  }
  qe.bytesToNumberBE = c;
  function l(O) {
    if (!n(O))
      throw new Error("Uint8Array expected");
    return o(i(Uint8Array.from(O).reverse()));
  }
  qe.bytesToNumberLE = l;
  function f(O, I) {
    return u(O.toString(16).padStart(I * 2, "0"));
  }
  qe.numberToBytesBE = f;
  function d(O, I) {
    return f(O, I).reverse();
  }
  qe.numberToBytesLE = d;
  function h(O) {
    return u(a(O));
  }
  qe.numberToVarBytesBE = h;
  function p(O, I, P) {
    let S;
    if (typeof I == "string")
      try {
        S = u(I);
      } catch (C) {
        throw new Error(`${O} must be valid hex string, got "${I}". Cause: ${C}`);
      }
    else if (n(I))
      S = Uint8Array.from(I);
    else
      throw new Error(`${O} must be hex string or Uint8Array`);
    const B = S.length;
    if (typeof P == "number" && B !== P)
      throw new Error(`${O} expected ${P} bytes, got ${B}`);
    return S;
  }
  qe.ensureBytes = p;
  function g(...O) {
    const I = new Uint8Array(O.reduce((S, B) => S + B.length, 0));
    let P = 0;
    return O.forEach((S) => {
      if (!n(S))
        throw new Error("Uint8Array expected");
      I.set(S, P), P += S.length;
    }), I;
  }
  qe.concatBytes = g;
  function k(O, I) {
    if (O.length !== I.length)
      return !1;
    for (let P = 0; P < O.length; P++)
      if (O[P] !== I[P])
        return !1;
    return !0;
  }
  qe.equalBytes = k;
  function A(O) {
    if (typeof O != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof O}`);
    return new Uint8Array(new TextEncoder().encode(O));
  }
  qe.utf8ToBytes = A;
  function y(O) {
    let I;
    for (I = 0; O > r; O >>= e, I += 1)
      ;
    return I;
  }
  qe.bitLen = y;
  function E(O, I) {
    return O >> BigInt(I) & e;
  }
  qe.bitGet = E;
  const m = (O, I, P) => O | (P ? e : r) << BigInt(I);
  qe.bitSet = m;
  const N = (O) => (t << BigInt(O - 1)) - e;
  qe.bitMask = N;
  const T = (O) => new Uint8Array(O), U = (O) => Uint8Array.from(O);
  function R(O, I, P) {
    if (typeof O != "number" || O < 2)
      throw new Error("hashLen must be a number");
    if (typeof I != "number" || I < 2)
      throw new Error("qByteLen must be a number");
    if (typeof P != "function")
      throw new Error("hmacFn must be a function");
    let S = T(O), B = T(O), C = 0;
    const H = () => {
      S.fill(1), B.fill(0), C = 0;
    }, V = (...K) => P(B, S, ...K), J = (K = T()) => {
      B = V(U([0]), K), S = V(), K.length !== 0 && (B = V(U([1]), K), S = V());
    }, M = () => {
      if (C++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let K = 0;
      const X = [];
      for (; K < I; ) {
        S = V();
        const te = S.slice();
        X.push(te), K += S.length;
      }
      return g(...X);
    };
    return (K, X) => {
      H(), J(K);
      let te;
      for (; !(te = X(M())); )
        J();
      return H(), te;
    };
  }
  qe.createHmacDrbg = R;
  const j = {
    bigint: (O) => typeof O == "bigint",
    function: (O) => typeof O == "function",
    boolean: (O) => typeof O == "boolean",
    string: (O) => typeof O == "string",
    stringOrUint8Array: (O) => typeof O == "string" || O instanceof Uint8Array,
    isSafeInteger: (O) => Number.isSafeInteger(O),
    array: (O) => Array.isArray(O),
    field: (O, I) => I.Fp.isValid(O),
    hash: (O) => typeof O == "function" && Number.isSafeInteger(O.outputLen)
  };
  function D(O, I, P = {}) {
    const S = (B, C, H) => {
      const V = j[C];
      if (typeof V != "function")
        throw new Error(`Invalid validator "${C}", expected function`);
      const J = O[B];
      if (!(H && J === void 0) && !V(J, O))
        throw new Error(`Invalid param ${String(B)}=${J} (${typeof J}), expected ${C}`);
    };
    for (const [B, C] of Object.entries(I))
      S(B, C, !1);
    for (const [B, C] of Object.entries(P))
      S(B, C, !0);
    return O;
  }
  return qe.validateObject = D, qe;
}
var L1;
function Eh() {
  if (L1) return Qe;
  L1 = 1, Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.mapHashToField = Qe.getMinHashLength = Qe.getFieldBytesLength = Qe.hashToPrivateScalar = Qe.FpSqrtEven = Qe.FpSqrtOdd = Qe.Field = Qe.nLength = Qe.FpIsSquare = Qe.FpDiv = Qe.FpInvertBatch = Qe.FpPow = Qe.validateField = Qe.isNegativeLE = Qe.FpSqrt = Qe.tonelliShanks = Qe.invert = Qe.pow2 = Qe.pow = Qe.mod = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const r = Nu(), e = BigInt(0), t = BigInt(1), n = BigInt(2), s = BigInt(3), i = BigInt(4), a = BigInt(5), o = BigInt(8);
  BigInt(9), BigInt(16);
  function u(P, S) {
    const B = P % S;
    return B >= e ? B : S + B;
  }
  Qe.mod = u;
  function c(P, S, B) {
    if (B <= e || S < e)
      throw new Error("Expected power/modulo > 0");
    if (B === t)
      return e;
    let C = t;
    for (; S > e; )
      S & t && (C = C * P % B), P = P * P % B, S >>= t;
    return C;
  }
  Qe.pow = c;
  function l(P, S, B) {
    let C = P;
    for (; S-- > e; )
      C *= C, C %= B;
    return C;
  }
  Qe.pow2 = l;
  function f(P, S) {
    if (P === e || S <= e)
      throw new Error(`invert: expected positive integers, got n=${P} mod=${S}`);
    let B = u(P, S), C = S, H = e, V = t;
    for (; B !== e; ) {
      const M = C / B, G = C % B, K = H - V * M;
      C = B, B = G, H = V, V = K;
    }
    if (C !== t)
      throw new Error("invert: does not exist");
    return u(H, S);
  }
  Qe.invert = f;
  function d(P) {
    const S = (P - t) / n;
    let B, C, H;
    for (B = P - t, C = 0; B % n === e; B /= n, C++)
      ;
    for (H = n; H < P && c(H, S, P) !== P - t; H++)
      ;
    if (C === 1) {
      const J = (P + t) / i;
      return function(G, K) {
        const X = G.pow(K, J);
        if (!G.eql(G.sqr(X), K))
          throw new Error("Cannot find square root");
        return X;
      };
    }
    const V = (B + t) / n;
    return function(M, G) {
      if (M.pow(G, S) === M.neg(M.ONE))
        throw new Error("Cannot find square root");
      let K = C, X = M.pow(M.mul(M.ONE, H), B), te = M.pow(G, V), pe = M.pow(G, B);
      for (; !M.eql(pe, M.ONE); ) {
        if (M.eql(pe, M.ZERO))
          return M.ZERO;
        let he = 1;
        for (let re = M.sqr(pe); he < K && !M.eql(re, M.ONE); he++)
          re = M.sqr(re);
        const ye = M.pow(X, t << BigInt(K - he - 1));
        X = M.sqr(ye), te = M.mul(te, ye), pe = M.mul(pe, X), K = he;
      }
      return te;
    };
  }
  Qe.tonelliShanks = d;
  function h(P) {
    if (P % i === s) {
      const S = (P + t) / i;
      return function(C, H) {
        const V = C.pow(H, S);
        if (!C.eql(C.sqr(V), H))
          throw new Error("Cannot find square root");
        return V;
      };
    }
    if (P % o === a) {
      const S = (P - a) / o;
      return function(C, H) {
        const V = C.mul(H, n), J = C.pow(V, S), M = C.mul(H, J), G = C.mul(C.mul(M, n), J), K = C.mul(M, C.sub(G, C.ONE));
        if (!C.eql(C.sqr(K), H))
          throw new Error("Cannot find square root");
        return K;
      };
    }
    return d(P);
  }
  Qe.FpSqrt = h;
  const p = (P, S) => (u(P, S) & t) === t;
  Qe.isNegativeLE = p;
  const g = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function k(P) {
    const S = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, B = g.reduce((C, H) => (C[H] = "function", C), S);
    return (0, r.validateObject)(P, B);
  }
  Qe.validateField = k;
  function A(P, S, B) {
    if (B < e)
      throw new Error("Expected power > 0");
    if (B === e)
      return P.ONE;
    if (B === t)
      return S;
    let C = P.ONE, H = S;
    for (; B > e; )
      B & t && (C = P.mul(C, H)), H = P.sqr(H), B >>= t;
    return C;
  }
  Qe.FpPow = A;
  function y(P, S) {
    const B = new Array(S.length), C = S.reduce((V, J, M) => P.is0(J) ? V : (B[M] = V, P.mul(V, J)), P.ONE), H = P.inv(C);
    return S.reduceRight((V, J, M) => P.is0(J) ? V : (B[M] = P.mul(V, B[M]), P.mul(V, J)), H), B;
  }
  Qe.FpInvertBatch = y;
  function E(P, S, B) {
    return P.mul(S, typeof B == "bigint" ? f(B, P.ORDER) : P.inv(B));
  }
  Qe.FpDiv = E;
  function m(P) {
    const S = (P.ORDER - t) / n;
    return (B) => {
      const C = P.pow(B, S);
      return P.eql(C, P.ZERO) || P.eql(C, P.ONE);
    };
  }
  Qe.FpIsSquare = m;
  function N(P, S) {
    const B = S !== void 0 ? S : P.toString(2).length, C = Math.ceil(B / 8);
    return { nBitLength: B, nByteLength: C };
  }
  Qe.nLength = N;
  function T(P, S, B = !1, C = {}) {
    if (P <= e)
      throw new Error(`Expected Field ORDER > 0, got ${P}`);
    const { nBitLength: H, nByteLength: V } = N(P, S);
    if (V > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const J = h(P), M = Object.freeze({
      ORDER: P,
      BITS: H,
      BYTES: V,
      MASK: (0, r.bitMask)(H),
      ZERO: e,
      ONE: t,
      create: (G) => u(G, P),
      isValid: (G) => {
        if (typeof G != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof G}`);
        return e <= G && G < P;
      },
      is0: (G) => G === e,
      isOdd: (G) => (G & t) === t,
      neg: (G) => u(-G, P),
      eql: (G, K) => G === K,
      sqr: (G) => u(G * G, P),
      add: (G, K) => u(G + K, P),
      sub: (G, K) => u(G - K, P),
      mul: (G, K) => u(G * K, P),
      pow: (G, K) => A(M, G, K),
      div: (G, K) => u(G * f(K, P), P),
      // Same as above, but doesn't normalize
      sqrN: (G) => G * G,
      addN: (G, K) => G + K,
      subN: (G, K) => G - K,
      mulN: (G, K) => G * K,
      inv: (G) => f(G, P),
      sqrt: C.sqrt || ((G) => J(M, G)),
      invertBatch: (G) => y(M, G),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (G, K, X) => X ? K : G,
      toBytes: (G) => B ? (0, r.numberToBytesLE)(G, V) : (0, r.numberToBytesBE)(G, V),
      fromBytes: (G) => {
        if (G.length !== V)
          throw new Error(`Fp.fromBytes: expected ${V}, got ${G.length}`);
        return B ? (0, r.bytesToNumberLE)(G) : (0, r.bytesToNumberBE)(G);
      }
    });
    return Object.freeze(M);
  }
  Qe.Field = T;
  function U(P, S) {
    if (!P.isOdd)
      throw new Error("Field doesn't have isOdd");
    const B = P.sqrt(S);
    return P.isOdd(B) ? B : P.neg(B);
  }
  Qe.FpSqrtOdd = U;
  function R(P, S) {
    if (!P.isOdd)
      throw new Error("Field doesn't have isOdd");
    const B = P.sqrt(S);
    return P.isOdd(B) ? P.neg(B) : B;
  }
  Qe.FpSqrtEven = R;
  function j(P, S, B = !1) {
    P = (0, r.ensureBytes)("privateHash", P);
    const C = P.length, H = N(S).nByteLength + 8;
    if (H < 24 || C < H || C > 1024)
      throw new Error(`hashToPrivateScalar: expected ${H}-1024 bytes of input, got ${C}`);
    const V = B ? (0, r.bytesToNumberLE)(P) : (0, r.bytesToNumberBE)(P);
    return u(V, S - t) + t;
  }
  Qe.hashToPrivateScalar = j;
  function D(P) {
    if (typeof P != "bigint")
      throw new Error("field order must be bigint");
    const S = P.toString(2).length;
    return Math.ceil(S / 8);
  }
  Qe.getFieldBytesLength = D;
  function O(P) {
    const S = D(P);
    return S + Math.ceil(S / 2);
  }
  Qe.getMinHashLength = O;
  function I(P, S, B = !1) {
    const C = P.length, H = D(S), V = O(S);
    if (C < 16 || C < V || C > 1024)
      throw new Error(`expected ${V}-1024 bytes of input, got ${C}`);
    const J = B ? (0, r.bytesToNumberBE)(P) : (0, r.bytesToNumberLE)(P), M = u(J, S - t) + t;
    return B ? (0, r.numberToBytesLE)(M, H) : (0, r.numberToBytesBE)(M, H);
  }
  return Qe.mapHashToField = I, Qe;
}
var yp = {}, la = {}, M1;
function kv() {
  if (M1) return la;
  M1 = 1, Object.defineProperty(la, "__esModule", { value: !0 }), la.validateBasic = la.wNAF = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const r = Eh(), e = Nu(), t = BigInt(0), n = BigInt(1);
  function s(a, o) {
    const u = (l, f) => {
      const d = f.negate();
      return l ? d : f;
    }, c = (l) => {
      const f = Math.ceil(o / l) + 1, d = 2 ** (l - 1);
      return { windows: f, windowSize: d };
    };
    return {
      constTimeNegate: u,
      // non-const time multiplication ladder
      unsafeLadder(l, f) {
        let d = a.ZERO, h = l;
        for (; f > t; )
          f & n && (d = d.add(h)), h = h.double(), f >>= n;
        return d;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(l, f) {
        const { windows: d, windowSize: h } = c(f), p = [];
        let g = l, k = g;
        for (let A = 0; A < d; A++) {
          k = g, p.push(k);
          for (let y = 1; y < h; y++)
            k = k.add(g), p.push(k);
          g = k.double();
        }
        return p;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(l, f, d) {
        const { windows: h, windowSize: p } = c(l);
        let g = a.ZERO, k = a.BASE;
        const A = BigInt(2 ** l - 1), y = 2 ** l, E = BigInt(l);
        for (let m = 0; m < h; m++) {
          const N = m * p;
          let T = Number(d & A);
          d >>= E, T > p && (T -= y, d += n);
          const U = N, R = N + Math.abs(T) - 1, j = m % 2 !== 0, D = T < 0;
          T === 0 ? k = k.add(u(j, f[U])) : g = g.add(u(D, f[R]));
        }
        return { p: g, f: k };
      },
      wNAFCached(l, f, d, h) {
        const p = l._WINDOW_SIZE || 1;
        let g = f.get(l);
        return g || (g = this.precomputeWindow(l, p), p !== 1 && f.set(l, h(g))), this.wNAF(p, g, d);
      }
    };
  }
  la.wNAF = s;
  function i(a) {
    return (0, r.validateField)(a.Fp), (0, e.validateObject)(a, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, r.nLength)(a.n, a.nBitLength),
      ...a,
      p: a.Fp.ORDER
    });
  }
  return la.validateBasic = i, la;
}
var F1;
function ZA() {
  return F1 || (F1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.mapToCurveSimpleSWU = r.SWUFpSqrtRatio = r.weierstrass = r.weierstrassPoints = r.DER = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const e = Eh(), t = Nu(), n = Nu(), s = kv();
    function i(y) {
      const E = (0, s.validateBasic)(y);
      t.validateObject(E, {
        a: "field",
        b: "field"
      }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
      });
      const { endo: m, Fp: N, a: T } = E;
      if (m) {
        if (!N.eql(T, N.ZERO))
          throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof m != "object" || typeof m.beta != "bigint" || typeof m.splitScalar != "function")
          throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
      return Object.freeze({ ...E });
    }
    const { bytesToNumberBE: a, hexToBytes: o } = t;
    r.DER = {
      // asn.1 DER encoding utils
      Err: class extends Error {
        constructor(E = "") {
          super(E);
        }
      },
      _parseInt(y) {
        const { Err: E } = r.DER;
        if (y.length < 2 || y[0] !== 2)
          throw new E("Invalid signature integer tag");
        const m = y[1], N = y.subarray(2, m + 2);
        if (!m || N.length !== m)
          throw new E("Invalid signature integer: wrong length");
        if (N[0] & 128)
          throw new E("Invalid signature integer: negative");
        if (N[0] === 0 && !(N[1] & 128))
          throw new E("Invalid signature integer: unnecessary leading zero");
        return { d: a(N), l: y.subarray(m + 2) };
      },
      toSig(y) {
        const { Err: E } = r.DER, m = typeof y == "string" ? o(y) : y;
        if (!(m instanceof Uint8Array))
          throw new Error("ui8a expected");
        let N = m.length;
        if (N < 2 || m[0] != 48)
          throw new E("Invalid signature tag");
        if (m[1] !== N - 2)
          throw new E("Invalid signature: incorrect length");
        const { d: T, l: U } = r.DER._parseInt(m.subarray(2)), { d: R, l: j } = r.DER._parseInt(U);
        if (j.length)
          throw new E("Invalid signature: left bytes after parsing");
        return { r: T, s: R };
      },
      hexFromSig(y) {
        const E = (O) => Number.parseInt(O[0], 16) & 8 ? "00" + O : O, m = (O) => {
          const I = O.toString(16);
          return I.length & 1 ? `0${I}` : I;
        }, N = E(m(y.s)), T = E(m(y.r)), U = N.length / 2, R = T.length / 2, j = m(U), D = m(R);
        return `30${m(R + U + 4)}02${D}${T}02${j}${N}`;
      }
    };
    const u = BigInt(0), c = BigInt(1), l = BigInt(2), f = BigInt(3), d = BigInt(4);
    function h(y) {
      const E = i(y), { Fp: m } = E, N = E.toBytes || ((C, H, V) => {
        const J = H.toAffine();
        return t.concatBytes(Uint8Array.from([4]), m.toBytes(J.x), m.toBytes(J.y));
      }), T = E.fromBytes || ((C) => {
        const H = C.subarray(1), V = m.fromBytes(H.subarray(0, m.BYTES)), J = m.fromBytes(H.subarray(m.BYTES, 2 * m.BYTES));
        return { x: V, y: J };
      });
      function U(C) {
        const { a: H, b: V } = E, J = m.sqr(C), M = m.mul(J, C);
        return m.add(m.add(M, m.mul(C, H)), V);
      }
      if (!m.eql(m.sqr(E.Gy), U(E.Gx)))
        throw new Error("bad generator point: equation left != right");
      function R(C) {
        return typeof C == "bigint" && u < C && C < E.n;
      }
      function j(C) {
        if (!R(C))
          throw new Error("Expected valid bigint: 0 < bigint < curve.n");
      }
      function D(C) {
        const { allowedPrivateKeyLengths: H, nByteLength: V, wrapPrivateKey: J, n: M } = E;
        if (H && typeof C != "bigint") {
          if (C instanceof Uint8Array && (C = t.bytesToHex(C)), typeof C != "string" || !H.includes(C.length))
            throw new Error("Invalid key");
          C = C.padStart(V * 2, "0");
        }
        let G;
        try {
          G = typeof C == "bigint" ? C : t.bytesToNumberBE((0, n.ensureBytes)("private key", C, V));
        } catch {
          throw new Error(`private key must be ${V} bytes, hex or bigint, not ${typeof C}`);
        }
        return J && (G = e.mod(G, M)), j(G), G;
      }
      const O = /* @__PURE__ */ new Map();
      function I(C) {
        if (!(C instanceof P))
          throw new Error("ProjectivePoint expected");
      }
      class P {
        constructor(H, V, J) {
          if (this.px = H, this.py = V, this.pz = J, H == null || !m.isValid(H))
            throw new Error("x required");
          if (V == null || !m.isValid(V))
            throw new Error("y required");
          if (J == null || !m.isValid(J))
            throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(H) {
          const { x: V, y: J } = H || {};
          if (!H || !m.isValid(V) || !m.isValid(J))
            throw new Error("invalid affine point");
          if (H instanceof P)
            throw new Error("projective point not allowed");
          const M = (G) => m.eql(G, m.ZERO);
          return M(V) && M(J) ? P.ZERO : new P(V, J, m.ONE);
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(H) {
          const V = m.invertBatch(H.map((J) => J.pz));
          return H.map((J, M) => J.toAffine(V[M])).map(P.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(H) {
          const V = P.fromAffine(T((0, n.ensureBytes)("pointHex", H)));
          return V.assertValidity(), V;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(H) {
          return P.BASE.multiply(D(H));
        }
        // "Private method", don't use it directly
        _setWindowSize(H) {
          this._WINDOW_SIZE = H, O.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
          if (this.is0()) {
            if (E.allowInfinityPoint && !m.is0(this.py))
              return;
            throw new Error("bad point: ZERO");
          }
          const { x: H, y: V } = this.toAffine();
          if (!m.isValid(H) || !m.isValid(V))
            throw new Error("bad point: x or y not FE");
          const J = m.sqr(V), M = U(H);
          if (!m.eql(J, M))
            throw new Error("bad point: equation left != right");
          if (!this.isTorsionFree())
            throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
          const { y: H } = this.toAffine();
          if (m.isOdd)
            return !m.isOdd(H);
          throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(H) {
          I(H);
          const { px: V, py: J, pz: M } = this, { px: G, py: K, pz: X } = H, te = m.eql(m.mul(V, X), m.mul(G, M)), pe = m.eql(m.mul(J, X), m.mul(K, M));
          return te && pe;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
          return new P(this.px, m.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: H, b: V } = E, J = m.mul(V, f), { px: M, py: G, pz: K } = this;
          let X = m.ZERO, te = m.ZERO, pe = m.ZERO, he = m.mul(M, M), ye = m.mul(G, G), re = m.mul(K, K), ae = m.mul(M, G);
          return ae = m.add(ae, ae), pe = m.mul(M, K), pe = m.add(pe, pe), X = m.mul(H, pe), te = m.mul(J, re), te = m.add(X, te), X = m.sub(ye, te), te = m.add(ye, te), te = m.mul(X, te), X = m.mul(ae, X), pe = m.mul(J, pe), re = m.mul(H, re), ae = m.sub(he, re), ae = m.mul(H, ae), ae = m.add(ae, pe), pe = m.add(he, he), he = m.add(pe, he), he = m.add(he, re), he = m.mul(he, ae), te = m.add(te, he), re = m.mul(G, K), re = m.add(re, re), he = m.mul(re, ae), X = m.sub(X, he), pe = m.mul(re, ye), pe = m.add(pe, pe), pe = m.add(pe, pe), new P(X, te, pe);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(H) {
          I(H);
          const { px: V, py: J, pz: M } = this, { px: G, py: K, pz: X } = H;
          let te = m.ZERO, pe = m.ZERO, he = m.ZERO;
          const ye = E.a, re = m.mul(E.b, f);
          let ae = m.mul(V, G), L = m.mul(J, K), ne = m.mul(M, X), oe = m.add(V, J), ee = m.add(G, K);
          oe = m.mul(oe, ee), ee = m.add(ae, L), oe = m.sub(oe, ee), ee = m.add(V, M);
          let W = m.add(G, X);
          return ee = m.mul(ee, W), W = m.add(ae, ne), ee = m.sub(ee, W), W = m.add(J, M), te = m.add(K, X), W = m.mul(W, te), te = m.add(L, ne), W = m.sub(W, te), he = m.mul(ye, ee), te = m.mul(re, ne), he = m.add(te, he), te = m.sub(L, he), he = m.add(L, he), pe = m.mul(te, he), L = m.add(ae, ae), L = m.add(L, ae), ne = m.mul(ye, ne), ee = m.mul(re, ee), L = m.add(L, ne), ne = m.sub(ae, ne), ne = m.mul(ye, ne), ee = m.add(ee, ne), ae = m.mul(L, ee), pe = m.add(pe, ae), ae = m.mul(W, ee), te = m.mul(oe, te), te = m.sub(te, ae), ae = m.mul(oe, L), he = m.mul(W, he), he = m.add(he, ae), new P(te, pe, he);
        }
        subtract(H) {
          return this.add(H.negate());
        }
        is0() {
          return this.equals(P.ZERO);
        }
        wNAF(H) {
          return B.wNAFCached(this, O, H, (V) => {
            const J = m.invertBatch(V.map((M) => M.pz));
            return V.map((M, G) => M.toAffine(J[G])).map(P.fromAffine);
          });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(H) {
          const V = P.ZERO;
          if (H === u)
            return V;
          if (j(H), H === c)
            return this;
          const { endo: J } = E;
          if (!J)
            return B.unsafeLadder(this, H);
          let { k1neg: M, k1: G, k2neg: K, k2: X } = J.splitScalar(H), te = V, pe = V, he = this;
          for (; G > u || X > u; )
            G & c && (te = te.add(he)), X & c && (pe = pe.add(he)), he = he.double(), G >>= c, X >>= c;
          return M && (te = te.negate()), K && (pe = pe.negate()), pe = new P(m.mul(pe.px, J.beta), pe.py, pe.pz), te.add(pe);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(H) {
          j(H);
          let V = H, J, M;
          const { endo: G } = E;
          if (G) {
            const { k1neg: K, k1: X, k2neg: te, k2: pe } = G.splitScalar(V);
            let { p: he, f: ye } = this.wNAF(X), { p: re, f: ae } = this.wNAF(pe);
            he = B.constTimeNegate(K, he), re = B.constTimeNegate(te, re), re = new P(m.mul(re.px, G.beta), re.py, re.pz), J = he.add(re), M = ye.add(ae);
          } else {
            const { p: K, f: X } = this.wNAF(V);
            J = K, M = X;
          }
          return P.normalizeZ([J, M])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(H, V, J) {
          const M = P.BASE, G = (X, te) => te === u || te === c || !X.equals(M) ? X.multiplyUnsafe(te) : X.multiply(te), K = G(this, V).add(G(H, J));
          return K.is0() ? void 0 : K;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(H) {
          const { px: V, py: J, pz: M } = this, G = this.is0();
          H == null && (H = G ? m.ONE : m.inv(M));
          const K = m.mul(V, H), X = m.mul(J, H), te = m.mul(M, H);
          if (G)
            return { x: m.ZERO, y: m.ZERO };
          if (!m.eql(te, m.ONE))
            throw new Error("invZ was invalid");
          return { x: K, y: X };
        }
        isTorsionFree() {
          const { h: H, isTorsionFree: V } = E;
          if (H === c)
            return !0;
          if (V)
            return V(P, this);
          throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
          const { h: H, clearCofactor: V } = E;
          return H === c ? this : V ? V(P, this) : this.multiplyUnsafe(E.h);
        }
        toRawBytes(H = !0) {
          return this.assertValidity(), N(P, this, H);
        }
        toHex(H = !0) {
          return t.bytesToHex(this.toRawBytes(H));
        }
      }
      P.BASE = new P(E.Gx, E.Gy, m.ONE), P.ZERO = new P(m.ZERO, m.ONE, m.ZERO);
      const S = E.nBitLength, B = (0, s.wNAF)(P, E.endo ? Math.ceil(S / 2) : S);
      return {
        CURVE: E,
        ProjectivePoint: P,
        normPrivateKeyToScalar: D,
        weierstrassEquation: U,
        isWithinCurveOrder: R
      };
    }
    r.weierstrassPoints = h;
    function p(y) {
      const E = (0, s.validateBasic)(y);
      return t.validateObject(E, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
      }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
      }), Object.freeze({ lowS: !0, ...E });
    }
    function g(y) {
      const E = p(y), { Fp: m, n: N } = E, T = m.BYTES + 1, U = 2 * m.BYTES + 1;
      function R(ee) {
        return u < ee && ee < m.ORDER;
      }
      function j(ee) {
        return e.mod(ee, N);
      }
      function D(ee) {
        return e.invert(ee, N);
      }
      const { ProjectivePoint: O, normPrivateKeyToScalar: I, weierstrassEquation: P, isWithinCurveOrder: S } = h({
        ...E,
        toBytes(ee, W, v) {
          const z = W.toAffine(), q = m.toBytes(z.x), le = t.concatBytes;
          return v ? le(Uint8Array.from([W.hasEvenY() ? 2 : 3]), q) : le(Uint8Array.from([4]), q, m.toBytes(z.y));
        },
        fromBytes(ee) {
          const W = ee.length, v = ee[0], z = ee.subarray(1);
          if (W === T && (v === 2 || v === 3)) {
            const q = t.bytesToNumberBE(z);
            if (!R(q))
              throw new Error("Point is not on curve");
            const le = P(q);
            let be = m.sqrt(le);
            const ve = (be & c) === c;
            return (v & 1) === 1 !== ve && (be = m.neg(be)), { x: q, y: be };
          } else if (W === U && v === 4) {
            const q = m.fromBytes(z.subarray(0, m.BYTES)), le = m.fromBytes(z.subarray(m.BYTES, 2 * m.BYTES));
            return { x: q, y: le };
          } else
            throw new Error(`Point of length ${W} was invalid. Expected ${T} compressed bytes or ${U} uncompressed bytes`);
        }
      }), B = (ee) => t.bytesToHex(t.numberToBytesBE(ee, E.nByteLength));
      function C(ee) {
        const W = N >> c;
        return ee > W;
      }
      function H(ee) {
        return C(ee) ? j(-ee) : ee;
      }
      const V = (ee, W, v) => t.bytesToNumberBE(ee.slice(W, v));
      class J {
        constructor(W, v, z) {
          this.r = W, this.s = v, this.recovery = z, this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(W) {
          const v = E.nByteLength;
          return W = (0, n.ensureBytes)("compactSignature", W, v * 2), new J(V(W, 0, v), V(W, v, 2 * v));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(W) {
          const { r: v, s: z } = r.DER.toSig((0, n.ensureBytes)("DER", W));
          return new J(v, z);
        }
        assertValidity() {
          if (!S(this.r))
            throw new Error("r must be 0 < r < CURVE.n");
          if (!S(this.s))
            throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(W) {
          return new J(this.r, this.s, W);
        }
        recoverPublicKey(W) {
          const { r: v, s: z, recovery: q } = this, le = pe((0, n.ensureBytes)("msgHash", W));
          if (q == null || ![0, 1, 2, 3].includes(q))
            throw new Error("recovery id invalid");
          const be = q === 2 || q === 3 ? v + E.n : v;
          if (be >= m.ORDER)
            throw new Error("recovery id 2 or 3 invalid");
          const ve = q & 1 ? "03" : "02", Be = O.fromHex(ve + B(be)), Ae = D(be), ie = j(-le * Ae), se = j(z * Ae), me = O.BASE.multiplyAndAddUnsafe(Be, ie, se);
          if (!me)
            throw new Error("point at infinify");
          return me.assertValidity(), me;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return C(this.s);
        }
        normalizeS() {
          return this.hasHighS() ? new J(this.r, j(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
          return t.hexToBytes(this.toDERHex());
        }
        toDERHex() {
          return r.DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
          return t.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
          return B(this.r) + B(this.s);
        }
      }
      const M = {
        isValidPrivateKey(ee) {
          try {
            return I(ee), !0;
          } catch {
            return !1;
          }
        },
        normPrivateKeyToScalar: I,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
          const ee = e.getMinHashLength(E.n);
          return e.mapHashToField(E.randomBytes(ee), E.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(ee = 8, W = O.BASE) {
          return W._setWindowSize(ee), W.multiply(BigInt(3)), W;
        }
      };
      function G(ee, W = !0) {
        return O.fromPrivateKey(ee).toRawBytes(W);
      }
      function K(ee) {
        const W = ee instanceof Uint8Array, v = typeof ee == "string", z = (W || v) && ee.length;
        return W ? z === T || z === U : v ? z === 2 * T || z === 2 * U : ee instanceof O;
      }
      function X(ee, W, v = !0) {
        if (K(ee))
          throw new Error("first arg must be private key");
        if (!K(W))
          throw new Error("second arg must be public key");
        return O.fromHex(W).multiply(I(ee)).toRawBytes(v);
      }
      const te = E.bits2int || function(ee) {
        const W = t.bytesToNumberBE(ee), v = ee.length * 8 - E.nBitLength;
        return v > 0 ? W >> BigInt(v) : W;
      }, pe = E.bits2int_modN || function(ee) {
        return j(te(ee));
      }, he = t.bitMask(E.nBitLength);
      function ye(ee) {
        if (typeof ee != "bigint")
          throw new Error("bigint expected");
        if (!(u <= ee && ee < he))
          throw new Error(`bigint expected < 2^${E.nBitLength}`);
        return t.numberToBytesBE(ee, E.nByteLength);
      }
      function re(ee, W, v = ae) {
        if (["recovered", "canonical"].some((_) => _ in v))
          throw new Error("sign() legacy options not supported");
        const { hash: z, randomBytes: q } = E;
        let { lowS: le, prehash: be, extraEntropy: ve } = v;
        le == null && (le = !0), ee = (0, n.ensureBytes)("msgHash", ee), be && (ee = (0, n.ensureBytes)("prehashed msgHash", z(ee)));
        const Be = pe(ee), Ae = I(W), ie = [ye(Ae), ye(Be)];
        if (ve != null) {
          const _ = ve === !0 ? q(m.BYTES) : ve;
          ie.push((0, n.ensureBytes)("extraEntropy", _));
        }
        const se = t.concatBytes(...ie), me = Be;
        function fe(_) {
          const b = te(_);
          if (!S(b))
            return;
          const w = D(b), $ = O.BASE.multiply(b).toAffine(), Y = j($.x);
          if (Y === u)
            return;
          const ce = j(w * j(me + Y * Ae));
          if (ce === u)
            return;
          let xe = ($.x === Y ? 0 : 2) | Number($.y & c), Ie = ce;
          return le && C(ce) && (Ie = H(ce), xe ^= 1), new J(Y, Ie, xe);
        }
        return { seed: se, k2sig: fe };
      }
      const ae = { lowS: E.lowS, prehash: !1 }, L = { lowS: E.lowS, prehash: !1 };
      function ne(ee, W, v = ae) {
        const { seed: z, k2sig: q } = re(ee, W, v), le = E;
        return t.createHmacDrbg(le.hash.outputLen, le.nByteLength, le.hmac)(z, q);
      }
      O.BASE._setWindowSize(8);
      function oe(ee, W, v, z = L) {
        var $;
        const q = ee;
        if (W = (0, n.ensureBytes)("msgHash", W), v = (0, n.ensureBytes)("publicKey", v), "strict" in z)
          throw new Error("options.strict was renamed to lowS");
        const { lowS: le, prehash: be } = z;
        let ve, Be;
        try {
          if (typeof q == "string" || q instanceof Uint8Array)
            try {
              ve = J.fromDER(q);
            } catch (Y) {
              if (!(Y instanceof r.DER.Err))
                throw Y;
              ve = J.fromCompact(q);
            }
          else if (typeof q == "object" && typeof q.r == "bigint" && typeof q.s == "bigint") {
            const { r: Y, s: ce } = q;
            ve = new J(Y, ce);
          } else
            throw new Error("PARSE");
          Be = O.fromHex(v);
        } catch (Y) {
          if (Y.message === "PARSE")
            throw new Error("signature must be Signature instance, Uint8Array or hex string");
          return !1;
        }
        if (le && ve.hasHighS())
          return !1;
        be && (W = E.hash(W));
        const { r: Ae, s: ie } = ve, se = pe(W), me = D(ie), fe = j(se * me), _ = j(Ae * me), b = ($ = O.BASE.multiplyAndAddUnsafe(Be, fe, _)) == null ? void 0 : $.toAffine();
        return b ? j(b.x) === Ae : !1;
      }
      return {
        CURVE: E,
        getPublicKey: G,
        getSharedSecret: X,
        sign: ne,
        verify: oe,
        ProjectivePoint: O,
        Signature: J,
        utils: M
      };
    }
    r.weierstrass = g;
    function k(y, E) {
      const m = y.ORDER;
      let N = u;
      for (let C = m - c; C % l === u; C /= l)
        N += c;
      const T = N, U = l << T - c - c, R = U * l, j = (m - c) / R, D = (j - c) / l, O = R - c, I = U, P = y.pow(E, j), S = y.pow(E, (j + c) / l);
      let B = (C, H) => {
        let V = P, J = y.pow(H, O), M = y.sqr(J);
        M = y.mul(M, H);
        let G = y.mul(C, M);
        G = y.pow(G, D), G = y.mul(G, J), J = y.mul(G, H), M = y.mul(G, C);
        let K = y.mul(M, J);
        G = y.pow(K, I);
        let X = y.eql(G, y.ONE);
        J = y.mul(M, S), G = y.mul(K, V), M = y.cmov(J, M, X), K = y.cmov(G, K, X);
        for (let te = T; te > c; te--) {
          let pe = te - l;
          pe = l << pe - c;
          let he = y.pow(K, pe);
          const ye = y.eql(he, y.ONE);
          J = y.mul(M, V), V = y.mul(V, V), he = y.mul(K, V), M = y.cmov(J, M, ye), K = y.cmov(he, K, ye);
        }
        return { isValid: X, value: M };
      };
      if (y.ORDER % d === f) {
        const C = (y.ORDER - f) / d, H = y.sqrt(y.neg(E));
        B = (V, J) => {
          let M = y.sqr(J);
          const G = y.mul(V, J);
          M = y.mul(M, G);
          let K = y.pow(M, C);
          K = y.mul(K, G);
          const X = y.mul(K, H), te = y.mul(y.sqr(K), J), pe = y.eql(te, V);
          let he = y.cmov(X, K, pe);
          return { isValid: pe, value: he };
        };
      }
      return B;
    }
    r.SWUFpSqrtRatio = k;
    function A(y, E) {
      if (e.validateField(y), !y.isValid(E.A) || !y.isValid(E.B) || !y.isValid(E.Z))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const m = k(y, E.Z);
      if (!y.isOdd)
        throw new Error("Fp.isOdd is not implemented!");
      return (N) => {
        let T, U, R, j, D, O, I, P;
        T = y.sqr(N), T = y.mul(T, E.Z), U = y.sqr(T), U = y.add(U, T), R = y.add(U, y.ONE), R = y.mul(R, E.B), j = y.cmov(E.Z, y.neg(U), !y.eql(U, y.ZERO)), j = y.mul(j, E.A), U = y.sqr(R), O = y.sqr(j), D = y.mul(O, E.A), U = y.add(U, D), U = y.mul(U, R), O = y.mul(O, j), D = y.mul(O, E.B), U = y.add(U, D), I = y.mul(T, R);
        const { isValid: S, value: B } = m(U, O);
        P = y.mul(T, N), P = y.mul(P, B), I = y.cmov(I, R, S), P = y.cmov(P, B, S);
        const C = y.isOdd(N) === y.isOdd(P);
        return P = y.cmov(y.neg(P), P, C), I = y.div(I, j), { x: I, y: P };
      };
    }
    r.mapToCurveSimpleSWU = A;
  }(yp)), yp;
}
var yr = {}, D1;
function Tv() {
  if (D1) return yr;
  D1 = 1, Object.defineProperty(yr, "__esModule", { value: !0 }), yr.createHasher = yr.isogenyMap = yr.hash_to_field = yr.expand_message_xof = yr.expand_message_xmd = void 0;
  const r = Eh(), e = Nu();
  function t(h) {
    if (h instanceof Uint8Array)
      return h;
    if (typeof h == "string")
      return (0, e.utf8ToBytes)(h);
    throw new Error("DST must be Uint8Array or string");
  }
  const n = e.bytesToNumberBE;
  function s(h, p) {
    if (h < 0 || h >= 1 << 8 * p)
      throw new Error(`bad I2OSP call: value=${h} length=${p}`);
    const g = Array.from({ length: p }).fill(0);
    for (let k = p - 1; k >= 0; k--)
      g[k] = h & 255, h >>>= 8;
    return new Uint8Array(g);
  }
  function i(h, p) {
    const g = new Uint8Array(h.length);
    for (let k = 0; k < h.length; k++)
      g[k] = h[k] ^ p[k];
    return g;
  }
  function a(h) {
    if (!(h instanceof Uint8Array))
      throw new Error("Uint8Array expected");
  }
  function o(h) {
    if (!Number.isSafeInteger(h))
      throw new Error("number expected");
  }
  function u(h, p, g, k) {
    a(h), a(p), o(g), p.length > 255 && (p = k((0, e.concatBytes)((0, e.utf8ToBytes)("H2C-OVERSIZE-DST-"), p)));
    const { outputLen: A, blockLen: y } = k, E = Math.ceil(g / A);
    if (E > 255)
      throw new Error("Invalid xmd length");
    const m = (0, e.concatBytes)(p, s(p.length, 1)), N = s(0, y), T = s(g, 2), U = new Array(E), R = k((0, e.concatBytes)(N, h, T, s(0, 1), m));
    U[0] = k((0, e.concatBytes)(R, s(1, 1), m));
    for (let D = 1; D <= E; D++) {
      const O = [i(R, U[D - 1]), s(D + 1, 1), m];
      U[D] = k((0, e.concatBytes)(...O));
    }
    return (0, e.concatBytes)(...U).slice(0, g);
  }
  yr.expand_message_xmd = u;
  function c(h, p, g, k, A) {
    if (a(h), a(p), o(g), p.length > 255) {
      const y = Math.ceil(2 * k / 8);
      p = A.create({ dkLen: y }).update((0, e.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(p).digest();
    }
    if (g > 65535 || p.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return A.create({ dkLen: g }).update(h).update(s(g, 2)).update(p).update(s(p.length, 1)).digest();
  }
  yr.expand_message_xof = c;
  function l(h, p, g) {
    (0, e.validateObject)(g, {
      DST: "stringOrUint8Array",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: k, k: A, m: y, hash: E, expand: m, DST: N } = g;
    a(h), o(p);
    const T = t(N), U = k.toString(2).length, R = Math.ceil((U + A) / 8), j = p * y * R;
    let D;
    if (m === "xmd")
      D = u(h, T, j, E);
    else if (m === "xof")
      D = c(h, T, j, A, E);
    else if (m === "_internal_pass")
      D = h;
    else
      throw new Error('expand must be "xmd" or "xof"');
    const O = new Array(p);
    for (let I = 0; I < p; I++) {
      const P = new Array(y);
      for (let S = 0; S < y; S++) {
        const B = R * (S + I * y), C = D.subarray(B, B + R);
        P[S] = (0, r.mod)(n(C), k);
      }
      O[I] = P;
    }
    return O;
  }
  yr.hash_to_field = l;
  function f(h, p) {
    const g = p.map((k) => Array.from(k).reverse());
    return (k, A) => {
      const [y, E, m, N] = g.map((T) => T.reduce((U, R) => h.add(h.mul(U, k), R)));
      return k = h.div(y, E), A = h.mul(A, h.div(m, N)), { x: k, y: A };
    };
  }
  yr.isogenyMap = f;
  function d(h, p, g) {
    if (typeof p != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve.
      // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      hashToCurve(k, A) {
        const y = l(k, 2, { ...g, DST: g.DST, ...A }), E = h.fromAffine(p(y[0])), m = h.fromAffine(p(y[1])), N = E.add(m).clearCofactor();
        return N.assertValidity(), N;
      },
      // Encodes byte string to elliptic curve.
      // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      encodeToCurve(k, A) {
        const y = l(k, 1, { ...g, DST: g.encodeDST, ...A }), E = h.fromAffine(p(y[0])).clearCofactor();
        return E.assertValidity(), E;
      }
    };
  }
  return yr.createHasher = d, yr;
}
var fa = {}, j1;
function Bv() {
  if (j1) return fa;
  j1 = 1, Object.defineProperty(fa, "__esModule", { value: !0 }), fa.createCurve = fa.getHash = void 0;
  /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  const r = Qd(), e = On(), t = ZA();
  function n(i) {
    return {
      hash: i,
      hmac: (a, ...o) => (0, r.hmac)(i, a, (0, e.concatBytes)(...o)),
      randomBytes: e.randomBytes
    };
  }
  fa.getHash = n;
  function s(i, a) {
    const o = (u) => (0, t.weierstrass)({ ...i, ...n(u) });
    return Object.freeze({ ...o(a), create: o });
  }
  return fa.createCurve = s, fa;
}
var H1;
function Ov() {
  return H1 || (H1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.encodeToCurve = r.hashToCurve = r.schnorr = r.secp256k1 = void 0;
    /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
    const e = Kd(), t = On(), n = Eh(), s = ZA(), i = Nu(), a = Tv(), o = Bv(), u = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), c = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), l = BigInt(1), f = BigInt(2), d = (J, M) => (J + M / f) / M;
    function h(J) {
      const M = u, G = BigInt(3), K = BigInt(6), X = BigInt(11), te = BigInt(22), pe = BigInt(23), he = BigInt(44), ye = BigInt(88), re = J * J * J % M, ae = re * re * J % M, L = (0, n.pow2)(ae, G, M) * ae % M, ne = (0, n.pow2)(L, G, M) * ae % M, oe = (0, n.pow2)(ne, f, M) * re % M, ee = (0, n.pow2)(oe, X, M) * oe % M, W = (0, n.pow2)(ee, te, M) * ee % M, v = (0, n.pow2)(W, he, M) * W % M, z = (0, n.pow2)(v, ye, M) * v % M, q = (0, n.pow2)(z, he, M) * W % M, le = (0, n.pow2)(q, G, M) * ae % M, be = (0, n.pow2)(le, pe, M) * ee % M, ve = (0, n.pow2)(be, K, M) * re % M, Be = (0, n.pow2)(ve, f, M);
      if (!p.eql(p.sqr(Be), J))
        throw new Error("Cannot find square root");
      return Be;
    }
    const p = (0, n.Field)(u, void 0, void 0, { sqrt: h });
    r.secp256k1 = (0, o.createCurve)({
      a: BigInt(0),
      b: BigInt(7),
      Fp: p,
      n: c,
      // Base point (x, y) aka generator point
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      h: BigInt(1),
      lowS: !0,
      /**
       * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
       * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
       * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
       * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
       */
      endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (J) => {
          const M = c, G = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), K = -l * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), X = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), te = G, pe = BigInt("0x100000000000000000000000000000000"), he = d(te * J, M), ye = d(-K * J, M);
          let re = (0, n.mod)(J - he * G - ye * X, M), ae = (0, n.mod)(-he * K - ye * te, M);
          const L = re > pe, ne = ae > pe;
          if (L && (re = M - re), ne && (ae = M - ae), re > pe || ae > pe)
            throw new Error("splitScalar: Endomorphism failed, k=" + J);
          return { k1neg: L, k1: re, k2neg: ne, k2: ae };
        }
      }
    }, e.sha256);
    const g = BigInt(0), k = (J) => typeof J == "bigint" && g < J && J < u, A = (J) => typeof J == "bigint" && g < J && J < c, y = {};
    function E(J, ...M) {
      let G = y[J];
      if (G === void 0) {
        const K = (0, e.sha256)(Uint8Array.from(J, (X) => X.charCodeAt(0)));
        G = (0, i.concatBytes)(K, K), y[J] = G;
      }
      return (0, e.sha256)((0, i.concatBytes)(G, ...M));
    }
    const m = (J) => J.toRawBytes(!0).slice(1), N = (J) => (0, i.numberToBytesBE)(J, 32), T = (J) => (0, n.mod)(J, u), U = (J) => (0, n.mod)(J, c), R = r.secp256k1.ProjectivePoint, j = (J, M, G) => R.BASE.multiplyAndAddUnsafe(J, M, G);
    function D(J) {
      let M = r.secp256k1.utils.normPrivateKeyToScalar(J), G = R.fromPrivateKey(M);
      return { scalar: G.hasEvenY() ? M : U(-M), bytes: m(G) };
    }
    function O(J) {
      if (!k(J))
        throw new Error("bad x: need 0 < x < p");
      const M = T(J * J), G = T(M * J + BigInt(7));
      let K = h(G);
      K % f !== g && (K = T(-K));
      const X = new R(J, K, l);
      return X.assertValidity(), X;
    }
    function I(...J) {
      return U((0, i.bytesToNumberBE)(E("BIP0340/challenge", ...J)));
    }
    function P(J) {
      return D(J).bytes;
    }
    function S(J, M, G = (0, t.randomBytes)(32)) {
      const K = (0, i.ensureBytes)("message", J), { bytes: X, scalar: te } = D(M), pe = (0, i.ensureBytes)("auxRand", G, 32), he = N(te ^ (0, i.bytesToNumberBE)(E("BIP0340/aux", pe))), ye = E("BIP0340/nonce", he, X, K), re = U((0, i.bytesToNumberBE)(ye));
      if (re === g)
        throw new Error("sign failed: k is zero");
      const { bytes: ae, scalar: L } = D(re), ne = I(ae, X, K), oe = new Uint8Array(64);
      if (oe.set(ae, 0), oe.set(N(U(L + ne * te)), 32), !B(oe, K, X))
        throw new Error("sign: Invalid signature produced");
      return oe;
    }
    function B(J, M, G) {
      const K = (0, i.ensureBytes)("signature", J, 64), X = (0, i.ensureBytes)("message", M), te = (0, i.ensureBytes)("publicKey", G, 32);
      try {
        const pe = O((0, i.bytesToNumberBE)(te)), he = (0, i.bytesToNumberBE)(K.subarray(0, 32));
        if (!k(he))
          return !1;
        const ye = (0, i.bytesToNumberBE)(K.subarray(32, 64));
        if (!A(ye))
          return !1;
        const re = I(N(he), m(pe), X), ae = j(pe, ye, U(-re));
        return !(!ae || !ae.hasEvenY() || ae.toAffine().x !== he);
      } catch {
        return !1;
      }
    }
    r.schnorr = {
      getPublicKey: P,
      sign: S,
      verify: B,
      utils: {
        randomPrivateKey: r.secp256k1.utils.randomPrivateKey,
        lift_x: O,
        pointToBytes: m,
        numberToBytesBE: i.numberToBytesBE,
        bytesToNumberBE: i.bytesToNumberBE,
        taggedHash: E,
        mod: n.mod
      }
    };
    const C = (0, a.isogenyMap)(p, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((J) => J.map((M) => BigInt(M)))), H = (0, s.mapToCurveSimpleSWU)(p, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: p.create(BigInt("-11"))
    }), V = (0, a.createHasher)(r.secp256k1.ProjectivePoint, (J) => {
      const { x: M, y: G } = H(p.create(J[0]));
      return C(M, G);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: p.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: e.sha256
    });
    r.hashToCurve = V.hashToCurve, r.encodeToCurve = V.encodeToCurve;
  }(mp)), mp;
}
var ul = {}, wp = {}, ll = {}, G1;
function XA() {
  return G1 || (G1 = 1, Object.defineProperty(ll, "__esModule", { value: !0 }), ll.ZeroAddress = void 0, ll.ZeroAddress = "0x0000000000000000000000000000000000000000"), ll;
}
var fl = {}, V1;
function Nv() {
  return V1 || (V1 = 1, Object.defineProperty(fl, "__esModule", { value: !0 }), fl.ZeroHash = void 0, fl.ZeroHash = "0x0000000000000000000000000000000000000000000000000000000000000000"), fl;
}
var wr = {}, $1;
function Sv() {
  return $1 || ($1 = 1, Object.defineProperty(wr, "__esModule", { value: !0 }), wr.MaxInt256 = wr.MinInt256 = wr.MaxUint256 = wr.WeiPerEther = wr.N = void 0, wr.N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), wr.WeiPerEther = BigInt("1000000000000000000"), wr.MaxUint256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), wr.MinInt256 = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1), wr.MaxInt256 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")), wr;
}
var da = {}, K1;
function Cv() {
  return K1 || (K1 = 1, Object.defineProperty(da, "__esModule", { value: !0 }), da.MessagePrefix = da.EtherSymbol = void 0, da.EtherSymbol = "Ξ", da.MessagePrefix = `Ethereum Signed Message:
`), da;
}
var z1;
function ff() {
  return z1 || (z1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.MessagePrefix = r.EtherSymbol = r.MaxInt256 = r.MinInt256 = r.MaxUint256 = r.WeiPerEther = r.N = r.ZeroHash = r.ZeroAddress = void 0;
    var e = XA();
    Object.defineProperty(r, "ZeroAddress", { enumerable: !0, get: function() {
      return e.ZeroAddress;
    } });
    var t = Nv();
    Object.defineProperty(r, "ZeroHash", { enumerable: !0, get: function() {
      return t.ZeroHash;
    } });
    var n = Sv();
    Object.defineProperty(r, "N", { enumerable: !0, get: function() {
      return n.N;
    } }), Object.defineProperty(r, "WeiPerEther", { enumerable: !0, get: function() {
      return n.WeiPerEther;
    } }), Object.defineProperty(r, "MaxUint256", { enumerable: !0, get: function() {
      return n.MaxUint256;
    } }), Object.defineProperty(r, "MinInt256", { enumerable: !0, get: function() {
      return n.MinInt256;
    } }), Object.defineProperty(r, "MaxInt256", { enumerable: !0, get: function() {
      return n.MaxInt256;
    } });
    var s = Cv();
    Object.defineProperty(r, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(r, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
  }(wp)), wp;
}
var J1;
function e6() {
  var f, d, h, p;
  if (J1) return ul;
  J1 = 1, Object.defineProperty(ul, "__esModule", { value: !0 }), ul.Signature = void 0;
  const r = ff(), e = Me(), t = BigInt(0), n = BigInt(1), s = BigInt(2), i = BigInt(27), a = BigInt(28), o = BigInt(35), u = {};
  function c(k) {
    return (0, e.zeroPadValue)((0, e.toBeArray)(k), 32);
  }
  const g = class g {
    /**
     *  @private
     */
    constructor(A, y, E, m) {
      Z(this, f);
      Z(this, d);
      Z(this, h);
      Z(this, p);
      (0, e.assertPrivate)(A, u, "Signature"), F(this, f, y), F(this, d, E), F(this, h, m), F(this, p, null);
    }
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */
    get r() {
      return x(this, f);
    }
    set r(A) {
      (0, e.assertArgument)((0, e.dataLength)(A) === 32, "invalid r", "value", A), F(this, f, (0, e.hexlify)(A));
    }
    /**
     *  The ``s`` value for a signature.
     */
    get s() {
      return x(this, d);
    }
    set s(A) {
      (0, e.assertArgument)((0, e.dataLength)(A) === 32, "invalid s", "value", A);
      const y = (0, e.hexlify)(A);
      (0, e.assertArgument)(parseInt(y.substring(0, 3)) < 8, "non-canonical s", "value", y), F(this, d, y);
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */
    get v() {
      return x(this, h);
    }
    set v(A) {
      const y = (0, e.getNumber)(A, "value");
      (0, e.assertArgument)(y === 27 || y === 28, "invalid v", "v", A), F(this, h, y);
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get networkV() {
      return x(this, p);
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */
    get legacyChainId() {
      const A = this.networkV;
      return A == null ? null : g.getChainId(A);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */
    get yParity() {
      return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */
    get yParityAndS() {
      const A = (0, e.getBytes)(this.s);
      return this.yParity && (A[0] |= 128), (0, e.hexlify)(A);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */
    get compactSerialized() {
      return (0, e.concat)([this.r, this.yParityAndS]);
    }
    /**
     *  The serialized representation.
     */
    get serialized() {
      return (0, e.concat)([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
      return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */
    clone() {
      const A = new g(u, this.r, this.s, this.v);
      return this.networkV && F(A, p, this.networkV), A;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */
    toJSON() {
      const A = this.networkV;
      return {
        _type: "signature",
        networkV: A != null ? A.toString() : null,
        r: this.r,
        s: this.s,
        v: this.v
      };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */
    static getChainId(A) {
      const y = (0, e.getBigInt)(A, "v");
      return y == i || y == a ? t : ((0, e.assertArgument)(y >= o, "invalid EIP-155 v", "v", A), (y - o) / s);
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */
    static getChainIdV(A, y) {
      return (0, e.getBigInt)(A) * s + BigInt(35 + y - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */
    static getNormalizedV(A) {
      const y = (0, e.getBigInt)(A);
      return y === t || y === i ? 27 : y === n || y === a ? 28 : ((0, e.assertArgument)(y >= o, "invalid v", "v", A), y & n ? 27 : 28);
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */
    static from(A) {
      function y(j, D) {
        (0, e.assertArgument)(j, D, "signature", A);
      }
      if (A == null)
        return new g(u, r.ZeroHash, r.ZeroHash, 27);
      if (typeof A == "string") {
        const j = (0, e.getBytes)(A, "signature");
        if (j.length === 64) {
          const D = (0, e.hexlify)(j.slice(0, 32)), O = j.slice(32, 64), I = O[0] & 128 ? 28 : 27;
          return O[0] &= 127, new g(u, D, (0, e.hexlify)(O), I);
        }
        if (j.length === 65) {
          const D = (0, e.hexlify)(j.slice(0, 32)), O = j.slice(32, 64);
          y((O[0] & 128) === 0, "non-canonical s");
          const I = g.getNormalizedV(j[64]);
          return new g(u, D, (0, e.hexlify)(O), I);
        }
        y(!1, "invalid raw signature length");
      }
      if (A instanceof g)
        return A.clone();
      const E = A.r;
      y(E != null, "missing r");
      const m = c(E), N = function(j, D) {
        if (j != null)
          return c(j);
        if (D != null) {
          y((0, e.isHexString)(D, 32), "invalid yParityAndS");
          const O = (0, e.getBytes)(D);
          return O[0] &= 127, (0, e.hexlify)(O);
        }
        y(!1, "missing s");
      }(A.s, A.yParityAndS);
      y(((0, e.getBytes)(N)[0] & 128) == 0, "non-canonical s");
      const { networkV: T, v: U } = function(j, D, O) {
        if (j != null) {
          const I = (0, e.getBigInt)(j);
          return {
            networkV: I >= o ? I : void 0,
            v: g.getNormalizedV(I)
          };
        }
        if (D != null)
          return y((0, e.isHexString)(D, 32), "invalid yParityAndS"), { v: (0, e.getBytes)(D)[0] & 128 ? 28 : 27 };
        if (O != null) {
          switch ((0, e.getNumber)(O, "sig.yParity")) {
            case 0:
              return { v: 27 };
            case 1:
              return { v: 28 };
          }
          y(!1, "invalid yParity");
        }
        y(!1, "missing v");
      }(A.v, A.yParityAndS, A.yParity), R = new g(u, m, N, U);
      return T && F(R, p, T), y(A.yParity == null || (0, e.getNumber)(A.yParity, "sig.yParity") === R.yParity, "yParity mismatch"), y(A.yParityAndS == null || A.yParityAndS === R.yParityAndS, "yParityAndS mismatch"), R;
    }
  };
  f = new WeakMap(), d = new WeakMap(), h = new WeakMap(), p = new WeakMap();
  let l = g;
  return ul.Signature = l, ul;
}
var Q1;
function Rv() {
  var s;
  if (Q1) return cl;
  Q1 = 1, Object.defineProperty(cl, "__esModule", { value: !0 }), cl.SigningKey = void 0;
  const r = Ov(), e = Me(), t = e6(), i = class i {
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */
    constructor(o) {
      Z(this, s);
      (0, e.assertArgument)((0, e.dataLength)(o) === 32, "invalid private key", "privateKey", "[REDACTED]"), F(this, s, (0, e.hexlify)(o));
    }
    /**
     *  The private key.
     */
    get privateKey() {
      return x(this, s);
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */
    get publicKey() {
      return i.computePublicKey(x(this, s));
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */
    get compressedPublicKey() {
      return i.computePublicKey(x(this, s), !0);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */
    sign(o) {
      (0, e.assertArgument)((0, e.dataLength)(o) === 32, "invalid digest length", "digest", o);
      const u = r.secp256k1.sign((0, e.getBytesCopy)(o), (0, e.getBytesCopy)(x(this, s)), {
        lowS: !0
      });
      return t.Signature.from({
        r: (0, e.toBeHex)(u.r, 32),
        s: (0, e.toBeHex)(u.s, 32),
        v: u.recovery ? 28 : 27
      });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */
    computeSharedSecret(o) {
      const u = i.computePublicKey(o);
      return (0, e.hexlify)(r.secp256k1.getSharedSecret((0, e.getBytesCopy)(x(this, s)), (0, e.getBytes)(u), !1));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */
    static computePublicKey(o, u) {
      let c = (0, e.getBytes)(o, "key");
      if (c.length === 32) {
        const f = r.secp256k1.getPublicKey(c, !!u);
        return (0, e.hexlify)(f);
      }
      if (c.length === 64) {
        const f = new Uint8Array(65);
        f[0] = 4, f.set(c, 1), c = f;
      }
      const l = r.secp256k1.ProjectivePoint.fromHex(c);
      return (0, e.hexlify)(l.toRawBytes(u));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */
    static recoverPublicKey(o, u) {
      (0, e.assertArgument)((0, e.dataLength)(o) === 32, "invalid digest length", "digest", o);
      const c = t.Signature.from(u);
      let l = r.secp256k1.Signature.fromCompact((0, e.getBytesCopy)((0, e.concat)([c.r, c.s])));
      l = l.addRecoveryBit(c.yParity);
      const f = l.recoverPublicKey((0, e.getBytesCopy)(o));
      return (0, e.assertArgument)(f != null, "invalid signautre for digest", "signature", u), "0x" + f.toHex(!1);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */
    static addPoints(o, u, c) {
      const l = r.secp256k1.ProjectivePoint.fromHex(i.computePublicKey(o).substring(2)), f = r.secp256k1.ProjectivePoint.fromHex(i.computePublicKey(u).substring(2));
      return "0x" + l.add(f).toHex(!!c);
    }
  };
  s = new WeakMap();
  let n = i;
  return cl.SigningKey = n, cl;
}
var q1;
function Yt() {
  return q1 || (q1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.lock = r.Signature = r.SigningKey = r.scryptSync = r.scrypt = r.pbkdf2 = r.sha512 = r.sha256 = r.ripemd160 = r.keccak256 = r.randomBytes = r.computeHmac = void 0;
    const e = bv();
    Object.defineProperty(r, "computeHmac", { enumerable: !0, get: function() {
      return e.computeHmac;
    } });
    const t = xv();
    Object.defineProperty(r, "keccak256", { enumerable: !0, get: function() {
      return t.keccak256;
    } });
    const n = yv();
    Object.defineProperty(r, "ripemd160", { enumerable: !0, get: function() {
      return n.ripemd160;
    } });
    const s = wv();
    Object.defineProperty(r, "pbkdf2", { enumerable: !0, get: function() {
      return s.pbkdf2;
    } });
    const i = Av();
    Object.defineProperty(r, "randomBytes", { enumerable: !0, get: function() {
      return i.randomBytes;
    } });
    const a = Pv();
    Object.defineProperty(r, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(r, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } });
    const o = vv();
    Object.defineProperty(r, "sha256", { enumerable: !0, get: function() {
      return o.sha256;
    } }), Object.defineProperty(r, "sha512", { enumerable: !0, get: function() {
      return o.sha512;
    } });
    var u = Rv();
    Object.defineProperty(r, "SigningKey", { enumerable: !0, get: function() {
      return u.SigningKey;
    } });
    var c = e6();
    Object.defineProperty(r, "Signature", { enumerable: !0, get: function() {
      return c.Signature;
    } });
    function l() {
      e.computeHmac.lock(), t.keccak256.lock(), s.pbkdf2.lock(), i.randomBytes.lock(), n.ripemd160.lock(), a.scrypt.lock(), a.scryptSync.lock(), o.sha256.lock(), o.sha512.lock(), i.randomBytes.lock();
    }
    r.lock = l;
  }(xp)), xp;
}
var W1;
function ux() {
  if (W1) return sa;
  W1 = 1, Object.defineProperty(sa, "__esModule", { value: !0 }), sa.getIcapAddress = sa.getAddress = void 0;
  const r = Yt(), e = Me(), t = BigInt(0), n = BigInt(36);
  function s(d) {
    d = d.toLowerCase();
    const h = d.substring(2).split(""), p = new Uint8Array(40);
    for (let k = 0; k < 40; k++)
      p[k] = h[k].charCodeAt(0);
    const g = (0, e.getBytes)((0, r.keccak256)(p));
    for (let k = 0; k < 40; k += 2)
      g[k >> 1] >> 4 >= 8 && (h[k] = h[k].toUpperCase()), (g[k >> 1] & 15) >= 8 && (h[k + 1] = h[k + 1].toUpperCase());
    return "0x" + h.join("");
  }
  const i = {};
  for (let d = 0; d < 10; d++)
    i[String(d)] = String(d);
  for (let d = 0; d < 26; d++)
    i[String.fromCharCode(65 + d)] = String(10 + d);
  const a = 15;
  function o(d) {
    d = d.toUpperCase(), d = d.substring(4) + d.substring(0, 2) + "00";
    let h = d.split("").map((g) => i[g]).join("");
    for (; h.length >= a; ) {
      let g = h.substring(0, a);
      h = parseInt(g, 10) % 97 + h.substring(g.length);
    }
    let p = String(98 - parseInt(h, 10) % 97);
    for (; p.length < 2; )
      p = "0" + p;
    return p;
  }
  const u = function() {
    const d = {};
    for (let h = 0; h < 36; h++) {
      const p = "0123456789abcdefghijklmnopqrstuvwxyz"[h];
      d[p] = BigInt(h);
    }
    return d;
  }();
  function c(d) {
    d = d.toLowerCase();
    let h = t;
    for (let p = 0; p < d.length; p++)
      h = h * n + u[d[p]];
    return h;
  }
  function l(d) {
    if ((0, e.assertArgument)(typeof d == "string", "invalid address", "address", d), d.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
      d.startsWith("0x") || (d = "0x" + d);
      const h = s(d);
      return (0, e.assertArgument)(!d.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || h === d, "bad address checksum", "address", d), h;
    }
    if (d.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
      (0, e.assertArgument)(d.substring(2, 4) === o(d), "bad icap checksum", "address", d);
      let h = c(d.substring(4)).toString(16);
      for (; h.length < 40; )
        h = "0" + h;
      return s("0x" + h);
    }
    (0, e.assertArgument)(!1, "invalid address", "address", d);
  }
  sa.getAddress = l;
  function f(d) {
    let h = BigInt(l(d)).toString(36).toUpperCase();
    for (; h.length < 30; )
      h = "0" + h;
    return "XE" + o("XE00" + h) + h;
  }
  return sa.getIcapAddress = f, sa;
}
var ha = {}, Y1;
function Iv() {
  if (Y1) return ha;
  Y1 = 1, Object.defineProperty(ha, "__esModule", { value: !0 }), ha.getCreate2Address = ha.getCreateAddress = void 0;
  const r = Yt(), e = Me(), t = ux();
  function n(i) {
    const a = (0, t.getAddress)(i.from);
    let u = (0, e.getBigInt)(i.nonce, "tx.nonce").toString(16);
    return u === "0" ? u = "0x" : u.length % 2 ? u = "0x0" + u : u = "0x" + u, (0, t.getAddress)((0, e.dataSlice)((0, r.keccak256)((0, e.encodeRlp)([a, u])), 12));
  }
  ha.getCreateAddress = n;
  function s(i, a, o) {
    const u = (0, t.getAddress)(i), c = (0, e.getBytes)(a, "salt"), l = (0, e.getBytes)(o, "initCodeHash");
    return (0, e.assertArgument)(c.length === 32, "salt must be 32 bytes", "salt", a), (0, e.assertArgument)(l.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", o), (0, t.getAddress)((0, e.dataSlice)((0, r.keccak256)((0, e.concat)(["0xff", u, c, l])), 12));
  }
  return ha.getCreate2Address = s, ha;
}
var is = {}, Z1;
function _v() {
  if (Z1) return is;
  Z1 = 1, Object.defineProperty(is, "__esModule", { value: !0 }), is.resolveAddress = is.isAddress = is.isAddressable = void 0;
  const r = Me(), e = ux();
  function t(a) {
    return a && typeof a.getAddress == "function";
  }
  is.isAddressable = t;
  function n(a) {
    try {
      return (0, e.getAddress)(a), !0;
    } catch {
    }
    return !1;
  }
  is.isAddress = n;
  async function s(a, o) {
    const u = await o;
    return (u == null || u === "0x0000000000000000000000000000000000000000") && ((0, r.assert)(typeof a != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: a }), (0, r.assertArgument)(!1, "invalid AddressLike value; did not resolve to a value address", "target", a)), (0, e.getAddress)(u);
  }
  function i(a, o) {
    if (typeof a == "string")
      return a.match(/^0x[0-9a-f]{40}$/i) ? (0, e.getAddress)(a) : ((0, r.assert)(o != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), s(a, o.resolveName(a)));
    if (t(a))
      return s(a, a.getAddress());
    if (a && typeof a.then == "function")
      return s(a, a);
    (0, r.assertArgument)(!1, "unsupported addressable value", "target", a);
  }
  return is.resolveAddress = i, is;
}
var X1;
function zt() {
  return X1 || (X1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.resolveAddress = r.isAddress = r.isAddressable = r.getCreate2Address = r.getCreateAddress = r.getIcapAddress = r.getAddress = void 0;
    var e = ux();
    Object.defineProperty(r, "getAddress", { enumerable: !0, get: function() {
      return e.getAddress;
    } }), Object.defineProperty(r, "getIcapAddress", { enumerable: !0, get: function() {
      return e.getIcapAddress;
    } });
    var t = Iv();
    Object.defineProperty(r, "getCreateAddress", { enumerable: !0, get: function() {
      return t.getCreateAddress;
    } }), Object.defineProperty(r, "getCreate2Address", { enumerable: !0, get: function() {
      return t.getCreate2Address;
    } });
    var n = _v();
    Object.defineProperty(r, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(r, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(r, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
  }(gp)), gp;
}
var dl = {}, ey;
function Ws() {
  var a;
  if (ey) return dl;
  ey = 1, Object.defineProperty(dl, "__esModule", { value: !0 }), dl.Typed = void 0;
  const r = Me(), e = {};
  function t(u, c) {
    let l = !1;
    return c < 0 && (l = !0, c *= -1), new i(e, `${l ? "" : "u"}int${c}`, u, { signed: l, width: c });
  }
  function n(u, c) {
    return new i(e, `bytes${c || ""}`, u, { size: c });
  }
  const s = Symbol.for("_ethers_typed"), o = class o {
    /**
     *  @_ignore:
     */
    constructor(c, l, f, d) {
      /**
       *  The type, as a Solidity-compatible type.
       */
      Q(this, "type");
      /**
       *  The actual value.
       */
      Q(this, "value");
      Z(this, a);
      /**
       *  @_ignore:
       */
      Q(this, "_typedSymbol");
      d == null && (d = null), (0, r.assertPrivate)(e, c, "Typed"), (0, r.defineProperties)(this, { _typedSymbol: s, type: l, value: f }), F(this, a, d), this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */
    format() {
      if (this.type === "array")
        throw new Error("");
      if (this.type === "dynamicArray")
        throw new Error("");
      return this.type === "tuple" ? `tuple(${this.value.map((c) => c.format()).join(",")})` : this.type;
    }
    /**
     *  The default value returned by this type.
     */
    defaultValue() {
      return 0;
    }
    /**
     *  The minimum value for numeric types.
     */
    minValue() {
      return 0;
    }
    /**
     *  The maximum value for numeric types.
     */
    maxValue() {
      return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */
    isBigInt() {
      return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */
    isData() {
      return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */
    isString() {
      return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */
    get tupleName() {
      if (this.type !== "tuple")
        throw TypeError("not a tuple");
      return x(this, a);
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */
    get arrayLength() {
      if (this.type !== "array")
        throw TypeError("not an array");
      return x(this, a) === !0 ? -1 : x(this, a) === !1 ? this.value.length : null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */
    static from(c, l) {
      return new o(e, c, l);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static uint8(c) {
      return t(c, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */
    static uint16(c) {
      return t(c, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */
    static uint24(c) {
      return t(c, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */
    static uint32(c) {
      return t(c, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */
    static uint40(c) {
      return t(c, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */
    static uint48(c) {
      return t(c, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */
    static uint56(c) {
      return t(c, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */
    static uint64(c) {
      return t(c, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */
    static uint72(c) {
      return t(c, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */
    static uint80(c) {
      return t(c, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */
    static uint88(c) {
      return t(c, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */
    static uint96(c) {
      return t(c, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */
    static uint104(c) {
      return t(c, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */
    static uint112(c) {
      return t(c, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */
    static uint120(c) {
      return t(c, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */
    static uint128(c) {
      return t(c, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */
    static uint136(c) {
      return t(c, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */
    static uint144(c) {
      return t(c, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */
    static uint152(c) {
      return t(c, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */
    static uint160(c) {
      return t(c, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */
    static uint168(c) {
      return t(c, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */
    static uint176(c) {
      return t(c, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */
    static uint184(c) {
      return t(c, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */
    static uint192(c) {
      return t(c, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */
    static uint200(c) {
      return t(c, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */
    static uint208(c) {
      return t(c, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */
    static uint216(c) {
      return t(c, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */
    static uint224(c) {
      return t(c, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */
    static uint232(c) {
      return t(c, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */
    static uint240(c) {
      return t(c, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */
    static uint248(c) {
      return t(c, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint256(c) {
      return t(c, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint(c) {
      return t(c, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */
    static int8(c) {
      return t(c, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */
    static int16(c) {
      return t(c, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */
    static int24(c) {
      return t(c, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */
    static int32(c) {
      return t(c, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */
    static int40(c) {
      return t(c, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */
    static int48(c) {
      return t(c, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */
    static int56(c) {
      return t(c, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */
    static int64(c) {
      return t(c, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */
    static int72(c) {
      return t(c, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */
    static int80(c) {
      return t(c, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */
    static int88(c) {
      return t(c, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */
    static int96(c) {
      return t(c, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */
    static int104(c) {
      return t(c, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */
    static int112(c) {
      return t(c, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */
    static int120(c) {
      return t(c, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */
    static int128(c) {
      return t(c, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */
    static int136(c) {
      return t(c, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */
    static int144(c) {
      return t(c, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */
    static int152(c) {
      return t(c, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */
    static int160(c) {
      return t(c, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */
    static int168(c) {
      return t(c, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */
    static int176(c) {
      return t(c, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */
    static int184(c) {
      return t(c, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */
    static int192(c) {
      return t(c, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */
    static int200(c) {
      return t(c, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */
    static int208(c) {
      return t(c, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */
    static int216(c) {
      return t(c, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */
    static int224(c) {
      return t(c, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */
    static int232(c) {
      return t(c, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */
    static int240(c) {
      return t(c, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */
    static int248(c) {
      return t(c, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int256(c) {
      return t(c, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int(c) {
      return t(c, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */
    static bytes1(c) {
      return n(c, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */
    static bytes2(c) {
      return n(c, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */
    static bytes3(c) {
      return n(c, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */
    static bytes4(c) {
      return n(c, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */
    static bytes5(c) {
      return n(c, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */
    static bytes6(c) {
      return n(c, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */
    static bytes7(c) {
      return n(c, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */
    static bytes8(c) {
      return n(c, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */
    static bytes9(c) {
      return n(c, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */
    static bytes10(c) {
      return n(c, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */
    static bytes11(c) {
      return n(c, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */
    static bytes12(c) {
      return n(c, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */
    static bytes13(c) {
      return n(c, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */
    static bytes14(c) {
      return n(c, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */
    static bytes15(c) {
      return n(c, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */
    static bytes16(c) {
      return n(c, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */
    static bytes17(c) {
      return n(c, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */
    static bytes18(c) {
      return n(c, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */
    static bytes19(c) {
      return n(c, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */
    static bytes20(c) {
      return n(c, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */
    static bytes21(c) {
      return n(c, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */
    static bytes22(c) {
      return n(c, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */
    static bytes23(c) {
      return n(c, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */
    static bytes24(c) {
      return n(c, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */
    static bytes25(c) {
      return n(c, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */
    static bytes26(c) {
      return n(c, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */
    static bytes27(c) {
      return n(c, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */
    static bytes28(c) {
      return n(c, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */
    static bytes29(c) {
      return n(c, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */
    static bytes30(c) {
      return n(c, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */
    static bytes31(c) {
      return n(c, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */
    static bytes32(c) {
      return n(c, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */
    static address(c) {
      return new o(e, "address", c);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */
    static bool(c) {
      return new o(e, "bool", !!c);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */
    static bytes(c) {
      return new o(e, "bytes", c);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */
    static string(c) {
      return new o(e, "string", c);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */
    static array(c, l) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */
    static tuple(c, l) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static overrides(c) {
      return new o(e, "overrides", Object.assign({}, c));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */
    static isTyped(c) {
      return c && typeof c == "object" && "_typedSymbol" in c && c._typedSymbol === s;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */
    static dereference(c, l) {
      if (o.isTyped(c)) {
        if (c.type !== l)
          throw new Error(`invalid type: expecetd ${l}, got ${c.type}`);
        return c.value;
      }
      return c;
    }
  };
  a = new WeakMap();
  let i = o;
  return dl.Typed = i, dl;
}
var ty;
function Uv() {
  if (ty) return rl;
  ty = 1, Object.defineProperty(rl, "__esModule", { value: !0 }), rl.AddressCoder = void 0;
  const r = zt(), e = lf(), t = Ws(), n = Cn();
  class s extends n.Coder {
    constructor(a) {
      super("address", "address", a, !1);
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000";
    }
    encode(a, o) {
      let u = t.Typed.dereference(o, "string");
      try {
        u = (0, r.getAddress)(u);
      } catch (c) {
        return this._throwError(c.message, o);
      }
      return a.writeValue(u);
    }
    decode(a) {
      return (0, r.getAddress)((0, e.toBeHex)(a.readValue(), 20));
    }
  }
  return rl.AddressCoder = s, rl;
}
var as = {}, hl = {}, ry;
function Lv() {
  if (ry) return hl;
  ry = 1, Object.defineProperty(hl, "__esModule", { value: !0 }), hl.AnonymousCoder = void 0;
  const r = Cn();
  class e extends r.Coder {
    constructor(s) {
      super(s.name, s.type, "_", s.dynamic);
      Q(this, "coder");
      this.coder = s;
    }
    defaultValue() {
      return this.coder.defaultValue();
    }
    encode(s, i) {
      return this.coder.encode(s, i);
    }
    decode(s) {
      return this.coder.decode(s);
    }
  }
  return hl.AnonymousCoder = e, hl;
}
var ny;
function t6() {
  if (ny) return as;
  ny = 1, Object.defineProperty(as, "__esModule", { value: !0 }), as.ArrayCoder = as.unpack = as.pack = void 0;
  const r = Me(), e = Ws(), t = Cn(), n = Lv();
  function s(o, u, c) {
    let l = [];
    if (Array.isArray(c))
      l = c;
    else if (c && typeof c == "object") {
      let g = {};
      l = u.map((k) => {
        const A = k.localName;
        return (0, r.assert)(A, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: k }, value: c }), (0, r.assert)(!g[A], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: k }, value: c }), g[A] = !0, c[A];
      });
    } else
      (0, r.assertArgument)(!1, "invalid tuple value", "tuple", c);
    (0, r.assertArgument)(u.length === l.length, "types/value length mismatch", "tuple", c);
    let f = new t.Writer(), d = new t.Writer(), h = [];
    u.forEach((g, k) => {
      let A = l[k];
      if (g.dynamic) {
        let y = d.length;
        g.encode(d, A);
        let E = f.writeUpdatableValue();
        h.push((m) => {
          E(m + y);
        });
      } else
        g.encode(f, A);
    }), h.forEach((g) => {
      g(f.length);
    });
    let p = o.appendWriter(f);
    return p += o.appendWriter(d), p;
  }
  as.pack = s;
  function i(o, u) {
    let c = [], l = [], f = o.subReader(0);
    return u.forEach((d) => {
      let h = null;
      if (d.dynamic) {
        let p = o.readIndex(), g = f.subReader(p);
        try {
          h = d.decode(g);
        } catch (k) {
          if ((0, r.isError)(k, "BUFFER_OVERRUN"))
            throw k;
          h = k, h.baseType = d.name, h.name = d.localName, h.type = d.type;
        }
      } else
        try {
          h = d.decode(o);
        } catch (p) {
          if ((0, r.isError)(p, "BUFFER_OVERRUN"))
            throw p;
          h = p, h.baseType = d.name, h.name = d.localName, h.type = d.type;
        }
      if (h == null)
        throw new Error("investigate");
      c.push(h), l.push(d.localName || null);
    }), t.Result.fromItems(c, l);
  }
  as.unpack = i;
  class a extends t.Coder {
    constructor(c, l, f) {
      const d = c.type + "[" + (l >= 0 ? l : "") + "]", h = l === -1 || c.dynamic;
      super("array", d, f, h);
      Q(this, "coder");
      Q(this, "length");
      (0, r.defineProperties)(this, { coder: c, length: l });
    }
    defaultValue() {
      const c = this.coder.defaultValue(), l = [];
      for (let f = 0; f < this.length; f++)
        l.push(c);
      return l;
    }
    encode(c, l) {
      const f = e.Typed.dereference(l, "array");
      Array.isArray(f) || this._throwError("expected array value", f);
      let d = this.length;
      d === -1 && (d = f.length, c.writeValue(f.length)), (0, r.assertArgumentCount)(f.length, d, "coder array" + (this.localName ? " " + this.localName : ""));
      let h = [];
      for (let p = 0; p < f.length; p++)
        h.push(this.coder);
      return s(c, h, f);
    }
    decode(c) {
      let l = this.length;
      l === -1 && (l = c.readIndex(), (0, r.assert)(l * t.WordSize <= c.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: c.bytes, offset: l * t.WordSize, length: c.dataLength }));
      let f = [];
      for (let d = 0; d < l; d++)
        f.push(new n.AnonymousCoder(this.coder));
      return i(c, f);
    }
  }
  return as.ArrayCoder = a, as;
}
var pl = {}, sy;
function Mv() {
  if (sy) return pl;
  sy = 1, Object.defineProperty(pl, "__esModule", { value: !0 }), pl.BooleanCoder = void 0;
  const r = Ws(), e = Cn();
  class t extends e.Coder {
    constructor(s) {
      super("bool", "bool", s, !1);
    }
    defaultValue() {
      return !1;
    }
    encode(s, i) {
      const a = r.Typed.dereference(i, "bool");
      return s.writeValue(a ? 1 : 0);
    }
    decode(s) {
      return !!s.readValue();
    }
  }
  return pl.BooleanCoder = t, pl;
}
var pa = {}, iy;
function r6() {
  if (iy) return pa;
  iy = 1, Object.defineProperty(pa, "__esModule", { value: !0 }), pa.BytesCoder = pa.DynamicBytesCoder = void 0;
  const r = Me(), e = Cn();
  class t extends e.Coder {
    constructor(i, a) {
      super(i, i, a, !0);
    }
    defaultValue() {
      return "0x";
    }
    encode(i, a) {
      a = (0, r.getBytesCopy)(a);
      let o = i.writeValue(a.length);
      return o += i.writeBytes(a), o;
    }
    decode(i) {
      return i.readBytes(i.readIndex(), !0);
    }
  }
  pa.DynamicBytesCoder = t;
  class n extends t {
    constructor(i) {
      super("bytes", i);
    }
    decode(i) {
      return (0, r.hexlify)(super.decode(i));
    }
  }
  return pa.BytesCoder = n, pa;
}
var bl = {}, ay;
function Fv() {
  if (ay) return bl;
  ay = 1, Object.defineProperty(bl, "__esModule", { value: !0 }), bl.FixedBytesCoder = void 0;
  const r = Me(), e = Ws(), t = Cn();
  class n extends t.Coder {
    constructor(a, o) {
      let u = "bytes" + String(a);
      super(u, u, o, !1);
      Q(this, "size");
      (0, r.defineProperties)(this, { size: a }, { size: "number" });
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(a, o) {
      let u = (0, r.getBytesCopy)(e.Typed.dereference(o, this.type));
      return u.length !== this.size && this._throwError("incorrect data length", o), a.writeBytes(u);
    }
    decode(a) {
      return (0, r.hexlify)(a.readBytes(this.size));
    }
  }
  return bl.FixedBytesCoder = n, bl;
}
var gl = {}, oy;
function Dv() {
  if (oy) return gl;
  oy = 1, Object.defineProperty(gl, "__esModule", { value: !0 }), gl.NullCoder = void 0;
  const r = Cn(), e = new Uint8Array([]);
  class t extends r.Coder {
    constructor(s) {
      super("null", "", s, !1);
    }
    defaultValue() {
      return null;
    }
    encode(s, i) {
      return i != null && this._throwError("not null", i), s.writeBytes(e);
    }
    decode(s) {
      return s.readBytes(0), null;
    }
  }
  return gl.NullCoder = t, gl;
}
var xl = {}, cy;
function jv() {
  if (cy) return xl;
  cy = 1, Object.defineProperty(xl, "__esModule", { value: !0 }), xl.NumberCoder = void 0;
  const r = Me(), e = Ws(), t = Cn(), n = BigInt(0), s = BigInt(1), i = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  class a extends t.Coder {
    constructor(c, l, f) {
      const d = (l ? "int" : "uint") + c * 8;
      super(d, d, f, !1);
      Q(this, "size");
      Q(this, "signed");
      (0, r.defineProperties)(this, { size: c, signed: l }, { size: "number", signed: "boolean" });
    }
    defaultValue() {
      return 0;
    }
    encode(c, l) {
      let f = (0, r.getBigInt)(e.Typed.dereference(l, this.type)), d = (0, r.mask)(i, t.WordSize * 8);
      if (this.signed) {
        let h = (0, r.mask)(d, this.size * 8 - 1);
        (f > h || f < -(h + s)) && this._throwError("value out-of-bounds", l), f = (0, r.toTwos)(f, 8 * t.WordSize);
      } else (f < n || f > (0, r.mask)(d, this.size * 8)) && this._throwError("value out-of-bounds", l);
      return c.writeValue(f);
    }
    decode(c) {
      let l = (0, r.mask)(c.readValue(), this.size * 8);
      return this.signed && (l = (0, r.fromTwos)(l, this.size * 8)), l;
    }
  }
  return xl.NumberCoder = a, xl;
}
var ml = {}, uy;
function Hv() {
  if (uy) return ml;
  uy = 1, Object.defineProperty(ml, "__esModule", { value: !0 }), ml.StringCoder = void 0;
  const r = cx(), e = Ws(), t = r6();
  class n extends t.DynamicBytesCoder {
    constructor(i) {
      super("string", i);
    }
    defaultValue() {
      return "";
    }
    encode(i, a) {
      return super.encode(i, (0, r.toUtf8Bytes)(e.Typed.dereference(a, "string")));
    }
    decode(i) {
      return (0, r.toUtf8String)(super.decode(i));
    }
  }
  return ml.StringCoder = n, ml;
}
var yl = {}, ly;
function Gv() {
  if (ly) return yl;
  ly = 1, Object.defineProperty(yl, "__esModule", { value: !0 }), yl.TupleCoder = void 0;
  const r = So(), e = Ws(), t = Cn(), n = t6();
  class s extends t.Coder {
    constructor(o, u) {
      let c = !1;
      const l = [];
      o.forEach((d) => {
        d.dynamic && (c = !0), l.push(d.type);
      });
      const f = "tuple(" + l.join(",") + ")";
      super("tuple", f, u, c);
      Q(this, "coders");
      (0, r.defineProperties)(this, { coders: Object.freeze(o.slice()) });
    }
    defaultValue() {
      const o = [];
      this.coders.forEach((c) => {
        o.push(c.defaultValue());
      });
      const u = this.coders.reduce((c, l) => {
        const f = l.localName;
        return f && (c[f] || (c[f] = 0), c[f]++), c;
      }, {});
      return this.coders.forEach((c, l) => {
        let f = c.localName;
        !f || u[f] !== 1 || (f === "length" && (f = "_length"), o[f] == null && (o[f] = o[l]));
      }), Object.freeze(o);
    }
    encode(o, u) {
      const c = e.Typed.dereference(u, "tuple");
      return (0, n.pack)(o, this.coders, c);
    }
    decode(o) {
      return (0, n.unpack)(o, this.coders);
    }
  }
  return yl.TupleCoder = s, yl;
}
var Tt = {}, Ap = {}, wl = {}, fy;
function n6() {
  if (fy) return wl;
  fy = 1, Object.defineProperty(wl, "__esModule", { value: !0 }), wl.id = void 0;
  const r = Yt(), e = Me();
  function t(n) {
    return (0, r.keccak256)((0, e.toUtf8Bytes)(n));
  }
  return wl.id = t, wl;
}
var an = {}, Ar = {}, dy;
function Vv() {
  if (dy) return Ar;
  dy = 1;
  var r = "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";
  const e = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), t = 4;
  function n(ge) {
    let we = 0;
    function Pe() {
      return ge[we++] << 8 | ge[we++];
    }
    let Te = Pe(), ke = 1, Ne = [0, 1];
    for (let Ln = 1; Ln < Te; Ln++)
      Ne.push(ke += Pe());
    let Se = Pe(), Le = we;
    we += Se;
    let rt = 0, gt = 0;
    function $e() {
      return rt == 0 && (gt = gt << 8 | ge[we++], rt = 8), gt >> --rt & 1;
    }
    const Ze = 31, We = 2 ** Ze, ht = We >>> 1, _t = ht >> 1, kt = We - 1;
    let Rt = 0;
    for (let Ln = 0; Ln < Ze; Ln++) Rt = Rt << 1 | $e();
    let Un = [], $o = 0, bf = We;
    for (; ; ) {
      let Ln = Math.floor(((Rt - $o + 1) * ke - 1) / bf), Wi = 0, Nh = Te;
      for (; Nh - Wi > 1; ) {
        let Sh = Wi + Nh >>> 1;
        Ln < Ne[Sh] ? Nh = Sh : Wi = Sh;
      }
      if (Wi == 0) break;
      Un.push(Wi);
      let ri = $o + Math.floor(bf * Ne[Wi] / ke), Yi = $o + Math.floor(bf * Ne[Wi + 1] / ke) - 1;
      for (; !((ri ^ Yi) & ht); )
        Rt = Rt << 1 & kt | $e(), ri = ri << 1 & kt, Yi = Yi << 1 & kt | 1;
      for (; ri & ~Yi & _t; )
        Rt = Rt & ht | Rt << 1 & kt >>> 1 | $e(), ri = ri << 1 ^ ht, Yi = (Yi ^ ht) << 1 | ht | 1;
      $o = ri, bf = 1 + Yi - ri;
    }
    let gf = Te - 4;
    return Un.map((Ln) => {
      switch (Ln - gf) {
        case 3:
          return gf + 65792 + (ge[Le++] << 16 | ge[Le++] << 8 | ge[Le++]);
        case 2:
          return gf + 256 + (ge[Le++] << 8 | ge[Le++]);
        case 1:
          return gf + ge[Le++];
        default:
          return Ln - 1;
      }
    });
  }
  function s(ge) {
    let we = 0;
    return () => ge[we++];
  }
  function i(ge) {
    return s(n(a(ge)));
  }
  function a(ge) {
    let we = [];
    [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((ke, Ne) => we[ke.charCodeAt(0)] = Ne);
    let Pe = ge.length, Te = new Uint8Array(6 * Pe >> 3);
    for (let ke = 0, Ne = 0, Se = 0, Le = 0; ke < Pe; ke++)
      Le = Le << 6 | we[ge.charCodeAt(ke)], Se += 6, Se >= 8 && (Te[Ne++] = Le >> (Se -= 8));
    return Te;
  }
  function o(ge) {
    return ge & 1 ? ~ge >> 1 : ge >> 1;
  }
  function u(ge, we) {
    let Pe = Array(ge);
    for (let Te = 0, ke = 0; Te < ge; Te++) Pe[Te] = ke += o(we());
    return Pe;
  }
  function c(ge, we = 0) {
    let Pe = [];
    for (; ; ) {
      let Te = ge(), ke = ge();
      if (!ke) break;
      we += Te;
      for (let Ne = 0; Ne < ke; Ne++)
        Pe.push(we + Ne);
      we += ke + 1;
    }
    return Pe;
  }
  function l(ge) {
    return d(() => {
      let we = c(ge);
      if (we.length) return we;
    });
  }
  function f(ge) {
    let we = [];
    for (; ; ) {
      let Pe = ge();
      if (Pe == 0) break;
      we.push(p(Pe, ge));
    }
    for (; ; ) {
      let Pe = ge() - 1;
      if (Pe < 0) break;
      we.push(g(Pe, ge));
    }
    return we.flat();
  }
  function d(ge) {
    let we = [];
    for (; ; ) {
      let Pe = ge(we.length);
      if (!Pe) break;
      we.push(Pe);
    }
    return we;
  }
  function h(ge, we, Pe) {
    let Te = Array(ge).fill().map(() => []);
    for (let ke = 0; ke < we; ke++)
      u(ge, Pe).forEach((Ne, Se) => Te[Se].push(Ne));
    return Te;
  }
  function p(ge, we) {
    let Pe = 1 + we(), Te = we(), ke = d(we);
    return h(ke.length, 1 + ge, we).flatMap((Se, Le) => {
      let [rt, ...gt] = Se;
      return Array(ke[Le]).fill().map(($e, Ze) => {
        let We = Ze * Te;
        return [rt + Ze * Pe, gt.map((ht) => ht + We)];
      });
    });
  }
  function g(ge, we) {
    let Pe = 1 + we();
    return h(Pe, 1 + ge, we).map((ke) => [ke[0], ke.slice(1)]);
  }
  function k(ge) {
    let we = [], Pe = c(ge);
    return ke(Te([]), []), we;
    function Te(Ne) {
      let Se = ge(), Le = d(() => {
        let rt = c(ge).map((gt) => Pe[gt]);
        if (rt.length) return Te(rt);
      });
      return { S: Se, B: Le, Q: Ne };
    }
    function ke({ S: Ne, B: Se }, Le, rt) {
      if (!(Ne & 4 && rt === Le[Le.length - 1])) {
        Ne & 2 && (rt = Le[Le.length - 1]), Ne & 1 && we.push(Le);
        for (let gt of Se)
          for (let $e of gt.Q)
            ke(gt, [...Le, $e], rt);
      }
    }
  }
  function A(ge) {
    return ge.toString(16).toUpperCase().padStart(2, "0");
  }
  function y(ge) {
    return `{${A(ge)}}`;
  }
  function E(ge) {
    let we = [];
    for (let Pe = 0, Te = ge.length; Pe < Te; ) {
      let ke = ge.codePointAt(Pe);
      Pe += ke < 65536 ? 1 : 2, we.push(ke);
    }
    return we;
  }
  function m(ge) {
    let Pe = ge.length;
    if (Pe < 4096) return String.fromCodePoint(...ge);
    let Te = [];
    for (let ke = 0; ke < Pe; )
      Te.push(String.fromCodePoint(...ge.slice(ke, ke += 4096)));
    return Te.join("");
  }
  function N(ge, we) {
    let Pe = ge.length, Te = Pe - we.length;
    for (let ke = 0; Te == 0 && ke < Pe; ke++) Te = ge[ke] - we[ke];
    return Te;
  }
  var T = "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";
  const U = 44032, R = 4352, j = 4449, D = 4519, O = 19, I = 21, P = 28, S = I * P, B = O * S, C = U + B, H = R + O, V = j + I, J = D + P;
  function M(ge) {
    return ge >> 24 & 255;
  }
  function G(ge) {
    return ge & 16777215;
  }
  let K, X, te, pe;
  function he() {
    let ge = i(T);
    K = new Map(l(ge).flatMap((we, Pe) => we.map((Te) => [Te, Pe + 1 << 24]))), X = new Set(c(ge)), te = /* @__PURE__ */ new Map(), pe = /* @__PURE__ */ new Map();
    for (let [we, Pe] of f(ge)) {
      if (!X.has(we) && Pe.length == 2) {
        let [Te, ke] = Pe, Ne = pe.get(Te);
        Ne || (Ne = /* @__PURE__ */ new Map(), pe.set(Te, Ne)), Ne.set(ke, we);
      }
      te.set(we, Pe.reverse());
    }
  }
  function ye(ge) {
    return ge >= U && ge < C;
  }
  function re(ge, we) {
    if (ge >= R && ge < H && we >= j && we < V)
      return U + (ge - R) * S + (we - j) * P;
    if (ye(ge) && we > D && we < J && (ge - U) % P == 0)
      return ge + (we - D);
    {
      let Pe = pe.get(ge);
      return Pe && (Pe = Pe.get(we), Pe) ? Pe : -1;
    }
  }
  function ae(ge) {
    K || he();
    let we = [], Pe = [], Te = !1;
    function ke(Ne) {
      let Se = K.get(Ne);
      Se && (Te = !0, Ne |= Se), we.push(Ne);
    }
    for (let Ne of ge)
      for (; ; ) {
        if (Ne < 128)
          we.push(Ne);
        else if (ye(Ne)) {
          let Se = Ne - U, Le = Se / S | 0, rt = Se % S / P | 0, gt = Se % P;
          ke(R + Le), ke(j + rt), gt > 0 && ke(D + gt);
        } else {
          let Se = te.get(Ne);
          Se ? Pe.push(...Se) : ke(Ne);
        }
        if (!Pe.length) break;
        Ne = Pe.pop();
      }
    if (Te && we.length > 1) {
      let Ne = M(we[0]);
      for (let Se = 1; Se < we.length; Se++) {
        let Le = M(we[Se]);
        if (Le == 0 || Ne <= Le) {
          Ne = Le;
          continue;
        }
        let rt = Se - 1;
        for (; ; ) {
          let gt = we[rt + 1];
          if (we[rt + 1] = we[rt], we[rt] = gt, !rt || (Ne = M(we[--rt]), Ne <= Le)) break;
        }
        Ne = M(we[Se]);
      }
    }
    return we;
  }
  function L(ge) {
    let we = [], Pe = [], Te = -1, ke = 0;
    for (let Ne of ge) {
      let Se = M(Ne), Le = G(Ne);
      if (Te == -1)
        Se == 0 ? Te = Le : we.push(Le);
      else if (ke > 0 && ke >= Se)
        Se == 0 ? (we.push(Te, ...Pe), Pe.length = 0, Te = Le) : Pe.push(Le), ke = Se;
      else {
        let rt = re(Te, Le);
        rt >= 0 ? Te = rt : ke == 0 && Se == 0 ? (we.push(Te), Te = Le) : (Pe.push(Le), ke = Se);
      }
    }
    return Te >= 0 && we.push(Te, ...Pe), we;
  }
  function ne(ge) {
    return ae(ge).map(G);
  }
  function oe(ge) {
    return L(ae(ge));
  }
  const ee = 45, W = 46, v = ".", z = 65039, q = 1, le = (ge) => Array.from(ge);
  function be(ge, we) {
    return ge.P.has(we) || ge.Q.has(we);
  }
  class ve extends Array {
    get is_emoji() {
      return !0;
    }
    // free tagging system
  }
  let Be, Ae, ie, se, me, fe, _, b, w, $, Y, ce;
  function xe() {
    if (Be) return;
    let ge = i(r);
    const we = () => c(ge), Pe = () => new Set(we()), Te = ($e, Ze) => Ze.forEach((We) => $e.add(We));
    Be = new Map(f(ge)), Ae = Pe(), ie = we(), se = new Set(we().map(($e) => ie[$e])), ie = new Set(ie), me = Pe(), fe = Pe();
    let ke = l(ge), Ne = ge();
    const Se = () => {
      let $e = /* @__PURE__ */ new Set();
      return we().forEach((Ze) => Te($e, ke[Ze])), Te($e, we()), $e;
    };
    _ = d(($e) => {
      let Ze = d(ge).map((We) => We + 96);
      if (Ze.length) {
        let We = $e >= Ne;
        Ze[0] -= 32, Ze = m(Ze), We && (Ze = `Restricted[${Ze}]`);
        let ht = Se(), _t = Se(), kt = !ge();
        return { N: Ze, P: ht, Q: _t, M: kt, R: We };
      }
    }), b = Pe(), w = /* @__PURE__ */ new Map();
    let Le = we().concat(le(b)).sort(($e, Ze) => $e - Ze);
    Le.forEach(($e, Ze) => {
      let We = ge(), ht = Le[Ze] = We ? Le[Ze - We] : { V: [], M: /* @__PURE__ */ new Map() };
      ht.V.push($e), b.has($e) || w.set($e, ht);
    });
    for (let { V: $e, M: Ze } of new Set(w.values())) {
      let We = [];
      for (let _t of $e) {
        let kt = _.filter((Un) => be(Un, _t)), Rt = We.find(({ G: Un }) => kt.some(($o) => Un.has($o)));
        Rt || (Rt = { G: /* @__PURE__ */ new Set(), V: [] }, We.push(Rt)), Rt.V.push(_t), Te(Rt.G, kt);
      }
      let ht = We.flatMap((_t) => le(_t.G));
      for (let { G: _t, V: kt } of We) {
        let Rt = new Set(ht.filter((Un) => !_t.has(Un)));
        for (let Un of kt)
          Ze.set(Un, Rt);
      }
    }
    $ = /* @__PURE__ */ new Set();
    let rt = /* @__PURE__ */ new Set();
    const gt = ($e) => $.has($e) ? rt.add($e) : $.add($e);
    for (let $e of _) {
      for (let Ze of $e.P) gt(Ze);
      for (let Ze of $e.Q) gt(Ze);
    }
    for (let $e of $)
      !w.has($e) && !rt.has($e) && w.set($e, q);
    Te($, ne($)), Y = k(ge).map(($e) => ve.from($e)).sort(N), ce = /* @__PURE__ */ new Map();
    for (let $e of Y) {
      let Ze = [ce];
      for (let We of $e) {
        let ht = Ze.map((_t) => {
          let kt = _t.get(We);
          return kt || (kt = /* @__PURE__ */ new Map(), _t.set(We, kt)), kt;
        });
        We === z ? Ze.push(...ht) : Ze = ht;
      }
      for (let We of Ze)
        We.V = $e;
    }
  }
  function Ie(ge) {
    return (Zs(ge) ? "" : `${He(xr([ge]))} `) + y(ge);
  }
  function He(ge) {
    return `"${ge}"‎`;
  }
  function Ue(ge) {
    if (ge.length >= 4 && ge[2] == ee && ge[3] == ee)
      throw new Error(`invalid label extension: "${m(ge.slice(0, 4))}"`);
  }
  function je(ge) {
    for (let Pe = ge.lastIndexOf(95); Pe > 0; )
      if (ge[--Pe] !== 95)
        throw new Error("underscore allowed only at start");
  }
  function Je(ge) {
    let we = ge[0], Pe = e.get(we);
    if (Pe) throw In(`leading ${Pe}`);
    let Te = ge.length, ke = -1;
    for (let Ne = 1; Ne < Te; Ne++) {
      we = ge[Ne];
      let Se = e.get(we);
      if (Se) {
        if (ke == Ne) throw In(`${Pe} + ${Se}`);
        ke = Ne + 1, Pe = Se;
      }
    }
    if (ke == Te) throw In(`trailing ${Pe}`);
  }
  function xr(ge, we = 1 / 0, Pe = y) {
    let Te = [];
    ji(ge[0]) && Te.push("◌"), ge.length > we && (we >>= 1, ge = [...ge.slice(0, we), 8230, ...ge.slice(-we)]);
    let ke = 0, Ne = ge.length;
    for (let Se = 0; Se < Ne; Se++) {
      let Le = ge[Se];
      Zs(Le) && (Te.push(m(ge.slice(ke, Se))), Te.push(Pe(Le)), ke = Se + 1);
    }
    return Te.push(m(ge.slice(ke, Ne))), Te.join("");
  }
  function ji(ge) {
    return xe(), ie.has(ge);
  }
  function Zs(ge) {
    return xe(), me.has(ge);
  }
  function Co() {
    return xe(), Y.map((ge) => ge.slice());
  }
  function Ro(ge, we) {
    xe();
    let Pe = we ? ne : oe;
    return ge.split(v).map((Te) => m($i(E(Te), Pe, ns).flat())).join(v);
  }
  function Io(ge) {
    return Hi(Xs(ge, oe, ns));
  }
  function _o(ge) {
    let we = Xs(ge, oe, (Pe) => Pe);
    for (let { type: Pe, output: Te, error: ke } of we) {
      if (ke) break;
      Pe !== "Greek" && Uo(Te, 958, 926);
    }
    return Hi(we);
  }
  function Uo(ge, we, Pe) {
    let Te = 0;
    for (; ; ) {
      let ke = ge.indexOf(we, Te);
      if (ke < 0) break;
      ge[ke] = Pe, Te = ke + 1;
    }
  }
  function Lo(ge, we) {
    return Xs(ge, oe, we ? (Pe) => Pe.slice() : ns);
  }
  function Xs(ge, we, Pe) {
    if (!ge) return [];
    xe();
    let Te = 0;
    return ge.split(v).map((ke) => {
      let Ne = E(ke), Se = {
        input: Ne,
        offset: Te
        // codepoint, not substring!
      };
      Te += Ne.length + 1;
      try {
        let Le = Se.tokens = $i(Ne, we, Pe), rt = Le.length, gt;
        if (!rt)
          throw new Error("empty label");
        let $e = Se.output = Le.flat();
        if (je($e), !(Se.emoji = rt > 1 || Le[0].is_emoji) && $e.every((We) => We < 128))
          Ue($e), gt = "ASCII";
        else {
          let We = Le.flatMap((ht) => ht.is_emoji ? [] : ht);
          if (!We.length)
            gt = "Emoji";
          else {
            if (ie.has($e[0])) throw In("leading combining mark");
            for (let kt = 1; kt < rt; kt++) {
              let Rt = Le[kt];
              if (!Rt.is_emoji && ie.has(Rt[0]))
                throw In(`emoji + combining mark: "${m(Le[kt - 1])} + ${xr([Rt[0]])}"`);
            }
            Je($e);
            let ht = le(new Set(We)), [_t] = Fo(ht);
            Do(_t, We), Mo(_t, ht), gt = _t.N;
          }
        }
        Se.type = gt;
      } catch (Le) {
        Se.error = Le;
      }
      return Se;
    });
  }
  function Mo(ge, we) {
    let Pe, Te = [];
    for (let ke of we) {
      let Ne = w.get(ke);
      if (Ne === q) return;
      if (Ne) {
        let Se = Ne.M.get(ke);
        if (Pe = Pe ? Pe.filter((Le) => Se.has(Le)) : le(Se), !Pe.length) return;
      } else
        Te.push(ke);
    }
    if (Pe) {
      for (let ke of Pe)
        if (Te.every((Ne) => be(ke, Ne)))
          throw new Error(`whole-script confusable: ${ge.N}/${ke.N}`);
    }
  }
  function Fo(ge) {
    let we = _;
    for (let Pe of ge) {
      let Te = we.filter((ke) => be(ke, Pe));
      if (!Te.length)
        throw _.some((ke) => be(ke, Pe)) ? Vi(we[0], Pe) : Gi(Pe);
      if (we = Te, Te.length == 1) break;
    }
    return we;
  }
  function Hi(ge) {
    return ge.map(({ input: we, error: Pe, output: Te }) => {
      if (Pe) {
        let ke = Pe.message;
        throw new Error(ge.length == 1 ? ke : `Invalid label ${He(xr(we, 63))}: ${ke}`);
      }
      return m(Te);
    }).join(v);
  }
  function Gi(ge) {
    return new Error(`disallowed character: ${Ie(ge)}`);
  }
  function Vi(ge, we) {
    let Pe = Ie(we), Te = _.find((ke) => ke.P.has(we));
    return Te && (Pe = `${Te.N} ${Pe}`), new Error(`illegal mixture: ${ge.N} + ${Pe}`);
  }
  function In(ge) {
    return new Error(`illegal placement: ${ge}`);
  }
  function Do(ge, we) {
    for (let Pe of we)
      if (!be(ge, Pe))
        throw Vi(ge, Pe);
    if (ge.M) {
      let Pe = ne(we);
      for (let Te = 1, ke = Pe.length; Te < ke; Te++)
        if (se.has(Pe[Te])) {
          let Ne = Te + 1;
          for (let Se; Ne < ke && se.has(Se = Pe[Ne]); Ne++)
            for (let Le = Te; Le < Ne; Le++)
              if (Pe[Le] == Se)
                throw new Error(`duplicate non-spacing marks: ${Ie(Se)}`);
          if (Ne - Te > t)
            throw new Error(`excessive non-spacing marks: ${He(xr(Pe.slice(Te - 1, Ne)))} (${Ne - Te}/${t})`);
          Te = Ne;
        }
    }
  }
  function $i(ge, we, Pe) {
    let Te = [], ke = [];
    for (ge = ge.slice().reverse(); ge.length; ) {
      let Ne = Ki(ge);
      if (Ne)
        ke.length && (Te.push(we(ke)), ke = []), Te.push(Pe(Ne));
      else {
        let Se = ge.pop();
        if ($.has(Se))
          ke.push(Se);
        else {
          let Le = Be.get(Se);
          if (Le)
            ke.push(...Le);
          else if (!Ae.has(Se))
            throw Gi(Se);
        }
      }
    }
    return ke.length && Te.push(we(ke)), Te;
  }
  function ns(ge) {
    return ge.filter((we) => we != z);
  }
  function Ki(ge, we) {
    let Pe = ce, Te, ke = ge.length;
    for (; ke && (Pe = Pe.get(ge[--ke]), !!Pe); ) {
      let { V: Ne } = Pe;
      Ne && (Te = Ne, we && we.push(...ge.slice(ke).reverse()), ge.length = ke);
    }
    return Te;
  }
  const _n = "valid", zi = "mapped", ei = "ignored", jo = "disallowed", Ho = "emoji", Go = "nfc", Vo = "stop";
  function Ji(ge, {
    nf: we = !0
    // collapse unnormalized runs into a single token
  } = {}) {
    xe();
    let Pe = E(ge).reverse(), Te = [], ke = [];
    for (; Pe.length; ) {
      let Ne = Ki(Pe, Te);
      if (Ne)
        ke.push({
          type: Ho,
          emoji: Ne.slice(),
          // copy emoji
          input: Te,
          cps: ns(Ne)
        }), Te = [];
      else {
        let Se = Pe.pop();
        if (Se == W)
          ke.push({ type: Vo, cp: Se });
        else if ($.has(Se))
          ke.push({ type: _n, cps: [Se] });
        else if (Ae.has(Se))
          ke.push({ type: ei, cp: Se });
        else {
          let Le = Be.get(Se);
          Le ? ke.push({ type: zi, cp: Se, cps: Le.slice() }) : ke.push({ type: jo, cp: Se });
        }
      }
    }
    if (we)
      for (let Ne = 0, Se = -1; Ne < ke.length; Ne++) {
        let Le = ke[Ne];
        if (ti(Le.type))
          if (Qi(Le.cps)) {
            let rt = Ne + 1;
            for (let We = rt; We < ke.length; We++) {
              let { type: ht, cps: _t } = ke[We];
              if (ti(ht)) {
                if (!Qi(_t)) break;
                rt = We + 1;
              } else if (ht !== ei)
                break;
            }
            Se < 0 && (Se = Ne);
            let gt = ke.slice(Se, rt), $e = gt.flatMap((We) => ti(We.type) ? We.cps : []), Ze = oe($e);
            N(Ze, $e) ? (ke.splice(Se, rt - Se, {
              type: Go,
              input: $e,
              // there are 3 states: tokens0 ==(process)=> input ==(nfc)=> tokens/cps
              cps: Ze,
              tokens0: qi(gt),
              tokens: Ji(m(Ze), { nf: !1 })
            }), Ne = Se) : Ne = rt - 1, Se = -1;
          } else
            Se = Ne;
        else Le.type !== ei && (Se = -1);
      }
    return qi(ke);
  }
  function ti(ge) {
    return ge == _n || ge == zi;
  }
  function Qi(ge) {
    return ge.some((we) => fe.has(we));
  }
  function qi(ge) {
    for (let we = 0; we < ge.length; we++)
      if (ge[we].type == _n) {
        let Pe = we + 1;
        for (; Pe < ge.length && ge[Pe].type == _n; ) Pe++;
        ge.splice(we, Pe - we, { type: _n, cps: ge.slice(we, Pe).flatMap((Te) => Te.cps) });
      }
    return ge;
  }
  return Ar.ens_beautify = _o, Ar.ens_emoji = Co, Ar.ens_normalize = Io, Ar.ens_normalize_fragment = Ro, Ar.ens_split = Lo, Ar.ens_tokenize = Ji, Ar.is_combining_mark = ji, Ar.nfc = oe, Ar.nfd = ne, Ar.safe_str_from_cps = xr, Ar.should_escape = Zs, Ar;
}
var hy;
function $v() {
  if (hy) return an;
  hy = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.dnsEncode = an.namehash = an.isValidName = an.ensNormalize = void 0;
  const r = Yt(), e = Me(), t = Vv(), n = new Uint8Array(32);
  n.fill(0);
  function s(l) {
    return (0, e.assertArgument)(l.length !== 0, "invalid ENS name; empty component", "comp", l), l;
  }
  function i(l) {
    const f = (0, e.toUtf8Bytes)(a(l)), d = [];
    if (l.length === 0)
      return d;
    let h = 0;
    for (let p = 0; p < f.length; p++)
      f[p] === 46 && (d.push(s(f.slice(h, p))), h = p + 1);
    return (0, e.assertArgument)(h < f.length, "invalid ENS name; empty component", "name", l), d.push(s(f.slice(h))), d;
  }
  function a(l) {
    try {
      if (l.length === 0)
        throw new Error("empty label");
      return (0, t.ens_normalize)(l);
    } catch (f) {
      (0, e.assertArgument)(!1, `invalid ENS name (${f.message})`, "name", l);
    }
  }
  an.ensNormalize = a;
  function o(l) {
    try {
      return i(l).length !== 0;
    } catch {
    }
    return !1;
  }
  an.isValidName = o;
  function u(l) {
    (0, e.assertArgument)(typeof l == "string", "invalid ENS name; not a string", "name", l), (0, e.assertArgument)(l.length, "invalid ENS name (empty label)", "name", l);
    let f = n;
    const d = i(l);
    for (; d.length; )
      f = (0, r.keccak256)((0, e.concat)([f, (0, r.keccak256)(d.pop())]));
    return (0, e.hexlify)(f);
  }
  an.namehash = u;
  function c(l, f) {
    const d = f ?? 63;
    return (0, e.assertArgument)(d <= 255, "DNS encoded label cannot exceed 255", "length", d), (0, e.hexlify)((0, e.concat)(i(l).map((h) => {
      (0, e.assertArgument)(h.length <= d, `label ${JSON.stringify(l)} exceeds ${d} bytes`, "name", l);
      const p = new Uint8Array(h.length + 1);
      return p.set(h, 1), p[0] = p.length - 1, p;
    }))) + "00";
  }
  return an.dnsEncode = c, an;
}
var ba = {}, Ep = {}, Al = {}, py;
function s6() {
  if (py) return Al;
  py = 1, Object.defineProperty(Al, "__esModule", { value: !0 }), Al.accessListify = void 0;
  const r = zt(), e = Me();
  function t(s, i) {
    return {
      address: (0, r.getAddress)(s),
      storageKeys: i.map((a, o) => ((0, e.assertArgument)((0, e.isHexString)(a, 32), "invalid slot", `storageKeys[${o}]`, a), a.toLowerCase()))
    };
  }
  function n(s) {
    if (Array.isArray(s))
      return s.map((a, o) => Array.isArray(a) ? ((0, e.assertArgument)(a.length === 2, "invalid slot set", `value[${o}]`, a), t(a[0], a[1])) : ((0, e.assertArgument)(a != null && typeof a == "object", "invalid address-slot set", "value", s), t(a.address, a.storageKeys)));
    (0, e.assertArgument)(s != null && typeof s == "object", "invalid access list", "value", s);
    const i = Object.keys(s).map((a) => {
      const o = s[a].reduce((u, c) => (u[c] = !0, u), {});
      return t(a, Object.keys(o).sort());
    });
    return i.sort((a, o) => a.address.localeCompare(o.address)), i;
  }
  return Al.accessListify = n, Al;
}
var ga = {}, by;
function i6() {
  if (by) return ga;
  by = 1, Object.defineProperty(ga, "__esModule", { value: !0 }), ga.recoverAddress = ga.computeAddress = void 0;
  const r = zt(), e = Yt();
  function t(s) {
    let i;
    return typeof s == "string" ? i = e.SigningKey.computePublicKey(s, !1) : i = s.publicKey, (0, r.getAddress)((0, e.keccak256)("0x" + i.substring(4)).substring(26));
  }
  ga.computeAddress = t;
  function n(s, i) {
    return t(e.SigningKey.recoverPublicKey(s, i));
  }
  return ga.recoverAddress = n, ga;
}
var El = {}, gy;
function Kv() {
  var B, C, H, V, J, M, G, K, X, te, pe, he, ye, re, ae, L, ne, ed;
  if (gy) return El;
  gy = 1, Object.defineProperty(El, "__esModule", { value: !0 }), El.Transaction = void 0;
  const r = zt(), e = XA(), t = Yt(), n = Me(), s = s6(), i = i6(), a = BigInt(0), o = BigInt(2), u = BigInt(27), c = BigInt(28), l = BigInt(35), f = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), d = 4096 * 32;
  function h(W, v) {
    let z = W.toString(16);
    for (; z.length < 2; )
      z = "0" + z;
    return z += (0, t.sha256)(v).substring(4), "0x" + z;
  }
  function p(W) {
    return W === "0x" ? null : (0, r.getAddress)(W);
  }
  function g(W, v) {
    try {
      return (0, s.accessListify)(W);
    } catch (z) {
      (0, n.assertArgument)(!1, z.message, v, W);
    }
  }
  function k(W, v) {
    return W === "0x" ? 0 : (0, n.getNumber)(W, v);
  }
  function A(W, v) {
    if (W === "0x")
      return a;
    const z = (0, n.getBigInt)(W, v);
    return (0, n.assertArgument)(z <= f, "value exceeds uint size", v, z), z;
  }
  function y(W, v) {
    const z = (0, n.getBigInt)(W, "value"), q = (0, n.toBeArray)(z);
    return (0, n.assertArgument)(q.length <= 32, "value too large", `tx.${v}`, z), q;
  }
  function E(W) {
    return (0, s.accessListify)(W).map((v) => [v.address, v.storageKeys]);
  }
  function m(W, v) {
    (0, n.assertArgument)(Array.isArray(W), `invalid ${v}`, "value", W);
    for (let z = 0; z < W.length; z++)
      (0, n.assertArgument)((0, n.isHexString)(W[z], 32), "invalid ${ param } hash", `value[${z}]`, W[z]);
    return W;
  }
  function N(W) {
    const v = (0, n.decodeRlp)(W);
    (0, n.assertArgument)(Array.isArray(v) && (v.length === 9 || v.length === 6), "invalid field count for legacy transaction", "data", W);
    const z = {
      type: 0,
      nonce: k(v[0], "nonce"),
      gasPrice: A(v[1], "gasPrice"),
      gasLimit: A(v[2], "gasLimit"),
      to: p(v[3]),
      value: A(v[4], "value"),
      data: (0, n.hexlify)(v[5]),
      chainId: a
    };
    if (v.length === 6)
      return z;
    const q = A(v[6], "v"), le = A(v[7], "r"), be = A(v[8], "s");
    if (le === a && be === a)
      z.chainId = q;
    else {
      let ve = (q - l) / o;
      ve < a && (ve = a), z.chainId = ve, (0, n.assertArgument)(ve !== a || q === u || q === c, "non-canonical legacy v", "v", v[6]), z.signature = t.Signature.from({
        r: (0, n.zeroPadValue)(v[7], 32),
        s: (0, n.zeroPadValue)(v[8], 32),
        v: q
      });
    }
    return z;
  }
  function T(W, v) {
    const z = [
      y(W.nonce, "nonce"),
      y(W.gasPrice || 0, "gasPrice"),
      y(W.gasLimit, "gasLimit"),
      W.to || "0x",
      y(W.value, "value"),
      W.data
    ];
    let q = a;
    if (W.chainId != a)
      q = (0, n.getBigInt)(W.chainId, "tx.chainId"), (0, n.assertArgument)(!v || v.networkV == null || v.legacyChainId === q, "tx.chainId/sig.v mismatch", "sig", v);
    else if (W.signature) {
      const be = W.signature.legacyChainId;
      be != null && (q = be);
    }
    if (!v)
      return q !== a && (z.push((0, n.toBeArray)(q)), z.push("0x"), z.push("0x")), (0, n.encodeRlp)(z);
    let le = BigInt(27 + v.yParity);
    return q !== a ? le = t.Signature.getChainIdV(q, v.v) : BigInt(v.v) !== le && (0, n.assertArgument)(!1, "tx.chainId/sig.v mismatch", "sig", v), z.push((0, n.toBeArray)(le)), z.push((0, n.toBeArray)(v.r)), z.push((0, n.toBeArray)(v.s)), (0, n.encodeRlp)(z);
  }
  function U(W, v) {
    let z;
    try {
      if (z = k(v[0], "yParity"), z !== 0 && z !== 1)
        throw new Error("bad yParity");
    } catch {
      (0, n.assertArgument)(!1, "invalid yParity", "yParity", v[0]);
    }
    const q = (0, n.zeroPadValue)(v[1], 32), le = (0, n.zeroPadValue)(v[2], 32), be = t.Signature.from({ r: q, s: le, yParity: z });
    W.signature = be;
  }
  function R(W) {
    const v = (0, n.decodeRlp)((0, n.getBytes)(W).slice(1));
    (0, n.assertArgument)(Array.isArray(v) && (v.length === 9 || v.length === 12), "invalid field count for transaction type: 2", "data", (0, n.hexlify)(W));
    const z = {
      type: 2,
      chainId: A(v[0], "chainId"),
      nonce: k(v[1], "nonce"),
      maxPriorityFeePerGas: A(v[2], "maxPriorityFeePerGas"),
      maxFeePerGas: A(v[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: A(v[4], "gasLimit"),
      to: p(v[5]),
      value: A(v[6], "value"),
      data: (0, n.hexlify)(v[7]),
      accessList: g(v[8], "accessList")
    };
    return v.length === 9 || U(z, v.slice(9)), z;
  }
  function j(W, v) {
    const z = [
      y(W.chainId, "chainId"),
      y(W.nonce, "nonce"),
      y(W.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      y(W.maxFeePerGas || 0, "maxFeePerGas"),
      y(W.gasLimit, "gasLimit"),
      W.to || "0x",
      y(W.value, "value"),
      W.data,
      E(W.accessList || [])
    ];
    return v && (z.push(y(v.yParity, "yParity")), z.push((0, n.toBeArray)(v.r)), z.push((0, n.toBeArray)(v.s))), (0, n.concat)(["0x02", (0, n.encodeRlp)(z)]);
  }
  function D(W) {
    const v = (0, n.decodeRlp)((0, n.getBytes)(W).slice(1));
    (0, n.assertArgument)(Array.isArray(v) && (v.length === 8 || v.length === 11), "invalid field count for transaction type: 1", "data", (0, n.hexlify)(W));
    const z = {
      type: 1,
      chainId: A(v[0], "chainId"),
      nonce: k(v[1], "nonce"),
      gasPrice: A(v[2], "gasPrice"),
      gasLimit: A(v[3], "gasLimit"),
      to: p(v[4]),
      value: A(v[5], "value"),
      data: (0, n.hexlify)(v[6]),
      accessList: g(v[7], "accessList")
    };
    return v.length === 8 || U(z, v.slice(8)), z;
  }
  function O(W, v) {
    const z = [
      y(W.chainId, "chainId"),
      y(W.nonce, "nonce"),
      y(W.gasPrice || 0, "gasPrice"),
      y(W.gasLimit, "gasLimit"),
      W.to || "0x",
      y(W.value, "value"),
      W.data,
      E(W.accessList || [])
    ];
    return v && (z.push(y(v.yParity, "recoveryParam")), z.push((0, n.toBeArray)(v.r)), z.push((0, n.toBeArray)(v.s))), (0, n.concat)(["0x01", (0, n.encodeRlp)(z)]);
  }
  function I(W) {
    let v = (0, n.decodeRlp)((0, n.getBytes)(W).slice(1)), z = "3", q = null;
    if (v.length === 4 && Array.isArray(v[0])) {
      z = "3 (network format)";
      const be = v[1], ve = v[2], Be = v[3];
      (0, n.assertArgument)(Array.isArray(be), "invalid network format: blobs not an array", "fields[1]", be), (0, n.assertArgument)(Array.isArray(ve), "invalid network format: commitments not an array", "fields[2]", ve), (0, n.assertArgument)(Array.isArray(Be), "invalid network format: proofs not an array", "fields[3]", Be), (0, n.assertArgument)(be.length === ve.length, "invalid network format: blobs/commitments length mismatch", "fields", v), (0, n.assertArgument)(be.length === Be.length, "invalid network format: blobs/proofs length mismatch", "fields", v), q = [];
      for (let Ae = 0; Ae < v[1].length; Ae++)
        q.push({
          data: be[Ae],
          commitment: ve[Ae],
          proof: Be[Ae]
        });
      v = v[0];
    }
    (0, n.assertArgument)(Array.isArray(v) && (v.length === 11 || v.length === 14), `invalid field count for transaction type: ${z}`, "data", (0, n.hexlify)(W));
    const le = {
      type: 3,
      chainId: A(v[0], "chainId"),
      nonce: k(v[1], "nonce"),
      maxPriorityFeePerGas: A(v[2], "maxPriorityFeePerGas"),
      maxFeePerGas: A(v[3], "maxFeePerGas"),
      gasPrice: null,
      gasLimit: A(v[4], "gasLimit"),
      to: p(v[5]),
      value: A(v[6], "value"),
      data: (0, n.hexlify)(v[7]),
      accessList: g(v[8], "accessList"),
      maxFeePerBlobGas: A(v[9], "maxFeePerBlobGas"),
      blobVersionedHashes: v[10]
    };
    q && (le.blobs = q), (0, n.assertArgument)(le.to != null, `invalid address for transaction type: ${z}`, "data", W), (0, n.assertArgument)(Array.isArray(le.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", W);
    for (let be = 0; be < le.blobVersionedHashes.length; be++)
      (0, n.assertArgument)((0, n.isHexString)(le.blobVersionedHashes[be], 32), `invalid blobVersionedHash at index ${be}: must be length 32`, "data", W);
    return v.length === 11 || U(le, v.slice(11)), le;
  }
  function P(W, v, z) {
    const q = [
      y(W.chainId, "chainId"),
      y(W.nonce, "nonce"),
      y(W.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
      y(W.maxFeePerGas || 0, "maxFeePerGas"),
      y(W.gasLimit, "gasLimit"),
      W.to || e.ZeroAddress,
      y(W.value, "value"),
      W.data,
      E(W.accessList || []),
      y(W.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
      m(W.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    return v && (q.push(y(v.yParity, "yParity")), q.push((0, n.toBeArray)(v.r)), q.push((0, n.toBeArray)(v.s)), z) ? (0, n.concat)([
      "0x03",
      (0, n.encodeRlp)([
        q,
        z.map((le) => le.data),
        z.map((le) => le.commitment),
        z.map((le) => le.proof)
      ])
    ]) : (0, n.concat)(["0x03", (0, n.encodeRlp)(q)]);
  }
  const ee = class ee {
    /**
     *  Creates a new Transaction with default values.
     */
    constructor() {
      Z(this, ne);
      Z(this, B);
      Z(this, C);
      Z(this, H);
      Z(this, V);
      Z(this, J);
      Z(this, M);
      Z(this, G);
      Z(this, K);
      Z(this, X);
      Z(this, te);
      Z(this, pe);
      Z(this, he);
      Z(this, ye);
      Z(this, re);
      Z(this, ae);
      Z(this, L);
      F(this, B, null), F(this, C, null), F(this, V, 0), F(this, J, a), F(this, M, null), F(this, G, null), F(this, K, null), F(this, H, "0x"), F(this, X, a), F(this, te, a), F(this, pe, null), F(this, he, null), F(this, ye, null), F(this, re, null), F(this, L, null), F(this, ae, null);
    }
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */
    get type() {
      return x(this, B);
    }
    set type(v) {
      switch (v) {
        case null:
          F(this, B, null);
          break;
        case 0:
        case "legacy":
          F(this, B, 0);
          break;
        case 1:
        case "berlin":
        case "eip-2930":
          F(this, B, 1);
          break;
        case 2:
        case "london":
        case "eip-1559":
          F(this, B, 2);
          break;
        case 3:
        case "cancun":
        case "eip-4844":
          F(this, B, 3);
          break;
        default:
          (0, n.assertArgument)(!1, "unsupported transaction type", "type", v);
      }
    }
    /**
     *  The name of the transaction type.
     */
    get typeName() {
      switch (this.type) {
        case 0:
          return "legacy";
        case 1:
          return "eip-2930";
        case 2:
          return "eip-1559";
        case 3:
          return "eip-4844";
      }
      return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */
    get to() {
      const v = x(this, C);
      return v == null && this.type === 3 ? e.ZeroAddress : v;
    }
    set to(v) {
      F(this, C, v == null ? null : (0, r.getAddress)(v));
    }
    /**
     *  The transaction nonce.
     */
    get nonce() {
      return x(this, V);
    }
    set nonce(v) {
      F(this, V, (0, n.getNumber)(v, "value"));
    }
    /**
     *  The gas limit.
     */
    get gasLimit() {
      return x(this, J);
    }
    set gasLimit(v) {
      F(this, J, (0, n.getBigInt)(v));
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */
    get gasPrice() {
      const v = x(this, M);
      return v == null && (this.type === 0 || this.type === 1) ? a : v;
    }
    set gasPrice(v) {
      F(this, M, v == null ? null : (0, n.getBigInt)(v, "gasPrice"));
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxPriorityFeePerGas() {
      const v = x(this, G);
      return v ?? (this.type === 2 || this.type === 3 ? a : null);
    }
    set maxPriorityFeePerGas(v) {
      F(this, G, v == null ? null : (0, n.getBigInt)(v, "maxPriorityFeePerGas"));
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */
    get maxFeePerGas() {
      const v = x(this, K);
      return v ?? (this.type === 2 || this.type === 3 ? a : null);
    }
    set maxFeePerGas(v) {
      F(this, K, v == null ? null : (0, n.getBigInt)(v, "maxFeePerGas"));
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */
    get data() {
      return x(this, H);
    }
    set data(v) {
      F(this, H, (0, n.hexlify)(v));
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */
    get value() {
      return x(this, X);
    }
    set value(v) {
      F(this, X, (0, n.getBigInt)(v, "value"));
    }
    /**
     *  The chain ID this transaction is valid on.
     */
    get chainId() {
      return x(this, te);
    }
    set chainId(v) {
      F(this, te, (0, n.getBigInt)(v));
    }
    /**
     *  If signed, the signature for this transaction.
     */
    get signature() {
      return x(this, pe) || null;
    }
    set signature(v) {
      F(this, pe, v == null ? null : t.Signature.from(v));
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */
    get accessList() {
      const v = x(this, he) || null;
      return v ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
    }
    set accessList(v) {
      F(this, he, v == null ? null : (0, s.accessListify)(v));
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */
    get maxFeePerBlobGas() {
      const v = x(this, ye);
      return v == null && this.type === 3 ? a : v;
    }
    set maxFeePerBlobGas(v) {
      F(this, ye, v == null ? null : (0, n.getBigInt)(v, "maxFeePerBlobGas"));
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */
    get blobVersionedHashes() {
      let v = x(this, re);
      return v == null && this.type === 3 ? [] : v;
    }
    set blobVersionedHashes(v) {
      if (v != null) {
        (0, n.assertArgument)(Array.isArray(v), "blobVersionedHashes must be an Array", "value", v), v = v.slice();
        for (let z = 0; z < v.length; z++)
          (0, n.assertArgument)((0, n.isHexString)(v[z], 32), "invalid blobVersionedHash", `value[${z}]`, v[z]);
      }
      F(this, re, v);
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */
    get blobs() {
      return x(this, L) == null ? null : x(this, L).map((v) => Object.assign({}, v));
    }
    set blobs(v) {
      if (v == null) {
        F(this, L, null);
        return;
      }
      const z = [], q = [];
      for (let le = 0; le < v.length; le++) {
        const be = v[le];
        if ((0, n.isBytesLike)(be)) {
          (0, n.assert)(x(this, ae), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
            operation: "set blobs()"
          });
          let ve = (0, n.getBytes)(be);
          if ((0, n.assertArgument)(ve.length <= d, "blob is too large", `blobs[${le}]`, be), ve.length !== d) {
            const ie = new Uint8Array(d);
            ie.set(ve), ve = ie;
          }
          const Be = x(this, ae).blobToKzgCommitment(ve), Ae = (0, n.hexlify)(x(this, ae).computeBlobKzgProof(ve, Be));
          z.push({
            data: (0, n.hexlify)(ve),
            commitment: (0, n.hexlify)(Be),
            proof: Ae
          }), q.push(h(1, Be));
        } else {
          const ve = (0, n.hexlify)(be.commitment);
          z.push({
            data: (0, n.hexlify)(be.data),
            commitment: ve,
            proof: (0, n.hexlify)(be.proof)
          }), q.push(h(1, ve));
        }
      }
      F(this, L, z), F(this, re, q);
    }
    get kzg() {
      return x(this, ae);
    }
    set kzg(v) {
      F(this, ae, v);
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */
    get hash() {
      return this.signature == null ? null : (0, t.keccak256)(de(this, ne, ed).call(this, !0, !1));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */
    get unsignedHash() {
      return (0, t.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */
    get from() {
      return this.signature == null ? null : (0, i.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */
    get fromPublicKey() {
      return this.signature == null ? null : t.SigningKey.recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */
    isSigned() {
      return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */
    get serialized() {
      return de(this, ne, ed).call(this, !0, !0);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */
    get unsignedSerialized() {
      return de(this, ne, ed).call(this, !1, !1);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */
    inferType() {
      const v = this.inferTypes();
      return v.indexOf(2) >= 0 ? 2 : v.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */
    inferTypes() {
      const v = this.gasPrice != null, z = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, q = this.accessList != null, le = x(this, ye) != null || x(this, re);
      this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && (0, n.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), (0, n.assert)(!z || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), (0, n.assert)(this.type !== 0 || !q, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
      const be = [];
      return this.type != null ? be.push(this.type) : z ? be.push(2) : v ? (be.push(1), q || be.push(0)) : q ? (be.push(1), be.push(2)) : (le && this.to || (be.push(0), be.push(1), be.push(2)), be.push(3)), be.sort(), be;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */
    clone() {
      return ee.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */
    toJSON() {
      const v = (z) => z == null ? null : z.toString();
      return {
        type: this.type,
        to: this.to,
        //            from: this.from,
        data: this.data,
        nonce: this.nonce,
        gasLimit: v(this.gasLimit),
        gasPrice: v(this.gasPrice),
        maxPriorityFeePerGas: v(this.maxPriorityFeePerGas),
        maxFeePerGas: v(this.maxFeePerGas),
        value: v(this.value),
        chainId: v(this.chainId),
        sig: this.signature ? this.signature.toJSON() : null,
        accessList: this.accessList
      };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */
    static from(v) {
      if (v == null)
        return new ee();
      if (typeof v == "string") {
        const q = (0, n.getBytes)(v);
        if (q[0] >= 127)
          return ee.from(N(q));
        switch (q[0]) {
          case 1:
            return ee.from(D(q));
          case 2:
            return ee.from(R(q));
          case 3:
            return ee.from(I(q));
        }
        (0, n.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
      }
      const z = new ee();
      return v.type != null && (z.type = v.type), v.to != null && (z.to = v.to), v.nonce != null && (z.nonce = v.nonce), v.gasLimit != null && (z.gasLimit = v.gasLimit), v.gasPrice != null && (z.gasPrice = v.gasPrice), v.maxPriorityFeePerGas != null && (z.maxPriorityFeePerGas = v.maxPriorityFeePerGas), v.maxFeePerGas != null && (z.maxFeePerGas = v.maxFeePerGas), v.maxFeePerBlobGas != null && (z.maxFeePerBlobGas = v.maxFeePerBlobGas), v.data != null && (z.data = v.data), v.value != null && (z.value = v.value), v.chainId != null && (z.chainId = v.chainId), v.signature != null && (z.signature = t.Signature.from(v.signature)), v.accessList != null && (z.accessList = v.accessList), v.blobVersionedHashes != null && (z.blobVersionedHashes = v.blobVersionedHashes), v.kzg != null && (z.kzg = v.kzg), v.blobs != null && (z.blobs = v.blobs), v.hash != null && ((0, n.assertArgument)(z.isSigned(), "unsigned transaction cannot define '.hash'", "tx", v), (0, n.assertArgument)(z.hash === v.hash, "hash mismatch", "tx", v)), v.from != null && ((0, n.assertArgument)(z.isSigned(), "unsigned transaction cannot define '.from'", "tx", v), (0, n.assertArgument)(z.from.toLowerCase() === (v.from || "").toLowerCase(), "from mismatch", "tx", v)), z;
    }
  };
  B = new WeakMap(), C = new WeakMap(), H = new WeakMap(), V = new WeakMap(), J = new WeakMap(), M = new WeakMap(), G = new WeakMap(), K = new WeakMap(), X = new WeakMap(), te = new WeakMap(), pe = new WeakMap(), he = new WeakMap(), ye = new WeakMap(), re = new WeakMap(), ae = new WeakMap(), L = new WeakMap(), ne = new WeakSet(), ed = function(v, z) {
    (0, n.assert)(!v || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
    const q = v ? this.signature : null;
    switch (this.inferType()) {
      case 0:
        return T(this, q);
      case 1:
        return O(this, q);
      case 2:
        return j(this, q);
      case 3:
        return P(this, q, z ? this.blobs : null);
    }
    (0, n.assert)(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  };
  let S = ee;
  return El.Transaction = S, El;
}
var xy;
function Lr() {
  return xy || (xy = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Transaction = r.recoverAddress = r.computeAddress = r.accessListify = void 0;
    var e = s6();
    Object.defineProperty(r, "accessListify", { enumerable: !0, get: function() {
      return e.accessListify;
    } });
    var t = i6();
    Object.defineProperty(r, "computeAddress", { enumerable: !0, get: function() {
      return t.computeAddress;
    } }), Object.defineProperty(r, "recoverAddress", { enumerable: !0, get: function() {
      return t.recoverAddress;
    } });
    var n = Kv();
    Object.defineProperty(r, "Transaction", { enumerable: !0, get: function() {
      return n.Transaction;
    } });
  }(Ep)), Ep;
}
var my;
function zv() {
  if (my) return ba;
  my = 1, Object.defineProperty(ba, "__esModule", { value: !0 }), ba.verifyMessage = ba.hashMessage = void 0;
  const r = Yt(), e = ff(), t = Lr(), n = Me();
  function s(a) {
    return typeof a == "string" && (a = (0, n.toUtf8Bytes)(a)), (0, r.keccak256)((0, n.concat)([
      (0, n.toUtf8Bytes)(e.MessagePrefix),
      (0, n.toUtf8Bytes)(String(a.length)),
      a
    ]));
  }
  ba.hashMessage = s;
  function i(a, o) {
    const u = s(a);
    return (0, t.recoverAddress)(u, o);
  }
  return ba.verifyMessage = i, ba;
}
var os = {}, yy;
function Jv() {
  if (yy) return os;
  yy = 1, Object.defineProperty(os, "__esModule", { value: !0 }), os.solidityPackedSha256 = os.solidityPackedKeccak256 = os.solidityPacked = void 0;
  const r = zt(), e = Yt(), t = Me(), n = new RegExp("^bytes([0-9]+)$"), s = new RegExp("^(u?int)([0-9]*)$"), i = new RegExp("^(.*)\\[([0-9]*)\\]$");
  function a(l, f, d) {
    switch (l) {
      case "address":
        return d ? (0, t.getBytes)((0, t.zeroPadValue)(f, 32)) : (0, t.getBytes)((0, r.getAddress)(f));
      case "string":
        return (0, t.toUtf8Bytes)(f);
      case "bytes":
        return (0, t.getBytes)(f);
      case "bool":
        return f = f ? "0x01" : "0x00", d ? (0, t.getBytes)((0, t.zeroPadValue)(f, 32)) : (0, t.getBytes)(f);
    }
    let h = l.match(s);
    if (h) {
      let p = h[1] === "int", g = parseInt(h[2] || "256");
      return (0, t.assertArgument)((!h[2] || h[2] === String(g)) && g % 8 === 0 && g !== 0 && g <= 256, "invalid number type", "type", l), d && (g = 256), p && (f = (0, t.toTwos)(f, g)), (0, t.getBytes)((0, t.zeroPadValue)((0, t.toBeArray)(f), g / 8));
    }
    if (h = l.match(n), h) {
      const p = parseInt(h[1]);
      return (0, t.assertArgument)(String(p) === h[1] && p !== 0 && p <= 32, "invalid bytes type", "type", l), (0, t.assertArgument)((0, t.dataLength)(f) === p, `invalid value for ${l}`, "value", f), d ? (0, t.getBytes)((0, t.zeroPadBytes)(f, 32)) : f;
    }
    if (h = l.match(i), h && Array.isArray(f)) {
      const p = h[1], g = parseInt(h[2] || String(f.length));
      (0, t.assertArgument)(g === f.length, `invalid array length for ${l}`, "value", f);
      const k = [];
      return f.forEach(function(A) {
        k.push(a(p, A, !0));
      }), (0, t.getBytes)((0, t.concat)(k));
    }
    (0, t.assertArgument)(!1, "invalid type", "type", l);
  }
  function o(l, f) {
    (0, t.assertArgument)(l.length === f.length, "wrong number of values; expected ${ types.length }", "values", f);
    const d = [];
    return l.forEach(function(h, p) {
      d.push(a(h, f[p]));
    }), (0, t.hexlify)((0, t.concat)(d));
  }
  os.solidityPacked = o;
  function u(l, f) {
    return (0, e.keccak256)(o(l, f));
  }
  os.solidityPackedKeccak256 = u;
  function c(l, f) {
    return (0, e.sha256)(o(l, f));
  }
  return os.solidityPackedSha256 = c, os;
}
var xa = {}, wy;
function Qv() {
  var T, U, R, j, a6;
  if (wy) return xa;
  wy = 1, Object.defineProperty(xa, "__esModule", { value: !0 }), xa.verifyTypedData = xa.TypedDataEncoder = void 0;
  const r = zt(), e = Yt(), t = Lr(), n = Me(), s = n6(), i = new Uint8Array(32);
  i.fill(0);
  const a = BigInt(-1), o = BigInt(0), u = BigInt(1), c = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  function l(I) {
    const P = (0, n.getBytes)(I), S = P.length % 32;
    return S ? (0, n.concat)([P, i.slice(S)]) : (0, n.hexlify)(P);
  }
  const f = (0, n.toBeHex)(u, 32), d = (0, n.toBeHex)(o, 32), h = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
  }, p = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
  ];
  function g(I) {
    return function(P) {
      return (0, n.assertArgument)(typeof P == "string", `invalid domain value for ${JSON.stringify(I)}`, `domain.${I}`, P), P;
    };
  }
  const k = {
    name: g("name"),
    version: g("version"),
    chainId: function(I) {
      const P = (0, n.getBigInt)(I, "domain.chainId");
      return (0, n.assertArgument)(P >= 0, "invalid chain ID", "domain.chainId", I), Number.isSafeInteger(P) ? Number(P) : (0, n.toQuantity)(P);
    },
    verifyingContract: function(I) {
      try {
        return (0, r.getAddress)(I).toLowerCase();
      } catch {
      }
      (0, n.assertArgument)(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", I);
    },
    salt: function(I) {
      const P = (0, n.getBytes)(I, "domain.salt");
      return (0, n.assertArgument)(P.length === 32, 'invalid domain value "salt"', "domain.salt", I), (0, n.hexlify)(P);
    }
  };
  function A(I) {
    {
      const P = I.match(/^(u?)int(\d+)$/);
      if (P) {
        const S = P[1] === "", B = parseInt(P[2]);
        (0, n.assertArgument)(B % 8 === 0 && B !== 0 && B <= 256 && P[2] === String(B), "invalid numeric width", "type", I);
        const C = (0, n.mask)(c, S ? B - 1 : B), H = S ? (C + u) * a : o;
        return function(V) {
          const J = (0, n.getBigInt)(V, "value");
          return (0, n.assertArgument)(J >= H && J <= C, `value out-of-bounds for ${I}`, "value", J), (0, n.toBeHex)(S ? (0, n.toTwos)(J, 256) : J, 32);
        };
      }
    }
    {
      const P = I.match(/^bytes(\d+)$/);
      if (P) {
        const S = parseInt(P[1]);
        return (0, n.assertArgument)(S !== 0 && S <= 32 && P[1] === String(S), "invalid bytes width", "type", I), function(B) {
          const C = (0, n.getBytes)(B);
          return (0, n.assertArgument)(C.length === S, `invalid length for ${I}`, "value", B), l(B);
        };
      }
    }
    switch (I) {
      case "address":
        return function(P) {
          return (0, n.zeroPadValue)((0, r.getAddress)(P), 32);
        };
      case "bool":
        return function(P) {
          return P ? f : d;
        };
      case "bytes":
        return function(P) {
          return (0, e.keccak256)(P);
        };
      case "string":
        return function(P) {
          return (0, s.id)(P);
        };
    }
    return null;
  }
  function y(I, P) {
    return `${I}(${P.map(({ name: S, type: B }) => B + " " + S).join(",")})`;
  }
  function E(I) {
    const P = I.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    return P ? {
      base: P[1],
      index: P[2] + P[4],
      array: {
        base: P[1],
        prefix: P[1] + P[2],
        count: P[5] ? parseInt(P[5]) : -1
      }
    } : { base: I };
  }
  const O = class O {
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */
    constructor(P) {
      Z(this, j);
      /**
       *  The primary type for the structured [[types]].
       *
       *  This is derived automatically from the [[types]], since no
       *  recursion is possible, once the DAG for the types is consturcted
       *  internally, the primary type must be the only remaining type with
       *  no parent nodes.
       */
      Q(this, "primaryType");
      Z(this, T);
      Z(this, U);
      Z(this, R);
      F(this, U, /* @__PURE__ */ new Map()), F(this, R, /* @__PURE__ */ new Map());
      const S = /* @__PURE__ */ new Map(), B = /* @__PURE__ */ new Map(), C = /* @__PURE__ */ new Map(), H = {};
      Object.keys(P).forEach((M) => {
        H[M] = P[M].map(({ name: G, type: K }) => {
          let { base: X, index: te } = E(K);
          return X === "int" && !P.int && (X = "int256"), X === "uint" && !P.uint && (X = "uint256"), { name: G, type: X + (te || "") };
        }), S.set(M, /* @__PURE__ */ new Set()), B.set(M, []), C.set(M, /* @__PURE__ */ new Set());
      }), F(this, T, JSON.stringify(H));
      for (const M in H) {
        const G = /* @__PURE__ */ new Set();
        for (const K of H[M]) {
          (0, n.assertArgument)(!G.has(K.name), `duplicate variable name ${JSON.stringify(K.name)} in ${JSON.stringify(M)}`, "types", P), G.add(K.name);
          const X = E(K.type).base;
          (0, n.assertArgument)(X !== M, `circular type reference to ${JSON.stringify(X)}`, "types", P), !A(X) && ((0, n.assertArgument)(B.has(X), `unknown type ${JSON.stringify(X)}`, "types", P), B.get(X).push(M), S.get(M).add(X));
        }
      }
      const V = Array.from(B.keys()).filter((M) => B.get(M).length === 0);
      (0, n.assertArgument)(V.length !== 0, "missing primary type", "types", P), (0, n.assertArgument)(V.length === 1, `ambiguous primary types or unused types: ${V.map((M) => JSON.stringify(M)).join(", ")}`, "types", P), (0, n.defineProperties)(this, { primaryType: V[0] });
      function J(M, G) {
        (0, n.assertArgument)(!G.has(M), `circular type reference to ${JSON.stringify(M)}`, "types", P), G.add(M);
        for (const K of S.get(M))
          if (B.has(K)) {
            J(K, G);
            for (const X of G)
              C.get(X).add(K);
          }
        G.delete(M);
      }
      J(this.primaryType, /* @__PURE__ */ new Set());
      for (const [M, G] of C) {
        const K = Array.from(G);
        K.sort(), x(this, U).set(M, y(M, H[M]) + K.map((X) => y(X, H[X])).join(""));
      }
    }
    /**
     *  The types.
     */
    get types() {
      return JSON.parse(x(this, T));
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */
    getEncoder(P) {
      let S = x(this, R).get(P);
      return S || (S = de(this, j, a6).call(this, P), x(this, R).set(P, S)), S;
    }
    /**
     *  Return the full type for %%name%%.
     */
    encodeType(P) {
      const S = x(this, U).get(P);
      return (0, n.assertArgument)(S, `unknown type: ${JSON.stringify(P)}`, "name", P), S;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */
    encodeData(P, S) {
      return this.getEncoder(P)(S);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */
    hashStruct(P, S) {
      return (0, e.keccak256)(this.encodeData(P, S));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */
    encode(P) {
      return this.encodeData(this.primaryType, P);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */
    hash(P) {
      return this.hashStruct(this.primaryType, P);
    }
    /**
     *  @_ignore:
     */
    _visit(P, S, B) {
      if (A(P))
        return B(P, S);
      const C = E(P).array;
      if (C)
        return (0, n.assertArgument)(C.count === -1 || C.count === S.length, `array length mismatch; expected length ${C.count}`, "value", S), S.map((V) => this._visit(C.prefix, V, B));
      const H = this.types[P];
      if (H)
        return H.reduce((V, { name: J, type: M }) => (V[J] = this._visit(M, S[J], B), V), {});
      (0, n.assertArgument)(!1, `unknown type: ${P}`, "type", P);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */
    visit(P, S) {
      return this._visit(this.primaryType, P, S);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */
    static from(P) {
      return new O(P);
    }
    /**
     *  Return the primary type for %%types%%.
     */
    static getPrimaryType(P) {
      return O.from(P).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */
    static hashStruct(P, S, B) {
      return O.from(S).hashStruct(P, B);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */
    static hashDomain(P) {
      const S = [];
      for (const B in P) {
        if (P[B] == null)
          continue;
        const C = h[B];
        (0, n.assertArgument)(C, `invalid typed-data domain key: ${JSON.stringify(B)}`, "domain", P), S.push({ name: B, type: C });
      }
      return S.sort((B, C) => p.indexOf(B.name) - p.indexOf(C.name)), O.hashStruct("EIP712Domain", { EIP712Domain: S }, P);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static encode(P, S, B) {
      return (0, n.concat)([
        "0x1901",
        O.hashDomain(P),
        O.from(S).hash(B)
      ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
    static hash(P, S, B) {
      return (0, e.keccak256)(O.encode(P, S, B));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */
    static async resolveNames(P, S, B, C) {
      P = Object.assign({}, P);
      for (const J in P)
        P[J] == null && delete P[J];
      const H = {};
      P.verifyingContract && !(0, n.isHexString)(P.verifyingContract, 20) && (H[P.verifyingContract] = "0x");
      const V = O.from(S);
      V.visit(B, (J, M) => (J === "address" && !(0, n.isHexString)(M, 20) && (H[M] = "0x"), M));
      for (const J in H)
        H[J] = await C(J);
      return P.verifyingContract && H[P.verifyingContract] && (P.verifyingContract = H[P.verifyingContract]), B = V.visit(B, (J, M) => J === "address" && H[M] ? H[M] : M), { domain: P, value: B };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */
    static getPayload(P, S, B) {
      O.hashDomain(P);
      const C = {}, H = [];
      p.forEach((M) => {
        const G = P[M];
        G != null && (C[M] = k[M](G), H.push({ name: M, type: h[M] }));
      });
      const V = O.from(S);
      S = V.types;
      const J = Object.assign({}, S);
      return (0, n.assertArgument)(J.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", S), J.EIP712Domain = H, V.encode(B), {
        types: J,
        domain: C,
        primaryType: V.primaryType,
        message: V.visit(B, (M, G) => {
          if (M.match(/^bytes(\d*)/))
            return (0, n.hexlify)((0, n.getBytes)(G));
          if (M.match(/^u?int/))
            return (0, n.getBigInt)(G).toString();
          switch (M) {
            case "address":
              return G.toLowerCase();
            case "bool":
              return !!G;
            case "string":
              return (0, n.assertArgument)(typeof G == "string", "invalid string", "value", G), G;
          }
          (0, n.assertArgument)(!1, "unsupported type", "type", M);
        })
      };
    }
  };
  T = new WeakMap(), U = new WeakMap(), R = new WeakMap(), j = new WeakSet(), a6 = function(P) {
    {
      const C = A(P);
      if (C)
        return C;
    }
    const S = E(P).array;
    if (S) {
      const C = S.prefix, H = this.getEncoder(C);
      return (V) => {
        (0, n.assertArgument)(S.count === -1 || S.count === V.length, `array length mismatch; expected length ${S.count}`, "value", V);
        let J = V.map(H);
        return x(this, U).has(C) && (J = J.map(e.keccak256)), (0, e.keccak256)((0, n.concat)(J));
      };
    }
    const B = this.types[P];
    if (B) {
      const C = (0, s.id)(x(this, U).get(P));
      return (H) => {
        const V = B.map(({ name: J, type: M }) => {
          const G = this.getEncoder(M)(H[J]);
          return x(this, U).has(M) ? (0, e.keccak256)(G) : G;
        });
        return V.unshift(C), (0, n.concat)(V);
      };
    }
    (0, n.assertArgument)(!1, `unknown type: ${P}`, "type", P);
  };
  let m = O;
  xa.TypedDataEncoder = m;
  function N(I, P, S, B) {
    return (0, t.recoverAddress)(m.hash(I, P, S), B);
  }
  return xa.verifyTypedData = N, xa;
}
var Ay;
function Ys() {
  return Ay || (Ay = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.verifyTypedData = r.TypedDataEncoder = r.solidityPackedSha256 = r.solidityPackedKeccak256 = r.solidityPacked = r.verifyMessage = r.hashMessage = r.dnsEncode = r.namehash = r.isValidName = r.ensNormalize = r.id = void 0;
    var e = n6();
    Object.defineProperty(r, "id", { enumerable: !0, get: function() {
      return e.id;
    } });
    var t = $v();
    Object.defineProperty(r, "ensNormalize", { enumerable: !0, get: function() {
      return t.ensNormalize;
    } }), Object.defineProperty(r, "isValidName", { enumerable: !0, get: function() {
      return t.isValidName;
    } }), Object.defineProperty(r, "namehash", { enumerable: !0, get: function() {
      return t.namehash;
    } }), Object.defineProperty(r, "dnsEncode", { enumerable: !0, get: function() {
      return t.dnsEncode;
    } });
    var n = zv();
    Object.defineProperty(r, "hashMessage", { enumerable: !0, get: function() {
      return n.hashMessage;
    } }), Object.defineProperty(r, "verifyMessage", { enumerable: !0, get: function() {
      return n.verifyMessage;
    } });
    var s = Jv();
    Object.defineProperty(r, "solidityPacked", { enumerable: !0, get: function() {
      return s.solidityPacked;
    } }), Object.defineProperty(r, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return s.solidityPackedKeccak256;
    } }), Object.defineProperty(r, "solidityPackedSha256", { enumerable: !0, get: function() {
      return s.solidityPackedSha256;
    } });
    var i = Qv();
    Object.defineProperty(r, "TypedDataEncoder", { enumerable: !0, get: function() {
      return i.TypedDataEncoder;
    } }), Object.defineProperty(r, "verifyTypedData", { enumerable: !0, get: function() {
      return i.verifyTypedData;
    } });
  }(Ap)), Ap;
}
var Ey;
function lx() {
  var W, v, z, Ob, be, td;
  if (Ey) return Tt;
  Ey = 1, Object.defineProperty(Tt, "__esModule", { value: !0 }), Tt.StructFragment = Tt.FunctionFragment = Tt.FallbackFragment = Tt.ConstructorFragment = Tt.EventFragment = Tt.ErrorFragment = Tt.NamedFragment = Tt.Fragment = Tt.ParamType = void 0;
  const r = Me(), e = Ys();
  function t(Ae) {
    const ie = /* @__PURE__ */ new Set();
    return Ae.forEach((se) => ie.add(se)), Object.freeze(ie);
  }
  const s = t("external public payable override".split(" ")), i = "constant external internal payable private public pure view override", a = t(i.split(" ")), o = "constructor error event fallback function receive struct", u = t(o.split(" ")), c = "calldata memory storage payable indexed", l = t(c.split(" ")), d = [o, c, "tuple returns", i].join(" "), h = t(d.split(" ")), p = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
  }, g = new RegExp("^(\\s*)"), k = new RegExp("^([0-9]+)"), A = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), y = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), E = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$"), le = class le {
    constructor(ie) {
      Z(this, z);
      Z(this, W);
      Z(this, v);
      F(this, W, 0), F(this, v, ie.slice());
    }
    get offset() {
      return x(this, W);
    }
    get length() {
      return x(this, v).length - x(this, W);
    }
    clone() {
      return new le(x(this, v));
    }
    reset() {
      F(this, W, 0);
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(ie) {
      const se = this.peek();
      if (se.type !== "KEYWORD" || !ie.has(se.text))
        throw new Error(`expected keyword ${se.text}`);
      return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(ie) {
      if (this.peek().type !== ie) {
        const se = this.peek();
        throw new Error(`expected ${ie}; got ${se.type} ${JSON.stringify(se.text)}`);
      }
      return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
      const ie = this.peek();
      if (ie.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const se = de(this, z, Ob).call(this, x(this, W) + 1, ie.match + 1);
      return F(this, W, ie.match + 1), se;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
      const ie = this.peek();
      if (ie.type !== "OPEN_PAREN")
        throw new Error("bad start");
      const se = [];
      for (; x(this, W) < ie.match - 1; ) {
        const me = this.peek().linkNext;
        se.push(de(this, z, Ob).call(this, x(this, W) + 1, me)), F(this, W, me);
      }
      return F(this, W, ie.match + 1), se;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
      if (x(this, W) >= x(this, v).length)
        throw new Error("out-of-bounds");
      return x(this, v)[x(this, W)];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(ie) {
      const se = this.peekType("KEYWORD");
      return se != null && ie.has(se) ? se : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(ie) {
      if (this.length === 0)
        return null;
      const se = this.peek();
      return se.type === ie ? se.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
      const ie = this.peek();
      return rn(this, W)._++, ie;
    }
    toString() {
      const ie = [];
      for (let se = x(this, W); se < x(this, v).length; se++) {
        const me = x(this, v)[se];
        ie.push(`${me.type}:${me.text}`);
      }
      return `<TokenString ${ie.join(" ")}>`;
    }
  };
  W = new WeakMap(), v = new WeakMap(), z = new WeakSet(), Ob = function(ie = 0, se = 0) {
    return new le(x(this, v).slice(ie, se).map((me) => Object.freeze(Object.assign({}, me, {
      match: me.match - ie,
      linkBack: me.linkBack - ie,
      linkNext: me.linkNext - ie
    }))));
  };
  let m = le;
  function N(Ae) {
    const ie = [], se = (b) => {
      const w = _ < Ae.length ? JSON.stringify(Ae[_]) : "$EOI";
      throw new Error(`invalid token ${w} at ${_}: ${b}`);
    };
    let me = [], fe = [], _ = 0;
    for (; _ < Ae.length; ) {
      let b = Ae.substring(_), w = b.match(g);
      w && (_ += w[1].length, b = Ae.substring(_));
      const $ = { depth: me.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: _, value: -1 };
      ie.push($);
      let Y = p[b[0]] || "";
      if (Y) {
        if ($.type = Y, $.text = b[0], _++, Y === "OPEN_PAREN")
          me.push(ie.length - 1), fe.push(ie.length - 1);
        else if (Y == "CLOSE_PAREN")
          me.length === 0 && se("no matching open bracket"), $.match = me.pop(), ie[$.match].match = ie.length - 1, $.depth--, $.linkBack = fe.pop(), ie[$.linkBack].linkNext = ie.length - 1;
        else if (Y === "COMMA")
          $.linkBack = fe.pop(), ie[$.linkBack].linkNext = ie.length - 1, fe.push(ie.length - 1);
        else if (Y === "OPEN_BRACKET")
          $.type = "BRACKET";
        else if (Y === "CLOSE_BRACKET") {
          let ce = ie.pop().text;
          if (ie.length > 0 && ie[ie.length - 1].type === "NUMBER") {
            const xe = ie.pop().text;
            ce = xe + ce, ie[ie.length - 1].value = (0, r.getNumber)(xe);
          }
          if (ie.length === 0 || ie[ie.length - 1].type !== "BRACKET")
            throw new Error("missing opening bracket");
          ie[ie.length - 1].text += ce;
        }
        continue;
      }
      if (w = b.match(A), w) {
        if ($.text = w[1], _ += $.text.length, h.has($.text)) {
          $.type = "KEYWORD";
          continue;
        }
        if ($.text.match(E)) {
          $.type = "TYPE";
          continue;
        }
        $.type = "ID";
        continue;
      }
      if (w = b.match(k), w) {
        $.text = w[1], $.type = "NUMBER", _ += $.text.length;
        continue;
      }
      throw new Error(`unexpected token ${JSON.stringify(b[0])} at position ${_}`);
    }
    return new m(ie.map((b) => Object.freeze(b)));
  }
  function T(Ae, ie) {
    let se = [];
    for (const me in ie.keys())
      Ae.has(me) && se.push(me);
    if (se.length > 1)
      throw new Error(`conflicting types: ${se.join(", ")}`);
  }
  function U(Ae, ie) {
    if (ie.peekKeyword(u)) {
      const se = ie.pop().text;
      if (se !== Ae)
        throw new Error(`expected ${Ae}, got ${se}`);
    }
    return ie.popType("ID");
  }
  function R(Ae, ie) {
    const se = /* @__PURE__ */ new Set();
    for (; ; ) {
      const me = Ae.peekType("KEYWORD");
      if (me == null || ie && !ie.has(me))
        break;
      if (Ae.pop(), se.has(me))
        throw new Error(`duplicate keywords: ${JSON.stringify(me)}`);
      se.add(me);
    }
    return Object.freeze(se);
  }
  function j(Ae) {
    let ie = R(Ae, a);
    return T(ie, t("constant payable nonpayable".split(" "))), T(ie, t("pure view payable nonpayable".split(" "))), ie.has("view") ? "view" : ie.has("pure") ? "pure" : ie.has("payable") ? "payable" : ie.has("nonpayable") ? "nonpayable" : ie.has("constant") ? "view" : "nonpayable";
  }
  function D(Ae, ie) {
    return Ae.popParams().map((se) => te.from(se, ie));
  }
  function O(Ae) {
    if (Ae.peekType("AT")) {
      if (Ae.pop(), Ae.peekType("NUMBER"))
        return (0, r.getBigInt)(Ae.pop().text);
      throw new Error("invalid gas");
    }
    return null;
  }
  function I(Ae) {
    if (Ae.length)
      throw new Error(`unexpected tokens at offset ${Ae.offset}: ${Ae.toString()}`);
  }
  const P = new RegExp(/^(.*)\[([0-9]*)\]$/);
  function S(Ae) {
    const ie = Ae.match(E);
    if ((0, r.assertArgument)(ie, "invalid type", "type", Ae), Ae === "uint")
      return "uint256";
    if (Ae === "int")
      return "int256";
    if (ie[2]) {
      const se = parseInt(ie[2]);
      (0, r.assertArgument)(se !== 0 && se <= 32, "invalid bytes length", "type", Ae);
    } else if (ie[3]) {
      const se = parseInt(ie[3]);
      (0, r.assertArgument)(se !== 0 && se <= 256 && se % 8 === 0, "invalid numeric width", "type", Ae);
    }
    return Ae;
  }
  const B = {}, C = Symbol.for("_ethers_internal"), H = "_ParamTypeInternal", V = "_ErrorInternal", J = "_EventInternal", M = "_ConstructorInternal", G = "_FallbackInternal", K = "_FunctionInternal", X = "_StructInternal", Be = class Be {
    /**
     *  @private
     */
    constructor(ie, se, me, fe, _, b, w, $) {
      Z(this, be);
      /**
       *  The local name of the parameter (or ``""`` if unbound)
       */
      Q(this, "name");
      /**
       *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
       *  ``"uint256[3][]"``)
       */
      Q(this, "type");
      /**
       *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
       */
      Q(this, "baseType");
      /**
       *  True if the parameters is indexed.
       *
       *  For non-indexable types this is ``null``.
       */
      Q(this, "indexed");
      /**
       *  The components for the tuple.
       *
       *  For non-tuple types this is ``null``.
       */
      Q(this, "components");
      /**
       *  The array length, or ``-1`` for dynamic-lengthed arrays.
       *
       *  For non-array types this is ``null``.
       */
      Q(this, "arrayLength");
      /**
       *  The type of each child in the array.
       *
       *  For non-array types this is ``null``.
       */
      Q(this, "arrayChildren");
      if ((0, r.assertPrivate)(ie, B, "ParamType"), Object.defineProperty(this, C, { value: H }), b && (b = Object.freeze(b.slice())), fe === "array") {
        if (w == null || $ == null)
          throw new Error("");
      } else if (w != null || $ != null)
        throw new Error("");
      if (fe === "tuple") {
        if (b == null)
          throw new Error("");
      } else if (b != null)
        throw new Error("");
      (0, r.defineProperties)(this, {
        name: se,
        type: me,
        baseType: fe,
        indexed: _,
        components: b,
        arrayLength: w,
        arrayChildren: $
      });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */
    format(ie) {
      if (ie == null && (ie = "sighash"), ie === "json") {
        const me = this.name || "";
        if (this.isArray()) {
          const _ = JSON.parse(this.arrayChildren.format("json"));
          return _.name = me, _.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(_);
        }
        const fe = {
          type: this.baseType === "tuple" ? "tuple" : this.type,
          name: me
        };
        return typeof this.indexed == "boolean" && (fe.indexed = this.indexed), this.isTuple() && (fe.components = this.components.map((_) => JSON.parse(_.format(ie)))), JSON.stringify(fe);
      }
      let se = "";
      return this.isArray() ? (se += this.arrayChildren.format(ie), se += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? se += "(" + this.components.map((me) => me.format(ie)).join(ie === "full" ? ", " : ",") + ")" : se += this.type, ie !== "sighash" && (this.indexed === !0 && (se += " indexed"), ie === "full" && this.name && (se += " " + this.name)), se;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */
    isArray() {
      return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */
    isTuple() {
      return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */
    isIndexable() {
      return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */
    walk(ie, se) {
      if (this.isArray()) {
        if (!Array.isArray(ie))
          throw new Error("invalid array value");
        if (this.arrayLength !== -1 && ie.length !== this.arrayLength)
          throw new Error("array is wrong length");
        const me = this;
        return ie.map((fe) => me.arrayChildren.walk(fe, se));
      }
      if (this.isTuple()) {
        if (!Array.isArray(ie))
          throw new Error("invalid tuple value");
        if (ie.length !== this.components.length)
          throw new Error("array is wrong length");
        const me = this;
        return ie.map((fe, _) => me.components[_].walk(fe, se));
      }
      return se(this.type, ie);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */
    async walkAsync(ie, se) {
      const me = [], fe = [ie];
      return de(this, be, td).call(this, me, ie, se, (_) => {
        fe[0] = _;
      }), me.length && await Promise.all(me), fe[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */
    static from(ie, se) {
      if (Be.isParamType(ie))
        return ie;
      if (typeof ie == "string")
        try {
          return Be.from(N(ie), se);
        } catch {
          (0, r.assertArgument)(!1, "invalid param type", "obj", ie);
        }
      else if (ie instanceof m) {
        let w = "", $ = "", Y = null;
        R(ie, t(["tuple"])).has("tuple") || ie.peekType("OPEN_PAREN") ? ($ = "tuple", Y = ie.popParams().map((je) => Be.from(je)), w = `tuple(${Y.map((je) => je.format()).join(",")})`) : (w = S(ie.popType("TYPE")), $ = w);
        let ce = null, xe = null;
        for (; ie.length && ie.peekType("BRACKET"); ) {
          const je = ie.pop();
          ce = new Be(B, "", w, $, null, Y, xe, ce), xe = je.value, w += je.text, $ = "array", Y = null;
        }
        let Ie = null;
        if (R(ie, l).has("indexed")) {
          if (!se)
            throw new Error("");
          Ie = !0;
        }
        const Ue = ie.peekType("ID") ? ie.pop().text : "";
        if (ie.length)
          throw new Error("leftover tokens");
        return new Be(B, Ue, w, $, Ie, Y, xe, ce);
      }
      const me = ie.name;
      (0, r.assertArgument)(!me || typeof me == "string" && me.match(y), "invalid name", "obj.name", me);
      let fe = ie.indexed;
      fe != null && ((0, r.assertArgument)(se, "parameter cannot be indexed", "obj.indexed", ie.indexed), fe = !!fe);
      let _ = ie.type, b = _.match(P);
      if (b) {
        const w = parseInt(b[2] || "-1"), $ = Be.from({
          type: b[1],
          components: ie.components
        });
        return new Be(B, me || "", _, "array", fe, null, w, $);
      }
      if (_ === "tuple" || _.startsWith(
        "tuple("
        /* fix: ) */
      ) || _.startsWith(
        "("
        /* fix: ) */
      )) {
        const w = ie.components != null ? ie.components.map((Y) => Be.from(Y)) : null;
        return new Be(B, me || "", _, "tuple", fe, w, null, null);
      }
      return _ = S(ie.type), new Be(B, me || "", _, _, fe, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */
    static isParamType(ie) {
      return ie && ie[C] === H;
    }
  };
  be = new WeakSet(), td = function(ie, se, me, fe) {
    if (this.isArray()) {
      if (!Array.isArray(se))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && se.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const b = this.arrayChildren, w = se.slice();
      w.forEach(($, Y) => {
        var ce;
        de(ce = b, be, td).call(ce, ie, $, me, (xe) => {
          w[Y] = xe;
        });
      }), fe(w);
      return;
    }
    if (this.isTuple()) {
      const b = this.components;
      let w;
      if (Array.isArray(se))
        w = se.slice();
      else {
        if (se == null || typeof se != "object")
          throw new Error("invalid tuple value");
        w = b.map(($) => {
          if (!$.name)
            throw new Error("cannot use object value with unnamed components");
          if (!($.name in se))
            throw new Error(`missing value for component ${$.name}`);
          return se[$.name];
        });
      }
      if (w.length !== this.components.length)
        throw new Error("array is wrong length");
      w.forEach(($, Y) => {
        var ce;
        de(ce = b[Y], be, td).call(ce, ie, $, me, (xe) => {
          w[Y] = xe;
        });
      }), fe(w);
      return;
    }
    const _ = me(this.type, se);
    _.then ? ie.push(async function() {
      fe(await _);
    }()) : fe(_);
  };
  let te = Be;
  Tt.ParamType = te;
  class pe {
    /**
     *  @private
     */
    constructor(ie, se, me) {
      /**
       *  The type of the fragment.
       */
      Q(this, "type");
      /**
       *  The inputs for the fragment.
       */
      Q(this, "inputs");
      (0, r.assertPrivate)(ie, B, "Fragment"), me = Object.freeze(me.slice()), (0, r.defineProperties)(this, { type: se, inputs: me });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */
    static from(ie) {
      if (typeof ie == "string") {
        try {
          pe.from(JSON.parse(ie));
        } catch {
        }
        return pe.from(N(ie));
      }
      if (ie instanceof m)
        switch (ie.peekKeyword(u)) {
          case "constructor":
            return L.from(ie);
          case "error":
            return re.from(ie);
          case "event":
            return ae.from(ie);
          case "fallback":
          case "receive":
            return ne.from(ie);
          case "function":
            return oe.from(ie);
          case "struct":
            return ee.from(ie);
        }
      else if (typeof ie == "object") {
        switch (ie.type) {
          case "constructor":
            return L.from(ie);
          case "error":
            return re.from(ie);
          case "event":
            return ae.from(ie);
          case "fallback":
          case "receive":
            return ne.from(ie);
          case "function":
            return oe.from(ie);
          case "struct":
            return ee.from(ie);
        }
        (0, r.assert)(!1, `unsupported type: ${ie.type}`, "UNSUPPORTED_OPERATION", {
          operation: "Fragment.from"
        });
      }
      (0, r.assertArgument)(!1, "unsupported frgament object", "obj", ie);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */
    static isConstructor(ie) {
      return L.isFragment(ie);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */
    static isError(ie) {
      return re.isFragment(ie);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */
    static isEvent(ie) {
      return ae.isFragment(ie);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */
    static isFunction(ie) {
      return oe.isFragment(ie);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */
    static isStruct(ie) {
      return ee.isFragment(ie);
    }
  }
  Tt.Fragment = pe;
  class he extends pe {
    /**
     *  @private
     */
    constructor(se, me, fe, _) {
      super(se, me, _);
      /**
       *  The name of the fragment.
       */
      Q(this, "name");
      (0, r.assertArgument)(typeof fe == "string" && fe.match(y), "invalid identifier", "name", fe), _ = Object.freeze(_.slice()), (0, r.defineProperties)(this, { name: fe });
    }
  }
  Tt.NamedFragment = he;
  function ye(Ae, ie) {
    return "(" + ie.map((se) => se.format(Ae)).join(Ae === "full" ? ", " : ",") + ")";
  }
  class re extends he {
    /**
     *  @private
     */
    constructor(ie, se, me) {
      super(ie, "error", se, me), Object.defineProperty(this, C, { value: V });
    }
    /**
     *  The Custom Error selector.
     */
    get selector() {
      return (0, e.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */
    format(ie) {
      if (ie == null && (ie = "sighash"), ie === "json")
        return JSON.stringify({
          type: "error",
          name: this.name,
          inputs: this.inputs.map((me) => JSON.parse(me.format(ie)))
        });
      const se = [];
      return ie !== "sighash" && se.push("error"), se.push(this.name + ye(ie, this.inputs)), se.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */
    static from(ie) {
      if (re.isFragment(ie))
        return ie;
      if (typeof ie == "string")
        return re.from(N(ie));
      if (ie instanceof m) {
        const se = U("error", ie), me = D(ie);
        return I(ie), new re(B, se, me);
      }
      return new re(B, ie.name, ie.inputs ? ie.inputs.map(te.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */
    static isFragment(ie) {
      return ie && ie[C] === V;
    }
  }
  Tt.ErrorFragment = re;
  class ae extends he {
    /**
     *  @private
     */
    constructor(se, me, fe, _) {
      super(se, "event", me, fe);
      /**
       *  Whether this event is anonymous.
       */
      Q(this, "anonymous");
      Object.defineProperty(this, C, { value: J }), (0, r.defineProperties)(this, { anonymous: _ });
    }
    /**
     *  The Event topic hash.
     */
    get topicHash() {
      return (0, e.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */
    format(se) {
      if (se == null && (se = "sighash"), se === "json")
        return JSON.stringify({
          type: "event",
          anonymous: this.anonymous,
          name: this.name,
          inputs: this.inputs.map((fe) => JSON.parse(fe.format(se)))
        });
      const me = [];
      return se !== "sighash" && me.push("event"), me.push(this.name + ye(se, this.inputs)), se !== "sighash" && this.anonymous && me.push("anonymous"), me.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */
    static getTopicHash(se, me) {
      return me = (me || []).map((_) => te.from(_)), new ae(B, se, me, !1).topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */
    static from(se) {
      if (ae.isFragment(se))
        return se;
      if (typeof se == "string")
        try {
          return ae.from(N(se));
        } catch {
          (0, r.assertArgument)(!1, "invalid event fragment", "obj", se);
        }
      else if (se instanceof m) {
        const me = U("event", se), fe = D(se, !0), _ = !!R(se, t(["anonymous"])).has("anonymous");
        return I(se), new ae(B, me, fe, _);
      }
      return new ae(B, se.name, se.inputs ? se.inputs.map((me) => te.from(me, !0)) : [], !!se.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */
    static isFragment(se) {
      return se && se[C] === J;
    }
  }
  Tt.EventFragment = ae;
  class L extends pe {
    /**
     *  @private
     */
    constructor(se, me, fe, _, b) {
      super(se, me, fe);
      /**
       *  Whether the constructor can receive an endowment.
       */
      Q(this, "payable");
      /**
       *  The recommended gas limit for deployment or ``null``.
       */
      Q(this, "gas");
      Object.defineProperty(this, C, { value: M }), (0, r.defineProperties)(this, { payable: _, gas: b });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */
    format(se) {
      if ((0, r.assert)(se != null && se !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), se === "json")
        return JSON.stringify({
          type: "constructor",
          stateMutability: this.payable ? "payable" : "undefined",
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((fe) => JSON.parse(fe.format(se)))
        });
      const me = [`constructor${ye(se, this.inputs)}`];
      return this.payable && me.push("payable"), this.gas != null && me.push(`@${this.gas.toString()}`), me.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */
    static from(se) {
      if (L.isFragment(se))
        return se;
      if (typeof se == "string")
        try {
          return L.from(N(se));
        } catch {
          (0, r.assertArgument)(!1, "invalid constuctor fragment", "obj", se);
        }
      else if (se instanceof m) {
        R(se, t(["constructor"]));
        const me = D(se), fe = !!R(se, s).has("payable"), _ = O(se);
        return I(se), new L(B, "constructor", me, fe, _);
      }
      return new L(B, "constructor", se.inputs ? se.inputs.map(te.from) : [], !!se.payable, se.gas != null ? se.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */
    static isFragment(se) {
      return se && se[C] === M;
    }
  }
  Tt.ConstructorFragment = L;
  class ne extends pe {
    constructor(se, me, fe) {
      super(se, "fallback", me);
      /**
       *  If the function can be sent value during invocation.
       */
      Q(this, "payable");
      Object.defineProperty(this, C, { value: G }), (0, r.defineProperties)(this, { payable: fe });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */
    format(se) {
      const me = this.inputs.length === 0 ? "receive" : "fallback";
      if (se === "json") {
        const fe = this.payable ? "payable" : "nonpayable";
        return JSON.stringify({ type: me, stateMutability: fe });
      }
      return `${me}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */
    static from(se) {
      if (ne.isFragment(se))
        return se;
      if (typeof se == "string")
        try {
          return ne.from(N(se));
        } catch {
          (0, r.assertArgument)(!1, "invalid fallback fragment", "obj", se);
        }
      else if (se instanceof m) {
        const me = se.toString(), fe = se.peekKeyword(t(["fallback", "receive"]));
        if ((0, r.assertArgument)(fe, "type must be fallback or receive", "obj", me), se.popKeyword(t(["fallback", "receive"])) === "receive") {
          const $ = D(se);
          return (0, r.assertArgument)($.length === 0, "receive cannot have arguments", "obj.inputs", $), R(se, t(["payable"])), I(se), new ne(B, [], !0);
        }
        let b = D(se);
        b.length ? (0, r.assertArgument)(b.length === 1 && b[0].type === "bytes", "invalid fallback inputs", "obj.inputs", b.map(($) => $.format("minimal")).join(", ")) : b = [te.from("bytes")];
        const w = j(se);
        if ((0, r.assertArgument)(w === "nonpayable" || w === "payable", "fallback cannot be constants", "obj.stateMutability", w), R(se, t(["returns"])).has("returns")) {
          const $ = D(se);
          (0, r.assertArgument)($.length === 1 && $[0].type === "bytes", "invalid fallback outputs", "obj.outputs", $.map((Y) => Y.format("minimal")).join(", "));
        }
        return I(se), new ne(B, b, w === "payable");
      }
      if (se.type === "receive")
        return new ne(B, [], !0);
      if (se.type === "fallback") {
        const me = [te.from("bytes")], fe = se.stateMutability === "payable";
        return new ne(B, me, fe);
      }
      (0, r.assertArgument)(!1, "invalid fallback description", "obj", se);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */
    static isFragment(se) {
      return se && se[C] === G;
    }
  }
  Tt.FallbackFragment = ne;
  class oe extends he {
    /**
     *  @private
     */
    constructor(se, me, fe, _, b, w) {
      super(se, "function", me, _);
      /**
       *  If the function is constant (e.g. ``pure`` or ``view`` functions).
       */
      Q(this, "constant");
      /**
       *  The returned types for the result of calling this function.
       */
      Q(this, "outputs");
      /**
       *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
       *  or ``pure``)
       */
      Q(this, "stateMutability");
      /**
       *  If the function can be sent value during invocation.
       */
      Q(this, "payable");
      /**
       *  The recommended gas limit to send when calling this function.
       */
      Q(this, "gas");
      Object.defineProperty(this, C, { value: K }), b = Object.freeze(b.slice());
      const $ = fe === "view" || fe === "pure", Y = fe === "payable";
      (0, r.defineProperties)(this, { constant: $, gas: w, outputs: b, payable: Y, stateMutability: fe });
    }
    /**
     *  The Function selector.
     */
    get selector() {
      return (0, e.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */
    format(se) {
      if (se == null && (se = "sighash"), se === "json")
        return JSON.stringify({
          type: "function",
          name: this.name,
          constant: this.constant,
          stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((fe) => JSON.parse(fe.format(se))),
          outputs: this.outputs.map((fe) => JSON.parse(fe.format(se)))
        });
      const me = [];
      return se !== "sighash" && me.push("function"), me.push(this.name + ye(se, this.inputs)), se !== "sighash" && (this.stateMutability !== "nonpayable" && me.push(this.stateMutability), this.outputs && this.outputs.length && (me.push("returns"), me.push(ye(se, this.outputs))), this.gas != null && me.push(`@${this.gas.toString()}`)), me.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */
    static getSelector(se, me) {
      return me = (me || []).map((_) => te.from(_)), new oe(B, se, "view", me, [], null).selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */
    static from(se) {
      if (oe.isFragment(se))
        return se;
      if (typeof se == "string")
        try {
          return oe.from(N(se));
        } catch {
          (0, r.assertArgument)(!1, "invalid function fragment", "obj", se);
        }
      else if (se instanceof m) {
        const fe = U("function", se), _ = D(se), b = j(se);
        let w = [];
        R(se, t(["returns"])).has("returns") && (w = D(se));
        const $ = O(se);
        return I(se), new oe(B, fe, b, _, w, $);
      }
      let me = se.stateMutability;
      return me == null && (me = "payable", typeof se.constant == "boolean" ? (me = "view", se.constant || (me = "payable", typeof se.payable == "boolean" && !se.payable && (me = "nonpayable"))) : typeof se.payable == "boolean" && !se.payable && (me = "nonpayable")), new oe(B, se.name, me, se.inputs ? se.inputs.map(te.from) : [], se.outputs ? se.outputs.map(te.from) : [], se.gas != null ? se.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */
    static isFragment(se) {
      return se && se[C] === K;
    }
  }
  Tt.FunctionFragment = oe;
  class ee extends he {
    /**
     *  @private
     */
    constructor(ie, se, me) {
      super(ie, "struct", se, me), Object.defineProperty(this, C, { value: X });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */
    format() {
      throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */
    static from(ie) {
      if (typeof ie == "string")
        try {
          return ee.from(N(ie));
        } catch {
          (0, r.assertArgument)(!1, "invalid struct fragment", "obj", ie);
        }
      else if (ie instanceof m) {
        const se = U("struct", ie), me = D(ie);
        return I(ie), new ee(B, se, me);
      }
      return new ee(B, ie.name, ie.inputs ? ie.inputs.map(te.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */
    static isFragment(ie) {
      return ie && ie[C] === X;
    }
  }
  return Tt.StructFragment = ee, Tt;
}
var Py;
function o6() {
  var N, nc;
  if (Py) return Wu;
  Py = 1, Object.defineProperty(Wu, "__esModule", { value: !0 }), Wu.AbiCoder = void 0;
  const r = Me(), e = Cn(), t = Uv(), n = t6(), s = Mv(), i = r6(), a = Fv(), o = Dv(), u = jv(), c = Hv(), l = Gv(), f = lx(), d = zt(), h = Me(), p = /* @__PURE__ */ new Map();
  p.set(0, "GENERIC_PANIC"), p.set(1, "ASSERT_FALSE"), p.set(17, "OVERFLOW"), p.set(18, "DIVIDE_BY_ZERO"), p.set(33, "ENUM_RANGE_ERROR"), p.set(34, "BAD_STORAGE_DATA"), p.set(49, "STACK_UNDERFLOW"), p.set(50, "ARRAY_RANGE_ERROR"), p.set(65, "OUT_OF_MEMORY"), p.set(81, "UNINITIALIZED_FUNCTION_CALL");
  const g = new RegExp(/^bytes([0-9]*)$/), k = new RegExp(/^(u?int)([0-9]*)$/);
  let A = null, y = 1024;
  function E(R, j, D, O) {
    let I = "missing revert data", P = null;
    const S = null;
    let B = null;
    if (D) {
      I = "execution reverted";
      const H = (0, h.getBytes)(D);
      if (D = (0, h.hexlify)(D), H.length === 0)
        I += " (no data present; likely require(false) occurred", P = "require(false)";
      else if (H.length % 32 !== 4)
        I += " (could not decode reason; invalid data length)";
      else if ((0, h.hexlify)(H.slice(0, 4)) === "0x08c379a0")
        try {
          P = O.decode(["string"], H.slice(4))[0], B = {
            signature: "Error(string)",
            name: "Error",
            args: [P]
          }, I += `: ${JSON.stringify(P)}`;
        } catch {
          I += " (could not decode reason; invalid string data)";
        }
      else if ((0, h.hexlify)(H.slice(0, 4)) === "0x4e487b71")
        try {
          const V = Number(O.decode(["uint256"], H.slice(4))[0]);
          B = {
            signature: "Panic(uint256)",
            name: "Panic",
            args: [V]
          }, P = `Panic due to ${p.get(V) || "UNKNOWN"}(${V})`, I += `: ${P}`;
        } catch {
          I += " (could not decode panic code)";
        }
      else
        I += " (unknown custom error)";
    }
    const C = {
      to: j.to ? (0, d.getAddress)(j.to) : null,
      data: j.data || "0x"
    };
    return j.from && (C.from = (0, d.getAddress)(j.from)), (0, h.makeError)(I, "CALL_EXCEPTION", {
      action: R,
      data: D,
      reason: P,
      transaction: C,
      invocation: S,
      revert: B
    });
  }
  const U = class U {
    constructor() {
      Z(this, N);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */
    getDefaultValue(j) {
      const D = j.map((I) => de(this, N, nc).call(this, f.ParamType.from(I)));
      return new l.TupleCoder(D, "_").defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */
    encode(j, D) {
      (0, r.assertArgumentCount)(D.length, j.length, "types/values length mismatch");
      const O = j.map((S) => de(this, N, nc).call(this, f.ParamType.from(S))), I = new l.TupleCoder(O, "_"), P = new e.Writer();
      return I.encode(P, D), P.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */
    decode(j, D, O) {
      const I = j.map((S) => de(this, N, nc).call(this, f.ParamType.from(S)));
      return new l.TupleCoder(I, "_").decode(new e.Reader(D, O, y));
    }
    static _setDefaultMaxInflation(j) {
      (0, r.assertArgument)(typeof j == "number" && Number.isInteger(j), "invalid defaultMaxInflation factor", "value", j), y = j;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */
    static defaultAbiCoder() {
      return A == null && (A = new U()), A;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */
    static getBuiltinCallException(j, D, O) {
      return E(j, D, O, U.defaultAbiCoder());
    }
  };
  N = new WeakSet(), nc = function(j) {
    if (j.isArray())
      return new n.ArrayCoder(de(this, N, nc).call(this, j.arrayChildren), j.arrayLength, j.name);
    if (j.isTuple())
      return new l.TupleCoder(j.components.map((O) => de(this, N, nc).call(this, O)), j.name);
    switch (j.baseType) {
      case "address":
        return new t.AddressCoder(j.name);
      case "bool":
        return new s.BooleanCoder(j.name);
      case "string":
        return new c.StringCoder(j.name);
      case "bytes":
        return new i.BytesCoder(j.name);
      case "":
        return new o.NullCoder(j.name);
    }
    let D = j.type.match(k);
    if (D) {
      let O = parseInt(D[2] || "256");
      return (0, r.assertArgument)(O !== 0 && O <= 256 && O % 8 === 0, "invalid " + D[1] + " bit length", "param", j), new u.NumberCoder(O / 8, D[1] === "int", j.name);
    }
    if (D = j.type.match(g), D) {
      let O = parseInt(D[1]);
      return (0, r.assertArgument)(O !== 0 && O <= 32, "invalid bytes length", "param", j), new a.FixedBytesCoder(O, j.name);
    }
    (0, r.assertArgument)(!1, "invalid type", "type", j.type);
  };
  let m = U;
  return Wu.AbiCoder = m, Wu;
}
var ma = {}, vy;
function qv() {
  if (vy) return ma;
  vy = 1, Object.defineProperty(ma, "__esModule", { value: !0 }), ma.decodeBytes32String = ma.encodeBytes32String = void 0;
  const r = Me();
  function e(n) {
    const s = (0, r.toUtf8Bytes)(n);
    if (s.length > 31)
      throw new Error("bytes32 string must be less than 32 bytes");
    return (0, r.zeroPadBytes)(s, 32);
  }
  ma.encodeBytes32String = e;
  function t(n) {
    const s = (0, r.getBytes)(n, "bytes");
    if (s.length !== 32)
      throw new Error("invalid bytes32 - not 32 bytes long");
    if (s[31] !== 0)
      throw new Error("invalid bytes32 string - no null terminator");
    let i = 31;
    for (; s[i - 1] === 0; )
      i--;
    return (0, r.toUtf8String)(s.slice(0, i));
  }
  return ma.decodeBytes32String = t, ma;
}
var Pp = {}, ky;
function Wv() {
  return ky || (ky = 1, function(r) {
    var g, k, A, y, E, rd, nd;
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Interface = r.Indexed = r.ErrorDescription = r.TransactionDescription = r.LogDescription = r.Result = r.checkResultErrors = void 0;
    const e = Yt(), t = Ys(), n = Me(), s = o6(), i = Cn();
    Object.defineProperty(r, "checkResultErrors", { enumerable: !0, get: function() {
      return i.checkResultErrors;
    } }), Object.defineProperty(r, "Result", { enumerable: !0, get: function() {
      return i.Result;
    } });
    const a = lx(), o = Ws();
    class u {
      /**
       *  @_ignore:
       */
      constructor(R, j, D) {
        /**
         *  The matching fragment for the ``topic0``.
         */
        Q(this, "fragment");
        /**
         *  The name of the Event.
         */
        Q(this, "name");
        /**
         *  The full Event signature.
         */
        Q(this, "signature");
        /**
         *  The topic hash for the Event.
         */
        Q(this, "topic");
        /**
         *  The arguments passed into the Event with ``emit``.
         */
        Q(this, "args");
        const O = R.name, I = R.format();
        (0, n.defineProperties)(this, {
          fragment: R,
          name: O,
          signature: I,
          topic: j,
          args: D
        });
      }
    }
    r.LogDescription = u;
    class c {
      /**
       *  @_ignore:
       */
      constructor(R, j, D, O) {
        /**
         *  The matching fragment from the transaction ``data``.
         */
        Q(this, "fragment");
        /**
         *  The name of the Function from the transaction ``data``.
         */
        Q(this, "name");
        /**
         *  The arguments passed to the Function from the transaction ``data``.
         */
        Q(this, "args");
        /**
         *  The full Function signature from the transaction ``data``.
         */
        Q(this, "signature");
        /**
         *  The selector for the Function from the transaction ``data``.
         */
        Q(this, "selector");
        /**
         *  The ``value`` (in wei) from the transaction.
         */
        Q(this, "value");
        const I = R.name, P = R.format();
        (0, n.defineProperties)(this, {
          fragment: R,
          name: I,
          args: D,
          signature: P,
          selector: j,
          value: O
        });
      }
    }
    r.TransactionDescription = c;
    class l {
      /**
       *  @_ignore:
       */
      constructor(R, j, D) {
        /**
         *  The matching fragment.
         */
        Q(this, "fragment");
        /**
         *  The name of the Error.
         */
        Q(this, "name");
        /**
         *  The arguments passed to the Error with ``revert``.
         */
        Q(this, "args");
        /**
         *  The full Error signature.
         */
        Q(this, "signature");
        /**
         *  The selector for the Error.
         */
        Q(this, "selector");
        const O = R.name, I = R.format();
        (0, n.defineProperties)(this, {
          fragment: R,
          name: O,
          args: D,
          signature: I,
          selector: j
        });
      }
    }
    r.ErrorDescription = l;
    class f {
      /**
       *  @_ignore:
       */
      constructor(R) {
        /**
         *  The ``keccak256`` of the value logged.
         */
        Q(this, "hash");
        /**
         *  @_ignore:
         */
        Q(this, "_isIndexed");
        (0, n.defineProperties)(this, { hash: R, _isIndexed: !0 });
      }
      /**
       *  Returns ``true`` if %%value%% is an **Indexed**.
       *
       *  This provides a Type Guard for property access.
       */
      static isIndexed(R) {
        return !!(R && R._isIndexed);
      }
    }
    r.Indexed = f;
    const d = {
      0: "generic panic",
      1: "assert(false)",
      17: "arithmetic overflow",
      18: "division or modulo by zero",
      33: "enum overflow",
      34: "invalid encoded storage byte array accessed",
      49: "out-of-bounds array access; popping on an empty array",
      50: "out-of-bounds access of an array or bytesN",
      65: "out of memory",
      81: "uninitialized function"
    }, h = {
      "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: ["string"],
        reason: (U) => `reverted with reason string ${JSON.stringify(U)}`
      },
      "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: ["uint256"],
        reason: (U) => {
          let R = "unknown panic code";
          return U >= 0 && U <= 255 && d[U.toString()] && (R = d[U.toString()]), `reverted with panic code 0x${U.toString(16)} (${R})`;
        }
      }
    }, T = class T {
      /**
       *  Create a new Interface for the %%fragments%%.
       */
      constructor(R) {
        Z(this, E);
        /**
         *  All the Contract ABI members (i.e. methods, events, errors, etc).
         */
        Q(this, "fragments");
        /**
         *  The Contract constructor.
         */
        Q(this, "deploy");
        /**
         *  The Fallback method, if any.
         */
        Q(this, "fallback");
        /**
         *  If receiving ether is supported.
         */
        Q(this, "receive");
        Z(this, g);
        Z(this, k);
        Z(this, A);
        //    #structs: Map<string, StructFragment>;
        Z(this, y);
        let j = [];
        typeof R == "string" ? j = JSON.parse(R) : j = R, F(this, A, /* @__PURE__ */ new Map()), F(this, g, /* @__PURE__ */ new Map()), F(this, k, /* @__PURE__ */ new Map());
        const D = [];
        for (const P of j)
          try {
            D.push(a.Fragment.from(P));
          } catch (S) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(P)}:`, S.message);
          }
        (0, n.defineProperties)(this, {
          fragments: Object.freeze(D)
        });
        let O = null, I = !1;
        F(this, y, this.getAbiCoder()), this.fragments.forEach((P, S) => {
          let B;
          switch (P.type) {
            case "constructor":
              if (this.deploy) {
                console.log("duplicate definition - constructor");
                return;
              }
              (0, n.defineProperties)(this, { deploy: P });
              return;
            case "fallback":
              P.inputs.length === 0 ? I = !0 : ((0, n.assertArgument)(!O || P.payable !== O.payable, "conflicting fallback fragments", `fragments[${S}]`, P), O = P, I = O.payable);
              return;
            case "function":
              B = x(this, A);
              break;
            case "event":
              B = x(this, k);
              break;
            case "error":
              B = x(this, g);
              break;
            default:
              return;
          }
          const C = P.format();
          B.has(C) || B.set(C, P);
        }), this.deploy || (0, n.defineProperties)(this, {
          deploy: a.ConstructorFragment.from("constructor()")
        }), (0, n.defineProperties)(this, { fallback: O, receive: I });
      }
      /**
       *  Returns the entire Human-Readable ABI, as an array of
       *  signatures, optionally as %%minimal%% strings, which
       *  removes parameter names and unneceesary spaces.
       */
      format(R) {
        const j = R ? "minimal" : "full";
        return this.fragments.map((O) => O.format(j));
      }
      /**
       *  Return the JSON-encoded ABI. This is the format Solidiy
       *  returns.
       */
      formatJson() {
        const R = this.fragments.map((j) => j.format("json"));
        return JSON.stringify(R.map((j) => JSON.parse(j)));
      }
      /**
       *  The ABI coder that will be used to encode and decode binary
       *  data.
       */
      getAbiCoder() {
        return s.AbiCoder.defaultAbiCoder();
      }
      /**
       *  Get the function name for %%key%%, which may be a function selector,
       *  function name or function signature that belongs to the ABI.
       */
      getFunctionName(R) {
        const j = de(this, E, rd).call(this, R, null, !1);
        return (0, n.assertArgument)(j, "no matching function", "key", R), j.name;
      }
      /**
       *  Returns true if %%key%% (a function selector, function name or
       *  function signature) is present in the ABI.
       *
       *  In the case of a function name, the name may be ambiguous, so
       *  accessing the [[FunctionFragment]] may require refinement.
       */
      hasFunction(R) {
        return !!de(this, E, rd).call(this, R, null, !1);
      }
      /**
       *  Get the [[FunctionFragment]] for %%key%%, which may be a function
       *  selector, function name or function signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple functions match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single function in
       *  the ABI, this will throw.
       */
      getFunction(R, j) {
        return de(this, E, rd).call(this, R, j || null, !0);
      }
      /**
       *  Iterate over all functions, calling %%callback%%, sorted by their name.
       */
      forEachFunction(R) {
        const j = Array.from(x(this, A).keys());
        j.sort((D, O) => D.localeCompare(O));
        for (let D = 0; D < j.length; D++) {
          const O = j[D];
          R(x(this, A).get(O), D);
        }
      }
      /**
       *  Get the event name for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       */
      getEventName(R) {
        const j = de(this, E, nd).call(this, R, null, !1);
        return (0, n.assertArgument)(j, "no matching event", "key", R), j.name;
      }
      /**
       *  Returns true if %%key%% (an event topic hash, event name or
       *  event signature) is present in the ABI.
       *
       *  In the case of an event name, the name may be ambiguous, so
       *  accessing the [[EventFragment]] may require refinement.
       */
      hasEvent(R) {
        return !!de(this, E, nd).call(this, R, null, !1);
      }
      /**
       *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
       *  event name or event signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple events match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single event in
       *  the ABI, this will throw.
       */
      getEvent(R, j) {
        return de(this, E, nd).call(this, R, j || null, !0);
      }
      /**
       *  Iterate over all events, calling %%callback%%, sorted by their name.
       */
      forEachEvent(R) {
        const j = Array.from(x(this, k).keys());
        j.sort((D, O) => D.localeCompare(O));
        for (let D = 0; D < j.length; D++) {
          const O = j[D];
          R(x(this, k).get(O), D);
        }
      }
      /**
       *  Get the [[ErrorFragment]] for %%key%%, which may be an error
       *  selector, error name or error signature that belongs to the ABI.
       *
       *  If %%values%% is provided, it will use the Typed API to handle
       *  ambiguous cases where multiple errors match by name.
       *
       *  If the %%key%% and %%values%% do not refine to a single error in
       *  the ABI, this will throw.
       */
      getError(R, j) {
        if ((0, n.isHexString)(R)) {
          const O = R.toLowerCase();
          if (h[O])
            return a.ErrorFragment.from(h[O].signature);
          for (const I of x(this, g).values())
            if (O === I.selector)
              return I;
          return null;
        }
        if (R.indexOf("(") === -1) {
          const O = [];
          for (const [I, P] of x(this, g))
            I.split(
              "("
              /* fix:) */
            )[0] === R && O.push(P);
          if (O.length === 0)
            return R === "Error" ? a.ErrorFragment.from("error Error(string)") : R === "Panic" ? a.ErrorFragment.from("error Panic(uint256)") : null;
          if (O.length > 1) {
            const I = O.map((P) => JSON.stringify(P.format())).join(", ");
            (0, n.assertArgument)(!1, `ambiguous error description (i.e. ${I})`, "name", R);
          }
          return O[0];
        }
        if (R = a.ErrorFragment.from(R).format(), R === "Error(string)")
          return a.ErrorFragment.from("error Error(string)");
        if (R === "Panic(uint256)")
          return a.ErrorFragment.from("error Panic(uint256)");
        const D = x(this, g).get(R);
        return D || null;
      }
      /**
       *  Iterate over all errors, calling %%callback%%, sorted by their name.
       */
      forEachError(R) {
        const j = Array.from(x(this, g).keys());
        j.sort((D, O) => D.localeCompare(O));
        for (let D = 0; D < j.length; D++) {
          const O = j[D];
          R(x(this, g).get(O), D);
        }
      }
      // Get the 4-byte selector used by Solidity to identify a function
      /*
      		getSelector(fragment: ErrorFragment | FunctionFragment): string {
      		    if (typeof(fragment) === "string") {
      		        const matches: Array<Fragment> = [ ];
      
      		        try { matches.push(this.getFunction(fragment)); } catch (error) { }
      		        try { matches.push(this.getError(<string>fragment)); } catch (_) { }
      
      		        if (matches.length === 0) {
      		            logger.throwArgumentError("unknown fragment", "key", fragment);
      		        } else if (matches.length > 1) {
      		            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
      		        }
      
      		        fragment = matches[0];
      		    }
      
      		    return dataSlice(id(fragment.format()), 0, 4);
      		}
      		    */
      // Get the 32-byte topic hash used by Solidity to identify an event
      /*
      getEventTopic(fragment: EventFragment): string {
          //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
          return id(fragment.format());
      }
      */
      _decodeParams(R, j) {
        return x(this, y).decode(R, j);
      }
      _encodeParams(R, j) {
        return x(this, y).encode(R, j);
      }
      /**
       *  Encodes a ``tx.data`` object for deploying the Contract with
       *  the %%values%% as the constructor arguments.
       */
      encodeDeploy(R) {
        return this._encodeParams(this.deploy.inputs, R || []);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified error (see [[getError]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeErrorResult(R, j) {
        if (typeof R == "string") {
          const D = this.getError(R);
          (0, n.assertArgument)(D, "unknown error", "fragment", R), R = D;
        }
        return (0, n.assertArgument)((0, n.dataSlice)(j, 0, 4) === R.selector, `data signature does not match error ${R.name}.`, "data", j), this._decodeParams(R.inputs, (0, n.dataSlice)(j, 4));
      }
      /**
       *  Encodes the transaction revert data for a call result that
       *  reverted from the the Contract with the sepcified %%error%%
       *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeErrorResult(R, j) {
        if (typeof R == "string") {
          const D = this.getError(R);
          (0, n.assertArgument)(D, "unknown error", "fragment", R), R = D;
        }
        return (0, n.concat)([
          R.selector,
          this._encodeParams(R.inputs, j || [])
        ]);
      }
      /**
       *  Decodes the %%data%% from a transaction ``tx.data`` for
       *  the function specified (see [[getFunction]] for valid values
       *  for %%fragment%%).
       *
       *  Most developers should prefer the [[parseTransaction]] method
       *  instead, which will automatically detect the fragment.
       */
      decodeFunctionData(R, j) {
        if (typeof R == "string") {
          const D = this.getFunction(R);
          (0, n.assertArgument)(D, "unknown function", "fragment", R), R = D;
        }
        return (0, n.assertArgument)((0, n.dataSlice)(j, 0, 4) === R.selector, `data signature does not match function ${R.name}.`, "data", j), this._decodeParams(R.inputs, (0, n.dataSlice)(j, 4));
      }
      /**
       *  Encodes the ``tx.data`` for a transaction that calls the function
       *  specified (see [[getFunction]] for valid values for %%fragment%%) with
       *  the %%values%%.
       */
      encodeFunctionData(R, j) {
        if (typeof R == "string") {
          const D = this.getFunction(R);
          (0, n.assertArgument)(D, "unknown function", "fragment", R), R = D;
        }
        return (0, n.concat)([
          R.selector,
          this._encodeParams(R.inputs, j || [])
        ]);
      }
      /**
       *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values for
       *  %%key%%).
       *
       *  Most developers should prefer the [[parseCallResult]] method instead,
       *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
       *  corresponding error.
       */
      decodeFunctionResult(R, j) {
        if (typeof R == "string") {
          const I = this.getFunction(R);
          (0, n.assertArgument)(I, "unknown function", "fragment", R), R = I;
        }
        let D = "invalid length for result data";
        const O = (0, n.getBytesCopy)(j);
        if (O.length % 32 === 0)
          try {
            return x(this, y).decode(R.outputs, O);
          } catch {
            D = "could not decode result data";
          }
        (0, n.assert)(!1, D, "BAD_DATA", {
          value: (0, n.hexlify)(O),
          info: { method: R.name, signature: R.format() }
        });
      }
      makeError(R, j) {
        const D = (0, n.getBytes)(R, "data"), O = s.AbiCoder.getBuiltinCallException("call", j, D);
        if (O.message.startsWith("execution reverted (unknown custom error)")) {
          const S = (0, n.hexlify)(D.slice(0, 4)), B = this.getError(S);
          if (B)
            try {
              const C = x(this, y).decode(B.inputs, D.slice(4));
              O.revert = {
                name: B.name,
                signature: B.format(),
                args: C
              }, O.reason = O.revert.signature, O.message = `execution reverted: ${O.reason}`;
            } catch {
              O.message = "execution reverted (coult not decode custom error)";
            }
        }
        const P = this.parseTransaction(j);
        return P && (O.invocation = {
          method: P.name,
          signature: P.signature,
          args: P.args
        }), O;
      }
      /**
       *  Encodes the result data (e.g. from an ``eth_call``) for the
       *  specified function (see [[getFunction]] for valid values
       *  for %%fragment%%) with %%values%%.
       *
       *  This is generally not used by most developers, unless trying to mock
       *  a result from a Contract.
       */
      encodeFunctionResult(R, j) {
        if (typeof R == "string") {
          const D = this.getFunction(R);
          (0, n.assertArgument)(D, "unknown function", "fragment", R), R = D;
        }
        return (0, n.hexlify)(x(this, y).encode(R.outputs, j || []));
      }
      /*
          spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
              const promises: Array<Promise<>> = [ ];
              const process = function(type: ParamType, value: any): any {
                  if (type.baseType === "array") {
                      return descend(type.child
                  }
                  if (type. === "address") {
                  }
              };
      
              const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                  if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                  
              };
      
              const result: Array<any> = [ ];
              values.forEach((value, index) => {
                  if (value == null) {
                      topics.push(null);
                  } else if (param.baseType === "array" || param.baseType === "tuple") {
                      logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                  } else if (Array.isArray(value)) {
                      topics.push(value.map((value) => encodeTopic(param, value)));
                  } else {
                      topics.push(encodeTopic(param, value));
                  }
              });
          }
      */
      // Create the filter for the event with search criteria (e.g. for eth_filterLog)
      encodeFilterTopics(R, j) {
        if (typeof R == "string") {
          const I = this.getEvent(R);
          (0, n.assertArgument)(I, "unknown event", "eventFragment", R), R = I;
        }
        (0, n.assert)(j.length <= R.inputs.length, `too many arguments for ${R.format()}`, "UNEXPECTED_ARGUMENT", { count: j.length, expectedCount: R.inputs.length });
        const D = [];
        R.anonymous || D.push(R.topicHash);
        const O = (I, P) => I.type === "string" ? (0, t.id)(P) : I.type === "bytes" ? (0, e.keccak256)((0, n.hexlify)(P)) : (I.type === "bool" && typeof P == "boolean" ? P = P ? "0x01" : "0x00" : I.type.match(/^u?int/) ? P = (0, n.toBeHex)(P) : I.type.match(/^bytes/) ? P = (0, n.zeroPadBytes)(P, 32) : I.type === "address" && x(this, y).encode(["address"], [P]), (0, n.zeroPadValue)((0, n.hexlify)(P), 32));
        for (j.forEach((I, P) => {
          const S = R.inputs[P];
          if (!S.indexed) {
            (0, n.assertArgument)(I == null, "cannot filter non-indexed parameters; must be null", "contract." + S.name, I);
            return;
          }
          I == null ? D.push(null) : S.baseType === "array" || S.baseType === "tuple" ? (0, n.assertArgument)(!1, "filtering with tuples or arrays not supported", "contract." + S.name, I) : Array.isArray(I) ? D.push(I.map((B) => O(S, B))) : D.push(O(S, I));
        }); D.length && D[D.length - 1] === null; )
          D.pop();
        return D;
      }
      encodeEventLog(R, j) {
        if (typeof R == "string") {
          const P = this.getEvent(R);
          (0, n.assertArgument)(P, "unknown event", "eventFragment", R), R = P;
        }
        const D = [], O = [], I = [];
        return R.anonymous || D.push(R.topicHash), (0, n.assertArgument)(j.length === R.inputs.length, "event arguments/values mismatch", "values", j), R.inputs.forEach((P, S) => {
          const B = j[S];
          if (P.indexed)
            if (P.type === "string")
              D.push((0, t.id)(B));
            else if (P.type === "bytes")
              D.push((0, e.keccak256)(B));
            else {
              if (P.baseType === "tuple" || P.baseType === "array")
                throw new Error("not implemented");
              D.push(x(this, y).encode([P.type], [B]));
            }
          else
            O.push(P), I.push(B);
        }), {
          data: x(this, y).encode(O, I),
          topics: D
        };
      }
      // Decode a filter for the event and the search criteria
      decodeEventLog(R, j, D) {
        if (typeof R == "string") {
          const M = this.getEvent(R);
          (0, n.assertArgument)(M, "unknown event", "eventFragment", R), R = M;
        }
        if (D != null && !R.anonymous) {
          const M = R.topicHash;
          (0, n.assertArgument)((0, n.isHexString)(D[0], 32) && D[0].toLowerCase() === M, "fragment/topic mismatch", "topics[0]", D[0]), D = D.slice(1);
        }
        const O = [], I = [], P = [];
        R.inputs.forEach((M, G) => {
          M.indexed ? M.type === "string" || M.type === "bytes" || M.baseType === "tuple" || M.baseType === "array" ? (O.push(a.ParamType.from({ type: "bytes32", name: M.name })), P.push(!0)) : (O.push(M), P.push(!1)) : (I.push(M), P.push(!1));
        });
        const S = D != null ? x(this, y).decode(O, (0, n.concat)(D)) : null, B = x(this, y).decode(I, j, !0), C = [], H = [];
        let V = 0, J = 0;
        return R.inputs.forEach((M, G) => {
          let K = null;
          if (M.indexed)
            if (S == null)
              K = new f(null);
            else if (P[G])
              K = new f(S[J++]);
            else
              try {
                K = S[J++];
              } catch (X) {
                K = X;
              }
          else
            try {
              K = B[V++];
            } catch (X) {
              K = X;
            }
          C.push(K), H.push(M.name || null);
        }), i.Result.fromItems(C, H);
      }
      /**
       *  Parses a transaction, finding the matching function and extracts
       *  the parameter values along with other useful function details.
       *
       *  If the matching function cannot be found, return null.
       */
      parseTransaction(R) {
        const j = (0, n.getBytes)(R.data, "tx.data"), D = (0, n.getBigInt)(R.value != null ? R.value : 0, "tx.value"), O = this.getFunction((0, n.hexlify)(j.slice(0, 4)));
        if (!O)
          return null;
        const I = x(this, y).decode(O.inputs, j.slice(4));
        return new c(O, O.selector, I, D);
      }
      parseCallResult(R) {
        throw new Error("@TODO");
      }
      /**
       *  Parses a receipt log, finding the matching event and extracts
       *  the parameter values along with other useful event details.
       *
       *  If the matching event cannot be found, returns null.
       */
      parseLog(R) {
        const j = this.getEvent(R.topics[0]);
        return !j || j.anonymous ? null : new u(j, j.topicHash, this.decodeEventLog(j, R.data, R.topics));
      }
      /**
       *  Parses a revert data, finding the matching error and extracts
       *  the parameter values along with other useful error details.
       *
       *  If the matching error cannot be found, returns null.
       */
      parseError(R) {
        const j = (0, n.hexlify)(R), D = this.getError((0, n.dataSlice)(j, 0, 4));
        if (!D)
          return null;
        const O = x(this, y).decode(D.inputs, (0, n.dataSlice)(j, 4));
        return new l(D, D.selector, O);
      }
      /**
       *  Creates a new [[Interface]] from the ABI %%value%%.
       *
       *  The %%value%% may be provided as an existing [[Interface]] object,
       *  a JSON-encoded ABI or any Human-Readable ABI format.
       */
      static from(R) {
        return R instanceof T ? R : typeof R == "string" ? new T(JSON.parse(R)) : typeof R.formatJson == "function" ? new T(R.formatJson()) : typeof R.format == "function" ? new T(R.format("json")) : new T(R);
      }
    };
    g = new WeakMap(), k = new WeakMap(), A = new WeakMap(), y = new WeakMap(), E = new WeakSet(), // Find a function definition by any means necessary (unless it is ambiguous)
    rd = function(R, j, D) {
      if ((0, n.isHexString)(R)) {
        const I = R.toLowerCase();
        for (const P of x(this, A).values())
          if (I === P.selector)
            return P;
        return null;
      }
      if (R.indexOf("(") === -1) {
        const I = [];
        for (const [P, S] of x(this, A))
          P.split(
            "("
            /* fix:) */
          )[0] === R && I.push(S);
        if (j) {
          const P = j.length > 0 ? j[j.length - 1] : null;
          let S = j.length, B = !0;
          o.Typed.isTyped(P) && P.type === "overrides" && (B = !1, S--);
          for (let C = I.length - 1; C >= 0; C--) {
            const H = I[C].inputs.length;
            H !== S && (!B || H !== S - 1) && I.splice(C, 1);
          }
          for (let C = I.length - 1; C >= 0; C--) {
            const H = I[C].inputs;
            for (let V = 0; V < j.length; V++)
              if (o.Typed.isTyped(j[V])) {
                if (V >= H.length) {
                  if (j[V].type === "overrides")
                    continue;
                  I.splice(C, 1);
                  break;
                }
                if (j[V].type !== H[V].baseType) {
                  I.splice(C, 1);
                  break;
                }
              }
          }
        }
        if (I.length === 1 && j && j.length !== I[0].inputs.length) {
          const P = j[j.length - 1];
          (P == null || Array.isArray(P) || typeof P != "object") && I.splice(0, 1);
        }
        if (I.length === 0)
          return null;
        if (I.length > 1 && D) {
          const P = I.map((S) => JSON.stringify(S.format())).join(", ");
          (0, n.assertArgument)(!1, `ambiguous function description (i.e. matches ${P})`, "key", R);
        }
        return I[0];
      }
      const O = x(this, A).get(a.FunctionFragment.from(R).format());
      return O || null;
    }, // Find an event definition by any means necessary (unless it is ambiguous)
    nd = function(R, j, D) {
      if ((0, n.isHexString)(R)) {
        const I = R.toLowerCase();
        for (const P of x(this, k).values())
          if (I === P.topicHash)
            return P;
        return null;
      }
      if (R.indexOf("(") === -1) {
        const I = [];
        for (const [P, S] of x(this, k))
          P.split(
            "("
            /* fix:) */
          )[0] === R && I.push(S);
        if (j) {
          for (let P = I.length - 1; P >= 0; P--)
            I[P].inputs.length < j.length && I.splice(P, 1);
          for (let P = I.length - 1; P >= 0; P--) {
            const S = I[P].inputs;
            for (let B = 0; B < j.length; B++)
              if (o.Typed.isTyped(j[B]) && j[B].type !== S[B].baseType) {
                I.splice(P, 1);
                break;
              }
          }
        }
        if (I.length === 0)
          return null;
        if (I.length > 1 && D) {
          const P = I.map((S) => JSON.stringify(S.format())).join(", ");
          (0, n.assertArgument)(!1, `ambiguous event description (i.e. matches ${P})`, "key", R);
        }
        return I[0];
      }
      const O = x(this, k).get(a.EventFragment.from(R).format());
      return O || null;
    };
    let p = T;
    r.Interface = p;
  }(Pp)), Pp;
}
var Ty;
function df() {
  return Ty || (Ty = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Typed = r.Result = r.TransactionDescription = r.LogDescription = r.ErrorDescription = r.Interface = r.Indexed = r.checkResultErrors = r.StructFragment = r.ParamType = r.NamedFragment = r.FunctionFragment = r.Fragment = r.FallbackFragment = r.EventFragment = r.ErrorFragment = r.ConstructorFragment = r.encodeBytes32String = r.decodeBytes32String = r.AbiCoder = void 0;
    var e = o6();
    Object.defineProperty(r, "AbiCoder", { enumerable: !0, get: function() {
      return e.AbiCoder;
    } });
    var t = qv();
    Object.defineProperty(r, "decodeBytes32String", { enumerable: !0, get: function() {
      return t.decodeBytes32String;
    } }), Object.defineProperty(r, "encodeBytes32String", { enumerable: !0, get: function() {
      return t.encodeBytes32String;
    } });
    var n = lx();
    Object.defineProperty(r, "ConstructorFragment", { enumerable: !0, get: function() {
      return n.ConstructorFragment;
    } }), Object.defineProperty(r, "ErrorFragment", { enumerable: !0, get: function() {
      return n.ErrorFragment;
    } }), Object.defineProperty(r, "EventFragment", { enumerable: !0, get: function() {
      return n.EventFragment;
    } }), Object.defineProperty(r, "FallbackFragment", { enumerable: !0, get: function() {
      return n.FallbackFragment;
    } }), Object.defineProperty(r, "Fragment", { enumerable: !0, get: function() {
      return n.Fragment;
    } }), Object.defineProperty(r, "FunctionFragment", { enumerable: !0, get: function() {
      return n.FunctionFragment;
    } }), Object.defineProperty(r, "NamedFragment", { enumerable: !0, get: function() {
      return n.NamedFragment;
    } }), Object.defineProperty(r, "ParamType", { enumerable: !0, get: function() {
      return n.ParamType;
    } }), Object.defineProperty(r, "StructFragment", { enumerable: !0, get: function() {
      return n.StructFragment;
    } });
    var s = Wv();
    Object.defineProperty(r, "checkResultErrors", { enumerable: !0, get: function() {
      return s.checkResultErrors;
    } }), Object.defineProperty(r, "Indexed", { enumerable: !0, get: function() {
      return s.Indexed;
    } }), Object.defineProperty(r, "Interface", { enumerable: !0, get: function() {
      return s.Interface;
    } }), Object.defineProperty(r, "ErrorDescription", { enumerable: !0, get: function() {
      return s.ErrorDescription;
    } }), Object.defineProperty(r, "LogDescription", { enumerable: !0, get: function() {
      return s.LogDescription;
    } }), Object.defineProperty(r, "TransactionDescription", { enumerable: !0, get: function() {
      return s.TransactionDescription;
    } }), Object.defineProperty(r, "Result", { enumerable: !0, get: function() {
      return s.Result;
    } });
    var i = Ws();
    Object.defineProperty(r, "Typed", { enumerable: !0, get: function() {
      return i.Typed;
    } });
  }(dp)), dp;
}
var vp = {}, on = {}, sr = {}, By;
function hf() {
  var g, k, A;
  if (By) return sr;
  By = 1, Object.defineProperty(sr, "__esModule", { value: !0 }), sr.TransactionResponse = sr.TransactionReceipt = sr.Log = sr.Block = sr.copyRequest = sr.FeeData = void 0;
  const r = Me(), e = Lr(), t = BigInt(0);
  function n(E) {
    return E ?? null;
  }
  function s(E) {
    return E == null ? null : E.toString();
  }
  class i {
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */
    constructor(m, N, T) {
      /**
       *  The gas price for legacy networks.
       */
      Q(this, "gasPrice");
      /**
       *  The maximum fee to pay per gas.
       *
       *  The base fee per gas is defined by the network and based on
       *  congestion, increasing the cost during times of heavy load
       *  and lowering when less busy.
       *
       *  The actual fee per gas will be the base fee for the block
       *  and the priority fee, up to the max fee per gas.
       *
       *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
       */
      Q(this, "maxFeePerGas");
      /**
       *  The additional amout to pay per gas to encourage a validator
       *  to include the transaction.
       *
       *  The purpose of this is to compensate the validator for the
       *  adjusted risk for including a given transaction.
       *
       *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
       */
      Q(this, "maxPriorityFeePerGas");
      (0, r.defineProperties)(this, {
        gasPrice: n(m),
        maxFeePerGas: n(N),
        maxPriorityFeePerGas: n(T)
      });
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { gasPrice: m, maxFeePerGas: N, maxPriorityFeePerGas: T } = this;
      return {
        _type: "FeeData",
        gasPrice: s(m),
        maxFeePerGas: s(N),
        maxPriorityFeePerGas: s(T)
      };
    }
  }
  sr.FeeData = i;
  function a(E) {
    const m = {};
    E.to && (m.to = E.to), E.from && (m.from = E.from), E.data && (m.data = (0, r.hexlify)(E.data));
    const N = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const U of N)
      !(U in E) || E[U] == null || (m[U] = (0, r.getBigInt)(E[U], `request.${U}`));
    const T = "type,nonce".split(/,/);
    for (const U of T)
      !(U in E) || E[U] == null || (m[U] = (0, r.getNumber)(E[U], `request.${U}`));
    return E.accessList && (m.accessList = (0, e.accessListify)(E.accessList)), "blockTag" in E && (m.blockTag = E.blockTag), "enableCcipRead" in E && (m.enableCcipRead = !!E.enableCcipRead), "customData" in E && (m.customData = E.customData), "blobVersionedHashes" in E && E.blobVersionedHashes && (m.blobVersionedHashes = E.blobVersionedHashes.slice()), "kzg" in E && (m.kzg = E.kzg), "blobs" in E && E.blobs && (m.blobs = E.blobs.map((U) => (0, r.isBytesLike)(U) ? (0, r.hexlify)(U) : Object.assign({}, U))), m;
  }
  sr.copyRequest = a;
  class o {
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */
    constructor(m, N) {
      /**
       *  The provider connected to the block used to fetch additional details
       *  if necessary.
       */
      Q(this, "provider");
      /**
       *  The block number, sometimes called the block height. This is a
       *  sequential number that is one higher than the parent block.
       */
      Q(this, "number");
      /**
       *  The block hash.
       *
       *  This hash includes all properties, so can be safely used to identify
       *  an exact set of block properties.
       */
      Q(this, "hash");
      /**
       *  The timestamp for this block, which is the number of seconds since
       *  epoch that this block was included.
       */
      Q(this, "timestamp");
      /**
       *  The block hash of the parent block.
       */
      Q(this, "parentHash");
      /**
       *  The hash tree root of the parent beacon block for the given
       *  execution block. See [[link-eip-4788]].
       */
      Q(this, "parentBeaconBlockRoot");
      /**
       *  The nonce.
       *
       *  On legacy networks, this is the random number inserted which
       *  permitted the difficulty target to be reached.
       */
      Q(this, "nonce");
      /**
       *  The difficulty target.
       *
       *  On legacy networks, this is the proof-of-work target required
       *  for a block to meet the protocol rules to be included.
       *
       *  On modern networks, this is a random number arrived at using
       *  randao.  @TODO: Find links?
       */
      Q(this, "difficulty");
      /**
       *  The total gas limit for this block.
       */
      Q(this, "gasLimit");
      /**
       *  The total gas used in this block.
       */
      Q(this, "gasUsed");
      /**
       *  The root hash for the global state after applying changes
       *  in this block.
       */
      Q(this, "stateRoot");
      /**
       *  The hash of the transaction receipts trie.
       */
      Q(this, "receiptsRoot");
      /**
       *  The total amount of blob gas consumed by the transactions
       *  within the block. See [[link-eip-4844]].
       */
      Q(this, "blobGasUsed");
      /**
       *  The running total of blob gas consumed in excess of the
       *  target, prior to the block. See [[link-eip-4844]].
       */
      Q(this, "excessBlobGas");
      /**
       *  The miner coinbase address, wihch receives any subsidies for
       *  including this block.
       */
      Q(this, "miner");
      /**
       *  The latest RANDAO mix of the post beacon state of
       *  the previous block.
       */
      Q(this, "prevRandao");
      /**
       *  Any extra data the validator wished to include.
       */
      Q(this, "extraData");
      /**
       *  The base fee per gas that all transactions in this block were
       *  charged.
       *
       *  This adjusts after each block, depending on how congested the network
       *  is.
       */
      Q(this, "baseFeePerGas");
      Z(this, g);
      F(this, g, m.transactions.map((T) => typeof T != "string" ? new l(T, N) : T)), (0, r.defineProperties)(this, {
        provider: N,
        hash: n(m.hash),
        number: m.number,
        timestamp: m.timestamp,
        parentHash: m.parentHash,
        parentBeaconBlockRoot: m.parentBeaconBlockRoot,
        nonce: m.nonce,
        difficulty: m.difficulty,
        gasLimit: m.gasLimit,
        gasUsed: m.gasUsed,
        blobGasUsed: m.blobGasUsed,
        excessBlobGas: m.excessBlobGas,
        miner: m.miner,
        prevRandao: n(m.prevRandao),
        extraData: m.extraData,
        baseFeePerGas: n(m.baseFeePerGas),
        stateRoot: m.stateRoot,
        receiptsRoot: m.receiptsRoot
      });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */
    get transactions() {
      return x(this, g).map((m) => typeof m == "string" ? m : m.hash);
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */
    get prefetchedTransactions() {
      const m = x(this, g).slice();
      return m.length === 0 ? [] : ((0, r.assert)(typeof m[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
        operation: "transactionResponses()"
      }), m);
    }
    /**
     *  Returns a JSON-friendly value.
     */
    toJSON() {
      const { baseFeePerGas: m, difficulty: N, extraData: T, gasLimit: U, gasUsed: R, hash: j, miner: D, prevRandao: O, nonce: I, number: P, parentHash: S, parentBeaconBlockRoot: B, stateRoot: C, receiptsRoot: H, timestamp: V, transactions: J } = this;
      return {
        _type: "Block",
        baseFeePerGas: s(m),
        difficulty: s(N),
        extraData: T,
        gasLimit: s(U),
        gasUsed: s(R),
        blobGasUsed: s(this.blobGasUsed),
        excessBlobGas: s(this.excessBlobGas),
        hash: j,
        miner: D,
        prevRandao: O,
        nonce: I,
        number: P,
        parentHash: S,
        timestamp: V,
        parentBeaconBlockRoot: B,
        stateRoot: C,
        receiptsRoot: H,
        transactions: J
      };
    }
    [Symbol.iterator]() {
      let m = 0;
      const N = this.transactions;
      return {
        next: () => m < this.length ? {
          value: N[m++],
          done: !1
        } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The number of transactions in this block.
     */
    get length() {
      return x(this, g).length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */
    get date() {
      return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */
    async getTransaction(m) {
      let N;
      if (typeof m == "number")
        N = x(this, g)[m];
      else {
        const T = m.toLowerCase();
        for (const U of x(this, g))
          if (typeof U == "string") {
            if (U !== T)
              continue;
            N = U;
            break;
          } else {
            if (U.hash === T)
              continue;
            N = U;
            break;
          }
      }
      if (N == null)
        throw new Error("no such tx");
      return typeof N == "string" ? await this.provider.getTransaction(N) : N;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */
    getPrefetchedTransaction(m) {
      const N = this.prefetchedTransactions;
      if (typeof m == "number")
        return N[m];
      m = m.toLowerCase();
      for (const T of N)
        if (T.hash === m)
          return T;
      (0, r.assertArgument)(!1, "no matching transaction", "indexOrHash", m);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */
    isMined() {
      return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */
    isLondon() {
      return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */
    orphanedEvent() {
      if (!this.isMined())
        throw new Error("");
      return f(this);
    }
  }
  g = new WeakMap(), sr.Block = o;
  class u {
    /**
     *  @_ignore:
     */
    constructor(m, N) {
      /**
       *  The provider connected to the log used to fetch additional details
       *  if necessary.
       */
      Q(this, "provider");
      /**
       *  The transaction hash of the transaction this log occurred in. Use the
       *  [[Log-getTransaction]] to get the [[TransactionResponse]].
       */
      Q(this, "transactionHash");
      /**
       *  The block hash of the block this log occurred in. Use the
       *  [[Log-getBlock]] to get the [[Block]].
       */
      Q(this, "blockHash");
      /**
       *  The block number of the block this log occurred in. It is preferred
       *  to use the [[Block-hash]] when fetching the related [[Block]],
       *  since in the case of an orphaned block, the block at that height may
       *  have changed.
       */
      Q(this, "blockNumber");
      /**
       *  If the **Log** represents a block that was removed due to an orphaned
       *  block, this will be true.
       *
       *  This can only happen within an orphan event listener.
       */
      Q(this, "removed");
      /**
       *  The address of the contract that emitted this log.
       */
      Q(this, "address");
      /**
       *  The data included in this log when it was emitted.
       */
      Q(this, "data");
      /**
       *  The indexed topics included in this log when it was emitted.
       *
       *  All topics are included in the bloom filters, so they can be
       *  efficiently filtered using the [[Provider-getLogs]] method.
       */
      Q(this, "topics");
      /**
       *  The index within the block this log occurred at. This is generally
       *  not useful to developers, but can be used with the various roots
       *  to proof inclusion within a block.
       */
      Q(this, "index");
      /**
       *  The index within the transaction of this log.
       */
      Q(this, "transactionIndex");
      this.provider = N;
      const T = Object.freeze(m.topics.slice());
      (0, r.defineProperties)(this, {
        transactionHash: m.transactionHash,
        blockHash: m.blockHash,
        blockNumber: m.blockNumber,
        removed: m.removed,
        address: m.address,
        data: m.data,
        topics: T,
        index: m.index,
        transactionIndex: m.transactionIndex
      });
    }
    /**
     *  Returns a JSON-compatible object.
     */
    toJSON() {
      const { address: m, blockHash: N, blockNumber: T, data: U, index: R, removed: j, topics: D, transactionHash: O, transactionIndex: I } = this;
      return {
        _type: "log",
        address: m,
        blockHash: N,
        blockNumber: T,
        data: U,
        index: R,
        removed: j,
        topics: D,
        transactionHash: O,
        transactionIndex: I
      };
    }
    /**
     *  Returns the block that this log occurred in.
     */
    async getBlock() {
      const m = await this.provider.getBlock(this.blockHash);
      return (0, r.assert)(!!m, "failed to find transaction", "UNKNOWN_ERROR", {}), m;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */
    async getTransaction() {
      const m = await this.provider.getTransaction(this.transactionHash);
      return (0, r.assert)(!!m, "failed to find transaction", "UNKNOWN_ERROR", {}), m;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */
    async getTransactionReceipt() {
      const m = await this.provider.getTransactionReceipt(this.transactionHash);
      return (0, r.assert)(!!m, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), m;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return p(this);
    }
  }
  sr.Log = u;
  class c {
    /**
     *  @_ignore:
     */
    constructor(m, N) {
      /**
       *  The provider connected to the log used to fetch additional details
       *  if necessary.
       */
      Q(this, "provider");
      /**
       *  The address the transaction was sent to.
       */
      Q(this, "to");
      /**
       *  The sender of the transaction.
       */
      Q(this, "from");
      /**
       *  The address of the contract if the transaction was directly
       *  responsible for deploying one.
       *
       *  This is non-null **only** if the ``to`` is empty and the ``data``
       *  was successfully executed as initcode.
       */
      Q(this, "contractAddress");
      /**
       *  The transaction hash.
       */
      Q(this, "hash");
      /**
       *  The index of this transaction within the block transactions.
       */
      Q(this, "index");
      /**
       *  The block hash of the [[Block]] this transaction was included in.
       */
      Q(this, "blockHash");
      /**
       *  The block number of the [[Block]] this transaction was included in.
       */
      Q(this, "blockNumber");
      /**
       *  The bloom filter bytes that represent all logs that occurred within
       *  this transaction. This is generally not useful for most developers,
       *  but can be used to validate the included logs.
       */
      Q(this, "logsBloom");
      /**
       *  The actual amount of gas used by this transaction.
       *
       *  When creating a transaction, the amount of gas that will be used can
       *  only be approximated, but the sender must pay the gas fee for the
       *  entire gas limit. After the transaction, the difference is refunded.
       */
      Q(this, "gasUsed");
      /**
       *  The gas used for BLObs. See [[link-eip-4844]].
       */
      Q(this, "blobGasUsed");
      /**
       *  The amount of gas used by all transactions within the block for this
       *  and all transactions with a lower ``index``.
       *
       *  This is generally not useful for developers but can be used to
       *  validate certain aspects of execution.
       */
      Q(this, "cumulativeGasUsed");
      /**
       *  The actual gas price used during execution.
       *
       *  Due to the complexity of [[link-eip-1559]] this value can only
       *  be caluclated after the transaction has been mined, snce the base
       *  fee is protocol-enforced.
       */
      Q(this, "gasPrice");
      /**
       *  The price paid per BLOB in gas. See [[link-eip-4844]].
       */
      Q(this, "blobGasPrice");
      /**
       *  The [[link-eip-2718]] transaction type.
       */
      Q(this, "type");
      //readonly byzantium!: boolean;
      /**
       *  The status of this transaction, indicating success (i.e. ``1``) or
       *  a revert (i.e. ``0``).
       *
       *  This is available in post-byzantium blocks, but some backends may
       *  backfill this value.
       */
      Q(this, "status");
      /**
       *  The root hash of this transaction.
       *
       *  This is no present and was only included in pre-byzantium blocks, but
       *  could be used to validate certain parts of the receipt.
       */
      Q(this, "root");
      Z(this, k);
      F(this, k, Object.freeze(m.logs.map((U) => new u(U, N))));
      let T = t;
      m.effectiveGasPrice != null ? T = m.effectiveGasPrice : m.gasPrice != null && (T = m.gasPrice), (0, r.defineProperties)(this, {
        provider: N,
        to: m.to,
        from: m.from,
        contractAddress: m.contractAddress,
        hash: m.hash,
        index: m.index,
        blockHash: m.blockHash,
        blockNumber: m.blockNumber,
        logsBloom: m.logsBloom,
        gasUsed: m.gasUsed,
        cumulativeGasUsed: m.cumulativeGasUsed,
        blobGasUsed: m.blobGasUsed,
        gasPrice: T,
        blobGasPrice: m.blobGasPrice,
        type: m.type,
        //byzantium: tx.byzantium,
        status: m.status,
        root: m.root
      });
    }
    /**
     *  The logs for this transaction.
     */
    get logs() {
      return x(this, k);
    }
    /**
     *  Returns a JSON-compatible representation.
     */
    toJSON() {
      const {
        to: m,
        from: N,
        contractAddress: T,
        hash: U,
        index: R,
        blockHash: j,
        blockNumber: D,
        logsBloom: O,
        logs: I,
        //byzantium, 
        status: P,
        root: S
      } = this;
      return {
        _type: "TransactionReceipt",
        blockHash: j,
        blockNumber: D,
        //byzantium, 
        contractAddress: T,
        cumulativeGasUsed: s(this.cumulativeGasUsed),
        from: N,
        gasPrice: s(this.gasPrice),
        blobGasUsed: s(this.blobGasUsed),
        blobGasPrice: s(this.blobGasPrice),
        gasUsed: s(this.gasUsed),
        hash: U,
        index: R,
        logs: I,
        logsBloom: O,
        root: S,
        status: P,
        to: m
      };
    }
    /**
     *  @_ignore:
     */
    get length() {
      return this.logs.length;
    }
    [Symbol.iterator]() {
      let m = 0;
      return {
        next: () => m < this.length ? { value: this.logs[m++], done: !1 } : { value: void 0, done: !0 }
      };
    }
    /**
     *  The total fee for this transaction, in wei.
     */
    get fee() {
      return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */
    async getBlock() {
      const m = await this.provider.getBlock(this.blockHash);
      if (m == null)
        throw new Error("TODO");
      return m;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */
    async getTransaction() {
      const m = await this.provider.getTransaction(this.hash);
      if (m == null)
        throw new Error("TODO");
      return m;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */
    async getResult() {
      return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */
    async confirmations() {
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return h(this);
    }
    /**
     *  @_ignore:
     */
    reorderedEvent(m) {
      return (0, r.assert)(!m || m.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), d(this, m);
    }
  }
  k = new WeakMap(), sr.TransactionReceipt = c;
  const y = class y {
    /**
     *  @_ignore:
     */
    constructor(m, N) {
      /**
       *  The provider this is connected to, which will influence how its
       *  methods will resolve its async inspection methods.
       */
      Q(this, "provider");
      /**
       *  The block number of the block that this transaction was included in.
       *
       *  This is ``null`` for pending transactions.
       */
      Q(this, "blockNumber");
      /**
       *  The blockHash of the block that this transaction was included in.
       *
       *  This is ``null`` for pending transactions.
       */
      Q(this, "blockHash");
      /**
       *  The index within the block that this transaction resides at.
       */
      Q(this, "index");
      /**
       *  The transaction hash.
       */
      Q(this, "hash");
      /**
       *  The [[link-eip-2718]] transaction envelope type. This is
       *  ``0`` for legacy transactions types.
       */
      Q(this, "type");
      /**
       *  The receiver of this transaction.
       *
       *  If ``null``, then the transaction is an initcode transaction.
       *  This means the result of executing the [[data]] will be deployed
       *  as a new contract on chain (assuming it does not revert) and the
       *  address may be computed using [[getCreateAddress]].
       */
      Q(this, "to");
      /**
       *  The sender of this transaction. It is implicitly computed
       *  from the transaction pre-image hash (as the digest) and the
       *  [[signature]] using ecrecover.
       */
      Q(this, "from");
      /**
       *  The nonce, which is used to prevent replay attacks and offer
       *  a method to ensure transactions from a given sender are explicitly
       *  ordered.
       *
       *  When sending a transaction, this must be equal to the number of
       *  transactions ever sent by [[from]].
       */
      Q(this, "nonce");
      /**
       *  The maximum units of gas this transaction can consume. If execution
       *  exceeds this, the entries transaction is reverted and the sender
       *  is charged for the full amount, despite not state changes being made.
       */
      Q(this, "gasLimit");
      /**
       *  The gas price can have various values, depending on the network.
       *
       *  In modern networks, for transactions that are included this is
       *  the //effective gas price// (the fee per gas that was actually
       *  charged), while for transactions that have not been included yet
       *  is the [[maxFeePerGas]].
       *
       *  For legacy transactions, or transactions on legacy networks, this
       *  is the fee that will be charged per unit of gas the transaction
       *  consumes.
       */
      Q(this, "gasPrice");
      /**
       *  The maximum priority fee (per unit of gas) to allow a
       *  validator to charge the sender. This is inclusive of the
       *  [[maxFeeFeePerGas]].
       */
      Q(this, "maxPriorityFeePerGas");
      /**
       *  The maximum fee (per unit of gas) to allow this transaction
       *  to charge the sender.
       */
      Q(this, "maxFeePerGas");
      /**
       *  The [[link-eip-4844]] max fee per BLOb gas.
       */
      Q(this, "maxFeePerBlobGas");
      /**
       *  The data.
       */
      Q(this, "data");
      /**
       *  The value, in wei. Use [[formatEther]] to format this value
       *  as ether.
       */
      Q(this, "value");
      /**
       *  The chain ID.
       */
      Q(this, "chainId");
      /**
       *  The signature.
       */
      Q(this, "signature");
      /**
       *  The [[link-eip-2930]] access list for transaction types that
       *  support it, otherwise ``null``.
       */
      Q(this, "accessList");
      /**
       *  The [[link-eip-4844]] BLOb versioned hashes.
       */
      Q(this, "blobVersionedHashes");
      Z(this, A);
      this.provider = N, this.blockNumber = m.blockNumber != null ? m.blockNumber : null, this.blockHash = m.blockHash != null ? m.blockHash : null, this.hash = m.hash, this.index = m.index, this.type = m.type, this.from = m.from, this.to = m.to || null, this.gasLimit = m.gasLimit, this.nonce = m.nonce, this.data = m.data, this.value = m.value, this.gasPrice = m.gasPrice, this.maxPriorityFeePerGas = m.maxPriorityFeePerGas != null ? m.maxPriorityFeePerGas : null, this.maxFeePerGas = m.maxFeePerGas != null ? m.maxFeePerGas : null, this.maxFeePerBlobGas = m.maxFeePerBlobGas != null ? m.maxFeePerBlobGas : null, this.chainId = m.chainId, this.signature = m.signature, this.accessList = m.accessList != null ? m.accessList : null, this.blobVersionedHashes = m.blobVersionedHashes != null ? m.blobVersionedHashes : null, F(this, A, -1);
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */
    toJSON() {
      const { blockNumber: m, blockHash: N, index: T, hash: U, type: R, to: j, from: D, nonce: O, data: I, signature: P, accessList: S, blobVersionedHashes: B } = this;
      return {
        _type: "TransactionResponse",
        accessList: S,
        blockNumber: m,
        blockHash: N,
        blobVersionedHashes: B,
        chainId: s(this.chainId),
        data: I,
        from: D,
        gasLimit: s(this.gasLimit),
        gasPrice: s(this.gasPrice),
        hash: U,
        maxFeePerGas: s(this.maxFeePerGas),
        maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
        maxFeePerBlobGas: s(this.maxFeePerBlobGas),
        nonce: O,
        signature: P,
        to: j,
        index: T,
        type: R,
        value: s(this.value)
      };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */
    async getBlock() {
      let m = this.blockNumber;
      if (m == null) {
        const T = await this.getTransaction();
        T && (m = T.blockNumber);
      }
      if (m == null)
        return null;
      const N = this.provider.getBlock(m);
      if (N == null)
        throw new Error("TODO");
      return N;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */
    async getTransaction() {
      return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */
    async confirmations() {
      if (this.blockNumber == null) {
        const { tx: N, blockNumber: T } = await (0, r.resolveProperties)({
          tx: this.getTransaction(),
          blockNumber: this.provider.getBlockNumber()
        });
        return N == null || N.blockNumber == null ? 0 : T - N.blockNumber + 1;
      }
      return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(m, N) {
      const T = m ?? 1, U = N ?? 0;
      let R = x(this, A), j = -1, D = R === -1;
      const O = async () => {
        if (D)
          return null;
        const { blockNumber: B, nonce: C } = await (0, r.resolveProperties)({
          blockNumber: this.provider.getBlockNumber(),
          nonce: this.provider.getTransactionCount(this.from)
        });
        if (C < this.nonce) {
          R = B;
          return;
        }
        if (D)
          return null;
        const H = await this.getTransaction();
        if (!(H && H.blockNumber != null))
          for (j === -1 && (j = R - 3, j < x(this, A) && (j = x(this, A))); j <= B; ) {
            if (D)
              return null;
            const V = await this.provider.getBlock(j, !0);
            if (V == null)
              return;
            for (const J of V)
              if (J === this.hash)
                return;
            for (let J = 0; J < V.length; J++) {
              const M = await V.getTransaction(J);
              if (M.from === this.from && M.nonce === this.nonce) {
                if (D)
                  return null;
                const G = await this.provider.getTransactionReceipt(M.hash);
                if (G == null || B - G.blockNumber + 1 < T)
                  return;
                let K = "replaced";
                M.data === this.data && M.to === this.to && M.value === this.value ? K = "repriced" : M.data === "0x" && M.from === M.to && M.value === t && (K = "cancelled"), (0, r.assert)(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                  cancelled: K === "replaced" || K === "cancelled",
                  reason: K,
                  replacement: M.replaceableTransaction(R),
                  hash: M.hash,
                  receipt: G
                });
              }
            }
            j++;
          }
      }, I = (B) => {
        if (B == null || B.status !== 0)
          return B;
        (0, r.assert)(!1, "transaction execution reverted", "CALL_EXCEPTION", {
          action: "sendTransaction",
          data: null,
          reason: null,
          invocation: null,
          revert: null,
          transaction: {
            to: B.to,
            from: B.from,
            data: ""
            // @TODO: in v7, split out sendTransaction properties
          },
          receipt: B
        });
      }, P = await this.provider.getTransactionReceipt(this.hash);
      if (T === 0)
        return I(P);
      if (P) {
        if (await P.confirmations() >= T)
          return I(P);
      } else if (await O(), T === 0)
        return null;
      return await new Promise((B, C) => {
        const H = [], V = () => {
          H.forEach((M) => M());
        };
        if (H.push(() => {
          D = !0;
        }), U > 0) {
          const M = setTimeout(() => {
            V(), C((0, r.makeError)("wait for transaction timeout", "TIMEOUT"));
          }, U);
          H.push(() => {
            clearTimeout(M);
          });
        }
        const J = async (M) => {
          if (await M.confirmations() >= T) {
            V();
            try {
              B(I(M));
            } catch (G) {
              C(G);
            }
          }
        };
        if (H.push(() => {
          this.provider.off(this.hash, J);
        }), this.provider.on(this.hash, J), R >= 0) {
          const M = async () => {
            try {
              await O();
            } catch (G) {
              if ((0, r.isError)(G, "TRANSACTION_REPLACED")) {
                V(), C(G);
                return;
              }
            }
            D || this.provider.once("block", M);
          };
          H.push(() => {
            this.provider.off("block", M);
          }), this.provider.once("block", M);
        }
      });
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */
    isMined() {
      return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */
    removedEvent() {
      return (0, r.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), h(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */
    reorderedEvent(m) {
      return (0, r.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), (0, r.assert)(!m || m.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), d(this, m);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */
    replaceableTransaction(m) {
      (0, r.assertArgument)(Number.isInteger(m) && m >= 0, "invalid startBlock", "startBlock", m);
      const N = new y(this, this.provider);
      return F(N, A, m), N;
    }
  };
  A = new WeakMap();
  let l = y;
  sr.TransactionResponse = l;
  function f(E) {
    return { orphan: "drop-block", hash: E.hash, number: E.number };
  }
  function d(E, m) {
    return { orphan: "reorder-transaction", tx: E, other: m };
  }
  function h(E) {
    return { orphan: "drop-transaction", tx: E };
  }
  function p(E) {
    return { orphan: "drop-log", log: {
      transactionHash: E.transactionHash,
      blockHash: E.blockHash,
      blockNumber: E.blockNumber,
      address: E.address,
      data: E.data,
      topics: Object.freeze(E.topics.slice()),
      index: E.index
    } };
  }
  return sr;
}
var ir = {}, Oy;
function c6() {
  var u, c;
  if (Oy) return ir;
  Oy = 1, Object.defineProperty(ir, "__esModule", { value: !0 }), ir.ContractEventPayload = ir.ContractUnknownEventPayload = ir.ContractTransactionResponse = ir.ContractTransactionReceipt = ir.UndecodedEventLog = ir.EventLog = void 0;
  const r = hf(), e = Me();
  class t extends r.Log {
    /**
     * @_ignore:
     */
    constructor(d, h, p) {
      super(d, d.provider);
      /**
       *  The Contract Interface.
       */
      Q(this, "interface");
      /**
       *  The matching event.
       */
      Q(this, "fragment");
      /**
       *  The parsed arguments passed to the event by ``emit``.
       */
      Q(this, "args");
      const g = h.decodeEventLog(p, d.data, d.topics);
      (0, e.defineProperties)(this, { args: g, fragment: p, interface: h });
    }
    /**
     *  The name of the event.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  ir.EventLog = t;
  class n extends r.Log {
    /**
     * @_ignore:
     */
    constructor(d, h) {
      super(d, d.provider);
      /**
       *  The error encounted when trying to decode the log.
       */
      Q(this, "error");
      (0, e.defineProperties)(this, { error: h });
    }
  }
  ir.UndecodedEventLog = n;
  class s extends r.TransactionReceipt {
    /**
     *  @_ignore:
     */
    constructor(d, h, p) {
      super(p, h);
      Z(this, u);
      F(this, u, d);
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */
    get logs() {
      return super.logs.map((d) => {
        const h = d.topics.length ? x(this, u).getEvent(d.topics[0]) : null;
        if (h)
          try {
            return new t(d, x(this, u), h);
          } catch (p) {
            return new n(d, p);
          }
        return d;
      });
    }
  }
  u = new WeakMap(), ir.ContractTransactionReceipt = s;
  class i extends r.TransactionResponse {
    /**
     *  @_ignore:
     */
    constructor(d, h, p) {
      super(p, h);
      Z(this, c);
      F(this, c, d);
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(d, h) {
      const p = await super.wait(d, h);
      return p == null ? null : new s(x(this, c), this.provider, p);
    }
  }
  c = new WeakMap(), ir.ContractTransactionResponse = i;
  class a extends e.EventPayload {
    /**
     *  @_event:
     */
    constructor(d, h, p, g) {
      super(d, h, p);
      /**
       *  The log with no matching events.
       */
      Q(this, "log");
      (0, e.defineProperties)(this, { log: g });
    }
    /**
     *  Resolves to the block the event occured in.
     */
    async getBlock() {
      return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */
    async getTransaction() {
      return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */
    async getTransactionReceipt() {
      return await this.log.getTransactionReceipt();
    }
  }
  ir.ContractUnknownEventPayload = a;
  class o extends a {
    /**
     *  @_ignore:
     */
    constructor(f, d, h, p, g) {
      super(f, d, h, new t(g, f.interface, p));
      const k = f.interface.decodeEventLog(p, this.log.data, this.log.topics);
      (0, e.defineProperties)(this, { args: k, fragment: p });
    }
    /**
     *  The event name.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The event signature.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  }
  return ir.ContractEventPayload = o, ir;
}
var Ny;
function u6() {
  var V, J;
  if (Ny) return on;
  Ny = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.Contract = on.BaseContract = on.resolveArgs = on.copyOverrides = void 0;
  const r = df(), e = zt(), t = hf(), n = Me(), s = c6(), i = BigInt(0);
  function a(G) {
    return G && typeof G.call == "function";
  }
  function o(G) {
    return G && typeof G.estimateGas == "function";
  }
  function u(G) {
    return G && typeof G.resolveName == "function";
  }
  function c(G) {
    return G && typeof G.sendTransaction == "function";
  }
  function l(G) {
    if (G != null) {
      if (u(G))
        return G;
      if (G.provider)
        return G.provider;
    }
  }
  class f {
    constructor(K, X, te) {
      Z(this, V);
      Q(this, "fragment");
      if ((0, n.defineProperties)(this, { fragment: X }), X.inputs.length < te.length)
        throw new Error("too many arguments");
      const pe = d(K.runner, "resolveName"), he = u(pe) ? pe : null;
      F(this, V, async function() {
        const ye = await Promise.all(X.inputs.map((re, ae) => te[ae] == null ? null : re.walkAsync(te[ae], (ne, oe) => ne === "address" ? Array.isArray(oe) ? Promise.all(oe.map((ee) => (0, e.resolveAddress)(ee, he))) : (0, e.resolveAddress)(oe, he) : oe)));
        return K.interface.encodeFilterTopics(X, ye);
      }());
    }
    getTopicFilter() {
      return x(this, V);
    }
  }
  V = new WeakMap();
  function d(G, K) {
    return G == null ? null : typeof G[K] == "function" ? G : G.provider && typeof G.provider[K] == "function" ? G.provider : null;
  }
  function h(G) {
    return G == null ? null : G.provider || null;
  }
  async function p(G, K) {
    const X = r.Typed.dereference(G, "overrides");
    (0, n.assertArgument)(typeof X == "object", "invalid overrides parameter", "overrides", G);
    const te = (0, t.copyRequest)(X);
    return (0, n.assertArgument)(te.to == null || (K || []).indexOf("to") >= 0, "cannot override to", "overrides.to", te.to), (0, n.assertArgument)(te.data == null || (K || []).indexOf("data") >= 0, "cannot override data", "overrides.data", te.data), te.from && (te.from = te.from), te;
  }
  on.copyOverrides = p;
  async function g(G, K, X) {
    const te = d(G, "resolveName"), pe = u(te) ? te : null;
    return await Promise.all(K.map((he, ye) => he.walkAsync(X[ye], (re, ae) => (ae = r.Typed.dereference(ae, re), re === "address" ? (0, e.resolveAddress)(ae, pe) : ae))));
  }
  on.resolveArgs = g;
  function k(G) {
    const K = async function(ye) {
      const re = await p(ye, ["data"]);
      re.to = await G.getAddress(), re.from && (re.from = await (0, e.resolveAddress)(re.from, l(G.runner)));
      const ae = G.interface, L = (0, n.getBigInt)(re.value || i, "overrides.value") === i, ne = (re.data || "0x") === "0x";
      ae.fallback && !ae.fallback.payable && ae.receive && !ne && !L && (0, n.assertArgument)(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", ye), (0, n.assertArgument)(ae.fallback || ne, "cannot send data to receive-only contract", "overrides.data", re.data);
      const oe = ae.receive || ae.fallback && ae.fallback.payable;
      return (0, n.assertArgument)(oe || L, "cannot send value to non-payable fallback", "overrides.value", re.value), (0, n.assertArgument)(ae.fallback || ne, "cannot send data to receive-only contract", "overrides.data", re.data), re;
    }, X = async function(ye) {
      const re = d(G.runner, "call");
      (0, n.assert)(a(re), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const ae = await K(ye);
      try {
        return await re.call(ae);
      } catch (L) {
        throw (0, n.isCallException)(L) && L.data ? G.interface.makeError(L.data, ae) : L;
      }
    }, te = async function(ye) {
      const re = G.runner;
      (0, n.assert)(c(re), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const ae = await re.sendTransaction(await K(ye)), L = h(G.runner);
      return new s.ContractTransactionResponse(G.interface, L, ae);
    }, pe = async function(ye) {
      const re = d(G.runner, "estimateGas");
      return (0, n.assert)(o(re), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await re.estimateGas(await K(ye));
    }, he = async (ye) => await te(ye);
    return (0, n.defineProperties)(he, {
      _contract: G,
      estimateGas: pe,
      populateTransaction: K,
      send: te,
      staticCall: X
    }), he;
  }
  function A(G, K) {
    const X = function(...L) {
      const ne = G.interface.getFunction(K, L);
      return (0, n.assert)(ne, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: K, args: L }
      }), ne;
    }, te = async function(...L) {
      const ne = X(...L);
      let oe = {};
      if (ne.inputs.length + 1 === L.length && (oe = await p(L.pop()), oe.from && (oe.from = await (0, e.resolveAddress)(oe.from, l(G.runner)))), ne.inputs.length !== L.length)
        throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
      const ee = await g(G.runner, ne.inputs, L);
      return Object.assign({}, oe, await (0, n.resolveProperties)({
        to: G.getAddress(),
        data: G.interface.encodeFunctionData(ne, ee)
      }));
    }, pe = async function(...L) {
      const ne = await re(...L);
      return ne.length === 1 ? ne[0] : ne;
    }, he = async function(...L) {
      const ne = G.runner;
      (0, n.assert)(c(ne), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
      const oe = await ne.sendTransaction(await te(...L)), ee = h(G.runner);
      return new s.ContractTransactionResponse(G.interface, ee, oe);
    }, ye = async function(...L) {
      const ne = d(G.runner, "estimateGas");
      return (0, n.assert)(o(ne), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await ne.estimateGas(await te(...L));
    }, re = async function(...L) {
      const ne = d(G.runner, "call");
      (0, n.assert)(a(ne), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
      const oe = await te(...L);
      let ee = "0x";
      try {
        ee = await ne.call(oe);
      } catch (v) {
        throw (0, n.isCallException)(v) && v.data ? G.interface.makeError(v.data, oe) : v;
      }
      const W = X(...L);
      return G.interface.decodeFunctionResult(W, ee);
    }, ae = async (...L) => X(...L).constant ? await pe(...L) : await he(...L);
    return (0, n.defineProperties)(ae, {
      name: G.interface.getFunctionName(K),
      _contract: G,
      _key: K,
      getFragment: X,
      estimateGas: ye,
      populateTransaction: te,
      send: he,
      staticCall: pe,
      staticCallResult: re
    }), Object.defineProperty(ae, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const L = G.interface.getFunction(K);
        return (0, n.assert)(L, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: K }
        }), L;
      }
    }), ae;
  }
  function y(G, K) {
    const X = function(...pe) {
      const he = G.interface.getEvent(K, pe);
      return (0, n.assert)(he, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: K, args: pe }
      }), he;
    }, te = function(...pe) {
      return new f(G, X(...pe), pe);
    };
    return (0, n.defineProperties)(te, {
      name: G.interface.getEventName(K),
      _contract: G,
      _key: K,
      getFragment: X
    }), Object.defineProperty(te, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const pe = G.interface.getEvent(K);
        return (0, n.assert)(pe, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: { key: K }
        }), pe;
      }
    }), te;
  }
  const E = Symbol.for("_ethersInternal_contract"), m = /* @__PURE__ */ new WeakMap();
  function N(G, K) {
    m.set(G[E], K);
  }
  function T(G) {
    return m.get(G[E]);
  }
  function U(G) {
    return G && typeof G == "object" && "getTopicFilter" in G && typeof G.getTopicFilter == "function" && G.fragment;
  }
  async function R(G, K) {
    let X, te = null;
    if (Array.isArray(K)) {
      const he = function(ye) {
        if ((0, n.isHexString)(ye, 32))
          return ye;
        const re = G.interface.getEvent(ye);
        return (0, n.assertArgument)(re, "unknown fragment", "name", ye), re.topicHash;
      };
      X = K.map((ye) => ye == null ? null : Array.isArray(ye) ? ye.map(he) : he(ye));
    } else K === "*" ? X = [null] : typeof K == "string" ? (0, n.isHexString)(K, 32) ? X = [K] : (te = G.interface.getEvent(K), (0, n.assertArgument)(te, "unknown fragment", "event", K), X = [te.topicHash]) : U(K) ? X = await K.getTopicFilter() : "fragment" in K ? (te = K.fragment, X = [te.topicHash]) : (0, n.assertArgument)(!1, "unknown event name", "event", K);
    X = X.map((he) => {
      if (he == null)
        return null;
      if (Array.isArray(he)) {
        const ye = Array.from(new Set(he.map((re) => re.toLowerCase())).values());
        return ye.length === 1 ? ye[0] : (ye.sort(), ye);
      }
      return he.toLowerCase();
    });
    const pe = X.map((he) => he == null ? "null" : Array.isArray(he) ? he.join("|") : he).join("&");
    return { fragment: te, tag: pe, topics: X };
  }
  async function j(G, K) {
    const { subs: X } = T(G);
    return X.get((await R(G, K)).tag) || null;
  }
  async function D(G, K, X) {
    const te = h(G.runner);
    (0, n.assert)(te, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: K });
    const { fragment: pe, tag: he, topics: ye } = await R(G, X), { addr: re, subs: ae } = T(G);
    let L = ae.get(he);
    if (!L) {
      const oe = { address: re || G, topics: ye }, ee = (q) => {
        let le = pe;
        if (le == null)
          try {
            le = G.interface.getEvent(q.topics[0]);
          } catch {
          }
        if (le) {
          const be = le, ve = pe ? G.interface.decodeEventLog(pe, q.data, q.topics) : [];
          P(G, X, ve, (Be) => new s.ContractEventPayload(G, Be, X, be, q));
        } else
          P(G, X, [], (be) => new s.ContractUnknownEventPayload(G, be, X, q));
      };
      let W = [];
      L = { tag: he, listeners: [], start: () => {
        W.length || W.push(te.on(oe, ee));
      }, stop: async () => {
        if (W.length == 0)
          return;
        let q = W;
        W = [], await Promise.all(q), te.off(oe, ee);
      } }, ae.set(he, L);
    }
    return L;
  }
  let O = Promise.resolve();
  async function I(G, K, X, te) {
    await O;
    const pe = await j(G, K);
    if (!pe)
      return !1;
    const he = pe.listeners.length;
    return pe.listeners = pe.listeners.filter(({ listener: ye, once: re }) => {
      const ae = Array.from(X);
      te && ae.push(te(re ? null : ye));
      try {
        ye.call(G, ...ae);
      } catch {
      }
      return !re;
    }), pe.listeners.length === 0 && (pe.stop(), T(G).subs.delete(pe.tag)), he > 0;
  }
  async function P(G, K, X, te) {
    try {
      await O;
    } catch {
    }
    const pe = I(G, K, X, te);
    return O = pe, await pe;
  }
  const S = ["then"];
  J = E;
  const M = class M {
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */
    constructor(K, X, te, pe) {
      /**
       *  The target to connect to.
       *
       *  This can be an address, ENS name or any [[Addressable]], such as
       *  another contract. To get the resovled address, use the ``getAddress``
       *  method.
       */
      Q(this, "target");
      /**
       *  The contract Interface.
       */
      Q(this, "interface");
      /**
       *  The connected runner. This is generally a [[Provider]] or a
       *  [[Signer]], which dictates what operations are supported.
       *
       *  For example, a **Contract** connected to a [[Provider]] may
       *  only execute read-only operations.
       */
      Q(this, "runner");
      /**
       *  All the Events available on this contract.
       */
      Q(this, "filters");
      /**
       *  @_ignore:
       */
      Q(this, J);
      /**
       *  The fallback or receive function if any.
       */
      Q(this, "fallback");
      (0, n.assertArgument)(typeof K == "string" || (0, e.isAddressable)(K), "invalid value for Contract target", "target", K), te == null && (te = null);
      const he = r.Interface.from(X);
      (0, n.defineProperties)(this, { target: K, runner: te, interface: he }), Object.defineProperty(this, E, { value: {} });
      let ye, re = null, ae = null;
      if (pe) {
        const oe = h(te);
        ae = new s.ContractTransactionResponse(this.interface, oe, pe);
      }
      let L = /* @__PURE__ */ new Map();
      if (typeof K == "string")
        if ((0, n.isHexString)(K))
          re = K, ye = Promise.resolve(K);
        else {
          const oe = d(te, "resolveName");
          if (!u(oe))
            throw (0, n.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
              operation: "resolveName"
            });
          ye = oe.resolveName(K).then((ee) => {
            if (ee == null)
              throw (0, n.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                value: K
              });
            return T(this).addr = ee, ee;
          });
        }
      else
        ye = K.getAddress().then((oe) => {
          if (oe == null)
            throw new Error("TODO");
          return T(this).addr = oe, oe;
        });
      N(this, { addrPromise: ye, addr: re, deployTx: ae, subs: L });
      const ne = new Proxy({}, {
        get: (oe, ee, W) => {
          if (typeof ee == "symbol" || S.indexOf(ee) >= 0)
            return Reflect.get(oe, ee, W);
          try {
            return this.getEvent(ee);
          } catch (v) {
            if (!(0, n.isError)(v, "INVALID_ARGUMENT") || v.argument !== "key")
              throw v;
          }
        },
        has: (oe, ee) => S.indexOf(ee) >= 0 ? Reflect.has(oe, ee) : Reflect.has(oe, ee) || this.interface.hasEvent(String(ee))
      });
      return (0, n.defineProperties)(this, { filters: ne }), (0, n.defineProperties)(this, {
        fallback: he.receive || he.fallback ? k(this) : null
      }), new Proxy(this, {
        get: (oe, ee, W) => {
          if (typeof ee == "symbol" || ee in oe || S.indexOf(ee) >= 0)
            return Reflect.get(oe, ee, W);
          try {
            return oe.getFunction(ee);
          } catch (v) {
            if (!(0, n.isError)(v, "INVALID_ARGUMENT") || v.argument !== "key")
              throw v;
          }
        },
        has: (oe, ee) => typeof ee == "symbol" || ee in oe || S.indexOf(ee) >= 0 ? Reflect.has(oe, ee) : oe.interface.hasFunction(ee)
      });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */
    connect(K) {
      return new M(this.target, this.interface, K);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */
    attach(K) {
      return new M(K, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */
    async getAddress() {
      return await T(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */
    async getDeployedCode() {
      const K = h(this.runner);
      (0, n.assert)(K, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
      const X = await K.getCode(await this.getAddress());
      return X === "0x" ? null : X;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */
    async waitForDeployment() {
      const K = this.deploymentTransaction();
      if (K)
        return await K.wait(), this;
      if (await this.getDeployedCode() != null)
        return this;
      const te = h(this.runner);
      return (0, n.assert)(te != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((pe, he) => {
        const ye = async () => {
          try {
            if (await this.getDeployedCode() != null)
              return pe(this);
            te.once("block", ye);
          } catch (re) {
            he(re);
          }
        };
        ye();
      });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */
    deploymentTransaction() {
      return T(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getFunction(K) {
      return typeof K != "string" && (K = K.format()), A(this, K);
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getEvent(K) {
      return typeof K != "string" && (K = K.format()), y(this, K);
    }
    /**
     *  @_ignore:
     */
    async queryTransaction(K) {
      throw new Error("@TODO");
    }
    /*
    	    // @TODO: this is a non-backwards compatible change, but will be added
    	    //        in v7 and in a potential SmartContract class in an upcoming
    	    //        v6 release
    	    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
    	        const provider = getProvider(this.runner);
    	        assert(provider, "contract runner does not have a provider",
    	            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
    
    	        const receipt = await provider.getTransactionReceipt(hash);
    	        if (receipt == null) { return null; }
    
    	        return new ContractTransactionReceipt(this.interface, provider, receipt);
    	    }
    	    */
    /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */
    async queryFilter(K, X, te) {
      X == null && (X = 0), te == null && (te = "latest");
      const { addr: pe, addrPromise: he } = T(this), ye = pe || await he, { fragment: re, topics: ae } = await R(this, K), L = { address: ye, topics: ae, fromBlock: X, toBlock: te }, ne = h(this.runner);
      return (0, n.assert)(ne, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await ne.getLogs(L)).map((oe) => {
        let ee = re;
        if (ee == null)
          try {
            ee = this.interface.getEvent(oe.topics[0]);
          } catch {
          }
        if (ee)
          try {
            return new s.EventLog(oe, this.interface, ee);
          } catch (W) {
            return new s.UndecodedEventLog(oe, W);
          }
        return new t.Log(oe, ne);
      });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */
    async on(K, X) {
      const te = await D(this, "on", K);
      return te.listeners.push({ listener: X, once: !1 }), te.start(), this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */
    async once(K, X) {
      const te = await D(this, "once", K);
      return te.listeners.push({ listener: X, once: !0 }), te.start(), this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */
    async emit(K, ...X) {
      return await P(this, K, X, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */
    async listenerCount(K) {
      if (K) {
        const pe = await j(this, K);
        return pe ? pe.listeners.length : 0;
      }
      const { subs: X } = T(this);
      let te = 0;
      for (const { listeners: pe } of X.values())
        te += pe.length;
      return te;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */
    async listeners(K) {
      if (K) {
        const pe = await j(this, K);
        return pe ? pe.listeners.map(({ listener: he }) => he) : [];
      }
      const { subs: X } = T(this);
      let te = [];
      for (const { listeners: pe } of X.values())
        te = te.concat(pe.map(({ listener: he }) => he));
      return te;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */
    async off(K, X) {
      const te = await j(this, K);
      if (!te)
        return this;
      if (X) {
        const pe = te.listeners.map(({ listener: he }) => he).indexOf(X);
        pe >= 0 && te.listeners.splice(pe, 1);
      }
      return (X == null || te.listeners.length === 0) && (te.stop(), T(this).subs.delete(te.tag)), this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */
    async removeAllListeners(K) {
      if (K) {
        const X = await j(this, K);
        if (!X)
          return this;
        X.stop(), T(this).subs.delete(X.tag);
      } else {
        const { subs: X } = T(this);
        for (const { tag: te, stop: pe } of X.values())
          pe(), X.delete(te);
      }
      return this;
    }
    /**
     *  Alias for [on].
     */
    async addListener(K, X) {
      return await this.on(K, X);
    }
    /**
     *  Alias for [off].
     */
    async removeListener(K, X) {
      return await this.off(K, X);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */
    static buildClass(K) {
      class X extends M {
        constructor(pe, he = null) {
          super(pe, K, he);
        }
      }
      return X;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */
    static from(K, X, te) {
      return te == null && (te = null), new this(K, X, te);
    }
  };
  let B = M;
  on.BaseContract = B;
  function C() {
    return B;
  }
  class H extends C() {
  }
  return on.Contract = H, on;
}
var Pl = {}, Sy;
function Yv() {
  if (Sy) return Pl;
  Sy = 1, Object.defineProperty(Pl, "__esModule", { value: !0 }), Pl.ContractFactory = void 0;
  const r = df(), e = zt(), t = Me(), n = u6();
  class s {
    /**
     *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
     *  optionally connected to %%runner%%.
     *
     *  The %%bytecode%% may be the ``bytecode`` property within the
     *  standard Solidity JSON output.
     */
    constructor(a, o, u) {
      /**
       *  The Contract Interface.
       */
      Q(this, "interface");
      /**
       *  The Contract deployment bytecode. Often called the initcode.
       */
      Q(this, "bytecode");
      /**
       *  The ContractRunner to deploy the Contract as.
       */
      Q(this, "runner");
      const c = r.Interface.from(a);
      o instanceof Uint8Array || (typeof o == "object" && (o = o.object), o.startsWith("0x") || (o = "0x" + o)), o = (0, t.hexlify)((0, t.getBytes)(o)), (0, t.defineProperties)(this, {
        bytecode: o,
        interface: c,
        runner: u || null
      });
    }
    attach(a) {
      return new n.BaseContract(a, this.interface, this.runner);
    }
    /**
     *  Resolves to the transaction to deploy the contract, passing %%args%%
     *  into the constructor.
     */
    async getDeployTransaction(...a) {
      let o = {};
      const u = this.interface.deploy;
      if (u.inputs.length + 1 === a.length && (o = await (0, n.copyOverrides)(a.pop())), u.inputs.length !== a.length)
        throw new Error("incorrect number of arguments to constructor");
      const c = await (0, n.resolveArgs)(this.runner, u.inputs, a), l = (0, t.concat)([this.bytecode, this.interface.encodeDeploy(c)]);
      return Object.assign({}, o, { data: l });
    }
    /**
     *  Resolves to the Contract deployed by passing %%args%% into the
     *  constructor.
     *
     *  This will resolve to the Contract before it has been deployed to the
     *  network, so the [[BaseContract-waitForDeployment]] should be used before
     *  sending any transactions to it.
     */
    async deploy(...a) {
      const o = await this.getDeployTransaction(...a);
      (0, t.assert)(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
        operation: "sendTransaction"
      });
      const u = await this.runner.sendTransaction(o), c = (0, e.getCreateAddress)(u);
      return new n.BaseContract(c, this.interface, this.runner, u);
    }
    /**
     *  Return a new **ContractFactory** with the same ABI and bytecode,
     *  but connected to %%runner%%.
     */
    connect(a) {
      return new s(this.interface, this.bytecode, a);
    }
    /**
     *  Create a new **ContractFactory** from the standard Solidity JSON output.
     */
    static fromSolidity(a, o) {
      (0, t.assertArgument)(a != null, "bad compiler output", "output", a), typeof a == "string" && (a = JSON.parse(a));
      const u = a.abi;
      let c = "";
      return a.bytecode ? c = a.bytecode : a.evm && a.evm.bytecode && (c = a.evm.bytecode), new this(u, c, o);
    }
  }
  return Pl.ContractFactory = s, Pl;
}
var Cy;
function Ph() {
  return Cy || (Cy = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.UndecodedEventLog = r.EventLog = r.ContractTransactionResponse = r.ContractTransactionReceipt = r.ContractUnknownEventPayload = r.ContractEventPayload = r.ContractFactory = r.Contract = r.BaseContract = void 0;
    var e = u6();
    Object.defineProperty(r, "BaseContract", { enumerable: !0, get: function() {
      return e.BaseContract;
    } }), Object.defineProperty(r, "Contract", { enumerable: !0, get: function() {
      return e.Contract;
    } });
    var t = Yv();
    Object.defineProperty(r, "ContractFactory", { enumerable: !0, get: function() {
      return t.ContractFactory;
    } });
    var n = c6();
    Object.defineProperty(r, "ContractEventPayload", { enumerable: !0, get: function() {
      return n.ContractEventPayload;
    } }), Object.defineProperty(r, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return n.ContractUnknownEventPayload;
    } }), Object.defineProperty(r, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return n.ContractTransactionReceipt;
    } }), Object.defineProperty(r, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return n.ContractTransactionResponse;
    } }), Object.defineProperty(r, "EventLog", { enumerable: !0, get: function() {
      return n.EventLog;
    } }), Object.defineProperty(r, "UndecodedEventLog", { enumerable: !0, get: function() {
      return n.UndecodedEventLog;
    } });
  }(vp)), vp;
}
var kp = {}, ya = {}, cs = {}, Ry;
function f6() {
  var d, h, p, sc, k, l6;
  if (Ry) return cs;
  Ry = 1, Object.defineProperty(cs, "__esModule", { value: !0 }), cs.EnsResolver = cs.BasicMulticoinProviderPlugin = cs.MulticoinProviderPlugin = void 0;
  const r = zt(), e = ff(), t = Ph(), n = Ys(), s = Me();
  function i(E) {
    return E.match(/^ipfs:\/\/ipfs\//i) ? E = E.substring(12) : E.match(/^ipfs:\/\//i) ? E = E.substring(7) : (0, s.assertArgument)(!1, "unsupported IPFS format", "link", E), `https://gateway.ipfs.io/ipfs/${E}`;
  }
  class a {
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */
    constructor(m) {
      /**
       *  The name.
       */
      Q(this, "name");
      (0, s.defineProperties)(this, { name: m });
    }
    connect(m) {
      return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */
    supportsCoinType(m) {
      return !1;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */
    async encodeAddress(m, N) {
      throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */
    async decodeAddress(m, N) {
      throw new Error("unsupported coin");
    }
  }
  cs.MulticoinProviderPlugin = a;
  const o = "org.ethers.plugins.provider.BasicMulticoin";
  class u extends a {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */
    constructor() {
      super(o);
    }
  }
  cs.BasicMulticoinProviderPlugin = u;
  const c = new RegExp("^(ipfs)://(.*)$", "i"), l = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    c,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
  ], y = class y {
    constructor(m, N, T) {
      Z(this, p);
      /**
       *  The connected provider.
       */
      Q(this, "provider");
      /**
       *  The address of the resolver.
       */
      Q(this, "address");
      /**
       *  The name this resolver was resolved against.
       */
      Q(this, "name");
      // For EIP-2544 names, the ancestor that provided the resolver
      Z(this, d);
      Z(this, h);
      (0, s.defineProperties)(this, { provider: m, address: N, name: T }), F(this, d, null), F(this, h, new t.Contract(N, [
        "function supportsInterface(bytes4) view returns (bool)",
        "function resolve(bytes, bytes) view returns (bytes)",
        "function addr(bytes32) view returns (address)",
        "function addr(bytes32, uint) view returns (bytes)",
        "function text(bytes32, string) view returns (string)",
        "function contenthash(bytes32) view returns (bytes)"
      ], m));
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */
    async supportsWildcard() {
      return x(this, d) == null && F(this, d, (async () => {
        try {
          return await x(this, h).supportsInterface("0x9061b923");
        } catch (m) {
          if ((0, s.isError)(m, "CALL_EXCEPTION"))
            return !1;
          throw F(this, d, null), m;
        }
      })()), await x(this, d);
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */
    async getAddress(m) {
      if (m == null && (m = 60), m === 60)
        try {
          const R = await de(this, p, sc).call(this, "addr(bytes32)");
          return R == null || R === e.ZeroAddress ? null : R;
        } catch (R) {
          if ((0, s.isError)(R, "CALL_EXCEPTION"))
            return null;
          throw R;
        }
      if (m >= 0 && m < 2147483648) {
        let R = m + 2147483648;
        const j = await de(this, p, sc).call(this, "addr(bytes32,uint)", [R]);
        if ((0, s.isHexString)(j, 20))
          return (0, r.getAddress)(j);
      }
      let N = null;
      for (const R of this.provider.plugins)
        if (R instanceof a && R.supportsCoinType(m)) {
          N = R;
          break;
        }
      if (N == null)
        return null;
      const T = await de(this, p, sc).call(this, "addr(bytes32,uint)", [m]);
      if (T == null || T === "0x")
        return null;
      const U = await N.decodeAddress(m, T);
      if (U != null)
        return U;
      (0, s.assert)(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
        operation: `getAddress(${m})`,
        info: { coinType: m, data: T }
      });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */
    async getText(m) {
      const N = await de(this, p, sc).call(this, "text(bytes32,string)", [m]);
      return N == null || N === "0x" ? null : N;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */
    async getContentHash() {
      const m = await de(this, p, sc).call(this, "contenthash(bytes32)");
      if (m == null || m === "0x")
        return null;
      const N = m.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (N) {
        const U = N[1] === "e3010170" ? "ipfs" : "ipns", R = parseInt(N[4], 16);
        if (N[5].length === R * 2)
          return `${U}://${(0, s.encodeBase58)("0x" + N[2])}`;
      }
      const T = m.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (T && T[1].length === 64)
        return `bzz://${T[1]}`;
      (0, s.assert)(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
        operation: "getContentHash()",
        info: { data: m }
      });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */
    async getAvatar() {
      return (await this._getAvatar()).url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */
    async _getAvatar() {
      const m = [{ type: "name", value: this.name }];
      try {
        const N = await this.getText("avatar");
        if (N == null)
          return m.push({ type: "!avatar", value: "" }), { url: null, linkage: m };
        m.push({ type: "avatar", value: N });
        for (let T = 0; T < l.length; T++) {
          const U = N.match(l[T]);
          if (U == null)
            continue;
          const R = U[1].toLowerCase();
          switch (R) {
            case "https":
            case "data":
              return m.push({ type: "url", value: N }), { linkage: m, url: N };
            case "ipfs": {
              const j = i(N);
              return m.push({ type: "ipfs", value: N }), m.push({ type: "url", value: j }), { linkage: m, url: j };
            }
            case "erc721":
            case "erc1155": {
              const j = R === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
              m.push({ type: R, value: N });
              const D = await this.getAddress();
              if (D == null)
                return m.push({ type: "!owner", value: "" }), { url: null, linkage: m };
              const O = (U[2] || "").split("/");
              if (O.length !== 2)
                return m.push({ type: `!${R}caip`, value: U[2] || "" }), { url: null, linkage: m };
              const I = O[1], P = new t.Contract(O[0], [
                // ERC-721
                "function tokenURI(uint) view returns (string)",
                "function ownerOf(uint) view returns (address)",
                // ERC-1155
                "function uri(uint) view returns (string)",
                "function balanceOf(address, uint256) view returns (uint)"
              ], this.provider);
              if (R === "erc721") {
                const V = await P.ownerOf(I);
                if (D !== V)
                  return m.push({ type: "!owner", value: V }), { url: null, linkage: m };
                m.push({ type: "owner", value: V });
              } else if (R === "erc1155") {
                const V = await P.balanceOf(D, I);
                if (!V)
                  return m.push({ type: "!balance", value: "0" }), { url: null, linkage: m };
                m.push({ type: "balance", value: V.toString() });
              }
              let S = await P[j](I);
              if (S == null || S === "0x")
                return m.push({ type: "!metadata-url", value: "" }), { url: null, linkage: m };
              m.push({ type: "metadata-url-base", value: S }), R === "erc1155" && (S = S.replace("{id}", (0, s.toBeHex)(I, 32).substring(2)), m.push({ type: "metadata-url-expanded", value: S })), S.match(/^ipfs:/i) && (S = i(S)), m.push({ type: "metadata-url", value: S });
              let B = {};
              const C = await new s.FetchRequest(S).send();
              C.assertOk();
              try {
                B = C.bodyJson;
              } catch {
                try {
                  m.push({ type: "!metadata", value: C.bodyText });
                } catch {
                  const M = C.body;
                  return M && m.push({ type: "!metadata", value: (0, s.hexlify)(M) }), { url: null, linkage: m };
                }
                return { url: null, linkage: m };
              }
              if (!B)
                return m.push({ type: "!metadata", value: "" }), { url: null, linkage: m };
              m.push({ type: "metadata", value: JSON.stringify(B) });
              let H = B.image;
              if (typeof H != "string")
                return m.push({ type: "!imageUrl", value: "" }), { url: null, linkage: m };
              if (!H.match(/^(https:\/\/|data:)/i)) {
                if (H.match(c) == null)
                  return m.push({ type: "!imageUrl-ipfs", value: H }), { url: null, linkage: m };
                m.push({ type: "imageUrl-ipfs", value: H }), H = i(H);
              }
              return m.push({ type: "url", value: H }), { linkage: m, url: H };
            }
          }
        }
      } catch {
      }
      return { linkage: m, url: null };
    }
    static async getEnsAddress(m) {
      const N = await m.getNetwork(), T = N.getPlugin("org.ethers.plugins.network.Ens");
      return (0, s.assert)(T, "network does not support ENS", "UNSUPPORTED_OPERATION", {
        operation: "getEnsAddress",
        info: { network: N }
      }), T.address;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */
    static async fromName(m, N) {
      var U;
      let T = N;
      for (; ; ) {
        if (T === "" || T === "." || N !== "eth" && T === "eth")
          return null;
        const R = await de(U = y, k, l6).call(U, m, T);
        if (R != null) {
          const j = new y(m, R, N);
          return T !== N && !await j.supportsWildcard() ? null : j;
        }
        T = T.split(".").slice(1).join(".");
      }
    }
  };
  d = new WeakMap(), h = new WeakMap(), p = new WeakSet(), sc = async function(m, N) {
    N = (N || []).slice();
    const T = x(this, h).interface;
    N.unshift((0, n.namehash)(this.name));
    let U = null;
    await this.supportsWildcard() && (U = T.getFunction(m), (0, s.assert)(U, "missing fragment", "UNKNOWN_ERROR", {
      info: { funcName: m }
    }), N = [
      (0, n.dnsEncode)(this.name, 255),
      T.encodeFunctionData(U, N)
    ], m = "resolve(bytes,bytes)"), N.push({
      enableCcipRead: !0
    });
    try {
      const R = await x(this, h)[m](...N);
      return U ? T.decodeFunctionResult(U, R)[0] : R;
    } catch (R) {
      if (!(0, s.isError)(R, "CALL_EXCEPTION"))
        throw R;
    }
    return null;
  }, k = new WeakSet(), l6 = async function(m, N) {
    const T = await y.getEnsAddress(m);
    try {
      const R = await new t.Contract(T, [
        "function resolver(bytes32) view returns (address)"
      ], m).resolver((0, n.namehash)(N), {
        enableCcipRead: !0
      });
      return R === e.ZeroAddress ? null : R;
    } catch (U) {
      throw U;
    }
    return null;
  }, Z(y, k);
  let f = y;
  return cs.EnsResolver = f, cs;
}
var bt = {}, Iy;
function Zv() {
  if (Iy) return bt;
  Iy = 1, Object.defineProperty(bt, "__esModule", { value: !0 }), bt.formatTransactionResponse = bt.formatTransactionReceipt = bt.formatReceiptLog = bt.formatBlock = bt.formatLog = bt.formatUint256 = bt.formatHash = bt.formatData = bt.formatBoolean = bt.object = bt.arrayOf = bt.allowNull = void 0;
  const r = zt(), e = Yt(), t = Lr(), n = Me(), s = BigInt(0);
  function i(N, T) {
    return function(U) {
      return U == null ? T : N(U);
    };
  }
  bt.allowNull = i;
  function a(N, T) {
    return (U) => {
      if (T && U == null)
        return null;
      if (!Array.isArray(U))
        throw new Error("not an array");
      return U.map((R) => N(R));
    };
  }
  bt.arrayOf = a;
  function o(N, T) {
    return (U) => {
      const R = {};
      for (const j in N) {
        let D = j;
        if (T && j in T && !(D in U)) {
          for (const O of T[j])
            if (O in U) {
              D = O;
              break;
            }
        }
        try {
          const O = N[j](U[D]);
          O !== void 0 && (R[j] = O);
        } catch (O) {
          const I = O instanceof Error ? O.message : "not-an-error";
          (0, n.assert)(!1, `invalid value for value.${j} (${I})`, "BAD_DATA", { value: U });
        }
      }
      return R;
    };
  }
  bt.object = o;
  function u(N) {
    switch (N) {
      case !0:
      case "true":
        return !0;
      case !1:
      case "false":
        return !1;
    }
    (0, n.assertArgument)(!1, `invalid boolean; ${JSON.stringify(N)}`, "value", N);
  }
  bt.formatBoolean = u;
  function c(N) {
    return (0, n.assertArgument)((0, n.isHexString)(N, !0), "invalid data", "value", N), N;
  }
  bt.formatData = c;
  function l(N) {
    return (0, n.assertArgument)((0, n.isHexString)(N, 32), "invalid hash", "value", N), N;
  }
  bt.formatHash = l;
  function f(N) {
    if (!(0, n.isHexString)(N))
      throw new Error("invalid uint256");
    return (0, n.zeroPadValue)(N, 32);
  }
  bt.formatUint256 = f;
  const d = o({
    address: r.getAddress,
    blockHash: l,
    blockNumber: n.getNumber,
    data: c,
    index: n.getNumber,
    removed: i(u, !1),
    topics: a(l),
    transactionHash: l,
    transactionIndex: n.getNumber
  }, {
    index: ["logIndex"]
  });
  function h(N) {
    return d(N);
  }
  bt.formatLog = h;
  const p = o({
    hash: i(l),
    parentHash: l,
    parentBeaconBlockRoot: i(l, null),
    number: n.getNumber,
    timestamp: n.getNumber,
    nonce: i(c),
    difficulty: n.getBigInt,
    gasLimit: n.getBigInt,
    gasUsed: n.getBigInt,
    stateRoot: i(l, null),
    receiptsRoot: i(l, null),
    blobGasUsed: i(n.getBigInt, null),
    excessBlobGas: i(n.getBigInt, null),
    miner: i(r.getAddress),
    prevRandao: i(l, null),
    extraData: c,
    baseFeePerGas: i(n.getBigInt)
  }, {
    prevRandao: ["mixHash"]
  });
  function g(N) {
    const T = p(N);
    return T.transactions = N.transactions.map((U) => typeof U == "string" ? U : m(U)), T;
  }
  bt.formatBlock = g;
  const k = o({
    transactionIndex: n.getNumber,
    blockNumber: n.getNumber,
    transactionHash: l,
    address: r.getAddress,
    topics: a(l),
    data: c,
    index: n.getNumber,
    blockHash: l
  }, {
    index: ["logIndex"]
  });
  function A(N) {
    return k(N);
  }
  bt.formatReceiptLog = A;
  const y = o({
    to: i(r.getAddress, null),
    from: i(r.getAddress, null),
    contractAddress: i(r.getAddress, null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: n.getNumber,
    root: i(n.hexlify),
    gasUsed: n.getBigInt,
    blobGasUsed: i(n.getBigInt, null),
    logsBloom: i(c),
    blockHash: l,
    hash: l,
    logs: a(A),
    blockNumber: n.getNumber,
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: n.getBigInt,
    effectiveGasPrice: i(n.getBigInt),
    blobGasPrice: i(n.getBigInt, null),
    status: i(n.getNumber),
    type: i(n.getNumber, 0)
  }, {
    effectiveGasPrice: ["gasPrice"],
    hash: ["transactionHash"],
    index: ["transactionIndex"]
  });
  function E(N) {
    return y(N);
  }
  bt.formatTransactionReceipt = E;
  function m(N) {
    N.to && (0, n.getBigInt)(N.to) === s && (N.to = "0x0000000000000000000000000000000000000000");
    const T = o({
      hash: l,
      // Some nodes do not return this, usually test nodes (like Ganache)
      index: i(n.getNumber, void 0),
      type: (U) => U === "0x" || U == null ? 0 : (0, n.getNumber)(U),
      accessList: i(t.accessListify, null),
      blobVersionedHashes: i(a(l, !0), null),
      blockHash: i(l, null),
      blockNumber: i(n.getNumber, null),
      transactionIndex: i(n.getNumber, null),
      from: r.getAddress,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
      gasPrice: i(n.getBigInt),
      maxPriorityFeePerGas: i(n.getBigInt),
      maxFeePerGas: i(n.getBigInt),
      maxFeePerBlobGas: i(n.getBigInt, null),
      gasLimit: n.getBigInt,
      to: i(r.getAddress, null),
      value: n.getBigInt,
      nonce: n.getNumber,
      data: c,
      creates: i(r.getAddress, null),
      chainId: i(n.getBigInt, null)
    }, {
      data: ["input"],
      gasLimit: ["gas"],
      index: ["transactionIndex"]
    })(N);
    if (T.to == null && T.creates == null && (T.creates = (0, r.getCreateAddress)(T)), (N.type === 1 || N.type === 2) && N.accessList == null && (T.accessList = []), N.signature ? T.signature = e.Signature.from(N.signature) : T.signature = e.Signature.from(N), T.chainId == null) {
      const U = T.signature.legacyChainId;
      U != null && (T.chainId = U);
    }
    return T.blockHash && (0, n.getBigInt)(T.blockHash) === s && (T.blockHash = null), T;
  }
  return bt.formatTransactionResponse = m, bt;
}
var vl = {}, Er = {}, _y;
function fx() {
  var u, l, f;
  if (_y) return Er;
  _y = 1, Object.defineProperty(Er, "__esModule", { value: !0 }), Er.FetchUrlFeeDataNetworkPlugin = Er.FeeDataNetworkPlugin = Er.EnsPlugin = Er.GasCostPlugin = Er.NetworkPlugin = void 0;
  const r = So(), e = Me(), t = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
  class n {
    /**
     *  Creates a new **NetworkPlugin**.
     */
    constructor(h) {
      /**
       *  The name of the plugin.
       *
       *  It is recommended to use reverse-domain-notation, which permits
       *  unique names with a known authority as well as hierarchal entries.
       */
      Q(this, "name");
      (0, r.defineProperties)(this, { name: h });
    }
    /**
     *  Creates a copy of this plugin.
     */
    clone() {
      return new n(this.name);
    }
  }
  Er.NetworkPlugin = n;
  class s extends n {
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */
    constructor(p, g) {
      p == null && (p = 0);
      super(`org.ethers.network.plugins.GasCost#${p || 0}`);
      /**
       *  The block number to treat these values as valid from.
       *
       *  This allows a hardfork to have updated values included as well as
       *  mulutiple hardforks to be supported.
       */
      Q(this, "effectiveBlock");
      /**
       *  The transactions base fee.
       */
      Q(this, "txBase");
      /**
       *  The fee for creating a new account.
       */
      Q(this, "txCreate");
      /**
       *  The fee per zero-byte in the data.
       */
      Q(this, "txDataZero");
      /**
       *  The fee per non-zero-byte in the data.
       */
      Q(this, "txDataNonzero");
      /**
       *  The fee per storage key in the [[link-eip-2930]] access list.
       */
      Q(this, "txAccessListStorageKey");
      /**
       *  The fee per address in the [[link-eip-2930]] access list.
       */
      Q(this, "txAccessListAddress");
      const k = { effectiveBlock: p };
      function A(y, E) {
        let m = (g || {})[y];
        m == null && (m = E), (0, e.assertArgument)(typeof m == "number", `invalud value for ${y}`, "costs", g), k[y] = m;
      }
      A("txBase", 21e3), A("txCreate", 32e3), A("txDataZero", 4), A("txDataNonzero", 16), A("txAccessListStorageKey", 1900), A("txAccessListAddress", 2400), (0, r.defineProperties)(this, k);
    }
    clone() {
      return new s(this.effectiveBlock, this);
    }
  }
  Er.GasCostPlugin = s;
  class i extends n {
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */
    constructor(p, g) {
      super("org.ethers.plugins.network.Ens");
      /**
       *  The ENS Registrty Contract address.
       */
      Q(this, "address");
      /**
       *  The chain ID that the ENS contract lives on.
       */
      Q(this, "targetNetwork");
      (0, r.defineProperties)(this, {
        address: p || t,
        targetNetwork: g ?? 1
      });
    }
    clone() {
      return new i(this.address, this.targetNetwork);
    }
  }
  Er.EnsPlugin = i;
  const c = class c extends n {
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */
    constructor(p) {
      super("org.ethers.plugins.network.FeeData");
      Z(this, u);
      F(this, u, p);
    }
    /**
     *  The fee data function provided to the constructor.
     */
    get feeDataFunc() {
      return x(this, u);
    }
    /**
     *  Resolves to the fee data.
     */
    async getFeeData(p) {
      return await x(this, u).call(this, p);
    }
    clone() {
      return new c(x(this, u));
    }
  };
  u = new WeakMap();
  let a = c;
  Er.FeeDataNetworkPlugin = a;
  class o extends n {
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */
    constructor(p, g) {
      super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
      Z(this, l);
      Z(this, f);
      F(this, l, p), F(this, f, g);
    }
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */
    get url() {
      return x(this, l);
    }
    /**
     *  The callback to use when computing the FeeData.
     */
    get processFunc() {
      return x(this, f);
    }
    // We are immutable, so we can serve as our own clone
    clone() {
      return this;
    }
  }
  return l = new WeakMap(), f = new WeakMap(), Er.FetchUrlFeeDataNetworkPlugin = o, Er;
}
var Uy;
function Mr() {
  var c, l, f;
  if (Uy) return vl;
  Uy = 1, Object.defineProperty(vl, "__esModule", { value: !0 }), vl.Network = void 0;
  const r = Lr(), e = Me(), t = fx(), n = /* @__PURE__ */ new Map(), d = class d {
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */
    constructor(p, g) {
      Z(this, c);
      Z(this, l);
      Z(this, f);
      F(this, c, p), F(this, l, (0, e.getBigInt)(g)), F(this, f, /* @__PURE__ */ new Map());
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */
    toJSON() {
      return { name: this.name, chainId: String(this.chainId) };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */
    get name() {
      return x(this, c);
    }
    set name(p) {
      F(this, c, p);
    }
    /**
     *  The network chain ID.
     */
    get chainId() {
      return x(this, l);
    }
    set chainId(p) {
      F(this, l, (0, e.getBigInt)(p, "chainId"));
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */
    matches(p) {
      if (p == null)
        return !1;
      if (typeof p == "string") {
        try {
          return this.chainId === (0, e.getBigInt)(p);
        } catch {
        }
        return this.name === p;
      }
      if (typeof p == "number" || typeof p == "bigint") {
        try {
          return this.chainId === (0, e.getBigInt)(p);
        } catch {
        }
        return !1;
      }
      if (typeof p == "object") {
        if (p.chainId != null) {
          try {
            return this.chainId === (0, e.getBigInt)(p.chainId);
          } catch {
          }
          return !1;
        }
        return p.name != null ? this.name === p.name : !1;
      }
      return !1;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */
    get plugins() {
      return Array.from(x(this, f).values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */
    attachPlugin(p) {
      if (x(this, f).get(p.name))
        throw new Error(`cannot replace existing plugin: ${p.name} `);
      return x(this, f).set(p.name, p.clone()), this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */
    getPlugin(p) {
      return x(this, f).get(p) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */
    getPlugins(p) {
      return this.plugins.filter((g) => g.name.split("#")[0] === p);
    }
    /**
     *  Create a copy of this Network.
     */
    clone() {
      const p = new d(this.name, this.chainId);
      return this.plugins.forEach((g) => {
        p.attachPlugin(g.clone());
      }), p;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */
    computeIntrinsicGas(p) {
      const g = this.getPlugin("org.ethers.plugins.network.GasCost") || new t.GasCostPlugin();
      let k = g.txBase;
      if (p.to == null && (k += g.txCreate), p.data)
        for (let A = 2; A < p.data.length; A += 2)
          p.data.substring(A, A + 2) === "00" ? k += g.txDataZero : k += g.txDataNonzero;
      if (p.accessList) {
        const A = (0, r.accessListify)(p.accessList);
        for (const y in A)
          k += g.txAccessListAddress + g.txAccessListStorageKey * A[y].storageKeys.length;
      }
      return k;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */
    static from(p) {
      if (u(), p == null)
        return d.from("mainnet");
      if (typeof p == "number" && (p = BigInt(p)), typeof p == "string" || typeof p == "bigint") {
        const g = n.get(p);
        if (g)
          return g();
        if (typeof p == "bigint")
          return new d("unknown", p);
        (0, e.assertArgument)(!1, "unknown network", "network", p);
      }
      if (typeof p.clone == "function")
        return p.clone();
      if (typeof p == "object") {
        (0, e.assertArgument)(typeof p.name == "string" && typeof p.chainId == "number", "invalid network object name or chainId", "network", p);
        const g = new d(p.name, p.chainId);
        return (p.ensAddress || p.ensNetwork != null) && g.attachPlugin(new t.EnsPlugin(p.ensAddress, p.ensNetwork)), g;
      }
      (0, e.assertArgument)(!1, "invalid network", "network", p);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */
    static register(p, g) {
      typeof p == "number" && (p = BigInt(p));
      const k = n.get(p);
      k && (0, e.assertArgument)(!1, `conflicting network for ${JSON.stringify(k.name)}`, "nameOrChainId", p), n.set(p, g);
    }
  };
  c = new WeakMap(), l = new WeakMap(), f = new WeakMap();
  let s = d;
  vl.Network = s;
  function i(h, p) {
    const g = String(h);
    if (!g.match(/^[0-9.]+$/))
      throw new Error(`invalid gwei value: ${h}`);
    const k = g.split(".");
    if (k.length === 1 && k.push(""), k.length !== 2)
      throw new Error(`invalid gwei value: ${h}`);
    for (; k[1].length < p; )
      k[1] += "0";
    if (k[1].length > 9) {
      let A = BigInt(k[1].substring(0, 9));
      k[1].substring(9).match(/^0+$/) || A++, k[1] = A.toString();
    }
    return BigInt(k[0] + k[1]);
  }
  function a(h) {
    return new t.FetchUrlFeeDataNetworkPlugin(h, async (p, g, k) => {
      k.setHeader("User-Agent", "ethers");
      let A;
      try {
        const [y, E] = await Promise.all([
          k.send(),
          p()
        ]);
        A = y;
        const m = A.bodyJson.standard;
        return {
          gasPrice: E.gasPrice,
          maxFeePerGas: i(m.maxFee, 9),
          maxPriorityFeePerGas: i(m.maxPriorityFee, 9)
        };
      } catch (y) {
        (0, e.assert)(!1, `error encountered with polygon gas station (${JSON.stringify(k.url)})`, "SERVER_ERROR", { request: k, response: A, error: y });
      }
    });
  }
  let o = !1;
  function u() {
    if (o)
      return;
    o = !0;
    function h(p, g, k) {
      const A = function() {
        const y = new s(p, g);
        return k.ensNetwork != null && y.attachPlugin(new t.EnsPlugin(null, k.ensNetwork)), y.attachPlugin(new t.GasCostPlugin()), (k.plugins || []).forEach((E) => {
          y.attachPlugin(E);
        }), y;
      };
      s.register(p, A), s.register(g, A), k.altNames && k.altNames.forEach((y) => {
        s.register(y, A);
      });
    }
    h("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), h("ropsten", 3, { ensNetwork: 3 }), h("rinkeby", 4, { ensNetwork: 4 }), h("goerli", 5, { ensNetwork: 5 }), h("kovan", 42, { ensNetwork: 42 }), h("sepolia", 11155111, { ensNetwork: 11155111 }), h("holesky", 17e3, { ensNetwork: 17e3 }), h("classic", 61, {}), h("classicKotti", 6, {}), h("arbitrum", 42161, {
      ensNetwork: 1
    }), h("arbitrum-goerli", 421613, {}), h("arbitrum-sepolia", 421614, {}), h("base", 8453, { ensNetwork: 1 }), h("base-goerli", 84531, {}), h("base-sepolia", 84532, {}), h("bnb", 56, { ensNetwork: 1 }), h("bnbt", 97, {}), h("linea", 59144, { ensNetwork: 1 }), h("linea-goerli", 59140, {}), h("linea-sepolia", 59141, {}), h("matic", 137, {
      ensNetwork: 1,
      plugins: [
        a("https://gasstation.polygon.technology/v2")
      ]
    }), h("matic-amoy", 80002, {}), h("matic-mumbai", 80001, {
      altNames: ["maticMumbai", "maticmum"],
      plugins: [
        a("https://gasstation-testnet.polygon.technology/v2")
      ]
    }), h("optimism", 10, {
      ensNetwork: 1,
      plugins: []
    }), h("optimism-goerli", 420, {}), h("optimism-sepolia", 11155420, {}), h("xdai", 100, { ensNetwork: 1 });
  }
  return vl;
}
var Qt = {}, Ly;
function dx() {
  var c, l, f, d, h, sd, g, k, A, y, E, m, N, T, U, R, j, D, O, d6;
  if (Ly) return Qt;
  Ly = 1, Object.defineProperty(Qt, "__esModule", { value: !0 }), Qt.PollingEventSubscriber = Qt.PollingTransactionSubscriber = Qt.PollingOrphanSubscriber = Qt.PollingBlockTagSubscriber = Qt.OnBlockSubscriber = Qt.PollingBlockSubscriber = Qt.getPollingSubscriber = void 0;
  const r = Me();
  function e(P) {
    return JSON.parse(JSON.stringify(P));
  }
  function t(P, S) {
    if (S === "block")
      return new n(P);
    if ((0, r.isHexString)(S, 32))
      return new o(P, S);
    (0, r.assert)(!1, "unsupported polling event", "UNSUPPORTED_OPERATION", {
      operation: "getPollingSubscriber",
      info: { event: S }
    });
  }
  Qt.getPollingSubscriber = t;
  class n {
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */
    constructor(S) {
      Z(this, h);
      Z(this, c);
      Z(this, l);
      Z(this, f);
      // The most recent block we have scanned for events. The value -2
      // indicates we still need to fetch an initial block number
      Z(this, d);
      F(this, c, S), F(this, l, null), F(this, f, 4e3), F(this, d, -2);
    }
    /**
     *  The polling interval.
     */
    get pollingInterval() {
      return x(this, f);
    }
    set pollingInterval(S) {
      F(this, f, S);
    }
    start() {
      x(this, l) || (F(this, l, x(this, c)._setTimeout(de(this, h, sd).bind(this), x(this, f))), de(this, h, sd).call(this));
    }
    stop() {
      x(this, l) && (x(this, c)._clearTimeout(x(this, l)), F(this, l, null));
    }
    pause(S) {
      this.stop(), S && F(this, d, -2);
    }
    resume() {
      this.start();
    }
  }
  c = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), h = new WeakSet(), sd = async function() {
    try {
      const S = await x(this, c).getBlockNumber();
      if (x(this, d) === -2) {
        F(this, d, S);
        return;
      }
      if (S !== x(this, d)) {
        for (let B = x(this, d) + 1; B <= S; B++) {
          if (x(this, l) == null)
            return;
          await x(this, c).emit("block", B);
        }
        F(this, d, S);
      }
    } catch {
    }
    x(this, l) != null && F(this, l, x(this, c)._setTimeout(de(this, h, sd).bind(this), x(this, f)));
  }, Qt.PollingBlockSubscriber = n;
  class s {
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */
    constructor(S) {
      Z(this, g);
      Z(this, k);
      Z(this, A);
      F(this, g, S), F(this, A, !1), F(this, k, (B) => {
        this._poll(B, x(this, g));
      });
    }
    /**
     *  Called on every new block.
     */
    async _poll(S, B) {
      throw new Error("sub-classes must override this");
    }
    start() {
      x(this, A) || (F(this, A, !0), x(this, k).call(this, -2), x(this, g).on("block", x(this, k)));
    }
    stop() {
      x(this, A) && (F(this, A, !1), x(this, g).off("block", x(this, k)));
    }
    pause(S) {
      this.stop();
    }
    resume() {
      this.start();
    }
  }
  g = new WeakMap(), k = new WeakMap(), A = new WeakMap(), Qt.OnBlockSubscriber = s;
  class i extends s {
    constructor(B, C) {
      super(B);
      Z(this, y);
      Z(this, E);
      F(this, y, C), F(this, E, -2);
    }
    pause(B) {
      B && F(this, E, -2), super.pause(B);
    }
    async _poll(B, C) {
      const H = await C.getBlock(x(this, y));
      H != null && (x(this, E) === -2 ? F(this, E, H.number) : H.number > x(this, E) && (C.emit(x(this, y), H.number), F(this, E, H.number)));
    }
  }
  y = new WeakMap(), E = new WeakMap(), Qt.PollingBlockTagSubscriber = i;
  class a extends s {
    constructor(B, C) {
      super(B);
      Z(this, m);
      F(this, m, e(C));
    }
    async _poll(B, C) {
      throw new Error("@TODO");
    }
  }
  m = new WeakMap(), Qt.PollingOrphanSubscriber = a;
  class o extends s {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */
    constructor(B, C) {
      super(B);
      Z(this, N);
      F(this, N, C);
    }
    async _poll(B, C) {
      const H = await C.getTransactionReceipt(x(this, N));
      H && C.emit(x(this, N), H);
    }
  }
  N = new WeakMap(), Qt.PollingTransactionSubscriber = o;
  class u {
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */
    constructor(S, B) {
      Z(this, O);
      Z(this, T);
      Z(this, U);
      Z(this, R);
      Z(this, j);
      // The most recent block we have scanned for events. The value -2
      // indicates we still need to fetch an initial block number
      Z(this, D);
      F(this, T, S), F(this, U, e(B)), F(this, R, de(this, O, d6).bind(this)), F(this, j, !1), F(this, D, -2);
    }
    start() {
      x(this, j) || (F(this, j, !0), x(this, D) === -2 && x(this, T).getBlockNumber().then((S) => {
        F(this, D, S);
      }), x(this, T).on("block", x(this, R)));
    }
    stop() {
      x(this, j) && (F(this, j, !1), x(this, T).off("block", x(this, R)));
    }
    pause(S) {
      this.stop(), S && F(this, D, -2);
    }
    resume() {
      this.start();
    }
  }
  return T = new WeakMap(), U = new WeakMap(), R = new WeakMap(), j = new WeakMap(), D = new WeakMap(), O = new WeakSet(), d6 = async function(S) {
    if (x(this, D) === -2)
      return;
    const B = e(x(this, U));
    B.fromBlock = x(this, D) + 1, B.toBlock = S;
    const C = await x(this, T).getLogs(B);
    if (C.length === 0) {
      x(this, D) < S - 60 && F(this, D, S - 60);
      return;
    }
    for (const H of C)
      x(this, T).emit(x(this, U), H), F(this, D, H.blockNumber);
  }, Qt.PollingEventSubscriber = u, Qt;
}
var My;
function pf() {
  var S, B, C, H, V, J, M, G, K, X, te, pe, he, Tr, Nb, Sb, h0, Cb, p0, id;
  if (My) return ya;
  My = 1, Object.defineProperty(ya, "__esModule", { value: !0 }), ya.AbstractProvider = ya.UnmanagedSubscriber = void 0;
  const r = zt(), e = ff(), t = Ph(), n = Ys(), s = Lr(), i = Me(), a = f6(), o = Zv(), u = Mr(), c = hf(), l = dx(), f = BigInt(2), d = 10;
  function h(W) {
    return W && typeof W.then == "function";
  }
  function p(W, v) {
    return W + ":" + JSON.stringify(v, (z, q) => {
      if (q == null)
        return "null";
      if (typeof q == "bigint")
        return `bigint:${q.toString()}`;
      if (typeof q == "string")
        return q.toLowerCase();
      if (typeof q == "object" && !Array.isArray(q)) {
        const le = Object.keys(q);
        return le.sort(), le.reduce((be, ve) => (be[ve] = q[ve], be), {});
      }
      return q;
    });
  }
  class g {
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */
    constructor(v) {
      /**
       *  The name fof the event.
       */
      Q(this, "name");
      (0, i.defineProperties)(this, { name: v });
    }
    start() {
    }
    stop() {
    }
    pause(v) {
    }
    resume() {
    }
  }
  ya.UnmanagedSubscriber = g;
  function k(W) {
    return JSON.parse(JSON.stringify(W));
  }
  function A(W) {
    return W = Array.from(new Set(W).values()), W.sort(), W;
  }
  async function y(W, v) {
    if (W == null)
      throw new Error("invalid event");
    if (Array.isArray(W) && (W = { topics: W }), typeof W == "string")
      switch (W) {
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
          return { type: W, tag: W };
      }
    if ((0, i.isHexString)(W, 32)) {
      const z = W.toLowerCase();
      return { type: "transaction", tag: p("tx", { hash: z }), hash: z };
    }
    if (W.orphan) {
      const z = W;
      return { type: "orphan", tag: p("orphan", z), filter: k(z) };
    }
    if (W.address || W.topics) {
      const z = W, q = {
        topics: (z.topics || []).map((le) => le == null ? null : Array.isArray(le) ? A(le.map((be) => be.toLowerCase())) : le.toLowerCase())
      };
      if (z.address) {
        const le = [], be = [], ve = (Be) => {
          (0, i.isHexString)(Be) ? le.push(Be) : be.push((async () => {
            le.push(await (0, r.resolveAddress)(Be, v));
          })());
        };
        Array.isArray(z.address) ? z.address.forEach(ve) : ve(z.address), be.length && await Promise.all(be), q.address = A(le.map((Be) => Be.toLowerCase()));
      }
      return { filter: q, tag: p("event", q), type: "event" };
    }
    (0, i.assertArgument)(!1, "unknown ProviderEvent", "event", W);
  }
  function E() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  const m = {
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class N {
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */
    constructor(v, z) {
      Z(this, he);
      Z(this, S);
      Z(this, B);
      // null=unpaused, true=paused+dropWhilePaused, false=paused
      Z(this, C);
      Z(this, H);
      Z(this, V);
      Z(this, J);
      Z(this, M);
      // The most recent block number if running an event or -1 if no "block" event
      Z(this, G);
      Z(this, K);
      Z(this, X);
      Z(this, te);
      Z(this, pe);
      if (F(this, pe, Object.assign({}, m, z || {})), v === "any")
        F(this, J, !0), F(this, V, null);
      else if (v) {
        const q = u.Network.from(v);
        F(this, J, !1), F(this, V, Promise.resolve(q)), setTimeout(() => {
          this.emit("network", q, null);
        }, 0);
      } else
        F(this, J, !1), F(this, V, null);
      F(this, G, -1), F(this, M, /* @__PURE__ */ new Map()), F(this, S, /* @__PURE__ */ new Map()), F(this, B, /* @__PURE__ */ new Map()), F(this, C, null), F(this, H, !1), F(this, K, 1), F(this, X, /* @__PURE__ */ new Map()), F(this, te, !1);
    }
    get pollingInterval() {
      return x(this, pe).pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */
    get provider() {
      return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */
    get plugins() {
      return Array.from(x(this, B).values());
    }
    /**
     *  Attach a new plug-in.
     */
    attachPlugin(v) {
      if (x(this, B).get(v.name))
        throw new Error(`cannot replace existing plugin: ${v.name} `);
      return x(this, B).set(v.name, v.connect(this)), this;
    }
    /**
     *  Get a plugin by name.
     */
    getPlugin(v) {
      return x(this, B).get(v) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */
    get disableCcipRead() {
      return x(this, te);
    }
    set disableCcipRead(v) {
      F(this, te, !!v);
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */
    async ccipReadFetch(v, z, q) {
      if (this.disableCcipRead || q.length === 0 || v.to == null)
        return null;
      const le = v.to.toLowerCase(), be = z.toLowerCase(), ve = [];
      for (let Be = 0; Be < q.length; Be++) {
        const Ae = q[Be], ie = Ae.replace("{sender}", le).replace("{data}", be), se = new i.FetchRequest(ie);
        Ae.indexOf("{data}") === -1 && (se.body = { data: be, sender: le }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: se, index: Be, urls: q });
        let me = "unknown error", fe;
        try {
          fe = await se.send();
        } catch (_) {
          ve.push(_.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: se, result: { error: _ } });
          continue;
        }
        try {
          const _ = fe.bodyJson;
          if (_.data)
            return this.emit("debug", { action: "receiveCcipReadFetchResult", request: se, result: _ }), _.data;
          _.message && (me = _.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: se, result: _ });
        } catch {
        }
        (0, i.assert)(fe.statusCode < 400 || fe.statusCode >= 500, `response not found during CCIP fetch: ${me}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: v, info: { url: Ae, errorMessage: me } }), ve.push(me);
      }
      (0, i.assert)(!1, `error encountered during CCIP fetch: ${ve.map((Be) => JSON.stringify(Be)).join(", ")}`, "OFFCHAIN_FAULT", {
        reason: "500_SERVER_ERROR",
        transaction: v,
        info: { urls: q, errorMessages: ve }
      });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */
    _wrapBlock(v, z) {
      return new c.Block((0, o.formatBlock)(v), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */
    _wrapLog(v, z) {
      return new c.Log((0, o.formatLog)(v), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */
    _wrapTransactionReceipt(v, z) {
      return new c.TransactionReceipt((0, o.formatTransactionReceipt)(v), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */
    _wrapTransactionResponse(v, z) {
      return new c.TransactionResponse((0, o.formatTransactionResponse)(v), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */
    _detectNetwork() {
      (0, i.assert)(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
        operation: "_detectNetwork"
      });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */
    async _perform(v) {
      (0, i.assert)(!1, `unsupported method: ${v.method}`, "UNSUPPORTED_OPERATION", {
        operation: v.method,
        info: v
      });
    }
    // State
    async getBlockNumber() {
      const v = (0, i.getNumber)(await de(this, he, Tr).call(this, { method: "getBlockNumber" }), "%response");
      return x(this, G) >= 0 && F(this, G, v), v;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */
    _getAddress(v) {
      return (0, r.resolveAddress)(v, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */
    _getBlockTag(v) {
      if (v == null)
        return "latest";
      switch (v) {
        case "earliest":
          return "0x0";
        case "finalized":
        case "latest":
        case "pending":
        case "safe":
          return v;
      }
      if ((0, i.isHexString)(v))
        return (0, i.isHexString)(v, 32) ? v : (0, i.toQuantity)(v);
      if (typeof v == "bigint" && (v = (0, i.getNumber)(v, "blockTag")), typeof v == "number")
        return v >= 0 ? (0, i.toQuantity)(v) : x(this, G) >= 0 ? (0, i.toQuantity)(x(this, G) + v) : this.getBlockNumber().then((z) => (0, i.toQuantity)(z + v));
      (0, i.assertArgument)(!1, "invalid blockTag", "blockTag", v);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */
    _getFilter(v) {
      const z = (v.topics || []).map((Ae) => Ae == null ? null : Array.isArray(Ae) ? A(Ae.map((ie) => ie.toLowerCase())) : Ae.toLowerCase()), q = "blockHash" in v ? v.blockHash : void 0, le = (Ae, ie, se) => {
        let me;
        switch (Ae.length) {
          case 0:
            break;
          case 1:
            me = Ae[0];
            break;
          default:
            Ae.sort(), me = Ae;
        }
        if (q && (ie != null || se != null))
          throw new Error("invalid filter");
        const fe = {};
        return me && (fe.address = me), z.length && (fe.topics = z), ie && (fe.fromBlock = ie), se && (fe.toBlock = se), q && (fe.blockHash = q), fe;
      };
      let be = [];
      if (v.address)
        if (Array.isArray(v.address))
          for (const Ae of v.address)
            be.push(this._getAddress(Ae));
        else
          be.push(this._getAddress(v.address));
      let ve;
      "fromBlock" in v && (ve = this._getBlockTag(v.fromBlock));
      let Be;
      return "toBlock" in v && (Be = this._getBlockTag(v.toBlock)), be.filter((Ae) => typeof Ae != "string").length || ve != null && typeof ve != "string" || Be != null && typeof Be != "string" ? Promise.all([Promise.all(be), ve, Be]).then((Ae) => le(Ae[0], Ae[1], Ae[2])) : le(be, ve, Be);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */
    _getTransactionRequest(v) {
      const z = (0, c.copyRequest)(v), q = [];
      if (["to", "from"].forEach((le) => {
        if (z[le] == null)
          return;
        const be = (0, r.resolveAddress)(z[le], this);
        h(be) ? q.push(async function() {
          z[le] = await be;
        }()) : z[le] = be;
      }), z.blockTag != null) {
        const le = this._getBlockTag(z.blockTag);
        h(le) ? q.push(async function() {
          z.blockTag = await le;
        }()) : z.blockTag = le;
      }
      return q.length ? async function() {
        return await Promise.all(q), z;
      }() : z;
    }
    async getNetwork() {
      if (x(this, V) == null) {
        const le = (async () => {
          try {
            const be = await this._detectNetwork();
            return this.emit("network", be, null), be;
          } catch (be) {
            throw x(this, V) === le && F(this, V, null), be;
          }
        })();
        return F(this, V, le), (await le).clone();
      }
      const v = x(this, V), [z, q] = await Promise.all([
        v,
        this._detectNetwork()
        // The actual connected network
      ]);
      return z.chainId !== q.chainId && (x(this, J) ? (this.emit("network", q, z), x(this, V) === v && F(this, V, Promise.resolve(q))) : (0, i.assert)(!1, `network changed: ${z.chainId} => ${q.chainId} `, "NETWORK_ERROR", {
        event: "changed"
      })), z.clone();
    }
    async getFeeData() {
      const v = await this.getNetwork(), z = async () => {
        const { _block: le, gasPrice: be, priorityFee: ve } = await (0, i.resolveProperties)({
          _block: de(this, he, Cb).call(this, "latest", !1),
          gasPrice: (async () => {
            try {
              const se = await de(this, he, Tr).call(this, { method: "getGasPrice" });
              return (0, i.getBigInt)(se, "%response");
            } catch {
            }
            return null;
          })(),
          priorityFee: (async () => {
            try {
              const se = await de(this, he, Tr).call(this, { method: "getPriorityFee" });
              return (0, i.getBigInt)(se, "%response");
            } catch {
            }
            return null;
          })()
        });
        let Be = null, Ae = null;
        const ie = this._wrapBlock(le, v);
        return ie && ie.baseFeePerGas && (Ae = ve ?? BigInt("1000000000"), Be = ie.baseFeePerGas * f + Ae), new c.FeeData(be, Be, Ae);
      }, q = v.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
      if (q) {
        const le = new i.FetchRequest(q.url), be = await q.processFunc(z, this, le);
        return new c.FeeData(be.gasPrice, be.maxFeePerGas, be.maxPriorityFeePerGas);
      }
      return await z();
    }
    async estimateGas(v) {
      let z = this._getTransactionRequest(v);
      return h(z) && (z = await z), (0, i.getBigInt)(await de(this, he, Tr).call(this, {
        method: "estimateGas",
        transaction: z
      }), "%response");
    }
    async call(v) {
      const { tx: z, blockTag: q } = await (0, i.resolveProperties)({
        tx: this._getTransactionRequest(v),
        blockTag: this._getBlockTag(v.blockTag)
      });
      return await de(this, he, Sb).call(this, de(this, he, Nb).call(this, z, q, v.enableCcipRead ? 0 : -1));
    }
    async getBalance(v, z) {
      return (0, i.getBigInt)(await de(this, he, h0).call(this, { method: "getBalance" }, v, z), "%response");
    }
    async getTransactionCount(v, z) {
      return (0, i.getNumber)(await de(this, he, h0).call(this, { method: "getTransactionCount" }, v, z), "%response");
    }
    async getCode(v, z) {
      return (0, i.hexlify)(await de(this, he, h0).call(this, { method: "getCode" }, v, z));
    }
    async getStorage(v, z, q) {
      const le = (0, i.getBigInt)(z, "position");
      return (0, i.hexlify)(await de(this, he, h0).call(this, { method: "getStorage", position: le }, v, q));
    }
    // Write
    async broadcastTransaction(v) {
      const { blockNumber: z, hash: q, network: le } = await (0, i.resolveProperties)({
        blockNumber: this.getBlockNumber(),
        hash: this._perform({
          method: "broadcastTransaction",
          signedTransaction: v
        }),
        network: this.getNetwork()
      }), be = s.Transaction.from(v);
      if (be.hash !== q)
        throw new Error("@TODO: the returned hash did not match");
      return this._wrapTransactionResponse(be, le).replaceableTransaction(z);
    }
    // Queries
    async getBlock(v, z) {
      const { network: q, params: le } = await (0, i.resolveProperties)({
        network: this.getNetwork(),
        params: de(this, he, Cb).call(this, v, !!z)
      });
      return le == null ? null : this._wrapBlock(le, q);
    }
    async getTransaction(v) {
      const { network: z, params: q } = await (0, i.resolveProperties)({
        network: this.getNetwork(),
        params: de(this, he, Tr).call(this, { method: "getTransaction", hash: v })
      });
      return q == null ? null : this._wrapTransactionResponse(q, z);
    }
    async getTransactionReceipt(v) {
      const { network: z, params: q } = await (0, i.resolveProperties)({
        network: this.getNetwork(),
        params: de(this, he, Tr).call(this, { method: "getTransactionReceipt", hash: v })
      });
      if (q == null)
        return null;
      if (q.gasPrice == null && q.effectiveGasPrice == null) {
        const le = await de(this, he, Tr).call(this, { method: "getTransaction", hash: v });
        if (le == null)
          throw new Error("report this; could not find tx or effectiveGasPrice");
        q.effectiveGasPrice = le.gasPrice;
      }
      return this._wrapTransactionReceipt(q, z);
    }
    async getTransactionResult(v) {
      const { result: z } = await (0, i.resolveProperties)({
        network: this.getNetwork(),
        result: de(this, he, Tr).call(this, { method: "getTransactionResult", hash: v })
      });
      return z == null ? null : (0, i.hexlify)(z);
    }
    // Bloom-filter Queries
    async getLogs(v) {
      let z = this._getFilter(v);
      h(z) && (z = await z);
      const { network: q, params: le } = await (0, i.resolveProperties)({
        network: this.getNetwork(),
        params: de(this, he, Tr).call(this, { method: "getLogs", filter: z })
      });
      return le.map((be) => this._wrapLog(be, q));
    }
    // ENS
    _getProvider(v) {
      (0, i.assert)(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
        operation: "_getProvider()"
      });
    }
    async getResolver(v) {
      return await a.EnsResolver.fromName(this, v);
    }
    async getAvatar(v) {
      const z = await this.getResolver(v);
      return z ? await z.getAvatar() : null;
    }
    async resolveName(v) {
      const z = await this.getResolver(v);
      return z ? await z.getAddress() : null;
    }
    async lookupAddress(v) {
      v = (0, r.getAddress)(v);
      const z = (0, n.namehash)(v.substring(2).toLowerCase() + ".addr.reverse");
      try {
        const q = await a.EnsResolver.getEnsAddress(this), be = await new t.Contract(q, [
          "function resolver(bytes32) view returns (address)"
        ], this).resolver(z);
        if (be == null || be === e.ZeroAddress)
          return null;
        const Be = await new t.Contract(be, [
          "function name(bytes32) view returns (string)"
        ], this).name(z);
        return await this.resolveName(Be) !== v ? null : Be;
      } catch (q) {
        if ((0, i.isError)(q, "BAD_DATA") && q.value === "0x" || (0, i.isError)(q, "CALL_EXCEPTION"))
          return null;
        throw q;
      }
      return null;
    }
    async waitForTransaction(v, z, q) {
      const le = z ?? 1;
      return le === 0 ? this.getTransactionReceipt(v) : new Promise(async (be, ve) => {
        let Be = null;
        const Ae = async (ie) => {
          try {
            const se = await this.getTransactionReceipt(v);
            if (se != null && ie - se.blockNumber + 1 >= le) {
              be(se), Be && (clearTimeout(Be), Be = null);
              return;
            }
          } catch (se) {
            console.log("EEE", se);
          }
          this.once("block", Ae);
        };
        q != null && (Be = setTimeout(() => {
          Be != null && (Be = null, this.off("block", Ae), ve((0, i.makeError)("timeout", "TIMEOUT", { reason: "timeout" })));
        }, q)), Ae(await this.getBlockNumber());
      });
    }
    async waitForBlock(v) {
      (0, i.assert)(!1, "not implemented yet", "NOT_IMPLEMENTED", {
        operation: "waitForBlock"
      });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */
    _clearTimeout(v) {
      const z = x(this, X).get(v);
      z && (z.timer && clearTimeout(z.timer), x(this, X).delete(v));
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */
    _setTimeout(v, z) {
      z == null && (z = 0);
      const q = rn(this, K)._++, le = () => {
        x(this, X).delete(q), v();
      };
      if (this.paused)
        x(this, X).set(q, { timer: null, func: le, time: z });
      else {
        const be = setTimeout(le, z);
        x(this, X).set(q, { timer: be, func: le, time: E() });
      }
      return q;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */
    _forEachSubscriber(v) {
      for (const z of x(this, S).values())
        v(z.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */
    _getSubscriber(v) {
      switch (v.type) {
        case "debug":
        case "error":
        case "network":
          return new g(v.type);
        case "block": {
          const z = new l.PollingBlockSubscriber(this);
          return z.pollingInterval = this.pollingInterval, z;
        }
        case "safe":
        case "finalized":
          return new l.PollingBlockTagSubscriber(this, v.type);
        case "event":
          return new l.PollingEventSubscriber(this, v.filter);
        case "transaction":
          return new l.PollingTransactionSubscriber(this, v.hash);
        case "orphan":
          return new l.PollingOrphanSubscriber(this, v.filter);
      }
      throw new Error(`unsupported event: ${v.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */
    _recoverSubscriber(v, z) {
      for (const q of x(this, S).values())
        if (q.subscriber === v) {
          q.started && q.subscriber.stop(), q.subscriber = z, q.started && z.start(), x(this, C) != null && z.pause(x(this, C));
          break;
        }
    }
    async on(v, z) {
      const q = await de(this, he, id).call(this, v);
      return q.listeners.push({ listener: z, once: !1 }), q.started || (q.subscriber.start(), q.started = !0, x(this, C) != null && q.subscriber.pause(x(this, C))), this;
    }
    async once(v, z) {
      const q = await de(this, he, id).call(this, v);
      return q.listeners.push({ listener: z, once: !0 }), q.started || (q.subscriber.start(), q.started = !0, x(this, C) != null && q.subscriber.pause(x(this, C))), this;
    }
    async emit(v, ...z) {
      const q = await de(this, he, p0).call(this, v, z);
      if (!q || q.listeners.length === 0)
        return !1;
      const le = q.listeners.length;
      return q.listeners = q.listeners.filter(({ listener: be, once: ve }) => {
        const Be = new i.EventPayload(this, ve ? null : be, v);
        try {
          be.call(this, ...z, Be);
        } catch {
        }
        return !ve;
      }), q.listeners.length === 0 && (q.started && q.subscriber.stop(), x(this, S).delete(q.tag)), le > 0;
    }
    async listenerCount(v) {
      if (v) {
        const q = await de(this, he, p0).call(this, v);
        return q ? q.listeners.length : 0;
      }
      let z = 0;
      for (const { listeners: q } of x(this, S).values())
        z += q.length;
      return z;
    }
    async listeners(v) {
      if (v) {
        const q = await de(this, he, p0).call(this, v);
        return q ? q.listeners.map(({ listener: le }) => le) : [];
      }
      let z = [];
      for (const { listeners: q } of x(this, S).values())
        z = z.concat(q.map(({ listener: le }) => le));
      return z;
    }
    async off(v, z) {
      const q = await de(this, he, p0).call(this, v);
      if (!q)
        return this;
      if (z) {
        const le = q.listeners.map(({ listener: be }) => be).indexOf(z);
        le >= 0 && q.listeners.splice(le, 1);
      }
      return (!z || q.listeners.length === 0) && (q.started && q.subscriber.stop(), x(this, S).delete(q.tag)), this;
    }
    async removeAllListeners(v) {
      if (v) {
        const { tag: z, started: q, subscriber: le } = await de(this, he, id).call(this, v);
        q && le.stop(), x(this, S).delete(z);
      } else
        for (const [z, { started: q, subscriber: le }] of x(this, S))
          q && le.stop(), x(this, S).delete(z);
      return this;
    }
    // Alias for "on"
    async addListener(v, z) {
      return await this.on(v, z);
    }
    // Alias for "off"
    async removeListener(v, z) {
      return this.off(v, z);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */
    get destroyed() {
      return x(this, H);
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */
    destroy() {
      this.removeAllListeners();
      for (const v of x(this, X).keys())
        this._clearTimeout(v);
      F(this, H, !0);
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */
    get paused() {
      return x(this, C) != null;
    }
    set paused(v) {
      !!v !== this.paused && (this.paused ? this.resume() : this.pause(!1));
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */
    pause(v) {
      if (F(this, G, -1), x(this, C) != null) {
        if (x(this, C) == !!v)
          return;
        (0, i.assert)(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
          operation: "pause"
        });
      }
      this._forEachSubscriber((z) => z.pause(v)), F(this, C, !!v);
      for (const z of x(this, X).values())
        z.timer && clearTimeout(z.timer), z.time = E() - z.time;
    }
    /**
     *  Resume the provider.
     */
    resume() {
      if (x(this, C) != null) {
        this._forEachSubscriber((v) => v.resume()), F(this, C, null);
        for (const v of x(this, X).values()) {
          let z = v.time;
          z < 0 && (z = 0), v.time = E(), setTimeout(v.func, z);
        }
      }
    }
  }
  S = new WeakMap(), B = new WeakMap(), C = new WeakMap(), H = new WeakMap(), V = new WeakMap(), J = new WeakMap(), M = new WeakMap(), G = new WeakMap(), K = new WeakMap(), X = new WeakMap(), te = new WeakMap(), pe = new WeakMap(), he = new WeakSet(), Tr = async function(v) {
    const z = x(this, pe).cacheTimeout;
    if (z < 0)
      return await this._perform(v);
    const q = p(v.method, v);
    let le = x(this, M).get(q);
    return le || (le = this._perform(v), x(this, M).set(q, le), setTimeout(() => {
      x(this, M).get(q) === le && x(this, M).delete(q);
    }, z)), await le;
  }, Nb = async function(v, z, q) {
    (0, i.assert)(q < d, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
      reason: "TOO_MANY_REDIRECTS",
      transaction: Object.assign({}, v, { blockTag: z, enableCcipRead: !0 })
    });
    const le = (0, c.copyRequest)(v);
    try {
      return (0, i.hexlify)(await this._perform({ method: "call", transaction: le, blockTag: z }));
    } catch (be) {
      if (!this.disableCcipRead && (0, i.isCallException)(be) && be.data && q >= 0 && z === "latest" && le.to != null && (0, i.dataSlice)(be.data, 0, 4) === "0x556f1830") {
        const ve = be.data, Be = await (0, r.resolveAddress)(le.to, this);
        let Ae;
        try {
          Ae = P((0, i.dataSlice)(be.data, 4));
        } catch (me) {
          (0, i.assert)(!1, me.message, "OFFCHAIN_FAULT", {
            reason: "BAD_DATA",
            transaction: le,
            info: { data: ve }
          });
        }
        (0, i.assert)(Ae.sender.toLowerCase() === Be.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
          action: "call",
          data: ve,
          reason: "OffchainLookup",
          transaction: le,
          invocation: null,
          revert: {
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            name: "OffchainLookup",
            args: Ae.errorArgs
          }
        });
        const ie = await this.ccipReadFetch(le, Ae.calldata, Ae.urls);
        (0, i.assert)(ie != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
          reason: "FETCH_FAILED",
          transaction: le,
          info: { data: be.data, errorArgs: Ae.errorArgs }
        });
        const se = {
          to: Be,
          data: (0, i.concat)([Ae.selector, O([ie, Ae.extraData])])
        };
        this.emit("debug", { action: "sendCcipReadCall", transaction: se });
        try {
          const me = await de(this, he, Nb).call(this, se, z, q + 1);
          return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, se), result: me }), me;
        } catch (me) {
          throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, se), error: me }), me;
        }
      }
      throw be;
    }
  }, Sb = async function(v) {
    const { value: z } = await (0, i.resolveProperties)({
      network: this.getNetwork(),
      value: v
    });
    return z;
  }, h0 = async function(v, z, q) {
    let le = this._getAddress(z), be = this._getBlockTag(q);
    return (typeof le != "string" || typeof be != "string") && ([le, be] = await Promise.all([le, be])), await de(this, he, Sb).call(this, de(this, he, Tr).call(this, Object.assign(v, { address: le, blockTag: be })));
  }, Cb = async function(v, z) {
    if ((0, i.isHexString)(v, 32))
      return await de(this, he, Tr).call(this, {
        method: "getBlock",
        blockHash: v,
        includeTransactions: z
      });
    let q = this._getBlockTag(v);
    return typeof q != "string" && (q = await q), await de(this, he, Tr).call(this, {
      method: "getBlock",
      blockTag: q,
      includeTransactions: z
    });
  }, p0 = async function(v, z) {
    let q = await y(v, this);
    return q.type === "event" && z && z.length > 0 && z[0].removed === !0 && (q = await y({ orphan: "drop-log", log: z[0] }, this)), x(this, S).get(q.tag) || null;
  }, id = async function(v) {
    const z = await y(v, this), q = z.tag;
    let le = x(this, S).get(q);
    return le || (le = { subscriber: this._getSubscriber(z), tag: q, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, x(this, S).set(q, le)), le;
  }, ya.AbstractProvider = N;
  function T(W, v) {
    try {
      const z = U(W, v);
      if (z)
        return (0, i.toUtf8String)(z);
    } catch {
    }
    return null;
  }
  function U(W, v) {
    if (W === "0x")
      return null;
    try {
      const z = (0, i.getNumber)((0, i.dataSlice)(W, v, v + 32)), q = (0, i.getNumber)((0, i.dataSlice)(W, z, z + 32));
      return (0, i.dataSlice)(W, z + 32, z + 32 + q);
    } catch {
    }
    return null;
  }
  function R(W) {
    const v = (0, i.toBeArray)(W);
    if (v.length > 32)
      throw new Error("internal; should not happen");
    const z = new Uint8Array(32);
    return z.set(v, 32 - v.length), z;
  }
  function j(W) {
    if (W.length % 32 === 0)
      return W;
    const v = new Uint8Array(Math.ceil(W.length / 32) * 32);
    return v.set(W), v;
  }
  const D = new Uint8Array([]);
  function O(W) {
    const v = [];
    let z = 0;
    for (let q = 0; q < W.length; q++)
      v.push(D), z += 32;
    for (let q = 0; q < W.length; q++) {
      const le = (0, i.getBytes)(W[q]);
      v[q] = R(z), v.push(R(le.length)), v.push(j(le)), z += 32 + Math.ceil(le.length / 32) * 32;
    }
    return (0, i.concat)(v);
  }
  const I = "0x0000000000000000000000000000000000000000000000000000000000000000";
  function P(W) {
    const v = {
      sender: "",
      urls: [],
      calldata: "",
      selector: "",
      extraData: "",
      errorArgs: []
    };
    (0, i.assert)((0, i.dataLength)(W) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
      reason: "insufficient OffchainLookup data"
    });
    const z = (0, i.dataSlice)(W, 0, 32);
    (0, i.assert)((0, i.dataSlice)(z, 0, 12) === (0, i.dataSlice)(I, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup sender"
    }), v.sender = (0, i.dataSlice)(z, 12);
    try {
      const q = [], le = (0, i.getNumber)((0, i.dataSlice)(W, 32, 64)), be = (0, i.getNumber)((0, i.dataSlice)(W, le, le + 32)), ve = (0, i.dataSlice)(W, le + 32);
      for (let Be = 0; Be < be; Be++) {
        const Ae = T(ve, Be * 32);
        if (Ae == null)
          throw new Error("abort");
        q.push(Ae);
      }
      v.urls = q;
    } catch {
      (0, i.assert)(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup urls"
      });
    }
    try {
      const q = U(W, 64);
      if (q == null)
        throw new Error("abort");
      v.calldata = q;
    } catch {
      (0, i.assert)(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup calldata"
      });
    }
    (0, i.assert)((0, i.dataSlice)(W, 100, 128) === (0, i.dataSlice)(I, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup callbaackSelector"
    }), v.selector = (0, i.dataSlice)(W, 96, 100);
    try {
      const q = U(W, 128);
      if (q == null)
        throw new Error("abort");
      v.extraData = q;
    } catch {
      (0, i.assert)(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup extraData"
      });
    }
    return v.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((q) => v[q]), v;
  }
  return ya;
}
var wa = {}, Fy;
function hx() {
  var u, ad;
  if (Fy) return wa;
  Fy = 1, Object.defineProperty(wa, "__esModule", { value: !0 }), wa.VoidSigner = wa.AbstractSigner = void 0;
  const r = zt(), e = Lr(), t = Me(), n = hf();
  function s(f, d) {
    if (f.provider)
      return f.provider;
    (0, t.assert)(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: d });
  }
  async function i(f, d) {
    let h = (0, n.copyRequest)(d);
    if (h.to != null && (h.to = (0, r.resolveAddress)(h.to, f)), h.from != null) {
      const p = h.from;
      h.from = Promise.all([
        f.getAddress(),
        (0, r.resolveAddress)(p, f)
      ]).then(([g, k]) => ((0, t.assertArgument)(g.toLowerCase() === k.toLowerCase(), "transaction from mismatch", "tx.from", k), g));
    } else
      h.from = f.getAddress();
    return await (0, t.resolveProperties)(h);
  }
  class a {
    /**
     *  Creates a new Signer connected to %%provider%%.
     */
    constructor(d) {
      /**
       *  The provider this signer is connected to.
       */
      Q(this, "provider");
      (0, t.defineProperties)(this, { provider: d || null });
    }
    async getNonce(d) {
      return s(this, "getTransactionCount").getTransactionCount(await this.getAddress(), d);
    }
    async populateCall(d) {
      return await i(this, d);
    }
    async populateTransaction(d) {
      const h = s(this, "populateTransaction"), p = await i(this, d);
      p.nonce == null && (p.nonce = await this.getNonce("pending")), p.gasLimit == null && (p.gasLimit = await this.estimateGas(p));
      const g = await this.provider.getNetwork();
      if (p.chainId != null) {
        const A = (0, t.getBigInt)(p.chainId);
        (0, t.assertArgument)(A === g.chainId, "transaction chainId mismatch", "tx.chainId", d.chainId);
      } else
        p.chainId = g.chainId;
      const k = p.maxFeePerGas != null || p.maxPriorityFeePerGas != null;
      if (p.gasPrice != null && (p.type === 2 || k) ? (0, t.assertArgument)(!1, "eip-1559 transaction do not support gasPrice", "tx", d) : (p.type === 0 || p.type === 1) && k && (0, t.assertArgument)(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", d), (p.type === 2 || p.type == null) && p.maxFeePerGas != null && p.maxPriorityFeePerGas != null)
        p.type = 2;
      else if (p.type === 0 || p.type === 1) {
        const A = await h.getFeeData();
        (0, t.assert)(A.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
          operation: "getGasPrice"
        }), p.gasPrice == null && (p.gasPrice = A.gasPrice);
      } else {
        const A = await h.getFeeData();
        if (p.type == null)
          if (A.maxFeePerGas != null && A.maxPriorityFeePerGas != null)
            if (p.type = 2, p.gasPrice != null) {
              const y = p.gasPrice;
              delete p.gasPrice, p.maxFeePerGas = y, p.maxPriorityFeePerGas = y;
            } else
              p.maxFeePerGas == null && (p.maxFeePerGas = A.maxFeePerGas), p.maxPriorityFeePerGas == null && (p.maxPriorityFeePerGas = A.maxPriorityFeePerGas);
          else A.gasPrice != null ? ((0, t.assert)(!k, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
            operation: "populateTransaction"
          }), p.gasPrice == null && (p.gasPrice = A.gasPrice), p.type = 0) : (0, t.assert)(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
            operation: "signer.getFeeData"
          });
        else (p.type === 2 || p.type === 3) && (p.maxFeePerGas == null && (p.maxFeePerGas = A.maxFeePerGas), p.maxPriorityFeePerGas == null && (p.maxPriorityFeePerGas = A.maxPriorityFeePerGas));
      }
      return await (0, t.resolveProperties)(p);
    }
    async estimateGas(d) {
      return s(this, "estimateGas").estimateGas(await this.populateCall(d));
    }
    async call(d) {
      return s(this, "call").call(await this.populateCall(d));
    }
    async resolveName(d) {
      return await s(this, "resolveName").resolveName(d);
    }
    async sendTransaction(d) {
      const h = s(this, "sendTransaction"), p = await this.populateTransaction(d);
      delete p.from;
      const g = e.Transaction.from(p);
      return await h.broadcastTransaction(await this.signTransaction(g));
    }
  }
  wa.AbstractSigner = a;
  const l = class l extends a {
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */
    constructor(h, p) {
      super(p);
      Z(this, u);
      /**
       *  The signer address.
       */
      Q(this, "address");
      (0, t.defineProperties)(this, { address: h });
    }
    async getAddress() {
      return this.address;
    }
    connect(h) {
      return new l(this.address, h);
    }
    async signTransaction(h) {
      de(this, u, ad).call(this, "transactions", "signTransaction");
    }
    async signMessage(h) {
      de(this, u, ad).call(this, "messages", "signMessage");
    }
    async signTypedData(h, p, g) {
      de(this, u, ad).call(this, "typed-data", "signTypedData");
    }
  };
  u = new WeakSet(), ad = function(h, p) {
    (0, t.assert)(!1, `VoidSigner cannot sign ${h}`, "UNSUPPORTED_OPERATION", { operation: p });
  };
  let o = l;
  return wa.VoidSigner = o, wa;
}
var kl = {}, Dy;
function Di() {
  if (Dy) return kl;
  Dy = 1, Object.defineProperty(kl, "__esModule", { value: !0 }), kl.showThrottleMessage = void 0;
  const r = /* @__PURE__ */ new Set();
  function e(t) {
    r.has(t) || (r.add(t), console.log("========= NOTICE ========="), console.log(`Request-Rate Exceeded for ${t} (this message will not be repeated)`), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.org/api-keys/"), console.log("=========================="));
  }
  return kl.showThrottleMessage = e, kl;
}
var Tl = {}, Bl = {}, cn = {}, us = {}, jy;
function Xv() {
  var a, o, u, c, l, f, d, Rb, Ib, g;
  if (jy) return us;
  jy = 1, Object.defineProperty(us, "__esModule", { value: !0 }), us.FilterIdPendingSubscriber = us.FilterIdEventSubscriber = us.FilterIdSubscriber = void 0;
  const r = Me(), e = dx();
  function t(k) {
    return JSON.parse(JSON.stringify(k));
  }
  class n {
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */
    constructor(A) {
      Z(this, d);
      Z(this, a);
      Z(this, o);
      Z(this, u);
      Z(this, c);
      Z(this, l);
      Z(this, f);
      F(this, a, A), F(this, o, null), F(this, u, de(this, d, Rb).bind(this)), F(this, c, !1), F(this, l, null), F(this, f, !1);
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */
    _subscribe(A) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */
    _emitResults(A, y) {
      throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */
    _recover(A) {
      throw new Error("subclasses must override this");
    }
    start() {
      x(this, c) || (F(this, c, !0), de(this, d, Rb).call(this, -2));
    }
    stop() {
      x(this, c) && (F(this, c, !1), F(this, f, !0), de(this, d, Ib).call(this), x(this, a).off("block", x(this, u)));
    }
    pause(A) {
      A && de(this, d, Ib).call(this), x(this, a).off("block", x(this, u));
    }
    resume() {
      this.start();
    }
  }
  a = new WeakMap(), o = new WeakMap(), u = new WeakMap(), c = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakSet(), Rb = async function(A) {
    try {
      x(this, o) == null && F(this, o, this._subscribe(x(this, a)));
      let y = null;
      try {
        y = await x(this, o);
      } catch (N) {
        if (!(0, r.isError)(N, "UNSUPPORTED_OPERATION") || N.operation !== "eth_newFilter")
          throw N;
      }
      if (y == null) {
        F(this, o, null), x(this, a)._recoverSubscriber(this, this._recover(x(this, a)));
        return;
      }
      const E = await x(this, a).getNetwork();
      if (x(this, l) || F(this, l, E), x(this, l).chainId !== E.chainId)
        throw new Error("chaid changed");
      if (x(this, f))
        return;
      const m = await x(this, a).send("eth_getFilterChanges", [y]);
      await this._emitResults(x(this, a), m);
    } catch (y) {
      console.log("@TODO", y);
    }
    x(this, a).once("block", x(this, u));
  }, Ib = function() {
    const A = x(this, o);
    A && (F(this, o, null), A.then((y) => {
      x(this, a).destroyed || x(this, a).send("eth_uninstallFilter", [y]);
    }));
  }, us.FilterIdSubscriber = n;
  class s extends n {
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */
    constructor(y, E) {
      super(y);
      Z(this, g);
      F(this, g, t(E));
    }
    _recover(y) {
      return new e.PollingEventSubscriber(y, x(this, g));
    }
    async _subscribe(y) {
      return await y.send("eth_newFilter", [x(this, g)]);
    }
    async _emitResults(y, E) {
      for (const m of E)
        y.emit(x(this, g), y._wrapLog(m, y._network));
    }
  }
  g = new WeakMap(), us.FilterIdEventSubscriber = s;
  class i extends n {
    async _subscribe(A) {
      return await A.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(A, y) {
      for (const E of y)
        A.emit("pending", E);
    }
  }
  return us.FilterIdPendingSubscriber = i, us;
}
var Hy;
function Rn() {
  var U, R, j, D, O, I, P, S, _b, C, H;
  if (Hy) return cn;
  Hy = 1, Object.defineProperty(cn, "__esModule", { value: !0 }), cn.JsonRpcProvider = cn.JsonRpcApiPollingProvider = cn.JsonRpcApiProvider = cn.JsonRpcSigner = void 0;
  const r = df(), e = zt(), t = Ys(), n = Lr(), s = Me(), i = pf(), a = hx(), o = Mr(), u = Xv(), c = dx(), l = "bigint,boolean,function,number,string,symbol".split(/,/g);
  function f(V) {
    if (V == null || l.indexOf(typeof V) >= 0 || typeof V.getAddress == "function")
      return V;
    if (Array.isArray(V))
      return V.map(f);
    if (typeof V == "object")
      return Object.keys(V).reduce((J, M) => (J[M] = V[M], J), {});
    throw new Error(`should not happen: ${V} (${typeof V})`);
  }
  function d(V) {
    return new Promise((J) => {
      setTimeout(J, V);
    });
  }
  function h(V) {
    return V && V.toLowerCase();
  }
  function p(V) {
    return V && typeof V.pollingInterval == "number";
  }
  const g = {
    polling: !1,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1 << 20,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4e3
  };
  class k extends a.AbstractSigner {
    constructor(M, G) {
      super(M);
      Q(this, "address");
      G = (0, e.getAddress)(G), (0, s.defineProperties)(this, { address: G });
    }
    connect(M) {
      (0, s.assert)(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
        operation: "signer.connect"
      });
    }
    async getAddress() {
      return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(M) {
      return await this.populateCall(M);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(M) {
      const G = f(M), K = [];
      if (G.from) {
        const te = G.from;
        K.push((async () => {
          const pe = await (0, e.resolveAddress)(te, this.provider);
          (0, s.assertArgument)(pe != null && pe.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", M), G.from = pe;
        })());
      } else
        G.from = this.address;
      if (G.gasLimit == null && K.push((async () => {
        G.gasLimit = await this.provider.estimateGas({ ...G, from: this.address });
      })()), G.to != null) {
        const te = G.to;
        K.push((async () => {
          G.to = await (0, e.resolveAddress)(te, this.provider);
        })());
      }
      K.length && await Promise.all(K);
      const X = this.provider.getRpcTransaction(G);
      return this.provider.send("eth_sendTransaction", [X]);
    }
    async sendTransaction(M) {
      const G = await this.provider.getBlockNumber(), K = await this.sendUncheckedTransaction(M);
      return await new Promise((X, te) => {
        const pe = [1e3, 100];
        let he = 0;
        const ye = async () => {
          try {
            const re = await this.provider.getTransaction(K);
            if (re != null) {
              X(re.replaceableTransaction(G));
              return;
            }
          } catch (re) {
            if ((0, s.isError)(re, "CANCELLED") || (0, s.isError)(re, "BAD_DATA") || (0, s.isError)(re, "NETWORK_ERROR") || (0, s.isError)(re, "UNSUPPORTED_OPERATION")) {
              re.info == null && (re.info = {}), re.info.sendTransactionHash = K, te(re);
              return;
            }
            if ((0, s.isError)(re, "INVALID_ARGUMENT") && (he++, re.info == null && (re.info = {}), re.info.sendTransactionHash = K, he > 10)) {
              te(re);
              return;
            }
            this.provider.emit("error", (0, s.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: re }));
          }
          this.provider._setTimeout(() => {
            ye();
          }, pe.pop() || 4e3);
        };
        ye();
      });
    }
    async signTransaction(M) {
      const G = f(M);
      if (G.from) {
        const X = await (0, e.resolveAddress)(G.from, this.provider);
        (0, s.assertArgument)(X != null && X.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", M), G.from = X;
      } else
        G.from = this.address;
      const K = this.provider.getRpcTransaction(G);
      return await this.provider.send("eth_signTransaction", [K]);
    }
    async signMessage(M) {
      const G = typeof M == "string" ? (0, s.toUtf8Bytes)(M) : M;
      return await this.provider.send("personal_sign", [
        (0, s.hexlify)(G),
        this.address.toLowerCase()
      ]);
    }
    async signTypedData(M, G, K) {
      const X = f(K), te = await t.TypedDataEncoder.resolveNames(M, G, X, async (pe) => {
        const he = await (0, e.resolveAddress)(pe);
        return (0, s.assertArgument)(he != null, "TypedData does not support null address", "value", pe), he;
      });
      return await this.provider.send("eth_signTypedData_v4", [
        this.address.toLowerCase(),
        JSON.stringify(t.TypedDataEncoder.getPayload(te.domain, G, te.value))
      ]);
    }
    async unlock(M) {
      return this.provider.send("personal_unlockAccount", [
        this.address.toLowerCase(),
        M,
        null
      ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(M) {
      const G = typeof M == "string" ? (0, s.toUtf8Bytes)(M) : M;
      return await this.provider.send("eth_sign", [
        this.address.toLowerCase(),
        (0, s.hexlify)(G)
      ]);
    }
  }
  cn.JsonRpcSigner = k;
  class A extends i.AbstractProvider {
    constructor(M, G) {
      super(M, G);
      Z(this, S);
      Z(this, U);
      // The next ID to use for the JSON-RPC ID field
      Z(this, R);
      // Payloads are queued and triggered in batches using the drainTimer
      Z(this, j);
      Z(this, D);
      Z(this, O);
      Z(this, I);
      Z(this, P);
      F(this, R, 1), F(this, U, Object.assign({}, g, G || {})), F(this, j, []), F(this, D, null), F(this, I, null), F(this, P, null);
      {
        let X = null;
        const te = new Promise((pe) => {
          X = pe;
        });
        F(this, O, { promise: te, resolve: X });
      }
      const K = this._getOption("staticNetwork");
      typeof K == "boolean" ? ((0, s.assertArgument)(!K || M !== "any", "staticNetwork cannot be used on special network 'any'", "options", G), K && M != null && F(this, I, o.Network.from(M))) : K && ((0, s.assertArgument)(M == null || K.matches(M), "staticNetwork MUST match network object", "options", G), F(this, I, K));
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */
    _getOption(M) {
      return x(this, U)[M];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */
    get _network() {
      return (0, s.assert)(x(this, I), "network is not available yet", "NETWORK_ERROR"), x(this, I);
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */
    async _perform(M) {
      if (M.method === "call" || M.method === "estimateGas") {
        let K = M.transaction;
        if (K && K.type != null && (0, s.getBigInt)(K.type) && K.maxFeePerGas == null && K.maxPriorityFeePerGas == null) {
          const X = await this.getFeeData();
          X.maxFeePerGas == null && X.maxPriorityFeePerGas == null && (M = Object.assign({}, M, {
            transaction: Object.assign({}, K, { type: void 0 })
          }));
        }
      }
      const G = this.getRpcRequest(M);
      return G != null ? await this.send(G.method, G.args) : super._perform(M);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */
    async _detectNetwork() {
      const M = this._getOption("staticNetwork");
      if (M)
        if (M === !0) {
          if (x(this, I))
            return x(this, I);
        } else
          return M;
      return x(this, P) ? await x(this, P) : this.ready ? (F(this, P, (async () => {
        try {
          const G = o.Network.from((0, s.getBigInt)(await this.send("eth_chainId", [])));
          return F(this, P, null), G;
        } catch (G) {
          throw F(this, P, null), G;
        }
      })()), await x(this, P)) : (F(this, P, (async () => {
        const G = {
          id: rn(this, R)._++,
          method: "eth_chainId",
          params: [],
          jsonrpc: "2.0"
        };
        this.emit("debug", { action: "sendRpcPayload", payload: G });
        let K;
        try {
          K = (await this._send(G))[0], F(this, P, null);
        } catch (X) {
          throw F(this, P, null), this.emit("debug", { action: "receiveRpcError", error: X }), X;
        }
        if (this.emit("debug", { action: "receiveRpcResult", result: K }), "result" in K)
          return o.Network.from((0, s.getBigInt)(K.result));
        throw this.getRpcError(G, K);
      })()), await x(this, P));
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */
    _start() {
      x(this, O) == null || x(this, O).resolve == null || (x(this, O).resolve(), F(this, O, null), (async () => {
        for (; x(this, I) == null && !this.destroyed; )
          try {
            F(this, I, await this._detectNetwork());
          } catch (M) {
            if (this.destroyed)
              break;
            console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", (0, s.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: M } })), await d(1e3);
          }
        de(this, S, _b).call(this);
      })());
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */
    async _waitUntilReady() {
      if (x(this, O) != null)
        return await x(this, O).promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */
    _getSubscriber(M) {
      return M.type === "pending" ? new u.FilterIdPendingSubscriber(this) : M.type === "event" ? this._getOption("polling") ? new c.PollingEventSubscriber(this, M.filter) : new u.FilterIdEventSubscriber(this, M.filter) : M.type === "orphan" && M.filter.orphan === "drop-log" ? new i.UnmanagedSubscriber("orphan") : super._getSubscriber(M);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */
    get ready() {
      return x(this, O) == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */
    getRpcTransaction(M) {
      const G = {};
      return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((K) => {
        if (M[K] == null)
          return;
        let X = K;
        K === "gasLimit" && (X = "gas"), G[X] = (0, s.toQuantity)((0, s.getBigInt)(M[K], `tx.${K}`));
      }), ["from", "to", "data"].forEach((K) => {
        M[K] != null && (G[K] = (0, s.hexlify)(M[K]));
      }), M.accessList && (G.accessList = (0, n.accessListify)(M.accessList)), M.blobVersionedHashes && (G.blobVersionedHashes = M.blobVersionedHashes.map((K) => K.toLowerCase())), G;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */
    getRpcRequest(M) {
      switch (M.method) {
        case "chainId":
          return { method: "eth_chainId", args: [] };
        case "getBlockNumber":
          return { method: "eth_blockNumber", args: [] };
        case "getGasPrice":
          return { method: "eth_gasPrice", args: [] };
        case "getPriorityFee":
          return { method: "eth_maxPriorityFeePerGas", args: [] };
        case "getBalance":
          return {
            method: "eth_getBalance",
            args: [h(M.address), M.blockTag]
          };
        case "getTransactionCount":
          return {
            method: "eth_getTransactionCount",
            args: [h(M.address), M.blockTag]
          };
        case "getCode":
          return {
            method: "eth_getCode",
            args: [h(M.address), M.blockTag]
          };
        case "getStorage":
          return {
            method: "eth_getStorageAt",
            args: [
              h(M.address),
              "0x" + M.position.toString(16),
              M.blockTag
            ]
          };
        case "broadcastTransaction":
          return {
            method: "eth_sendRawTransaction",
            args: [M.signedTransaction]
          };
        case "getBlock":
          if ("blockTag" in M)
            return {
              method: "eth_getBlockByNumber",
              args: [M.blockTag, !!M.includeTransactions]
            };
          if ("blockHash" in M)
            return {
              method: "eth_getBlockByHash",
              args: [M.blockHash, !!M.includeTransactions]
            };
          break;
        case "getTransaction":
          return {
            method: "eth_getTransactionByHash",
            args: [M.hash]
          };
        case "getTransactionReceipt":
          return {
            method: "eth_getTransactionReceipt",
            args: [M.hash]
          };
        case "call":
          return {
            method: "eth_call",
            args: [this.getRpcTransaction(M.transaction), M.blockTag]
          };
        case "estimateGas":
          return {
            method: "eth_estimateGas",
            args: [this.getRpcTransaction(M.transaction)]
          };
        case "getLogs":
          return M.filter && M.filter.address != null && (Array.isArray(M.filter.address) ? M.filter.address = M.filter.address.map(h) : M.filter.address = h(M.filter.address)), { method: "eth_getLogs", args: [M.filter] };
      }
      return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */
    getRpcError(M, G) {
      const { method: K } = M, { error: X } = G;
      if (K === "eth_estimateGas" && X.message) {
        const he = X.message;
        if (!he.match(/revert/i) && he.match(/insufficient funds/i))
          return (0, s.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
            transaction: M.params[0],
            info: { payload: M, error: X }
          });
      }
      if (K === "eth_call" || K === "eth_estimateGas") {
        const he = m(X), ye = r.AbiCoder.getBuiltinCallException(K === "eth_call" ? "call" : "estimateGas", M.params[0], he ? he.data : null);
        return ye.info = { error: X, payload: M }, ye;
      }
      const te = JSON.stringify(T(X));
      if (typeof X.message == "string" && X.message.match(/user denied|ethers-user-denied/i)) {
        const he = {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        };
        return (0, s.makeError)("user rejected action", "ACTION_REJECTED", {
          action: he[K] || "unknown",
          reason: "rejected",
          info: { payload: M, error: X }
        });
      }
      if (K === "eth_sendRawTransaction" || K === "eth_sendTransaction") {
        const he = M.params[0];
        if (te.match(/insufficient funds|base fee exceeds gas limit/i))
          return (0, s.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
            transaction: he,
            info: { error: X }
          });
        if (te.match(/nonce/i) && te.match(/too low/i))
          return (0, s.makeError)("nonce has already been used", "NONCE_EXPIRED", { transaction: he, info: { error: X } });
        if (te.match(/replacement transaction/i) && te.match(/underpriced/i))
          return (0, s.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: he, info: { error: X } });
        if (te.match(/only replay-protected/i))
          return (0, s.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
            operation: K,
            info: { transaction: he, info: { error: X } }
          });
      }
      let pe = !!te.match(/the method .* does not exist/i);
      return pe || X && X.details && X.details.startsWith("Unauthorized method:") && (pe = !0), pe ? (0, s.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
        operation: M.method,
        info: { error: X, payload: M }
      }) : (0, s.makeError)("could not coalesce error", "UNKNOWN_ERROR", { error: X, payload: M });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */
    send(M, G) {
      if (this.destroyed)
        return Promise.reject((0, s.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: M }));
      const K = rn(this, R)._++, X = new Promise((te, pe) => {
        x(this, j).push({
          resolve: te,
          reject: pe,
          payload: { method: M, params: G, id: K, jsonrpc: "2.0" }
        });
      });
      return de(this, S, _b).call(this), X;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */
    async getSigner(M) {
      M == null && (M = 0);
      const G = this.send("eth_accounts", []);
      if (typeof M == "number") {
        const X = await G;
        if (M >= X.length)
          throw new Error("no such account");
        return new k(this, X[M]);
      }
      const { accounts: K } = await (0, s.resolveProperties)({
        network: this.getNetwork(),
        accounts: G
      });
      M = (0, e.getAddress)(M);
      for (const X of K)
        if ((0, e.getAddress)(X) === M)
          return new k(this, M);
      throw new Error("invalid account");
    }
    async listAccounts() {
      return (await this.send("eth_accounts", [])).map((G) => new k(this, G));
    }
    destroy() {
      x(this, D) && (clearTimeout(x(this, D)), F(this, D, null));
      for (const { payload: M, reject: G } of x(this, j))
        G((0, s.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: M.method }));
      F(this, j, []), super.destroy();
    }
  }
  U = new WeakMap(), R = new WeakMap(), j = new WeakMap(), D = new WeakMap(), O = new WeakMap(), I = new WeakMap(), P = new WeakMap(), S = new WeakSet(), _b = function() {
    if (x(this, D))
      return;
    const M = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
    F(this, D, setTimeout(() => {
      F(this, D, null);
      const G = x(this, j);
      for (F(this, j, []); G.length; ) {
        const K = [G.shift()];
        for (; G.length && K.length !== x(this, U).batchMaxCount; )
          if (K.push(G.shift()), JSON.stringify(K.map((te) => te.payload)).length > x(this, U).batchMaxSize) {
            G.unshift(K.pop());
            break;
          }
        (async () => {
          const X = K.length === 1 ? K[0].payload : K.map((te) => te.payload);
          this.emit("debug", { action: "sendRpcPayload", payload: X });
          try {
            const te = await this._send(X);
            this.emit("debug", { action: "receiveRpcResult", result: te });
            for (const { resolve: pe, reject: he, payload: ye } of K) {
              if (this.destroyed) {
                he((0, s.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: ye.method }));
                continue;
              }
              const re = te.filter((ae) => ae.id === ye.id)[0];
              if (re == null) {
                const ae = (0, s.makeError)("missing response for request", "BAD_DATA", {
                  value: te,
                  info: { payload: ye }
                });
                this.emit("error", ae), he(ae);
                continue;
              }
              if ("error" in re) {
                he(this.getRpcError(ye, re));
                continue;
              }
              pe(re.result);
            }
          } catch (te) {
            this.emit("debug", { action: "receiveRpcError", error: te });
            for (const { reject: pe } of K)
              pe(te);
          }
        })();
      }
    }, M));
  }, cn.JsonRpcApiProvider = A;
  class y extends A {
    constructor(M, G) {
      super(M, G);
      Z(this, C);
      let K = this._getOption("pollingInterval");
      K == null && (K = g.pollingInterval), F(this, C, K);
    }
    _getSubscriber(M) {
      const G = super._getSubscriber(M);
      return p(G) && (G.pollingInterval = x(this, C)), G;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */
    get pollingInterval() {
      return x(this, C);
    }
    set pollingInterval(M) {
      if (!Number.isInteger(M) || M < 0)
        throw new Error("invalid interval");
      F(this, C, M), this._forEachSubscriber((G) => {
        p(G) && (G.pollingInterval = x(this, C));
      });
    }
  }
  C = new WeakMap(), cn.JsonRpcApiPollingProvider = y;
  class E extends y {
    constructor(M, G, K) {
      M == null && (M = "http://localhost:8545");
      super(G, K);
      Z(this, H);
      typeof M == "string" ? F(this, H, new s.FetchRequest(M)) : F(this, H, M.clone());
    }
    _getConnection() {
      return x(this, H).clone();
    }
    async send(M, G) {
      return await this._start(), await super.send(M, G);
    }
    async _send(M) {
      const G = this._getConnection();
      G.body = JSON.stringify(M), G.setHeader("content-type", "application/json");
      const K = await G.send();
      K.assertOk();
      let X = K.bodyJson;
      return Array.isArray(X) || (X = [X]), X;
    }
  }
  H = new WeakMap(), cn.JsonRpcProvider = E;
  function m(V) {
    if (V == null)
      return null;
    if (typeof V.message == "string" && V.message.match(/revert/i) && (0, s.isHexString)(V.data))
      return { message: V.message, data: V.data };
    if (typeof V == "object") {
      for (const J in V) {
        const M = m(V[J]);
        if (M)
          return M;
      }
      return null;
    }
    if (typeof V == "string")
      try {
        return m(JSON.parse(V));
      } catch {
      }
    return null;
  }
  function N(V, J) {
    if (V != null) {
      if (typeof V.message == "string" && J.push(V.message), typeof V == "object")
        for (const M in V)
          N(V[M], J);
      if (typeof V == "string")
        try {
          return N(JSON.parse(V), J);
        } catch {
        }
    }
  }
  function T(V) {
    const J = [];
    return N(V, J), J;
  }
  return cn;
}
var Gy;
function h6() {
  if (Gy) return Bl;
  Gy = 1, Object.defineProperty(Bl, "__esModule", { value: !0 }), Bl.AnkrProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn(), s = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
  function i(o) {
    switch (o) {
      case "mainnet":
        return "rpc.ankr.com/eth";
      case "goerli":
        return "rpc.ankr.com/eth_goerli";
      case "sepolia":
        return "rpc.ankr.com/eth_sepolia";
      case "arbitrum":
        return "rpc.ankr.com/arbitrum";
      case "base":
        return "rpc.ankr.com/base";
      case "base-goerli":
        return "rpc.ankr.com/base_goerli";
      case "base-sepolia":
        return "rpc.ankr.com/base_sepolia";
      case "bnb":
        return "rpc.ankr.com/bsc";
      case "bnbt":
        return "rpc.ankr.com/bsc_testnet_chapel";
      case "matic":
        return "rpc.ankr.com/polygon";
      case "matic-mumbai":
        return "rpc.ankr.com/polygon_mumbai";
      case "optimism":
        return "rpc.ankr.com/optimism";
      case "optimism-goerli":
        return "rpc.ankr.com/optimism_testnet";
      case "optimism-sepolia":
        return "rpc.ankr.com/optimism_sepolia";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **AnkrProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(c, l) {
      c == null && (c = "mainnet");
      const f = t.Network.from(c);
      l == null && (l = s);
      const d = { polling: !0, staticNetwork: f }, h = a.getRequest(f, l);
      super(h, f, d);
      /**
       *  The API key for the Ankr connection.
       */
      Q(this, "apiKey");
      (0, r.defineProperties)(this, { apiKey: l });
    }
    _getProvider(c) {
      try {
        return new a(c, this.apiKey);
      } catch {
      }
      return super._getProvider(c);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%apiKey%%.
     */
    static getRequest(c, l) {
      l == null && (l = s);
      const f = new r.FetchRequest(`https://${i(c.name)}/${l}`);
      return f.allowGzip = !0, l === s && (f.retryFunc = async (d, h, p) => ((0, e.showThrottleMessage)("AnkrProvider"), !0)), f;
    }
    getRpcError(c, l) {
      return c.method === "eth_sendRawTransaction" && l && l.error && l.error.message === "INTERNAL_ERROR: could not replace existing tx" && (l.error.message = "replacement transaction underpriced"), super.getRpcError(c, l);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
  }
  return Bl.AnkrProvider = a, Bl;
}
var Ol = {}, Vy;
function p6() {
  if (Vy) return Ol;
  Vy = 1, Object.defineProperty(Ol, "__esModule", { value: !0 }), Ol.AlchemyProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn(), s = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
  function i(o) {
    switch (o) {
      case "mainnet":
        return "eth-mainnet.alchemyapi.io";
      case "goerli":
        return "eth-goerli.g.alchemy.com";
      case "sepolia":
        return "eth-sepolia.g.alchemy.com";
      case "arbitrum":
        return "arb-mainnet.g.alchemy.com";
      case "arbitrum-goerli":
        return "arb-goerli.g.alchemy.com";
      case "arbitrum-sepolia":
        return "arb-sepolia.g.alchemy.com";
      case "base":
        return "base-mainnet.g.alchemy.com";
      case "base-goerli":
        return "base-goerli.g.alchemy.com";
      case "base-sepolia":
        return "base-sepolia.g.alchemy.com";
      case "matic":
        return "polygon-mainnet.g.alchemy.com";
      case "matic-amoy":
        return "polygon-amoy.g.alchemy.com";
      case "matic-mumbai":
        return "polygon-mumbai.g.alchemy.com";
      case "optimism":
        return "opt-mainnet.g.alchemy.com";
      case "optimism-goerli":
        return "opt-goerli.g.alchemy.com";
      case "optimism-sepolia":
        return "opt-sepolia.g.alchemy.com";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  class a extends n.JsonRpcProvider {
    constructor(c, l) {
      c == null && (c = "mainnet");
      const f = t.Network.from(c);
      l == null && (l = s);
      const d = a.getRequest(f, l);
      super(d, f, { staticNetwork: f });
      Q(this, "apiKey");
      (0, r.defineProperties)(this, { apiKey: l });
    }
    _getProvider(c) {
      try {
        return new a(c, this.apiKey);
      } catch {
      }
      return super._getProvider(c);
    }
    async _perform(c) {
      if (c.method === "getTransactionResult") {
        const { trace: l, tx: f } = await (0, r.resolveProperties)({
          trace: this.send("trace_transaction", [c.hash]),
          tx: this.getTransaction(c.hash)
        });
        if (l == null || f == null)
          return null;
        let d, h = !1;
        try {
          d = l[0].result.output, h = l[0].error === "Reverted";
        } catch {
        }
        if (d)
          return (0, r.assert)(!h, "an error occurred during transaction executions", "CALL_EXCEPTION", {
            action: "getTransactionResult",
            data: d,
            reason: null,
            transaction: f,
            invocation: null,
            revert: null
            // @TODO
          }), d;
        (0, r.assert)(!1, "could not parse trace result", "BAD_DATA", { value: l });
      }
      return await super._perform(c);
    }
    isCommunityResource() {
      return this.apiKey === s;
    }
    static getRequest(c, l) {
      l == null && (l = s);
      const f = new r.FetchRequest(`https://${i(c.name)}/v2/${l}`);
      return f.allowGzip = !0, l === s && (f.retryFunc = async (d, h, p) => ((0, e.showThrottleMessage)("alchemy"), !0)), f;
    }
  }
  return Ol.AlchemyProvider = a, Ol;
}
var Nl = {}, $y;
function b6() {
  if ($y) return Nl;
  $y = 1, Object.defineProperty(Nl, "__esModule", { value: !0 }), Nl.ChainstackProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn();
  function s(o) {
    switch (o) {
      case "mainnet":
        return "39f1d67cedf8b7831010a665328c9197";
      case "arbitrum":
        return "0550c209db33c3abf4cc927e1e18cea1";
      case "bnb":
        return "98b5a77e531614387366f6fc5da097f8";
      case "matic":
        return "cd9d4d70377471aa7c142ec4a4205249";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  function i(o) {
    switch (o) {
      case "mainnet":
        return "ethereum-mainnet.core.chainstack.com";
      case "arbitrum":
        return "arbitrum-mainnet.core.chainstack.com";
      case "bnb":
        return "bsc-mainnet.core.chainstack.com";
      case "matic":
        return "polygon-mainnet.core.chainstack.com";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **ChainstackProvider**.
     */
    constructor(c, l) {
      c == null && (c = "mainnet");
      const f = t.Network.from(c);
      l == null && (l = s(f.name));
      const d = a.getRequest(f, l);
      super(d, f, { staticNetwork: f });
      /**
       *  The API key for the Chainstack connection.
       */
      Q(this, "apiKey");
      (0, r.defineProperties)(this, { apiKey: l });
    }
    _getProvider(c) {
      try {
        return new a(c, this.apiKey);
      } catch {
      }
      return super._getProvider(c);
    }
    isCommunityResource() {
      return this.apiKey === s(this._network.name);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%apiKey%% and %%projectSecret%%.
     */
    static getRequest(c, l) {
      l == null && (l = s(c.name));
      const f = new r.FetchRequest(`https://${i(c.name)}/${l}`);
      return f.allowGzip = !0, l === s(c.name) && (f.retryFunc = async (d, h, p) => ((0, e.showThrottleMessage)("ChainstackProvider"), !0)), f;
    }
  }
  return Nl.ChainstackProvider = a, Nl;
}
var Sl = {}, Ky;
function g6() {
  if (Ky) return Sl;
  Ky = 1, Object.defineProperty(Sl, "__esModule", { value: !0 }), Sl.CloudflareProvider = void 0;
  const r = Me(), e = Mr(), t = Rn();
  class n extends t.JsonRpcProvider {
    constructor(i) {
      i == null && (i = "mainnet");
      const a = e.Network.from(i);
      (0, r.assertArgument)(a.name === "mainnet", "unsupported network", "network", i), super("https://cloudflare-eth.com/", a, { staticNetwork: a });
    }
  }
  return Sl.CloudflareProvider = n, Sl;
}
var Aa = {}, zy;
function x6() {
  var g;
  if (zy) return Aa;
  zy = 1, Object.defineProperty(Aa, "__esModule", { value: !0 }), Aa.EtherscanProvider = Aa.EtherscanPlugin = void 0;
  const r = df(), e = Ph(), t = Lr(), n = Me(), s = pf(), i = Mr(), a = fx(), o = Di(), u = 2e3;
  function c(k) {
    return k && typeof k.then == "function";
  }
  const l = "org.ethers.plugins.provider.Etherscan";
  class f extends a.NetworkPlugin {
    /**
     *  Creates a new **EtherscanProvider** which will use
     *  %%baseUrl%%.
     */
    constructor(y) {
      super(l);
      /**
       *  The Etherscan API base URL.
       */
      Q(this, "baseUrl");
      (0, n.defineProperties)(this, { baseUrl: y });
    }
    clone() {
      return new f(this.baseUrl);
    }
  }
  Aa.EtherscanPlugin = f;
  const d = ["enableCcipRead"];
  let h = 1;
  class p extends s.AbstractProvider {
    /**
     *  Creates a new **EtherscanBaseProvider**.
     */
    constructor(y, E) {
      const m = E ?? null;
      super();
      /**
       *  The connected network.
       */
      Q(this, "network");
      /**
       *  The API key or null if using the community provided bandwidth.
       */
      Q(this, "apiKey");
      Z(this, g);
      const N = i.Network.from(y);
      F(this, g, N.getPlugin(l)), (0, n.defineProperties)(this, { apiKey: m, network: N }), this.getBaseUrl();
    }
    /**
     *  Returns the base URL.
     *
     *  If an [[EtherscanPlugin]] is configured on the
     *  [[EtherscanBaseProvider_network]], returns the plugin's
     *  baseUrl.
     */
    getBaseUrl() {
      if (x(this, g))
        return x(this, g).baseUrl;
      switch (this.network.name) {
        case "mainnet":
          return "https://api.etherscan.io";
        case "goerli":
          return "https://api-goerli.etherscan.io";
        case "sepolia":
          return "https://api-sepolia.etherscan.io";
        case "holesky":
          return "https://api-holesky.etherscan.io";
        case "arbitrum":
          return "https://api.arbiscan.io";
        case "arbitrum-goerli":
          return "https://api-goerli.arbiscan.io";
        case "base":
          return "https://api.basescan.org";
        case "base-sepolia":
          return "https://api-sepolia.basescan.org";
        case "bnb":
          return "https://api.bscscan.com";
        case "bnbt":
          return "https://api-testnet.bscscan.com";
        case "matic":
          return "https://api.polygonscan.com";
        case "matic-amoy":
          return "https://api-amoy.polygonscan.com";
        case "matic-mumbai":
          return "https://api-testnet.polygonscan.com";
        case "optimism":
          return "https://api-optimistic.etherscan.io";
        case "optimism-goerli":
          return "https://api-goerli-optimistic.etherscan.io";
      }
      (0, n.assertArgument)(!1, "unsupported network", "network", this.network);
    }
    /**
     *  Returns the URL for the %%module%% and %%params%%.
     */
    getUrl(y, E) {
      const m = Object.keys(E).reduce((T, U) => {
        const R = E[U];
        return R != null && (T += `&${U}=${R}`), T;
      }, ""), N = this.apiKey ? `&apikey=${this.apiKey}` : "";
      return `${this.getBaseUrl()}/api?module=${y}${m}${N}`;
    }
    /**
     *  Returns the URL for using POST requests.
     */
    getPostUrl() {
      return `${this.getBaseUrl()}/api`;
    }
    /**
     *  Returns the parameters for using POST requests.
     */
    getPostData(y, E) {
      return E.module = y, E.apikey = this.apiKey, E;
    }
    async detectNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the result of calling %%module%% with %%params%%.
     *
     *  If %%post%%, the request is made as a POST request.
     */
    async fetch(y, E, m) {
      const N = h++, T = m ? this.getPostUrl() : this.getUrl(y, E), U = m ? this.getPostData(y, E) : null;
      this.emit("debug", { action: "sendRequest", id: N, url: T, payload: U });
      const R = new n.FetchRequest(T);
      R.setThrottleParams({ slotInterval: 1e3 }), R.retryFunc = (O, I, P) => (this.isCommunityResource() && (0, o.showThrottleMessage)("Etherscan"), Promise.resolve(!0)), R.processFunc = async (O, I) => {
        const P = I.hasBody() ? JSON.parse((0, n.toUtf8String)(I.body)) : {}, S = (typeof P.result == "string" ? P.result : "").toLowerCase().indexOf("rate limit") >= 0;
        return y === "proxy" ? P && P.status == 0 && P.message == "NOTOK" && S && (this.emit("debug", { action: "receiveError", id: N, reason: "proxy-NOTOK", error: P }), I.throwThrottleError(P.result, u)) : S && (this.emit("debug", { action: "receiveError", id: N, reason: "null result", error: P.result }), I.throwThrottleError(P.result, u)), I;
      }, U && (R.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8"), R.body = Object.keys(U).map((O) => `${O}=${U[O]}`).join("&"));
      const j = await R.send();
      try {
        j.assertOk();
      } catch (O) {
        this.emit("debug", { action: "receiveError", id: N, error: O, reason: "assertOk" }), (0, n.assert)(!1, "response error", "SERVER_ERROR", { request: R, response: j });
      }
      j.hasBody() || (this.emit("debug", { action: "receiveError", id: N, error: "missing body", reason: "null body" }), (0, n.assert)(!1, "missing response", "SERVER_ERROR", { request: R, response: j }));
      const D = JSON.parse((0, n.toUtf8String)(j.body));
      return y === "proxy" ? (D.jsonrpc != "2.0" && (this.emit("debug", { action: "receiveError", id: N, result: D, reason: "invalid JSON-RPC" }), (0, n.assert)(!1, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", { request: R, response: j, info: { result: D } })), D.error && (this.emit("debug", { action: "receiveError", id: N, result: D, reason: "JSON-RPC error" }), (0, n.assert)(!1, "error response", "SERVER_ERROR", { request: R, response: j, info: { result: D } })), this.emit("debug", { action: "receiveRequest", id: N, result: D }), D.result) : D.status == 0 && (D.message === "No records found" || D.message === "No transactions found") ? (this.emit("debug", { action: "receiveRequest", id: N, result: D }), D.result) : ((D.status != 1 || typeof D.message == "string" && !D.message.match(/^OK/)) && (this.emit("debug", { action: "receiveError", id: N, result: D }), (0, n.assert)(!1, "error response", "SERVER_ERROR", { request: R, response: j, info: { result: D } })), this.emit("debug", { action: "receiveRequest", id: N, result: D }), D.result);
    }
    /**
     *  Returns %%transaction%% normalized for the Etherscan API.
     */
    _getTransactionPostData(y) {
      const E = {};
      for (let m in y) {
        if (d.indexOf(m) >= 0 || y[m] == null)
          continue;
        let N = y[m];
        if (!(m === "type" && N === 0) && !(m === "blockTag" && N === "latest")) {
          if ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[m])
            N = (0, n.toQuantity)(N);
          else if (m === "accessList")
            N = "[" + (0, t.accessListify)(N).map((T) => `{address:"${T.address}",storageKeys:["${T.storageKeys.join('","')}"]}`).join(",") + "]";
          else if (m === "blobVersionedHashes") {
            if (N.length === 0)
              continue;
            (0, n.assert)(!1, "Etherscan API does not support blobVersionedHashes", "UNSUPPORTED_OPERATION", {
              operation: "_getTransactionPostData",
              info: { transaction: y }
            });
          } else
            N = (0, n.hexlify)(N);
          E[m] = N;
        }
      }
      return E;
    }
    /**
     *  Throws the normalized Etherscan error.
     */
    _checkError(y, E, m) {
      let N = "";
      if ((0, n.isError)(E, "SERVER_ERROR")) {
        try {
          N = E.info.result.error.message;
        } catch {
        }
        if (!N)
          try {
            N = E.info.message;
          } catch {
          }
      }
      if (y.method === "estimateGas" && !N.match(/revert/i) && N.match(/insufficient funds/i) && (0, n.assert)(!1, "insufficient funds", "INSUFFICIENT_FUNDS", {
        transaction: y.transaction
      }), (y.method === "call" || y.method === "estimateGas") && N.match(/execution reverted/i)) {
        let T = "";
        try {
          T = E.info.result.error.data;
        } catch {
        }
        const U = r.AbiCoder.getBuiltinCallException(y.method, y.transaction, T);
        throw U.info = { request: y, error: E }, U;
      }
      if (N && y.method === "broadcastTransaction") {
        const T = t.Transaction.from(y.signedTransaction);
        N.match(/replacement/i) && N.match(/underpriced/i) && (0, n.assert)(!1, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
          transaction: T
        }), N.match(/insufficient funds/) && (0, n.assert)(!1, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: T
        }), N.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && (0, n.assert)(!1, "nonce has already been used", "NONCE_EXPIRED", {
          transaction: T
        });
      }
      throw E;
    }
    async _detectNetwork() {
      return this.network;
    }
    async _perform(y) {
      switch (y.method) {
        case "chainId":
          return this.network.chainId;
        case "getBlockNumber":
          return this.fetch("proxy", { action: "eth_blockNumber" });
        case "getGasPrice":
          return this.fetch("proxy", { action: "eth_gasPrice" });
        case "getPriorityFee":
          if (this.network.name === "mainnet")
            return "1000000000";
          if (this.network.name === "optimism")
            return "1000000";
          throw new Error("fallback onto the AbstractProvider default");
        case "getBalance":
          return this.fetch("account", {
            action: "balance",
            address: y.address,
            tag: y.blockTag
          });
        case "getTransactionCount":
          return this.fetch("proxy", {
            action: "eth_getTransactionCount",
            address: y.address,
            tag: y.blockTag
          });
        case "getCode":
          return this.fetch("proxy", {
            action: "eth_getCode",
            address: y.address,
            tag: y.blockTag
          });
        case "getStorage":
          return this.fetch("proxy", {
            action: "eth_getStorageAt",
            address: y.address,
            position: y.position,
            tag: y.blockTag
          });
        case "broadcastTransaction":
          return this.fetch("proxy", {
            action: "eth_sendRawTransaction",
            hex: y.signedTransaction
          }, !0).catch((E) => this._checkError(y, E, y.signedTransaction));
        case "getBlock":
          if ("blockTag" in y)
            return this.fetch("proxy", {
              action: "eth_getBlockByNumber",
              tag: y.blockTag,
              boolean: y.includeTransactions ? "true" : "false"
            });
          (0, n.assert)(!1, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
            operation: "getBlock(blockHash)"
          });
        case "getTransaction":
          return this.fetch("proxy", {
            action: "eth_getTransactionByHash",
            txhash: y.hash
          });
        case "getTransactionReceipt":
          return this.fetch("proxy", {
            action: "eth_getTransactionReceipt",
            txhash: y.hash
          });
        case "call": {
          if (y.blockTag !== "latest")
            throw new Error("EtherscanProvider does not support blockTag for call");
          const E = this._getTransactionPostData(y.transaction);
          E.module = "proxy", E.action = "eth_call";
          try {
            return await this.fetch("proxy", E, !0);
          } catch (m) {
            return this._checkError(y, m, y.transaction);
          }
        }
        case "estimateGas": {
          const E = this._getTransactionPostData(y.transaction);
          E.module = "proxy", E.action = "eth_estimateGas";
          try {
            return await this.fetch("proxy", E, !0);
          } catch (m) {
            return this._checkError(y, m, y.transaction);
          }
        }
      }
      return super._perform(y);
    }
    async getNetwork() {
      return this.network;
    }
    /**
     *  Resolves to the current price of ether.
     *
     *  This returns ``0`` on any network other than ``mainnet``.
     */
    async getEtherPrice() {
      return this.network.name !== "mainnet" ? 0 : parseFloat((await this.fetch("stats", { action: "ethprice" })).ethusd);
    }
    /**
     *  Resolves to a [Contract]] for %%address%%, using the
     *  Etherscan API to retreive the Contract ABI.
     */
    async getContract(y) {
      let E = this._getAddress(y);
      c(E) && (E = await E);
      try {
        const m = await this.fetch("contract", {
          action: "getabi",
          address: E
        }), N = JSON.parse(m);
        return new e.Contract(E, N, this);
      } catch {
        return null;
      }
    }
    isCommunityResource() {
      return this.apiKey == null;
    }
  }
  return g = new WeakMap(), Aa.EtherscanProvider = p, Aa;
}
var Ea = {}, Cl = {}, Rl = {}, Jy;
function ek() {
  if (Jy) return Rl;
  Jy = 1, Object.defineProperty(Rl, "__esModule", { value: !0 }), Rl.WebSocket = void 0;
  function r() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof nt < "u")
      return nt;
    throw new Error("unable to locate global object");
  }
  const e = r().WebSocket;
  return Rl.WebSocket = e, Rl;
}
var Pr = {}, Qy;
function Ub() {
  var u, c, l, f, d, h, p, g, k;
  if (Qy) return Pr;
  Qy = 1, Object.defineProperty(Pr, "__esModule", { value: !0 }), Pr.SocketProvider = Pr.SocketEventSubscriber = Pr.SocketPendingSubscriber = Pr.SocketBlockSubscriber = Pr.SocketSubscriber = void 0;
  const r = pf(), e = Me(), t = Rn();
  class n {
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */
    constructor(y, E) {
      Z(this, u);
      Z(this, c);
      Z(this, l);
      Z(this, f);
      Z(this, d);
      F(this, u, y), F(this, c, JSON.stringify(E)), F(this, l, null), F(this, f, null), F(this, d, null);
    }
    /**
     *  The filter.
     */
    get filter() {
      return JSON.parse(x(this, c));
    }
    start() {
      F(this, l, x(this, u).send("eth_subscribe", this.filter).then((y) => (x(this, u)._register(y, this), y)));
    }
    stop() {
      x(this, l).then((y) => {
        x(this, u).destroyed || x(this, u).send("eth_unsubscribe", [y]);
      }), F(this, l, null);
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(y) {
      (0, e.assert)(y, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", { operation: "pause(false)" }), F(this, f, !!y);
    }
    resume() {
      F(this, f, null);
    }
    /**
     *  @_ignore:
     */
    _handleMessage(y) {
      if (x(this, l) != null && x(this, f) === null) {
        let E = x(this, d);
        E == null ? E = this._emit(x(this, u), y) : E = E.then(async () => {
          await this._emit(x(this, u), y);
        }), F(this, d, E.then(() => {
          x(this, d) === E && F(this, d, null);
        }));
      }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */
    async _emit(y, E) {
      throw new Error("sub-classes must implemente this; _emit");
    }
  }
  u = new WeakMap(), c = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), Pr.SocketSubscriber = n;
  class s extends n {
    /**
     *  @_ignore:
     */
    constructor(y) {
      super(y, ["newHeads"]);
    }
    async _emit(y, E) {
      y.emit("block", parseInt(E.number));
    }
  }
  Pr.SocketBlockSubscriber = s;
  class i extends n {
    /**
     *  @_ignore:
     */
    constructor(y) {
      super(y, ["newPendingTransactions"]);
    }
    async _emit(y, E) {
      y.emit("pending", E);
    }
  }
  Pr.SocketPendingSubscriber = i;
  class a extends n {
    /**
     *  @_ignore:
     */
    constructor(E, m) {
      super(E, ["logs", m]);
      Z(this, h);
      F(this, h, JSON.stringify(m));
    }
    /**
     *  The filter.
     */
    get logFilter() {
      return JSON.parse(x(this, h));
    }
    async _emit(E, m) {
      E.emit(this.logFilter, E._wrapLog(m, E._network));
    }
  }
  h = new WeakMap(), Pr.SocketEventSubscriber = a;
  class o extends t.JsonRpcApiProvider {
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */
    constructor(E, m) {
      const N = Object.assign({}, m ?? {});
      (0, e.assertArgument)(N.batchMaxCount == null || N.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", m), N.batchMaxCount = 1, N.staticNetwork == null && (N.staticNetwork = !0);
      super(E, N);
      Z(this, p);
      // Maps each filterId to its subscriber
      Z(this, g);
      // If any events come in before a subscriber has finished
      // registering, queue them
      Z(this, k);
      F(this, p, /* @__PURE__ */ new Map()), F(this, g, /* @__PURE__ */ new Map()), F(this, k, /* @__PURE__ */ new Map());
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */
    _getSubscriber(E) {
      switch (E.type) {
        case "close":
          return new r.UnmanagedSubscriber("close");
        case "block":
          return new s(this);
        case "pending":
          return new i(this);
        case "event":
          return new a(this, E.filter);
        case "orphan":
          if (E.filter.orphan === "drop-log")
            return new r.UnmanagedSubscriber("drop-log");
      }
      return super._getSubscriber(E);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */
    _register(E, m) {
      x(this, g).set(E, m);
      const N = x(this, k).get(E);
      if (N) {
        for (const T of N)
          m._handleMessage(T);
        x(this, k).delete(E);
      }
    }
    async _send(E) {
      (0, e.assertArgument)(!Array.isArray(E), "WebSocket does not support batch send", "payload", E);
      const m = new Promise((N, T) => {
        x(this, p).set(E.id, { payload: E, resolve: N, reject: T });
      });
      return await this._waitUntilReady(), await this._write(JSON.stringify(E)), [await m];
    }
    // Sub-classes must call this once they are connected
    /*
    	    async _start(): Promise<void> {
    	        if (this.#ready) { return; }
    
    	        for (const { payload } of this.#callbacks.values()) {
    	            await this._write(JSON.stringify(payload));
    	        }
    
    	        this.#ready = (async function() {
    	            await super._start();
    	        })();
    	    }
    	    */
    /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */
    async _processMessage(E) {
      const m = JSON.parse(E);
      if (m && typeof m == "object" && "id" in m) {
        const N = x(this, p).get(m.id);
        if (N == null) {
          this.emit("error", (0, e.makeError)("received result for unknown id", "UNKNOWN_ERROR", {
            reasonCode: "UNKNOWN_ID",
            result: m
          }));
          return;
        }
        x(this, p).delete(m.id), N.resolve(m);
      } else if (m && m.method === "eth_subscription") {
        const N = m.params.subscription, T = x(this, g).get(N);
        if (T)
          T._handleMessage(m.params.result);
        else {
          let U = x(this, k).get(N);
          U == null && (U = [], x(this, k).set(N, U)), U.push(m.params.result);
        }
      } else {
        this.emit("error", (0, e.makeError)("received unexpected message", "UNKNOWN_ERROR", {
          reasonCode: "UNEXPECTED_MESSAGE",
          result: m
        }));
        return;
      }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */
    async _write(E) {
      throw new Error("sub-classes must override this");
    }
  }
  return p = new WeakMap(), g = new WeakMap(), k = new WeakMap(), Pr.SocketProvider = o, Pr;
}
var qy;
function px() {
  var n, s;
  if (qy) return Cl;
  qy = 1, Object.defineProperty(Cl, "__esModule", { value: !0 }), Cl.WebSocketProvider = void 0;
  const r = ek(), e = Ub();
  class t extends e.SocketProvider {
    constructor(o, u, c) {
      super(u, c);
      Z(this, n);
      Z(this, s);
      typeof o == "string" ? (F(this, n, () => new r.WebSocket(o)), F(this, s, x(this, n).call(this))) : typeof o == "function" ? (F(this, n, o), F(this, s, o())) : (F(this, n, null), F(this, s, o)), this.websocket.onopen = async () => {
        try {
          await this._start(), this.resume();
        } catch (l) {
          console.log("failed to start WebsocketProvider", l);
        }
      }, this.websocket.onmessage = (l) => {
        this._processMessage(l.data);
      };
    }
    get websocket() {
      if (x(this, s) == null)
        throw new Error("websocket closed");
      return x(this, s);
    }
    async _write(o) {
      this.websocket.send(o);
    }
    async destroy() {
      x(this, s) != null && (x(this, s).close(), F(this, s, null)), super.destroy();
    }
  }
  return n = new WeakMap(), s = new WeakMap(), Cl.WebSocketProvider = t, Cl;
}
var Wy;
function m6() {
  if (Wy) return Ea;
  Wy = 1, Object.defineProperty(Ea, "__esModule", { value: !0 }), Ea.InfuraProvider = Ea.InfuraWebSocketProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn(), s = px(), i = "84842078b09946638c03157f83405213";
  function a(c) {
    switch (c) {
      case "mainnet":
        return "mainnet.infura.io";
      case "goerli":
        return "goerli.infura.io";
      case "sepolia":
        return "sepolia.infura.io";
      case "arbitrum":
        return "arbitrum-mainnet.infura.io";
      case "arbitrum-goerli":
        return "arbitrum-goerli.infura.io";
      case "arbitrum-sepolia":
        return "arbitrum-sepolia.infura.io";
      case "base":
        return "base-mainnet.infura.io";
      case "base-goerlia":
        return "base-goerli.infura.io";
      case "base-sepolia":
        return "base-sepolia.infura.io";
      case "bnb":
        return "bnbsmartchain-mainnet.infura.io";
      case "bnbt":
        return "bnbsmartchain-testnet.infura.io";
      case "linea":
        return "linea-mainnet.infura.io";
      case "linea-goerli":
        return "linea-goerli.infura.io";
      case "linea-sepolia":
        return "linea-sepolia.infura.io";
      case "matic":
        return "polygon-mainnet.infura.io";
      case "matic-amoy":
        return "polygon-amoy.infura.io";
      case "matic-mumbai":
        return "polygon-mumbai.infura.io";
      case "optimism":
        return "optimism-mainnet.infura.io";
      case "optimism-goerli":
        return "optimism-goerli.infura.io";
      case "optimism-sepolia":
        return "optimism-sepolia.infura.io";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", c);
  }
  class o extends s.WebSocketProvider {
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    constructor(f, d) {
      const h = new u(f, d), p = h._getConnection();
      (0, r.assert)(!p.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", { operation: "InfuraProvider.getWebSocketProvider()" });
      const g = p.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
      super(g, h._network);
      /**
       *  The Project ID for the INFURA connection.
       */
      Q(this, "projectId");
      /**
       *  The Project Secret.
       *
       *  If null, no authenticated requests are made. This should not
       *  be used outside of private contexts.
       */
      Q(this, "projectSecret");
      (0, r.defineProperties)(this, {
        projectId: h.projectId,
        projectSecret: h.projectSecret
      });
    }
    isCommunityResource() {
      return this.projectId === i;
    }
  }
  Ea.InfuraWebSocketProvider = o;
  class u extends n.JsonRpcProvider {
    /**
     *  Creates a new **InfuraProvider**.
     */
    constructor(f, d, h) {
      f == null && (f = "mainnet");
      const p = t.Network.from(f);
      d == null && (d = i), h == null && (h = null);
      const g = u.getRequest(p, d, h);
      super(g, p, { staticNetwork: p });
      /**
       *  The Project ID for the INFURA connection.
       */
      Q(this, "projectId");
      /**
       *  The Project Secret.
       *
       *  If null, no authenticated requests are made. This should not
       *  be used outside of private contexts.
       */
      Q(this, "projectSecret");
      (0, r.defineProperties)(this, { projectId: d, projectSecret: h });
    }
    _getProvider(f) {
      try {
        return new u(f, this.projectId, this.projectSecret);
      } catch {
      }
      return super._getProvider(f);
    }
    isCommunityResource() {
      return this.projectId === i;
    }
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */
    static getWebSocketProvider(f, d) {
      return new o(f, d);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%projectId%% and %%projectSecret%%.
     */
    static getRequest(f, d, h) {
      d == null && (d = i), h == null && (h = null);
      const p = new r.FetchRequest(`https://${a(f.name)}/v3/${d}`);
      return p.allowGzip = !0, h && p.setCredentials("", h), d === i && (p.retryFunc = async (g, k, A) => ((0, e.showThrottleMessage)("InfuraProvider"), !0)), p;
    }
  }
  return Ea.InfuraProvider = u, Ea;
}
var Il = {}, Yy;
function y6() {
  if (Yy) return Il;
  Yy = 1, Object.defineProperty(Il, "__esModule", { value: !0 }), Il.QuickNodeProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn(), s = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
  function i(o) {
    switch (o) {
      case "mainnet":
        return "ethers.quiknode.pro";
      case "goerli":
        return "ethers.ethereum-goerli.quiknode.pro";
      case "sepolia":
        return "ethers.ethereum-sepolia.quiknode.pro";
      case "holesky":
        return "ethers.ethereum-holesky.quiknode.pro";
      case "arbitrum":
        return "ethers.arbitrum-mainnet.quiknode.pro";
      case "arbitrum-goerli":
        return "ethers.arbitrum-goerli.quiknode.pro";
      case "arbitrum-sepolia":
        return "ethers.arbitrum-sepolia.quiknode.pro";
      case "base":
        return "ethers.base-mainnet.quiknode.pro";
      case "base-goerli":
        return "ethers.base-goerli.quiknode.pro";
      case "base-spolia":
        return "ethers.base-sepolia.quiknode.pro";
      case "bnb":
        return "ethers.bsc.quiknode.pro";
      case "bnbt":
        return "ethers.bsc-testnet.quiknode.pro";
      case "matic":
        return "ethers.matic.quiknode.pro";
      case "matic-mumbai":
        return "ethers.matic-testnet.quiknode.pro";
      case "optimism":
        return "ethers.optimism.quiknode.pro";
      case "optimism-goerli":
        return "ethers.optimism-goerli.quiknode.pro";
      case "optimism-sepolia":
        return "ethers.optimism-sepolia.quiknode.pro";
      case "xdai":
        return "ethers.xdai.quiknode.pro";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Creates a new **QuickNodeProvider**.
     */
    constructor(c, l) {
      c == null && (c = "mainnet");
      const f = t.Network.from(c);
      l == null && (l = s);
      const d = a.getRequest(f, l);
      super(d, f, { staticNetwork: f });
      /**
       *  The API token.
       */
      Q(this, "token");
      (0, r.defineProperties)(this, { token: l });
    }
    _getProvider(c) {
      try {
        return new a(c, this.token);
      } catch {
      }
      return super._getProvider(c);
    }
    isCommunityResource() {
      return this.token === s;
    }
    /**
     *  Returns a new request prepared for %%network%% and the
     *  %%token%%.
     */
    static getRequest(c, l) {
      l == null && (l = s);
      const f = new r.FetchRequest(`https://${i(c.name)}/${l}`);
      return f.allowGzip = !0, l === s && (f.retryFunc = async (d, h, p) => ((0, e.showThrottleMessage)("QuickNodeProvider"), !0)), f;
    }
  }
  return Il.QuickNodeProvider = a, Il;
}
var _l = {}, Zy;
function P6() {
  var E, m, N, T, w6, Lb, A6, E6, Mb;
  if (Zy) return _l;
  Zy = 1, Object.defineProperty(_l, "__esModule", { value: !0 }), _l.FallbackProvider = void 0;
  const r = Me(), e = pf(), t = Mr(), n = BigInt("1"), s = BigInt("2");
  function i(I) {
    for (let P = I.length - 1; P > 0; P--) {
      const S = Math.floor(Math.random() * (P + 1)), B = I[P];
      I[P] = I[S], I[S] = B;
    }
  }
  function a(I) {
    return new Promise((P) => {
      setTimeout(P, I);
    });
  }
  function o() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  function u(I) {
    return JSON.stringify(I, (P, S) => typeof S == "bigint" ? { type: "bigint", value: S.toString() } : S);
  }
  const c = { stallTimeout: 400, priority: 1, weight: 1 }, l = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
  };
  async function f(I, P) {
    for (; (I.blockNumber < 0 || I.blockNumber < P) && (I._updateNumber || (I._updateNumber = (async () => {
      try {
        const S = await I.provider.getBlockNumber();
        S > I.blockNumber && (I.blockNumber = S);
      } catch (S) {
        I.blockNumber = -2, I._lastFatalError = S, I._lastFatalErrorTimestamp = o();
      }
      I._updateNumber = null;
    })()), await I._updateNumber, I.outOfSync++, !I._lastFatalError); )
      ;
  }
  function d(I) {
    if (I == null)
      return "null";
    if (Array.isArray(I))
      return "[" + I.map(d).join(",") + "]";
    if (typeof I == "object" && typeof I.toJSON == "function")
      return d(I.toJSON());
    switch (typeof I) {
      case "boolean":
      case "symbol":
        return I.toString();
      case "bigint":
      case "number":
        return BigInt(I).toString();
      case "string":
        return JSON.stringify(I);
      case "object": {
        const P = Object.keys(I);
        return P.sort(), "{" + P.map((S) => `${JSON.stringify(S)}:${d(I[S])}`).join(",") + "}";
      }
    }
    throw console.log("Could not serialize", I), new Error("Hmm...");
  }
  function h(I) {
    if ("error" in I) {
      const S = I.error;
      return { tag: d(S), value: S };
    }
    const P = I.result;
    return { tag: d(P), value: P };
  }
  function p(I, P) {
    const S = /* @__PURE__ */ new Map();
    for (const { value: C, tag: H, weight: V } of P) {
      const J = S.get(H) || { value: C, weight: 0 };
      J.weight += V, S.set(H, J);
    }
    let B = null;
    for (const C of S.values())
      C.weight >= I && (!B || C.weight > B.weight) && (B = C);
    if (B)
      return B.value;
  }
  function g(I, P) {
    let S = 0;
    const B = /* @__PURE__ */ new Map();
    let C = null;
    const H = [];
    for (const { value: J, tag: M, weight: G } of P)
      if (J instanceof Error) {
        const K = B.get(M) || { value: J, weight: 0 };
        K.weight += G, B.set(M, K), (C == null || K.weight > C.weight) && (C = K);
      } else
        H.push(BigInt(J)), S += G;
    if (S < I)
      return C && C.weight >= I ? C.value : void 0;
    H.sort((J, M) => J < M ? -1 : M > J ? 1 : 0);
    const V = Math.floor(H.length / 2);
    return H.length % 2 ? H[V] : (H[V - 1] + H[V] + n) / s;
  }
  function k(I, P) {
    const S = p(I, P);
    if (S !== void 0)
      return S;
    for (const B of P)
      if (B.value)
        return B.value;
  }
  function A(I, P) {
    if (I === 1)
      return (0, r.getNumber)(g(I, P), "%internal");
    const S = /* @__PURE__ */ new Map(), B = (V, J) => {
      const M = S.get(V) || { result: V, weight: 0 };
      M.weight += J, S.set(V, M);
    };
    for (const { weight: V, value: J } of P) {
      const M = (0, r.getNumber)(J);
      B(M - 1, V), B(M, V), B(M + 1, V);
    }
    let C = 0, H;
    for (const { weight: V, result: J } of S.values())
      V >= I && (V > C || H != null && V === C && J > H) && (C = V, H = J);
    return H;
  }
  class y extends e.AbstractProvider {
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */
    constructor(S, B, C) {
      super(B, C);
      Z(this, T);
      /**
       *  The number of backends that must agree on a value before it is
       *  accpeted.
       */
      Q(this, "quorum");
      /**
       *  @_ignore:
       */
      Q(this, "eventQuorum");
      /**
       *  @_ignore:
       */
      Q(this, "eventWorkers");
      Z(this, E);
      Z(this, m);
      Z(this, N);
      F(this, E, S.map((H) => H instanceof e.AbstractProvider ? Object.assign({ provider: H }, c, l) : Object.assign({}, c, H, l))), F(this, m, -2), F(this, N, null), C && C.quorum != null ? this.quorum = C.quorum : this.quorum = Math.ceil(x(this, E).reduce((H, V) => (H += V.weight, H), 0) / 2), this.eventQuorum = 1, this.eventWorkers = 1, (0, r.assertArgument)(this.quorum <= x(this, E).reduce((H, V) => H + V.weight, 0), "quorum exceed provider weight", "quorum", this.quorum);
    }
    get providerConfigs() {
      return x(this, E).map((S) => {
        const B = Object.assign({}, S);
        for (const C in B)
          C[0] === "_" && delete B[C];
        return B;
      });
    }
    async _detectNetwork() {
      return t.Network.from((0, r.getBigInt)(await this._perform({ method: "chainId" })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */
    async _translatePerform(S, B) {
      switch (B.method) {
        case "broadcastTransaction":
          return await S.broadcastTransaction(B.signedTransaction);
        case "call":
          return await S.call(Object.assign({}, B.transaction, { blockTag: B.blockTag }));
        case "chainId":
          return (await S.getNetwork()).chainId;
        case "estimateGas":
          return await S.estimateGas(B.transaction);
        case "getBalance":
          return await S.getBalance(B.address, B.blockTag);
        case "getBlock": {
          const C = "blockHash" in B ? B.blockHash : B.blockTag;
          return await S.getBlock(C, B.includeTransactions);
        }
        case "getBlockNumber":
          return await S.getBlockNumber();
        case "getCode":
          return await S.getCode(B.address, B.blockTag);
        case "getGasPrice":
          return (await S.getFeeData()).gasPrice;
        case "getPriorityFee":
          return (await S.getFeeData()).maxPriorityFeePerGas;
        case "getLogs":
          return await S.getLogs(B.filter);
        case "getStorage":
          return await S.getStorage(B.address, B.position, B.blockTag);
        case "getTransaction":
          return await S.getTransaction(B.hash);
        case "getTransactionCount":
          return await S.getTransactionCount(B.address, B.blockTag);
        case "getTransactionReceipt":
          return await S.getTransactionReceipt(B.hash);
        case "getTransactionResult":
          return await S.getTransactionResult(B.hash);
      }
    }
    async _perform(S) {
      if (S.method === "broadcastTransaction") {
        const V = x(this, E).map((G) => null), J = x(this, E).map(async ({ provider: G, weight: K }, X) => {
          try {
            const te = await G._perform(S);
            V[X] = Object.assign(h({ result: te }), { weight: K });
          } catch (te) {
            V[X] = Object.assign(h({ error: te }), { weight: K });
          }
        });
        for (; ; ) {
          const G = V.filter((te) => te != null);
          for (const { value: te } of G)
            if (!(te instanceof Error))
              return te;
          const K = p(this.quorum, V.filter((te) => te != null));
          if ((0, r.isError)(K, "INSUFFICIENT_FUNDS"))
            throw K;
          const X = J.filter((te, pe) => V[pe] == null);
          if (X.length === 0)
            break;
          await Promise.race(X);
        }
        const M = k(this.quorum, V);
        if ((0, r.assert)(M !== void 0, "problem multi-broadcasting", "SERVER_ERROR", {
          request: "%sub-requests",
          info: { request: S, results: V.map(u) }
        }), M instanceof Error)
          throw M;
        return M;
      }
      await de(this, T, A6).call(this);
      const B = /* @__PURE__ */ new Set();
      let C = 0;
      for (; ; ) {
        const V = de(this, T, Lb).call(this, B, S);
        if (V == null || (C += V.config.weight, C >= this.quorum))
          break;
      }
      const H = await de(this, T, Mb).call(this, B, S);
      for (const V of B)
        V.perform && V.result == null && V.config.lateResponses++;
      return H;
    }
    async destroy() {
      for (const { provider: S } of x(this, E))
        S.destroy();
      super.destroy();
    }
  }
  return E = new WeakMap(), m = new WeakMap(), N = new WeakMap(), T = new WeakSet(), // Grab the next (random) config that is not already part of
  // the running set
  w6 = function(S) {
    const B = Array.from(S).map((H) => H.config), C = x(this, E).slice();
    i(C), C.sort((H, V) => H.priority - V.priority);
    for (const H of C)
      if (!H._lastFatalError && B.indexOf(H) === -1)
        return H;
    return null;
  }, // Adds a new runner (if available) to running.
  Lb = function(S, B) {
    const C = de(this, T, w6).call(this, S);
    if (C == null)
      return null;
    const H = {
      config: C,
      result: null,
      didBump: !1,
      perform: null,
      staller: null
    }, V = o();
    return H.perform = (async () => {
      try {
        C.requests++;
        const M = await this._translatePerform(C.provider, B);
        H.result = { result: M };
      } catch (M) {
        C.errorResponses++, H.result = { error: M };
      }
      const J = o() - V;
      C._totalTime += J, C.rollingDuration = 0.95 * C.rollingDuration + 0.05 * J, H.perform = null;
    })(), H.staller = (async () => {
      await a(C.stallTimeout), H.staller = null;
    })(), S.add(H), H;
  }, A6 = async function() {
    let S = x(this, N);
    if (!S) {
      const B = [];
      x(this, E).forEach((C) => {
        B.push((async () => {
          await f(C, 0), C._lastFatalError || (C._network = await C.provider.getNetwork());
        })());
      }), F(this, N, S = (async () => {
        await Promise.all(B);
        let C = null;
        for (const H of x(this, E)) {
          if (H._lastFatalError)
            continue;
          const V = H._network;
          C == null ? C = V.chainId : V.chainId !== C && (0, r.assert)(!1, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
            operation: "new FallbackProvider"
          });
        }
      })());
    }
    await S;
  }, E6 = async function(S, B) {
    const C = [];
    for (const H of S)
      if (H.result != null) {
        const { tag: V, value: J } = h(H.result);
        C.push({ tag: V, value: J, weight: H.config.weight });
      }
    if (!(C.reduce((H, V) => H + V.weight, 0) < this.quorum)) {
      switch (B.method) {
        case "getBlockNumber": {
          x(this, m) === -2 && F(this, m, Math.ceil((0, r.getNumber)(g(this.quorum, x(this, E).filter((V) => !V._lastFatalError).map((V) => ({
            value: V.blockNumber,
            tag: (0, r.getNumber)(V.blockNumber).toString(),
            weight: V.weight
          }))))));
          const H = A(this.quorum, C);
          return H === void 0 ? void 0 : (H > x(this, m) && F(this, m, H), x(this, m));
        }
        case "getGasPrice":
        case "getPriorityFee":
        case "estimateGas":
          return g(this.quorum, C);
        case "getBlock":
          return "blockTag" in B && B.blockTag === "pending" ? k(this.quorum, C) : p(this.quorum, C);
        case "call":
        case "chainId":
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorage":
        case "getTransaction":
        case "getTransactionReceipt":
        case "getLogs":
          return p(this.quorum, C);
        case "broadcastTransaction":
          return k(this.quorum, C);
      }
      (0, r.assert)(!1, "unsupported method", "UNSUPPORTED_OPERATION", {
        operation: `_perform(${u(B.method)})`
      });
    }
  }, Mb = async function(S, B) {
    if (S.size === 0)
      throw new Error("no runners?!");
    const C = [];
    let H = 0;
    for (const J of S) {
      if (J.perform && C.push(J.perform), J.staller) {
        C.push(J.staller);
        continue;
      }
      J.didBump || (J.didBump = !0, H++);
    }
    const V = await de(this, T, E6).call(this, S, B);
    if (V !== void 0) {
      if (V instanceof Error)
        throw V;
      return V;
    }
    for (let J = 0; J < H; J++)
      de(this, T, Lb).call(this, S, B);
    return (0, r.assert)(C.length > 0, "quorum not met", "SERVER_ERROR", {
      request: "%sub-requests",
      info: { request: B, results: Array.from(S).map((J) => u(J.result)) }
    }), await Promise.race(C), await de(this, T, Mb).call(this, S, B);
  }, _l.FallbackProvider = y, _l;
}
var Xy;
function tk() {
  if (Xy) return Tl;
  Xy = 1, Object.defineProperty(Tl, "__esModule", { value: !0 }), Tl.getDefaultProvider = void 0;
  const r = Me(), e = h6(), t = p6(), n = b6(), s = g6(), i = x6(), a = m6(), o = y6(), u = P6(), c = Rn(), l = Mr(), f = px();
  function d(g) {
    return g && typeof g.send == "function" && typeof g.close == "function";
  }
  const h = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
  function p(g, k) {
    k == null && (k = {});
    const A = (N) => k[N] === "-" ? !1 : typeof k.exclusive == "string" ? N === k.exclusive : Array.isArray(k.exclusive) ? k.exclusive.indexOf(N) !== -1 : !0;
    if (typeof g == "string" && g.match(/^https?:/))
      return new c.JsonRpcProvider(g);
    if (typeof g == "string" && g.match(/^wss?:/) || d(g))
      return new f.WebSocketProvider(g);
    let y = null;
    try {
      y = l.Network.from(g);
    } catch {
    }
    const E = [];
    if (A("publicPolygon") && y && (y.name === "matic" ? E.push(new c.JsonRpcProvider("https://polygon-rpc.com/", y, { staticNetwork: y })) : y.name === "matic-amoy" && E.push(new c.JsonRpcProvider("https://rpc-amoy.polygon.technology/", y, { staticNetwork: y }))), A("alchemy"))
      try {
        E.push(new t.AlchemyProvider(g, k.alchemy));
      } catch {
      }
    if (A("ankr") && k.ankr != null)
      try {
        E.push(new e.AnkrProvider(g, k.ankr));
      } catch {
      }
    if (A("chainstack"))
      try {
        E.push(new n.ChainstackProvider(g, k.chainstack));
      } catch {
      }
    if (A("cloudflare"))
      try {
        E.push(new s.CloudflareProvider(g));
      } catch {
      }
    if (A("etherscan"))
      try {
        E.push(new i.EtherscanProvider(g, k.etherscan));
      } catch {
      }
    if (A("infura"))
      try {
        let N = k.infura, T;
        typeof N == "object" && (T = N.projectSecret, N = N.projectId), E.push(new a.InfuraProvider(g, N, T));
      } catch {
      }
    if (A("quicknode"))
      try {
        let N = k.quicknode;
        E.push(new o.QuickNodeProvider(g, N));
      } catch {
      }
    if ((0, r.assert)(E.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
      operation: "getDefaultProvider"
    }), E.length === 1)
      return E[0];
    let m = Math.floor(E.length / 2);
    return m > 2 && (m = 2), y && h.indexOf(y.name) !== -1 && (m = 1), k && k.quorum && (m = k.quorum), new u.FallbackProvider(E, void 0, { quorum: m });
  }
  return Tl.getDefaultProvider = p, Tl;
}
var Ul = {}, e2;
function rk() {
  var n, s;
  if (e2) return Ul;
  e2 = 1, Object.defineProperty(Ul, "__esModule", { value: !0 }), Ul.NonceManager = void 0;
  const r = Me(), e = hx(), i = class i extends e.AbstractSigner {
    /**
     *  Creates a new **NonceManager** to manage %%signer%%.
     */
    constructor(u) {
      super(u.provider);
      /**
       *  The Signer being managed.
       */
      Q(this, "signer");
      Z(this, n);
      Z(this, s);
      (0, r.defineProperties)(this, { signer: u }), F(this, n, null), F(this, s, 0);
    }
    async getAddress() {
      return this.signer.getAddress();
    }
    connect(u) {
      return new i(this.signer.connect(u));
    }
    async getNonce(u) {
      if (u === "pending") {
        x(this, n) == null && F(this, n, super.getNonce("pending"));
        const c = x(this, s);
        return await x(this, n) + c;
      }
      return super.getNonce(u);
    }
    /**
     *  Manually increment the nonce. This may be useful when managng
     *  offline transactions.
     */
    increment() {
      rn(this, s)._++;
    }
    /**
     *  Resets the nonce, causing the **NonceManager** to reload the current
     *  nonce from the blockchain on the next transaction.
     */
    reset() {
      F(this, s, 0), F(this, n, null);
    }
    async sendTransaction(u) {
      const c = this.getNonce("pending");
      return this.increment(), u = await this.signer.populateTransaction(u), u.nonce = await c, await this.signer.sendTransaction(u);
    }
    signTransaction(u) {
      return this.signer.signTransaction(u);
    }
    signMessage(u) {
      return this.signer.signMessage(u);
    }
    signTypedData(u, c, l) {
      return this.signer.signTypedData(u, c, l);
    }
  };
  n = new WeakMap(), s = new WeakMap();
  let t = i;
  return Ul.NonceManager = t, Ul;
}
var Ll = {}, t2;
function nk() {
  var n;
  if (t2) return Ll;
  t2 = 1, Object.defineProperty(Ll, "__esModule", { value: !0 }), Ll.BrowserProvider = void 0;
  const r = Me(), e = Rn();
  class t extends e.JsonRpcApiPollingProvider {
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */
    constructor(a, o, u) {
      const c = Object.assign({}, u ?? {}, { batchMaxCount: 1 });
      (0, r.assertArgument)(a && a.request, "invalid EIP-1193 provider", "ethereum", a);
      super(o, c);
      Z(this, n);
      F(this, n, async (l, f) => {
        const d = { method: l, params: f };
        this.emit("debug", { action: "sendEip1193Request", payload: d });
        try {
          const h = await a.request(d);
          return this.emit("debug", { action: "receiveEip1193Result", result: h }), h;
        } catch (h) {
          const p = new Error(h.message);
          throw p.code = h.code, p.data = h.data, p.payload = d, this.emit("debug", { action: "receiveEip1193Error", error: p }), p;
        }
      });
    }
    async send(a, o) {
      return await this._start(), await super.send(a, o);
    }
    async _send(a) {
      (0, r.assertArgument)(!Array.isArray(a), "EIP-1193 does not support batch request", "payload", a);
      try {
        const o = await x(this, n).call(this, a.method, a.params || []);
        return [{ id: a.id, result: o }];
      } catch (o) {
        return [{
          id: a.id,
          error: { code: o.code, data: o.data, message: o.message }
        }];
      }
    }
    getRpcError(a, o) {
      switch (o = JSON.parse(JSON.stringify(o)), o.error.code || -1) {
        case 4001:
          o.error.message = `ethers-user-denied: ${o.error.message}`;
          break;
        case 4200:
          o.error.message = `ethers-unsupported: ${o.error.message}`;
          break;
      }
      return super.getRpcError(a, o);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */
    async hasSigner(a) {
      a == null && (a = 0);
      const o = await this.send("eth_accounts", []);
      return typeof a == "number" ? o.length > a : (a = a.toLowerCase(), o.filter((u) => u.toLowerCase() === a).length !== 0);
    }
    async getSigner(a) {
      if (a == null && (a = 0), !await this.hasSigner(a))
        try {
          await x(this, n).call(this, "eth_requestAccounts", []);
        } catch (o) {
          const u = o.payload;
          throw this.getRpcError(u, { id: u.id, error: o });
        }
      return await super.getSigner(a);
    }
  }
  return n = new WeakMap(), Ll.BrowserProvider = t, Ll;
}
var Ml = {}, r2;
function sk() {
  if (r2) return Ml;
  r2 = 1, Object.defineProperty(Ml, "__esModule", { value: !0 }), Ml.PocketProvider = void 0;
  const r = Me(), e = Di(), t = Mr(), n = Rn(), s = "62e1ad51b37b8e00394bda3b";
  function i(o) {
    switch (o) {
      case "mainnet":
        return "eth-mainnet.gateway.pokt.network";
      case "goerli":
        return "eth-goerli.gateway.pokt.network";
      case "matic":
        return "poly-mainnet.gateway.pokt.network";
      case "matic-mumbai":
        return "polygon-mumbai-rpc.gateway.pokt.network";
    }
    (0, r.assertArgument)(!1, "unsupported network", "network", o);
  }
  class a extends n.JsonRpcProvider {
    /**
     *  Create a new **PocketProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */
    constructor(c, l, f) {
      c == null && (c = "mainnet");
      const d = t.Network.from(c);
      l == null && (l = s), f == null && (f = null);
      const h = { staticNetwork: d }, p = a.getRequest(d, l, f);
      super(p, d, h);
      /**
       *  The Application ID for the Pocket connection.
       */
      Q(this, "applicationId");
      /**
       *  The Application Secret for making authenticated requests
       *  to the Pocket connection.
       */
      Q(this, "applicationSecret");
      (0, r.defineProperties)(this, { applicationId: l, applicationSecret: f });
    }
    _getProvider(c) {
      try {
        return new a(c, this.applicationId, this.applicationSecret);
      } catch {
      }
      return super._getProvider(c);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%applicationId%%.
     */
    static getRequest(c, l, f) {
      l == null && (l = s);
      const d = new r.FetchRequest(`https://${i(c.name)}/v1/lb/${l}`);
      return d.allowGzip = !0, f && d.setCredentials("", f), l === s && (d.retryFunc = async (h, p, g) => ((0, e.showThrottleMessage)("PocketProvider"), !0)), d;
    }
    isCommunityResource() {
      return this.applicationId === s;
    }
  }
  return Ml.PocketProvider = a, Ml;
}
var Fl = {}, n2;
function ik() {
  if (n2) return Fl;
  n2 = 1, Object.defineProperty(Fl, "__esModule", { value: !0 }), Fl.IpcSocketProvider = void 0;
  const r = void 0;
  return Fl.IpcSocketProvider = r, Fl;
}
var s2;
function bx() {
  return s2 || (s2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.SocketEventSubscriber = r.SocketPendingSubscriber = r.SocketBlockSubscriber = r.SocketSubscriber = r.WebSocketProvider = r.SocketProvider = r.IpcSocketProvider = r.QuickNodeProvider = r.PocketProvider = r.InfuraWebSocketProvider = r.InfuraProvider = r.EtherscanPlugin = r.EtherscanProvider = r.ChainstackProvider = r.CloudflareProvider = r.AnkrProvider = r.AlchemyProvider = r.BrowserProvider = r.JsonRpcSigner = r.JsonRpcProvider = r.JsonRpcApiProvider = r.FallbackProvider = r.copyRequest = r.TransactionResponse = r.TransactionReceipt = r.Log = r.FeeData = r.Block = r.FetchUrlFeeDataNetworkPlugin = r.FeeDataNetworkPlugin = r.EnsPlugin = r.GasCostPlugin = r.NetworkPlugin = r.NonceManager = r.Network = r.MulticoinProviderPlugin = r.EnsResolver = r.getDefaultProvider = r.showThrottleMessage = r.VoidSigner = r.AbstractSigner = r.UnmanagedSubscriber = r.AbstractProvider = void 0;
    var e = pf();
    Object.defineProperty(r, "AbstractProvider", { enumerable: !0, get: function() {
      return e.AbstractProvider;
    } }), Object.defineProperty(r, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return e.UnmanagedSubscriber;
    } });
    var t = hx();
    Object.defineProperty(r, "AbstractSigner", { enumerable: !0, get: function() {
      return t.AbstractSigner;
    } }), Object.defineProperty(r, "VoidSigner", { enumerable: !0, get: function() {
      return t.VoidSigner;
    } });
    var n = Di();
    Object.defineProperty(r, "showThrottleMessage", { enumerable: !0, get: function() {
      return n.showThrottleMessage;
    } });
    var s = tk();
    Object.defineProperty(r, "getDefaultProvider", { enumerable: !0, get: function() {
      return s.getDefaultProvider;
    } });
    var i = f6();
    Object.defineProperty(r, "EnsResolver", { enumerable: !0, get: function() {
      return i.EnsResolver;
    } }), Object.defineProperty(r, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return i.MulticoinProviderPlugin;
    } });
    var a = Mr();
    Object.defineProperty(r, "Network", { enumerable: !0, get: function() {
      return a.Network;
    } });
    var o = rk();
    Object.defineProperty(r, "NonceManager", { enumerable: !0, get: function() {
      return o.NonceManager;
    } });
    var u = fx();
    Object.defineProperty(r, "NetworkPlugin", { enumerable: !0, get: function() {
      return u.NetworkPlugin;
    } }), Object.defineProperty(r, "GasCostPlugin", { enumerable: !0, get: function() {
      return u.GasCostPlugin;
    } }), Object.defineProperty(r, "EnsPlugin", { enumerable: !0, get: function() {
      return u.EnsPlugin;
    } }), Object.defineProperty(r, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return u.FeeDataNetworkPlugin;
    } }), Object.defineProperty(r, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return u.FetchUrlFeeDataNetworkPlugin;
    } });
    var c = hf();
    Object.defineProperty(r, "Block", { enumerable: !0, get: function() {
      return c.Block;
    } }), Object.defineProperty(r, "FeeData", { enumerable: !0, get: function() {
      return c.FeeData;
    } }), Object.defineProperty(r, "Log", { enumerable: !0, get: function() {
      return c.Log;
    } }), Object.defineProperty(r, "TransactionReceipt", { enumerable: !0, get: function() {
      return c.TransactionReceipt;
    } }), Object.defineProperty(r, "TransactionResponse", { enumerable: !0, get: function() {
      return c.TransactionResponse;
    } }), Object.defineProperty(r, "copyRequest", { enumerable: !0, get: function() {
      return c.copyRequest;
    } });
    var l = P6();
    Object.defineProperty(r, "FallbackProvider", { enumerable: !0, get: function() {
      return l.FallbackProvider;
    } });
    var f = Rn();
    Object.defineProperty(r, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return f.JsonRpcApiProvider;
    } }), Object.defineProperty(r, "JsonRpcProvider", { enumerable: !0, get: function() {
      return f.JsonRpcProvider;
    } }), Object.defineProperty(r, "JsonRpcSigner", { enumerable: !0, get: function() {
      return f.JsonRpcSigner;
    } });
    var d = nk();
    Object.defineProperty(r, "BrowserProvider", { enumerable: !0, get: function() {
      return d.BrowserProvider;
    } });
    var h = p6();
    Object.defineProperty(r, "AlchemyProvider", { enumerable: !0, get: function() {
      return h.AlchemyProvider;
    } });
    var p = h6();
    Object.defineProperty(r, "AnkrProvider", { enumerable: !0, get: function() {
      return p.AnkrProvider;
    } });
    var g = g6();
    Object.defineProperty(r, "CloudflareProvider", { enumerable: !0, get: function() {
      return g.CloudflareProvider;
    } });
    var k = b6();
    Object.defineProperty(r, "ChainstackProvider", { enumerable: !0, get: function() {
      return k.ChainstackProvider;
    } });
    var A = x6();
    Object.defineProperty(r, "EtherscanProvider", { enumerable: !0, get: function() {
      return A.EtherscanProvider;
    } }), Object.defineProperty(r, "EtherscanPlugin", { enumerable: !0, get: function() {
      return A.EtherscanPlugin;
    } });
    var y = m6();
    Object.defineProperty(r, "InfuraProvider", { enumerable: !0, get: function() {
      return y.InfuraProvider;
    } }), Object.defineProperty(r, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return y.InfuraWebSocketProvider;
    } });
    var E = sk();
    Object.defineProperty(r, "PocketProvider", { enumerable: !0, get: function() {
      return E.PocketProvider;
    } });
    var m = y6();
    Object.defineProperty(r, "QuickNodeProvider", { enumerable: !0, get: function() {
      return m.QuickNodeProvider;
    } });
    const N = ik();
    Object.defineProperty(r, "IpcSocketProvider", { enumerable: !0, get: function() {
      return N.IpcSocketProvider;
    } });
    var T = Ub();
    Object.defineProperty(r, "SocketProvider", { enumerable: !0, get: function() {
      return T.SocketProvider;
    } });
    var U = px();
    Object.defineProperty(r, "WebSocketProvider", { enumerable: !0, get: function() {
      return U.WebSocketProvider;
    } });
    var R = Ub();
    Object.defineProperty(r, "SocketSubscriber", { enumerable: !0, get: function() {
      return R.SocketSubscriber;
    } }), Object.defineProperty(r, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return R.SocketBlockSubscriber;
    } }), Object.defineProperty(r, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return R.SocketPendingSubscriber;
    } }), Object.defineProperty(r, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return R.SocketEventSubscriber;
    } });
  }(kp)), kp;
}
var Tp = {}, Dl = {}, i2;
function gx() {
  var a;
  if (i2) return Dl;
  i2 = 1, Object.defineProperty(Dl, "__esModule", { value: !0 }), Dl.BaseWallet = void 0;
  const r = zt(), e = Ys(), t = bx(), n = Lr(), s = Me(), o = class o extends t.AbstractSigner {
    /**
     *  Creates a new BaseWallet for %%privateKey%%, optionally
     *  connected to %%provider%%.
     *
     *  If %%provider%% is not specified, only offline methods can
     *  be used.
     */
    constructor(l, f) {
      super(f);
      /**
       *  The wallet address.
       */
      Q(this, "address");
      Z(this, a);
      (0, s.assertArgument)(l && typeof l.sign == "function", "invalid private key", "privateKey", "[ REDACTED ]"), F(this, a, l);
      const d = (0, n.computeAddress)(this.signingKey.publicKey);
      (0, s.defineProperties)(this, { address: d });
    }
    // Store private values behind getters to reduce visibility
    // in console.log
    /**
     *  The [[SigningKey]] used for signing payloads.
     */
    get signingKey() {
      return x(this, a);
    }
    /**
     *  The private key for this wallet.
     */
    get privateKey() {
      return this.signingKey.privateKey;
    }
    async getAddress() {
      return this.address;
    }
    connect(l) {
      return new o(x(this, a), l);
    }
    async signTransaction(l) {
      l = (0, t.copyRequest)(l);
      const { to: f, from: d } = await (0, s.resolveProperties)({
        to: l.to ? (0, r.resolveAddress)(l.to, this.provider) : void 0,
        from: l.from ? (0, r.resolveAddress)(l.from, this.provider) : void 0
      });
      f != null && (l.to = f), d != null && (l.from = d), l.from != null && ((0, s.assertArgument)((0, r.getAddress)(l.from) === this.address, "transaction from address mismatch", "tx.from", l.from), delete l.from);
      const h = n.Transaction.from(l);
      return h.signature = this.signingKey.sign(h.unsignedHash), h.serialized;
    }
    async signMessage(l) {
      return this.signMessageSync(l);
    }
    // @TODO: Add a secialized signTx and signTyped sync that enforces
    // all parameters are known?
    /**
     *  Returns the signature for %%message%% signed with this wallet.
     */
    signMessageSync(l) {
      return this.signingKey.sign((0, e.hashMessage)(l)).serialized;
    }
    async signTypedData(l, f, d) {
      const h = await e.TypedDataEncoder.resolveNames(l, f, d, async (p) => {
        (0, s.assert)(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
          operation: "resolveName",
          info: { name: p }
        });
        const g = await this.provider.resolveName(p);
        return (0, s.assert)(g != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
          value: p
        }), g;
      });
      return this.signingKey.sign(e.TypedDataEncoder.hash(h.domain, f, h.value)).serialized;
    }
  };
  a = new WeakMap();
  let i = o;
  return Dl.BaseWallet = i, Dl;
}
var Bp = {}, jl = {}, Hl = {}, Pa = {}, a2;
function v6() {
  if (a2) return Pa;
  a2 = 1, Object.defineProperty(Pa, "__esModule", { value: !0 }), Pa.decodeOwl = Pa.decode = void 0;
  const r = Me(), e = " !#$%&'()*+,-./<=>?@[]^_`{|}~", t = /^[a-z]*$/i;
  function n(a, o) {
    let u = 97;
    return a.reduce((c, l) => (l === o ? u++ : l.match(t) ? c.push(String.fromCharCode(u) + l) : (u = 97, c.push(l)), c), []);
  }
  function s(a, o) {
    for (let l = e.length - 1; l >= 0; l--)
      a = a.split(e[l]).join(o.substring(2 * l, 2 * l + 2));
    const u = [], c = a.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (l, f, d, h) => {
      if (d)
        for (let p = parseInt(d); p >= 0; p--)
          u.push(";");
      else
        u.push(f.toLowerCase());
      return "";
    });
    if (c)
      throw new Error(`leftovers: ${JSON.stringify(c)}`);
    return n(n(u, ";"), ":");
  }
  Pa.decode = s;
  function i(a) {
    return (0, r.assertArgument)(a[0] === "0", "unsupported auwl data", "data", a), s(a.substring(1 + 2 * e.length), a.substring(1, 1 + 2 * e.length));
  }
  return Pa.decodeOwl = i, Pa;
}
var Gl = {}, o2;
function k6() {
  if (o2) return Gl;
  o2 = 1, Object.defineProperty(Gl, "__esModule", { value: !0 }), Gl.Wordlist = void 0;
  const r = Me();
  class e {
    /**
     *  Creates a new Wordlist instance.
     *
     *  Sub-classes MUST call this if they provide their own constructor,
     *  passing in the locale string of the language.
     *
     *  Generally there is no need to create instances of a Wordlist,
     *  since each language-specific Wordlist creates an instance and
     *  there is no state kept internally, so they are safe to share.
     */
    constructor(n) {
      Q(this, "locale");
      (0, r.defineProperties)(this, { locale: n });
    }
    /**
     *  Sub-classes may override this to provide a language-specific
     *  method for spliting %%phrase%% into individual words.
     *
     *  By default, %%phrase%% is split using any sequences of
     *  white-space as defined by regular expressions (i.e. ``/\s+/``).
     */
    split(n) {
      return n.toLowerCase().split(/\s+/g);
    }
    /**
     *  Sub-classes may override this to provider a language-specific
     *  method for joining %%words%% into a phrase.
     *
     *  By default, %%words%% are joined by a single space.
     */
    join(n) {
      return n.join(" ");
    }
  }
  return Gl.Wordlist = e, Gl;
}
var c2;
function xx() {
  var i, a, o, u, Fb;
  if (c2) return Hl;
  c2 = 1, Object.defineProperty(Hl, "__esModule", { value: !0 }), Hl.WordlistOwl = void 0;
  const r = Ys(), e = Me(), t = v6(), n = k6();
  class s extends n.Wordlist {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
     *  and validated against the %%checksum%%.
     */
    constructor(d, h, p) {
      super(d);
      Z(this, u);
      Z(this, i);
      Z(this, a);
      Z(this, o);
      F(this, i, h), F(this, a, p), F(this, o, null);
    }
    /**
     *  The OWL-encoded data.
     */
    get _data() {
      return x(this, i);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, t.decodeOwl)(x(this, i));
    }
    getWord(d) {
      const h = de(this, u, Fb).call(this);
      return (0, e.assertArgument)(d >= 0 && d < h.length, `invalid word index: ${d}`, "index", d), h[d];
    }
    getWordIndex(d) {
      return de(this, u, Fb).call(this).indexOf(d);
    }
  }
  return i = new WeakMap(), a = new WeakMap(), o = new WeakMap(), u = new WeakSet(), Fb = function() {
    if (x(this, o) == null) {
      const d = this._decodeWords();
      if ((0, r.id)(d.join(`
`) + `
`) !== x(this, a))
        throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
      F(this, o, d);
    }
    return x(this, o);
  }, Hl.WordlistOwl = s, Hl;
}
var u2;
function vh() {
  if (u2) return jl;
  u2 = 1, Object.defineProperty(jl, "__esModule", { value: !0 }), jl.LangEn = void 0;
  const r = xx(), e = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO", t = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
  let n = null;
  class s extends r.WordlistOwl {
    /**
     *  Creates a new instance of the English language Wordlist.
     *
     *  This should be unnecessary most of the time as the exported
     *  [[langEn]] should suffice.
     *
     *  @_ignore:
     */
    constructor() {
      super("en", e, t);
    }
    /**
     *  Returns a singleton instance of a ``LangEn``, creating it
     *  if this is the first time being called.
     */
    static wordlist() {
      return n == null && (n = new s()), n;
    }
  }
  return jl.LangEn = s, jl;
}
var Vl = {}, l2;
function mx() {
  if (l2) return Vl;
  l2 = 1, Object.defineProperty(Vl, "__esModule", { value: !0 }), Vl.Mnemonic = void 0;
  const r = Yt(), e = Me(), t = vh();
  function n(c) {
    return (1 << c) - 1 << 8 - c & 255;
  }
  function s(c) {
    return (1 << c) - 1 & 255;
  }
  function i(c, l) {
    (0, e.assertNormalize)("NFKD"), l == null && (l = t.LangEn.wordlist());
    const f = l.split(c);
    (0, e.assertArgument)(f.length % 3 === 0 && f.length >= 12 && f.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
    const d = new Uint8Array(Math.ceil(11 * f.length / 8));
    let h = 0;
    for (let y = 0; y < f.length; y++) {
      let E = l.getWordIndex(f[y].normalize("NFKD"));
      (0, e.assertArgument)(E >= 0, `invalid mnemonic word at index ${y}`, "mnemonic", "[ REDACTED ]");
      for (let m = 0; m < 11; m++)
        E & 1 << 10 - m && (d[h >> 3] |= 1 << 7 - h % 8), h++;
    }
    const p = 32 * f.length / 3, g = f.length / 3, k = n(g), A = (0, e.getBytes)((0, r.sha256)(d.slice(0, p / 8)))[0] & k;
    return (0, e.assertArgument)(A === (d[d.length - 1] & k), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]"), (0, e.hexlify)(d.slice(0, p / 8));
  }
  function a(c, l) {
    (0, e.assertArgument)(c.length % 4 === 0 && c.length >= 16 && c.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]"), l == null && (l = t.LangEn.wordlist());
    const f = [0];
    let d = 11;
    for (let g = 0; g < c.length; g++)
      d > 8 ? (f[f.length - 1] <<= 8, f[f.length - 1] |= c[g], d -= 8) : (f[f.length - 1] <<= d, f[f.length - 1] |= c[g] >> 8 - d, f.push(c[g] & s(8 - d)), d += 3);
    const h = c.length / 4, p = parseInt((0, r.sha256)(c).substring(2, 4), 16) & n(h);
    return f[f.length - 1] <<= h, f[f.length - 1] |= p >> 8 - h, l.join(f.map((g) => l.getWord(g)));
  }
  const o = {};
  class u {
    /**
     *  @private
     */
    constructor(l, f, d, h, p) {
      /**
       *  The mnemonic phrase of 12, 15, 18, 21 or 24 words.
       *
       *  Use the [[wordlist]] ``split`` method to get the individual words.
       */
      Q(this, "phrase");
      /**
       *  The password used for this mnemonic. If no password is used this
       *  is the empty string (i.e. ``""``) as per the specification.
       */
      Q(this, "password");
      /**
       *  The wordlist for this mnemonic.
       */
      Q(this, "wordlist");
      /**
       *  The underlying entropy which the mnemonic encodes.
       */
      Q(this, "entropy");
      h == null && (h = ""), p == null && (p = t.LangEn.wordlist()), (0, e.assertPrivate)(l, o, "Mnemonic"), (0, e.defineProperties)(this, { phrase: d, password: h, wordlist: p, entropy: f });
    }
    /**
     *  Returns the seed for the mnemonic.
     */
    computeSeed() {
      const l = (0, e.toUtf8Bytes)("mnemonic" + this.password, "NFKD");
      return (0, r.pbkdf2)((0, e.toUtf8Bytes)(this.phrase, "NFKD"), l, 2048, 64, "sha512");
    }
    /**
     *  Creates a new Mnemonic for the %%phrase%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromPhrase(l, f, d) {
      const h = i(l, d);
      return l = a((0, e.getBytes)(h), d), new u(o, h, l, f, d);
    }
    /**
     *  Create a new **Mnemonic** from the %%entropy%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */
    static fromEntropy(l, f, d) {
      const h = (0, e.getBytes)(l, "entropy"), p = a(h, d);
      return new u(o, (0, e.hexlify)(h), p, f, d);
    }
    /**
     *  Returns the phrase for %%mnemonic%%.
     */
    static entropyToPhrase(l, f) {
      const d = (0, e.getBytes)(l, "entropy");
      return a(d, f);
    }
    /**
     *  Returns the entropy for %%phrase%%.
     */
    static phraseToEntropy(l, f) {
      return i(l, f);
    }
    /**
     *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
     *
     *  This checks all the provided words belong to the %%wordlist%%,
     *  that the length is valid and the checksum is correct.
     */
    static isValidMnemonic(l, f) {
      try {
        return i(l, f), !0;
      } catch {
      }
      return !1;
    }
  }
  return Vl.Mnemonic = u, Vl;
}
var vr = {}, Op = {}, $l = {}, f2;
function T6() {
  if (f2) return $l;
  f2 = 1;
  /*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
  var r = nt && nt.__classPrivateFieldGet || function(U, R, j, D) {
    if (j === "a" && !D) throw new TypeError("Private accessor was defined without a getter");
    if (typeof R == "function" ? U !== R || !D : !R.has(U)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return j === "m" ? D : j === "a" ? D.call(U) : D ? D.value : R.get(U);
  }, e = nt && nt.__classPrivateFieldSet || function(U, R, j, D, O) {
    if (D === "m") throw new TypeError("Private method is not writable");
    if (D === "a" && !O) throw new TypeError("Private accessor was defined without a setter");
    if (typeof R == "function" ? U !== R || !O : !R.has(U)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return D === "a" ? O.call(U, j) : O ? O.value = j : R.set(U, j), j;
  }, t, n, s;
  Object.defineProperty($l, "__esModule", { value: !0 }), $l.AES = void 0;
  const i = { 16: 10, 24: 12, 32: 14 }, a = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], o = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], u = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], c = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], l = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], f = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], d = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], h = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], p = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], g = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], k = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], A = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], y = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], E = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], m = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
  function N(U) {
    const R = [];
    for (let j = 0; j < U.length; j += 4)
      R.push(U[j] << 24 | U[j + 1] << 16 | U[j + 2] << 8 | U[j + 3]);
    return R;
  }
  class T {
    get key() {
      return r(this, t, "f").slice();
    }
    constructor(R) {
      if (t.set(this, void 0), n.set(this, void 0), s.set(this, void 0), !(this instanceof T))
        throw Error("AES must be instanitated with `new`");
      e(this, t, new Uint8Array(R), "f");
      const j = i[this.key.length];
      if (j == null)
        throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
      e(this, s, [], "f"), e(this, n, [], "f");
      for (let H = 0; H <= j; H++)
        r(this, s, "f").push([0, 0, 0, 0]), r(this, n, "f").push([0, 0, 0, 0]);
      const D = (j + 1) * 4, O = this.key.length / 4, I = N(this.key);
      let P;
      for (let H = 0; H < O; H++)
        P = H >> 2, r(this, s, "f")[P][H % 4] = I[H], r(this, n, "f")[j - P][H % 4] = I[H];
      let S = 0, B = O, C;
      for (; B < D; ) {
        if (C = I[O - 1], I[0] ^= o[C >> 16 & 255] << 24 ^ o[C >> 8 & 255] << 16 ^ o[C & 255] << 8 ^ o[C >> 24 & 255] ^ a[S] << 24, S += 1, O != 8)
          for (let M = 1; M < O; M++)
            I[M] ^= I[M - 1];
        else {
          for (let M = 1; M < O / 2; M++)
            I[M] ^= I[M - 1];
          C = I[O / 2 - 1], I[O / 2] ^= o[C & 255] ^ o[C >> 8 & 255] << 8 ^ o[C >> 16 & 255] << 16 ^ o[C >> 24 & 255] << 24;
          for (let M = O / 2 + 1; M < O; M++)
            I[M] ^= I[M - 1];
        }
        let H = 0, V, J;
        for (; H < O && B < D; )
          V = B >> 2, J = B % 4, r(this, s, "f")[V][J] = I[H], r(this, n, "f")[j - V][J] = I[H++], B++;
      }
      for (let H = 1; H < j; H++)
        for (let V = 0; V < 4; V++)
          C = r(this, n, "f")[H][V], r(this, n, "f")[H][V] = A[C >> 24 & 255] ^ y[C >> 16 & 255] ^ E[C >> 8 & 255] ^ m[C & 255];
    }
    encrypt(R) {
      if (R.length != 16)
        throw new TypeError("invalid plaintext size (must be 16 bytes)");
      const j = r(this, s, "f").length - 1, D = [0, 0, 0, 0];
      let O = N(R);
      for (let S = 0; S < 4; S++)
        O[S] ^= r(this, s, "f")[0][S];
      for (let S = 1; S < j; S++) {
        for (let B = 0; B < 4; B++)
          D[B] = c[O[B] >> 24 & 255] ^ l[O[(B + 1) % 4] >> 16 & 255] ^ f[O[(B + 2) % 4] >> 8 & 255] ^ d[O[(B + 3) % 4] & 255] ^ r(this, s, "f")[S][B];
        O = D.slice();
      }
      const I = new Uint8Array(16);
      let P = 0;
      for (let S = 0; S < 4; S++)
        P = r(this, s, "f")[j][S], I[4 * S] = (o[O[S] >> 24 & 255] ^ P >> 24) & 255, I[4 * S + 1] = (o[O[(S + 1) % 4] >> 16 & 255] ^ P >> 16) & 255, I[4 * S + 2] = (o[O[(S + 2) % 4] >> 8 & 255] ^ P >> 8) & 255, I[4 * S + 3] = (o[O[(S + 3) % 4] & 255] ^ P) & 255;
      return I;
    }
    decrypt(R) {
      if (R.length != 16)
        throw new TypeError("invalid ciphertext size (must be 16 bytes)");
      const j = r(this, n, "f").length - 1, D = [0, 0, 0, 0];
      let O = N(R);
      for (let S = 0; S < 4; S++)
        O[S] ^= r(this, n, "f")[0][S];
      for (let S = 1; S < j; S++) {
        for (let B = 0; B < 4; B++)
          D[B] = h[O[B] >> 24 & 255] ^ p[O[(B + 3) % 4] >> 16 & 255] ^ g[O[(B + 2) % 4] >> 8 & 255] ^ k[O[(B + 1) % 4] & 255] ^ r(this, n, "f")[S][B];
        O = D.slice();
      }
      const I = new Uint8Array(16);
      let P = 0;
      for (let S = 0; S < 4; S++)
        P = r(this, n, "f")[j][S], I[4 * S] = (u[O[S] >> 24 & 255] ^ P >> 24) & 255, I[4 * S + 1] = (u[O[(S + 3) % 4] >> 16 & 255] ^ P >> 16) & 255, I[4 * S + 2] = (u[O[(S + 2) % 4] >> 8 & 255] ^ P >> 8) & 255, I[4 * S + 3] = (u[O[(S + 1) % 4] & 255] ^ P) & 255;
      return I;
    }
  }
  return $l.AES = T, t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), $l;
}
var Kl = {}, d2;
function ju() {
  if (d2) return Kl;
  d2 = 1, Object.defineProperty(Kl, "__esModule", { value: !0 }), Kl.ModeOfOperation = void 0;
  const r = T6();
  class e {
    constructor(n, s, i) {
      if (i && !(this instanceof i))
        throw new Error(`${n} must be instantiated with "new"`);
      Object.defineProperties(this, {
        aes: { enumerable: !0, value: new r.AES(s) },
        name: { enumerable: !0, value: n }
      });
    }
  }
  return Kl.ModeOfOperation = e, Kl;
}
var zl = {}, h2;
function ak() {
  if (h2) return zl;
  h2 = 1;
  var r = nt && nt.__classPrivateFieldSet || function(a, o, u, c, l) {
    if (c === "m") throw new TypeError("Private method is not writable");
    if (c === "a" && !l) throw new TypeError("Private accessor was defined without a setter");
    if (typeof o == "function" ? a !== o || !l : !o.has(a)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return c === "a" ? l.call(a, u) : l ? l.value = u : o.set(a, u), u;
  }, e = nt && nt.__classPrivateFieldGet || function(a, o, u, c) {
    if (u === "a" && !c) throw new TypeError("Private accessor was defined without a getter");
    if (typeof o == "function" ? a !== o || !c : !o.has(a)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return u === "m" ? c : u === "a" ? c.call(a) : c ? c.value : o.get(a);
  }, t, n;
  Object.defineProperty(zl, "__esModule", { value: !0 }), zl.CBC = void 0;
  const s = ju();
  class i extends s.ModeOfOperation {
    constructor(o, u) {
      if (super("ECC", o, i), t.set(this, void 0), n.set(this, void 0), u) {
        if (u.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        r(this, t, new Uint8Array(u), "f");
      } else
        r(this, t, new Uint8Array(16), "f");
      r(this, n, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(e(this, t, "f"));
    }
    encrypt(o) {
      if (o.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const u = new Uint8Array(o.length);
      for (let c = 0; c < o.length; c += 16) {
        for (let l = 0; l < 16; l++)
          e(this, n, "f")[l] ^= o[c + l];
        r(this, n, this.aes.encrypt(e(this, n, "f")), "f"), u.set(e(this, n, "f"), c);
      }
      return u;
    }
    decrypt(o) {
      if (o.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const u = new Uint8Array(o.length);
      for (let c = 0; c < o.length; c += 16) {
        const l = this.aes.decrypt(o.subarray(c, c + 16));
        for (let f = 0; f < 16; f++)
          u[c + f] = l[f] ^ e(this, n, "f")[f], e(this, n, "f")[f] = o[c + f];
      }
      return u;
    }
  }
  return zl.CBC = i, t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), zl;
}
var Jl = {}, p2;
function ok() {
  if (p2) return Jl;
  p2 = 1;
  var r = nt && nt.__classPrivateFieldSet || function(u, c, l, f, d) {
    if (f === "m") throw new TypeError("Private method is not writable");
    if (f === "a" && !d) throw new TypeError("Private accessor was defined without a setter");
    if (typeof c == "function" ? u !== c || !d : !c.has(u)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return f === "a" ? d.call(u, l) : d ? d.value = l : c.set(u, l), l;
  }, e = nt && nt.__classPrivateFieldGet || function(u, c, l, f) {
    if (l === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof c == "function" ? u !== c || !f : !c.has(u)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return l === "m" ? f : l === "a" ? f.call(u) : f ? f.value : c.get(u);
  }, t, n, s, i;
  Object.defineProperty(Jl, "__esModule", { value: !0 }), Jl.CFB = void 0;
  const a = ju();
  class o extends a.ModeOfOperation {
    constructor(c, l, f = 8) {
      if (super("CFB", c, o), t.add(this), n.set(this, void 0), s.set(this, void 0), !Number.isInteger(f) || f % 8)
        throw new TypeError("invalid segmentSize");
      if (Object.defineProperties(this, {
        segmentSize: { enumerable: !0, value: f }
      }), l) {
        if (l.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        r(this, n, new Uint8Array(l), "f");
      } else
        r(this, n, new Uint8Array(16), "f");
      r(this, s, this.iv, "f");
    }
    get iv() {
      return new Uint8Array(e(this, n, "f"));
    }
    encrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid plaintext size (must be multiple of segmentSize bytes)");
      const l = this.segmentSize / 8, f = new Uint8Array(c);
      for (let d = 0; d < f.length; d += l) {
        const h = this.aes.encrypt(e(this, s, "f"));
        for (let p = 0; p < l; p++)
          f[d + p] ^= h[p];
        e(this, t, "m", i).call(this, f.subarray(d));
      }
      return f;
    }
    decrypt(c) {
      if (8 * c.length % this.segmentSize)
        throw new TypeError("invalid ciphertext size (must be multiple of segmentSize bytes)");
      const l = this.segmentSize / 8, f = new Uint8Array(c);
      for (let d = 0; d < f.length; d += l) {
        const h = this.aes.encrypt(e(this, s, "f"));
        for (let p = 0; p < l; p++)
          f[d + p] ^= h[p];
        e(this, t, "m", i).call(this, c.subarray(d));
      }
      return f;
    }
  }
  return Jl.CFB = o, n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakSet(), i = function(c) {
    const l = this.segmentSize / 8;
    e(this, s, "f").set(e(this, s, "f").subarray(l)), e(this, s, "f").set(c.subarray(0, l), 16 - l);
  }, Jl;
}
var Ql = {}, b2;
function ck() {
  if (b2) return Ql;
  b2 = 1;
  var r = nt && nt.__classPrivateFieldSet || function(o, u, c, l, f) {
    if (l === "m") throw new TypeError("Private method is not writable");
    if (l === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof u == "function" ? o !== u || !f : !u.has(o)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return l === "a" ? f.call(o, c) : f ? f.value = c : u.set(o, c), c;
  }, e = nt && nt.__classPrivateFieldGet || function(o, u, c, l) {
    if (c === "a" && !l) throw new TypeError("Private accessor was defined without a getter");
    if (typeof u == "function" ? o !== u || !l : !u.has(o)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? l : c === "a" ? l.call(o) : l ? l.value : u.get(o);
  }, t, n, s;
  Object.defineProperty(Ql, "__esModule", { value: !0 }), Ql.CTR = void 0;
  const i = ju();
  class a extends i.ModeOfOperation {
    constructor(u, c) {
      super("CTR", u, a), t.set(this, void 0), n.set(this, void 0), s.set(this, void 0), r(this, s, new Uint8Array(16), "f"), e(this, s, "f").fill(0), r(this, t, e(this, s, "f"), "f"), r(this, n, 16, "f"), c == null && (c = 1), typeof c == "number" ? this.setCounterValue(c) : this.setCounterBytes(c);
    }
    get counter() {
      return new Uint8Array(e(this, s, "f"));
    }
    setCounterValue(u) {
      if (!Number.isInteger(u) || u < 0 || u > Number.MAX_SAFE_INTEGER)
        throw new TypeError("invalid counter initial integer value");
      for (let c = 15; c >= 0; --c)
        e(this, s, "f")[c] = u % 256, u = Math.floor(u / 256);
    }
    setCounterBytes(u) {
      if (u.length !== 16)
        throw new TypeError("invalid counter initial Uint8Array value length");
      e(this, s, "f").set(u);
    }
    increment() {
      for (let u = 15; u >= 0; u--)
        if (e(this, s, "f")[u] === 255)
          e(this, s, "f")[u] = 0;
        else {
          e(this, s, "f")[u]++;
          break;
        }
    }
    encrypt(u) {
      var c, l;
      const f = new Uint8Array(u);
      for (let d = 0; d < f.length; d++)
        e(this, n, "f") === 16 && (r(this, t, this.aes.encrypt(e(this, s, "f")), "f"), r(this, n, 0, "f"), this.increment()), f[d] ^= e(this, t, "f")[r(this, n, (l = e(this, n, "f"), c = l++, l), "f"), c];
      return f;
    }
    decrypt(u) {
      return this.encrypt(u);
    }
  }
  return Ql.CTR = a, t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), Ql;
}
var ql = {}, g2;
function uk() {
  if (g2) return ql;
  g2 = 1, Object.defineProperty(ql, "__esModule", { value: !0 }), ql.ECB = void 0;
  const r = ju();
  class e extends r.ModeOfOperation {
    constructor(n) {
      super("ECB", n, e);
    }
    encrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.encrypt(n.subarray(i, i + 16)), i);
      return s;
    }
    decrypt(n) {
      if (n.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      const s = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i += 16)
        s.set(this.aes.decrypt(n.subarray(i, i + 16)), i);
      return s;
    }
  }
  return ql.ECB = e, ql;
}
var Wl = {}, x2;
function lk() {
  if (x2) return Wl;
  x2 = 1;
  var r = nt && nt.__classPrivateFieldSet || function(o, u, c, l, f) {
    if (l === "m") throw new TypeError("Private method is not writable");
    if (l === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof u == "function" ? o !== u || !f : !u.has(o)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return l === "a" ? f.call(o, c) : f ? f.value = c : u.set(o, c), c;
  }, e = nt && nt.__classPrivateFieldGet || function(o, u, c, l) {
    if (c === "a" && !l) throw new TypeError("Private accessor was defined without a getter");
    if (typeof u == "function" ? o !== u || !l : !u.has(o)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return c === "m" ? l : c === "a" ? l.call(o) : l ? l.value : u.get(o);
  }, t, n, s;
  Object.defineProperty(Wl, "__esModule", { value: !0 }), Wl.OFB = void 0;
  const i = ju();
  class a extends i.ModeOfOperation {
    constructor(u, c) {
      if (super("OFB", u, a), t.set(this, void 0), n.set(this, void 0), s.set(this, void 0), c) {
        if (c.length % 16)
          throw new TypeError("invalid iv size (must be 16 bytes)");
        r(this, t, new Uint8Array(c), "f");
      } else
        r(this, t, new Uint8Array(16), "f");
      r(this, n, this.iv, "f"), r(this, s, 16, "f");
    }
    get iv() {
      return new Uint8Array(e(this, t, "f"));
    }
    encrypt(u) {
      var c, l;
      if (u.length % 16)
        throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
      const f = new Uint8Array(u);
      for (let d = 0; d < f.length; d++)
        e(this, s, "f") === 16 && (r(this, n, this.aes.encrypt(e(this, n, "f")), "f"), r(this, s, 0, "f")), f[d] ^= e(this, n, "f")[r(this, s, (l = e(this, s, "f"), c = l++, l), "f"), c];
      return f;
    }
    decrypt(u) {
      if (u.length % 16)
        throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
      return this.encrypt(u);
    }
  }
  return Wl.OFB = a, t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), Wl;
}
var va = {}, m2;
function fk() {
  if (m2) return va;
  m2 = 1, Object.defineProperty(va, "__esModule", { value: !0 }), va.pkcs7Strip = va.pkcs7Pad = void 0;
  function r(t) {
    const n = 16 - t.length % 16, s = new Uint8Array(t.length + n);
    s.set(t);
    for (let i = t.length; i < s.length; i++)
      s[i] = n;
    return s;
  }
  va.pkcs7Pad = r;
  function e(t) {
    if (t.length < 16)
      throw new TypeError("PKCS#7 invalid length");
    const n = t[t.length - 1];
    if (n > 16)
      throw new TypeError("PKCS#7 padding byte out of range");
    const s = t.length - n;
    for (let i = 0; i < n; i++)
      if (t[s + i] !== n)
        throw new TypeError("PKCS#7 invalid padding byte");
    return new Uint8Array(t.subarray(0, s));
  }
  return va.pkcs7Strip = e, va;
}
var y2;
function B6() {
  return y2 || (y2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.pkcs7Strip = r.pkcs7Pad = r.OFB = r.ECB = r.CTR = r.CFB = r.CBC = r.ModeOfOperation = r.AES = void 0;
    var e = T6();
    Object.defineProperty(r, "AES", { enumerable: !0, get: function() {
      return e.AES;
    } });
    var t = ju();
    Object.defineProperty(r, "ModeOfOperation", { enumerable: !0, get: function() {
      return t.ModeOfOperation;
    } });
    var n = ak();
    Object.defineProperty(r, "CBC", { enumerable: !0, get: function() {
      return n.CBC;
    } });
    var s = ok();
    Object.defineProperty(r, "CFB", { enumerable: !0, get: function() {
      return s.CFB;
    } });
    var i = ck();
    Object.defineProperty(r, "CTR", { enumerable: !0, get: function() {
      return i.CTR;
    } });
    var a = uk();
    Object.defineProperty(r, "ECB", { enumerable: !0, get: function() {
      return a.ECB;
    } });
    var o = lk();
    Object.defineProperty(r, "OFB", { enumerable: !0, get: function() {
      return o.OFB;
    } });
    var u = fk();
    Object.defineProperty(r, "pkcs7Pad", { enumerable: !0, get: function() {
      return u.pkcs7Pad;
    } }), Object.defineProperty(r, "pkcs7Strip", { enumerable: !0, get: function() {
      return u.pkcs7Strip;
    } });
  }(Op)), Op;
}
var un = {}, w2;
function O6() {
  if (w2) return un;
  w2 = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.spelunk = un.getPassword = un.zpad = un.looseArrayify = void 0;
  const r = Me();
  function e(i) {
    return typeof i == "string" && !i.startsWith("0x") && (i = "0x" + i), (0, r.getBytesCopy)(i);
  }
  un.looseArrayify = e;
  function t(i, a) {
    for (i = String(i); i.length < a; )
      i = "0" + i;
    return i;
  }
  un.zpad = t;
  function n(i) {
    return typeof i == "string" ? (0, r.toUtf8Bytes)(i, "NFKC") : (0, r.getBytesCopy)(i);
  }
  un.getPassword = n;
  function s(i, a) {
    const o = a.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
    (0, r.assertArgument)(o != null, "invalid path", "path", a);
    const u = o[1], c = o[3], l = o[4] === "!";
    let f = i;
    for (const d of u.toLowerCase().split(".")) {
      if (Array.isArray(f)) {
        if (!d.match(/^[0-9]+$/))
          break;
        f = f[parseInt(d)];
      } else if (typeof f == "object") {
        let h = null;
        for (const p in f)
          if (p.toLowerCase() === d) {
            h = f[p];
            break;
          }
        f = h;
      } else
        f = null;
      if (f == null)
        break;
    }
    if ((0, r.assertArgument)(!l || f != null, "missing required value", "path", u), c && f != null) {
      if (c === "int") {
        if (typeof f == "string" && f.match(/^-?[0-9]+$/))
          return parseInt(f);
        if (Number.isSafeInteger(f))
          return f;
      }
      if (c === "number" && typeof f == "string" && f.match(/^-?[0-9.]*$/))
        return parseFloat(f);
      if (c === "data" && typeof f == "string")
        return e(f);
      if (c === "array" && Array.isArray(f) || c === typeof f)
        return f;
      (0, r.assertArgument)(!1, `wrong type found for ${c} `, "path", u);
    }
    return f;
  }
  return un.spelunk = s, un;
}
var A2;
function yx() {
  if (A2) return vr;
  A2 = 1, Object.defineProperty(vr, "__esModule", { value: !0 }), vr.encryptKeystoreJson = vr.encryptKeystoreJsonSync = vr.decryptKeystoreJson = vr.decryptKeystoreJsonSync = vr.isKeystoreJson = void 0;
  const r = B6(), e = zt(), t = Yt(), n = Lr(), s = Me(), i = O6(), a = ox(), o = "m/44'/60'/0'/0/0";
  function u(E) {
    try {
      const m = JSON.parse(E);
      if ((m.version != null ? parseInt(m.version) : 0) === 3)
        return !0;
    } catch {
    }
    return !1;
  }
  vr.isKeystoreJson = u;
  function c(E, m, N) {
    if ((0, i.spelunk)(E, "crypto.cipher:string") === "aes-128-ctr") {
      const U = (0, i.spelunk)(E, "crypto.cipherparams.iv:data!"), R = new r.CTR(m, U);
      return (0, s.hexlify)(R.decrypt(N));
    }
    (0, s.assert)(!1, "unsupported cipher", "UNSUPPORTED_OPERATION", {
      operation: "decrypt"
    });
  }
  function l(E, m) {
    const N = (0, s.getBytes)(m), T = (0, i.spelunk)(E, "crypto.ciphertext:data!"), U = (0, s.hexlify)((0, t.keccak256)((0, s.concat)([N.slice(16, 32), T]))).substring(2);
    (0, s.assertArgument)(U === (0, i.spelunk)(E, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
    const R = c(E, N.slice(0, 16), T), j = (0, n.computeAddress)(R);
    if (E.address) {
      let I = E.address.toLowerCase();
      I.startsWith("0x") || (I = "0x" + I), (0, s.assertArgument)((0, e.getAddress)(I) === j, "keystore address/privateKey mismatch", "address", E.address);
    }
    const D = { address: j, privateKey: R };
    if ((0, i.spelunk)(E, "x-ethers.version:string") === "0.1") {
      const I = N.slice(32, 64), P = (0, i.spelunk)(E, "x-ethers.mnemonicCiphertext:data!"), S = (0, i.spelunk)(E, "x-ethers.mnemonicCounter:data!"), B = new r.CTR(I, S);
      D.mnemonic = {
        path: (0, i.spelunk)(E, "x-ethers.path:string") || o,
        locale: (0, i.spelunk)(E, "x-ethers.locale:string") || "en",
        entropy: (0, s.hexlify)((0, s.getBytes)(B.decrypt(P)))
      };
    }
    return D;
  }
  function f(E) {
    const m = (0, i.spelunk)(E, "crypto.kdf:string");
    if (m && typeof m == "string") {
      if (m.toLowerCase() === "scrypt") {
        const N = (0, i.spelunk)(E, "crypto.kdfparams.salt:data!"), T = (0, i.spelunk)(E, "crypto.kdfparams.n:int!"), U = (0, i.spelunk)(E, "crypto.kdfparams.r:int!"), R = (0, i.spelunk)(E, "crypto.kdfparams.p:int!");
        (0, s.assertArgument)(T > 0 && (T & T - 1) === 0, "invalid kdf.N", "kdf.N", T), (0, s.assertArgument)(U > 0 && R > 0, "invalid kdf", "kdf", m);
        const j = (0, i.spelunk)(E, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(j === 32, "invalid kdf.dklen", "kdf.dflen", j), { name: "scrypt", salt: N, N: T, r: U, p: R, dkLen: 64 };
      } else if (m.toLowerCase() === "pbkdf2") {
        const N = (0, i.spelunk)(E, "crypto.kdfparams.salt:data!"), T = (0, i.spelunk)(E, "crypto.kdfparams.prf:string!"), U = T.split("-").pop();
        (0, s.assertArgument)(U === "sha256" || U === "sha512", "invalid kdf.pdf", "kdf.pdf", T);
        const R = (0, i.spelunk)(E, "crypto.kdfparams.c:int!"), j = (0, i.spelunk)(E, "crypto.kdfparams.dklen:int!");
        return (0, s.assertArgument)(j === 32, "invalid kdf.dklen", "kdf.dklen", j), { name: "pbkdf2", salt: N, count: R, dkLen: j, algorithm: U };
      }
    }
    (0, s.assertArgument)(!1, "unsupported key-derivation function", "kdf", m);
  }
  function d(E, m) {
    const N = JSON.parse(E), T = (0, i.getPassword)(m), U = f(N);
    if (U.name === "pbkdf2") {
      const { salt: S, count: B, dkLen: C, algorithm: H } = U, V = (0, t.pbkdf2)(T, S, B, C, H);
      return l(N, V);
    }
    (0, s.assert)(U.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: U });
    const { salt: R, N: j, r: D, p: O, dkLen: I } = U, P = (0, t.scryptSync)(T, R, j, D, O, I);
    return l(N, P);
  }
  vr.decryptKeystoreJsonSync = d;
  function h(E) {
    return new Promise((m) => {
      setTimeout(() => {
        m();
      }, E);
    });
  }
  async function p(E, m, N) {
    const T = JSON.parse(E), U = (0, i.getPassword)(m), R = f(T);
    if (R.name === "pbkdf2") {
      N && (N(0), await h(0));
      const { salt: B, count: C, dkLen: H, algorithm: V } = R, J = (0, t.pbkdf2)(U, B, C, H, V);
      return N && (N(1), await h(0)), l(T, J);
    }
    (0, s.assert)(R.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", { params: R });
    const { salt: j, N: D, r: O, p: I, dkLen: P } = R, S = await (0, t.scrypt)(U, j, D, O, I, P, N);
    return l(T, S);
  }
  vr.decryptKeystoreJson = p;
  function g(E) {
    const m = E.salt != null ? (0, s.getBytes)(E.salt, "options.salt") : (0, t.randomBytes)(32);
    let N = 1 << 17, T = 8, U = 1;
    return E.scrypt && (E.scrypt.N && (N = E.scrypt.N), E.scrypt.r && (T = E.scrypt.r), E.scrypt.p && (U = E.scrypt.p)), (0, s.assertArgument)(typeof N == "number" && N > 0 && Number.isSafeInteger(N) && (BigInt(N) & BigInt(N - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", N), (0, s.assertArgument)(typeof T == "number" && T > 0 && Number.isSafeInteger(T), "invalid scrypt r parameter", "options.r", T), (0, s.assertArgument)(typeof U == "number" && U > 0 && Number.isSafeInteger(U), "invalid scrypt p parameter", "options.p", U), { name: "scrypt", dkLen: 32, salt: m, N, r: T, p: U };
  }
  function k(E, m, N, T) {
    const U = (0, s.getBytes)(N.privateKey, "privateKey"), R = T.iv != null ? (0, s.getBytes)(T.iv, "options.iv") : (0, t.randomBytes)(16);
    (0, s.assertArgument)(R.length === 16, "invalid options.iv length", "options.iv", T.iv);
    const j = T.uuid != null ? (0, s.getBytes)(T.uuid, "options.uuid") : (0, t.randomBytes)(16);
    (0, s.assertArgument)(j.length === 16, "invalid options.uuid length", "options.uuid", T.iv);
    const D = E.slice(0, 16), O = E.slice(16, 32), I = new r.CTR(D, R), P = (0, s.getBytes)(I.encrypt(U)), S = (0, t.keccak256)((0, s.concat)([O, P])), B = {
      address: N.address.substring(2).toLowerCase(),
      id: (0, s.uuidV4)(j),
      version: 3,
      Crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: (0, s.hexlify)(R).substring(2)
        },
        ciphertext: (0, s.hexlify)(P).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: (0, s.hexlify)(m.salt).substring(2),
          n: m.N,
          dklen: 32,
          p: m.p,
          r: m.r
        },
        mac: S.substring(2)
      }
    };
    if (N.mnemonic) {
      const C = T.client != null ? T.client : `ethers/${a.version}`, H = N.mnemonic.path || o, V = N.mnemonic.locale || "en", J = E.slice(32, 64), M = (0, s.getBytes)(N.mnemonic.entropy, "account.mnemonic.entropy"), G = (0, t.randomBytes)(16), K = new r.CTR(J, G), X = (0, s.getBytes)(K.encrypt(M)), te = /* @__PURE__ */ new Date(), he = "UTC--" + (te.getUTCFullYear() + "-" + (0, i.zpad)(te.getUTCMonth() + 1, 2) + "-" + (0, i.zpad)(te.getUTCDate(), 2) + "T" + (0, i.zpad)(te.getUTCHours(), 2) + "-" + (0, i.zpad)(te.getUTCMinutes(), 2) + "-" + (0, i.zpad)(te.getUTCSeconds(), 2) + ".0Z") + "--" + B.address;
      B["x-ethers"] = {
        client: C,
        gethFilename: he,
        path: H,
        locale: V,
        mnemonicCounter: (0, s.hexlify)(G).substring(2),
        mnemonicCiphertext: (0, s.hexlify)(X).substring(2),
        version: "0.1"
      };
    }
    return JSON.stringify(B);
  }
  function A(E, m, N) {
    N == null && (N = {});
    const T = (0, i.getPassword)(m), U = g(N), R = (0, t.scryptSync)(T, U.salt, U.N, U.r, U.p, 64);
    return k((0, s.getBytes)(R), U, E, N);
  }
  vr.encryptKeystoreJsonSync = A;
  async function y(E, m, N) {
    N == null && (N = {});
    const T = (0, i.getPassword)(m), U = g(N), R = await (0, t.scrypt)(T, U.salt, U.N, U.r, U.p, 64, N.progressCallback);
    return k((0, s.getBytes)(R), U, E, N);
  }
  return vr.encryptKeystoreJson = y, vr;
}
var E2;
function N6() {
  return E2 || (E2 = 1, function(r) {
    var T, Db, R, b0;
    Object.defineProperty(r, "__esModule", { value: !0 }), r.getIndexedAccountPath = r.getAccountPath = r.HDNodeVoidWallet = r.HDNodeWallet = r.defaultPath = void 0;
    const e = Yt(), t = bx(), n = Lr(), s = Me(), i = vh(), a = gx(), o = mx(), u = yx();
    r.defaultPath = "m/44'/60'/0'/0/0";
    const c = new Uint8Array([66, 105, 116, 99, 111, 105, 110, 32, 115, 101, 101, 100]), l = 2147483648, f = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), d = "0123456789abcdef";
    function h(O, I) {
      let P = "";
      for (; O; )
        P = d[O % 16] + P, O = Math.trunc(O / 16);
      for (; P.length < I * 2; )
        P = "0" + P;
      return "0x" + P;
    }
    function p(O) {
      const I = (0, s.getBytes)(O), P = (0, s.dataSlice)((0, e.sha256)((0, e.sha256)(I)), 0, 4), S = (0, s.concat)([I, P]);
      return (0, s.encodeBase58)(S);
    }
    const g = {};
    function k(O, I, P, S) {
      const B = new Uint8Array(37);
      O & l ? ((0, s.assert)(S != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
        operation: "deriveChild"
      }), B.set((0, s.getBytes)(S), 1)) : B.set((0, s.getBytes)(P));
      for (let H = 24; H >= 0; H -= 8)
        B[33 + (H >> 3)] = O >> 24 - H & 255;
      const C = (0, s.getBytes)((0, e.computeHmac)("sha512", I, B));
      return { IL: C.slice(0, 32), IR: C.slice(32) };
    }
    function A(O, I) {
      const P = I.split("/");
      (0, s.assertArgument)(P.length > 0, "invalid path", "path", I), P[0] === "m" && ((0, s.assertArgument)(O.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${O.depth}`, "path", I), P.shift());
      let S = O;
      for (let B = 0; B < P.length; B++) {
        const C = P[B];
        if (C.match(/^[0-9]+'$/)) {
          const H = parseInt(C.substring(0, C.length - 1));
          (0, s.assertArgument)(H < l, "invalid path index", `path[${B}]`, C), S = S.deriveChild(l + H);
        } else if (C.match(/^[0-9]+$/)) {
          const H = parseInt(C);
          (0, s.assertArgument)(H < l, "invalid path index", `path[${B}]`, C), S = S.deriveChild(H);
        } else
          (0, s.assertArgument)(!1, "invalid path component", `path[${B}]`, C);
      }
      return S;
    }
    const D = class D extends a.BaseWallet {
      /**
       *  @private
       */
      constructor(P, S, B, C, H, V, J, M, G) {
        super(S, G);
        Z(this, T);
        /**
         *  The compressed public key.
         */
        Q(this, "publicKey");
        /**
         *  The fingerprint.
         *
         *  A fingerprint allows quick qay to detect parent and child nodes,
         *  but developers should be prepared to deal with collisions as it
         *  is only 4 bytes.
         */
        Q(this, "fingerprint");
        /**
         *  The parent fingerprint.
         */
        Q(this, "parentFingerprint");
        /**
         *  The mnemonic used to create this HD Node, if available.
         *
         *  Sources such as extended keys do not encode the mnemonic, in
         *  which case this will be ``null``.
         */
        Q(this, "mnemonic");
        /**
         *  The chaincode, which is effectively a public key used
         *  to derive children.
         */
        Q(this, "chainCode");
        /**
         *  The derivation path of this wallet.
         *
         *  Since extended keys do not provide full path details, this
         *  may be ``null``, if instantiated from a source that does not
         *  encode it.
         */
        Q(this, "path");
        /**
         *  The child index of this wallet. Values over ``2 *\* 31`` indicate
         *  the node is hardened.
         */
        Q(this, "index");
        /**
         *  The depth of this wallet, which is the number of components
         *  in its path.
         */
        Q(this, "depth");
        (0, s.assertPrivate)(P, g, "HDNodeWallet"), (0, s.defineProperties)(this, { publicKey: S.compressedPublicKey });
        const K = (0, s.dataSlice)((0, e.ripemd160)((0, e.sha256)(this.publicKey)), 0, 4);
        (0, s.defineProperties)(this, {
          parentFingerprint: B,
          fingerprint: K,
          chainCode: C,
          path: H,
          index: V,
          depth: J
        }), (0, s.defineProperties)(this, { mnemonic: M });
      }
      connect(P) {
        return new D(g, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, P);
      }
      /**
       *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
       *  %%password%%.
       *
       *  If %%progressCallback%% is specified, it will receive periodic
       *  updates as the encryption process progreses.
       */
      async encrypt(P, S) {
        return await (0, u.encryptKeystoreJson)(de(this, T, Db).call(this), P, { progressCallback: S });
      }
      /**
       *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
       *  %%password%%.
       *
       *  It is preferred to use the [async version](encrypt) instead,
       *  which allows a [[ProgressCallback]] to keep the user informed.
       *
       *  This method will block the event loop (freezing all UI) until
       *  it is complete, which may be a non-trivial duration.
       */
      encryptSync(P) {
        return (0, u.encryptKeystoreJsonSync)(de(this, T, Db).call(this), P);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpriv`` and can be used to
       *  reconstruct this HD Node to derive its children.
       */
      get extendedKey() {
        return (0, s.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), p((0, s.concat)([
          "0x0488ADE4",
          h(this.depth, 1),
          this.parentFingerprint,
          h(this.index, 4),
          this.chainCode,
          (0, s.concat)(["0x00", this.privateKey])
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Returns a neutered HD Node, which removes the private details
       *  of an HD Node.
       *
       *  A neutered node has no private key, but can be used to derive
       *  child addresses and other public data about the HD Node.
       */
      neuter() {
        return new E(g, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(P) {
        const S = (0, s.getNumber)(P, "index");
        (0, s.assertArgument)(S <= 4294967295, "invalid index", "index", S);
        let B = this.path;
        B && (B += "/" + (S & ~l), S & l && (B += "'"));
        const { IR: C, IL: H } = k(S, this.chainCode, this.publicKey, this.privateKey), V = new e.SigningKey((0, s.toBeHex)(((0, s.toBigInt)(H) + BigInt(this.privateKey)) % f, 32));
        return new D(g, V, this.fingerprint, (0, s.hexlify)(C), B, S, this.depth + 1, this.mnemonic, this.provider);
      }
      /**
       *  Return the HDNode for %%path%% from this node.
       */
      derivePath(P) {
        return A(this, P);
      }
      /**
       *  Creates a new HD Node from %%extendedKey%%.
       *
       *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
       *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
       *  or full HD Node ([[HDNodeWallet) respectively.
       */
      static fromExtendedKey(P) {
        const S = (0, s.toBeArray)((0, s.decodeBase58)(P));
        (0, s.assertArgument)(S.length === 82 || p(S.slice(0, 78)) === P, "invalid extended key", "extendedKey", "[ REDACTED ]");
        const B = S[4], C = (0, s.hexlify)(S.slice(5, 9)), H = parseInt((0, s.hexlify)(S.slice(9, 13)).substring(2), 16), V = (0, s.hexlify)(S.slice(13, 45)), J = S.slice(45, 78);
        switch ((0, s.hexlify)(S.slice(0, 4))) {
          case "0x0488b21e":
          case "0x043587cf": {
            const M = (0, s.hexlify)(J);
            return new E(g, (0, n.computeAddress)(M), M, C, V, null, H, B, null);
          }
          case "0x0488ade4":
          case "0x04358394 ":
            if (J[0] !== 0)
              break;
            return new D(g, new e.SigningKey(J.slice(1)), C, V, null, H, B, null, null);
        }
        (0, s.assertArgument)(!1, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
      }
      /**
       *  Creates a new random HDNode.
       */
      static createRandom(P, S, B) {
        var H;
        P == null && (P = ""), S == null && (S = r.defaultPath), B == null && (B = i.LangEn.wordlist());
        const C = o.Mnemonic.fromEntropy((0, e.randomBytes)(16), P, B);
        return de(H = D, R, b0).call(H, C.computeSeed(), C).derivePath(S);
      }
      /**
       *  Create an HD Node from %%mnemonic%%.
       */
      static fromMnemonic(P, S) {
        var B;
        return S || (S = r.defaultPath), de(B = D, R, b0).call(B, P.computeSeed(), P).derivePath(S);
      }
      /**
       *  Creates an HD Node from a mnemonic %%phrase%%.
       */
      static fromPhrase(P, S, B, C) {
        var V;
        S == null && (S = ""), B == null && (B = r.defaultPath), C == null && (C = i.LangEn.wordlist());
        const H = o.Mnemonic.fromPhrase(P, S, C);
        return de(V = D, R, b0).call(V, H.computeSeed(), H).derivePath(B);
      }
      /**
       *  Creates an HD Node from a %%seed%%.
       */
      static fromSeed(P) {
        var S;
        return de(S = D, R, b0).call(S, P, null);
      }
    };
    T = new WeakSet(), Db = function() {
      const P = { address: this.address, privateKey: this.privateKey }, S = this.mnemonic;
      return this.path && S && S.wordlist.locale === "en" && S.password === "" && (P.mnemonic = {
        path: this.path,
        locale: "en",
        entropy: S.entropy
      }), P;
    }, R = new WeakSet(), b0 = function(P, S) {
      (0, s.assertArgument)((0, s.isBytesLike)(P), "invalid seed", "seed", "[REDACTED]");
      const B = (0, s.getBytes)(P, "seed");
      (0, s.assertArgument)(B.length >= 16 && B.length <= 64, "invalid seed", "seed", "[REDACTED]");
      const C = (0, s.getBytes)((0, e.computeHmac)("sha512", c, B)), H = new e.SigningKey((0, s.hexlify)(C.slice(0, 32)));
      return new D(g, H, "0x00000000", (0, s.hexlify)(C.slice(32)), "m", 0, 0, S, null);
    }, Z(D, R);
    let y = D;
    r.HDNodeWallet = y;
    class E extends t.VoidSigner {
      /**
       *  @private
       */
      constructor(P, S, B, C, H, V, J, M, G) {
        super(S, G);
        /**
         *  The compressed public key.
         */
        Q(this, "publicKey");
        /**
         *  The fingerprint.
         *
         *  A fingerprint allows quick qay to detect parent and child nodes,
         *  but developers should be prepared to deal with collisions as it
         *  is only 4 bytes.
         */
        Q(this, "fingerprint");
        /**
         *  The parent node fingerprint.
         */
        Q(this, "parentFingerprint");
        /**
         *  The chaincode, which is effectively a public key used
         *  to derive children.
         */
        Q(this, "chainCode");
        /**
         *  The derivation path of this wallet.
         *
         *  Since extended keys do not provider full path details, this
         *  may be ``null``, if instantiated from a source that does not
         *  enocde it.
         */
        Q(this, "path");
        /**
         *  The child index of this wallet. Values over ``2 *\* 31`` indicate
         *  the node is hardened.
         */
        Q(this, "index");
        /**
         *  The depth of this wallet, which is the number of components
         *  in its path.
         */
        Q(this, "depth");
        (0, s.assertPrivate)(P, g, "HDNodeVoidWallet"), (0, s.defineProperties)(this, { publicKey: B });
        const K = (0, s.dataSlice)((0, e.ripemd160)((0, e.sha256)(B)), 0, 4);
        (0, s.defineProperties)(this, {
          publicKey: B,
          fingerprint: K,
          parentFingerprint: C,
          chainCode: H,
          path: V,
          index: J,
          depth: M
        });
      }
      connect(P) {
        return new E(g, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, P);
      }
      /**
       *  The extended key.
       *
       *  This key will begin with the prefix ``xpub`` and can be used to
       *  reconstruct this neutered key to derive its children addresses.
       */
      get extendedKey() {
        return (0, s.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", { operation: "extendedKey" }), p((0, s.concat)([
          "0x0488B21E",
          h(this.depth, 1),
          this.parentFingerprint,
          h(this.index, 4),
          this.chainCode,
          this.publicKey
        ]));
      }
      /**
       *  Returns true if this wallet has a path, providing a Type Guard
       *  that the path is non-null.
       */
      hasPath() {
        return this.path != null;
      }
      /**
       *  Return the child for %%index%%.
       */
      deriveChild(P) {
        const S = (0, s.getNumber)(P, "index");
        (0, s.assertArgument)(S <= 4294967295, "invalid index", "index", S);
        let B = this.path;
        B && (B += "/" + (S & ~l), S & l && (B += "'"));
        const { IR: C, IL: H } = k(S, this.chainCode, this.publicKey, null), V = e.SigningKey.addPoints(H, this.publicKey, !0), J = (0, n.computeAddress)(V);
        return new E(g, J, V, this.fingerprint, (0, s.hexlify)(C), B, S, this.depth + 1, this.provider);
      }
      /**
       *  Return the signer for %%path%% from this node.
       */
      derivePath(P) {
        return A(this, P);
      }
    }
    r.HDNodeVoidWallet = E;
    function m(O) {
      const I = (0, s.getNumber)(O, "index");
      return (0, s.assertArgument)(I >= 0 && I < l, "invalid account index", "index", I), `m/44'/60'/${I}'/0/0`;
    }
    r.getAccountPath = m;
    function N(O) {
      const I = (0, s.getNumber)(O, "index");
      return (0, s.assertArgument)(I >= 0 && I < l, "invalid account index", "index", I), `m/44'/60'/0'/0/${I}`;
    }
    r.getIndexedAccountPath = N;
  }(Bp)), Bp;
}
var ka = {}, P2;
function S6() {
  if (P2) return ka;
  P2 = 1, Object.defineProperty(ka, "__esModule", { value: !0 }), ka.decryptCrowdsaleJson = ka.isCrowdsaleJson = void 0;
  const r = B6(), e = zt(), t = Yt(), n = Ys(), s = Me(), i = O6();
  function a(u) {
    try {
      if (JSON.parse(u).encseed)
        return !0;
    } catch {
    }
    return !1;
  }
  ka.isCrowdsaleJson = a;
  function o(u, c) {
    const l = JSON.parse(u), f = (0, i.getPassword)(c), d = (0, e.getAddress)((0, i.spelunk)(l, "ethaddr:string!")), h = (0, i.looseArrayify)((0, i.spelunk)(l, "encseed:string!"));
    (0, s.assertArgument)(h && h.length % 16 === 0, "invalid encseed", "json", u);
    const p = (0, s.getBytes)((0, t.pbkdf2)(f, f, 2e3, 32, "sha256")).slice(0, 16), g = h.slice(0, 16), k = h.slice(16), A = new r.CBC(p, g), y = (0, r.pkcs7Strip)((0, s.getBytes)(A.decrypt(k)));
    let E = "";
    for (let m = 0; m < y.length; m++)
      E += String.fromCharCode(y[m]);
    return { address: d, privateKey: (0, n.id)(E) };
  }
  return ka.decryptCrowdsaleJson = o, ka;
}
var Yl = {}, v2;
function dk() {
  var c, jb;
  if (v2) return Yl;
  v2 = 1, Object.defineProperty(Yl, "__esModule", { value: !0 }), Yl.Wallet = void 0;
  const r = Yt(), e = Me(), t = gx(), n = N6(), s = S6(), i = yx(), a = mx();
  function o(d) {
    return new Promise((h) => {
      setTimeout(() => {
        h();
      }, d);
    });
  }
  const f = class f extends t.BaseWallet {
    /**
     *  Create a new wallet for the private %%key%%, optionally connected
     *  to %%provider%%.
     */
    constructor(h, p) {
      typeof h == "string" && !h.startsWith("0x") && (h = "0x" + h);
      let g = typeof h == "string" ? new r.SigningKey(h) : h;
      super(g, p);
    }
    connect(h) {
      return new f(this.signingKey, h);
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */
    async encrypt(h, p) {
      const g = { address: this.address, privateKey: this.privateKey };
      return await (0, i.encryptKeystoreJson)(g, h, { progressCallback: p });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */
    encryptSync(h) {
      const p = { address: this.address, privateKey: this.privateKey };
      return (0, i.encryptKeystoreJsonSync)(p, h);
    }
    /**
     *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
     *  with %%password%%.
     *
     *  If %%progress%% is provided, it is called periodically during
     *  decryption so that any UI can be updated.
     */
    static async fromEncryptedJson(h, p, g) {
      var A;
      let k = null;
      return (0, i.isKeystoreJson)(h) ? k = await (0, i.decryptKeystoreJson)(h, p, g) : (0, s.isCrowdsaleJson)(h) && (g && (g(0), await o(0)), k = (0, s.decryptCrowdsaleJson)(h, p), g && (g(1), await o(0))), de(A = f, c, jb).call(A, k);
    }
    /**
     *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
     *
     *  The [[fromEncryptedJson]] method is preferred, as this method
     *  will lock up and freeze the UI during decryption, which may take
     *  some time.
     */
    static fromEncryptedJsonSync(h, p) {
      var k;
      let g = null;
      return (0, i.isKeystoreJson)(h) ? g = (0, i.decryptKeystoreJsonSync)(h, p) : (0, s.isCrowdsaleJson)(h) ? g = (0, s.decryptCrowdsaleJson)(h, p) : (0, e.assertArgument)(!1, "invalid JSON wallet", "json", "[ REDACTED ]"), de(k = f, c, jb).call(k, g);
    }
    /**
     *  Creates a new random [[HDNodeWallet]] using the available
     *  [cryptographic random source](randomBytes).
     *
     *  If there is no crytographic random source, this will throw.
     */
    static createRandom(h) {
      const p = n.HDNodeWallet.createRandom();
      return h ? p.connect(h) : p;
    }
    /**
     *  Creates a [[HDNodeWallet]] for %%phrase%%.
     */
    static fromPhrase(h, p) {
      const g = n.HDNodeWallet.fromPhrase(h);
      return p ? g.connect(p) : g;
    }
  };
  c = new WeakSet(), jb = function(h) {
    if ((0, e.assertArgument)(h, "invalid JSON wallet", "json", "[ REDACTED ]"), "mnemonic" in h && h.mnemonic && h.mnemonic.locale === "en") {
      const g = a.Mnemonic.fromEntropy(h.mnemonic.entropy), k = n.HDNodeWallet.fromMnemonic(g, h.mnemonic.path);
      if (k.address === h.address && k.privateKey === h.privateKey)
        return k;
      console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
    }
    const p = new f(h.privateKey);
    return (0, e.assertArgument)(p.address === h.address, "address/privateKey mismatch", "json", "[ REDACTED ]"), p;
  }, Z(f, c);
  let u = f;
  return Yl.Wallet = u, Yl;
}
var k2;
function hk() {
  return k2 || (k2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Wallet = r.Mnemonic = r.encryptKeystoreJsonSync = r.encryptKeystoreJson = r.decryptKeystoreJson = r.decryptKeystoreJsonSync = r.isKeystoreJson = r.decryptCrowdsaleJson = r.isCrowdsaleJson = r.HDNodeVoidWallet = r.HDNodeWallet = r.getIndexedAccountPath = r.getAccountPath = r.defaultPath = r.BaseWallet = void 0;
    var e = gx();
    Object.defineProperty(r, "BaseWallet", { enumerable: !0, get: function() {
      return e.BaseWallet;
    } });
    var t = N6();
    Object.defineProperty(r, "defaultPath", { enumerable: !0, get: function() {
      return t.defaultPath;
    } }), Object.defineProperty(r, "getAccountPath", { enumerable: !0, get: function() {
      return t.getAccountPath;
    } }), Object.defineProperty(r, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return t.getIndexedAccountPath;
    } }), Object.defineProperty(r, "HDNodeWallet", { enumerable: !0, get: function() {
      return t.HDNodeWallet;
    } }), Object.defineProperty(r, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return t.HDNodeVoidWallet;
    } });
    var n = S6();
    Object.defineProperty(r, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return n.isCrowdsaleJson;
    } }), Object.defineProperty(r, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return n.decryptCrowdsaleJson;
    } });
    var s = yx();
    Object.defineProperty(r, "isKeystoreJson", { enumerable: !0, get: function() {
      return s.isKeystoreJson;
    } }), Object.defineProperty(r, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.decryptKeystoreJsonSync;
    } }), Object.defineProperty(r, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return s.decryptKeystoreJson;
    } }), Object.defineProperty(r, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return s.encryptKeystoreJson;
    } }), Object.defineProperty(r, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return s.encryptKeystoreJsonSync;
    } });
    var i = mx();
    Object.defineProperty(r, "Mnemonic", { enumerable: !0, get: function() {
      return i.Mnemonic;
    } });
    var a = dk();
    Object.defineProperty(r, "Wallet", { enumerable: !0, get: function() {
      return a.Wallet;
    } });
  }(Tp)), Tp;
}
var Np = {}, Zl = {}, Xl = {}, e0 = {}, T2;
function pk() {
  if (T2) return e0;
  T2 = 1, Object.defineProperty(e0, "__esModule", { value: !0 }), e0.decodeBits = void 0;
  const r = ")!@#$%^&*(ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
  function e(t, n) {
    const s = (1 << t) - 1, i = [];
    let a = 0, o = 0, u = 0;
    for (let c = 0; c < n.length; c++)
      for (a = a << 6 | r.indexOf(n[c]), o += 6; o >= t; ) {
        const l = a >> o - t;
        a &= (1 << o - t) - 1, o -= t, l === 0 ? u += s : (i.push(l + u), u = 0);
      }
    return i;
  }
  return e0.decodeBits = e, e0;
}
var B2;
function bk() {
  if (B2) return Xl;
  B2 = 1, Object.defineProperty(Xl, "__esModule", { value: !0 }), Xl.decodeOwlA = void 0;
  const r = Me(), e = pk(), t = v6();
  function n(s, i) {
    let a = (0, t.decodeOwl)(s).join(",");
    return i.split(/,/g).forEach((o) => {
      const u = o.match(/^([a-z]*)([0-9]+)([0-9])(.*)$/);
      (0, r.assertArgument)(u !== null, "internal error parsing accents", "accents", i);
      let c = 0;
      const l = (0, e.decodeBits)(parseInt(u[3]), u[4]), f = parseInt(u[2]), d = new RegExp(`([${u[1]}])`, "g");
      a = a.replace(d, (h, p) => (--l[c] === 0 && (p = String.fromCharCode(p.charCodeAt(0), f), c++), p));
    }), a.split(",");
  }
  return Xl.decodeOwlA = n, Xl;
}
var O2;
function gk() {
  var n;
  if (O2) return Zl;
  O2 = 1, Object.defineProperty(Zl, "__esModule", { value: !0 }), Zl.WordlistOwlA = void 0;
  const r = xx(), e = bk();
  class t extends r.WordlistOwl {
    /**
     *  Creates a new Wordlist for %%locale%% using the OWLA %%data%%
     *  and %%accent%% data and validated against the %%checksum%%.
     */
    constructor(a, o, u, c) {
      super(a, o, c);
      Z(this, n);
      F(this, n, u);
    }
    /**
     *  The OWLA-encoded accent data.
     */
    get _accent() {
      return x(this, n);
    }
    /**
     *  Decode all the words for the wordlist.
     */
    _decodeWords() {
      return (0, e.decodeOwlA)(this._data, this._accent);
    }
  }
  return n = new WeakMap(), Zl.WordlistOwlA = t, Zl;
}
var t0 = {}, N2;
function xk() {
  if (N2) return t0;
  N2 = 1, Object.defineProperty(t0, "__esModule", { value: !0 }), t0.wordlists = void 0;
  const r = vh();
  return t0.wordlists = {
    en: r.LangEn.wordlist()
  }, t0;
}
var S2;
function mk() {
  return S2 || (S2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.wordlists = r.WordlistOwlA = r.WordlistOwl = r.LangEn = r.Wordlist = void 0;
    var e = k6();
    Object.defineProperty(r, "Wordlist", { enumerable: !0, get: function() {
      return e.Wordlist;
    } });
    var t = vh();
    Object.defineProperty(r, "LangEn", { enumerable: !0, get: function() {
      return t.LangEn;
    } });
    var n = xx();
    Object.defineProperty(r, "WordlistOwl", { enumerable: !0, get: function() {
      return n.WordlistOwl;
    } });
    var s = gk();
    Object.defineProperty(r, "WordlistOwlA", { enumerable: !0, get: function() {
      return s.WordlistOwlA;
    } });
    var i = xk();
    Object.defineProperty(r, "wordlists", { enumerable: !0, get: function() {
      return i.wordlists;
    } });
  }(Np)), Np;
}
var C2;
function R2() {
  return C2 || (C2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.ripemd160 = r.keccak256 = r.randomBytes = r.computeHmac = r.UndecodedEventLog = r.EventLog = r.ContractUnknownEventPayload = r.ContractTransactionResponse = r.ContractTransactionReceipt = r.ContractEventPayload = r.ContractFactory = r.Contract = r.BaseContract = r.MessagePrefix = r.EtherSymbol = r.ZeroHash = r.N = r.MaxInt256 = r.MinInt256 = r.MaxUint256 = r.WeiPerEther = r.ZeroAddress = r.resolveAddress = r.isAddress = r.isAddressable = r.getCreate2Address = r.getCreateAddress = r.getIcapAddress = r.getAddress = r.Typed = r.TransactionDescription = r.Result = r.LogDescription = r.Interface = r.Indexed = r.ErrorDescription = r.checkResultErrors = r.StructFragment = r.ParamType = r.NamedFragment = r.FunctionFragment = r.FallbackFragment = r.Fragment = r.EventFragment = r.ErrorFragment = r.ConstructorFragment = r.AbiCoder = r.encodeBytes32String = r.decodeBytes32String = r.version = void 0, r.EnsPlugin = r.Network = r.EnsResolver = r.WebSocketProvider = r.SocketProvider = r.IpcSocketProvider = r.QuickNodeProvider = r.PocketProvider = r.InfuraWebSocketProvider = r.InfuraProvider = r.EtherscanProvider = r.CloudflareProvider = r.ChainstackProvider = r.AnkrProvider = r.AlchemyProvider = r.BrowserProvider = r.JsonRpcSigner = r.JsonRpcProvider = r.JsonRpcApiProvider = r.FallbackProvider = r.AbstractProvider = r.VoidSigner = r.NonceManager = r.AbstractSigner = r.TransactionResponse = r.TransactionReceipt = r.Log = r.FeeData = r.Block = r.getDefaultProvider = r.verifyTypedData = r.TypedDataEncoder = r.solidityPackedSha256 = r.solidityPackedKeccak256 = r.solidityPacked = r.verifyMessage = r.hashMessage = r.dnsEncode = r.namehash = r.isValidName = r.ensNormalize = r.id = r.SigningKey = r.Signature = r.lock = r.scryptSync = r.scrypt = r.pbkdf2 = r.sha512 = r.sha256 = void 0, r.getUint = r.getNumber = r.getBigInt = r.FixedNumber = r.FetchCancelSignal = r.FetchResponse = r.FetchRequest = r.EventPayload = r.isError = r.isCallException = r.makeError = r.assertPrivate = r.assertNormalize = r.assertArgumentCount = r.assertArgument = r.assert = r.resolveProperties = r.defineProperties = r.zeroPadValue = r.zeroPadBytes = r.stripZerosLeft = r.isBytesLike = r.isHexString = r.hexlify = r.getBytesCopy = r.getBytes = r.dataSlice = r.dataLength = r.concat = r.encodeBase64 = r.decodeBase64 = r.encodeBase58 = r.decodeBase58 = r.Transaction = r.recoverAddress = r.computeAddress = r.accessListify = r.showThrottleMessage = r.copyRequest = r.UnmanagedSubscriber = r.SocketSubscriber = r.SocketPendingSubscriber = r.SocketEventSubscriber = r.SocketBlockSubscriber = r.MulticoinProviderPlugin = r.NetworkPlugin = r.GasCostPlugin = r.FetchUrlFeeDataNetworkPlugin = r.FeeDataNetworkPlugin = r.EtherscanPlugin = void 0, r.wordlists = r.WordlistOwlA = r.WordlistOwl = r.LangEn = r.Wordlist = r.encryptKeystoreJsonSync = r.encryptKeystoreJson = r.decryptKeystoreJson = r.decryptKeystoreJsonSync = r.decryptCrowdsaleJson = r.isKeystoreJson = r.isCrowdsaleJson = r.getIndexedAccountPath = r.getAccountPath = r.defaultPath = r.Wallet = r.HDNodeVoidWallet = r.HDNodeWallet = r.BaseWallet = r.Mnemonic = r.uuidV4 = r.encodeRlp = r.decodeRlp = r.Utf8ErrorFuncs = r.toUtf8String = r.toUtf8CodePoints = r.toUtf8Bytes = r.parseUnits = r.formatUnits = r.parseEther = r.formatEther = r.mask = r.toTwos = r.fromTwos = r.toQuantity = r.toNumber = r.toBeHex = r.toBigInt = r.toBeArray = void 0;
    var e = ox();
    Object.defineProperty(r, "version", { enumerable: !0, get: function() {
      return e.version;
    } });
    var t = df();
    Object.defineProperty(r, "decodeBytes32String", { enumerable: !0, get: function() {
      return t.decodeBytes32String;
    } }), Object.defineProperty(r, "encodeBytes32String", { enumerable: !0, get: function() {
      return t.encodeBytes32String;
    } }), Object.defineProperty(r, "AbiCoder", { enumerable: !0, get: function() {
      return t.AbiCoder;
    } }), Object.defineProperty(r, "ConstructorFragment", { enumerable: !0, get: function() {
      return t.ConstructorFragment;
    } }), Object.defineProperty(r, "ErrorFragment", { enumerable: !0, get: function() {
      return t.ErrorFragment;
    } }), Object.defineProperty(r, "EventFragment", { enumerable: !0, get: function() {
      return t.EventFragment;
    } }), Object.defineProperty(r, "Fragment", { enumerable: !0, get: function() {
      return t.Fragment;
    } }), Object.defineProperty(r, "FallbackFragment", { enumerable: !0, get: function() {
      return t.FallbackFragment;
    } }), Object.defineProperty(r, "FunctionFragment", { enumerable: !0, get: function() {
      return t.FunctionFragment;
    } }), Object.defineProperty(r, "NamedFragment", { enumerable: !0, get: function() {
      return t.NamedFragment;
    } }), Object.defineProperty(r, "ParamType", { enumerable: !0, get: function() {
      return t.ParamType;
    } }), Object.defineProperty(r, "StructFragment", { enumerable: !0, get: function() {
      return t.StructFragment;
    } }), Object.defineProperty(r, "checkResultErrors", { enumerable: !0, get: function() {
      return t.checkResultErrors;
    } }), Object.defineProperty(r, "ErrorDescription", { enumerable: !0, get: function() {
      return t.ErrorDescription;
    } }), Object.defineProperty(r, "Indexed", { enumerable: !0, get: function() {
      return t.Indexed;
    } }), Object.defineProperty(r, "Interface", { enumerable: !0, get: function() {
      return t.Interface;
    } }), Object.defineProperty(r, "LogDescription", { enumerable: !0, get: function() {
      return t.LogDescription;
    } }), Object.defineProperty(r, "Result", { enumerable: !0, get: function() {
      return t.Result;
    } }), Object.defineProperty(r, "TransactionDescription", { enumerable: !0, get: function() {
      return t.TransactionDescription;
    } }), Object.defineProperty(r, "Typed", { enumerable: !0, get: function() {
      return t.Typed;
    } });
    var n = zt();
    Object.defineProperty(r, "getAddress", { enumerable: !0, get: function() {
      return n.getAddress;
    } }), Object.defineProperty(r, "getIcapAddress", { enumerable: !0, get: function() {
      return n.getIcapAddress;
    } }), Object.defineProperty(r, "getCreateAddress", { enumerable: !0, get: function() {
      return n.getCreateAddress;
    } }), Object.defineProperty(r, "getCreate2Address", { enumerable: !0, get: function() {
      return n.getCreate2Address;
    } }), Object.defineProperty(r, "isAddressable", { enumerable: !0, get: function() {
      return n.isAddressable;
    } }), Object.defineProperty(r, "isAddress", { enumerable: !0, get: function() {
      return n.isAddress;
    } }), Object.defineProperty(r, "resolveAddress", { enumerable: !0, get: function() {
      return n.resolveAddress;
    } });
    var s = ff();
    Object.defineProperty(r, "ZeroAddress", { enumerable: !0, get: function() {
      return s.ZeroAddress;
    } }), Object.defineProperty(r, "WeiPerEther", { enumerable: !0, get: function() {
      return s.WeiPerEther;
    } }), Object.defineProperty(r, "MaxUint256", { enumerable: !0, get: function() {
      return s.MaxUint256;
    } }), Object.defineProperty(r, "MinInt256", { enumerable: !0, get: function() {
      return s.MinInt256;
    } }), Object.defineProperty(r, "MaxInt256", { enumerable: !0, get: function() {
      return s.MaxInt256;
    } }), Object.defineProperty(r, "N", { enumerable: !0, get: function() {
      return s.N;
    } }), Object.defineProperty(r, "ZeroHash", { enumerable: !0, get: function() {
      return s.ZeroHash;
    } }), Object.defineProperty(r, "EtherSymbol", { enumerable: !0, get: function() {
      return s.EtherSymbol;
    } }), Object.defineProperty(r, "MessagePrefix", { enumerable: !0, get: function() {
      return s.MessagePrefix;
    } });
    var i = Ph();
    Object.defineProperty(r, "BaseContract", { enumerable: !0, get: function() {
      return i.BaseContract;
    } }), Object.defineProperty(r, "Contract", { enumerable: !0, get: function() {
      return i.Contract;
    } }), Object.defineProperty(r, "ContractFactory", { enumerable: !0, get: function() {
      return i.ContractFactory;
    } }), Object.defineProperty(r, "ContractEventPayload", { enumerable: !0, get: function() {
      return i.ContractEventPayload;
    } }), Object.defineProperty(r, "ContractTransactionReceipt", { enumerable: !0, get: function() {
      return i.ContractTransactionReceipt;
    } }), Object.defineProperty(r, "ContractTransactionResponse", { enumerable: !0, get: function() {
      return i.ContractTransactionResponse;
    } }), Object.defineProperty(r, "ContractUnknownEventPayload", { enumerable: !0, get: function() {
      return i.ContractUnknownEventPayload;
    } }), Object.defineProperty(r, "EventLog", { enumerable: !0, get: function() {
      return i.EventLog;
    } }), Object.defineProperty(r, "UndecodedEventLog", { enumerable: !0, get: function() {
      return i.UndecodedEventLog;
    } });
    var a = Yt();
    Object.defineProperty(r, "computeHmac", { enumerable: !0, get: function() {
      return a.computeHmac;
    } }), Object.defineProperty(r, "randomBytes", { enumerable: !0, get: function() {
      return a.randomBytes;
    } }), Object.defineProperty(r, "keccak256", { enumerable: !0, get: function() {
      return a.keccak256;
    } }), Object.defineProperty(r, "ripemd160", { enumerable: !0, get: function() {
      return a.ripemd160;
    } }), Object.defineProperty(r, "sha256", { enumerable: !0, get: function() {
      return a.sha256;
    } }), Object.defineProperty(r, "sha512", { enumerable: !0, get: function() {
      return a.sha512;
    } }), Object.defineProperty(r, "pbkdf2", { enumerable: !0, get: function() {
      return a.pbkdf2;
    } }), Object.defineProperty(r, "scrypt", { enumerable: !0, get: function() {
      return a.scrypt;
    } }), Object.defineProperty(r, "scryptSync", { enumerable: !0, get: function() {
      return a.scryptSync;
    } }), Object.defineProperty(r, "lock", { enumerable: !0, get: function() {
      return a.lock;
    } }), Object.defineProperty(r, "Signature", { enumerable: !0, get: function() {
      return a.Signature;
    } }), Object.defineProperty(r, "SigningKey", { enumerable: !0, get: function() {
      return a.SigningKey;
    } });
    var o = Ys();
    Object.defineProperty(r, "id", { enumerable: !0, get: function() {
      return o.id;
    } }), Object.defineProperty(r, "ensNormalize", { enumerable: !0, get: function() {
      return o.ensNormalize;
    } }), Object.defineProperty(r, "isValidName", { enumerable: !0, get: function() {
      return o.isValidName;
    } }), Object.defineProperty(r, "namehash", { enumerable: !0, get: function() {
      return o.namehash;
    } }), Object.defineProperty(r, "dnsEncode", { enumerable: !0, get: function() {
      return o.dnsEncode;
    } }), Object.defineProperty(r, "hashMessage", { enumerable: !0, get: function() {
      return o.hashMessage;
    } }), Object.defineProperty(r, "verifyMessage", { enumerable: !0, get: function() {
      return o.verifyMessage;
    } }), Object.defineProperty(r, "solidityPacked", { enumerable: !0, get: function() {
      return o.solidityPacked;
    } }), Object.defineProperty(r, "solidityPackedKeccak256", { enumerable: !0, get: function() {
      return o.solidityPackedKeccak256;
    } }), Object.defineProperty(r, "solidityPackedSha256", { enumerable: !0, get: function() {
      return o.solidityPackedSha256;
    } }), Object.defineProperty(r, "TypedDataEncoder", { enumerable: !0, get: function() {
      return o.TypedDataEncoder;
    } }), Object.defineProperty(r, "verifyTypedData", { enumerable: !0, get: function() {
      return o.verifyTypedData;
    } });
    var u = bx();
    Object.defineProperty(r, "getDefaultProvider", { enumerable: !0, get: function() {
      return u.getDefaultProvider;
    } }), Object.defineProperty(r, "Block", { enumerable: !0, get: function() {
      return u.Block;
    } }), Object.defineProperty(r, "FeeData", { enumerable: !0, get: function() {
      return u.FeeData;
    } }), Object.defineProperty(r, "Log", { enumerable: !0, get: function() {
      return u.Log;
    } }), Object.defineProperty(r, "TransactionReceipt", { enumerable: !0, get: function() {
      return u.TransactionReceipt;
    } }), Object.defineProperty(r, "TransactionResponse", { enumerable: !0, get: function() {
      return u.TransactionResponse;
    } }), Object.defineProperty(r, "AbstractSigner", { enumerable: !0, get: function() {
      return u.AbstractSigner;
    } }), Object.defineProperty(r, "NonceManager", { enumerable: !0, get: function() {
      return u.NonceManager;
    } }), Object.defineProperty(r, "VoidSigner", { enumerable: !0, get: function() {
      return u.VoidSigner;
    } }), Object.defineProperty(r, "AbstractProvider", { enumerable: !0, get: function() {
      return u.AbstractProvider;
    } }), Object.defineProperty(r, "FallbackProvider", { enumerable: !0, get: function() {
      return u.FallbackProvider;
    } }), Object.defineProperty(r, "JsonRpcApiProvider", { enumerable: !0, get: function() {
      return u.JsonRpcApiProvider;
    } }), Object.defineProperty(r, "JsonRpcProvider", { enumerable: !0, get: function() {
      return u.JsonRpcProvider;
    } }), Object.defineProperty(r, "JsonRpcSigner", { enumerable: !0, get: function() {
      return u.JsonRpcSigner;
    } }), Object.defineProperty(r, "BrowserProvider", { enumerable: !0, get: function() {
      return u.BrowserProvider;
    } }), Object.defineProperty(r, "AlchemyProvider", { enumerable: !0, get: function() {
      return u.AlchemyProvider;
    } }), Object.defineProperty(r, "AnkrProvider", { enumerable: !0, get: function() {
      return u.AnkrProvider;
    } }), Object.defineProperty(r, "ChainstackProvider", { enumerable: !0, get: function() {
      return u.ChainstackProvider;
    } }), Object.defineProperty(r, "CloudflareProvider", { enumerable: !0, get: function() {
      return u.CloudflareProvider;
    } }), Object.defineProperty(r, "EtherscanProvider", { enumerable: !0, get: function() {
      return u.EtherscanProvider;
    } }), Object.defineProperty(r, "InfuraProvider", { enumerable: !0, get: function() {
      return u.InfuraProvider;
    } }), Object.defineProperty(r, "InfuraWebSocketProvider", { enumerable: !0, get: function() {
      return u.InfuraWebSocketProvider;
    } }), Object.defineProperty(r, "PocketProvider", { enumerable: !0, get: function() {
      return u.PocketProvider;
    } }), Object.defineProperty(r, "QuickNodeProvider", { enumerable: !0, get: function() {
      return u.QuickNodeProvider;
    } }), Object.defineProperty(r, "IpcSocketProvider", { enumerable: !0, get: function() {
      return u.IpcSocketProvider;
    } }), Object.defineProperty(r, "SocketProvider", { enumerable: !0, get: function() {
      return u.SocketProvider;
    } }), Object.defineProperty(r, "WebSocketProvider", { enumerable: !0, get: function() {
      return u.WebSocketProvider;
    } }), Object.defineProperty(r, "EnsResolver", { enumerable: !0, get: function() {
      return u.EnsResolver;
    } }), Object.defineProperty(r, "Network", { enumerable: !0, get: function() {
      return u.Network;
    } }), Object.defineProperty(r, "EnsPlugin", { enumerable: !0, get: function() {
      return u.EnsPlugin;
    } }), Object.defineProperty(r, "EtherscanPlugin", { enumerable: !0, get: function() {
      return u.EtherscanPlugin;
    } }), Object.defineProperty(r, "FeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return u.FeeDataNetworkPlugin;
    } }), Object.defineProperty(r, "FetchUrlFeeDataNetworkPlugin", { enumerable: !0, get: function() {
      return u.FetchUrlFeeDataNetworkPlugin;
    } }), Object.defineProperty(r, "GasCostPlugin", { enumerable: !0, get: function() {
      return u.GasCostPlugin;
    } }), Object.defineProperty(r, "NetworkPlugin", { enumerable: !0, get: function() {
      return u.NetworkPlugin;
    } }), Object.defineProperty(r, "MulticoinProviderPlugin", { enumerable: !0, get: function() {
      return u.MulticoinProviderPlugin;
    } }), Object.defineProperty(r, "SocketBlockSubscriber", { enumerable: !0, get: function() {
      return u.SocketBlockSubscriber;
    } }), Object.defineProperty(r, "SocketEventSubscriber", { enumerable: !0, get: function() {
      return u.SocketEventSubscriber;
    } }), Object.defineProperty(r, "SocketPendingSubscriber", { enumerable: !0, get: function() {
      return u.SocketPendingSubscriber;
    } }), Object.defineProperty(r, "SocketSubscriber", { enumerable: !0, get: function() {
      return u.SocketSubscriber;
    } }), Object.defineProperty(r, "UnmanagedSubscriber", { enumerable: !0, get: function() {
      return u.UnmanagedSubscriber;
    } }), Object.defineProperty(r, "copyRequest", { enumerable: !0, get: function() {
      return u.copyRequest;
    } }), Object.defineProperty(r, "showThrottleMessage", { enumerable: !0, get: function() {
      return u.showThrottleMessage;
    } });
    var c = Lr();
    Object.defineProperty(r, "accessListify", { enumerable: !0, get: function() {
      return c.accessListify;
    } }), Object.defineProperty(r, "computeAddress", { enumerable: !0, get: function() {
      return c.computeAddress;
    } }), Object.defineProperty(r, "recoverAddress", { enumerable: !0, get: function() {
      return c.recoverAddress;
    } }), Object.defineProperty(r, "Transaction", { enumerable: !0, get: function() {
      return c.Transaction;
    } });
    var l = Me();
    Object.defineProperty(r, "decodeBase58", { enumerable: !0, get: function() {
      return l.decodeBase58;
    } }), Object.defineProperty(r, "encodeBase58", { enumerable: !0, get: function() {
      return l.encodeBase58;
    } }), Object.defineProperty(r, "decodeBase64", { enumerable: !0, get: function() {
      return l.decodeBase64;
    } }), Object.defineProperty(r, "encodeBase64", { enumerable: !0, get: function() {
      return l.encodeBase64;
    } }), Object.defineProperty(r, "concat", { enumerable: !0, get: function() {
      return l.concat;
    } }), Object.defineProperty(r, "dataLength", { enumerable: !0, get: function() {
      return l.dataLength;
    } }), Object.defineProperty(r, "dataSlice", { enumerable: !0, get: function() {
      return l.dataSlice;
    } }), Object.defineProperty(r, "getBytes", { enumerable: !0, get: function() {
      return l.getBytes;
    } }), Object.defineProperty(r, "getBytesCopy", { enumerable: !0, get: function() {
      return l.getBytesCopy;
    } }), Object.defineProperty(r, "hexlify", { enumerable: !0, get: function() {
      return l.hexlify;
    } }), Object.defineProperty(r, "isHexString", { enumerable: !0, get: function() {
      return l.isHexString;
    } }), Object.defineProperty(r, "isBytesLike", { enumerable: !0, get: function() {
      return l.isBytesLike;
    } }), Object.defineProperty(r, "stripZerosLeft", { enumerable: !0, get: function() {
      return l.stripZerosLeft;
    } }), Object.defineProperty(r, "zeroPadBytes", { enumerable: !0, get: function() {
      return l.zeroPadBytes;
    } }), Object.defineProperty(r, "zeroPadValue", { enumerable: !0, get: function() {
      return l.zeroPadValue;
    } }), Object.defineProperty(r, "defineProperties", { enumerable: !0, get: function() {
      return l.defineProperties;
    } }), Object.defineProperty(r, "resolveProperties", { enumerable: !0, get: function() {
      return l.resolveProperties;
    } }), Object.defineProperty(r, "assert", { enumerable: !0, get: function() {
      return l.assert;
    } }), Object.defineProperty(r, "assertArgument", { enumerable: !0, get: function() {
      return l.assertArgument;
    } }), Object.defineProperty(r, "assertArgumentCount", { enumerable: !0, get: function() {
      return l.assertArgumentCount;
    } }), Object.defineProperty(r, "assertNormalize", { enumerable: !0, get: function() {
      return l.assertNormalize;
    } }), Object.defineProperty(r, "assertPrivate", { enumerable: !0, get: function() {
      return l.assertPrivate;
    } }), Object.defineProperty(r, "makeError", { enumerable: !0, get: function() {
      return l.makeError;
    } }), Object.defineProperty(r, "isCallException", { enumerable: !0, get: function() {
      return l.isCallException;
    } }), Object.defineProperty(r, "isError", { enumerable: !0, get: function() {
      return l.isError;
    } }), Object.defineProperty(r, "EventPayload", { enumerable: !0, get: function() {
      return l.EventPayload;
    } }), Object.defineProperty(r, "FetchRequest", { enumerable: !0, get: function() {
      return l.FetchRequest;
    } }), Object.defineProperty(r, "FetchResponse", { enumerable: !0, get: function() {
      return l.FetchResponse;
    } }), Object.defineProperty(r, "FetchCancelSignal", { enumerable: !0, get: function() {
      return l.FetchCancelSignal;
    } }), Object.defineProperty(r, "FixedNumber", { enumerable: !0, get: function() {
      return l.FixedNumber;
    } }), Object.defineProperty(r, "getBigInt", { enumerable: !0, get: function() {
      return l.getBigInt;
    } }), Object.defineProperty(r, "getNumber", { enumerable: !0, get: function() {
      return l.getNumber;
    } }), Object.defineProperty(r, "getUint", { enumerable: !0, get: function() {
      return l.getUint;
    } }), Object.defineProperty(r, "toBeArray", { enumerable: !0, get: function() {
      return l.toBeArray;
    } }), Object.defineProperty(r, "toBigInt", { enumerable: !0, get: function() {
      return l.toBigInt;
    } }), Object.defineProperty(r, "toBeHex", { enumerable: !0, get: function() {
      return l.toBeHex;
    } }), Object.defineProperty(r, "toNumber", { enumerable: !0, get: function() {
      return l.toNumber;
    } }), Object.defineProperty(r, "toQuantity", { enumerable: !0, get: function() {
      return l.toQuantity;
    } }), Object.defineProperty(r, "fromTwos", { enumerable: !0, get: function() {
      return l.fromTwos;
    } }), Object.defineProperty(r, "toTwos", { enumerable: !0, get: function() {
      return l.toTwos;
    } }), Object.defineProperty(r, "mask", { enumerable: !0, get: function() {
      return l.mask;
    } }), Object.defineProperty(r, "formatEther", { enumerable: !0, get: function() {
      return l.formatEther;
    } }), Object.defineProperty(r, "parseEther", { enumerable: !0, get: function() {
      return l.parseEther;
    } }), Object.defineProperty(r, "formatUnits", { enumerable: !0, get: function() {
      return l.formatUnits;
    } }), Object.defineProperty(r, "parseUnits", { enumerable: !0, get: function() {
      return l.parseUnits;
    } }), Object.defineProperty(r, "toUtf8Bytes", { enumerable: !0, get: function() {
      return l.toUtf8Bytes;
    } }), Object.defineProperty(r, "toUtf8CodePoints", { enumerable: !0, get: function() {
      return l.toUtf8CodePoints;
    } }), Object.defineProperty(r, "toUtf8String", { enumerable: !0, get: function() {
      return l.toUtf8String;
    } }), Object.defineProperty(r, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
      return l.Utf8ErrorFuncs;
    } }), Object.defineProperty(r, "decodeRlp", { enumerable: !0, get: function() {
      return l.decodeRlp;
    } }), Object.defineProperty(r, "encodeRlp", { enumerable: !0, get: function() {
      return l.encodeRlp;
    } }), Object.defineProperty(r, "uuidV4", { enumerable: !0, get: function() {
      return l.uuidV4;
    } });
    var f = hk();
    Object.defineProperty(r, "Mnemonic", { enumerable: !0, get: function() {
      return f.Mnemonic;
    } }), Object.defineProperty(r, "BaseWallet", { enumerable: !0, get: function() {
      return f.BaseWallet;
    } }), Object.defineProperty(r, "HDNodeWallet", { enumerable: !0, get: function() {
      return f.HDNodeWallet;
    } }), Object.defineProperty(r, "HDNodeVoidWallet", { enumerable: !0, get: function() {
      return f.HDNodeVoidWallet;
    } }), Object.defineProperty(r, "Wallet", { enumerable: !0, get: function() {
      return f.Wallet;
    } }), Object.defineProperty(r, "defaultPath", { enumerable: !0, get: function() {
      return f.defaultPath;
    } }), Object.defineProperty(r, "getAccountPath", { enumerable: !0, get: function() {
      return f.getAccountPath;
    } }), Object.defineProperty(r, "getIndexedAccountPath", { enumerable: !0, get: function() {
      return f.getIndexedAccountPath;
    } }), Object.defineProperty(r, "isCrowdsaleJson", { enumerable: !0, get: function() {
      return f.isCrowdsaleJson;
    } }), Object.defineProperty(r, "isKeystoreJson", { enumerable: !0, get: function() {
      return f.isKeystoreJson;
    } }), Object.defineProperty(r, "decryptCrowdsaleJson", { enumerable: !0, get: function() {
      return f.decryptCrowdsaleJson;
    } }), Object.defineProperty(r, "decryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return f.decryptKeystoreJsonSync;
    } }), Object.defineProperty(r, "decryptKeystoreJson", { enumerable: !0, get: function() {
      return f.decryptKeystoreJson;
    } }), Object.defineProperty(r, "encryptKeystoreJson", { enumerable: !0, get: function() {
      return f.encryptKeystoreJson;
    } }), Object.defineProperty(r, "encryptKeystoreJsonSync", { enumerable: !0, get: function() {
      return f.encryptKeystoreJsonSync;
    } });
    var d = mk();
    Object.defineProperty(r, "Wordlist", { enumerable: !0, get: function() {
      return d.Wordlist;
    } }), Object.defineProperty(r, "LangEn", { enumerable: !0, get: function() {
      return d.LangEn;
    } }), Object.defineProperty(r, "WordlistOwl", { enumerable: !0, get: function() {
      return d.WordlistOwl;
    } }), Object.defineProperty(r, "WordlistOwlA", { enumerable: !0, get: function() {
      return d.WordlistOwlA;
    } }), Object.defineProperty(r, "wordlists", { enumerable: !0, get: function() {
      return d.wordlists;
    } });
  }(fp)), fp;
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.ethers = void 0;
  const e = iv, t = e.__importStar(R2());
  r.ethers = t, e.__exportStar(R2(), r);
})(ix);
Object.defineProperty(Ms, "__esModule", { value: !0 });
Ms.getAddress = Ms.hashMessage = Ms.verifyMessage = void 0;
const Xo = ix;
let Hb = null, Gb = null, Vb = null;
try {
  Hb = Xo.ethers.utils.verifyMessage, Gb = Xo.ethers.utils.hashMessage, Vb = Xo.ethers.utils.getAddress;
} catch {
  Hb = Xo.ethers.verifyMessage, Gb = Xo.ethers.hashMessage, Vb = Xo.ethers.getAddress;
}
Ms.verifyMessage = Hb;
Ms.hashMessage = Gb;
Ms.getAddress = Vb;
var wx = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.SiweErrorType = r.SiweError = r.VerifyOptsKeys = r.VerifyParamsKeys = void 0, r.VerifyParamsKeys = [
    "signature",
    "scheme",
    "domain",
    "nonce",
    "time"
  ], r.VerifyOptsKeys = [
    "provider",
    "suppressExceptions",
    "verificationFallback"
  ];
  class e {
    constructor(n, s, i) {
      this.type = n, this.expected = s, this.received = i;
    }
  }
  r.SiweError = e, function(t) {
    t.EXPIRED_MESSAGE = "Expired message.", t.INVALID_DOMAIN = "Invalid domain.", t.SCHEME_MISMATCH = "Scheme does not match provided scheme for verification.", t.DOMAIN_MISMATCH = "Domain does not match provided domain for verification.", t.NONCE_MISMATCH = "Nonce does not match provided nonce for verification.", t.INVALID_ADDRESS = "Invalid address.", t.INVALID_URI = "URI does not conform to RFC 3986.", t.INVALID_NONCE = "Nonce size smaller then 8 characters or is not alphanumeric.", t.NOT_YET_VALID_MESSAGE = "Message is not valid yet.", t.INVALID_SIGNATURE = "Signature does not match address of the message.", t.INVALID_TIME_FORMAT = "Invalid time format.", t.INVALID_MESSAGE_VERSION = "Invalid message version.", t.UNABLE_TO_PARSE = "Unable to parse the message.";
  }(r.SiweErrorType || (r.SiweErrorType = {}));
})(wx);
var Pn = {}, C6 = {}, kh = {}, Th = {};
Object.defineProperty(Th, "__esModule", { value: !0 });
Th.BrowserRandomSource = void 0;
const I2 = 65536;
class yk {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const e = typeof self < "u" ? self.crypto || self.msCrypto : null;
    e && e.getRandomValues !== void 0 && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const t = new Uint8Array(e);
    for (let n = 0; n < t.length; n += I2)
      this._crypto.getRandomValues(t.subarray(n, n + Math.min(t.length - n, I2)));
    return t;
  }
}
Th.BrowserRandomSource = yk;
function wk(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Bh = {}, Oh = {};
Object.defineProperty(Oh, "__esModule", { value: !0 });
function Ak(r) {
  for (var e = 0; e < r.length; e++)
    r[e] = 0;
  return r;
}
Oh.wipe = Ak;
const Ek = {}, Pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ek
}, Symbol.toStringTag, { value: "Module" })), vk = /* @__PURE__ */ zw(Pk);
Object.defineProperty(Bh, "__esModule", { value: !0 });
Bh.NodeRandomSource = void 0;
const kk = Oh;
class Tk {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof wk < "u") {
      const e = vk;
      e && e.randomBytes && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let t = this._crypto.randomBytes(e);
    if (t.length !== e)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const n = new Uint8Array(e);
    for (let s = 0; s < n.length; s++)
      n[s] = t[s];
    return (0, kk.wipe)(t), n;
  }
}
Bh.NodeRandomSource = Tk;
Object.defineProperty(kh, "__esModule", { value: !0 });
kh.SystemRandomSource = void 0;
const Bk = Th, Ok = Bh;
class Nk {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new Bk.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new Ok.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(e);
  }
}
kh.SystemRandomSource = Nk;
var tt = {}, R6 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  function e(o, u) {
    var c = o >>> 16 & 65535, l = o & 65535, f = u >>> 16 & 65535, d = u & 65535;
    return l * d + (c * d + l * f << 16 >>> 0) | 0;
  }
  r.mul = Math.imul || e;
  function t(o, u) {
    return o + u | 0;
  }
  r.add = t;
  function n(o, u) {
    return o - u | 0;
  }
  r.sub = n;
  function s(o, u) {
    return o << u | o >>> 32 - u;
  }
  r.rotl = s;
  function i(o, u) {
    return o << 32 - u | o >>> u;
  }
  r.rotr = i;
  function a(o) {
    return typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  }
  r.isInteger = Number.isInteger || a, r.MAX_SAFE_INTEGER = 9007199254740991, r.isSafeInteger = function(o) {
    return r.isInteger(o) && o >= -r.MAX_SAFE_INTEGER && o <= r.MAX_SAFE_INTEGER;
  };
})(R6);
Object.defineProperty(tt, "__esModule", { value: !0 });
var I6 = R6;
function Sk(r, e) {
  return e === void 0 && (e = 0), (r[e + 0] << 8 | r[e + 1]) << 16 >> 16;
}
tt.readInt16BE = Sk;
function Ck(r, e) {
  return e === void 0 && (e = 0), (r[e + 0] << 8 | r[e + 1]) >>> 0;
}
tt.readUint16BE = Ck;
function Rk(r, e) {
  return e === void 0 && (e = 0), (r[e + 1] << 8 | r[e]) << 16 >> 16;
}
tt.readInt16LE = Rk;
function Ik(r, e) {
  return e === void 0 && (e = 0), (r[e + 1] << 8 | r[e]) >>> 0;
}
tt.readUint16LE = Ik;
function _6(r, e, t) {
  return e === void 0 && (e = new Uint8Array(2)), t === void 0 && (t = 0), e[t + 0] = r >>> 8, e[t + 1] = r >>> 0, e;
}
tt.writeUint16BE = _6;
tt.writeInt16BE = _6;
function U6(r, e, t) {
  return e === void 0 && (e = new Uint8Array(2)), t === void 0 && (t = 0), e[t + 0] = r >>> 0, e[t + 1] = r >>> 8, e;
}
tt.writeUint16LE = U6;
tt.writeInt16LE = U6;
function $b(r, e) {
  return e === void 0 && (e = 0), r[e] << 24 | r[e + 1] << 16 | r[e + 2] << 8 | r[e + 3];
}
tt.readInt32BE = $b;
function Kb(r, e) {
  return e === void 0 && (e = 0), (r[e] << 24 | r[e + 1] << 16 | r[e + 2] << 8 | r[e + 3]) >>> 0;
}
tt.readUint32BE = Kb;
function zb(r, e) {
  return e === void 0 && (e = 0), r[e + 3] << 24 | r[e + 2] << 16 | r[e + 1] << 8 | r[e];
}
tt.readInt32LE = zb;
function Jb(r, e) {
  return e === void 0 && (e = 0), (r[e + 3] << 24 | r[e + 2] << 16 | r[e + 1] << 8 | r[e]) >>> 0;
}
tt.readUint32LE = Jb;
function Nd(r, e, t) {
  return e === void 0 && (e = new Uint8Array(4)), t === void 0 && (t = 0), e[t + 0] = r >>> 24, e[t + 1] = r >>> 16, e[t + 2] = r >>> 8, e[t + 3] = r >>> 0, e;
}
tt.writeUint32BE = Nd;
tt.writeInt32BE = Nd;
function Sd(r, e, t) {
  return e === void 0 && (e = new Uint8Array(4)), t === void 0 && (t = 0), e[t + 0] = r >>> 0, e[t + 1] = r >>> 8, e[t + 2] = r >>> 16, e[t + 3] = r >>> 24, e;
}
tt.writeUint32LE = Sd;
tt.writeInt32LE = Sd;
function _k(r, e) {
  e === void 0 && (e = 0);
  var t = $b(r, e), n = $b(r, e + 4);
  return t * 4294967296 + n - (n >> 31) * 4294967296;
}
tt.readInt64BE = _k;
function Uk(r, e) {
  e === void 0 && (e = 0);
  var t = Kb(r, e), n = Kb(r, e + 4);
  return t * 4294967296 + n;
}
tt.readUint64BE = Uk;
function Lk(r, e) {
  e === void 0 && (e = 0);
  var t = zb(r, e), n = zb(r, e + 4);
  return n * 4294967296 + t - (t >> 31) * 4294967296;
}
tt.readInt64LE = Lk;
function Mk(r, e) {
  e === void 0 && (e = 0);
  var t = Jb(r, e), n = Jb(r, e + 4);
  return n * 4294967296 + t;
}
tt.readUint64LE = Mk;
function L6(r, e, t) {
  return e === void 0 && (e = new Uint8Array(8)), t === void 0 && (t = 0), Nd(r / 4294967296 >>> 0, e, t), Nd(r >>> 0, e, t + 4), e;
}
tt.writeUint64BE = L6;
tt.writeInt64BE = L6;
function M6(r, e, t) {
  return e === void 0 && (e = new Uint8Array(8)), t === void 0 && (t = 0), Sd(r >>> 0, e, t), Sd(r / 4294967296 >>> 0, e, t + 4), e;
}
tt.writeUint64LE = M6;
tt.writeInt64LE = M6;
function Fk(r, e, t) {
  if (t === void 0 && (t = 0), r % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (r / 8 > e.length - t)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var n = 0, s = 1, i = r / 8 + t - 1; i >= t; i--)
    n += e[i] * s, s *= 256;
  return n;
}
tt.readUintBE = Fk;
function Dk(r, e, t) {
  if (t === void 0 && (t = 0), r % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (r / 8 > e.length - t)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var n = 0, s = 1, i = t; i < t + r / 8; i++)
    n += e[i] * s, s *= 256;
  return n;
}
tt.readUintLE = Dk;
function jk(r, e, t, n) {
  if (t === void 0 && (t = new Uint8Array(r / 8)), n === void 0 && (n = 0), r % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!I6.isSafeInteger(e))
    throw new Error("writeUintBE value must be an integer");
  for (var s = 1, i = r / 8 + n - 1; i >= n; i--)
    t[i] = e / s & 255, s *= 256;
  return t;
}
tt.writeUintBE = jk;
function Hk(r, e, t, n) {
  if (t === void 0 && (t = new Uint8Array(r / 8)), n === void 0 && (n = 0), r % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!I6.isSafeInteger(e))
    throw new Error("writeUintLE value must be an integer");
  for (var s = 1, i = n; i < n + r / 8; i++)
    t[i] = e / s & 255, s *= 256;
  return t;
}
tt.writeUintLE = Hk;
function Gk(r, e) {
  e === void 0 && (e = 0);
  var t = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return t.getFloat32(e);
}
tt.readFloat32BE = Gk;
function Vk(r, e) {
  e === void 0 && (e = 0);
  var t = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return t.getFloat32(e, !0);
}
tt.readFloat32LE = Vk;
function $k(r, e) {
  e === void 0 && (e = 0);
  var t = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return t.getFloat64(e);
}
tt.readFloat64BE = $k;
function Kk(r, e) {
  e === void 0 && (e = 0);
  var t = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return t.getFloat64(e, !0);
}
tt.readFloat64LE = Kk;
function zk(r, e, t) {
  e === void 0 && (e = new Uint8Array(4)), t === void 0 && (t = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat32(t, r), e;
}
tt.writeFloat32BE = zk;
function Jk(r, e, t) {
  e === void 0 && (e = new Uint8Array(4)), t === void 0 && (t = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat32(t, r, !0), e;
}
tt.writeFloat32LE = Jk;
function Qk(r, e, t) {
  e === void 0 && (e = new Uint8Array(8)), t === void 0 && (t = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat64(t, r), e;
}
tt.writeFloat64BE = Qk;
function qk(r, e, t) {
  e === void 0 && (e = new Uint8Array(8)), t === void 0 && (t = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat64(t, r, !0), e;
}
tt.writeFloat64LE = qk;
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.randomStringForEntropy = r.randomString = r.randomUint32 = r.randomBytes = r.defaultRandomSource = void 0;
  const e = kh, t = tt, n = Oh;
  r.defaultRandomSource = new e.SystemRandomSource();
  function s(c, l = r.defaultRandomSource) {
    return l.randomBytes(c);
  }
  r.randomBytes = s;
  function i(c = r.defaultRandomSource) {
    const l = s(4, c), f = (0, t.readUint32LE)(l);
    return (0, n.wipe)(l), f;
  }
  r.randomUint32 = i;
  const a = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function o(c, l = a, f = r.defaultRandomSource) {
    if (l.length < 2)
      throw new Error("randomString charset is too short");
    if (l.length > 256)
      throw new Error("randomString charset is too long");
    let d = "";
    const h = l.length, p = 256 - 256 % h;
    for (; c > 0; ) {
      const g = s(Math.ceil(c * 256 / p), f);
      for (let k = 0; k < g.length && c > 0; k++) {
        const A = g[k];
        A < p && (d += l.charAt(A % h), c--);
      }
      (0, n.wipe)(g);
    }
    return d;
  }
  r.randomString = o;
  function u(c, l = a, f = r.defaultRandomSource) {
    const d = Math.ceil(c / (Math.log(l.length) / Math.LN2));
    return o(d, l, f);
  }
  r.randomStringForEntropy = u;
})(C6);
Object.defineProperty(Pn, "__esModule", { value: !0 });
Pn.checkInvalidKeys = Pn.isValidISO8601Date = Pn.generateNonce = Pn.checkContractWalletSignature = void 0;
const Wk = C6, Yk = ix, Zk = Ms, Xk = [
  "function isValidSignature(bytes32 _message, bytes _signature) public view returns (bytes4)"
], eT = "0x1626ba7e", _2 = /^(?<date>[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(.[0-9]+)?(([Zz])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/, tT = async (r, e, t) => {
  if (!t)
    return !1;
  const n = new Yk.Contract(r.address, Xk, t), s = (0, Zk.hashMessage)(r.prepareMessage());
  return await n.isValidSignature(s, e) === eT;
};
Pn.checkContractWalletSignature = tT;
const rT = () => {
  const r = (0, Wk.randomStringForEntropy)(96);
  if (!r || r.length < 8)
    throw new Error("Error during nonce creation.");
  return r;
};
Pn.generateNonce = rT;
const nT = (r) => {
  const e = _2.exec(r);
  if (!e)
    return !1;
  const t = new Date(e.groups.date).toISOString(), n = _2.exec(t);
  return e.groups.date === n.groups.date;
};
Pn.isValidISO8601Date = nT;
const sT = (r, e) => {
  const t = [];
  return Object.keys(r).forEach((n) => {
    e.includes(n) || t.push(n);
  }), t;
};
Pn.checkInvalidKeys = sT;
Object.defineProperty(ph, "__esModule", { value: !0 });
ph.SiweMessage = void 0;
const Sp = F4, iT = Ms, lr = wx, r0 = Pn;
class aT {
  /**
   * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
   * string or an object. If a string is used an ABNF parser is called to
   * validate the parameter, otherwise the fields are attributed.
   * @param param {string | SiweMessage} Sign message as a string or an object.
   */
  constructor(e) {
    if (typeof e == "string") {
      const t = new Sp.ParsedMessage(e);
      this.scheme = t.scheme, this.domain = t.domain, this.address = t.address, this.statement = t.statement, this.uri = t.uri, this.version = t.version, this.nonce = t.nonce, this.issuedAt = t.issuedAt, this.expirationTime = t.expirationTime, this.notBefore = t.notBefore, this.requestId = t.requestId, this.chainId = t.chainId, this.resources = t.resources;
    } else
      this.scheme = e == null ? void 0 : e.scheme, this.domain = e.domain, this.address = e.address, this.statement = e == null ? void 0 : e.statement, this.uri = e.uri, this.version = e.version, this.chainId = e.chainId, this.nonce = e.nonce, this.issuedAt = e == null ? void 0 : e.issuedAt, this.expirationTime = e == null ? void 0 : e.expirationTime, this.notBefore = e == null ? void 0 : e.notBefore, this.requestId = e == null ? void 0 : e.requestId, this.resources = e == null ? void 0 : e.resources, typeof this.chainId == "string" && (this.chainId = (0, Sp.parseIntegerNumber)(this.chainId)), this.nonce = this.nonce || (0, r0.generateNonce)(), new Sp.ParsedMessage(this.prepareMessage());
  }
  /**
   * This function can be used to retrieve an EIP-4361 formatted message for
   * signature, although you can call it directly it's advised to use
   * [prepareMessage()] instead which will resolve to the correct method based
   * on the [type] attribute of this object, in case of other formats being
   * implemented.
   * @returns {string} EIP-4361 formatted message, ready for EIP-191 signing.
   */
  toMessage() {
    const t = `${this.scheme ? `${this.scheme}://${this.domain}` : this.domain} wants you to sign in with your Ethereum account:`, n = `URI: ${this.uri}`;
    let s = [t, this.address].join(`
`);
    const i = `Version: ${this.version}`;
    this.nonce || (this.nonce = (0, r0.generateNonce)());
    const a = "Chain ID: " + this.chainId || "1", o = `Nonce: ${this.nonce}`, u = [n, i, a, o];
    if (this.issuedAt = this.issuedAt || (/* @__PURE__ */ new Date()).toISOString(), u.push(`Issued At: ${this.issuedAt}`), this.expirationTime) {
      const l = `Expiration Time: ${this.expirationTime}`;
      u.push(l);
    }
    this.notBefore && u.push(`Not Before: ${this.notBefore}`), this.requestId && u.push(`Request ID: ${this.requestId}`), this.resources && u.push(["Resources:", ...this.resources.map((l) => `- ${l}`)].join(`
`));
    const c = u.join(`
`);
    return s = [s, this.statement].join(`

`), this.statement !== void 0 && (s += `
`), [s, c].join(`
`);
  }
  /**
   * This method parses all the fields in the object and creates a messaging for signing
   * message according with the type defined.
   * @returns {string} Returns a message ready to be signed according with the
   * type defined in the object.
   */
  prepareMessage() {
    let e;
    switch (this.version) {
      case "1": {
        e = this.toMessage();
        break;
      }
      default: {
        e = this.toMessage();
        break;
      }
    }
    return e;
  }
  /**
   * Verifies the integrity of the object by matching its signature.
   * @param params Parameters to verify the integrity of the message, signature is required.
   * @returns {Promise<SiweMessage>} This object if valid.
   */
  async verify(e, t = { suppressExceptions: !1 }) {
    return new Promise((n, s) => {
      var i, a, o;
      const u = (E) => t.suppressExceptions ? n(E) : s(E), c = (0, r0.checkInvalidKeys)(e, lr.VerifyParamsKeys);
      c.length > 0 && u({
        success: !1,
        data: this,
        error: new Error(`${c.join(", ")} is/are not valid key(s) for VerifyParams.`)
      });
      const l = (0, r0.checkInvalidKeys)(t, lr.VerifyOptsKeys);
      l.length > 0 && u({
        success: !1,
        data: this,
        error: new Error(`${l.join(", ")} is/are not valid key(s) for VerifyOpts.`)
      });
      const { signature: f, scheme: d, domain: h, nonce: p, time: g } = e;
      d && d !== this.scheme && u({
        success: !1,
        data: this,
        error: new lr.SiweError(lr.SiweErrorType.SCHEME_MISMATCH, d, this.scheme)
      }), h && h !== this.domain && u({
        success: !1,
        data: this,
        error: new lr.SiweError(lr.SiweErrorType.DOMAIN_MISMATCH, h, this.domain)
      }), p && p !== this.nonce && u({
        success: !1,
        data: this,
        error: new lr.SiweError(lr.SiweErrorType.NONCE_MISMATCH, p, this.nonce)
      });
      const k = new Date(g || /* @__PURE__ */ new Date());
      if (this.expirationTime) {
        const E = new Date(this.expirationTime);
        k.getTime() >= E.getTime() && u({
          success: !1,
          data: this,
          error: new lr.SiweError(lr.SiweErrorType.EXPIRED_MESSAGE, `${k.toISOString()} < ${E.toISOString()}`, `${k.toISOString()} >= ${E.toISOString()}`)
        });
      }
      if (this.notBefore) {
        const E = new Date(this.notBefore);
        k.getTime() < E.getTime() && u({
          success: !1,
          data: this,
          error: new lr.SiweError(lr.SiweErrorType.NOT_YET_VALID_MESSAGE, `${k.toISOString()} >= ${E.toISOString()}`, `${k.toISOString()} < ${E.toISOString()}`)
        });
      }
      let A;
      try {
        A = this.prepareMessage();
      } catch (E) {
        u({
          success: !1,
          data: this,
          error: E
        });
      }
      let y;
      try {
        y = (0, iT.verifyMessage)(A, f);
      } catch (E) {
        console.error(E);
      }
      if (y === this.address)
        return n({
          success: !0,
          data: this
        });
      {
        const E = (0, r0.checkContractWalletSignature)(this, f, t.provider).then((m) => m ? {
          success: !0,
          data: this
        } : {
          success: !1,
          data: this,
          error: new lr.SiweError(lr.SiweErrorType.INVALID_SIGNATURE, y, `Resolved address to be ${this.address}`)
        }).catch((m) => ({
          success: !1,
          data: this,
          error: m
        }));
        Promise.all([
          E,
          (o = (a = (i = t == null ? void 0 : t.verificationFallback) === null || i === void 0 ? void 0 : i.call(t, e, t, this, E)) === null || a === void 0 ? void 0 : a.then((m) => m)) === null || o === void 0 ? void 0 : o.catch((m) => m)
        ]).then(([m, N]) => {
          if (N) {
            if (N.success)
              return n(N);
            u(N);
          } else {
            if (m.success)
              return n(m);
            u(m);
          }
        });
      }
    });
  }
}
ph.SiweMessage = aT;
(function(r) {
  var e = nt && nt.__createBinding || (Object.create ? function(n, s, i, a) {
    a === void 0 && (a = i);
    var o = Object.getOwnPropertyDescriptor(s, i);
    (!o || ("get" in o ? !s.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(n, a, o);
  } : function(n, s, i, a) {
    a === void 0 && (a = i), n[a] = s[i];
  }), t = nt && nt.__exportStar || function(n, s) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && e(s, n, i);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), t(ph, r), t(wx, r), t(Pn, r);
})(M4);
var F6 = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.9.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2023
 * @license MIT
 */
(function(r) {
  (function() {
    var e = "input is invalid type", t = "finalize already called", n = typeof window == "object", s = n ? window : {};
    s.JS_SHA3_NO_WINDOW && (n = !1);
    var i = !n && typeof self == "object", a = !s.JS_SHA3_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    a ? s = nt : i && (s = self);
    for (var o = !s.JS_SHA3_NO_COMMON_JS && !0 && r.exports, u = !s.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), l = [31, 7936, 2031616, 520093696], f = [4, 1024, 262144, 67108864], d = [1, 256, 65536, 16777216], h = [6, 1536, 393216, 100663296], p = [0, 8, 16, 24], g = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], k = [224, 256, 384, 512], A = [128, 256], y = ["hex", "buffer", "arrayBuffer", "array", "digest"], E = {
      128: 168,
      256: 136
    }, m = s.JS_SHA3_NO_NODE_JS || !Array.isArray ? function(L) {
      return Object.prototype.toString.call(L) === "[object Array]";
    } : Array.isArray, N = u && (s.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) ? function(L) {
      return typeof L == "object" && L.buffer && L.buffer.constructor === ArrayBuffer;
    } : ArrayBuffer.isView, T = function(L) {
      var ne = typeof L;
      if (ne === "string")
        return [L, !0];
      if (ne !== "object" || L === null)
        throw new Error(e);
      if (u && L.constructor === ArrayBuffer)
        return [new Uint8Array(L), !1];
      if (!m(L) && !N(L))
        throw new Error(e);
      return [L, !1];
    }, U = function(L) {
      return T(L)[0].length === 0;
    }, R = function(L) {
      for (var ne = [], oe = 0; oe < L.length; ++oe)
        ne[oe] = L[oe];
      return ne;
    }, j = function(L, ne, oe) {
      return function(ee) {
        return new ye(L, ne, L).update(ee)[oe]();
      };
    }, D = function(L, ne, oe) {
      return function(ee, W) {
        return new ye(L, ne, W).update(ee)[oe]();
      };
    }, O = function(L, ne, oe) {
      return function(ee, W, v, z) {
        return J["cshake" + L].update(ee, W, v, z)[oe]();
      };
    }, I = function(L, ne, oe) {
      return function(ee, W, v, z) {
        return J["kmac" + L].update(ee, W, v, z)[oe]();
      };
    }, P = function(L, ne, oe, ee) {
      for (var W = 0; W < y.length; ++W) {
        var v = y[W];
        L[v] = ne(oe, ee, v);
      }
      return L;
    }, S = function(L, ne) {
      var oe = j(L, ne, "hex");
      return oe.create = function() {
        return new ye(L, ne, L);
      }, oe.update = function(ee) {
        return oe.create().update(ee);
      }, P(oe, j, L, ne);
    }, B = function(L, ne) {
      var oe = D(L, ne, "hex");
      return oe.create = function(ee) {
        return new ye(L, ne, ee);
      }, oe.update = function(ee, W) {
        return oe.create(W).update(ee);
      }, P(oe, D, L, ne);
    }, C = function(L, ne) {
      var oe = E[L], ee = O(L, ne, "hex");
      return ee.create = function(W, v, z) {
        return U(v) && U(z) ? J["shake" + L].create(W) : new ye(L, ne, W).bytepad([v, z], oe);
      }, ee.update = function(W, v, z, q) {
        return ee.create(v, z, q).update(W);
      }, P(ee, O, L, ne);
    }, H = function(L, ne) {
      var oe = E[L], ee = I(L, ne, "hex");
      return ee.create = function(W, v, z) {
        return new re(L, ne, v).bytepad(["KMAC", z], oe).bytepad([W], oe);
      }, ee.update = function(W, v, z, q) {
        return ee.create(W, z, q).update(v);
      }, P(ee, I, L, ne);
    }, V = [
      { name: "keccak", padding: d, bits: k, createMethod: S },
      { name: "sha3", padding: h, bits: k, createMethod: S },
      { name: "shake", padding: l, bits: A, createMethod: B },
      { name: "cshake", padding: f, bits: A, createMethod: C },
      { name: "kmac", padding: f, bits: A, createMethod: H }
    ], J = {}, M = [], G = 0; G < V.length; ++G)
      for (var K = V[G], X = K.bits, te = 0; te < X.length; ++te) {
        var pe = K.name + "_" + X[te];
        if (M.push(pe), J[pe] = K.createMethod(X[te], K.padding), K.name !== "sha3") {
          var he = K.name + X[te];
          M.push(he), J[he] = J[pe];
        }
      }
    function ye(L, ne, oe) {
      this.blocks = [], this.s = [], this.padding = ne, this.outputBits = oe, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (L << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = oe >> 5, this.extraBytes = (oe & 31) >> 3;
      for (var ee = 0; ee < 50; ++ee)
        this.s[ee] = 0;
    }
    ye.prototype.update = function(L) {
      if (this.finalized)
        throw new Error(t);
      var ne = T(L);
      L = ne[0];
      for (var oe = ne[1], ee = this.blocks, W = this.byteCount, v = L.length, z = this.blockCount, q = 0, le = this.s, be, ve; q < v; ) {
        if (this.reset)
          for (this.reset = !1, ee[0] = this.block, be = 1; be < z + 1; ++be)
            ee[be] = 0;
        if (oe)
          for (be = this.start; q < v && be < W; ++q)
            ve = L.charCodeAt(q), ve < 128 ? ee[be >> 2] |= ve << p[be++ & 3] : ve < 2048 ? (ee[be >> 2] |= (192 | ve >> 6) << p[be++ & 3], ee[be >> 2] |= (128 | ve & 63) << p[be++ & 3]) : ve < 55296 || ve >= 57344 ? (ee[be >> 2] |= (224 | ve >> 12) << p[be++ & 3], ee[be >> 2] |= (128 | ve >> 6 & 63) << p[be++ & 3], ee[be >> 2] |= (128 | ve & 63) << p[be++ & 3]) : (ve = 65536 + ((ve & 1023) << 10 | L.charCodeAt(++q) & 1023), ee[be >> 2] |= (240 | ve >> 18) << p[be++ & 3], ee[be >> 2] |= (128 | ve >> 12 & 63) << p[be++ & 3], ee[be >> 2] |= (128 | ve >> 6 & 63) << p[be++ & 3], ee[be >> 2] |= (128 | ve & 63) << p[be++ & 3]);
        else
          for (be = this.start; q < v && be < W; ++q)
            ee[be >> 2] |= L[q] << p[be++ & 3];
        if (this.lastByteIndex = be, be >= W) {
          for (this.start = be - W, this.block = ee[z], be = 0; be < z; ++be)
            le[be] ^= ee[be];
          ae(le), this.reset = !0;
        } else
          this.start = be;
      }
      return this;
    }, ye.prototype.encode = function(L, ne) {
      var oe = L & 255, ee = 1, W = [oe];
      for (L = L >> 8, oe = L & 255; oe > 0; )
        W.unshift(oe), L = L >> 8, oe = L & 255, ++ee;
      return ne ? W.push(ee) : W.unshift(ee), this.update(W), W.length;
    }, ye.prototype.encodeString = function(L) {
      var ne = T(L);
      L = ne[0];
      var oe = ne[1], ee = 0, W = L.length;
      if (oe)
        for (var v = 0; v < L.length; ++v) {
          var z = L.charCodeAt(v);
          z < 128 ? ee += 1 : z < 2048 ? ee += 2 : z < 55296 || z >= 57344 ? ee += 3 : (z = 65536 + ((z & 1023) << 10 | L.charCodeAt(++v) & 1023), ee += 4);
        }
      else
        ee = W;
      return ee += this.encode(ee * 8), this.update(L), ee;
    }, ye.prototype.bytepad = function(L, ne) {
      for (var oe = this.encode(ne), ee = 0; ee < L.length; ++ee)
        oe += this.encodeString(L[ee]);
      var W = (ne - oe % ne) % ne, v = [];
      return v.length = W, this.update(v), this;
    }, ye.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var L = this.blocks, ne = this.lastByteIndex, oe = this.blockCount, ee = this.s;
        if (L[ne >> 2] |= this.padding[ne & 3], this.lastByteIndex === this.byteCount)
          for (L[0] = L[oe], ne = 1; ne < oe + 1; ++ne)
            L[ne] = 0;
        for (L[oe - 1] |= 2147483648, ne = 0; ne < oe; ++ne)
          ee[ne] ^= L[ne];
        ae(ee);
      }
    }, ye.prototype.toString = ye.prototype.hex = function() {
      this.finalize();
      for (var L = this.blockCount, ne = this.s, oe = this.outputBlocks, ee = this.extraBytes, W = 0, v = 0, z = "", q; v < oe; ) {
        for (W = 0; W < L && v < oe; ++W, ++v)
          q = ne[W], z += c[q >> 4 & 15] + c[q & 15] + c[q >> 12 & 15] + c[q >> 8 & 15] + c[q >> 20 & 15] + c[q >> 16 & 15] + c[q >> 28 & 15] + c[q >> 24 & 15];
        v % L === 0 && (ne = R(ne), ae(ne), W = 0);
      }
      return ee && (q = ne[W], z += c[q >> 4 & 15] + c[q & 15], ee > 1 && (z += c[q >> 12 & 15] + c[q >> 8 & 15]), ee > 2 && (z += c[q >> 20 & 15] + c[q >> 16 & 15])), z;
    }, ye.prototype.arrayBuffer = function() {
      this.finalize();
      var L = this.blockCount, ne = this.s, oe = this.outputBlocks, ee = this.extraBytes, W = 0, v = 0, z = this.outputBits >> 3, q;
      ee ? q = new ArrayBuffer(oe + 1 << 2) : q = new ArrayBuffer(z);
      for (var le = new Uint32Array(q); v < oe; ) {
        for (W = 0; W < L && v < oe; ++W, ++v)
          le[v] = ne[W];
        v % L === 0 && (ne = R(ne), ae(ne));
      }
      return ee && (le[v] = ne[W], q = q.slice(0, z)), q;
    }, ye.prototype.buffer = ye.prototype.arrayBuffer, ye.prototype.digest = ye.prototype.array = function() {
      this.finalize();
      for (var L = this.blockCount, ne = this.s, oe = this.outputBlocks, ee = this.extraBytes, W = 0, v = 0, z = [], q, le; v < oe; ) {
        for (W = 0; W < L && v < oe; ++W, ++v)
          q = v << 2, le = ne[W], z[q] = le & 255, z[q + 1] = le >> 8 & 255, z[q + 2] = le >> 16 & 255, z[q + 3] = le >> 24 & 255;
        v % L === 0 && (ne = R(ne), ae(ne));
      }
      return ee && (q = v << 2, le = ne[W], z[q] = le & 255, ee > 1 && (z[q + 1] = le >> 8 & 255), ee > 2 && (z[q + 2] = le >> 16 & 255)), z;
    };
    function re(L, ne, oe) {
      ye.call(this, L, ne, oe);
    }
    re.prototype = new ye(), re.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), ye.prototype.finalize.call(this);
    };
    var ae = function(L) {
      var ne, oe, ee, W, v, z, q, le, be, ve, Be, Ae, ie, se, me, fe, _, b, w, $, Y, ce, xe, Ie, He, Ue, je, Je, xr, ji, Zs, Co, Ro, Io, _o, Uo, Lo, Xs, Mo, Fo, Hi, Gi, Vi, In, Do, $i, ns, Ki, _n, zi, ei, jo, Ho, Go, Vo, Ji, ti, Qi, qi, ge, we, Pe, Te;
      for (ee = 0; ee < 48; ee += 2)
        W = L[0] ^ L[10] ^ L[20] ^ L[30] ^ L[40], v = L[1] ^ L[11] ^ L[21] ^ L[31] ^ L[41], z = L[2] ^ L[12] ^ L[22] ^ L[32] ^ L[42], q = L[3] ^ L[13] ^ L[23] ^ L[33] ^ L[43], le = L[4] ^ L[14] ^ L[24] ^ L[34] ^ L[44], be = L[5] ^ L[15] ^ L[25] ^ L[35] ^ L[45], ve = L[6] ^ L[16] ^ L[26] ^ L[36] ^ L[46], Be = L[7] ^ L[17] ^ L[27] ^ L[37] ^ L[47], Ae = L[8] ^ L[18] ^ L[28] ^ L[38] ^ L[48], ie = L[9] ^ L[19] ^ L[29] ^ L[39] ^ L[49], ne = Ae ^ (z << 1 | q >>> 31), oe = ie ^ (q << 1 | z >>> 31), L[0] ^= ne, L[1] ^= oe, L[10] ^= ne, L[11] ^= oe, L[20] ^= ne, L[21] ^= oe, L[30] ^= ne, L[31] ^= oe, L[40] ^= ne, L[41] ^= oe, ne = W ^ (le << 1 | be >>> 31), oe = v ^ (be << 1 | le >>> 31), L[2] ^= ne, L[3] ^= oe, L[12] ^= ne, L[13] ^= oe, L[22] ^= ne, L[23] ^= oe, L[32] ^= ne, L[33] ^= oe, L[42] ^= ne, L[43] ^= oe, ne = z ^ (ve << 1 | Be >>> 31), oe = q ^ (Be << 1 | ve >>> 31), L[4] ^= ne, L[5] ^= oe, L[14] ^= ne, L[15] ^= oe, L[24] ^= ne, L[25] ^= oe, L[34] ^= ne, L[35] ^= oe, L[44] ^= ne, L[45] ^= oe, ne = le ^ (Ae << 1 | ie >>> 31), oe = be ^ (ie << 1 | Ae >>> 31), L[6] ^= ne, L[7] ^= oe, L[16] ^= ne, L[17] ^= oe, L[26] ^= ne, L[27] ^= oe, L[36] ^= ne, L[37] ^= oe, L[46] ^= ne, L[47] ^= oe, ne = ve ^ (W << 1 | v >>> 31), oe = Be ^ (v << 1 | W >>> 31), L[8] ^= ne, L[9] ^= oe, L[18] ^= ne, L[19] ^= oe, L[28] ^= ne, L[29] ^= oe, L[38] ^= ne, L[39] ^= oe, L[48] ^= ne, L[49] ^= oe, se = L[0], me = L[1], $i = L[11] << 4 | L[10] >>> 28, ns = L[10] << 4 | L[11] >>> 28, Je = L[20] << 3 | L[21] >>> 29, xr = L[21] << 3 | L[20] >>> 29, ge = L[31] << 9 | L[30] >>> 23, we = L[30] << 9 | L[31] >>> 23, Gi = L[40] << 18 | L[41] >>> 14, Vi = L[41] << 18 | L[40] >>> 14, Io = L[2] << 1 | L[3] >>> 31, _o = L[3] << 1 | L[2] >>> 31, fe = L[13] << 12 | L[12] >>> 20, _ = L[12] << 12 | L[13] >>> 20, Ki = L[22] << 10 | L[23] >>> 22, _n = L[23] << 10 | L[22] >>> 22, ji = L[33] << 13 | L[32] >>> 19, Zs = L[32] << 13 | L[33] >>> 19, Pe = L[42] << 2 | L[43] >>> 30, Te = L[43] << 2 | L[42] >>> 30, Go = L[5] << 30 | L[4] >>> 2, Vo = L[4] << 30 | L[5] >>> 2, Uo = L[14] << 6 | L[15] >>> 26, Lo = L[15] << 6 | L[14] >>> 26, b = L[25] << 11 | L[24] >>> 21, w = L[24] << 11 | L[25] >>> 21, zi = L[34] << 15 | L[35] >>> 17, ei = L[35] << 15 | L[34] >>> 17, Co = L[45] << 29 | L[44] >>> 3, Ro = L[44] << 29 | L[45] >>> 3, Ie = L[6] << 28 | L[7] >>> 4, He = L[7] << 28 | L[6] >>> 4, Ji = L[17] << 23 | L[16] >>> 9, ti = L[16] << 23 | L[17] >>> 9, Xs = L[26] << 25 | L[27] >>> 7, Mo = L[27] << 25 | L[26] >>> 7, $ = L[36] << 21 | L[37] >>> 11, Y = L[37] << 21 | L[36] >>> 11, jo = L[47] << 24 | L[46] >>> 8, Ho = L[46] << 24 | L[47] >>> 8, In = L[8] << 27 | L[9] >>> 5, Do = L[9] << 27 | L[8] >>> 5, Ue = L[18] << 20 | L[19] >>> 12, je = L[19] << 20 | L[18] >>> 12, Qi = L[29] << 7 | L[28] >>> 25, qi = L[28] << 7 | L[29] >>> 25, Fo = L[38] << 8 | L[39] >>> 24, Hi = L[39] << 8 | L[38] >>> 24, ce = L[48] << 14 | L[49] >>> 18, xe = L[49] << 14 | L[48] >>> 18, L[0] = se ^ ~fe & b, L[1] = me ^ ~_ & w, L[10] = Ie ^ ~Ue & Je, L[11] = He ^ ~je & xr, L[20] = Io ^ ~Uo & Xs, L[21] = _o ^ ~Lo & Mo, L[30] = In ^ ~$i & Ki, L[31] = Do ^ ~ns & _n, L[40] = Go ^ ~Ji & Qi, L[41] = Vo ^ ~ti & qi, L[2] = fe ^ ~b & $, L[3] = _ ^ ~w & Y, L[12] = Ue ^ ~Je & ji, L[13] = je ^ ~xr & Zs, L[22] = Uo ^ ~Xs & Fo, L[23] = Lo ^ ~Mo & Hi, L[32] = $i ^ ~Ki & zi, L[33] = ns ^ ~_n & ei, L[42] = Ji ^ ~Qi & ge, L[43] = ti ^ ~qi & we, L[4] = b ^ ~$ & ce, L[5] = w ^ ~Y & xe, L[14] = Je ^ ~ji & Co, L[15] = xr ^ ~Zs & Ro, L[24] = Xs ^ ~Fo & Gi, L[25] = Mo ^ ~Hi & Vi, L[34] = Ki ^ ~zi & jo, L[35] = _n ^ ~ei & Ho, L[44] = Qi ^ ~ge & Pe, L[45] = qi ^ ~we & Te, L[6] = $ ^ ~ce & se, L[7] = Y ^ ~xe & me, L[16] = ji ^ ~Co & Ie, L[17] = Zs ^ ~Ro & He, L[26] = Fo ^ ~Gi & Io, L[27] = Hi ^ ~Vi & _o, L[36] = zi ^ ~jo & In, L[37] = ei ^ ~Ho & Do, L[46] = ge ^ ~Pe & Go, L[47] = we ^ ~Te & Vo, L[8] = ce ^ ~se & fe, L[9] = xe ^ ~me & _, L[18] = Co ^ ~Ie & Ue, L[19] = Ro ^ ~He & je, L[28] = Gi ^ ~Io & Uo, L[29] = Vi ^ ~_o & Lo, L[38] = jo ^ ~In & $i, L[39] = Ho ^ ~Do & ns, L[48] = Pe ^ ~Go & Ji, L[49] = Te ^ ~Vo & ti, L[0] ^= g[ee], L[1] ^= g[ee + 1];
    };
    if (o)
      r.exports = J;
    else
      for (G = 0; G < M.length; ++G)
        s[M[G]] = J[M[G]];
  })();
})(F6);
var oT = F6.exports;
const cT = /* @__PURE__ */ o5(oT), uT = (r) => {
  const e = r.toLowerCase().replace(/^0x/, ""), t = cT.keccak_256(e);
  let n = "0x";
  for (let s = 0; s < e.length; s++)
    n += parseInt(t[s], 16) >= 8 ? e[s].toUpperCase() : e[s];
  return n;
};
class lT {
  constructor(e) {
    Q(this, "name", "evm");
    Q(this, "sdk");
    Q(this, "provider");
    Q(this, "chainConfig");
    Q(this, "optionsProvider");
    Q(this, "once", oP);
    Q(this, "on", cP);
    Q(this, "_emit", uP);
    Q(this, "switchChainPromise");
    if (!e.chainConfig.chainId || !e.chainConfig.rpcUrl)
      throw new Error("chainId and rpcUrl are required fields");
    if (!e.chainConfig.chainId.includes("0x")) throw new Error("Chain id must be a hex value 0x prefixed");
    this.chainConfig = e.chainConfig, e.provider && (this.optionsProvider = e.provider);
  }
  async _initialize(e) {
    this.sdk = e, this.sdk.on(lP.LOGOUT, () => this.provider = void 0);
  }
  async _checkIsUserLoggedIn() {
    if (!this.sdk.isLoggedIn()) throw new Error("User is not logged in");
  }
  async _buildProvider() {
    try {
      switch (this.sdk.getLoginProvider()) {
        case Ju.EVM_PROVIDER: {
          if (!this.optionsProvider) throw new Error("EVM provider was not provided");
          return this.optionsProvider;
        }
        case Ju.OAUTH:
          return new yb({
            rpcUrl: this.chainConfig.rpcUrl,
            accessToken: this.sdk.getAccessToken(),
            env: this.sdk.env
          });
        default:
          throw new Error("Cannot build evm provider");
      }
    } catch (e) {
      throw this._emit("EVM_ERROR", e), e;
    }
  }
  async getProvider() {
    return await this._checkIsUserLoggedIn(), this.provider ? this.provider instanceof yb && this.provider.setAccessToken(this.sdk.getAccessToken()) : this.provider = await this._buildProvider(), this.provider;
  }
  async getEthersProvider() {
    const e = await this.getProvider();
    if (!e) throw new Error("Cannot get provider");
    return this.isEvmProvider() && await this._switchChainEip(this.chainConfig), new Jg(e);
  }
  async switchChain(e) {
    try {
      const t = await this.getProvider();
      switch (this.sdk.getLoginProvider()) {
        case Ju.EVM_PROVIDER: {
          await this._switchChainEip(e);
          break;
        }
        case Ju.OAUTH: {
          t.setRpcUrl(e.rpcUrl);
          break;
        }
      }
      this.chainConfig = e, this._emit(ip.EVM_SWITCH_CHAIN, { chainConfig: e });
    } catch (t) {
      throw this._emit(ip.EVM_ERROR, t), t;
    }
  }
  getChainConfig() {
    return this.chainConfig;
  }
  isEvmProvider() {
    return !!this.optionsProvider;
  }
  async loginWithSignature() {
    if (!this.isEvmProvider()) throw new Error("EVM provider was not provided");
    await this._switchChainEip(this.sdk.evm.getChainConfig());
    const [e] = await this.optionsProvider.request({
      method: "eth_requestAccounts"
    }), t = await mP(
      this.sdk,
      {
        scope: "openid profile email phone blockchain.evm blockchain.evm.write",
        responseType: "token"
      },
      { is_evm: !0 }
    );
    yP(t, { redirectUrl: "none" });
    const n = await fetch(t.toString());
    if (!n.ok) throw new Error(n.statusText);
    const { sid: s, nonce: i } = await n.json(), a = new M4.SiweMessage({
      domain: window.location.host,
      address: uT(e),
      statement: "Sign in with Credenza3",
      uri: window.location.origin,
      version: "1",
      chainId: +this.sdk.evm.getChainConfig().chainId,
      nonce: i
    }), o = a.prepareMessage(), u = await this.optionsProvider.request({
      method: "personal_sign",
      params: [o, e]
    }), c = await fetch(t.toString(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ signature: u, sid: s, message: a })
    }), { access_token: l } = await c.json();
    await this.sdk._setAccessToken(l, Ju.EVM_PROVIDER);
  }
  _ensureHexChainId(e) {
    return typeof e == "string" ? e.startsWith("0x") ? e : `0x${parseInt(e, 10).toString(16)}` : `0x${e.toString(16)}`;
  }
  async _addChainEip(e) {
    if (!this.optionsProvider) throw new Error("EVM provider was not provided");
    const t = this._ensureHexChainId(e.chainId);
    await this.optionsProvider.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: t,
          chainName: e.displayName,
          rpcUrls: [e.rpcUrl],
          blockExplorerUrls: e.blockExplorer ? [e.blockExplorer] : void 0,
          nativeCurrency: {
            name: e.nativeCurrency.name,
            symbol: e.nativeCurrency.symbol,
            decimals: e.nativeCurrency.decimals ?? 18
          }
        }
      ]
    });
  }
  async _switchChainEip(e) {
    if (!this.optionsProvider) throw new Error("EVM provider was not provided");
    if (this.switchChainPromise) return this.switchChainPromise;
    const t = this._ensureHexChainId(e.chainId);
    return this.switchChainPromise = this.optionsProvider.request({ method: "eth_chainId" }).then(async (n) => {
      var s, i, a;
      if ((n == null ? void 0 : n.toLowerCase()) === t.toLowerCase())
        throw new Error("SWITCH_CHAIN_NOT_REQUIRED");
      try {
        await this.optionsProvider.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: t }]
        });
      } catch (o) {
        if (((o == null ? void 0 : o.code) ?? ((i = (s = o == null ? void 0 : o.data) == null ? void 0 : s.originalError) == null ? void 0 : i.code)) === 4902 || (a = o == null ? void 0 : o.message) != null && a.includes("Unrecognized chain"))
          await this._addChainEip(e), await this.optionsProvider.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: t }]
          });
        else
          throw o;
      }
    }).catch((n) => {
      if ((n == null ? void 0 : n.message) !== "SWITCH_CHAIN_NOT_REQUIRED")
        return Promise.reject(n);
    }).finally(() => {
      this.switchChainPromise = void 0;
    }), this.switchChainPromise;
  }
}
Q(lT, "EVM_EVENT", ip);
export {
  lT as EvmExtension,
  hT as ethers
};
